// ASVAB Flashcards - Comprehensive study content covering all major subjects

const flashcards = [
  // Arithmetic Reasoning
  {
    id: 1,
    subject: "Arithmetic Reasoning",
    question: "A platoon has 240 rounds of ammunition to distribute equally among 4 squads. How many rounds does each squad receive?",
    answer: "60 rounds per squad. Division: 240 rounds ÷ 4 squads = 60 rounds per squad",
    difficulty: "Easy"
  },
  {
    id: 2,
    subject: "Arithmetic Reasoning",
    question: "A convoy travels 180 miles in 3 hours. What is the average speed in miles per hour?",
    answer: "60 mph. Distance ÷ Time = Speed. 180 miles ÷ 3 hours = 60 mph",
    difficulty: "Easy"
  },
  {
    id: 3,
    subject: "Arithmetic Reasoning",
    question: "If 3 soldiers can fortify a position in 8 hours, how long would it take 6 soldiers working at the same rate?",
    answer: "4 hours. Inverse proportion: 3 soldiers × 8 hours = 24 soldier-hours. 24 ÷ 6 soldiers = 4 hours",
    difficulty: "Medium"
  },

  // Word Knowledge
  {
    id: 4,
    subject: "Word Knowledge",
    question: "What does 'tactical' most nearly mean?",
    answer: "Relating to military tactics; strategic actions designed to achieve a specific objective in combat or operations.",
    difficulty: "Easy"
  },
  {
    id: 5,
    subject: "Word Knowledge",
    question: "What does 'reconnaissance' most nearly mean?",
    answer: "Military observation of a region to locate an enemy or ascertain strategic features. Used for gathering intelligence.",
    difficulty: "Easy"
  },
  {
    id: 6,
    subject: "Word Knowledge",
    question: "What does 'fortify' most nearly mean?",
    answer: "To strengthen and secure a military position with defensive works. Example: Engineers fortify the perimeter with sandbags.",
    difficulty: "Medium"
  },

  // Mathematics Knowledge
  {
    id: 7,
    subject: "Mathematics Knowledge",
    question: "What is the value of 5² + 3² ?",
    answer: "34. Calculate: 5² = 25, 3² = 9, then add: 25 + 9 = 34",
    difficulty: "Easy"
  },
  {
    id: 8,
    subject: "Mathematics Knowledge",
    question: "If x + 7 = 15, what is the value of x?",
    answer: "x = 8. Subtract 7 from both sides: x = 15 - 7 = 8",
    difficulty: "Easy"
  },
  {
    id: 9,
    subject: "Mathematics Knowledge",
    question: "What is the area of a triangle with base 10 and height 6?",
    answer: "30 square units. Formula: Area = (1/2) × base × height = (1/2) × 10 × 6 = 30",
    difficulty: "Medium"
  },

  // General Science
  {
    id: 10,
    subject: "General Science",
    question: "What chemical reaction occurs when an explosive detonates?",
    answer: "Rapid exothermic oxidation-reduction reaction. Chemical bonds break and reform, releasing energy as heat, light, and gas expansion in milliseconds.",
    difficulty: "Easy"
  },
  {
    id: 11,
    subject: "General Science",
    question: "What is ballistics?",
    answer: "The science of projectile motion and impact. It studies the trajectory, behavior, and effects of projectiles like bullets, missiles, and artillery shells.",
    difficulty: "Easy"
  },
  {
    id: 12,
    subject: "General Science",
    question: "What causes heat signature detection in thermal imaging?",
    answer: "All objects emit infrared radiation based on temperature. Thermal cameras detect this IR radiation to create images showing heat differences, crucial for night operations.",
    difficulty: "Medium"
  },

  // Mechanical Comprehension
  {
    id: 13,
    subject: "Mechanical Comprehension",
    question: "How does recoil work in firearms?",
    answer: "Newton's Third Law: for every action, there's an equal and opposite reaction. When a bullet is fired forward, an equal force pushes the weapon backward.",
    difficulty: "Easy"
  },
  {
    id: 14,
    subject: "Mechanical Comprehension",
    question: "What is the mechanical advantage of using a pulley system in tactical operations?",
    answer: "Pulleys multiply force, allowing soldiers to lift heavy equipment with less effort. A 2-pulley system provides 2:1 mechanical advantage - half the force needed.",
    difficulty: "Easy"
  },
  {
    id: 15,
    subject: "Mechanical Comprehension",
    question: "How does a hydraulic lift system work on military vehicles?",
    answer: "Pascal's Principle: pressure applied to confined fluid is transmitted equally throughout. Small force on small piston creates large force on large piston.",
    difficulty: "Medium"
  },

  // Electronics Information
  {
    id: 16,
    subject: "Electronics Information",
    question: "How does radio communication work in military operations?",
    answer: "Radio waves transmit encoded voice/data through electromagnetic radiation. Frequency modulation (FM) or amplitude modulation (AM) carries information over specific frequencies.",
    difficulty: "Easy"
  },
  {
    id: 17,
    subject: "Electronics Information",
    question: "What is Ohm's Law and why is it critical for field electronics?",
    answer: "V = I × R. Voltage equals current times resistance. Essential for troubleshooting electrical systems, calculating power requirements, and preventing equipment failure in the field.",
    difficulty: "Medium"
  },
  {
    id: 18,
    subject: "Electronics Information",
    question: "How do night vision goggles amplify available light?",
    answer: "Image intensifier tubes convert photons to electrons, multiply them thousands of times, then convert back to visible light. Amplifies ambient light 20,000-50,000 times.",
    difficulty: "Easy"
  },

  // Auto and Shop Information
  {
    id: 19,
    subject: "Auto & Shop Information",
    question: "Why is vehicle maintenance critical in combat zones?",
    answer: "Equipment failure in hostile territory can be fatal. Regular maintenance of engines, transmissions, and fuel systems ensures mission readiness and crew survival.",
    difficulty: "Easy"
  },
  {
    id: 20,
    subject: "Auto & Shop Information",
    question: "What is the purpose of an armored vehicle's differential?",
    answer: "Allows wheels to rotate at different speeds during turns while transmitting power from the engine. Critical for maneuvering heavy tactical vehicles on varied terrain.",
    difficulty: "Easy"
  },
  {
    id: 871,
    subject: "Arithmetic Reasoning",
    question: "A military supply truck carries 450 pounds of equipment. If each soldier's pack weighs 30 pounds, how many packs can the truck carry?",
    answer: "15 packs. Division: 450 pounds ÷ 30 pounds per pack = 15 packs",
    difficulty: "Easy"
  },
  {
    id: 872,
    subject: "Arithmetic Reasoning",
    question: "If a soldier runs 2 miles in 16 minutes, what is his average speed in miles per hour?",
    answer: "7.5 mph. First convert 16 minutes to hours: 16/60 = 0.267 hours. Speed = Distance ÷ Time = 2 miles ÷ 0.267 hours = 7.5 mph",
    difficulty: "Medium"
  },
  {
    id: 873,
    subject: "Arithmetic Reasoning",
    question: "A base cafeteria serves 1,200 meals per day. If 25% are breakfast meals, how many breakfast meals are served?",
    answer: "300 meals. Calculate 25% of 1,200: 0.25 × 1,200 = 300 breakfast meals",
    difficulty: "Easy"
  },
  {
    id: 874,
    subject: "Arithmetic Reasoning",
    question: "Three soldiers share guard duty for 24 hours. If they each work equal shifts, how many hours does each soldier work?",
    answer: "8 hours. Division: 24 hours ÷ 3 soldiers = 8 hours per soldier",
    difficulty: "Easy"
  },
  {
    id: 875,
    subject: "Arithmetic Reasoning",
    question: "A military vehicle travels 240 miles on 15 gallons of fuel. What is the fuel efficiency in miles per gallon?",
    answer: "16 mpg. Division: 240 miles ÷ 15 gallons = 16 miles per gallon",
    difficulty: "Easy"
  },
  {
    id: 876,
    subject: "Arithmetic Reasoning",
    question: "If ammunition costs $0.45 per round and a unit needs 800 rounds, what is the total cost?",
    answer: "$360. Multiplication: $0.45 × 800 rounds = $360",
    difficulty: "Easy"
  },
  {
    id: 877,
    subject: "Arithmetic Reasoning",
    question: "A convoy of 5 trucks carries 175 boxes total. If each truck carries the same number of boxes, how many boxes per truck?",
    answer: "35 boxes. Division: 175 boxes ÷ 5 trucks = 35 boxes per truck",
    difficulty: "Easy"
  },
  {
    id: 878,
    subject: "Arithmetic Reasoning",
    question: "A soldier earns $2,400 per month. If 20% is deducted for taxes, what is the take-home pay?",
    answer: "$1,920. Calculate tax: 0.20 × $2,400 = $480. Subtract: $2,400 - $480 = $1,920",
    difficulty: "Medium"
  },
  {
    id: 879,
    subject: "Arithmetic Reasoning",
    question: "If a helicopter flies at 120 mph for 2.5 hours, what distance does it cover?",
    answer: "300 miles. Distance = Speed × Time = 120 mph × 2.5 hours = 300 miles",
    difficulty: "Easy"
  },
  {
    id: 880,
    subject: "Arithmetic Reasoning",
    question: "A unit has 48 soldiers. If the ratio of officers to enlisted is 1:7, how many officers are there?",
    answer: "6 officers. Total parts: 1 + 7 = 8. Officers: (1/8) × 48 = 6 officers",
    difficulty: "Medium"
  },
  {
    id: 881,
    subject: "Arithmetic Reasoning",
    question: "A rope is 72 feet long and must be cut into 9 equal pieces. How long is each piece?",
    answer: "8 feet. Division: 72 feet ÷ 9 pieces = 8 feet per piece",
    difficulty: "Easy"
  },
  {
    id: 882,
    subject: "Arithmetic Reasoning",
    question: "If a soldier completes an obstacle course in 8 minutes and 45 seconds, and another completes it in 7 minutes and 30 seconds, what is the time difference?",
    answer: "1 minute 15 seconds. Convert to seconds: 525 - 450 = 75 seconds = 1 minute 15 seconds",
    difficulty: "Medium"
  },
  {
    id: 883,
    subject: "Arithmetic Reasoning",
    question: "A storage facility has 960 square feet and must store boxes that each take up 8 square feet. How many boxes can fit?",
    answer: "120 boxes. Division: 960 square feet ÷ 8 square feet per box = 120 boxes",
    difficulty: "Easy"
  },
  {
    id: 884,
    subject: "Arithmetic Reasoning",
    question: "If 12 soldiers can load a truck in 40 minutes, how long would it take 15 soldiers working at the same rate?",
    answer: "32 minutes. Calculate soldier-minutes: 12 × 40 = 480. Divide: 480 ÷ 15 = 32 minutes",
    difficulty: "Medium"
  },
  {
    id: 885,
    subject: "Arithmetic Reasoning",
    question: "A military base spends $18,000 on supplies. If this is 15% of the monthly budget, what is the total monthly budget?",
    answer: "$120,000. Set up equation: 0.15 × Budget = $18,000. Budget = $18,000 ÷ 0.15 = $120,000",
    difficulty: "Hard"
  },
  {
    id: 886,
    subject: "Arithmetic Reasoning",
    question: "A vehicle travels 45 miles in the first hour and 60 miles in the second hour. What is the average speed for the entire trip?",
    answer: "52.5 mph. Total distance: 45 + 60 = 105 miles. Total time: 2 hours. Average: 105 ÷ 2 = 52.5 mph",
    difficulty: "Medium"
  },
  {
    id: 887,
    subject: "Arithmetic Reasoning",
    question: "If a case of MREs costs $96 and contains 12 meals, what is the cost per meal?",
    answer: "$8 per meal. Division: $96 ÷ 12 meals = $8 per meal",
    difficulty: "Easy"
  },
  {
    id: 888,
    subject: "Arithmetic Reasoning",
    question: "A squad has 10 soldiers. If 3 are assigned to perimeter duty, what percentage remains for other tasks?",
    answer: "70%. Remaining soldiers: 10 - 3 = 7. Percentage: (7/10) × 100% = 70%",
    difficulty: "Easy"
  },
  {
    id: 889,
    subject: "Arithmetic Reasoning",
    question: "A training course is 15 miles long. If a soldier has completed 9 miles, what fraction of the course remains?",
    answer: "2/5 remains. Remaining: 15 - 9 = 6 miles. Fraction: 6/15 = 2/5",
    difficulty: "Medium"
  },
  {
    id: 890,
    subject: "Arithmetic Reasoning",
    question: "If a soldier's heart rate is 72 beats per minute, how many beats occur in 5 minutes?",
    answer: "360 beats. Multiplication: 72 beats/minute × 5 minutes = 360 beats",
    difficulty: "Easy"
  },
  {
    id: 891,
    subject: "Arithmetic Reasoning",
    question: "A unit receives 840 gallons of water for 35 soldiers. How many gallons per soldier?",
    answer: "24 gallons. Division: 840 gallons ÷ 35 soldiers = 24 gallons per soldier",
    difficulty: "Easy"
  },
  {
    id: 892,
    subject: "Arithmetic Reasoning",
    question: "A plane flies 450 miles per hour. How far does it travel in 3 hours and 20 minutes?",
    answer: "1,500 miles. Convert time: 3 hours 20 minutes = 3.333 hours. Distance = 450 × 3.333 = 1,500 miles",
    difficulty: "Medium"
  },
  {
    id: 893,
    subject: "Arithmetic Reasoning",
    question: "If 4 soldiers can dig a trench in 6 hours, how long would it take 8 soldiers?",
    answer: "3 hours. Calculate soldier-hours: 4 × 6 = 24. Divide: 24 ÷ 8 = 3 hours",
    difficulty: "Easy"
  },
  {
    id: 894,
    subject: "Arithmetic Reasoning",
    question: "A soldier's gear weighs 85 pounds. After removing 20% of the weight, what does the gear weigh?",
    answer: "68 pounds. Calculate 20%: 0.20 × 85 = 17 pounds. Subtract: 85 - 17 = 68 pounds",
    difficulty: "Medium"
  },
  {
    id: 895,
    subject: "Arithmetic Reasoning",
    question: "If a base has 1,500 personnel and the ratio of Army to Navy is 5:3, how many Navy personnel are there?",
    answer: "562.5, round to 563 Navy. Total parts: 5 + 3 = 8. Navy: (3/8) × 1,500 = 562.5 ≈ 563",
    difficulty: "Hard"
  },
  {
    id: 896,
    subject: "Arithmetic Reasoning",
    question: "A vehicle uses 3 quarts of oil. If oil costs $4.50 per quart, what is the total cost?",
    answer: "$13.50. Multiplication: 3 quarts × $4.50 per quart = $13.50",
    difficulty: "Easy"
  },
  {
    id: 897,
    subject: "Arithmetic Reasoning",
    question: "A soldier walks 4 miles in 1 hour and 15 minutes. What is the walking speed in miles per hour?",
    answer: "3.2 mph. Convert time: 1 hour 15 minutes = 1.25 hours. Speed = 4 miles ÷ 1.25 hours = 3.2 mph",
    difficulty: "Medium"
  },
  {
    id: 898,
    subject: "Arithmetic Reasoning",
    question: "If a barracks room is 24 feet by 18 feet, what is the area in square feet?",
    answer: "432 square feet. Area = Length × Width = 24 feet × 18 feet = 432 square feet",
    difficulty: "Easy"
  },
  {
    id: 899,
    subject: "Arithmetic Reasoning",
    question: "A supply order costs $840. If the price increases by 15%, what is the new cost?",
    answer: "$966. Calculate increase: 0.15 × $840 = $126. Add: $840 + $126 = $966",
    difficulty: "Medium"
  },
  {
    id: 900,
    subject: "Arithmetic Reasoning",
    question: "A convoy has 8 vehicles. If each vehicle carries 12 passengers, how many passengers total?",
    answer: "96 passengers. Multiplication: 8 vehicles × 12 passengers = 96 passengers",
    difficulty: "Easy"
  },
  {
    id: 901,
    subject: "Arithmetic Reasoning",
    question: "If a soldier saves $300 per month for 8 months, how much is saved?",
    answer: "$2,400. Multiplication: $300/month × 8 months = $2,400",
    difficulty: "Easy"
  },
  {
    id: 902,
    subject: "Arithmetic Reasoning",
    question: "A target is 600 yards away. If a bullet travels at 2,400 feet per second, how long does it take to reach the target?",
    answer: "0.75 seconds. Convert yards to feet: 600 × 3 = 1,800 feet. Time = 1,800 ÷ 2,400 = 0.75 seconds",
    difficulty: "Hard"
  },
  {
    id: 903,
    subject: "Arithmetic Reasoning",
    question: "A unit completes 36 training hours over 4 days. What is the average daily training time?",
    answer: "9 hours. Division: 36 hours ÷ 4 days = 9 hours per day",
    difficulty: "Easy"
  },
  {
    id: 904,
    subject: "Arithmetic Reasoning",
    question: "If 60% of 150 soldiers pass a fitness test, how many soldiers passed?",
    answer: "90 soldiers. Calculate: 0.60 × 150 = 90 soldiers passed",
    difficulty: "Easy"
  },
  {
    id: 905,
    subject: "Arithmetic Reasoning",
    question: "A vehicle travels 280 miles using 14 gallons of fuel. Another vehicle travels 330 miles using 15 gallons. Which has better fuel efficiency?",
    answer: "Second vehicle. First: 280 ÷ 14 = 20 mpg. Second: 330 ÷ 15 = 22 mpg. Second vehicle is more efficient.",
    difficulty: "Medium"
  },
  {
    id: 906,
    subject: "Arithmetic Reasoning",
    question: "A soldier earns $3,200 monthly. If rent is $800, what percentage of income is rent?",
    answer: "25%. Calculate: ($800 ÷ $3,200) × 100% = 25%",
    difficulty: "Medium"
  },
  {
    id: 907,
    subject: "Arithmetic Reasoning",
    question: "If a fence is 144 feet long and posts are placed every 12 feet, how many posts are needed including both ends?",
    answer: "13 posts. Number of sections: 144 ÷ 12 = 12. Posts needed: 12 + 1 = 13 (including both ends)",
    difficulty: "Medium"
  },
  {
    id: 908,
    subject: "Arithmetic Reasoning",
    question: "A box weighs 45 pounds. If 6 boxes are loaded onto a truck, what is the total weight?",
    answer: "270 pounds. Multiplication: 45 pounds × 6 boxes = 270 pounds",
    difficulty: "Easy"
  },
  {
    id: 909,
    subject: "Arithmetic Reasoning",
    question: "A soldier runs 3 miles in 24 minutes on Monday and 3 miles in 21 minutes on Friday. What is the percent improvement in time?",
    answer: "12.5% improvement. Time saved: 24 - 21 = 3 minutes. Percent: (3 ÷ 24) × 100% = 12.5%",
    difficulty: "Hard"
  },
  {
    id: 910,
    subject: "Arithmetic Reasoning",
    question: "If a vehicle's fuel tank holds 25 gallons and is currently 40% full, how many gallons are in the tank?",
    answer: "10 gallons. Calculate: 0.40 × 25 gallons = 10 gallons",
    difficulty: "Easy"
  },
  {
    id: 911,
    subject: "Arithmetic Reasoning",
    question: "A platoon of 40 soldiers needs to cross a river. If each boat holds 8 soldiers, how many trips are needed?",
    answer: "5 trips. Division: 40 soldiers ÷ 8 soldiers per boat = 5 trips",
    difficulty: "Easy"
  },
  {
    id: 912,
    subject: "Arithmetic Reasoning",
    question: "A supply crate costs $240. If three units split the cost equally, how much does each unit pay?",
    answer: "$80. Division: $240 ÷ 3 units = $80 per unit",
    difficulty: "Easy"
  },
  {
    id: 913,
    subject: "Arithmetic Reasoning",
    question: "If a soldier marches at 3 mph for 4 hours, then at 2.5 mph for 2 hours, what is the total distance?",
    answer: "17 miles. First leg: 3 × 4 = 12 miles. Second leg: 2.5 × 2 = 5 miles. Total: 12 + 5 = 17 miles",
    difficulty: "Medium"
  },
  {
    id: 914,
    subject: "Arithmetic Reasoning",
    question: "A communication tower is 150 feet tall. If a cable runs from the top to a point 90 feet from the base, how long is the cable? (Assume right triangle)",
    answer: "Approximately 175 feet. Use Pythagorean theorem: √(150² + 90²) = √(22,500 + 8,100) = √30,600 ≈ 175 feet",
    difficulty: "Hard"
  },
  {
    id: 915,
    subject: "Arithmetic Reasoning",
    question: "If ammunition boxes are stacked 5 high and there are 12 stacks, how many boxes are there?",
    answer: "60 boxes. Multiplication: 5 boxes high × 12 stacks = 60 boxes",
    difficulty: "Easy"
  },
  {
    id: 916,
    subject: "Arithmetic Reasoning",
    question: "A soldier's base pay is $2,000. With a 10% housing allowance and 5% hazard pay, what is the total compensation?",
    answer: "$2,300. Housing: $2,000 × 0.10 = $200. Hazard: $2,000 × 0.05 = $100. Total: $2,000 + $200 + $100 = $2,300",
    difficulty: "Medium"
  },
  {
    id: 917,
    subject: "Arithmetic Reasoning",
    question: "A training manual has 480 pages. If a soldier reads 30 pages per day, how many days to complete it?",
    answer: "16 days. Division: 480 pages ÷ 30 pages per day = 16 days",
    difficulty: "Easy"
  },
  {
    id: 918,
    subject: "Arithmetic Reasoning",
    question: "If 7 out of 28 vehicles need maintenance, what percentage need maintenance?",
    answer: "25%. Calculate: (7 ÷ 28) × 100% = 25%",
    difficulty: "Easy"
  },
  {
    id: 919,
    subject: "Arithmetic Reasoning",
    question: "A soldier drinks 8 bottles of water daily. If each bottle is 16 ounces, how many gallons does the soldier drink in a week?",
    answer: "7 gallons. Daily: 8 × 16 = 128 oz = 1 gallon. Weekly: 7 × 1 = 7 gallons",
    difficulty: "Medium"
  },
  {
    id: 920,
    subject: "Arithmetic Reasoning",
    question: "A vehicle's odometer reads 45,280 miles. After a mission, it reads 45,505 miles. How many miles was the mission?",
    answer: "225 miles. Subtraction: 45,505 - 45,280 = 225 miles",
    difficulty: "Easy"
  },
  {
    id: 921,
    subject: "Arithmetic Reasoning",
    question: "If a unit has 144 soldiers and forms teams of 9, how many teams can be formed?",
    answer: "16 teams. Division: 144 soldiers ÷ 9 soldiers per team = 16 teams",
    difficulty: "Easy"
  },
  {
    id: 922,
    subject: "Arithmetic Reasoning",
    question: "A supply shipment weighs 2.5 tons. How many pounds is this?",
    answer: "5,000 pounds. Conversion: 2.5 tons × 2,000 pounds per ton = 5,000 pounds",
    difficulty: "Easy"
  },
  {
    id: 923,
    subject: "Arithmetic Reasoning",
    question: "A soldier scores 85, 90, and 88 on three tests. What is the average score?",
    answer: "87.67 or approximately 88. Sum: 85 + 90 + 88 = 263. Average: 263 ÷ 3 = 87.67",
    difficulty: "Easy"
  },
  {
    id: 924,
    subject: "Arithmetic Reasoning",
    question: "If a helicopter travels 180 miles in 1.5 hours, what is its speed in miles per hour?",
    answer: "120 mph. Division: 180 miles ÷ 1.5 hours = 120 mph",
    difficulty: "Easy"
  },
  {
    id: 925,
    subject: "Arithmetic Reasoning",
    question: "A rectangular training field is 300 yards long and 150 yards wide. What is the perimeter?",
    answer: "900 yards. Perimeter = 2(Length + Width) = 2(300 + 150) = 2(450) = 900 yards",
    difficulty: "Medium"
  },
  {
    id: 926,
    subject: "Arithmetic Reasoning",
    question: "If a soldier's gear weighs 75 pounds and needs to be reduced by 12 pounds, what percentage reduction is this?",
    answer: "16%. Calculate: (12 ÷ 75) × 100% = 16%",
    difficulty: "Medium"
  },
  {
    id: 927,
    subject: "Arithmetic Reasoning",
    question: "A base has 360 personnel. If 2/5 are deployed, how many remain on base?",
    answer: "216 personnel. Deployed: (2/5) × 360 = 144. Remaining: 360 - 144 = 216",
    difficulty: "Medium"
  },
  {
    id: 928,
    subject: "Arithmetic Reasoning",
    question: "If a convoy travels 65 mph for 3 hours, how far does it travel?",
    answer: "195 miles. Distance = Speed × Time = 65 mph × 3 hours = 195 miles",
    difficulty: "Easy"
  },
  {
    id: 929,
    subject: "Arithmetic Reasoning",
    question: "A soldier completes 45 pushups in one minute. At this rate, how many in 3.5 minutes?",
    answer: "157.5, round to 158 pushups. Multiplication: 45 × 3.5 = 157.5 ≈ 158 pushups",
    difficulty: "Medium"
  },
  {
    id: 930,
    subject: "Arithmetic Reasoning",
    question: "If 18 soldiers share 126 MREs equally, how many does each soldier receive?",
    answer: "7 MREs. Division: 126 MREs ÷ 18 soldiers = 7 MREs per soldier",
    difficulty: "Easy"
  },
  {
    id: 931,
    subject: "Arithmetic Reasoning",
    question: "A vehicle travels 420 miles and uses fuel that costs $3.50 per gallon. If the vehicle gets 21 mpg, what is the fuel cost?",
    answer: "$70. Gallons used: 420 ÷ 21 = 20 gallons. Cost: 20 × $3.50 = $70",
    difficulty: "Hard"
  },
  {
    id: 932,
    subject: "Arithmetic Reasoning",
    question: "If a squad has 12 members and 3 are on leave, what fraction of the squad is present?",
    answer: "3/4 or 75%. Present: 12 - 3 = 9. Fraction: 9/12 = 3/4",
    difficulty: "Easy"
  },
  {
    id: 933,
    subject: "Arithmetic Reasoning",
    question: "A soldier earns $2,800 monthly and spends $420 on food. What percentage is spent on food?",
    answer: "15%. Calculate: ($420 ÷ $2,800) × 100% = 15%",
    difficulty: "Medium"
  },
  {
    id: 934,
    subject: "Arithmetic Reasoning",
    question: "If a parachute descent takes 90 seconds at a rate of 15 feet per second, what is the jump altitude?",
    answer: "1,350 feet. Distance = Rate × Time = 15 feet/second × 90 seconds = 1,350 feet",
    difficulty: "Medium"
  },
  {
    id: 935,
    subject: "Arithmetic Reasoning",
    question: "A base gym has 15 treadmills and 25 weight stations. What is the ratio of treadmills to weight stations in simplest form?",
    answer: "3:5. Divide both by 5: 15/5 = 3, 25/5 = 5. Ratio is 3:5",
    difficulty: "Medium"
  },
  {
    id: 936,
    subject: "Arithmetic Reasoning",
    question: "If a soldier walks 2.5 miles per hour for 2 hours and 40 minutes, what distance is covered?",
    answer: "6.67 miles. Convert time: 2 hours 40 minutes = 2.67 hours. Distance = 2.5 × 2.67 = 6.67 miles",
    difficulty: "Hard"
  },
  {
    id: 937,
    subject: "Arithmetic Reasoning",
    question: "A supply order costs $1,440. If paid in 12 equal installments, how much is each payment?",
    answer: "$120. Division: $1,440 ÷ 12 payments = $120 per payment",
    difficulty: "Easy"
  },
  {
    id: 938,
    subject: "Arithmetic Reasoning",
    question: "If 5 soldiers can paint a barracks in 8 hours, how long would it take 10 soldiers?",
    answer: "4 hours. Calculate soldier-hours: 5 × 8 = 40. Divide: 40 ÷ 10 = 4 hours",
    difficulty: "Easy"
  },
  {
    id: 939,
    subject: "Arithmetic Reasoning",
    question: "A soldier buys a uniform for $180. If there's an 8% sales tax, what is the total cost?",
    answer: "$194.40. Calculate tax: $180 × 0.08 = $14.40. Total: $180 + $14.40 = $194.40",
    difficulty: "Medium"
  },
  {
    id: 940,
    subject: "Arithmetic Reasoning",
    question: "A unit travels 210 miles in 3.5 hours. What is the average speed?",
    answer: "60 mph. Division: 210 miles ÷ 3.5 hours = 60 mph",
    difficulty: "Easy"
  },
  {
    id: 941,
    subject: "Arithmetic Reasoning",
    question: "If a rope is 250 feet long and 60 feet is used, what percentage remains?",
    answer: "76%. Remaining: 250 - 60 = 190 feet. Percentage: (190 ÷ 250) × 100% = 76%",
    difficulty: "Medium"
  },
  {
    id: 942,
    subject: "Arithmetic Reasoning",
    question: "A vehicle has a 20-gallon fuel tank. If it's 3/4 full, how many gallons are in the tank?",
    answer: "15 gallons. Calculate: (3/4) × 20 = 15 gallons",
    difficulty: "Easy"
  },
  {
    id: 943,
    subject: "Arithmetic Reasoning",
    question: "If 9 soldiers complete a task in 12 hours, how many soldiers are needed to complete it in 6 hours?",
    answer: "18 soldiers. Calculate soldier-hours: 9 × 12 = 108. Divide: 108 ÷ 6 = 18 soldiers needed",
    difficulty: "Medium"
  },
  {
    id: 944,
    subject: "Arithmetic Reasoning",
    question: "A soldier runs a 5-mile course in 40 minutes. What is the pace in minutes per mile?",
    answer: "8 minutes per mile. Division: 40 minutes ÷ 5 miles = 8 minutes per mile",
    difficulty: "Easy"
  },
  {
    id: 945,
    subject: "Arithmetic Reasoning",
    question: "A base has 800 personnel. If 35% are officers, how many enlisted personnel are there?",
    answer: "520 enlisted. Officers: 0.35 × 800 = 280. Enlisted: 800 - 280 = 520",
    difficulty: "Medium"
  },
  {
    id: 946,
    subject: "Arithmetic Reasoning",
    question: "If a vehicle depreciates 20% per year and costs $40,000 new, what is its value after one year?",
    answer: "$32,000. Depreciation: $40,000 × 0.20 = $8,000. Value: $40,000 - $8,000 = $32,000",
    difficulty: "Medium"
  },
  {
    id: 947,
    subject: "Arithmetic Reasoning",
    question: "A soldier completes 60 sit-ups in 2 minutes. What is the rate per minute?",
    answer: "30 sit-ups per minute. Division: 60 sit-ups ÷ 2 minutes = 30 per minute",
    difficulty: "Easy"
  },
  {
    id: 948,
    subject: "Arithmetic Reasoning",
    question: "If a convoy has 15 vehicles and each carries 800 pounds, what is the total cargo weight in tons?",
    answer: "6 tons. Total pounds: 15 × 800 = 12,000 pounds. Convert: 12,000 ÷ 2,000 = 6 tons",
    difficulty: "Medium"
  },
  {
    id: 949,
    subject: "Arithmetic Reasoning",
    question: "A training area is 450 meters long. How many feet is this? (1 meter = 3.28 feet)",
    answer: "1,476 feet. Conversion: 450 meters × 3.28 feet/meter = 1,476 feet",
    difficulty: "Medium"
  },
  {
    id: 950,
    subject: "Arithmetic Reasoning",
    question: "If a soldier's pack weighs 60 pounds and ammunition adds 15 pounds, what is the total weight?",
    answer: "75 pounds. Addition: 60 pounds + 15 pounds = 75 pounds",
    difficulty: "Easy"
  },
  {
    id: 951,
    subject: "Arithmetic Reasoning",
    question: "A unit completes a 12-mile march in 4 hours. What is the average speed in miles per hour?",
    answer: "3 mph. Division: 12 miles ÷ 4 hours = 3 mph",
    difficulty: "Easy"
  },
  {
    id: 952,
    subject: "Arithmetic Reasoning",
    question: "If a base cafeteria serves 450 meals and 18% are vegetarian, how many vegetarian meals are served?",
    answer: "81 meals. Calculate: 0.18 × 450 = 81 vegetarian meals",
    difficulty: "Easy"
  },
  {
    id: 953,
    subject: "Arithmetic Reasoning",
    question: "A soldier invests $5,000 at 4% annual interest. How much interest is earned in one year?",
    answer: "$200. Calculate: $5,000 × 0.04 = $200 interest",
    difficulty: "Easy"
  },
  {
    id: 954,
    subject: "Arithmetic Reasoning",
    question: "If 24 soldiers form 6 equal teams, and then 2 teams are reassigned, how many soldiers remain?",
    answer: "16 soldiers. Soldiers per team: 24 ÷ 6 = 4. Teams remaining: 6 - 2 = 4. Total: 4 × 4 = 16 soldiers",
    difficulty: "Hard"
  },
  {
    id: 955,
    subject: "Arithmetic Reasoning",
    question: "A vehicle travels at 55 mph. How many miles does it travel in 15 minutes?",
    answer: "13.75 miles. Convert time: 15 minutes = 0.25 hours. Distance = 55 × 0.25 = 13.75 miles",
    difficulty: "Medium"
  },
  {
    id: 956,
    subject: "Arithmetic Reasoning",
    question: "If a supply box measures 4 feet by 3 feet by 2 feet, what is the volume in cubic feet?",
    answer: "24 cubic feet. Volume = Length × Width × Height = 4 × 3 × 2 = 24 cubic feet",
    difficulty: "Medium"
  },
  {
    id: 957,
    subject: "Arithmetic Reasoning",
    question: "A soldier works 8 hours and earns $160. What is the hourly wage?",
    answer: "$20 per hour. Division: $160 ÷ 8 hours = $20 per hour",
    difficulty: "Easy"
  },
  {
    id: 958,
    subject: "Arithmetic Reasoning",
    question: "If a unit has 200 soldiers and 15% are on leave, how many are present for duty?",
    answer: "170 soldiers. On leave: 0.15 × 200 = 30. Present: 200 - 30 = 170 soldiers",
    difficulty: "Easy"
  },
  {
    id: 959,
    subject: "Arithmetic Reasoning",
    question: "A vehicle averages 18 mpg. If fuel costs $3.00 per gallon, what is the cost per mile?",
    answer: "$0.167 per mile or about 17 cents. Calculate: $3.00 ÷ 18 miles = $0.167 per mile",
    difficulty: "Hard"
  },
  {
    id: 960,
    subject: "Arithmetic Reasoning",
    question: "If 3 soldiers can assemble 15 tents in 5 hours, how many tents can 5 soldiers assemble in the same time?",
    answer: "25 tents. Rate per soldier: 15 ÷ 3 = 5 tents. Five soldiers: 5 × 5 = 25 tents",
    difficulty: "Medium"
  },
  {
    id: 961,
    subject: "Arithmetic Reasoning",
    question: "A soldier runs 2 laps around a 0.25-mile track. What is the total distance?",
    answer: "0.5 miles. Multiplication: 2 laps × 0.25 miles = 0.5 miles",
    difficulty: "Easy"
  },
  {
    id: 962,
    subject: "Arithmetic Reasoning",
    question: "If a platoon of 45 soldiers forms 3 equal squads, how many soldiers per squad?",
    answer: "15 soldiers. Division: 45 soldiers ÷ 3 squads = 15 soldiers per squad",
    difficulty: "Easy"
  },
  {
    id: 963,
    subject: "Arithmetic Reasoning",
    question: "A vehicle's fuel efficiency decreases from 25 mpg to 20 mpg. What is the percentage decrease?",
    answer: "20% decrease. Change: 25 - 20 = 5 mpg. Percentage: (5 ÷ 25) × 100% = 20%",
    difficulty: "Hard"
  },
  {
    id: 964,
    subject: "Arithmetic Reasoning",
    question: "If a soldier's uniform costs $120 and boots cost $85, what is the total cost?",
    answer: "$205. Addition: $120 + $85 = $205",
    difficulty: "Easy"
  },
  {
    id: 965,
    subject: "Arithmetic Reasoning",
    question: "A base has 320 vehicles. If 5/8 are operational, how many are operational?",
    answer: "200 vehicles. Calculate: (5/8) × 320 = 200 operational vehicles",
    difficulty: "Medium"
  },
  {
    id: 966,
    subject: "Arithmetic Reasoning",
    question: "If a soldier marches 18 miles in 6 hours, what is the average speed?",
    answer: "3 mph. Division: 18 miles ÷ 6 hours = 3 mph",
    difficulty: "Easy"
  },
  {
    id: 967,
    subject: "Arithmetic Reasoning",
    question: "A supply shipment contains 240 items packed in boxes of 16. How many boxes are there?",
    answer: "15 boxes. Division: 240 items ÷ 16 items per box = 15 boxes",
    difficulty: "Easy"
  },
  {
    id: 968,
    subject: "Arithmetic Reasoning",
    question: "If a training exercise starts at 0730 and lasts 4 hours and 45 minutes, what time does it end?",
    answer: "1215 (12:15 PM). Add 4 hours: 0730 + 4 hours = 1130. Add 45 minutes: 1130 + 45 = 1215",
    difficulty: "Medium"
  },
  {
    id: 969,
    subject: "Arithmetic Reasoning",
    question: "A soldier scores 92, 88, 94, and 86 on four tests. What is the average score?",
    answer: "90. Sum: 92 + 88 + 94 + 86 = 360. Average: 360 ÷ 4 = 90",
    difficulty: "Easy"
  },
  {
    id: 970,
    subject: "Arithmetic Reasoning",
    question: "If a helicopter uses 45 gallons of fuel per hour and flies for 3.5 hours, how much fuel is consumed?",
    answer: "157.5 gallons. Multiplication: 45 gallons/hour × 3.5 hours = 157.5 gallons",
    difficulty: "Easy"
  },
{
  id: 21,
  subject: "Word Knowledge",
  question: "What does 'accommodate' most nearly mean?",
  answer: "To provide lodging, food, or space for someone. Example: The barracks can accommodate 200 soldiers comfortably.",
  difficulty: "Easy"
},
{
  id: 22,
  subject: "Word Knowledge",
  question: "What does 'abide' most nearly mean?",
  answer: "To follow or comply with a rule or decision. Example: All personnel must abide by military regulations.",
  difficulty: "Easy"
},
{
  id: 23,
  subject: "Word Knowledge",
  question: "What does 'adjacent' most nearly mean?",
  answer: "Next to or adjoining something. Example: The ammunition depot is adjacent to the main base.",
  difficulty: "Easy"
},
{
  id: 24,
  subject: "Word Knowledge",
  question: "What does 'advocate' most nearly mean?",
  answer: "To publicly support or recommend something. Example: The commander advocates for better training programs.",
  difficulty: "Easy"
},
{
  id: 25,
  subject: "Word Knowledge",
  question: "What does 'affirm' most nearly mean?",
  answer: "To state or assert as true; to confirm. Example: The officer will affirm the soldier's commendation.",
  difficulty: "Easy"
},
{
  id: 26,
  subject: "Word Knowledge",
  question: "What does 'aggregate' most nearly mean?",
  answer: "To collect or combine into a whole. Example: The aggregate of all squad strengths is 500 soldiers.",
  difficulty: "Easy"
},
{
  id: 27,
  subject: "Word Knowledge",
  question: "What does 'allegiance' most nearly mean?",
  answer: "Loyalty or devotion to a person, cause, or flag. Example: Soldiers pledge their allegiance to their country.",
  difficulty: "Easy"
},
{
  id: 28,
  subject: "Word Knowledge",
  question: "What does 'allocate' most nearly mean?",
  answer: "To distribute or assign resources for a specific purpose. Example: Command will allocate supplies to each platoon.",
  difficulty: "Easy"
},
{
  id: 29,
  subject: "Word Knowledge",
  question: "What does 'amend' most nearly mean?",
  answer: "To make corrections or improvements to a document or rule. Example: The regulation was amended to clarify procedures.",
  difficulty: "Easy"
},
{
  id: 30,
  subject: "Word Knowledge",
  question: "What does 'annex' most nearly mean?",
  answer: "To attach or add something as a supplement; a building attached to a main structure. Example: The new annex houses additional storage.",
  difficulty: "Easy"
},
{
  id: 31,
  subject: "Word Knowledge",
  question: "What does 'apparent' most nearly mean?",
  answer: "Easily seen or understood; obvious. Example: The damage to the vehicle was apparent to all inspectors.",
  difficulty: "Easy"
},
{
  id: 32,
  subject: "Word Knowledge",
  question: "What does 'apprehend' most nearly mean?",
  answer: "To arrest or capture someone; to understand. Example: Military police will apprehend any unauthorized personnel.",
  difficulty: "Easy"
},
{
  id: 33,
  subject: "Word Knowledge",
  question: "What does 'arbitrary' most nearly mean?",
  answer: "Based on random choice or personal whim rather than reason. Example: The sergeant's decision seemed arbitrary to the recruits.",
  difficulty: "Easy"
},
{
  id: 34,
  subject: "Word Knowledge",
  question: "What does 'arduous' most nearly mean?",
  answer: "Difficult and tiring; requiring great effort. Example: The combat training course was arduous but essential.",
  difficulty: "Easy"
},
{
  id: 35,
  subject: "Word Knowledge",
  question: "What does 'arsenal' most nearly mean?",
  answer: "A storage facility for weapons and ammunition. Example: The base's arsenal contains thousands of rounds.",
  difficulty: "Easy"
},
{
  id: 36,
  subject: "Word Knowledge",
  question: "What does 'articulate' most nearly mean?",
  answer: "To express clearly and distinctly. Example: The general articulated the mission objectives to all commanders.",
  difficulty: "Easy"
},
{
  id: 37,
  subject: "Word Knowledge",
  question: "What does 'ascend' most nearly mean?",
  answer: "To move upward or climb. Example: Troops will ascend the hill to establish a defensive position.",
  difficulty: "Easy"
},
{
  id: 38,
  subject: "Word Knowledge",
  question: "What does 'assessor' most nearly mean?",
  answer: "A person who evaluates or determines the value of something. Example: The equipment assessor documented all damage.",
  difficulty: "Easy"
},
{
  id: 39,
  subject: "Word Knowledge",
  question: "What does 'assist' most nearly mean?",
  answer: "To help or provide support to someone. Example: Combat medics assist the wounded on the battlefield.",
  difficulty: "Easy"
},
{
  id: 40,
  subject: "Word Knowledge",
  question: "What does 'attest' most nearly mean?",
  answer: "To prove or provide evidence that something is true. Example: The captain will attest to the recruit's character.",
  difficulty: "Easy"
},
{
  id: 41,
  subject: "Word Knowledge",
  question: "What does 'augment' most nearly mean?",
  answer: "To make something larger or greater in quantity. Example: The deployment will augment the peacekeeping force.",
  difficulty: "Easy"
},
{
  id: 42,
  subject: "Word Knowledge",
  question: "What does 'austere' most nearly mean?",
  answer: "Severe, strict, or lacking comfort and luxury. Example: Living conditions in the field are austere but manageable.",
  difficulty: "Easy"
},
{
  id: 43,
  subject: "Word Knowledge",
  question: "What does 'avert' most nearly mean?",
  answer: "To turn away or prevent something harmful from happening. Example: Quick action helped avert a serious accident.",
  difficulty: "Easy"
},
{
  id: 44,
  subject: "Word Knowledge",
  question: "What does 'avid' most nearly mean?",
  answer: "Enthusiastic and passionate about something. Example: He is an avid supporter of physical fitness training.",
  difficulty: "Easy"
},
{
  id: 45,
  subject: "Word Knowledge",
  question: "What does 'balmy' most nearly mean?",
  answer: "Pleasantly warm and soft; mild. Example: The balmy weather made outdoor training comfortable.",
  difficulty: "Easy"
},
{
  id: 46,
  subject: "Word Knowledge",
  question: "What does 'barrier' most nearly mean?",
  answer: "A structure or obstacle that prevents movement or access. Example: The security barrier protected the perimeter.",
  difficulty: "Easy"
},
{
  id: 47,
  subject: "Word Knowledge",
  question: "What does 'barter' most nearly mean?",
  answer: "To exchange goods or services without using money. Example: Soldiers will barter supplies with other units.",
  difficulty: "Easy"
},
{
  id: 48,
  subject: "Word Knowledge",
  question: "What does 'battalion' most nearly mean?",
  answer: "A military unit consisting of several companies. Example: The battalion assembled for the morning formation.",
  difficulty: "Easy"
},
{
  id: 49,
  subject: "Word Knowledge",
  question: "What does 'bearing' most nearly mean?",
  answer: "A person's manner or posture; direction or relevance. Example: The soldier maintained an excellent military bearing.",
  difficulty: "Easy"
},
{
  id: 50,
  subject: "Word Knowledge",
  question: "What does 'benign' most nearly mean?",
  answer: "Harmless or not malignant; mild. Example: The commander's benign attitude made him approachable.",
  difficulty: "Easy"
},
{
  id: 51,
  subject: "Word Knowledge",
  question: "What does 'bilateral' most nearly mean?",
  answer: "Relating to or affecting two sides or parties. Example: The bilateral agreement strengthened military ties.",
  difficulty: "Easy"
},
{
  id: 52,
  subject: "Word Knowledge",
  question: "What does 'bilingual' most nearly mean?",
  answer: "Able to speak two languages fluently. Example: Bilingual soldiers are valuable for intelligence operations.",
  difficulty: "Easy"
},
{
  id: 53,
  subject: "Word Knowledge",
  question: "What does 'bivouac' most nearly mean?",
  answer: "A temporary military camp. Example: The company set up a bivouac for the overnight exercise.",
  difficulty: "Easy"
},
{
  id: 54,
  subject: "Word Knowledge",
  question: "What does 'boisterous' most nearly mean?",
  answer: "Noisy, rowdy, and high-spirited. Example: The barracks became boisterous after the successful mission.",
  difficulty: "Easy"
},
{
  id: 55,
  subject: "Word Knowledge",
  question: "What does 'brevity' most nearly mean?",
  answer: "Shortness in duration or conciseness in speech. Example: Military communications require brevity and clarity.",
  difficulty: "Easy"
},
{
  id: 56,
  subject: "Word Knowledge",
  question: "What does 'brigand' most nearly mean?",
  answer: "A bandit or robber. Example: Rangers were deployed to stop the brigand activity in the region.",
  difficulty: "Easy"
},
{
  id: 57,
  subject: "Word Knowledge",
  question: "What does 'brisk' most nearly mean?",
  answer: "Energetic, quick, and efficient. Example: The troops moved at a brisk pace during the march.",
  difficulty: "Easy"
},
{
  id: 58,
  subject: "Word Knowledge",
  question: "What does 'bulwark' most nearly mean?",
  answer: "A defensive wall or a strong defense. Example: The fort served as a bulwark against invasion.",
  difficulty: "Easy"
},
{
  id: 59,
  subject: "Word Knowledge",
  question: "What does 'bunker' most nearly mean?",
  answer: "A reinforced underground shelter or a sand trap. Example: Soldiers took shelter in the concrete bunker.",
  difficulty: "Easy"
},
{
  id: 60,
  subject: "Word Knowledge",
  question: "What does 'buoyant' most nearly mean?",
  answer: "Able to float; cheerful and optimistic. Example: The team maintained a buoyant attitude despite challenges.",
  difficulty: "Easy"
},
{
  id: 61,
  subject: "Word Knowledge",
  question: "What does 'cacophony' most nearly mean?",
  answer: "A harsh mixture of loud, discordant sounds. Example: The firing range produced a cacophony of gunfire.",
  difficulty: "Medium"
},
{
  id: 62,
  subject: "Word Knowledge",
  question: "What does 'caliber' most nearly mean?",
  answer: "The diameter of a gun barrel; the quality or ability level. Example: Officers of the highest caliber lead this unit.",
  difficulty: "Medium"
},
{
  id: 63,
  subject: "Word Knowledge",
  question: "What does 'camouflage' most nearly mean?",
  answer: "Disguise or concealment to blend with surroundings. Example: Soldiers wore camouflage uniforms for the patrol.",
  difficulty: "Medium"
},
{
  id: 64,
  subject: "Word Knowledge",
  question: "What does 'candor' most nearly mean?",
  answer: "Honesty and frankness in expression. Example: The sergeant spoke with candor about the mission risks.",
  difficulty: "Medium"
},
{
  id: 65,
  subject: "Word Knowledge",
  question: "What does 'canister' most nearly mean?",
  answer: "A container for holding ammunition or supplies. Example: The gunner loaded the ammo canister into the vehicle.",
  difficulty: "Medium"
},
{
  id: 66,
  subject: "Word Knowledge",
  question: "What does 'cantonment' most nearly mean?",
  answer: "A permanent military barracks or camp. Example: The new cantonment will house the regiment.",
  difficulty: "Medium"
},
{
  id: 67,
  subject: "Word Knowledge",
  question: "What does 'capacious' most nearly mean?",
  answer: "Spacious and able to hold a large amount. Example: The capacious cargo hold transported all equipment.",
  difficulty: "Medium"
},
{
  id: 68,
  subject: "Word Knowledge",
  question: "What does 'cardinal' most nearly mean?",
  answer: "Of greatest importance; principal. Example: Maintaining discipline is cardinal to military order.",
  difficulty: "Medium"
},
{
  id: 69,
  subject: "Word Knowledge",
  question: "What does 'casualty' most nearly mean?",
  answer: "A person killed, wounded, or missing in action. Example: The field medic treated casualties from the explosion.",
  difficulty: "Medium"
},
{
  id: 70,
  subject: "Word Knowledge",
  question: "What does 'catalyst' most nearly mean?",
  answer: "Something that causes change or triggers events. Example: The intelligence report was a catalyst for action.",
  difficulty: "Medium"
},
{
  id: 71,
  subject: "Word Knowledge",
  question: "What does 'categorical' most nearly mean?",
  answer: "Absolute and without qualification; definite. Example: The general gave a categorical denial of the rumor.",
  difficulty: "Medium"
},
{
  id: 72,
  subject: "Word Knowledge",
  question: "What does 'caustic' most nearly mean?",
  answer: "Capable of burning or corroding; harshly critical. Example: His caustic remarks undermined unit morale.",
  difficulty: "Medium"
},
{
  id: 73,
  subject: "Word Knowledge",
  question: "What does 'cessation' most nearly mean?",
  answer: "A temporary stop or end of activity. Example: The firing range ordered a cessation of all shooting.",
  difficulty: "Medium"
},
{
  id: 74,
  subject: "Word Knowledge",
  question: "What does 'chafe' most nearly mean?",
  answer: "To rub or irritate; to feel frustrated. Example: The soldier's collar began to chafe his neck.",
  difficulty: "Medium"
},
{
  id: 75,
  subject: "Word Knowledge",
  question: "What does 'chaotic' most nearly mean?",
  answer: "In a state of complete disorder and confusion. Example: The evacuation became chaotic without proper coordination.",
  difficulty: "Medium"
},
{
  id: 76,
  subject: "Word Knowledge",
  question: "What does 'chaplain' most nearly mean?",
  answer: "A clergyman who serves in military, hospital, or institution. Example: The chaplain conducted services for the troops.",
  difficulty: "Medium"
},
{
  id: 77,
  subject: "Word Knowledge",
  question: "What does 'charred' most nearly mean?",
  answer: "Burnt or blackened by fire. Example: The charred remains of the vehicle were examined.",
  difficulty: "Medium"
},
{
  id: 78,
  subject: "Word Knowledge",
  question: "What does 'chassis' most nearly mean?",
  answer: "The frame or structural base of a vehicle. Example: The heavy truck's chassis can handle rough terrain.",
  difficulty: "Medium"
},
{
  id: 79,
  subject: "Word Knowledge",
  question: "What does 'checkered' most nearly mean?",
  answer: "Having a pattern of alternating colors; marked by ups and downs. Example: His military record had a checkered history.",
  difficulty: "Medium"
},
{
  id: 80,
  subject: "Word Knowledge",
  question: "What does 'circulate' most nearly mean?",
  answer: "To move in a circle; to distribute or spread information. Example: The order will circulate through all ranks.",
  difficulty: "Medium"
},
{
  id: 81,
  subject: "Word Knowledge",
  question: "What does 'circumvent' most nearly mean?",
  answer: "To go around obstacles; to find a way to avoid or bypass. Example: Soldiers must not circumvent the chain of command.",
  difficulty: "Medium"
},
{
  id: 82,
  subject: "Word Knowledge",
  question: "What does 'citadel' most nearly mean?",
  answer: "A fortress or fortified stronghold. Example: The ancient citadel provided excellent defensive positions.",
  difficulty: "Medium"
},
{
  id: 83,
  subject: "Word Knowledge",
  question: "What does 'civilian' most nearly mean?",
  answer: "A person not serving in the military or armed forces. Example: Military personnel must treat civilians with respect.",
  difficulty: "Medium"
},
{
  id: 84,
  subject: "Word Knowledge",
  question: "What does 'clarity' most nearly mean?",
  answer: "The quality of being clear and easy to understand. Example: Clarity in orders prevents confusion during operations.",
  difficulty: "Medium"
},
{
  id: 85,
  subject: "Word Knowledge",
  question: "What does 'coalition' most nearly mean?",
  answer: "An alliance of groups or nations joining together. Example: The coalition forces coordinated the joint mission.",
  difficulty: "Medium"
},
{
  id: 86,
  subject: "Word Knowledge",
  question: "What does 'coerce' most nearly mean?",
  answer: "To force or compel someone to do something. Example: Officers cannot coerce soldiers into volunteering.",
  difficulty: "Medium"
},
{
  id: 87,
  subject: "Word Knowledge",
  question: "What does 'cogent' most nearly mean?",
  answer: "Clear, logical, and convincing. Example: The commander presented cogent reasons for the strategy change.",
  difficulty: "Medium"
},
{
  id: 88,
  subject: "Word Knowledge",
  question: "What does 'cohesion' most nearly mean?",
  answer: "Unity and togetherness of a group working as one. Example: Team cohesion improves overall combat effectiveness.",
  difficulty: "Medium"
},
{
  id: 89,
  subject: "Word Knowledge",
  question: "What does 'collateral' most nearly mean?",
  answer: "Accompanying or side-by-side; security for a loan. Example: Collateral damage was minimized in the operation.",
  difficulty: "Medium"
},
{
  id: 90,
  subject: "Word Knowledge",
  question: "What does 'collision' most nearly mean?",
  answer: "An impact or crash when two objects strike each other. Example: The convoy avoided collision with oncoming traffic.",
  difficulty: "Medium"
},
{
  id: 91,
  subject: "Word Knowledge",
  question: "What does 'ambiguous' most nearly mean?",
  answer: "Open to more than one interpretation; unclear. Example: The general's ambiguous orders confused the platoon.",
  difficulty: "Medium"
},
{
  id: 92,
  subject: "Word Knowledge",
  question: "What does 'appeasement' most nearly mean?",
  answer: "The policy of giving in to demands to avoid conflict. Example: Military strength deters aggression better than appeasement.",
  difficulty: "Medium"
},
{
  id: 93,
  subject: "Word Knowledge",
  question: "What does 'arsenal' most nearly mean?",
  answer: "A collection of weapons and ammunition; resources. Example: The nation's economic arsenal includes skilled workers.",
  difficulty: "Medium"
},
{
  id: 94,
  subject: "Word Knowledge",
  question: "What does 'assertion' most nearly mean?",
  answer: "A confident or forceful statement; a claim. Example: The general's assertion about readiness boosted confidence.",
  difficulty: "Medium"
},
{
  id: 95,
  subject: "Word Knowledge",
  question: "What does 'astute' most nearly mean?",
  answer: "Having keen judgment and sharp insight. Example: The commander's astute analysis predicted enemy movements.",
  difficulty: "Medium"
},
{
  id: 96,
  subject: "Word Knowledge",
  question: "What does 'attrition' most nearly mean?",
  answer: "Gradual wearing down or reduction in strength. Example: The enemy suffered high attrition rates.",
  difficulty: "Medium"
},
{
  id: 97,
  subject: "Word Knowledge",
  question: "What does 'audacity' most nearly mean?",
  answer: "Daring boldness and willingness to take risks. Example: The raid required audacity and precision.",
  difficulty: "Medium"
},
{
  id: 98,
  subject: "Word Knowledge",
  question: "What does 'augury' most nearly mean?",
  answer: "A sign or omen that predicts the future. Example: Poor training was an augury of mission failure.",
  difficulty: "Medium"
},
{
  id: 99,
  subject: "Word Knowledge",
  question: "What does 'auspicious' most nearly mean?",
  answer: "Favorable and giving signs of future success. Example: The auspicious weather conditions ensured mission success.",
  difficulty: "Medium"
},
{
  id: 100,
  subject: "Word Knowledge",
  question: "What does 'autonomy' most nearly mean?",
  answer: "Independence and self-governance; the right to self-rule. Example: Field commanders have limited autonomy in operations.",
  difficulty: "Medium"
},
{
  id: 101,
  subject: "Word Knowledge",
  question: "What does 'bellicose' most nearly mean?",
  answer: "Hostile, aggressive, and ready for war. Example: The nation's bellicose rhetoric alarmed neighboring countries.",
  difficulty: "Hard"
},
{
  id: 102,
  subject: "Word Knowledge",
  question: "What does 'benevolence' most nearly mean?",
  answer: "Kindness and generosity toward others. Example: The commander's benevolence toward troops improved morale.",
  difficulty: "Hard"
},
{
  id: 103,
  subject: "Word Knowledge",
  question: "What does 'bestow' most nearly mean?",
  answer: "To give as a gift or honor; to confer. Example: The president will bestow medals on the heroes.",
  difficulty: "Hard"
},
{
  id: 104,
  subject: "Word Knowledge",
  question: "What does 'biased' most nearly mean?",
  answer: "Having unfair prejudice or preference for one side. Example: Objective reporting requires avoiding biased language.",
  difficulty: "Hard"
},
{
  id: 105,
  subject: "Word Knowledge",
  question: "What does 'bilateral' most nearly mean?",
  answer: "Affecting or involving two parties or sides equally. Example: Bilateral negotiations between allied nations succeeded.",
  difficulty: "Hard"
},
{
  id: 106,
  subject: "Word Knowledge",
  question: "What does 'blasphemy' most nearly mean?",
  answer: "Disrespect or contempt toward something sacred. Example: Such comments were considered blasphemy to unit traditions.",
  difficulty: "Hard"
},
{
  id: 107,
  subject: "Word Knowledge",
  question: "What does 'blight' most nearly mean?",
  answer: "A disease that damages plants; something that damages. Example: Corruption is a blight on military readiness.",
  difficulty: "Hard"
},
{
  id: 108,
  subject: "Word Knowledge",
  question: "What does 'bliss' most nearly mean?",
  answer: "Perfect happiness and joy. Example: The soldiers found bliss in the peace after deployment.",
  difficulty: "Hard"
},
{
  id: 109,
  subject: "Word Knowledge",
  question: "What does 'bolster' most nearly mean?",
  answer: "To strengthen or reinforce something. Example: Additional troops will bolster defensive positions.",
  difficulty: "Hard"
},
{
  id: 110,
  subject: "Word Knowledge",
  question: "What does 'bonanza' most nearly mean?",
  answer: "A situation that suddenly produces wealth or success. Example: The supply agreement was a bonanza for the base.",
  difficulty: "Hard"
},
{
  id: 111,
  subject: "Word Knowledge",
  question: "What does 'bound' most nearly mean?",
  answer: "Limited by or tied to something; moving quickly. Example: Personnel are bound by oath to protect the country.",
  difficulty: "Hard"
},
{
  id: 112,
  subject: "Word Knowledge",
  question: "What does 'bourgeois' most nearly mean?",
  answer: "Relating to the middle class or materialistic values. Example: Military training discourages bourgeois attitudes.",
  difficulty: "Hard"
},
{
  id: 113,
  subject: "Word Knowledge",
  question: "What does 'bowdlerize' most nearly mean?",
  answer: "To remove offensive content or censor something. Example: The report was bowdlerized for public distribution.",
  difficulty: "Hard"
},
{
  id: 114,
  subject: "Word Knowledge",
  question: "What does 'brackish' most nearly mean?",
  answer: "Slightly salty; of mixed or questionable quality. Example: The brackish water was unsuitable for drinking.",
  difficulty: "Hard"
},
{
  id: 115,
  subject: "Word Knowledge",
  question: "What does 'braggadocio' most nearly mean?",
  answer: "Boastful and arrogant behavior or language. Example: True leaders avoid braggadocio about their accomplishments.",
  difficulty: "Hard"
},
{
  id: 116,
  subject: "Word Knowledge",
  question: "What does 'brigantine' most nearly mean?",
  answer: "A two-masted sailing ship used in naval operations. Example: The brigantine transported supplies across the ocean.",
  difficulty: "Hard"
},
{
  id: 117,
  subject: "Word Knowledge",
  question: "What does 'broadside' most nearly mean?",
  answer: "A forceful verbal attack; naval cannon fire from all guns. Example: The admiral unleashed a broadside of criticism.",
  difficulty: "Hard"
},
{
  id: 118,
  subject: "Word Knowledge",
  question: "What does 'buffoon' most nearly mean?",
  answer: "A foolish person who acts ridiculously. Example: No one respected the officer who acted like a buffoon.",
  difficulty: "Hard"
},
{
  id: 119,
  subject: "Word Knowledge",
  question: "What does 'bureaucracy' most nearly mean?",
  answer: "Complex administrative systems with rigid rules. Example: Military bureaucracy sometimes slows down decisions.",
  difficulty: "Hard"
},
{
  id: 120,
  subject: "Word Knowledge",
  question: "What does 'burgeoning' most nearly mean?",
  answer: "Growing, flourishing, and rapidly increasing. Example: The base's burgeoning population required new facilities.",
  difficulty: "Hard"
}
,
{
  id: 121,
  subject: "Mathematics Knowledge",
  question: "What is 1/2 + 1/4?",
  answer: "1/2 + 1/4 = 2/4 + 1/4 = 3/4. Convert 1/2 to 2/4 to have a common denominator of 4, then add the numerators.",
  difficulty: "Easy"
},
{
  id: 122,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x + 5 = 15",
  answer: "2x + 5 = 15. Subtract 5 from both sides: 2x = 10. Divide both sides by 2: x = 5.",
  difficulty: "Easy"
},
{
  id: 123,
  subject: "Mathematics Knowledge",
  question: "What is 25% of 80?",
  answer: "25% of 80 = 0.25 × 80 = 20. Convert percentage to decimal (25% = 0.25) and multiply by 80.",
  difficulty: "Easy"
},
{
  id: 124,
  subject: "Mathematics Knowledge",
  question: "Convert 0.375 to a fraction.",
  answer: "0.375 = 375/1000 = 3/8. Divide both numerator and denominator by 125 to simplify.",
  difficulty: "Easy"
},
{
  id: 125,
  subject: "Mathematics Knowledge",
  question: "What is 3^3?",
  answer: "3^3 = 3 × 3 × 3 = 27. Multiply 3 by itself 3 times.",
  difficulty: "Easy"
},
{
  id: 126,
  subject: "Mathematics Knowledge",
  question: "What is the area of a rectangle with length 6 and width 4?",
  answer: "Area = length × width = 6 × 4 = 24 square units.",
  difficulty: "Easy"
},
{
  id: 127,
  subject: "Mathematics Knowledge",
  question: "What is 3/4 × 2/3?",
  answer: "3/4 × 2/3 = (3 × 2)/(4 × 3) = 6/12 = 1/2. Multiply numerators and denominators, then simplify.",
  difficulty: "Easy"
},
{
  id: 128,
  subject: "Mathematics Knowledge",
  question: "Solve for y: y - 7 = 3",
  answer: "y - 7 = 3. Add 7 to both sides: y = 10.",
  difficulty: "Easy"
},
{
  id: 129,
  subject: "Mathematics Knowledge",
  question: "What is 10% of 50?",
  answer: "10% of 50 = 0.10 × 50 = 5. Convert 10% to 0.10 and multiply by 50.",
  difficulty: "Easy"
},
{
  id: 130,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a square with side length 5?",
  answer: "Perimeter = 4 × side = 4 × 5 = 20 units. A square has 4 equal sides.",
  difficulty: "Easy"
},
{
  id: 131,
  subject: "Mathematics Knowledge",
  question: "What is 2^5?",
  answer: "2^5 = 2 × 2 × 2 × 2 × 2 = 32. Multiply 2 by itself 5 times.",
  difficulty: "Easy"
},
{
  id: 132,
  subject: "Mathematics Knowledge",
  question: "What is 1/3 + 1/6?",
  answer: "1/3 + 1/6 = 2/6 + 1/6 = 3/6 = 1/2. Convert 1/3 to 2/6 for a common denominator of 6.",
  difficulty: "Easy"
},
{
  id: 133,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x = 12",
  answer: "3x = 12. Divide both sides by 3: x = 4.",
  difficulty: "Easy"
},
{
  id: 134,
  subject: "Mathematics Knowledge",
  question: "What is 50% of 24?",
  answer: "50% of 24 = 0.50 × 24 = 12. 50% is equivalent to dividing by 2.",
  difficulty: "Easy"
},
{
  id: 135,
  subject: "Mathematics Knowledge",
  question: "Convert 0.25 to a fraction.",
  answer: "0.25 = 25/100 = 1/4. Divide both numerator and denominator by 25.",
  difficulty: "Easy"
},
{
  id: 136,
  subject: "Mathematics Knowledge",
  question: "What is 4^2?",
  answer: "4^2 = 4 × 4 = 16. Any number squared means multiplying it by itself.",
  difficulty: "Easy"
},
{
  id: 137,
  subject: "Mathematics Knowledge",
  question: "What is the area of a triangle with base 8 and height 5?",
  answer: "Area = (1/2) × base × height = (1/2) × 8 × 5 = 20 square units.",
  difficulty: "Easy"
},
{
  id: 138,
  subject: "Mathematics Knowledge",
  question: "What is 2/5 + 1/5?",
  answer: "2/5 + 1/5 = (2 + 1)/5 = 3/5. When denominators are the same, add the numerators.",
  difficulty: "Easy"
},
{
  id: 139,
  subject: "Mathematics Knowledge",
  question: "Solve for z: z + 12 = 25",
  answer: "z + 12 = 25. Subtract 12 from both sides: z = 13.",
  difficulty: "Easy"
},
{
  id: 140,
  subject: "Mathematics Knowledge",
  question: "What is 20% of 100?",
  answer: "20% of 100 = 0.20 × 100 = 20. Convert 20% to 0.20 and multiply.",
  difficulty: "Easy"
},
{
  id: 141,
  subject: "Mathematics Knowledge",
  question: "Convert 0.5 to a fraction.",
  answer: "0.5 = 5/10 = 1/2. Divide both numerator and denominator by 5.",
  difficulty: "Easy"
},
{
  id: 142,
  subject: "Mathematics Knowledge",
  question: "What is 5^2?",
  answer: "5^2 = 5 × 5 = 25. A number squared is the number multiplied by itself.",
  difficulty: "Easy"
},
{
  id: 143,
  subject: "Mathematics Knowledge",
  question: "What is the circumference of a circle with radius 3? (Use π ≈ 3.14)",
  answer: "Circumference = 2πr = 2 × 3.14 × 3 ≈ 18.84 units.",
  difficulty: "Easy"
},
{
  id: 144,
  subject: "Mathematics Knowledge",
  question: "What is 3/8 - 1/8?",
  answer: "3/8 - 1/8 = (3 - 1)/8 = 2/8 = 1/4. Subtract numerators when denominators are the same.",
  difficulty: "Easy"
},
{
  id: 145,
  subject: "Mathematics Knowledge",
  question: "Solve for a: a/2 = 6",
  answer: "a/2 = 6. Multiply both sides by 2: a = 12.",
  difficulty: "Easy"
},
{
  id: 146,
  subject: "Mathematics Knowledge",
  question: "What is 15% of 60?",
  answer: "15% of 60 = 0.15 × 60 = 9. Convert percentage to decimal and multiply.",
  difficulty: "Easy"
},
{
  id: 147,
  subject: "Mathematics Knowledge",
  question: "Convert 0.75 to a fraction.",
  answer: "0.75 = 75/100 = 3/4. Divide both numerator and denominator by 25.",
  difficulty: "Easy"
},
{
  id: 148,
  subject: "Mathematics Knowledge",
  question: "What is 6^2?",
  answer: "6^2 = 6 × 6 = 36.",
  difficulty: "Easy"
},
{
  id: 149,
  subject: "Mathematics Knowledge",
  question: "What is the area of a circle with radius 2? (Use π ≈ 3.14)",
  answer: "Area = πr^2 = 3.14 × 2^2 = 3.14 × 4 ≈ 12.56 square units.",
  difficulty: "Easy"
},
{
  id: 150,
  subject: "Mathematics Knowledge",
  question: "What is 5/6 - 1/6?",
  answer: "5/6 - 1/6 = (5 - 1)/6 = 4/6 = 2/3. Subtract numerators when denominators match.",
  difficulty: "Easy"
},
{
  id: 151,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x - 3 = 7",
  answer: "2x - 3 = 7. Add 3 to both sides: 2x = 10. Divide by 2: x = 5.",
  difficulty: "Medium"
},
{
  id: 152,
  subject: "Mathematics Knowledge",
  question: "What is 30% of 150?",
  answer: "30% of 150 = 0.30 × 150 = 45. Move decimal point two places and multiply.",
  difficulty: "Medium"
},
{
  id: 153,
  subject: "Mathematics Knowledge",
  question: "If a shirt costs $40 and is on sale for 25% off, what is the sale price?",
  answer: "Discount = 25% of $40 = 0.25 × 40 = $10. Sale price = $40 - $10 = $30.",
  difficulty: "Medium"
},
{
  id: 154,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x/3 + 2 = 5",
  answer: "x/3 + 2 = 5. Subtract 2: x/3 = 3. Multiply by 3: x = 9.",
  difficulty: "Medium"
},
{
  id: 155,
  subject: "Mathematics Knowledge",
  question: "What is 2/3 ÷ 1/3?",
  answer: "2/3 ÷ 1/3 = 2/3 × 3/1 = (2 × 3)/(3 × 1) = 6/3 = 2. To divide fractions, multiply by the reciprocal.",
  difficulty: "Medium"
},
{
  id: 156,
  subject: "Mathematics Knowledge",
  question: "Simplify: 3(x + 2) - 5",
  answer: "3(x + 2) - 5 = 3x + 6 - 5 = 3x + 1. Distribute the 3 and combine like terms.",
  difficulty: "Medium"
},
{
  id: 157,
  subject: "Mathematics Knowledge",
  question: "What is 0.5 × 0.4?",
  answer: "0.5 × 0.4 = 0.20. Multiply as you would whole numbers: 5 × 4 = 20, then place decimal two places from the right.",
  difficulty: "Medium"
},
{
  id: 158,
  subject: "Mathematics Knowledge",
  question: "A triangle has angles of 45°, 60°, and x°. What is x?",
  answer: "The sum of angles in a triangle is 180°. 45° + 60° + x° = 180°. x° = 75°.",
  difficulty: "Medium"
},
{
  id: 159,
  subject: "Mathematics Knowledge",
  question: "What is 3/4 ÷ 2/5?",
  answer: "3/4 ÷ 2/5 = 3/4 × 5/2 = (3 × 5)/(4 × 2) = 15/8 = 1 7/8. Multiply by the reciprocal of the divisor.",
  difficulty: "Medium"
},
{
  id: 160,
  subject: "Mathematics Knowledge",
  question: "Solve for y: 2y + 3 = y + 8",
  answer: "2y + 3 = y + 8. Subtract y: y + 3 = 8. Subtract 3: y = 5.",
  difficulty: "Medium"
},
{
  id: 161,
  subject: "Mathematics Knowledge",
  question: "What is 45% of 200?",
  answer: "45% of 200 = 0.45 × 200 = 90.",
  difficulty: "Medium"
},
{
  id: 162,
  subject: "Mathematics Knowledge",
  question: "If a book costs $25 and increases in price by 20%, what is the new price?",
  answer: "Increase = 20% of $25 = 0.20 × 25 = $5. New price = $25 + $5 = $30.",
  difficulty: "Medium"
},
{
  id: 163,
  subject: "Mathematics Knowledge",
  question: "What is 1.5 + 2.3?",
  answer: "1.5 + 2.3 = 3.8. Align decimal points and add.",
  difficulty: "Medium"
},
{
  id: 164,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 4x - 2 = 6",
  answer: "4x - 2 = 6. Add 2: 4x = 8. Divide by 4: x = 2.",
  difficulty: "Medium"
},
{
  id: 165,
  subject: "Mathematics Knowledge",
  question: "What is 5/8 + 1/4?",
  answer: "5/8 + 1/4 = 5/8 + 2/8 = 7/8. Convert 1/4 to 2/8 for common denominator.",
  difficulty: "Medium"
},
{
  id: 166,
  subject: "Mathematics Knowledge",
  question: "Simplify: 2(x + 3) + 3(x - 1)",
  answer: "2(x + 3) + 3(x - 1) = 2x + 6 + 3x - 3 = 5x + 3. Distribute and combine like terms.",
  difficulty: "Medium"
},
{
  id: 167,
  subject: "Mathematics Knowledge",
  question: "What is 0.25 × 0.8?",
  answer: "0.25 × 0.8 = 0.20. Multiply: 25 × 8 = 200, then place decimal four places from the right.",
  difficulty: "Medium"
},
{
  id: 168,
  subject: "Mathematics Knowledge",
  question: "A rectangle has length 10 and perimeter 30. What is its width?",
  answer: "Perimeter = 2(length + width). 30 = 2(10 + w). 15 = 10 + w. w = 5.",
  difficulty: "Medium"
},
{
  id: 169,
  subject: "Mathematics Knowledge",
  question: "What is 7/10 - 3/10?",
  answer: "7/10 - 3/10 = (7 - 3)/10 = 4/10 = 2/5. Subtract numerators when denominators match.",
  difficulty: "Medium"
},
{
  id: 170,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x + 5 = 2x + 10",
  answer: "3x + 5 = 2x + 10. Subtract 2x: x + 5 = 10. Subtract 5: x = 5.",
  difficulty: "Medium"
},
{
  id: 171,
  subject: "Mathematics Knowledge",
  question: "What is 60% of 75?",
  answer: "60% of 75 = 0.60 × 75 = 45.",
  difficulty: "Medium"
},
{
  id: 172,
  subject: "Mathematics Knowledge",
  question: "If an item is 30% off and costs $21 after discount, what was the original price?",
  answer: "If 30% off, the item costs 70% of original. 0.70 × original = $21. original = $21 ÷ 0.70 = $30.",
  difficulty: "Medium"
},
{
  id: 173,
  subject: "Mathematics Knowledge",
  question: "What is 2.5 - 1.3?",
  answer: "2.5 - 1.3 = 1.2. Align decimal points and subtract.",
  difficulty: "Medium"
},
{
  id: 174,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 5x - 3 = 12",
  answer: "5x - 3 = 12. Add 3: 5x = 15. Divide by 5: x = 3.",
  difficulty: "Medium"
},
{
  id: 175,
  subject: "Mathematics Knowledge",
  question: "What is 3/7 × 4/9?",
  answer: "3/7 × 4/9 = (3 × 4)/(7 × 9) = 12/63 = 4/21. Multiply numerators and denominators, then simplify.",
  difficulty: "Medium"
},
{
  id: 176,
  subject: "Mathematics Knowledge",
  question: "Simplify: 4(2x - 1) - 2(x + 3)",
  answer: "4(2x - 1) - 2(x + 3) = 8x - 4 - 2x - 6 = 6x - 10. Distribute and combine like terms.",
  difficulty: "Medium"
},
{
  id: 177,
  subject: "Mathematics Knowledge",
  question: "What is 1.2 × 2.5?",
  answer: "1.2 × 2.5 = 3.0 or 3. Multiply: 12 × 25 = 300, then place decimal two places from the right.",
  difficulty: "Medium"
},
{
  id: 178,
  subject: "Mathematics Knowledge",
  question: "A triangle has base 6 and area 12. What is its height?",
  answer: "Area = (1/2) × base × height. 12 = (1/2) × 6 × h. 12 = 3h. h = 4.",
  difficulty: "Medium"
},
{
  id: 179,
  subject: "Mathematics Knowledge",
  question: "What is 9/10 ÷ 3/5?",
  answer: "9/10 ÷ 3/5 = 9/10 × 5/3 = (9 × 5)/(10 × 3) = 45/30 = 3/2 = 1.5. Multiply by reciprocal.",
  difficulty: "Medium"
},
{
  id: 180,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2(x + 4) = 16",
  answer: "2(x + 4) = 16. Divide by 2: x + 4 = 8. Subtract 4: x = 4.",
  difficulty: "Medium"
},
{
  id: 181,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x^2 = 16",
  answer: "x^2 = 16. Take the square root of both sides: x = 4 or x = -4. Both values satisfy the equation.",
  difficulty: "Hard"
},
{
  id: 182,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x^2 - 5x + 6 = 0",
  answer: "Factor: (x - 2)(x - 3) = 0. Therefore x = 2 or x = 3. These are the solutions when each factor equals zero.",
  difficulty: "Hard"
},
{
  id: 183,
  subject: "Mathematics Knowledge",
  question: "What is the value of 2^3 + 3^2 - 4?",
  answer: "2^3 = 8, 3^2 = 9. 8 + 9 - 4 = 13. Calculate exponents first, then add and subtract.",
  difficulty: "Hard"
},
{
  id: 184,
  subject: "Mathematics Knowledge",
  question: "If 3x - 2 = 2x + 5, what is x?",
  answer: "3x - 2 = 2x + 5. Subtract 2x: x - 2 = 5. Add 2: x = 7.",
  difficulty: "Hard"
},
{
  id: 185,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a cube with side length 3?",
  answer: "Volume = side^3 = 3^3 = 27 cubic units. A cube's volume is the side length cubed.",
  difficulty: "Hard"
},
{
  id: 186,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x^2 = 50",
  answer: "2x^2 = 50. Divide by 2: x^2 = 25. Take square root: x = 5 or x = -5.",
  difficulty: "Hard"
},
{
  id: 187,
  subject: "Mathematics Knowledge",
  question: "What is (1/2)^3?",
  answer: "(1/2)^3 = (1/2) × (1/2) × (1/2) = 1/8. Raise both numerator and denominator to the power.",
  difficulty: "Hard"
},
{
  id: 188,
  subject: "Mathematics Knowledge",
  question: "If the ratio of boys to girls is 3:5 and there are 15 boys, how many girls are there?",
  answer: "If boys:girls = 3:5 and boys = 15, then 3 units = 15, so 1 unit = 5. Girls = 5 × 5 = 25.",
  difficulty: "Hard"
},
{
  id: 189,
  subject: "Mathematics Knowledge",
  question: "What is 40% of what number equals 20?",
  answer: "0.40 × x = 20. Divide by 0.40: x = 20 ÷ 0.40 = 50. The number is 50.",
  difficulty: "Hard"
},
{
  id: 190,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3(x - 2) = 2(x + 1)",
  answer: "3(x - 2) = 2(x + 1). Expand: 3x - 6 = 2x + 2. Subtract 2x: x - 6 = 2. Add 6: x = 8.",
  difficulty: "Hard"
},
{
  id: 191,
  subject: "Mathematics Knowledge",
  question: "What is 85% of 120?",
  answer: "85% of 120 = 0.85 × 120 = 102.",
  difficulty: "Hard"
},
{
  id: 192,
  subject: "Mathematics Knowledge",
  question: "If a number is decreased by 25% and the result is 60, what was the original number?",
  answer: "If decreased by 25%, the result is 75% of original. 0.75 × original = 60. original = 60 ÷ 0.75 = 80.",
  difficulty: "Hard"
},
{
  id: 193,
  subject: "Mathematics Knowledge",
  question: "What is (2/3)^2?",
  answer: "(2/3)^2 = (2/3) × (2/3) = 4/9. Square both numerator and denominator.",
  difficulty: "Hard"
},
{
  id: 194,
  subject: "Mathematics Knowledge",
  question: "A square has area 49. What is its perimeter?",
  answer: "If area = 49, then side^2 = 49, so side = 7. Perimeter = 4 × 7 = 28.",
  difficulty: "Hard"
},
{
  id: 195,
  subject: "Mathematics Knowledge",
  question: "What is 2.4 ÷ 0.6?",
  answer: "2.4 ÷ 0.6 = 24 ÷ 6 = 4. Convert to avoid decimals by multiplying both by 10.",
  difficulty: "Hard"
},
{
  id: 196,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x^2 - 9 = 0",
  answer: "x^2 - 9 = 0. Factor: (x - 3)(x + 3) = 0. Therefore x = 3 or x = -3.",
  difficulty: "Hard"
},
{
  id: 197,
  subject: "Mathematics Knowledge",
  question: "If 2x + 3y = 12 and x = 3, what is y?",
  answer: "2(3) + 3y = 12. 6 + 3y = 12. Subtract 6: 3y = 6. Divide by 3: y = 2.",
  difficulty: "Hard"
},
{
  id: 198,
  subject: "Mathematics Knowledge",
  question: "What is the circumference of a circle with diameter 10? (Use π ≈ 3.14)",
  answer: "Circumference = πd = 3.14 × 10 = 31.4 units.",
  difficulty: "Hard"
},
{
  id: 199,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x/2 + x/3 = 10",
  answer: "x/2 + x/3 = 10. Find common denominator 6: 3x/6 + 2x/6 = 10. 5x/6 = 10. x = 12.",
  difficulty: "Hard"
},
{
  id: 200,
  subject: "Mathematics Knowledge",
  question: "What is 3^4?",
  answer: "3^4 = 3 × 3 × 3 × 3 = 81. Multiply 3 by itself 4 times.",
  difficulty: "Hard"
},
{
  id: 201,
  subject: "Mathematics Knowledge",
  question: "What is 1/5 + 2/5?",
  answer: "1/5 + 2/5 = (1 + 2)/5 = 3/5. When denominators are equal, add numerators.",
  difficulty: "Easy"
},
{
  id: 202,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x - 5 = 2",
  answer: "x - 5 = 2. Add 5 to both sides: x = 7.",
  difficulty: "Easy"
},
{
  id: 203,
  subject: "Mathematics Knowledge",
  question: "What is 35% of 100?",
  answer: "35% of 100 = 0.35 × 100 = 35. When the number is 100, the percentage equals the percent value.",
  difficulty: "Easy"
},
{
  id: 204,
  subject: "Mathematics Knowledge",
  question: "Convert 0.6 to a fraction.",
  answer: "0.6 = 6/10 = 3/5. Divide both numerator and denominator by 2.",
  difficulty: "Easy"
},
{
  id: 205,
  subject: "Mathematics Knowledge",
  question: "What is 2^4?",
  answer: "2^4 = 2 × 2 × 2 × 2 = 16.",
  difficulty: "Easy"
},
{
  id: 206,
  subject: "Mathematics Knowledge",
  question: "What is the area of a rectangle with length 7 and width 3?",
  answer: "Area = length × width = 7 × 3 = 21 square units.",
  difficulty: "Easy"
},
{
  id: 207,
  subject: "Mathematics Knowledge",
  question: "What is 2/5 × 5/6?",
  answer: "2/5 × 5/6 = (2 × 5)/(5 × 6) = 10/30 = 1/3. Multiply numerators and denominators, then simplify.",
  difficulty: "Easy"
},
{
  id: 208,
  subject: "Mathematics Knowledge",
  question: "Solve for y: y + 3 = 8",
  answer: "y + 3 = 8. Subtract 3 from both sides: y = 5.",
  difficulty: "Easy"
},
{
  id: 209,
  subject: "Mathematics Knowledge",
  question: "What is 5% of 40?",
  answer: "5% of 40 = 0.05 × 40 = 2.",
  difficulty: "Easy"
},
{
  id: 210,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a triangle with sides 3, 4, and 5?",
  answer: "Perimeter = 3 + 4 + 5 = 12 units. Add all three sides.",
  difficulty: "Easy"
},
{
  id: 211,
  subject: "Mathematics Knowledge",
  question: "What is 7^2?",
  answer: "7^2 = 7 × 7 = 49.",
  difficulty: "Easy"
},
{
  id: 212,
  subject: "Mathematics Knowledge",
  question: "What is 1/2 - 1/4?",
  answer: "1/2 - 1/4 = 2/4 - 1/4 = 1/4. Convert 1/2 to 2/4 for a common denominator.",
  difficulty: "Easy"
},
{
  id: 213,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x = 8",
  answer: "2x = 8. Divide both sides by 2: x = 4.",
  difficulty: "Easy"
},
{
  id: 214,
  subject: "Mathematics Knowledge",
  question: "What is 40% of 50?",
  answer: "40% of 50 = 0.40 × 50 = 20.",
  difficulty: "Easy"
},
{
  id: 215,
  subject: "Mathematics Knowledge",
  question: "Convert 0.125 to a fraction.",
  answer: "0.125 = 125/1000 = 1/8. Divide both numerator and denominator by 125.",
  difficulty: "Easy"
},
{
  id: 216,
  subject: "Mathematics Knowledge",
  question: "What is 8^2?",
  answer: "8^2 = 8 × 8 = 64.",
  difficulty: "Easy"
},
{
  id: 217,
  subject: "Mathematics Knowledge",
  question: "What is the area of a triangle with base 10 and height 6?",
  answer: "Area = (1/2) × base × height = (1/2) × 10 × 6 = 30 square units.",
  difficulty: "Easy"
},
{
  id: 218,
  subject: "Mathematics Knowledge",
  question: "What is 4/9 + 2/9?",
  answer: "4/9 + 2/9 = (4 + 2)/9 = 6/9 = 2/3. Add numerators when denominators match.",
  difficulty: "Easy"
},
{
  id: 219,
  subject: "Mathematics Knowledge",
  question: "Solve for z: z - 4 = 11",
  answer: "z - 4 = 11. Add 4 to both sides: z = 15.",
  difficulty: "Easy"
},
{
  id: 220,
  subject: "Mathematics Knowledge",
  question: "What is 65% of 80?",
  answer: "65% of 80 = 0.65 × 80 = 52.",
  difficulty: "Easy"
}
,
  {
    id: 221,
    subject: "General Science",
    question: "What is the basic unit of life?",
    answer: "The cell is the basic unit of life. All living organisms are composed of one or more cells, and cells can only come from pre-existing cells.",
    difficulty: "Easy"
  },
  {
    id: 222,
    subject: "General Science",
    question: "Define photosynthesis.",
    answer: "Photosynthesis is the process by which plants convert light energy (from the sun) into chemical energy stored in glucose, using carbon dioxide and water.",
    difficulty: "Easy"
  },
  {
    id: 223,
    subject: "General Science",
    question: "What are the four main types of macromolecules in living organisms?",
    answer: "The four main macromolecules are: carbohydrates, lipids, proteins, and nucleic acids. Each serves critical functions in cell structure and function.",
    difficulty: "Medium"
  },
  {
    id: 224,
    subject: "General Science",
    question: "What is the function of mitochondria?",
    answer: "Mitochondria are the powerhouses of the cell. They produce ATP (adenosine triphosphate) through cellular respiration, providing energy for cellular processes.",
    difficulty: "Easy"
  },
  {
    id: 225,
    subject: "General Science",
    question: "Name the three states of matter.",
    answer: "The three states of matter are: solid (fixed shape and volume), liquid (fixed volume but takes shape of container), and gas (no fixed shape or volume).",
    difficulty: "Easy"
  },
  {
    id: 226,
    subject: "General Science",
    question: "What is an atom?",
    answer: "An atom is the smallest unit of an element that retains the element's chemical properties. It consists of protons and neutrons in the nucleus, with electrons orbiting.",
    difficulty: "Easy"
  },
  {
    id: 227,
    subject: "General Science",
    question: "Define pH and the pH scale.",
    answer: "pH measures the concentration of hydrogen ions in a solution on a scale of 0-14. pH below 7 is acidic, pH 7 is neutral, and pH above 7 is basic/alkaline.",
    difficulty: "Medium"
  },
  {
    id: 228,
    subject: "General Science",
    question: "What is the process of osmosis?",
    answer: "Osmosis is the movement of water molecules across a semipermeable membrane from an area of higher water concentration to lower water concentration.",
    difficulty: "Medium"
  },
  {
    id: 229,
    subject: "General Science",
    question: "What are the main functions of the circulatory system?",
    answer: "The circulatory system transports oxygen and nutrients to cells, removes carbon dioxide and waste products, and helps regulate body temperature and pH.",
    difficulty: "Easy"
  },
  {
    id: 230,
    subject: "General Science",
    question: "Define metabolism.",
    answer: "Metabolism is the sum of all chemical reactions that occur in an organism to maintain life, including catabolism (breaking down) and anabolism (building up).",
    difficulty: "Medium"
  },
  {
    id: 231,
    subject: "General Science",
    question: "What is the basic function of DNA?",
    answer: "DNA (deoxyribonucleic acid) stores genetic information and instructions for building proteins. It carries hereditary information passed from parent to offspring.",
    difficulty: "Easy"
  },
  {
    id: 232,
    subject: "General Science",
    question: "Name the four bases found in DNA.",
    answer: "The four bases in DNA are adenine (A), thymine (T), guanine (G), and cytosine (C). They pair as A-T and G-C in the double helix structure.",
    difficulty: "Medium"
  },
  {
    id: 233,
    subject: "General Science",
    question: "What is the primary function of the respiratory system?",
    answer: "The respiratory system exchanges gases between the body and the environment, bringing oxygen into the lungs and removing carbon dioxide waste.",
    difficulty: "Easy"
  },
  {
    id: 234,
    subject: "General Science",
    question: "Define homeostasis.",
    answer: "Homeostasis is the maintenance of stable internal conditions in an organism despite external environmental changes, essential for survival.",
    difficulty: "Medium"
  },
  {
    id: 235,
    subject: "General Science",
    question: "What is an element?",
    answer: "An element is a pure substance made of only one type of atom, characterized by its atomic number (number of protons). There are about 118 known elements.",
    difficulty: "Easy"
  },
  {
    id: 236,
    subject: "General Science",
    question: "Explain the difference between prokaryotes and eukaryotes.",
    answer: "Prokaryotes lack a membrane-bound nucleus and organelles (bacteria), while eukaryotes have a nucleus and organelles (animals, plants, fungi). Eukaryotes are generally larger.",
    difficulty: "Medium"
  },
  {
    id: 237,
    subject: "General Science",
    question: "What are the main components of blood?",
    answer: "Blood consists of plasma (55%), red blood cells (carry oxygen), white blood cells (fight infection), and platelets (aid clotting). This composition is critical for transport and defense.",
    difficulty: "Medium"
  },
  {
    id: 238,
    subject: "General Science",
    question: "Define ecosystem.",
    answer: "An ecosystem is a community of living organisms interacting with each other and their physical environment, including energy flow and nutrient cycling.",
    difficulty: "Easy"
  },
  {
    id: 239,
    subject: "General Science",
    question: "What is the law of conservation of energy?",
    answer: "Energy cannot be created or destroyed, only transformed from one form to another. Total energy in an isolated system remains constant.",
    difficulty: "Medium"
  },
  {
    id: 240,
    subject: "General Science",
    question: "Name the two types of skeleton in animals.",
    answer: "The two types are endoskeleton (internal, found in vertebrates like humans) and exoskeleton (external, found in arthropods like insects).",
    difficulty: "Easy"
  },
  {
    id: 241,
    subject: "General Science",
    question: "What is photosynthesis' relationship to cellular respiration?",
    answer: "Photosynthesis stores energy from sunlight in glucose; cellular respiration releases that energy. They are reverse processes: 6CO₂ + 6H₂O ↔ C₆H₁₂O₆ + 6O₂.",
    difficulty: "Hard"
  },
  {
    id: 242,
    subject: "General Science",
    question: "Define reproduction.",
    answer: "Reproduction is the biological process by which organisms produce offspring, occurring through sexual reproduction (two parents, genetic variation) or asexual (one parent, identical).",
    difficulty: "Easy"
  },
  {
    id: 243,
    subject: "General Science",
    question: "What is the role of enzymes in biochemical reactions?",
    answer: "Enzymes are biological catalysts that speed up chemical reactions by lowering activation energy without being consumed. Essential for all metabolic processes.",
    difficulty: "Hard"
  },
  {
    id: 244,
    subject: "General Science",
    question: "Explain the rock cycle.",
    answer: "The rock cycle describes how rocks form and change: igneous rocks form from magma, weather into sediment, compact into sedimentary rocks, and transform under heat/pressure into metamorphic rocks.",
    difficulty: "Medium"
  },
  {
    id: 245,
    subject: "General Science",
    question: "What is density?",
    answer: "Density is the mass of an object per unit volume, calculated as mass divided by volume. It determines whether objects sink or float in fluids.",
    difficulty: "Easy"
  },
  {
    id: 246,
    subject: "General Science",
    question: "Define mutation.",
    answer: "A mutation is a change in an organism's DNA sequence that can result from errors during replication or external damage, potentially affecting traits or fitness.",
    difficulty: "Medium"
  },
  {
    id: 247,
    subject: "General Science",
    question: "What is natural selection?",
    answer: "Natural selection is the mechanism of evolution where organisms with advantageous traits are more likely to survive and reproduce, passing traits to offspring.",
    difficulty: "Medium"
  },
  {
    id: 248,
    subject: "General Science",
    question: "Name the five kingdoms of life classification.",
    answer: "The five kingdoms are: Monera (bacteria), Protista (protists), Fungi, Plantae (plants), and Animalia (animals), based on cellular structure and nutrition.",
    difficulty: "Medium"
  },
  {
    id: 249,
    subject: "General Science",
    question: "What is the primary function of the kidney?",
    answer: "Kidneys filter blood to remove urea and excess water, producing urine for waste excretion. They regulate electrolyte balance and blood pressure.",
    difficulty: "Medium"
  },
  {
    id: 250,
    subject: "General Science",
    question: "Define force.",
    answer: "Force is any push or pull that can change an object's motion or shape, measured in newtons (N). It has both magnitude and direction.",
    difficulty: "Easy"
  },
  {
    id: 251,
    subject: "General Science",
    question: "What is Newton's first law of motion?",
    answer: "An object at rest stays at rest, and an object in motion stays in motion with constant velocity unless acted upon by an external force.",
    difficulty: "Medium"
  },
  {
    id: 252,
    subject: "General Science",
    question: "Explain Newton's second law of motion.",
    answer: "The force on an object equals its mass times acceleration (F = ma). A greater force or smaller mass produces greater acceleration.",
    difficulty: "Medium"
  },
  {
    id: 253,
    subject: "General Science",
    question: "What is Newton's third law of motion?",
    answer: "For every action, there is an equal and opposite reaction. Forces always occur in pairs acting on different objects.",
    difficulty: "Easy"
  },
  {
    id: 254,
    subject: "General Science",
    question: "Define velocity.",
    answer: "Velocity is the rate of change of position in a specific direction, measuring both speed and direction. It is a vector quantity.",
    difficulty: "Easy"
  },
  {
    id: 255,
    subject: "General Science",
    question: "What is acceleration?",
    answer: "Acceleration is the rate of change of velocity over time. It can be positive (speeding up), negative (slowing down), or directional change.",
    difficulty: "Medium"
  },
  {
    id: 256,
    subject: "General Science",
    question: "Define potential energy.",
    answer: "Potential energy is stored energy due to an object's position or configuration. Gravitational PE = mgh; elastic PE = ½kx².",
    difficulty: "Medium"
  },
  {
    id: 257,
    subject: "General Science",
    question: "What is kinetic energy?",
    answer: "Kinetic energy is the energy of motion, calculated as KE = ½mv². It depends on both mass and velocity of the moving object.",
    difficulty: "Easy"
  },
  {
    id: 258,
    subject: "General Science",
    question: "What is work in physics?",
    answer: "Work is force applied over a distance in the direction of the force, measured in joules. W = Fd cos(θ). It transfers energy to an object.",
    difficulty: "Medium"
  },
  {
    id: 259,
    subject: "General Science",
    question: "Define friction.",
    answer: "Friction is a force that opposes motion between surfaces in contact. Static friction prevents motion; kinetic friction acts during motion.",
    difficulty: "Easy"
  },
  {
    id: 260,
    subject: "General Science",
    question: "What is a compound?",
    answer: "A compound is a pure substance made of two or more elements chemically bonded in fixed proportions, with properties different from its constituent elements.",
    difficulty: "Easy"
  },
  {
    id: 261,
    subject: "General Science",
    question: "Explain the difference between physical and chemical changes.",
    answer: "Physical changes alter appearance but not composition (melting, dissolving). Chemical changes produce new substances with different compositions (burning, rusting).",
    difficulty: "Medium"
  },
  {
    id: 262,
    subject: "General Science",
    question: "What is atomic mass?",
    answer: "Atomic mass is the average mass of an atom of an element, measured in atomic mass units (amu). It accounts for different isotopes and their abundance.",
    difficulty: "Medium"
  },
  {
    id: 263,
    subject: "General Science",
    question: "Define atomic number.",
    answer: "Atomic number is the number of protons in an atom's nucleus. It uniquely identifies an element and determines its position on the periodic table.",
    difficulty: "Easy"
  },
  {
    id: 264,
    subject: "General Science",
    question: "What is valence electrons?",
    answer: "Valence electrons are the outermost electrons in an atom's electron shells. They determine chemical bonding and reactivity of elements.",
    difficulty: "Hard"
  },
  {
    id: 265,
    subject: "General Science",
    question: "Explain ionic bonding.",
    answer: "Ionic bonding occurs between metals and nonmetals, where electrons transfer from the metal (forming cation) to the nonmetal (forming anion), creating electrostatic attraction.",
    difficulty: "Hard"
  },
  {
    id: 266,
    subject: "General Science",
    question: "What is covalent bonding?",
    answer: "Covalent bonding occurs when nonmetals share electrons to achieve stable electron configurations. Electrons are shared between atoms.",
    difficulty: "Medium"
  },
  {
    id: 267,
    subject: "General Science",
    question: "Define molarity.",
    answer: "Molarity is the concentration of a solution, expressed as moles of solute per liter of solution (mol/L). It's used to quantify solution strength.",
    difficulty: "Hard"
  },
  {
    id: 268,
    subject: "General Science",
    question: "What is an exothermic reaction?",
    answer: "An exothermic reaction releases energy (usually heat) to the surroundings. Examples include combustion, neutralization, and respiration.",
    difficulty: "Medium"
  },
  {
    id: 269,
    subject: "General Science",
    question: "What is an endothermic reaction?",
    answer: "An endothermic reaction absorbs energy from the surroundings, causing a temperature decrease. Examples include melting, evaporation, and photosynthesis.",
    difficulty: "Medium"
  },
  {
    id: 270,
    subject: "General Science",
    question: "Define redox reaction.",
    answer: "A redox (reduction-oxidation) reaction involves transfer of electrons between reactants. Oxidation is electron loss; reduction is electron gain.",
    difficulty: "Hard"
  },
  {
    id: 271,
    subject: "General Science",
    question: "What is oxidation in chemistry?",
    answer: "Oxidation is the loss of electrons from an atom or molecule. In older definitions, it meant addition of oxygen, but electron loss is the modern definition.",
    difficulty: "Hard"
  },
  {
    id: 272,
    subject: "General Science",
    question: "What is reduction in chemistry?",
    answer: "Reduction is the gain of electrons by an atom or molecule. It occurs simultaneously with oxidation in redox reactions.",
    difficulty: "Hard"
  },
  {
    id: 273,
    subject: "General Science",
    question: "Define pressure.",
    answer: "Pressure is force per unit area, measured in pascals (Pa) or pounds per square inch (psi). P = F/A. It's important in military applications like equipment design.",
    difficulty: "Easy"
  },
  {
    id: 274,
    subject: "General Science",
    question: "What is temperature?",
    answer: "Temperature measures the average kinetic energy of particles in a substance. Scales include Celsius, Fahrenheit, and Kelvin (absolute).",
    difficulty: "Easy"
  },
  {
    id: 275,
    subject: "General Science",
    question: "Define heat.",
    answer: "Heat is thermal energy transferred between objects due to temperature difference. It flows from higher to lower temperature.",
    difficulty: "Easy"
  },
  {
    id: 276,
    subject: "General Science",
    question: "What are the three methods of heat transfer?",
    answer: "Heat transfer occurs through conduction (direct contact), convection (fluid movement), and radiation (electromagnetic waves). Understanding these is important for equipment operation.",
    difficulty: "Medium"
  },
  {
    id: 277,
    subject: "General Science",
    question: "Define specific heat capacity.",
    answer: "Specific heat capacity is the amount of energy needed to raise the temperature of 1 kg of a substance by 1°C. Different materials have different values.",
    difficulty: "Hard"
  },
  {
    id: 278,
    subject: "General Science",
    question: "What is buoyancy?",
    answer: "Buoyancy is an upward force exerted by a fluid on an object, equal to the weight of fluid displaced. Important for naval operations.",
    difficulty: "Medium"
  },
  {
    id: 279,
    subject: "General Science",
    question: "Define wavelength.",
    answer: "Wavelength is the distance between consecutive peaks or troughs in a wave, represented by the symbol λ (lambda). It's inversely related to frequency.",
    difficulty: "Medium"
  },
  {
    id: 280,
    subject: "General Science",
    question: "What is frequency?",
    answer: "Frequency is the number of wave cycles that pass a point per unit time, measured in hertz (Hz). Higher frequency means more oscillations.",
    difficulty: "Medium"
  },
  {
    id: 281,
    subject: "General Science",
    question: "Define amplitude.",
    answer: "Amplitude is the maximum displacement of a wave from its equilibrium position. Greater amplitude means greater energy in the wave.",
    difficulty: "Easy"
  },
  {
    id: 282,
    subject: "General Science",
    question: "What is the relationship between wavelength and frequency?",
    answer: "Wavelength and frequency are inversely related: λ × f = v (wave velocity). Higher frequency means shorter wavelength.",
    difficulty: "Hard"
  },
  {
    id: 283,
    subject: "General Science",
    question: "Explain refraction.",
    answer: "Refraction is the bending of light as it passes between media of different densities. It occurs because light changes speed in different materials.",
    difficulty: "Medium"
  },
  {
    id: 284,
    subject: "General Science",
    question: "What is reflection?",
    answer: "Reflection is the bouncing back of light, sound, or other waves from a surface. The angle of incidence equals the angle of reflection.",
    difficulty: "Easy"
  },
  {
    id: 285,
    subject: "General Science",
    question: "Define diffraction.",
    answer: "Diffraction is the bending of waves around obstacles or through openings, more noticeable when the obstacle size is comparable to wavelength.",
    difficulty: "Hard"
  },
  {
    id: 286,
    subject: "General Science",
    question: "What is the speed of light?",
    answer: "The speed of light in vacuum is approximately 3 × 10⁸ m/s or 186,000 miles per second. It's the fastest speed at which information travels.",
    difficulty: "Easy"
  },
  {
    id: 287,
    subject: "General Science",
    question: "Define voltage.",
    answer: "Voltage is the electric potential difference between two points, measured in volts (V). It represents the work per unit charge in an electric field.",
    difficulty: "Medium"
  },
  {
    id: 288,
    subject: "General Science",
    question: "What is current?",
    answer: "Electric current is the flow of charge through a conductor, measured in amperes (A). It's the amount of charge passing per unit time.",
    difficulty: "Easy"
  },
  {
    id: 289,
    subject: "General Science",
    question: "Define resistance in electrical circuits.",
    answer: "Resistance is opposition to current flow in a conductor, measured in ohms (Ω). It determines the relationship V = IR (Ohm's Law).",
    difficulty: "Medium"
  },
  {
    id: 290,
    subject: "General Science",
    question: "What is Ohm's Law?",
    answer: "Ohm's Law states that voltage equals current times resistance: V = IR. This fundamental relationship applies to many electrical components.",
    difficulty: "Medium"
  },
  {
    id: 291,
    subject: "General Science",
    question: "Define power in electrical circuits.",
    answer: "Electrical power is the rate at which energy is transferred, measured in watts (W). P = VI = I²R = V²/R. Critical for equipment operation.",
    difficulty: "Medium"
  },
  {
    id: 292,
    subject: "General Science",
    question: "What is a circuit?",
    answer: "A circuit is a closed path through which electric current flows. Components can be arranged in series (same path) or parallel (different paths).",
    difficulty: "Easy"
  },
  {
    id: 293,
    subject: "General Science",
    question: "Explain series circuits.",
    answer: "In series circuits, components are connected in a single path. Current is the same through all components; total voltage is the sum of component voltages.",
    difficulty: "Medium"
  },
  {
    id: 294,
    subject: "General Science",
    question: "Explain parallel circuits.",
    answer: "In parallel circuits, components are connected across multiple paths. Voltage is the same across all branches; total current is the sum of branch currents.",
    difficulty: "Medium"
  },
  {
    id: 295,
    subject: "General Science",
    question: "What is an electromagnet?",
    answer: "An electromagnet is a magnet created by electric current flowing through a coil. Its strength depends on current and number of coils. Used in many military applications.",
    difficulty: "Medium"
  },
  {
    id: 296,
    subject: "General Science",
    question: "Define latitude.",
    answer: "Latitude is the angular distance north or south of the equator, measured in degrees from 0° (equator) to 90° (poles). Critical for navigation.",
    difficulty: "Easy"
  },
  {
    id: 297,
    subject: "General Science",
    question: "Define longitude.",
    answer: "Longitude is the angular distance east or west of the Prime Meridian (0°), measured from 0° to 180°. Essential for precise geographic location in military operations.",
    difficulty: "Easy"
  },
  {
    id: 298,
    subject: "General Science",
    question: "What are the layers of Earth's atmosphere?",
    answer: "From lowest to highest: troposphere (weather, shortest), stratosphere (ozone), mesosphere (coldest), thermosphere (hottest), and exosphere (edge of space).",
    difficulty: "Hard"
  },
  {
    id: 299,
    subject: "General Science",
    question: "What is the water cycle?",
    answer: "The water cycle involves evaporation (water to vapor), condensation (vapor to liquid), precipitation (rain/snow), and collection in oceans and groundwater.",
    difficulty: "Easy"
  },
  {
    id: 300,
    subject: "General Science",
    question: "Define weather versus climate.",
    answer: "Weather is short-term atmospheric conditions; climate is long-term average weather patterns for a region. Important for military operations planning.",
    difficulty: "Easy"
  },
  {
    id: 301,
    subject: "General Science",
    question: "What causes seasons?",
    answer: "Seasons result from Earth's tilted axis. When a hemisphere tilts toward the sun, it receives more direct sunlight and experiences summer; opposite is winter.",
    difficulty: "Medium"
  },
  {
    id: 302,
    subject: "General Science",
    question: "Define biome.",
    answer: "A biome is a large geographic area with characteristic climate, vegetation, and animal life. Examples include deserts, forests, grasslands, and marine environments.",
    difficulty: "Medium"
  },
  {
    id: 303,
    subject: "General Science",
    question: "What is the nitrogen cycle?",
    answer: "The nitrogen cycle involves nitrogen fixation (N₂ to NH₃), nitrification (NH₃ to NO₃⁻), assimilation (uptake by organisms), and denitrification (back to N₂).",
    difficulty: "Hard"
  },
  {
    id: 304,
    subject: "General Science",
    question: "Define the food chain.",
    answer: "A food chain shows energy flow from producers (plants) through consumers (herbivores, carnivores) to decomposers. Energy decreases at each level.",
    difficulty: "Easy"
  },
  {
    id: 305,
    subject: "General Science",
    question: "What is a food web?",
    answer: "A food web is a complex network of interconnected food chains showing multiple feeding relationships in an ecosystem.",
    difficulty: "Easy"
  },
  {
    id: 306,
    subject: "General Science",
    question: "Define biodiversity.",
    answer: "Biodiversity is the variety of life in an area, including different species, genes, and ecosystems. It's critical for ecosystem stability.",
    difficulty: "Easy"
  },
  {
    id: 307,
    subject: "General Science",
    question: "What is photosynthetically active radiation (PAR)?",
    answer: "PAR is the portion of electromagnetic radiation (400-700 nm wavelength) used by plants for photosynthesis, critical for plant growth and biomass production.",
    difficulty: "Hard"
  },
  {
    id: 308,
    subject: "General Science",
    question: "Define germination.",
    answer: "Germination is the process where a seed develops into a seedling, requiring appropriate temperature, moisture, and sometimes light conditions.",
    difficulty: "Easy"
  },
  {
    id: 309,
    subject: "General Science",
    question: "What is transpiration?",
    answer: "Transpiration is the loss of water vapor from plant leaves through stomata, essential for nutrient transport and temperature regulation.",
    difficulty: "Medium"
  },
  {
    id: 310,
    subject: "General Science",
    question: "Define adaptation.",
    answer: "An adaptation is an inherited trait that helps organisms survive and reproduce in their environment, resulting from natural selection over generations.",
    difficulty: "Medium"
  },
  {
    id: 311,
    subject: "General Science",
    question: "What is an enzyme's substrate?",
    answer: "A substrate is the specific molecule on which an enzyme acts, binding to the enzyme's active site to undergo chemical transformation.",
    difficulty: "Medium"
  },
  {
    id: 312,
    subject: "General Science",
    question: "Define allele.",
    answer: "An allele is one variant of a gene at a specific location on a chromosome. Different alleles can produce different traits (eye color, blood type).",
    difficulty: "Hard"
  },
  {
    id: 313,
    subject: "General Science",
    question: "What is genotype versus phenotype?",
    answer: "Genotype is an organism's genetic makeup (gene combinations); phenotype is the observable physical traits resulting from genotype and environment.",
    difficulty: "Hard"
  },
  {
    id: 314,
    subject: "General Science",
    question: "Define dominant versus recessive alleles.",
    answer: "Dominant alleles express their trait even with one copy; recessive alleles only express with two copies. Denoted by capital (dominant) and lowercase (recessive) letters.",
    difficulty: "Hard"
  },
  {
    id: 315,
    subject: "General Science",
    question: "What is the function of the liver?",
    answer: "The liver detoxifies harmful substances, produces digestive bile, stores glycogen and vitamins, produces blood proteins, and regulates blood glucose.",
    difficulty: "Medium"
  },
  {
    id: 316,
    subject: "General Science",
    question: "What is the function of the pancreas?",
    answer: "The pancreas produces digestive enzymes for nutrient breakdown and produces hormones (insulin, glucagon) for blood glucose regulation.",
    difficulty: "Medium"
  },
  {
    id: 317,
    subject: "General Science",
    question: "Define neurotransmitters.",
    answer: "Neurotransmitters are chemical messengers that transmit signals across synapses between neurons, affecting mood, muscle control, and body functions.",
    difficulty: "Hard"
  },
  {
    id: 318,
    subject: "General Science",
    question: "What are antibodies?",
    answer: "Antibodies are proteins produced by immune cells that bind to pathogens, marking them for destruction and preventing infection. Important for health in military training.",
    difficulty: "Medium"
  },
  {
    id: 319,
    subject: "General Science",
    question: "Define vaccine.",
    answer: "A vaccine contains weakened or inactive pathogen material that stimulates immune response, creating immunity without causing disease.",
    difficulty: "Easy"
  },
  {
    id: 320,
    subject: "General Science",
    question: "What is the role of white blood cells?",
    answer: "White blood cells defend against pathogens and foreign materials through phagocytosis, antibody production, and immune response coordination in the body.",
    difficulty: "Medium"
  }
,
{
  id: 321,
  subject: "Word Knowledge",
  question: "What does 'vigilant' most nearly mean?",
  answer: "Watchful and careful. Example: The sentries remained vigilant throughout the night to detect any enemy movement.",
  difficulty: "Easy"
},
{
  id: 322,
  subject: "Word Knowledge",
  question: "What does 'fortitude' most nearly mean?",
  answer: "Courage and mental strength in adversity. Example: The soldier showed great fortitude during the dangerous mission.",
  difficulty: "Medium"
},
{
  id: 323,
  subject: "Word Knowledge",
  question: "What does 'deploy' most nearly mean?",
  answer: "To position troops or equipment strategically. Example: The commander will deploy the battalion to the northern sector.",
  difficulty: "Easy"
},
{
  id: 324,
  subject: "Word Knowledge",
  question: "What does 'ambiguous' most nearly mean?",
  answer: "Having more than one possible meaning; unclear. Example: The general's ambiguous orders confused some of the officers.",
  difficulty: "Medium"
},
{
  id: 325,
  subject: "Word Knowledge",
  question: "What does 'resilient' most nearly mean?",
  answer: "Able to recover quickly from difficulty. Example: The military unit proved resilient after facing multiple setbacks.",
  difficulty: "Easy"
},
{
  id: 326,
  subject: "Word Knowledge",
  question: "What does 'protocol' most nearly mean?",
  answer: "An official procedure or system of rules. Example: All soldiers must follow the security protocol when entering the base.",
  difficulty: "Medium"
},
{
  id: 327,
  subject: "Word Knowledge",
  question: "What does 'meticulous' most nearly mean?",
  answer: "Very careful and precise. Example: The maintenance crew was meticulous in their inspection of the aircraft.",
  difficulty: "Easy"
},
{
  id: 328,
  subject: "Word Knowledge",
  question: "What does 'cohesion' most nearly mean?",
  answer: "Unity and togetherness of a group. Example: The squad's cohesion made them an effective fighting force.",
  difficulty: "Medium"
},
{
  id: 329,
  subject: "Word Knowledge",
  question: "What does 'strategic' most nearly mean?",
  answer: "Related to long-term planning and important goals. Example: The strategic location of the fort gave the army a tactical advantage.",
  difficulty: "Easy"
},
{
  id: 330,
  subject: "Word Knowledge",
  question: "What does 'extraneous' most nearly mean?",
  answer: "Not essential; unrelated to the matter at hand. Example: The commander dismissed the extraneous details and focused on the mission.",
  difficulty: "Hard"
},
{
  id: 331,
  subject: "Word Knowledge",
  question: "What does 'competent' most nearly mean?",
  answer: "Properly qualified and capable. Example: A competent officer needs both leadership skills and tactical knowledge.",
  difficulty: "Easy"
},
{
  id: 332,
  subject: "Word Knowledge",
  question: "What does 'persevere' most nearly mean?",
  answer: "To continue despite difficulty. Example: Soldiers persevere through intense training to build strength and endurance.",
  difficulty: "Medium"
},
{
  id: 333,
  subject: "Word Knowledge",
  question: "What does 'reconnaissance' most nearly mean?",
  answer: "A preliminary survey or inspection to gather information. Example: The reconnaissance mission revealed the enemy's defensive positions.",
  difficulty: "Medium"
},
{
  id: 334,
  subject: "Word Knowledge",
  question: "What does 'acute' most nearly mean?",
  answer: "Sharp, severe, or requiring immediate attention. Example: The field medic treated the soldier's acute wounds.",
  difficulty: "Easy"
},
{
  id: 335,
  subject: "Word Knowledge",
  question: "What does 'facilitate' most nearly mean?",
  answer: "To make easier or help the progress of something. Example: Supply lines facilitate the movement of troops across difficult terrain.",
  difficulty: "Medium"
},
{
  id: 336,
  subject: "Word Knowledge",
  question: "What does 'erratic' most nearly mean?",
  answer: "Unpredictable and inconsistent. Example: The enemy's erratic movements made them difficult to track.",
  difficulty: "Medium"
},
{
  id: 337,
  subject: "Word Knowledge",
  question: "What does 'subordinate' most nearly mean?",
  answer: "Of lower rank or importance; to place under authority. Example: Junior officers are subordinate to the commanding officer.",
  difficulty: "Easy"
},
{
  id: 338,
  subject: "Word Knowledge",
  question: "What does 'austere' most nearly mean?",
  answer: "Very simple and without decoration or luxury. Example: Military barracks often have austere furnishings to promote discipline.",
  difficulty: "Medium"
},
{
  id: 339,
  subject: "Word Knowledge",
  question: "What does 'diligent' most nearly mean?",
  answer: "Careful and thorough in work or effort. Example: The diligent soldiers maintained their equipment in perfect condition.",
  difficulty: "Easy"
},
{
  id: 340,
  subject: "Word Knowledge",
  question: "What does 'tangible' most nearly mean?",
  answer: "Able to be touched or clearly perceived. Example: The mission provided tangible results in terms of captured territory.",
  difficulty: "Medium"
},
{
  id: 341,
  subject: "Word Knowledge",
  question: "What does 'rigorous' most nearly mean?",
  answer: "Extremely thorough and strict. Example: Military training follows a rigorous schedule to prepare soldiers for combat.",
  difficulty: "Easy"
},
{
  id: 342,
  subject: "Word Knowledge",
  question: "What does 'obscure' most nearly mean?",
  answer: "Not clearly visible or understood; to hide. Example: The fog obscured the enemy's position from our observation post.",
  difficulty: "Medium"
},
{
  id: 343,
  subject: "Word Knowledge",
  question: "What does 'belligerent' most nearly mean?",
  answer: "Hostile and aggressive; inclined to fight. Example: The belligerent stance of the opposing forces made negotiations difficult.",
  difficulty: "Medium"
},
{
  id: 344,
  subject: "Word Knowledge",
  question: "What does 'mandate' most nearly mean?",
  answer: "An official command or authority to act. Example: The general's mandate was to secure the bridge by dawn.",
  difficulty: "Easy"
},
{
  id: 345,
  subject: "Word Knowledge",
  question: "What does 'juxtapose' most nearly mean?",
  answer: "To place two things side by side for contrast. Example: The instructor juxtaposed the correct and incorrect procedures during the demonstration.",
  difficulty: "Hard"
},
{
  id: 346,
  subject: "Word Knowledge",
  question: "What does 'pragmatic' most nearly mean?",
  answer: "Dealing with things in a practical, realistic way. Example: The commander took a pragmatic approach to resource allocation.",
  difficulty: "Medium"
},
{
  id: 347,
  subject: "Word Knowledge",
  question: "What does 'fortified' most nearly mean?",
  answer: "Strengthened or secured against attack. Example: The fortified position provided excellent protection against enemy fire.",
  difficulty: "Easy"
},
{
  id: 348,
  subject: "Word Knowledge",
  question: "What does 'deter' most nearly mean?",
  answer: "To discourage or prevent through fear. Example: Our military strength deters potential aggressors from attacking.",
  difficulty: "Easy"
},
{
  id: 349,
  subject: "Word Knowledge",
  question: "What does 'provisional' most nearly mean?",
  answer: "Intended to be temporary or subject to change. Example: The provisional base camp will be relocated once the permanent site is prepared.",
  difficulty: "Medium"
},
{
  id: 350,
  subject: "Word Knowledge",
  question: "What does 'circumvent' most nearly mean?",
  answer: "To go around or bypass a rule or obstacle. Example: Experienced soldiers learned to circumvent bureaucratic delays through proper channels.",
  difficulty: "Hard"
},
{
  id: 351,
  subject: "Word Knowledge",
  question: "What does 'candid' most nearly mean?",
  answer: "Honest and straightforward. Example: The soldier gave a candid report about the mission's challenges.",
  difficulty: "Easy"
},
{
  id: 352,
  subject: "Word Knowledge",
  question: "What does 'requisite' most nearly mean?",
  answer: "Required or necessary. Example: A strong sense of duty is requisite for military service.",
  difficulty: "Medium"
},
{
  id: 353,
  subject: "Word Knowledge",
  question: "What does 'apprehend' most nearly mean?",
  answer: "To arrest or capture; to understand. Example: Military police will apprehend anyone attempting to breach the perimeter.",
  difficulty: "Medium"
},
{
  id: 354,
  subject: "Word Knowledge",
  question: "What does 'liaison' most nearly mean?",
  answer: "A person who maintains communication between groups. Example: The staff officer served as a liaison between the two divisions.",
  difficulty: "Easy"
},
{
  id: 355,
  subject: "Word Knowledge",
  question: "What does 'vindicate' most nearly mean?",
  answer: "To prove right or justify. Example: The mission's success vindicated the general's controversial strategy.",
  difficulty: "Medium"
},
{
  id: 356,
  subject: "Word Knowledge",
  question: "What does 'malicious' most nearly mean?",
  answer: "Deliberately harmful or evil. Example: Counterintelligence teams guard against malicious cyber attacks on military networks.",
  difficulty: "Easy"
},
{
  id: 357,
  subject: "Word Knowledge",
  question: "What does 'amass' most nearly mean?",
  answer: "To gather or accumulate a large amount. Example: The supply depot began to amass equipment for the upcoming deployment.",
  difficulty: "Medium"
},
{
  id: 358,
  subject: "Word Knowledge",
  question: "What does 'abate' most nearly mean?",
  answer: "To reduce in amount or intensity. Example: The artillery bombardment will abate at dusk to allow troop advancement.",
  difficulty: "Hard"
},
{
  id: 359,
  subject: "Word Knowledge",
  question: "What does 'acclimate' most nearly mean?",
  answer: "To adjust to a new environment or conditions. Example: Soldiers must acclimate to the desert heat during their deployment.",
  difficulty: "Easy"
},
{
  id: 360,
  subject: "Word Knowledge",
  question: "What does 'attain' most nearly mean?",
  answer: "To achieve or reach a goal. Example: Officers must attain certain qualifications before commanding a platoon.",
  difficulty: "Easy"
},
{
  id: 361,
  subject: "Word Knowledge",
  question: "What does 'sanguine' most nearly mean?",
  answer: "Optimistic or positive about the future. Example: Despite the challenges, the commander remained sanguine about the mission's success.",
  difficulty: "Hard"
},
{
  id: 362,
  subject: "Word Knowledge",
  question: "What does 'eminent' most nearly mean?",
  answer: "Distinguished and of high rank or importance. Example: The general was an eminent military strategist known worldwide.",
  difficulty: "Medium"
},
{
  id: 363,
  subject: "Word Knowledge",
  question: "What does 'replenish' most nearly mean?",
  answer: "To refill or restore to full supply. Example: Supply convoys regularly replenish ammunition at forward operating bases.",
  difficulty: "Easy"
},
{
  id: 364,
  subject: "Word Knowledge",
  question: "What does 'brevity' most nearly mean?",
  answer: "Shortness in duration or length of expression. Example: Military radio communications emphasize brevity to maintain security.",
  difficulty: "Medium"
},
{
  id: 365,
  subject: "Word Knowledge",
  question: "What does 'fortuitous' most nearly mean?",
  answer: "Happening by lucky chance. Example: The fortuitous discovery of the enemy supply cache turned the battle in our favor.",
  difficulty: "Hard"
},
{
  id: 366,
  subject: "Word Knowledge",
  question: "What does 'nullify' most nearly mean?",
  answer: "To make null or without effect. Example: Electronic warfare can nullify enemy radar systems.",
  difficulty: "Medium"
},
{
  id: 367,
  subject: "Word Knowledge",
  question: "What does 'mitigate' most nearly mean?",
  answer: "To make less severe or reduce in intensity. Example: Proper training helps mitigate the risks of combat operations.",
  difficulty: "Medium"
},
{
  id: 368,
  subject: "Word Knowledge",
  question: "What does 'sagacious' most nearly mean?",
  answer: "Having keen judgment and good sense. Example: The general's sagacious decisions preserved the army's strength.",
  difficulty: "Hard"
},
{
  id: 369,
  subject: "Word Knowledge",
  question: "What does 'candor' most nearly mean?",
  answer: "Honesty and frankness. Example: The commander appreciated the candor of his staff officers.",
  difficulty: "Easy"
},
{
  id: 370,
  subject: "Word Knowledge",
  question: "What does 'nascent' most nearly mean?",
  answer: "Beginning to exist or develop. Example: The nascent unit completed its training before being deployed overseas.",
  difficulty: "Hard"
},
{
  id: 371,
  subject: "Word Knowledge",
  question: "What does 'adamant' most nearly mean?",
  answer: "Firmly unwilling to change; unyielding. Example: The sergeant was adamant that all soldiers maintain their equipment.",
  difficulty: "Easy"
},
{
  id: 372,
  subject: "Word Knowledge",
  question: "What does 'bolster' most nearly mean?",
  answer: "To strengthen or support. Example: Additional reinforcements will bolster our defensive position.",
  difficulty: "Medium"
},
{
  id: 373,
  subject: "Word Knowledge",
  question: "What does 'consummate' most nearly mean?",
  answer: "To complete or perfect; supremely skilled. Example: The pilot's consummate skill allowed him to execute the dangerous maneuver.",
  difficulty: "Hard"
},
{
  id: 374,
  subject: "Word Knowledge",
  question: "What does 'duplicitous' most nearly mean?",
  answer: "Deceitful and dishonest. Example: Military intelligence warned of the enemy's duplicitous peace negotiations.",
  difficulty: "Hard"
},
{
  id: 375,
  subject: "Word Knowledge",
  question: "What does 'exigency' most nearly mean?",
  answer: "An urgent need or demand. Example: The exigency of the situation required immediate military intervention.",
  difficulty: "Hard"
},
{
  id: 376,
  subject: "Word Knowledge",
  question: "What does 'flagrant' most nearly mean?",
  answer: "Blatantly obvious and offensive. Example: The flagrant violation of the cease-fire agreement alarmed military commanders.",
  difficulty: "Medium"
},
{
  id: 377,
  subject: "Word Knowledge",
  question: "What does 'gregarious' most nearly mean?",
  answer: "Fond of company; living in groups. Example: Military units foster gregarious teamwork to build unit cohesion.",
  difficulty: "Medium"
},
{
  id: 378,
  subject: "Word Knowledge",
  question: "What does 'hone' most nearly mean?",
  answer: "To sharpen or improve a skill. Example: Soldiers hone their marksmanship through regular practice at the range.",
  difficulty: "Easy"
},
{
  id: 379,
  subject: "Word Knowledge",
  question: "What does 'imminent' most nearly mean?",
  answer: "About to happen; impending. Example: The general warned that an enemy attack was imminent.",
  difficulty: "Easy"
},
{
  id: 380,
  subject: "Word Knowledge",
  question: "What does 'indefatigable' most nearly mean?",
  answer: "Tireless and never becoming weary. Example: The indefatigable medic treated wounded soldiers for hours without rest.",
  difficulty: "Hard"
},
{
  id: 381,
  subject: "Word Knowledge",
  question: "What does 'jeopardize' most nearly mean?",
  answer: "To put at risk or in danger. Example: Loose communication procedures could jeopardize the entire mission.",
  difficulty: "Easy"
},
{
  id: 382,
  subject: "Word Knowledge",
  question: "What does 'kindle' most nearly mean?",
  answer: "To ignite or inspire. Example: The sergeant's words kindled the soldiers' determination to succeed.",
  difficulty: "Medium"
},
{
  id: 383,
  subject: "Word Knowledge",
  question: "What does 'laudable' most nearly mean?",
  answer: "Deserving praise and commendation. Example: The soldier's laudable actions during the battle earned him a medal.",
  difficulty: "Medium"
},
{
  id: 384,
  subject: "Word Knowledge",
  question: "What does 'meager' most nearly mean?",
  answer: "Lacking in quantity or quality; insufficient. Example: The unit's meager supplies forced them to ration carefully.",
  difficulty: "Easy"
},
{
  id: 385,
  subject: "Word Knowledge",
  question: "What does 'nominal' most nearly mean?",
  answer: "In name only; stated but not actual. Example: The nominal commander lacked real authority in the field.",
  difficulty: "Medium"
},
{
  id: 386,
  subject: "Word Knowledge",
  question: "What does 'oblige' most nearly mean?",
  answer: "To do something as a favor; to compel. Example: Officers are obliged to follow the chain of command.",
  difficulty: "Easy"
},
{
  id: 387,
  subject: "Word Knowledge",
  question: "What does 'parsimonious' most nearly mean?",
  answer: "Unwilling to spend money; stingy. Example: The commander's parsimonious budget allocation limited equipment purchases.",
  difficulty: "Hard"
},
{
  id: 388,
  subject: "Word Knowledge",
  question: "What does 'quisling' most nearly mean?",
  answer: "A traitor who collaborates with the enemy. Example: The military court-martialed the quisling for sharing classified information.",
  difficulty: "Hard"
},
{
  id: 389,
  subject: "Word Knowledge",
  question: "What does 'recluse' most nearly mean?",
  answer: "A person who lives in seclusion. Example: The radar operator worked in relative isolation at the remote station.",
  difficulty: "Medium"
},
{
  id: 390,
  subject: "Word Knowledge",
  question: "What does 'sanctum' most nearly mean?",
  answer: "A sacred or private place. Example: The commander's office was his sanctum where he planned strategy.",
  difficulty: "Medium"
},
{
  id: 391,
  subject: "Word Knowledge",
  question: "What does 'tacit' most nearly mean?",
  answer: "Understood or implied without being stated. Example: There was a tacit agreement among the troops to maintain discipline.",
  difficulty: "Medium"
},
{
  id: 392,
  subject: "Word Knowledge",
  question: "What does 'utilitarian' most nearly mean?",
  answer: "Practical and functional rather than decorative. Example: Military uniforms have a utilitarian design for maximum functionality.",
  difficulty: "Medium"
},
{
  id: 393,
  subject: "Word Knowledge",
  question: "What does 'vacillate' most nearly mean?",
  answer: "To waver or be indecisive. Example: A military leader cannot vacillate when making critical decisions.",
  difficulty: "Hard"
},
{
  id: 394,
  subject: "Word Knowledge",
  question: "What does 'venerable' most nearly mean?",
  answer: "Worthy of respect due to age or status. Example: The venerable general brought decades of military experience to the operation.",
  difficulty: "Medium"
},
{
  id: 395,
  subject: "Word Knowledge",
  question: "What does 'voracious' most nearly mean?",
  answer: "Consuming or showing enthusiasm with great energy. Example: The soldier's voracious appetite after the long march was evident.",
  difficulty: "Medium"
},
{
  id: 396,
  subject: "Word Knowledge",
  question: "What does 'wary' most nearly mean?",
  answer: "Cautious and on guard against danger. Example: Sentries remained wary of infiltrators during the night watch.",
  difficulty: "Easy"
},
{
  id: 397,
  subject: "Word Knowledge",
  question: "What does 'xenophobia' most nearly mean?",
  answer: "Fear or hatred of foreigners or strangers. Example: Military units must overcome xenophobia to work with allied forces.",
  difficulty: "Hard"
},
{
  id: 398,
  subject: "Word Knowledge",
  question: "What does 'yearn' most nearly mean?",
  answer: "To have a strong longing or desire. Example: Deployed soldiers yearn to return home to their families.",
  difficulty: "Easy"
},
{
  id: 399,
  subject: "Word Knowledge",
  question: "What does 'zealot' most nearly mean?",
  answer: "A person who is fanatically devoted to a cause. Example: The zealot refused to compromise on military tradition.",
  difficulty: "Medium"
},
{
  id: 400,
  subject: "Word Knowledge",
  question: "What does 'zenith' most nearly mean?",
  answer: "The highest point or peak. Example: The general's career reached its zenith when he was promoted to Commander-in-Chief.",
  difficulty: "Easy"
},
{
  id: 401,
  subject: "Word Knowledge",
  question: "What does 'austerity' most nearly mean?",
  answer: "Severe simplicity and lack of comfort. Example: Military barracks are designed with austerity to maintain discipline.",
  difficulty: "Medium"
},
{
  id: 402,
  subject: "Word Knowledge",
  question: "What does 'benign' most nearly mean?",
  answer: "Harmless and not dangerous. Example: The commander's benign approach to minor infractions built troop morale.",
  difficulty: "Easy"
},
{
  id: 403,
  subject: "Word Knowledge",
  question: "What does 'capitulate' most nearly mean?",
  answer: "To surrender or agree to terms after resistance. Example: After weeks of siege, the enemy forces capitulated.",
  difficulty: "Medium"
},
{
  id: 404,
  subject: "Word Knowledge",
  question: "What does 'desolate' most nearly mean?",
  answer: "Barren and uninhabited; sad and lonely. Example: The desolate landscape offered little cover for advancing troops.",
  difficulty: "Easy"
},
{
  id: 405,
  subject: "Word Knowledge",
  question: "What does 'efficacious' most nearly mean?",
  answer: "Successful in producing desired results. Example: The new training program proved efficacious in improving unit readiness.",
  difficulty: "Hard"
},
{
  id: 406,
  subject: "Word Knowledge",
  question: "What does 'fervent' most nearly mean?",
  answer: "Intensely devoted or passionate. Example: The soldiers showed fervent commitment to their mission.",
  difficulty: "Easy"
},
{
  id: 407,
  subject: "Word Knowledge",
  question: "What does 'garrison' most nearly mean?",
  answer: "A military post or the troops stationed there. Example: The garrison defended the fort against multiple attacks.",
  difficulty: "Easy"
},
{
  id: 408,
  subject: "Word Knowledge",
  question: "What does 'guile' most nearly mean?",
  answer: "Cunning or deceptive intelligence. Example: The general used guile to outmaneuver the enemy's superior forces.",
  difficulty: "Hard"
},
{
  id: 409,
  subject: "Word Knowledge",
  question: "What does 'hegemony' most nearly mean?",
  answer: "Dominant power or authority over others. Example: The military superpower sought hegemony over the region.",
  difficulty: "Hard"
},
{
  id: 410,
  subject: "Word Knowledge",
  question: "What does 'incite' most nearly mean?",
  answer: "To encourage or provoke action. Example: Propaganda aimed to incite rebellion among the civilian population.",
  difficulty: "Easy"
},
{
  id: 411,
  subject: "Word Knowledge",
  question: "What does 'infiltrate' most nearly mean?",
  answer: "To enter secretly or gradually. Example: Special forces managed to infiltrate the enemy's rear position.",
  difficulty: "Medium"
},
{
  id: 412,
  subject: "Word Knowledge",
  question: "What does 'inherent' most nearly mean?",
  answer: "Existing as a natural or permanent element. Example: Military discipline has inherent value in building effective units.",
  difficulty: "Medium"
},
{
  id: 413,
  subject: "Word Knowledge",
  question: "What does 'inocuous' most nearly mean?",
  answer: "Harmless and not likely to cause damage. Example: The seemingly innocuous package contained important intelligence.",
  difficulty: "Hard"
},
{
  id: 414,
  subject: "Word Knowledge",
  question: "What does 'instill' most nearly mean?",
  answer: "To introduce gradually into the mind. Example: Drill instructors instill core values into recruit training.",
  difficulty: "Easy"
},
{
  id: 415,
  subject: "Word Knowledge",
  question: "What does 'intrepid' most nearly mean?",
  answer: "Fearless and adventurous. Example: The intrepid pilot flew dangerous reconnaissance missions.",
  difficulty: "Medium"
},
{
  id: 416,
  subject: "Word Knowledge",
  question: "What does 'irascible' most nearly mean?",
  answer: "Prone to anger; easily irritated. Example: The general's irascible temperament kept the staff alert.",
  difficulty: "Hard"
},
{
  id: 417,
  subject: "Word Knowledge",
  question: "What does 'laconic' most nearly mean?",
  answer: "Using very few words; concise. Example: Military commanders prefer laconic communications to avoid confusion.",
  difficulty: "Hard"
},
{
  id: 418,
  subject: "Word Knowledge",
  question: "What does 'laxity' most nearly mean?",
  answer: "Carelessness or lack of strictness. Example: The sergeant will not tolerate any laxity in uniform standards.",
  difficulty: "Medium"
},
{
  id: 419,
  subject: "Word Knowledge",
  question: "What does 'levity' most nearly mean?",
  answer: "Lack of seriousness; light humor. Example: During stressful operations, soldiers use levity to relieve tension.",
  difficulty: "Medium"
},
{
  id: 420,
  subject: "Word Knowledge",
  question: "What does 'logistics' most nearly mean?",
  answer: "The management and supply of equipment and personnel. Example: Successful military operations depend on efficient logistics.",
  difficulty: "Easy"
}
,
{
  id: 421,
  subject: "Word Knowledge",
  question: "What does 'vigilant' most nearly mean?",
  answer: "Alert and watchful; paying careful attention. Example: The sentries remained vigilant throughout the night watch.",
  difficulty: "Easy"
},
{
  id: 422,
  subject: "Word Knowledge",
  question: "What does 'meager' most nearly mean?",
  answer: "Lacking in quantity or quality; insufficient. Example: The soldiers received meager rations during the deployment.",
  difficulty: "Easy"
},
{
  id: 423,
  subject: "Word Knowledge",
  question: "What does 'expedite' most nearly mean?",
  answer: "To make something happen faster or with more speed. Example: The commander requested to expedite the supply shipment.",
  difficulty: "Easy"
},
{
  id: 424,
  subject: "Word Knowledge",
  question: "What does 'diligent' most nearly mean?",
  answer: "Showing careful and persistent effort in work or duties. Example: Diligent soldiers completed their training ahead of schedule.",
  difficulty: "Easy"
},
{
  id: 425,
  subject: "Word Knowledge",
  question: "What does 'perimeter' most nearly mean?",
  answer: "The outer boundary or edge of an area; the distance around something. Example: Guards patrolled the perimeter of the military base.",
  difficulty: "Easy"
},
{
  id: 426,
  subject: "Word Knowledge",
  question: "What does 'fortify' most nearly mean?",
  answer: "To strengthen or make more secure; to build defensive structures. Example: Engineers worked to fortify the defensive positions.",
  difficulty: "Easy"
},
{
  id: 427,
  subject: "Word Knowledge",
  question: "What does 'resilient' most nearly mean?",
  answer: "Able to recover quickly from difficulties; tough and flexible. Example: The resilient troops adapted well to harsh combat conditions.",
  difficulty: "Easy"
},
{
  id: 428,
  subject: "Word Knowledge",
  question: "What does 'coordinate' most nearly mean?",
  answer: "To organize or arrange different elements to work together effectively. Example: Platoon leaders must coordinate with other units during operations.",
  difficulty: "Easy"
},
{
  id: 429,
  subject: "Word Knowledge",
  question: "What does 'oblique' most nearly mean?",
  answer: "Slanting or at an angle; not straight or perpendicular. Example: The soldiers approached the enemy position from an oblique angle.",
  difficulty: "Easy"
},
{
  id: 430,
  subject: "Word Knowledge",
  question: "What does 'mobilize' most nearly mean?",
  answer: "To prepare and assemble for action or movement. Example: The military began to mobilize troops for the operation.",
  difficulty: "Easy"
},
{
  id: 431,
  subject: "Word Knowledge",
  question: "What does 'amenity' most nearly mean?",
  answer: "A desirable or useful feature that adds to comfort or convenience. Example: The barracks lacked basic amenities like hot water.",
  difficulty: "Easy"
},
{
  id: 432,
  subject: "Word Knowledge",
  question: "What does 'protocol' most nearly mean?",
  answer: "An official procedure or system of rules governing conduct. Example: Military protocol requires officers to salute before speaking.",
  difficulty: "Easy"
},
{
  id: 433,
  subject: "Word Knowledge",
  question: "What does 'retrieve' most nearly mean?",
  answer: "To recover or obtain something; to bring back. Example: Rescue teams were sent to retrieve the downed pilot.",
  difficulty: "Easy"
},
{
  id: 434,
  subject: "Word Knowledge",
  question: "What does 'tactics' most nearly mean?",
  answer: "Planned methods or strategies used to achieve a military objective. Example: The commander reviewed defensive tactics with the squad.",
  difficulty: "Easy"
},
{
  id: 435,
  subject: "Word Knowledge",
  question: "What does 'arsenal' most nearly mean?",
  answer: "A storage facility for military weapons and ammunition. Example: The base's arsenal contained thousands of rounds of ammunition.",
  difficulty: "Easy"
},
{
  id: 436,
  subject: "Word Knowledge",
  question: "What does 'debris' most nearly mean?",
  answer: "Scattered remains or broken pieces; trash or waste material. Example: Combat engineers cleared debris from the landing zone.",
  difficulty: "Easy"
},
{
  id: 437,
  subject: "Word Knowledge",
  question: "What does 'secure' most nearly mean?",
  answer: "To make safe from harm or capture; to obtain or fasten. Example: Soldiers must secure the perimeter before nightfall.",
  difficulty: "Easy"
},
{
  id: 438,
  subject: "Word Knowledge",
  question: "What does 'deploy' most nearly mean?",
  answer: "To position or spread out resources for use or action. Example: The infantry will deploy across three sectors.",
  difficulty: "Easy"
},
{
  id: 439,
  subject: "Word Knowledge",
  question: "What does 'liaison' most nearly mean?",
  answer: "A connection or communication link between separate units or groups. Example: The officer served as a liaison between battalions.",
  difficulty: "Easy"
},
{
  id: 440,
  subject: "Word Knowledge",
  question: "What does 'mandate' most nearly mean?",
  answer: "An official order or authorization; a command with authority. Example: The general issued a mandate to improve training standards.",
  difficulty: "Easy"
},
{
  id: 441,
  subject: "Word Knowledge",
  question: "What does 'auspicious' most nearly mean?",
  answer: "Favorable or showing signs of future success; promising. Example: The auspicious weather conditions were ideal for the mission.",
  difficulty: "Medium"
},
{
  id: 442,
  subject: "Word Knowledge",
  question: "What does 'ascertain' most nearly mean?",
  answer: "To find out with certainty; to determine the facts about something. Example: Intelligence officers worked to ascertain enemy positions.",
  difficulty: "Medium"
},
{
  id: 443,
  subject: "Word Knowledge",
  question: "What does 'jurisdiction' most nearly mean?",
  answer: "The official power to make legal decisions or enforce authority. Example: Military police have jurisdiction on base.",
  difficulty: "Medium"
},
{
  id: 444,
  subject: "Word Knowledge",
  question: "What does 'detriment' most nearly mean?",
  answer: "Harm or damage to something; something that causes injury. Example: Fatigue was a detriment to the soldier's performance.",
  difficulty: "Medium"
},
{
  id: 445,
  subject: "Word Knowledge",
  question: "What does 'requisite' most nearly mean?",
  answer: "Required or necessary for a particular purpose. Example: Combat training is requisite for all infantry soldiers.",
  difficulty: "Medium"
},
{
  id: 446,
  subject: "Word Knowledge",
  question: "What does 'proliferate' most nearly mean?",
  answer: "To increase rapidly in number or spread widely. Example: Drone technology began to proliferate across military units.",
  difficulty: "Medium"
},
{
  id: 447,
  subject: "Word Knowledge",
  question: "What does 'ambiguous' most nearly mean?",
  answer: "Unclear or open to more than one interpretation. Example: The commander's ambiguous orders confused the platoon leaders.",
  difficulty: "Medium"
},
{
  id: 448,
  subject: "Word Knowledge",
  question: "What does 'attenuate' most nearly mean?",
  answer: "To make thin or weak; to reduce in strength or intensity. Example: Distance will attenuate the signal transmission.",
  difficulty: "Medium"
},
{
  id: 449,
  subject: "Word Knowledge",
  question: "What does 'advocate' most nearly mean?",
  answer: "To support or speak in favor of something; a person who supports a cause. Example: The general will advocate for increased military funding.",
  difficulty: "Medium"
},
{
  id: 450,
  subject: "Word Knowledge",
  question: "What does 'corroborate' most nearly mean?",
  answer: "To confirm or support with evidence; to verify as true. Example: Multiple witnesses corroborate the soldier's account of events.",
  difficulty: "Medium"
},
{
  id: 451,
  subject: "Word Knowledge",
  question: "What does 'pragmatic' most nearly mean?",
  answer: "Practical and realistic; based on actual circumstances rather than theory. Example: The pragmatic approach focused on achievable objectives.",
  difficulty: "Medium"
},
{
  id: 452,
  subject: "Word Knowledge",
  question: "What does 'periphery' most nearly mean?",
  answer: "The outer area or edge of something; the margins. Example: Reconnaissance teams operated on the periphery of the battle zone.",
  difficulty: "Medium"
},
{
  id: 453,
  subject: "Word Knowledge",
  question: "What does 'inception' most nearly mean?",
  answer: "The beginning or start of something. Example: Since its inception, the unit has deployed three times.",
  difficulty: "Medium"
},
{
  id: 454,
  subject: "Word Knowledge",
  question: "What does 'diverge' most nearly mean?",
  answer: "To separate and go in different directions; to differ. Example: The units will diverge at the checkpoint.",
  difficulty: "Medium"
},
{
  id: 455,
  subject: "Word Knowledge",
  question: "What does 'suppress' most nearly mean?",
  answer: "To prevent or restrain; to keep from expressing or occurring. Example: Suppressing enemy fire was critical to the advance.",
  difficulty: "Medium"
},
{
  id: 456,
  subject: "Word Knowledge",
  question: "What does 'enumerate' most nearly mean?",
  answer: "To list or count items individually; to specify one by one. Example: The officer will enumerate all equipment requirements.",
  difficulty: "Medium"
},
{
  id: 457,
  subject: "Word Knowledge",
  question: "What does 'indoctrinate' most nearly mean?",
  answer: "To teach or instruct in a set of beliefs or principles. Example: Recruits are indoctrinated with military values during basic training.",
  difficulty: "Medium"
},
{
  id: 458,
  subject: "Word Knowledge",
  question: "What does 'rectify' most nearly mean?",
  answer: "To correct or put right; to make amends for. Example: The commander worked to rectify the supply shortage immediately.",
  difficulty: "Medium"
},
{
  id: 459,
  subject: "Word Knowledge",
  question: "What does 'stringent' most nearly mean?",
  answer: "Strict, rigorous, or demanding strict attention to rules. Example: Stringent safety protocols must be followed in the armory.",
  difficulty: "Medium"
},
{
  id: 460,
  subject: "Word Knowledge",
  question: "What does 'validate' most nearly mean?",
  answer: "To confirm or prove to be true or justified. Example: Testing will validate the effectiveness of the new equipment.",
  difficulty: "Medium"
},
{
  id: 461,
  subject: "Word Knowledge",
  question: "What does 'expeditious' most nearly mean?",
  answer: "Done with speed and efficiency; quick and prompt. Example: An expeditious response was necessary during the emergency.",
  difficulty: "Medium"
},
{
  id: 462,
  subject: "Word Knowledge",
  question: "What does 'aggregate' most nearly mean?",
  answer: "A total or combined amount; to gather together into a whole. Example: The aggregate strength of all battalions exceeds ten thousand.",
  difficulty: "Medium"
},
{
  id: 463,
  subject: "Word Knowledge",
  question: "What does 'conducive' most nearly mean?",
  answer: "Favorable or helping to produce; promoting conditions for success. Example: The climate conditions were conducive to training operations.",
  difficulty: "Medium"
},
{
  id: 464,
  subject: "Word Knowledge",
  question: "What does 'manifest' most nearly mean?",
  answer: "To display or show clearly; to reveal or demonstrate. Example: The soldier's courage was manifest during the battle.",
  difficulty: "Medium"
},
{
  id: 465,
  subject: "Word Knowledge",
  question: "What does 'mitigate' most nearly mean?",
  answer: "To lessen or reduce the severity of something harmful. Example: Protective gear mitigates injury risk during combat training.",
  difficulty: "Medium"
},
{
  id: 466,
  subject: "Word Knowledge",
  question: "What does 'incumbent' most nearly mean?",
  answer: "Resting as a duty or obligation; currently holding a position. Example: It is incumbent upon all soldiers to maintain discipline.",
  difficulty: "Medium"
},
{
  id: 467,
  subject: "Word Knowledge",
  question: "What does 'juxtapose' most nearly mean?",
  answer: "To place side by side for comparison or effect. Example: The trainer juxtaposed the correct and incorrect firing positions.",
  difficulty: "Medium"
},
{
  id: 468,
  subject: "Word Knowledge",
  question: "What does 'nuance' most nearly mean?",
  answer: "A subtle difference in meaning, tone, or appearance. Example: Officers must understand the nuance of political situations.",
  difficulty: "Medium"
},
{
  id: 469,
  subject: "Word Knowledge",
  question: "What does 'confluence' most nearly mean?",
  answer: "A flowing together; the meeting point of two streams or influences. Example: The confluence of two rivers marked the battle site.",
  difficulty: "Medium"
},
{
  id: 470,
  subject: "Word Knowledge",
  question: "What does 'ostentatious' most nearly mean?",
  answer: "Showy or displaying wealth in a way meant to impress. Example: Military uniforms avoid ostentatious decorations.",
  difficulty: "Medium"
},
{
  id: 471,
  subject: "Word Knowledge",
  question: "What does 'preempt' most nearly mean?",
  answer: "To take action before someone else; to prevent by acting first. Example: The unit will preempt enemy movements with reconnaissance.",
  difficulty: "Medium"
},
{
  id: 472,
  subject: "Word Knowledge",
  question: "What does 'proficiency' most nearly mean?",
  answer: "Skill or competence in performing a task or activity. Example: Marksmanship proficiency is essential for combat soldiers.",
  difficulty: "Medium"
},
{
  id: 473,
  subject: "Word Knowledge",
  question: "What does 'constitute' most nearly mean?",
  answer: "To form or compose; to make up as a component. Example: Infantry units constitute the core of ground forces.",
  difficulty: "Medium"
},
{
  id: 474,
  subject: "Word Knowledge",
  question: "What does 'belligerent' most nearly mean?",
  answer: "Engaged in war; showing readiness to fight. Example: The belligerent stance of the opposing forces increased tensions.",
  difficulty: "Medium"
},
{
  id: 475,
  subject: "Word Knowledge",
  question: "What does 'docile' most nearly mean?",
  answer: "Obedient and submissive; ready to accept instruction. Example: The docile recruits followed all orders without question.",
  difficulty: "Medium"
},
{
  id: 476,
  subject: "Word Knowledge",
  question: "What does 'ameliorate' most nearly mean?",
  answer: "To improve or make better; to make less severe. Example: New training methods will ameliorate soldier readiness.",
  difficulty: "Medium"
},
{
  id: 477,
  subject: "Word Knowledge",
  question: "What does 'exonerate' most nearly mean?",
  answer: "To declare free from blame or guilt; to clear of charges. Example: Evidence exonerated the officer of the allegations.",
  difficulty: "Medium"
},
{
  id: 478,
  subject: "Word Knowledge",
  question: "What does 'lucrative' most nearly mean?",
  answer: "Producing a great deal of profit; financially rewarding. Example: Military contracting can be a lucrative industry.",
  difficulty: "Medium"
},
{
  id: 479,
  subject: "Word Knowledge",
  question: "What does 'commodious' most nearly mean?",
  answer: "Spacious and comfortable; providing ample room. Example: The new barracks were more commodious than the old ones.",
  difficulty: "Medium"
},
{
  id: 480,
  subject: "Word Knowledge",
  question: "What does 'relegate' most nearly mean?",
  answer: "To assign to a lower position or rank; to put aside. Example: The general will relegate the reserve forces to secondary positions.",
  difficulty: "Medium"
},
{
  id: 481,
  subject: "Word Knowledge",
  question: "What does 'obfuscate' most nearly mean?",
  answer: "To deliberately confuse or obscure the meaning of something. Example: The intelligence report attempted to obfuscate classified information.",
  difficulty: "Hard"
},
{
  id: 482,
  subject: "Word Knowledge",
  question: "What does 'perspicacity' most nearly mean?",
  answer: "The quality of having keen judgment or insight; clear understanding. Example: The commander's perspicacity enabled successful tactical decisions.",
  difficulty: "Hard"
},
{
  id: 483,
  subject: "Word Knowledge",
  question: "What does 'concomitant' most nearly mean?",
  answer: "Existing or occurring together; accompanying. Example: War brings concomitant economic challenges.",
  difficulty: "Hard"
},
{
  id: 484,
  subject: "Word Knowledge",
  question: "What does 'penurious' most nearly mean?",
  answer: "Stingy with money; unwilling to spend; excessively poor. Example: The penurious military budget limited training opportunities.",
  difficulty: "Hard"
},
{
  id: 485,
  subject: "Word Knowledge",
  question: "What does 'pusillanimous' most nearly mean?",
  answer: "Lacking courage; timid and fearful. Example: Such pusillanimous behavior had no place in the warrior culture.",
  difficulty: "Hard"
},
{
  id: 486,
  subject: "Word Knowledge",
  question: "What does 'inimical' most nearly mean?",
  answer: "Hostile or opposed to; harmful or unfavorable. Example: Lack of training is inimical to military effectiveness.",
  difficulty: "Hard"
},
{
  id: 487,
  subject: "Word Knowledge",
  question: "What does 'bellicose' most nearly mean?",
  answer: "Eager or inclined to fight; warlike and aggressive. Example: The nation's bellicose rhetoric alarmed neighboring countries.",
  difficulty: "Hard"
},
{
  id: 488,
  subject: "Word Knowledge",
  question: "What does 'acerbic' most nearly mean?",
  answer: "Sharp and forthright; harsh in tone or manner. Example: The sergeant's acerbic comments motivated the troops.",
  difficulty: "Hard"
},
{
  id: 489,
  subject: "Word Knowledge",
  question: "What does 'propitious' most nearly mean?",
  answer: "Favorable or advantageous; presenting good conditions for success. Example: Propitious winds aided the ship's passage to port.",
  difficulty: "Hard"
},
{
  id: 490,
  subject: "Word Knowledge",
  question: "What does 'pellucid' most nearly mean?",
  answer: "Clearly expressed and easily understood; transparent. Example: The pellucid orders left no room for misinterpretation.",
  difficulty: "Hard"
},
{
  id: 491,
  subject: "Word Knowledge",
  question: "What does 'perfunctory' most nearly mean?",
  answer: "Done routinely and superficially without care or attention. Example: The inspection was perfunctory and failed to find defects.",
  difficulty: "Hard"
},
{
  id: 492,
  subject: "Word Knowledge",
  question: "What does 'sagacious' most nearly mean?",
  answer: "Having keen mental perception; intellectually sharp and wise. Example: The sagacious general outmaneuvered all opposition.",
  difficulty: "Hard"
},
{
  id: 493,
  subject: "Word Knowledge",
  question: "What does 'obsequious' most nearly mean?",
  answer: "Obedient in an excessive way; showing excessive willingness to please. Example: The obsequious aide followed the officer everywhere.",
  difficulty: "Hard"
},
{
  id: 494,
  subject: "Word Knowledge",
  question: "What does 'insidious' most nearly mean?",
  answer: "Proceeding in a slow or stealthy way; subtly harmful. Example: The insidious decline in morale went unnoticed for weeks.",
  difficulty: "Hard"
},
{
  id: 495,
  subject: "Word Knowledge",
  question: "What does 'prevarication' most nearly mean?",
  answer: "A deliberate lie or equivocation; evasion of truth. Example: The witness's prevarication undermined the investigation.",
  difficulty: "Hard"
},
{
  id: 496,
  subject: "Word Knowledge",
  question: "What does 'vituperative' most nearly mean?",
  answer: "Verbally abusive or harshly critical; expressed with contempt. Example: The vituperative attack damaged diplomatic relations.",
  difficulty: "Hard"
},
{
  id: 497,
  subject: "Word Knowledge",
  question: "What does 'ephemeral' most nearly mean?",
  answer: "Lasting for a very short time; temporary and fleeting. Example: The ceasefire proved ephemeral, lasting only hours.",
  difficulty: "Hard"
},
{
  id: 498,
  subject: "Word Knowledge",
  question: "What does 'amelioration' most nearly mean?",
  answer: "The act of making something better; improvement. Example: Amelioration of training conditions improved retention rates.",
  difficulty: "Hard"
},
{
  id: 499,
  subject: "Word Knowledge",
  question: "What does 'veracity' most nearly mean?",
  answer: "Truthfulness; accuracy and reliability in statement. Example: The witness's veracity was questioned during cross-examination.",
  difficulty: "Hard"
},
{
  id: 500,
  subject: "Word Knowledge",
  question: "What does 'amalgamation' most nearly mean?",
  answer: "A combination or merger of different parts into one whole. Example: The amalgamation of three battalions created a stronger force.",
  difficulty: "Hard"
},
{
  id: 501,
  subject: "Word Knowledge",
  question: "What does 'perspicuous' most nearly mean?",
  answer: "Expressed clearly and easily understood; lucid. Example: The perspicuous battle plan was understood by all units.",
  difficulty: "Hard"
},
{
  id: 502,
  subject: "Word Knowledge",
  question: "What does 'premeditation' most nearly mean?",
  answer: "Thinking about something beforehand; planned in advance. Example: The attack showed clear signs of premeditation.",
  difficulty: "Hard"
},
{
  id: 503,
  subject: "Word Knowledge",
  question: "What does 'sanguine' most nearly mean?",
  answer: "Optimistic or positive about the future; hopeful. Example: Despite losses, the commander remained sanguine about victory.",
  difficulty: "Hard"
},
{
  id: 504,
  subject: "Word Knowledge",
  question: "What does 'quixotic' most nearly mean?",
  answer: "Idealistic but unrealistic or impractical; pursuing noble but foolish goals. Example: The quixotic mission had little chance of success.",
  difficulty: "Hard"
},
{
  id: 505,
  subject: "Word Knowledge",
  question: "What does 'malfeasance' most nearly mean?",
  answer: "Misconduct or improper action by an official in their position. Example: The investigation revealed malfeasance in the procurement office.",
  difficulty: "Hard"
},
{
  id: 506,
  subject: "Word Knowledge",
  question: "What does 'serendipity' most nearly mean?",
  answer: "The occurrence of favorable events by chance; good luck. Example: By serendipity, scouts discovered an enemy supply depot.",
  difficulty: "Hard"
},
{
  id: 507,
  subject: "Word Knowledge",
  question: "What does 'byzantine' most nearly mean?",
  answer: "Complicated, intricate, and often deceptive; overly complex. Example: The byzantine bureaucracy delayed necessary equipment approval.",
  difficulty: "Hard"
},
{
  id: 508,
  subject: "Word Knowledge",
  question: "What does 'vindicate' most nearly mean?",
  answer: "To clear from blame or suspicion; to prove correct. Example: The successful mission vindicated the commander's strategy.",
  difficulty: "Hard"
},
{
  id: 509,
  subject: "Word Knowledge",
  question: "What does 'verisimilitude' most nearly mean?",
  answer: "The appearance of being true or real; seeming genuine. Example: The spy's cover story had verisimilitude and passed inspection.",
  difficulty: "Hard"
},
{
  id: 510,
  subject: "Word Knowledge",
  question: "What does 'impetuous' most nearly mean?",
  answer: "Acting with sudden force or violence; characterized by emotional impulse. Example: The impetuous charge succeeded despite heavy fire.",
  difficulty: "Hard"
},
{
  id: 511,
  subject: "Word Knowledge",
  question: "What does 'apex' most nearly mean?",
  answer: "The highest point or peak of something. Example: The mission reached its apex when all objectives were secured.",
  difficulty: "Easy"
},
{
  id: 512,
  subject: "Word Knowledge",
  question: "What does 'vital' most nearly mean?",
  answer: "Absolutely necessary for life or success; critical. Example: Water supply is vital for soldier survival in desert operations.",
  difficulty: "Easy"
},
{
  id: 513,
  subject: "Word Knowledge",
  question: "What does 'adjacent' most nearly mean?",
  answer: "Next to or adjoining something; situated beside. Example: The adjacent barracks house the training battalions.",
  difficulty: "Easy"
},
{
  id: 514,
  subject: "Word Knowledge",
  question: "What does 'comprise' most nearly mean?",
  answer: "To consist of or be made up of; to include. Example: The force comprises infantry, armor, and artillery units.",
  difficulty: "Easy"
},
{
  id: 515,
  subject: "Word Knowledge",
  question: "What does 'imminent' most nearly mean?",
  answer: "About to happen; impending or threatening. Example: With imminent danger, soldiers took defensive positions.",
  difficulty: "Easy"
},
{
  id: 516,
  subject: "Word Knowledge",
  question: "What does 'attest' most nearly mean?",
  answer: "To declare as truthful; to provide evidence or verify. Example: Witnesses can attest to the soldier's bravery.",
  difficulty: "Easy"
},
{
  id: 517,
  subject: "Word Knowledge",
  question: "What does 'adversary' most nearly mean?",
  answer: "An opponent or enemy in conflict; someone who opposes. Example: The general studied his adversary's military tactics.",
  difficulty: "Easy"
},
{
  id: 518,
  subject: "Word Knowledge",
  question: "What does 'apparatus' most nearly mean?",
  answer: "A set of equipment or machinery for a specific function. Example: The communications apparatus kept units connected.",
  difficulty: "Easy"
},
{
  id: 519,
  subject: "Word Knowledge",
  question: "What does 'calibrate' most nearly mean?",
  answer: "To adjust or set equipment to the proper standard. Example: Soldiers must calibrate their equipment before deployment.",
  difficulty: "Easy"
},
{
  id: 520,
  subject: "Word Knowledge",
  question: "What does 'elude' most nearly mean?",
  answer: "To escape or evade; to avoid capture or detection. Example: The reconnaissance team managed to elude enemy patrols.",
  difficulty: "Easy"
}
,
{
  id: 521,
  subject: "Mathematics Knowledge",
  question: "What is 5 + 7?",
  answer: "5 + 7 = 12. Simply add the two numbers together.",
  difficulty: "Easy"
},
{
  id: 522,
  subject: "Mathematics Knowledge",
  question: "What is 12 - 3?",
  answer: "12 - 3 = 9. Subtract 3 from 12.",
  difficulty: "Easy"
},
{
  id: 523,
  subject: "Mathematics Knowledge",
  question: "What is 6 × 8?",
  answer: "6 × 8 = 48. Multiply 6 by 8 to get 48.",
  difficulty: "Easy"
},
{
  id: 524,
  subject: "Mathematics Knowledge",
  question: "What is 24 ÷ 4?",
  answer: "24 ÷ 4 = 6. Divide 24 by 4 to get 6.",
  difficulty: "Easy"
},
{
  id: 525,
  subject: "Mathematics Knowledge",
  question: "Convert 1/2 to a decimal.",
  answer: "1/2 = 0.5. Divide the numerator by the denominator: 1 ÷ 2 = 0.5.",
  difficulty: "Easy"
},
{
  id: 526,
  subject: "Mathematics Knowledge",
  question: "What is 25% of 80?",
  answer: "25% of 80 = 20. Convert 25% to 0.25, then 0.25 × 80 = 20.",
  difficulty: "Easy"
},
{
  id: 527,
  subject: "Mathematics Knowledge",
  question: "What is 2³?",
  answer: "2³ = 8. This means 2 × 2 × 2 = 8.",
  difficulty: "Easy"
},
{
  id: 528,
  subject: "Mathematics Knowledge",
  question: "What is √16?",
  answer: "√16 = 4. Find the number that multiplied by itself equals 16: 4 × 4 = 16.",
  difficulty: "Easy"
},
{
  id: 529,
  subject: "Mathematics Knowledge",
  question: "What is 3/4 + 1/4?",
  answer: "3/4 + 1/4 = 4/4 = 1. Add the numerators since denominators are the same.",
  difficulty: "Easy"
},
{
  id: 530,
  subject: "Mathematics Knowledge",
  question: "Solve: x + 5 = 12",
  answer: "x = 7. Subtract 5 from both sides: x + 5 - 5 = 12 - 5, so x = 7.",
  difficulty: "Easy"
},
{
  id: 531,
  subject: "Mathematics Knowledge",
  question: "What is 0.25 as a fraction?",
  answer: "0.25 = 1/4. 0.25 means 25 hundredths, which simplifies to 1/4.",
  difficulty: "Easy"
},
{
  id: 532,
  subject: "Mathematics Knowledge",
  question: "What is 50% of 60?",
  answer: "50% of 60 = 30. 50% means half, so 60 ÷ 2 = 30.",
  difficulty: "Easy"
},
{
  id: 533,
  subject: "Mathematics Knowledge",
  question: "What is 3⁴?",
  answer: "3⁴ = 81. This means 3 × 3 × 3 × 3 = 81.",
  difficulty: "Easy"
},
{
  id: 534,
  subject: "Mathematics Knowledge",
  question: "What is √25?",
  answer: "√25 = 5. Find the number that multiplied by itself equals 25: 5 × 5 = 25.",
  difficulty: "Easy"
},
{
  id: 535,
  subject: "Mathematics Knowledge",
  question: "What is 1/2 + 1/3?",
  answer: "1/2 + 1/3 = 5/6. Find common denominator (6): 3/6 + 2/6 = 5/6.",
  difficulty: "Easy"
},
{
  id: 536,
  subject: "Mathematics Knowledge",
  question: "Solve: 2x = 10",
  answer: "x = 5. Divide both sides by 2: 2x ÷ 2 = 10 ÷ 2, so x = 5.",
  difficulty: "Easy"
},
{
  id: 537,
  subject: "Mathematics Knowledge",
  question: "What is 75% of 20?",
  answer: "75% of 20 = 15. Convert 75% to 0.75, then 0.75 × 20 = 15.",
  difficulty: "Easy"
},
{
  id: 538,
  subject: "Mathematics Knowledge",
  question: "What is 5²?",
  answer: "5² = 25. This means 5 × 5 = 25.",
  difficulty: "Easy"
},
{
  id: 539,
  subject: "Mathematics Knowledge",
  question: "What is √9?",
  answer: "√9 = 3. Find the number that multiplied by itself equals 9: 3 × 3 = 9.",
  difficulty: "Easy"
},
{
  id: 540,
  subject: "Mathematics Knowledge",
  question: "What is 2/5 as a decimal?",
  answer: "2/5 = 0.4. Divide 2 by 5: 2 ÷ 5 = 0.4.",
  difficulty: "Easy"
},
{
  id: 541,
  subject: "Mathematics Knowledge",
  question: "What is 15% of 100?",
  answer: "15% of 100 = 15. Convert 15% to 0.15, then 0.15 × 100 = 15.",
  difficulty: "Easy"
},
{
  id: 542,
  subject: "Mathematics Knowledge",
  question: "What is 4³?",
  answer: "4³ = 64. This means 4 × 4 × 4 = 64.",
  difficulty: "Easy"
},
{
  id: 543,
  subject: "Mathematics Knowledge",
  question: "What is √36?",
  answer: "√36 = 6. Find the number that multiplied by itself equals 36: 6 × 6 = 36.",
  difficulty: "Easy"
},
{
  id: 544,
  subject: "Mathematics Knowledge",
  question: "What is 3/4 - 1/2?",
  answer: "3/4 - 1/2 = 1/4. Find common denominator (4): 3/4 - 2/4 = 1/4.",
  difficulty: "Easy"
},
{
  id: 545,
  subject: "Mathematics Knowledge",
  question: "Solve: x - 3 = 7",
  answer: "x = 10. Add 3 to both sides: x - 3 + 3 = 7 + 3, so x = 10.",
  difficulty: "Easy"
},
{
  id: 546,
  subject: "Mathematics Knowledge",
  question: "What is 10% of 50?",
  answer: "10% of 50 = 5. Convert 10% to 0.1, then 0.1 × 50 = 5.",
  difficulty: "Easy"
},
{
  id: 547,
  subject: "Mathematics Knowledge",
  question: "What is 2⁵?",
  answer: "2⁵ = 32. This means 2 × 2 × 2 × 2 × 2 = 32.",
  difficulty: "Easy"
},
{
  id: 548,
  subject: "Mathematics Knowledge",
  question: "What is √49?",
  answer: "√49 = 7. Find the number that multiplied by itself equals 49: 7 × 7 = 49.",
  difficulty: "Easy"
},
{
  id: 549,
  subject: "Mathematics Knowledge",
  question: "What is 1/3 + 1/6?",
  answer: "1/3 + 1/6 = 3/6 = 1/2. Find common denominator (6): 2/6 + 1/6 = 3/6 = 1/2.",
  difficulty: "Easy"
},
{
  id: 550,
  subject: "Mathematics Knowledge",
  question: "Solve: 3x = 15",
  answer: "x = 5. Divide both sides by 3: 3x ÷ 3 = 15 ÷ 3, so x = 5.",
  difficulty: "Easy"
},
{
  id: 551,
  subject: "Mathematics Knowledge",
  question: "What is 20% of 150?",
  answer: "20% of 150 = 30. Convert 20% to 0.2, then 0.2 × 150 = 30.",
  difficulty: "Easy"
},
{
  id: 552,
  subject: "Mathematics Knowledge",
  question: "What is 6²?",
  answer: "6² = 36. This means 6 × 6 = 36.",
  difficulty: "Easy"
},
{
  id: 553,
  subject: "Mathematics Knowledge",
  question: "What is √64?",
  answer: "√64 = 8. Find the number that multiplied by itself equals 64: 8 × 8 = 64.",
  difficulty: "Easy"
},
{
  id: 554,
  subject: "Mathematics Knowledge",
  question: "What is 5/6 - 1/3?",
  answer: "5/6 - 1/3 = 3/6 = 1/2. Find common denominator (6): 5/6 - 2/6 = 3/6 = 1/2.",
  difficulty: "Easy"
},
{
  id: 555,
  subject: "Mathematics Knowledge",
  question: "Solve: x + 8 = 15",
  answer: "x = 7. Subtract 8 from both sides: x + 8 - 8 = 15 - 8, so x = 7.",
  difficulty: "Easy"
},
{
  id: 556,
  subject: "Mathematics Knowledge",
  question: "What is 30% of 40?",
  answer: "30% of 40 = 12. Convert 30% to 0.3, then 0.3 × 40 = 12.",
  difficulty: "Easy"
},
{
  id: 557,
  subject: "Mathematics Knowledge",
  question: "What is 7²?",
  answer: "7² = 49. This means 7 × 7 = 49.",
  difficulty: "Easy"
},
{
  id: 558,
  subject: "Mathematics Knowledge",
  question: "What is √81?",
  answer: "√81 = 9. Find the number that multiplied by itself equals 81: 9 × 9 = 81.",
  difficulty: "Easy"
},
{
  id: 559,
  subject: "Mathematics Knowledge",
  question: "What is 3/5 × 2/3?",
  answer: "3/5 × 2/3 = 6/15 = 2/5. Multiply numerators and denominators, then simplify.",
  difficulty: "Easy"
},
{
  id: 560,
  subject: "Mathematics Knowledge",
  question: "Solve: 2x + 3 = 9",
  answer: "x = 3. Subtract 3 from both sides: 2x = 6, then divide by 2: x = 3.",
  difficulty: "Easy"
},
{
  id: 561,
  subject: "Mathematics Knowledge",
  question: "Solve: 2x - 5 = 11",
  answer: "x = 8. Add 5 to both sides: 2x = 16, then divide by 2: x = 8.",
  difficulty: "Medium"
},
{
  id: 562,
  subject: "Mathematics Knowledge",
  question: "What is 35% of 80?",
  answer: "35% of 80 = 28. Convert 35% to 0.35, then 0.35 × 80 = 28.",
  difficulty: "Medium"
},
{
  id: 563,
  subject: "Mathematics Knowledge",
  question: "Simplify: 2/8",
  answer: "2/8 = 1/4. Find the GCD (2) and divide both numerator and denominator by it.",
  difficulty: "Medium"
},
{
  id: 564,
  subject: "Mathematics Knowledge",
  question: "What is √100?",
  answer: "√100 = 10. Find the number that multiplied by itself equals 100: 10 × 10 = 100.",
  difficulty: "Medium"
},
{
  id: 565,
  subject: "Mathematics Knowledge",
  question: "Solve: x/2 = 6",
  answer: "x = 12. Multiply both sides by 2: (x/2) × 2 = 6 × 2, so x = 12.",
  difficulty: "Medium"
},
{
  id: 566,
  subject: "Mathematics Knowledge",
  question: "What is 45% of 60?",
  answer: "45% of 60 = 27. Convert 45% to 0.45, then 0.45 × 60 = 27.",
  difficulty: "Medium"
},
{
  id: 567,
  subject: "Mathematics Knowledge",
  question: "What is 1/2 × 3/4?",
  answer: "1/2 × 3/4 = 3/8. Multiply numerators and denominators: (1 × 3)/(2 × 4) = 3/8.",
  difficulty: "Medium"
},
{
  id: 568,
  subject: "Mathematics Knowledge",
  question: "Solve: 3x + 2 = 14",
  answer: "x = 4. Subtract 2 from both sides: 3x = 12, then divide by 3: x = 4.",
  difficulty: "Medium"
},
{
  id: 569,
  subject: "Mathematics Knowledge",
  question: "What is 0.5 + 0.25?",
  answer: "0.5 + 0.25 = 0.75. Add the decimals: 50 hundredths + 25 hundredths = 75 hundredths.",
  difficulty: "Medium"
},
{
  id: 570,
  subject: "Mathematics Knowledge",
  question: "What is 2/3 ÷ 1/2?",
  answer: "2/3 ÷ 1/2 = 4/3. Multiply by the reciprocal: (2/3) × (2/1) = 4/3.",
  difficulty: "Medium"
},
{
  id: 571,
  subject: "Mathematics Knowledge",
  question: "What is 60% of 50?",
  answer: "60% of 50 = 30. Convert 60% to 0.6, then 0.6 × 50 = 30.",
  difficulty: "Medium"
},
{
  id: 572,
  subject: "Mathematics Knowledge",
  question: "Simplify: 12/16",
  answer: "12/16 = 3/4. Find the GCD (4) and divide both numerator and denominator by it.",
  difficulty: "Medium"
},
{
  id: 573,
  subject: "Mathematics Knowledge",
  question: "What is 0.75 - 0.25?",
  answer: "0.75 - 0.25 = 0.5. Subtract the decimals: 75 hundredths - 25 hundredths = 50 hundredths.",
  difficulty: "Medium"
},
{
  id: 574,
  subject: "Mathematics Knowledge",
  question: "Solve: 4x - 7 = 9",
  answer: "x = 4. Add 7 to both sides: 4x = 16, then divide by 4: x = 4.",
  difficulty: "Medium"
},
{
  id: 575,
  subject: "Mathematics Knowledge",
  question: "What is 3/4 ÷ 1/2?",
  answer: "3/4 ÷ 1/2 = 3/2. Multiply by the reciprocal: (3/4) × (2/1) = 6/4 = 3/2.",
  difficulty: "Medium"
},
{
  id: 576,
  subject: "Mathematics Knowledge",
  question: "What is 55% of 100?",
  answer: "55% of 100 = 55. Convert 55% to 0.55, then 0.55 × 100 = 55.",
  difficulty: "Medium"
},
{
  id: 577,
  subject: "Mathematics Knowledge",
  question: "Simplify: 15/25",
  answer: "15/25 = 3/5. Find the GCD (5) and divide both numerator and denominator by it.",
  difficulty: "Medium"
},
{
  id: 578,
  subject: "Mathematics Knowledge",
  question: "What is 0.3 × 0.5?",
  answer: "0.3 × 0.5 = 0.15. Multiply the decimals: 3/10 × 5/10 = 15/100 = 0.15.",
  difficulty: "Medium"
},
{
  id: 579,
  subject: "Mathematics Knowledge",
  question: "Solve: x/3 + 2 = 5",
  answer: "x = 9. Subtract 2 from both sides: x/3 = 3, then multiply by 3: x = 9.",
  difficulty: "Medium"
},
{
  id: 580,
  subject: "Mathematics Knowledge",
  question: "What is 5/6 × 2/5?",
  answer: "5/6 × 2/5 = 10/30 = 1/3. Multiply numerators and denominators, then simplify.",
  difficulty: "Medium"
},
{
  id: 581,
  subject: "Mathematics Knowledge",
  question: "What is 70% of 80?",
  answer: "70% of 80 = 56. Convert 70% to 0.7, then 0.7 × 80 = 56.",
  difficulty: "Medium"
},
{
  id: 582,
  subject: "Mathematics Knowledge",
  question: "Simplify: 18/24",
  answer: "18/24 = 3/4. Find the GCD (6) and divide both numerator and denominator by it.",
  difficulty: "Medium"
},
{
  id: 583,
  subject: "Mathematics Knowledge",
  question: "What is 0.8 - 0.3?",
  answer: "0.8 - 0.3 = 0.5. Subtract the decimals: 8 tenths - 3 tenths = 5 tenths.",
  difficulty: "Medium"
},
{
  id: 584,
  subject: "Mathematics Knowledge",
  question: "Solve: 2x + 5 = 17",
  answer: "x = 6. Subtract 5 from both sides: 2x = 12, then divide by 2: x = 6.",
  difficulty: "Medium"
},
{
  id: 585,
  subject: "Mathematics Knowledge",
  question: "What is 1/4 + 1/3?",
  answer: "1/4 + 1/3 = 7/12. Find common denominator (12): 3/12 + 4/12 = 7/12.",
  difficulty: "Medium"
},
{
  id: 586,
  subject: "Mathematics Knowledge",
  question: "What is 85% of 20?",
  answer: "85% of 20 = 17. Convert 85% to 0.85, then 0.85 × 20 = 17.",
  difficulty: "Medium"
},
{
  id: 587,
  subject: "Mathematics Knowledge",
  question: "Simplify: 20/30",
  answer: "20/30 = 2/3. Find the GCD (10) and divide both numerator and denominator by it.",
  difficulty: "Medium"
},
{
  id: 588,
  subject: "Mathematics Knowledge",
  question: "What is 0.6 ÷ 0.2?",
  answer: "0.6 ÷ 0.2 = 3. Convert to fractions: 6/10 ÷ 2/10 = 6/10 × 10/2 = 3.",
  difficulty: "Medium"
},
{
  id: 589,
  subject: "Mathematics Knowledge",
  question: "Solve: 5x - 3 = 22",
  answer: "x = 5. Add 3 to both sides: 5x = 25, then divide by 5: x = 5.",
  difficulty: "Medium"
},
{
  id: 590,
  subject: "Mathematics Knowledge",
  question: "What is 3/5 ÷ 1/4?",
  answer: "3/5 ÷ 1/4 = 12/5. Multiply by the reciprocal: (3/5) × (4/1) = 12/5.",
  difficulty: "Medium"
},
{
  id: 591,
  subject: "Mathematics Knowledge",
  question: "What is √121?",
  answer: "√121 = 11. Find the number that multiplied by itself equals 121: 11 × 11 = 121.",
  difficulty: "Medium"
},
{
  id: 592,
  subject: "Mathematics Knowledge",
  question: "What is 90% of 30?",
  answer: "90% of 30 = 27. Convert 90% to 0.9, then 0.9 × 30 = 27.",
  difficulty: "Medium"
},
{
  id: 593,
  subject: "Mathematics Knowledge",
  question: "Solve: x/4 - 2 = 3",
  answer: "x = 20. Add 2 to both sides: x/4 = 5, then multiply by 4: x = 20.",
  difficulty: "Medium"
},
{
  id: 594,
  subject: "Mathematics Knowledge",
  question: "What is 2/3 + 3/4?",
  answer: "2/3 + 3/4 = 17/12. Find common denominator (12): 8/12 + 9/12 = 17/12.",
  difficulty: "Medium"
},
{
  id: 595,
  subject: "Mathematics Knowledge",
  question: "What is 0.4 + 0.35?",
  answer: "0.4 + 0.35 = 0.75. Add the decimals: 40 hundredths + 35 hundredths = 75 hundredths.",
  difficulty: "Medium"
},
{
  id: 596,
  subject: "Mathematics Knowledge",
  question: "Solve: 3x - 4 = 11",
  answer: "x = 5. Add 4 to both sides: 3x = 15, then divide by 3: x = 5.",
  difficulty: "Medium"
},
{
  id: 597,
  subject: "Mathematics Knowledge",
  question: "What is 5/8 - 1/4?",
  answer: "5/8 - 1/4 = 3/8. Find common denominator (8): 5/8 - 2/8 = 3/8.",
  difficulty: "Medium"
},
{
  id: 598,
  subject: "Mathematics Knowledge",
  question: "What is √144?",
  answer: "√144 = 12. Find the number that multiplied by itself equals 144: 12 × 12 = 144.",
  difficulty: "Medium"
},
{
  id: 599,
  subject: "Mathematics Knowledge",
  question: "What is 40% of 120?",
  answer: "40% of 120 = 48. Convert 40% to 0.4, then 0.4 × 120 = 48.",
  difficulty: "Medium"
},
{
  id: 600,
  subject: "Mathematics Knowledge",
  question: "Solve: 2x + 3 = x + 7",
  answer: "x = 4. Subtract x from both sides: x + 3 = 7, then subtract 3: x = 4.",
  difficulty: "Medium"
},
{
  id: 601,
  subject: "Mathematics Knowledge",
  question: "Solve: x² = 25",
  answer: "x = 5 or x = -5. Find the square root of both sides: √(x²) = √25, so x = ±5.",
  difficulty: "Hard"
},
{
  id: 602,
  subject: "Mathematics Knowledge",
  question: "What is √2 × √8?",
  answer: "√2 × √8 = 4. Multiply: √(2 × 8) = √16 = 4.",
  difficulty: "Hard"
},
{
  id: 603,
  subject: "Mathematics Knowledge",
  question: "Solve: 2x + 3 = 4x - 5",
  answer: "x = 4. Rearrange: 3 + 5 = 4x - 2x, so 8 = 2x, thus x = 4.",
  difficulty: "Hard"
},
{
  id: 604,
  subject: "Mathematics Knowledge",
  question: "What is the area of a rectangle with length 5 and width 3?",
  answer: "Area = 15 square units. Formula: Area = length × width = 5 × 3 = 15.",
  difficulty: "Hard"
},
{
  id: 605,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a square with side 4?",
  answer: "Perimeter = 16 units. Formula: Perimeter = 4 × side = 4 × 4 = 16.",
  difficulty: "Hard"
},
{
  id: 606,
  subject: "Mathematics Knowledge",
  question: "Solve: 3(x + 2) = 15",
  answer: "x = 3. Distribute: 3x + 6 = 15, subtract 6: 3x = 9, divide by 3: x = 3.",
  difficulty: "Hard"
},
{
  id: 607,
  subject: "Mathematics Knowledge",
  question: "What is x² + 2x + 1 when x = 2?",
  answer: "4 + 4 + 1 = 9. Substitute x = 2: (2)² + 2(2) + 1 = 4 + 4 + 1 = 9.",
  difficulty: "Hard"
},
{
  id: 608,
  subject: "Mathematics Knowledge",
  question: "Solve: x/2 + 3 = 8",
  answer: "x = 10. Subtract 3: x/2 = 5, multiply by 2: x = 10.",
  difficulty: "Hard"
},
{
  id: 609,
  subject: "Mathematics Knowledge",
  question: "What is the circumference of a circle with radius 5?",
  answer: "Circumference ≈ 31.4 units. Formula: C = 2πr = 2π(5) ≈ 31.4.",
  difficulty: "Hard"
},
{
  id: 610,
  subject: "Mathematics Knowledge",
  question: "What is √50?",
  answer: "√50 = 5√2 ≈ 7.07. Factor: √(25 × 2) = 5√2.",
  difficulty: "Hard"
},
{
  id: 611,
  subject: "Mathematics Knowledge",
  question: "Solve: 2(x - 3) = 10",
  answer: "x = 8. Distribute: 2x - 6 = 10, add 6: 2x = 16, divide by 2: x = 8.",
  difficulty: "Hard"
},
{
  id: 612,
  subject: "Mathematics Knowledge",
  question: "What is the area of a triangle with base 6 and height 4?",
  answer: "Area = 12 square units. Formula: Area = (1/2) × base × height = (1/2) × 6 × 4 = 12.",
  difficulty: "Hard"
},
{
  id: 613,
  subject: "Mathematics Knowledge",
  question: "Solve: x² - 5x + 6 = 0",
  answer: "x = 2 or x = 3. Factor: (x - 2)(x - 3) = 0, so x = 2 or x = 3.",
  difficulty: "Hard"
},
{
  id: 614,
  subject: "Mathematics Knowledge",
  question: "What is 2^5 - 2^3?",
  answer: "32 - 8 = 24. Calculate: 2⁵ = 32 and 2³ = 8, so 32 - 8 = 24.",
  difficulty: "Hard"
},
{
  id: 615,
  subject: "Mathematics Knowledge",
  question: "Solve: 3x + 2 = 2x + 7",
  answer: "x = 5. Subtract 2x from both sides: x + 2 = 7, subtract 2: x = 5.",
  difficulty: "Hard"
},
{
  id: 616,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a cube with side 3?",
  answer: "Volume = 27 cubic units. Formula: Volume = side³ = 3³ = 27.",
  difficulty: "Hard"
},
{
  id: 617,
  subject: "Mathematics Knowledge",
  question: "Solve: x² = 49",
  answer: "x = 7 or x = -7. Find the square root: √(x²) = √49, so x = ±7.",
  difficulty: "Hard"
},
{
  id: 618,
  subject: "Mathematics Knowledge",
  question: "What is √18?",
  answer: "√18 = 3√2 ≈ 4.24. Factor: √(9 × 2) = 3√2.",
  difficulty: "Hard"
},
{
  id: 619,
  subject: "Mathematics Knowledge",
  question: "Solve: 2x - 3 = x + 2",
  answer: "x = 5. Subtract x from both sides: x - 3 = 2, add 3: x = 5.",
  difficulty: "Hard"
},
{
  id: 620,
  subject: "Mathematics Knowledge",
  question: "What is the area of a circle with radius 3?",
  answer: "Area ≈ 28.3 square units. Formula: A = πr² = π(3)² = 9π ≈ 28.3.",
  difficulty: "Hard"
}
,
{
  id: 621,
  subject: "Mathematics Knowledge",
  question: "What is 3 + 5 × 2?",
  answer: "13. Follow order of operations (PEMDAS): First multiply 5 × 2 = 10, then add 3 + 10 = 13.",
  difficulty: "Easy"
},
{
  id: 622,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x + 3 = 11",
  answer: "x = 4. Subtract 3 from both sides: 2x = 8. Divide both sides by 2: x = 4.",
  difficulty: "Easy"
},
{
  id: 623,
  subject: "Mathematics Knowledge",
  question: "What is 1/2 + 1/4?",
  answer: "3/4. Convert to common denominator: 2/4 + 1/4 = 3/4.",
  difficulty: "Easy"
},
{
  id: 624,
  subject: "Mathematics Knowledge",
  question: "Convert 0.75 to a fraction.",
  answer: "3/4. 0.75 = 75/100 = 3/4 (simplify by dividing by 25).",
  difficulty: "Easy"
},
{
  id: 625,
  subject: "Mathematics Knowledge",
  question: "What is 20% of 80?",
  answer: "16. 20% = 0.20, so 0.20 × 80 = 16.",
  difficulty: "Easy"
},
{
  id: 626,
  subject: "Mathematics Knowledge",
  question: "What is 2^3?",
  answer: "8. 2^3 means 2 × 2 × 2 = 8.",
  difficulty: "Easy"
},
{
  id: 627,
  subject: "Mathematics Knowledge",
  question: "Simplify: 3(x + 2)",
  answer: "3x + 6. Distribute 3 to both terms: 3 × x + 3 × 2 = 3x + 6.",
  difficulty: "Easy"
},
{
  id: 628,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a square with side 5?",
  answer: "20. Perimeter = 4 × side = 4 × 5 = 20.",
  difficulty: "Easy"
},
{
  id: 629,
  subject: "Mathematics Knowledge",
  question: "What is 12 ÷ 3 - 2?",
  answer: "2. Divide first: 12 ÷ 3 = 4, then subtract: 4 - 2 = 2.",
  difficulty: "Easy"
},
{
  id: 630,
  subject: "Mathematics Knowledge",
  question: "What is 25% of 40?",
  answer: "10. 25% = 0.25, so 0.25 × 40 = 10.",
  difficulty: "Easy"
},
{
  id: 631,
  subject: "Mathematics Knowledge",
  question: "What is 3/4 - 1/4?",
  answer: "1/2. Same denominator: (3-1)/4 = 2/4 = 1/2.",
  difficulty: "Easy"
},
{
  id: 632,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x - 5 = 10",
  answer: "x = 15. Add 5 to both sides: x = 10 + 5 = 15.",
  difficulty: "Easy"
},
{
  id: 633,
  subject: "Mathematics Knowledge",
  question: "What is the area of a rectangle with length 6 and width 4?",
  answer: "24. Area = length × width = 6 × 4 = 24.",
  difficulty: "Easy"
},
{
  id: 634,
  subject: "Mathematics Knowledge",
  question: "Convert 0.5 to a percentage.",
  answer: "50%. Multiply by 100: 0.5 × 100 = 50%.",
  difficulty: "Easy"
},
{
  id: 635,
  subject: "Mathematics Knowledge",
  question: "What is 5^2?",
  answer: "25. 5^2 means 5 × 5 = 25.",
  difficulty: "Easy"
},
{
  id: 636,
  subject: "Mathematics Knowledge",
  question: "Simplify: 2x + 3x",
  answer: "5x. Combine like terms: 2x + 3x = 5x.",
  difficulty: "Easy"
},
{
  id: 637,
  subject: "Mathematics Knowledge",
  question: "What is 1/3 + 1/6?",
  answer: "1/2. Convert to common denominator: 2/6 + 1/6 = 3/6 = 1/2.",
  difficulty: "Easy"
},
{
  id: 638,
  subject: "Mathematics Knowledge",
  question: "What is 15% of 60?",
  answer: "9. 15% = 0.15, so 0.15 × 60 = 9.",
  difficulty: "Easy"
},
{
  id: 639,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x = 18",
  answer: "x = 6. Divide both sides by 3: x = 18 ÷ 3 = 6.",
  difficulty: "Easy"
},
{
  id: 640,
  subject: "Mathematics Knowledge",
  question: "What is 10% of 50?",
  answer: "5. 10% = 0.10, so 0.10 × 50 = 5.",
  difficulty: "Easy"
},
{
  id: 641,
  subject: "Mathematics Knowledge",
  question: "Convert 2/5 to a decimal.",
  answer: "0.4. Divide 2 by 5: 2 ÷ 5 = 0.4.",
  difficulty: "Easy"
},
{
  id: 642,
  subject: "Mathematics Knowledge",
  question: "What is 4^2?",
  answer: "16. 4^2 means 4 × 4 = 16.",
  difficulty: "Easy"
},
{
  id: 643,
  subject: "Mathematics Knowledge",
  question: "Simplify: 5x - 2x",
  answer: "3x. Combine like terms: 5x - 2x = 3x.",
  difficulty: "Easy"
},
{
  id: 644,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a triangle with sides 3, 4, and 5?",
  answer: "12. Perimeter = 3 + 4 + 5 = 12.",
  difficulty: "Easy"
},
{
  id: 645,
  subject: "Mathematics Knowledge",
  question: "What is 30% of 20?",
  answer: "6. 30% = 0.30, so 0.30 × 20 = 6.",
  difficulty: "Easy"
},
{
  id: 646,
  subject: "Mathematics Knowledge",
  question: "What is 1/2 × 1/4?",
  answer: "1/8. Multiply numerators and denominators: (1 × 1)/(2 × 4) = 1/8.",
  difficulty: "Easy"
},
{
  id: 647,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x + 7 = 12",
  answer: "x = 5. Subtract 7 from both sides: x = 12 - 7 = 5.",
  difficulty: "Easy"
},
{
  id: 648,
  subject: "Mathematics Knowledge",
  question: "What is 0.25 as a fraction?",
  answer: "1/4. 0.25 = 25/100 = 1/4 (simplify by dividing by 25).",
  difficulty: "Easy"
},
{
  id: 649,
  subject: "Mathematics Knowledge",
  question: "What is 3^2 + 2^2?",
  answer: "13. 3^2 = 9 and 2^2 = 4, so 9 + 4 = 13.",
  difficulty: "Easy"
},
{
  id: 650,
  subject: "Mathematics Knowledge",
  question: "What is 50% of 30?",
  answer: "15. 50% = 0.50, so 0.50 × 30 = 15.",
  difficulty: "Easy"
},
{
  id: 651,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x + 5 = 17",
  answer: "x = 6. Subtract 5: 2x = 12. Divide by 2: x = 6.",
  difficulty: "Medium"
},
{
  id: 652,
  subject: "Mathematics Knowledge",
  question: "What is 3/4 × 2/3?",
  answer: "1/2. Multiply: (3 × 2)/(4 × 3) = 6/12 = 1/2.",
  difficulty: "Medium"
},
{
  id: 653,
  subject: "Mathematics Knowledge",
  question: "What is 35% of 80?",
  answer: "28. 35% = 0.35, so 0.35 × 80 = 28.",
  difficulty: "Medium"
},
{
  id: 654,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x - 7 = 5",
  answer: "x = 4. Add 7: 3x = 12. Divide by 3: x = 4.",
  difficulty: "Medium"
},
{
  id: 655,
  subject: "Mathematics Knowledge",
  question: "What is (2x + 3) + (3x - 1)?",
  answer: "5x + 2. Combine like terms: 2x + 3x + 3 - 1 = 5x + 2.",
  difficulty: "Medium"
},
{
  id: 656,
  subject: "Mathematics Knowledge",
  question: "What is the area of a triangle with base 8 and height 6?",
  answer: "24. Area = (1/2) × base × height = (1/2) × 8 × 6 = 24.",
  difficulty: "Medium"
},
{
  id: 657,
  subject: "Mathematics Knowledge",
  question: "Convert 5/8 to a decimal.",
  answer: "0.625. Divide 5 by 8: 5 ÷ 8 = 0.625.",
  difficulty: "Medium"
},
{
  id: 658,
  subject: "Mathematics Knowledge",
  question: "What is 2^4?",
  answer: "16. 2^4 means 2 × 2 × 2 × 2 = 16.",
  difficulty: "Medium"
},
{
  id: 659,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x/2 = 6",
  answer: "x = 12. Multiply both sides by 2: x = 6 × 2 = 12.",
  difficulty: "Medium"
},
{
  id: 660,
  subject: "Mathematics Knowledge",
  question: "What is 1/3 ÷ 1/6?",
  answer: "2. Divide: (1/3) ÷ (1/6) = (1/3) × (6/1) = 6/3 = 2.",
  difficulty: "Medium"
},
{
  id: 661,
  subject: "Mathematics Knowledge",
  question: "What is 45% of 60?",
  answer: "27. 45% = 0.45, so 0.45 × 60 = 27.",
  difficulty: "Medium"
},
{
  id: 662,
  subject: "Mathematics Knowledge",
  question: "Simplify: (x + 2)(x + 3)",
  answer: "x^2 + 5x + 6. Use FOIL: x·x + x·3 + 2·x + 2·3 = x^2 + 3x + 2x + 6 = x^2 + 5x + 6.",
  difficulty: "Medium"
},
{
  id: 663,
  subject: "Mathematics Knowledge",
  question: "What is 2/3 + 1/3?",
  answer: "1. Same denominator: (2+1)/3 = 3/3 = 1.",
  difficulty: "Medium"
},
{
  id: 664,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 4x - 3 = 13",
  answer: "x = 4. Add 3: 4x = 16. Divide by 4: x = 4.",
  difficulty: "Medium"
},
{
  id: 665,
  subject: "Mathematics Knowledge",
  question: "What is the circumference of a circle with radius 5? (Use π ≈ 3.14)",
  answer: "31.4. Circumference = 2πr = 2 × 3.14 × 5 = 31.4.",
  difficulty: "Medium"
},
{
  id: 666,
  subject: "Mathematics Knowledge",
  question: "What is 55% of 40?",
  answer: "22. 55% = 0.55, so 0.55 × 40 = 22.",
  difficulty: "Medium"
},
{
  id: 667,
  subject: "Mathematics Knowledge",
  question: "Convert 3/5 to a percentage.",
  answer: "60%. (3/5) = 0.6 = 60%.",
  difficulty: "Medium"
},
{
  id: 668,
  subject: "Mathematics Knowledge",
  question: "What is 3^3?",
  answer: "27. 3^3 means 3 × 3 × 3 = 27.",
  difficulty: "Medium"
},
{
  id: 669,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 5x + 2 = 22",
  answer: "x = 4. Subtract 2: 5x = 20. Divide by 5: x = 4.",
  difficulty: "Medium"
},
{
  id: 670,
  subject: "Mathematics Knowledge",
  question: "What is 5/6 - 1/6?",
  answer: "2/3. Same denominator: (5-1)/6 = 4/6 = 2/3.",
  difficulty: "Medium"
},
{
  id: 671,
  subject: "Mathematics Knowledge",
  question: "What is 65% of 50?",
  answer: "32.5. 65% = 0.65, so 0.65 × 50 = 32.5.",
  difficulty: "Medium"
},
{
  id: 672,
  subject: "Mathematics Knowledge",
  question: "Simplify: (x - 1)(x + 4)",
  answer: "x^2 + 3x - 4. Use FOIL: x·x + x·4 - 1·x - 1·4 = x^2 + 4x - x - 4 = x^2 + 3x - 4.",
  difficulty: "Medium"
},
{
  id: 673,
  subject: "Mathematics Knowledge",
  question: "What is 7/10 as a decimal?",
  answer: "0.7. 7/10 = 7 ÷ 10 = 0.7.",
  difficulty: "Medium"
},
{
  id: 674,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x - 8 = 4",
  answer: "x = 6. Add 8: 2x = 12. Divide by 2: x = 6.",
  difficulty: "Medium"
},
{
  id: 675,
  subject: "Mathematics Knowledge",
  question: "What is the area of a circle with radius 3? (Use π ≈ 3.14)",
  answer: "28.26. Area = πr^2 = 3.14 × 3^2 = 3.14 × 9 = 28.26.",
  difficulty: "Medium"
},
{
  id: 676,
  subject: "Mathematics Knowledge",
  question: "What is 72% of 25?",
  answer: "18. 72% = 0.72, so 0.72 × 25 = 18.",
  difficulty: "Medium"
},
{
  id: 677,
  subject: "Mathematics Knowledge",
  question: "What is 1/2 ÷ 1/3?",
  answer: "3/2 or 1.5. Divide: (1/2) ÷ (1/3) = (1/2) × (3/1) = 3/2.",
  difficulty: "Medium"
},
{
  id: 678,
  subject: "Mathematics Knowledge",
  question: "What is 2^5?",
  answer: "32. 2^5 means 2 × 2 × 2 × 2 × 2 = 32.",
  difficulty: "Medium"
},
{
  id: 679,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x/3 + 2 = 5",
  answer: "x = 9. Subtract 2: x/3 = 3. Multiply by 3: x = 9.",
  difficulty: "Medium"
},
{
  id: 680,
  subject: "Mathematics Knowledge",
  question: "What is 3/8 + 1/8?",
  answer: "1/2. Same denominator: (3+1)/8 = 4/8 = 1/2.",
  difficulty: "Medium"
},
{
  id: 681,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x + 3x = 25",
  answer: "x = 5. Combine: 5x = 25. Divide by 5: x = 5.",
  difficulty: "Medium"
},
{
  id: 682,
  subject: "Mathematics Knowledge",
  question: "What is 80% of 35?",
  answer: "28. 80% = 0.80, so 0.80 × 35 = 28.",
  difficulty: "Medium"
},
{
  id: 683,
  subject: "Mathematics Knowledge",
  question: "What is (x + 1)(x - 2)?",
  answer: "x^2 - x - 2. Use FOIL: x·x - x·2 + 1·x - 1·2 = x^2 - 2x + x - 2 = x^2 - x - 2.",
  difficulty: "Medium"
},
{
  id: 684,
  subject: "Mathematics Knowledge",
  question: "Convert 0.125 to a fraction.",
  answer: "1/8. 0.125 = 125/1000 = 1/8 (simplify by dividing by 125).",
  difficulty: "Medium"
},
{
  id: 685,
  subject: "Mathematics Knowledge",
  question: "What is 4/5 as a percentage?",
  answer: "80%. (4/5) = 0.8 = 80%.",
  difficulty: "Medium"
},
{
  id: 686,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 6x - 5 = 19",
  answer: "x = 4. Add 5: 6x = 24. Divide by 6: x = 4.",
  difficulty: "Medium"
},
{
  id: 687,
  subject: "Mathematics Knowledge",
  question: "What is 9/10 - 3/10?",
  answer: "3/5. Same denominator: (9-3)/10 = 6/10 = 3/5.",
  difficulty: "Medium"
},
{
  id: 688,
  subject: "Mathematics Knowledge",
  question: "What is 88% of 50?",
  answer: "44. 88% = 0.88, so 0.88 × 50 = 44.",
  difficulty: "Medium"
},
{
  id: 689,
  subject: "Mathematics Knowledge",
  question: "What is 4^3?",
  answer: "64. 4^3 means 4 × 4 × 4 = 64.",
  difficulty: "Medium"
},
{
  id: 690,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x + 4 = 2x + 9",
  answer: "x = 5. Subtract 2x: x + 4 = 9. Subtract 4: x = 5.",
  difficulty: "Medium"
},
{
  id: 691,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x^2 = 18",
  answer: "x = 3. Divide by 2: x^2 = 9. Take square root: x = 3.",
  difficulty: "Hard"
},
{
  id: 692,
  subject: "Mathematics Knowledge",
  question: "What is x^2 - 4 factored?",
  answer: "(x - 2)(x + 2). This is a difference of squares: a^2 - b^2 = (a-b)(a+b).",
  difficulty: "Hard"
},
{
  id: 693,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x^2 + 5x + 6 = 0",
  answer: "x = -2 or x = -3. Factor: (x + 2)(x + 3) = 0, so x = -2 or x = -3.",
  difficulty: "Hard"
},
{
  id: 694,
  subject: "Mathematics Knowledge",
  question: "What is the discriminant of x^2 + 3x + 2?",
  answer: "1. Discriminant = b^2 - 4ac = 3^2 - 4(1)(2) = 9 - 8 = 1.",
  difficulty: "Hard"
},
{
  id: 695,
  subject: "Mathematics Knowledge",
  question: "Solve for x: |x - 3| = 5",
  answer: "x = 8 or x = -2. Two cases: x - 3 = 5 (x = 8) or x - 3 = -5 (x = -2).",
  difficulty: "Hard"
},
{
  id: 696,
  subject: "Mathematics Knowledge",
  question: "What is the slope of a line passing through (2, 3) and (5, 9)?",
  answer: "2. Slope = (9 - 3)/(5 - 2) = 6/3 = 2.",
  difficulty: "Hard"
},
{
  id: 697,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x^2 - 12 = 0",
  answer: "x = 2 or x = -2. Divide by 3: x^2 - 4 = 0. Factor: (x - 2)(x + 2) = 0.",
  difficulty: "Hard"
},
{
  id: 698,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a rectangular prism with dimensions 3, 4, and 5?",
  answer: "60. Volume = length × width × height = 3 × 4 × 5 = 60.",
  difficulty: "Hard"
},
{
  id: 699,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x + 3y = 10 and x + y = 4 (find x)",
  answer: "x = 2. From second equation: x = 4 - y. Substitute: 2(4 - y) + 3y = 10, so 8 - 2y + 3y = 10, y = 2, x = 2.",
  difficulty: "Hard"
},
{
  id: 700,
  subject: "Mathematics Knowledge",
  question: "What is the sum of angles in a pentagon?",
  answer: "540 degrees. Sum = (n - 2) × 180 = (5 - 2) × 180 = 540.",
  difficulty: "Hard"
},
{
  id: 701,
  subject: "Mathematics Knowledge",
  question: "Simplify: sqrt(72)",
  answer: "6*sqrt(2). 72 = 36 × 2, so sqrt(72) = sqrt(36 × 2) = 6*sqrt(2).",
  difficulty: "Hard"
},
{
  id: 702,
  subject: "Mathematics Knowledge",
  question: "What is x if x^2 + 10x + 25 = 0?",
  answer: "x = -5. This factors as (x + 5)^2 = 0, so x = -5.",
  difficulty: "Hard"
},
{
  id: 703,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x^2 - 7x + 12 = 0",
  answer: "x = 3 or x = 4. Factor: (x - 3)(x - 4) = 0, so x = 3 or x = 4.",
  difficulty: "Hard"
},
{
  id: 704,
  subject: "Mathematics Knowledge",
  question: "What is 2^(-3)?",
  answer: "1/8. 2^(-3) = 1/(2^3) = 1/8.",
  difficulty: "Hard"
},
{
  id: 705,
  subject: "Mathematics Knowledge",
  question: "Solve for x: sqrt(x) = 7",
  answer: "x = 49. Square both sides: x = 7^2 = 49.",
  difficulty: "Hard"
},
{
  id: 706,
  subject: "Mathematics Knowledge",
  question: "What is the distance between (1, 2) and (4, 6)?",
  answer: "5. Distance = sqrt((4-1)^2 + (6-2)^2) = sqrt(9 + 16) = sqrt(25) = 5.",
  difficulty: "Hard"
},
{
  id: 707,
  subject: "Mathematics Knowledge",
  question: "Simplify: sqrt(50) + sqrt(8)",
  answer: "7*sqrt(2). sqrt(50) = 5*sqrt(2), sqrt(8) = 2*sqrt(2), sum = 7*sqrt(2).",
  difficulty: "Hard"
},
{
  id: 708,
  subject: "Mathematics Knowledge",
  question: "What is (2x + 3)^2?",
  answer: "4x^2 + 12x + 9. Use (a+b)^2 = a^2 + 2ab + b^2: (2x)^2 + 2(2x)(3) + 3^2.",
  difficulty: "Hard"
},
{
  id: 709,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 1/x + 1/2 = 3/4",
  answer: "x = 4. Subtract 1/2: 1/x = 1/4. Take reciprocal: x = 4.",
  difficulty: "Hard"
},
{
  id: 710,
  subject: "Mathematics Knowledge",
  question: "What is the area of a trapezoid with parallel sides 5 and 8, and height 4?",
  answer: "26. Area = (1/2) × (b1 + b2) × h = (1/2) × (5 + 8) × 4 = 26.",
  difficulty: "Hard"
},
{
  id: 711,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 4x - 2 = 3x + 7",
  answer: "x = 9. Subtract 3x: x - 2 = 7. Add 2: x = 9.",
  difficulty: "Easy"
},
{
  id: 712,
  subject: "Mathematics Knowledge",
  question: "What is 6 × 7 ÷ 2?",
  answer: "21. Multiply: 6 × 7 = 42, then divide: 42 ÷ 2 = 21.",
  difficulty: "Easy"
},
{
  id: 713,
  subject: "Mathematics Knowledge",
  question: "What is 1/5 + 2/5?",
  answer: "3/5. Same denominator: (1+2)/5 = 3/5.",
  difficulty: "Easy"
},
{
  id: 714,
  subject: "Mathematics Knowledge",
  question: "What is 0.1 as a fraction?",
  answer: "1/10. 0.1 = 1/10.",
  difficulty: "Easy"
},
{
  id: 715,
  subject: "Mathematics Knowledge",
  question: "What is 5% of 100?",
  answer: "5. 5% = 0.05, so 0.05 × 100 = 5.",
  difficulty: "Easy"
},
{
  id: 716,
  subject: "Mathematics Knowledge",
  question: "What is 9 - 3 × 2?",
  answer: "3. Multiply first: 3 × 2 = 6, then subtract: 9 - 6 = 3.",
  difficulty: "Easy"
},
{
  id: 717,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x + 10 = 18",
  answer: "x = 8. Subtract 10 from both sides: x = 18 - 10 = 8.",
  difficulty: "Easy"
},
{
  id: 718,
  subject: "Mathematics Knowledge",
  question: "What is the area of a square with side 7?",
  answer: "49. Area = side^2 = 7^2 = 49.",
  difficulty: "Easy"
},
{
  id: 719,
  subject: "Mathematics Knowledge",
  question: "What is 2/6 simplified?",
  answer: "1/3. Divide numerator and denominator by 2: 2/6 = 1/3.",
  difficulty: "Easy"
},
{
  id: 720,
  subject: "Mathematics Knowledge",
  question: "What is 8 ÷ 2 + 3?",
  answer: "7. Divide first: 8 ÷ 2 = 4, then add: 4 + 3 = 7.",
  difficulty: "Easy"
}
,
{
  id: 721,
  subject: "General Science",
  question: "What is the basic unit of life?",
  answer: "The cell is the basic unit of life. All living organisms are composed of one or more cells. Cells can be prokaryotic (bacteria) or eukaryotic (animals and plants). Understanding cellular structure is fundamental to military medical and biological training.",
  difficulty: "Easy"
},
{
  id: 722,
  subject: "General Science",
  question: "Define photosynthesis.",
  answer: "Photosynthesis is the process by which plants, algae, and some bacteria convert light energy into chemical energy stored in glucose. It occurs in two stages: light-dependent reactions (in thylakoids) and light-independent reactions (Calvin cycle). This is crucial for understanding ecosystems and oxygen production.",
  difficulty: "Easy"
},
{
  id: 723,
  subject: "General Science",
  question: "What are the three states of matter?",
  answer: "The three states of matter are solid, liquid, and gas. Solids have fixed shape and volume; liquids have fixed volume but take the shape of their container; gases have neither fixed shape nor volume. This is fundamental to understanding material properties in military applications.",
  difficulty: "Easy"
},
{
  id: 724,
  subject: "General Science",
  question: "What is the function of mitochondria?",
  answer: "Mitochondria are the powerhouses of the cell, responsible for producing ATP (adenosine triphosphate) through cellular respiration. They convert glucose and oxygen into usable energy for cellular functions. This is essential for understanding how the body generates energy during physical exertion.",
  difficulty: "Easy"
},
{
  id: 725,
  subject: "General Science",
  question: "Define velocity.",
  answer: "Velocity is the rate of change of displacement, measured in distance per unit time with a specific direction (e.g., 60 mph north). Unlike speed, velocity is a vector quantity that includes direction. In military contexts, understanding velocity is crucial for ballistics and projectile motion calculations.",
  difficulty: "Easy"
},
{
  id: 726,
  subject: "General Science",
  question: "What is the pH scale used for?",
  answer: "The pH scale measures the acidity or alkalinity of a solution, ranging from 0 (most acidic) to 14 (most alkaline), with 7 being neutral. pH is calculated as -log[H+]. This is important for understanding chemical reactions, water quality, and biological processes.",
  difficulty: "Easy"
},
{
  id: 727,
  subject: "General Science",
  question: "What is an atom?",
  answer: "An atom is the smallest unit of an element that retains the element's properties. It consists of a nucleus (containing protons and neutrons) surrounded by electrons in electron shells. Understanding atomic structure is fundamental to all chemistry and material science.",
  difficulty: "Easy"
},
{
  id: 728,
  subject: "General Science",
  question: "Define acceleration.",
  answer: "Acceleration is the rate of change of velocity over time, measured in distance per unit time squared (e.g., m/s²). It can involve changes in speed, direction, or both. This is critical for understanding forces and motion in military physics and engineering applications.",
  difficulty: "Easy"
},
{
  id: 729,
  subject: "General Science",
  question: "What is the function of chloroplasts?",
  answer: "Chloroplasts are organelles in plant cells where photosynthesis occurs. They contain chlorophyll pigments that capture light energy and convert it into chemical energy in the form of glucose. Understanding chloroplast function is essential for comprehending plant biology and oxygen production.",
  difficulty: "Easy"
},
{
  id: 730,
  subject: "General Science",
  question: "What is Newton's First Law of Motion?",
  answer: "Newton's First Law states that an object in motion remains in motion, and an object at rest remains at rest, unless acted upon by an external force. This is the principle of inertia and is fundamental to understanding vehicle dynamics and projectile motion in military applications.",
  difficulty: "Easy"
},
{
  id: 731,
  subject: "General Science",
  question: "What is the process of cell division in somatic cells?",
  answer: "Mitosis is the process of cell division in somatic (body) cells that produces two identical daughter cells. It involves prophase, metaphase, anaphase, and telophase stages. This is essential for understanding growth, repair, and regeneration of body tissues.",
  difficulty: "Medium"
},
{
  id: 732,
  subject: "General Science",
  question: "What is the difference between kinetic and potential energy?",
  answer: "Kinetic energy is the energy of motion, calculated as KE = 1/2mv². Potential energy is stored energy due to an object's position or state, such as gravitational potential energy (PE = mgh). Understanding both forms is crucial for calculations involving energy conservation in military engineering.",
  difficulty: "Medium"
},
{
  id: 733,
  subject: "General Science",
  question: "What are the primary components of the circulatory system?",
  answer: "The circulatory system consists of the heart, blood vessels (arteries, veins, and capillaries), and blood. The heart pumps blood through arteries to tissues and returns deoxygenated blood through veins. This system is critical for oxygen transport and nutrient delivery, essential in military medicine.",
  difficulty: "Medium"
},
{
  id: 734,
  subject: "General Science",
  question: "Define density and explain its importance.",
  answer: "Density is the mass of a substance per unit volume (ρ = m/V). It determines whether objects float or sink in fluids. Density is crucial in military applications for buoyancy calculations, material selection, and understanding how substances behave under pressure.",
  difficulty: "Medium"
},
{
  id: 735,
  subject: "General Science",
  question: "What is the role of enzymes in biochemical reactions?",
  answer: "Enzymes are biological catalysts that speed up chemical reactions by lowering the activation energy required. They work by binding to substrate molecules and facilitating specific reactions without being consumed. Understanding enzyme function is essential for military medical, forensic, and biological studies.",
  difficulty: "Medium"
},
{
  id: 736,
  subject: "General Science",
  question: "What is the greenhouse effect?",
  answer: "The greenhouse effect is the process by which certain atmospheric gases (CO2, methane, H2O vapor) trap heat from the sun, warming Earth's atmosphere. While essential for life, excess greenhouse gases increase global temperatures. Understanding this is important for military environmental and climate assessments.",
  difficulty: "Medium"
},
{
  id: 737,
  subject: "General Science",
  question: "What is Newton's Second Law of Motion?",
  answer: "Newton's Second Law states that Force equals mass times acceleration (F = ma). The acceleration of an object depends on the force applied and its mass. This principle is fundamental to calculating weapon trajectories, vehicle dynamics, and mechanical systems in military applications.",
  difficulty: "Medium"
},
{
  id: 738,
  subject: "General Science",
  question: "What is the function of the nervous system?",
  answer: "The nervous system transmits electrical and chemical signals throughout the body, coordinating responses to stimuli. It consists of the central nervous system (brain and spinal cord) and peripheral nervous system (nerves extending to the body). Understanding this is crucial for military medical and tactical training.",
  difficulty: "Medium"
},
{
  id: 739,
  subject: "General Science",
  question: "What is the difference between ionic and covalent bonds?",
  answer: "Ionic bonds form between atoms that transfer electrons (creating ions held together by electrostatic attraction), typically between metals and nonmetals. Covalent bonds form when atoms share electrons, typically between nonmetals. Understanding bond types is essential for chemistry and material science in military engineering.",
  difficulty: "Medium"
},
{
  id: 740,
  subject: "General Science",
  question: "What is the process of diffusion?",
  answer: "Diffusion is the spontaneous movement of particles from an area of higher concentration to lower concentration due to random motion. It is a passive transport process requiring no energy. This process is critical in cellular uptake of oxygen and nutrients in military medical applications.",
  difficulty: "Medium"
},
{
  id: 741,
  subject: "General Science",
  question: "Define work in physics and provide the formula.",
  answer: "Work is the transfer of energy when a force is applied over a distance: W = Fd cos(θ), where F is force, d is distance, and θ is the angle between them. Work is measured in joules. Understanding work is essential for calculating mechanical advantage and energy in military equipment.",
  difficulty: "Medium"
},
{
  id: 742,
  subject: "General Science",
  question: "What are the stages of human mitosis?",
  answer: "The stages of mitosis are: (1) Prophase - chromosomes condense and spindle forms, (2) Metaphase - chromosomes align at the cell's equator, (3) Anaphase - sister chromatids separate, (4) Telophase - nuclear envelopes reform. Understanding cell division is crucial for medical and biological training.",
  difficulty: "Medium"
},
{
  id: 743,
  subject: "General Science",
  question: "What is the water cycle?",
  answer: "The water cycle consists of evaporation (water becomes vapor), condensation (vapor becomes liquid), precipitation (liquid falls as rain/snow), and collection in water bodies. This continuous cycle distributes water across Earth. Understanding it is important for military environmental assessments and survival training.",
  difficulty: "Medium"
},
{
  id: 744,
  subject: "General Science",
  question: "What is pressure and how is it calculated?",
  answer: "Pressure is the force applied perpendicular to a surface per unit area: P = F/A, measured in pascals or atmospheres. It is crucial for understanding fluid dynamics, diving operations, and weapon system behavior. Military applications include understanding pressure in hydraulic systems and underwater operations.",
  difficulty: "Medium"
},
{
  id: 745,
  subject: "General Science",
  question: "What is the role of hemoglobin in the body?",
  answer: "Hemoglobin is a protein in red blood cells that binds to oxygen and transports it throughout the body. Each hemoglobin molecule can carry four oxygen molecules. Understanding oxygen transport is critical for military medical training, especially in high-altitude or high-exertion scenarios.",
  difficulty: "Medium"
},
{
  id: 746,
  subject: "General Science",
  question: "What is the difference between endothermic and exothermic reactions?",
  answer: "Endothermic reactions absorb heat energy from surroundings, resulting in a temperature decrease (ΔH > 0). Exothermic reactions release heat energy to surroundings, resulting in a temperature increase (ΔH < 0). This distinction is crucial for understanding explosives and chemical reactions in military applications.",
  difficulty: "Medium"
},
{
  id: 747,
  subject: "General Science",
  question: "What is the function of the immune system?",
  answer: "The immune system protects the body from pathogens like bacteria, viruses, and parasites through physical barriers, innate immunity, and adaptive immunity. White blood cells and antibodies are key components. Understanding immunity is essential for military medical readiness and disease prevention.",
  difficulty: "Medium"
},
{
  id: 748,
  subject: "General Science",
  question: "What is the principle of conservation of energy?",
  answer: "The principle of conservation of energy states that energy cannot be created or destroyed, only transformed from one form to another. Total energy in an isolated system remains constant. This fundamental principle applies to all military physics calculations and mechanical systems.",
  difficulty: "Medium"
},
{
  id: 749,
  subject: "General Science",
  question: "What are chromosomes and what role do they play?",
  answer: "Chromosomes are structures containing DNA that carry genetic information. Humans have 23 pairs of chromosomes (46 total). They are essential for heredity and cell division. Understanding chromosome behavior is crucial for military genetics, forensics, and medical applications.",
  difficulty: "Medium"
},
{
  id: 750,
  subject: "General Science",
  question: "What is friction and how does it affect motion?",
  answer: "Friction is a force that opposes relative motion between surfaces in contact. It acts parallel to surfaces and depends on normal force and the coefficient of friction (f = μN). Friction is critical in military applications including vehicle dynamics, weapons handling, and tactical movement.",
  difficulty: "Medium"
},
{
  id: 751,
  subject: "General Science",
  question: "What are prokaryotes and eukaryotes, and what are their key differences?",
  answer: "Prokaryotes (bacteria and archaea) lack a membrane-bound nucleus and organelles; their DNA floats freely. Eukaryotes (animals, plants, fungi) have a true nucleus and membrane-bound organelles. Understanding these cell types is fundamental to microbiology, biology, and military medical applications.",
  difficulty: "Hard"
},
{
  id: 752,
  subject: "General Science",
  question: "Explain the process of osmosis and its military medical relevance.",
  answer: "Osmosis is the passive movement of water molecules across a semipermeable membrane from areas of high water concentration (low solute) to low water concentration (high solute). In military medicine, understanding osmosis is critical for IV fluid administration and preventing cellular dehydration or lysis.",
  difficulty: "Hard"
},
{
  id: 753,
  subject: "General Science",
  question: "What is entropy and what does the Second Law of Thermodynamics state?",
  answer: "Entropy (S) is a measure of disorder or randomness in a system. The Second Law of Thermodynamics states that entropy in an isolated system always increases. In practical military terms, this explains why organized systems require energy input to maintain order against natural deterioration.",
  difficulty: "Hard"
},
{
  id: 754,
  subject: "General Science",
  question: "Explain the relationship between genotype and phenotype.",
  answer: "Genotype is the genetic makeup of an organism (the alleles inherited), while phenotype is the observable physical and behavioral characteristics resulting from genotype and environment interactions. Understanding this relationship is essential for military medical genetics, forensic analysis, and biological research.",
  difficulty: "Hard"
},
{
  id: 755,
  subject: "General Science",
  question: "What is the Krebs Cycle and its significance?",
  answer: "The Krebs Cycle (citric acid cycle) is a series of chemical reactions that extract energy from acetyl-CoA by oxidation, generating NADH and FADH2 for ATP production. It occurs in the mitochondria and produces 2 ATP and numerous electron carriers. Understanding cellular respiration is crucial for military medical physiology.",
  difficulty: "Hard"
},
{
  id: 756,
  subject: "General Science",
  question: "Explain wave properties including wavelength, frequency, and amplitude.",
  answer: "Wavelength (λ) is the distance between consecutive peaks; frequency (f) is the number of waves per unit time; amplitude (A) is the maximum displacement from equilibrium. The relationship is c = λf (where c is wave speed). Understanding waves is essential for sonar, radar, and communication systems in military applications.",
  difficulty: "Hard"
},
{
  id: 757,
  subject: "General Science",
  question: "What is the significance of the pH buffer system in blood?",
  answer: "The blood buffer system, primarily the bicarbonate buffer (H2CO3/HCO3-), maintains pH around 7.35-7.45 despite metabolic changes. It works by neutralizing excess acids or bases. In military medicine, understanding buffer systems is critical for treating acidosis or alkalosis in combat casualties.",
  difficulty: "Hard"
},
{
  id: 758,
  subject: "General Science",
  question: "Explain the process of cellular respiration and its stages.",
  answer: "Cellular respiration converts glucose into ATP in stages: (1) Glycolysis in cytoplasm producing pyruvate and 2 ATP, (2) Krebs Cycle in mitochondria, (3) Electron Transport Chain producing approximately 30-32 ATP. This process is essential for understanding energy production in the human body during physical exertion.",
  difficulty: "Hard"
},
{
  id: 759,
  subject: "General Science",
  question: "What is molar mass and how is it calculated?",
  answer: "Molar mass is the mass of one mole of a substance, measured in grams per mole (g/mol). It is numerically equal to the atomic or molecular mass. Calculating molar mass is essential for stoichiometry in military chemistry, explosives calculations, and chemical weapons analysis.",
  difficulty: "Hard"
},
{
  id: 760,
  subject: "General Science",
  question: "Explain Newton's Third Law of Motion and provide military examples.",
  answer: "Newton's Third Law states that for every action, there is an equal and opposite reaction. In military applications: when a gun fires, the bullet moves forward while the gun recoils backward; when a helicopter rotor pushes air down, it generates lift upward. This principle is fundamental to all military physics.",
  difficulty: "Hard"
},
{
  id: 761,
  subject: "General Science",
  question: "What is a compound and how does it differ from a mixture?",
  answer: "A compound is a pure substance formed by chemical bonding of two or more elements in fixed proportions (e.g., H2O). A mixture combines two or more substances physically without chemical bonding, maintaining individual properties (e.g., salt water). This distinction is crucial for military chemistry and material analysis.",
  difficulty: "Easy"
},
{
  id: 762,
  subject: "General Science",
  question: "Define osmotic pressure.",
  answer: "Osmotic pressure is the pressure required to prevent water from flowing across a semipermeable membrane from a dilute to concentrated solution. It's calculated as π = iMRT. In military medicine, understanding osmotic pressure is vital for proper IV fluid preparation and administration.",
  difficulty: "Hard"
},
{
  id: 763,
  subject: "General Science",
  question: "What is the function of the respiratory system?",
  answer: "The respiratory system exchanges gases between the body and environment. Oxygen is absorbed through the lungs into the bloodstream, while carbon dioxide is removed as waste. This system is critical for sustaining aerobic metabolism and is a focus of military fitness and tactical training.",
  difficulty: "Easy"
},
{
  id: 764,
  subject: "General Science",
  question: "What is the difference between an element and a compound?",
  answer: "An element is a pure substance consisting of only one type of atom (e.g., oxygen, iron). A compound consists of two or more elements chemically bonded in fixed ratios (e.g., water). Understanding this distinction is fundamental to all chemistry and material science.",
  difficulty: "Easy"
},
{
  id: 765,
  subject: "General Science",
  question: "What is half-life in radioactive decay?",
  answer: "Half-life is the time required for half of a radioactive sample to decay into its daughter products. Different isotopes have different half-lives (seconds to billions of years). Understanding half-life is essential for military radiation detection, nuclear weapon assessments, and radiological contamination analysis.",
  difficulty: "Hard"
},
{
  id: 766,
  subject: "General Science",
  question: "What is the function of the digestive system?",
  answer: "The digestive system breaks down food into nutrients that can be absorbed by the body. It involves mechanical and chemical digestion, occurring in the mouth, stomach, and small intestine. Understanding digestion is important for military nutrition and sustaining physical performance.",
  difficulty: "Easy"
},
{
  id: 767,
  subject: "General Science",
  question: "What is buoyancy and Archimedes' Principle?",
  answer: "Buoyancy is an upward force exerted by a fluid on a submerged object. Archimedes' Principle states that the buoyant force equals the weight of fluid displaced. This is crucial for military naval operations, submarine calculations, and amphibious vehicle design.",
  difficulty: "Medium"
},
{
  id: 768,
  subject: "General Science",
  question: "What are valence electrons and their significance?",
  answer: "Valence electrons are the outermost electrons in an atom that determine chemical bonding behavior. The number of valence electrons determines how many bonds an element typically forms. Understanding valence is essential for predicting chemical reactions and compound formation in military chemistry.",
  difficulty: "Medium"
},
{
  id: 769,
  subject: "General Science",
  question: "What is the function of platelets in blood?",
  answer: "Platelets are cell fragments that play a crucial role in blood clotting. They aggregate at wound sites and form a plug to prevent excessive bleeding. In military medicine, understanding platelet function is critical for treating hemorrhage and managing hemostasis in combat casualties.",
  difficulty: "Medium"
},
{
  id: 770,
  subject: "General Science",
  question: "What is the law of conservation of mass?",
  answer: "The law of conservation of mass states that matter cannot be created or destroyed; it can only change form. In chemical reactions, the mass of reactants equals the mass of products. This principle is fundamental to stoichiometry and chemical calculations in military applications.",
  difficulty: "Easy"
},
{
  id: 771,
  subject: "General Science",
  question: "What is force and what is its SI unit?",
  answer: "Force is a push or pull that causes an object to accelerate. Its SI unit is the newton (N), defined as 1 kg·m/s². Force can change an object's motion, shape, or direction. Understanding force is fundamental to all military physics and mechanics.",
  difficulty: "Easy"
},
{
  id: 772,
  subject: "General Science",
  question: "What is the function of antibodies in immunity?",
  answer: "Antibodies (immunoglobulins) are proteins produced by B cells that bind to antigens on pathogens, marking them for destruction by immune cells. Each antibody is specific to a particular antigen. Understanding antibody function is crucial for military immunology and disease resistance protocols.",
  difficulty: "Medium"
},
{
  id: 773,
  subject: "General Science",
  question: "What is a catalyst and how does it work?",
  answer: "A catalyst is a substance that speeds up a chemical reaction by lowering activation energy without being consumed in the process. Catalysts are essential in biological systems (enzymes) and industrial processes. Understanding catalysis is important for military chemistry and propellant combustion.",
  difficulty: "Medium"
},
{
  id: 774,
  subject: "General Science",
  question: "What is the relationship between mass and weight?",
  answer: "Mass is the amount of matter in an object (measured in kg), while weight is the gravitational force acting on that mass (W = mg, measured in newtons). Mass is constant, but weight varies with gravitational field strength. This distinction is crucial for military physics and ballistics calculations.",
  difficulty: "Medium"
},
{
  id: 775,
  subject: "General Science",
  question: "What are the components of blood?",
  answer: "Blood consists of plasma (fluid component) and cellular components: red blood cells (oxygen transport), white blood cells (immunity), and platelets (clotting). Red blood cells comprise about 84% of blood cells. Understanding blood composition is essential for military medical training and transfusion protocols.",
  difficulty: "Easy"
},
{
  id: 776,
  subject: "General Science",
  question: "What is oxidation and reduction (redox reactions)?",
  answer: "Oxidation is the loss of electrons (or gain of oxygen), while reduction is the gain of electrons (or loss of oxygen). Redox reactions involve simultaneous oxidation and reduction. These reactions are critical in energy production, corrosion prevention, and explosives in military applications.",
  difficulty: "Medium"
},
{
  id: 777,
  subject: "General Science",
  question: "What is the function of the skeleton?",
  answer: "The skeleton provides structural support, protects vital organs (skull protects brain, ribs protect lungs/heart), enables movement through muscle attachment, and produces blood cells in bone marrow. Understanding skeletal anatomy is crucial for military medical training and tactical anatomy.",
  difficulty: "Easy"
},
{
  id: 778,
  subject: "General Science",
  question: "What is specific heat capacity and its significance?",
  answer: "Specific heat capacity is the energy required to raise the temperature of 1 kg of a substance by 1°C. Different materials have different specific heat capacities. This is important for military applications including thermal imaging, equipment design, and understanding weapon effects.",
  difficulty: "Medium"
},
{
  id: 779,
  subject: "General Science",
  question: "What is the difference between an acid and a base?",
  answer: "Acids are substances that donate hydrogen ions (H+) and have pH < 7, while bases are substances that accept hydrogen ions and have pH > 7. Acids and bases neutralize each other in neutralization reactions. Understanding acid-base chemistry is crucial for military medical care and chemical analysis.",
  difficulty: "Easy"
},
{
  id: 780,
  subject: "General Science",
  question: "What is equilibrium in chemical reactions?",
  answer: "Chemical equilibrium is a state where forward and reverse reaction rates are equal, so concentrations of reactants and products remain constant. The equilibrium constant (K) describes the ratio of products to reactants. Understanding equilibrium is essential for predicting chemical reactions in military chemistry applications.",
  difficulty: "Hard"
},
{
  id: 781,
  subject: "General Science",
  question: "What is the function of DNA?",
  answer: "DNA (deoxyribonucleic acid) stores genetic information in sequences of nucleotide base pairs (A-T and G-C). It codes for proteins and passes hereditary information to offspring. Understanding DNA is fundamental for military genetics, forensics, and biological research applications.",
  difficulty: "Easy"
},
{
  id: 782,
  subject: "General Science",
  question: "What is momentum and how is it calculated?",
  answer: "Momentum is the product of an object's mass and velocity (p = mv), measured in kg·m/s. It is a vector quantity indicating the difficulty of stopping a moving object. Momentum is crucial in military ballistics, collision analysis, and calculating weapon effectiveness.",
  difficulty: "Medium"
},
{
  id: 783,
  subject: "General Science",
  question: "What are the three main types of rock?",
  answer: "The three main types of rock are: (1) Igneous - formed from solidified magma/lava, (2) Sedimentary - formed from compressed sediments, (3) Metamorphic - formed from existing rock transformed by heat/pressure. Understanding rock types is important for military geology and terrain analysis.",
  difficulty: "Easy"
},
{
  id: 784,
  subject: "General Science",
  question: "What is the function of the lymphatic system?",
  answer: "The lymphatic system circulates lymph fluid containing white blood cells throughout the body, providing immunity and returning tissue fluid to blood. Lymph nodes filter pathogens. This system is critical for military medical understanding of infection fighting and fluid balance.",
  difficulty: "Medium"
},
{
  id: 785,
  subject: "General Science",
  question: "What is a nucleotide and what are its components?",
  answer: "A nucleotide is the basic building block of DNA and RNA, consisting of three components: a phosphate group, a pentose sugar (ribose or deoxyribose), and a nitrogenous base (A, T, G, C, or U). Understanding nucleotide structure is essential for military genetics and molecular biology.",
  difficulty: "Medium"
},
{
  id: 786,
  subject: "General Science",
  question: "What is mechanical advantage and how does it apply to simple machines?",
  answer: "Mechanical advantage is the ratio of output force to input force (MA = Fout/Fin). Simple machines (lever, pulley, incline, etc.) provide mechanical advantage, allowing lifting heavy loads with less effort. This principle is crucial for military equipment design and tactical vehicle systems.",
  difficulty: "Medium"
},
{
  id: 787,
  subject: "General Science",
  question: "What is the difference between weather and climate?",
  answer: "Weather is short-term atmospheric conditions (temperature, precipitation, wind) occurring over days/weeks. Climate is long-term average weather patterns over years/decades for a region. Understanding this distinction is important for military operations planning and environmental assessments.",
  difficulty: "Easy"
},
{
  id: 788,
  subject: "General Science",
  question: "What is the role of myelin in the nervous system?",
  answer: "Myelin is an insulating sheath around axons that speeds up electrical signal transmission (action potentials). It increases transmission speed up to 120 m/s compared to 1 m/s in unmyelinated neurons. Understanding myelin function is crucial for military neuroscience and understanding neurological injuries.",
  difficulty: "Hard"
},
{
  id: 789,
  subject: "General Science",
  question: "What is tropism in plants?",
  answer: "Tropism is the directional growth response of plants to environmental stimuli (light, gravity, water). Phototropism (growth toward light) and geotropism (growth toward earth) help plants optimize survival. Understanding plant responses is important for military agriculture and field operations.",
  difficulty: "Medium"
},
{
  id: 790,
  subject: "General Science",
  question: "What is the difference between elastic and plastic deformation?",
  answer: "Elastic deformation is temporary and reversible when stress is removed (e.g., stretching a rubber band). Plastic deformation is permanent and causes permanent shape change (e.g., bending metal). Understanding material deformation is crucial for military engineering and armor/structure design.",
  difficulty: "Hard"
},
{
  id: 791,
  subject: "General Science",
  question: "What is an ecosystem and what are its key components?",
  answer: "An ecosystem is a community of living organisms interacting with their physical environment. Key components include producers (plants), consumers (animals), decomposers (bacteria/fungi), and abiotic factors (climate, soil). Understanding ecosystems is important for military environmental operations and sustainability.",
  difficulty: "Easy"
},
{
  id: 792,
  subject: "General Science",
  question: "What is the function of tRNA in protein synthesis?",
  answer: "Transfer RNA (tRNA) brings amino acids to the ribosome during protein synthesis, matching them to mRNA codons through complementary anticodon base pairing. Each tRNA is specific to one amino acid. Understanding translation is essential for military molecular biology and genetic research.",
  difficulty: "Hard"
},
{
  id: 793,
  subject: "General Science",
  question: "What is energy density and its military importance?",
  answer: "Energy density is the energy content per unit mass (J/kg) of a substance. Propellants, explosives, and fuels are evaluated by energy density. High energy density fuels enable longer vehicle range and lighter loads. This is critical for military logistics and equipment performance.",
  difficulty: "Hard"
},
{
  id: 794,
  subject: "General Science",
  question: "What is the process of transcription?",
  answer: "Transcription is the process of copying DNA into RNA, performed by RNA polymerase. The enzyme reads a DNA template strand and synthesizes a complementary mRNA strand with uracil instead of thymine. Understanding transcription is essential for military molecular biology and genetic engineering.",
  difficulty: "Hard"
},
{
  id: 795,
  subject: "General Science",
  question: "What is metamorphosis in insects?",
  answer: "Metamorphosis is the transformation process where insects dramatically change form through developmental stages. Complete metamorphosis has four stages: egg, larva, pupa, adult (e.g., butterflies). Understanding insect life cycles is important for military pest control and biological research.",
  difficulty: "Easy"
},
{
  id: 796,
  subject: "General Science",
  question: "What is oxidation state and how is it determined?",
  answer: "Oxidation state is a number assigned to an element representing its electrons gained or lost in compounds. Rules: elements = 0, monatomic ions = charge, oxygen usually -2, hydrogen usually +1. Oxidation states are crucial for identifying redox reactions in military chemistry applications.",
  difficulty: "Hard"
},
{
  id: 797,
  subject: "General Science",
  question: "What is the role of neurotransmitters?",
  answer: "Neurotransmitters are chemical messengers released by neurons that transmit signals across synapses to other neurons or muscles. Different neurotransmitters (dopamine, acetylcholine, serotonin) produce different effects. Understanding neurotransmission is important for military neuroscience and pharmacology.",
  difficulty: "Medium"
},
{
  id: 798,
  subject: "General Science",
  question: "What is simple harmonic motion?",
  answer: "Simple harmonic motion is periodic motion where acceleration is proportional to displacement but opposite in direction (a = -ω²x). Examples include pendulums and mass-spring systems. Understanding SHM is important for military applications in vibration analysis and weapon systems.",
  difficulty: "Hard"
},
{
  id: 799,
  subject: "General Science",
  question: "What is the function of the urinary system?",
  answer: "The urinary system filters waste products from blood to form urine, maintaining electrolyte and fluid balance. The kidneys filter waste into the bladder for elimination. Understanding urinary function is crucial for military medical training and understanding dehydration management.",
  difficulty: "Easy"
},
{
  id: 800,
  subject: "General Science",
  question: "What is speciation and how does it relate to evolution?",
  answer: "Speciation is the evolutionary process by which new species arise from existing species. It occurs through reproductive isolation and genetic divergence over time. Understanding speciation is important for military evolutionary biology, ecology, and understanding biological diversity.",
  difficulty: "Hard"
},
{
  id: 801,
  subject: "General Science",
  question: "What is the function of white blood cells?",
  answer: "White blood cells protect against pathogens and foreign substances through phagocytosis and antibody production. Types include neutrophils, lymphocytes, and macrophages. Understanding immune cell function is essential for military medical training and immunology.",
  difficulty: "Easy"
},
{
  id: 802,
  subject: "General Science",
  question: "What is the difference between accuracy and precision?",
  answer: "Accuracy refers to how close a measurement is to the true value, while precision refers to how reproducible measurements are. A measurement can be precise but inaccurate, or accurate but imprecise. Understanding this distinction is crucial for military weapons calibration and scientific measurement.",
  difficulty: "Medium"
},
{
  id: 803,
  subject: "General Science",
  question: "What is carbon fixation and its role in photosynthesis?",
  answer: "Carbon fixation is the conversion of atmospheric CO2 into organic compounds (glucose) using ATP and NADPH from light reactions. The enzyme RuBisCO catalyzes this in the Calvin Cycle. Understanding carbon fixation is important for military agricultural science and plant biology.",
  difficulty: "Hard"
},
{
  id: 804,
  subject: "General Science",
  question: "What is the law of reflection?",
  answer: "The law of reflection states that the angle of incidence equals the angle of reflection, both measured from the normal. This principle applies to all reflecting surfaces. Understanding reflection is crucial for military optics, targeting systems, and signal communication.",
  difficulty: "Medium"
},
{
  id: 805,
  subject: "General Science",
  question: "What is meiosis and how does it differ from mitosis?",
  answer: "Meiosis is cell division producing four haploid gametes (sex cells) with half the chromosomes. Mitosis produces two diploid cells with full chromosome sets. Meiosis involves two divisions and crossing over, creating genetic variation. Understanding these processes is fundamental to military genetics and reproduction.",
  difficulty: "Hard"
},
{
  id: 806,
  subject: "General Science",
  question: "What are biomolecules and their main categories?",
  answer: "Biomolecules are organic compounds essential for life, including: carbohydrates (energy), lipids (energy/structure), proteins (structure/function), and nucleic acids (genetic info). Understanding biomolecules is fundamental for military biochemistry, nutrition, and medical applications.",
  difficulty: "Medium"
},
{
  id: 807,
  subject: "General Science",
  question: "What is refraction and what causes it?",
  answer: "Refraction is the bending of light when it passes between media with different densities. It's caused by light changing speed in different media. Snell's Law describes refraction: n1sin(θ1) = n2sin(θ2). Understanding refraction is crucial for military optics and targeting systems.",
  difficulty: "Medium"
},
{
  id: 808,
  subject: "General Science",
  question: "What is photon energy and how is it calculated?",
  answer: "Photon energy is the energy carried by a photon, calculated as E = hf or E = hc/λ, where h is Planck's constant. Energy increases with frequency. Understanding photon energy is important for military applications including lasers, radiation detection, and electromagnetic weapons.",
  difficulty: "Hard"
},
{
  id: 809,
  subject: "General Science",
  question: "What is homeostasis and why is it important?",
  answer: "Homeostasis is the body's ability to maintain stable internal conditions (temperature, pH, glucose levels) despite external changes. Negative feedback mechanisms correct deviations. Understanding homeostasis is crucial for military medical training and understanding physiological responses to stress.",
  difficulty: "Medium"
},
{
  id: 810,
  subject: "General Science",
  question: "What is the endocrine system and its primary function?",
  answer: "The endocrine system uses hormones to regulate body functions including metabolism, growth, and reproduction. Hormones are secreted by endocrine glands like the pituitary, thyroid, and adrenal glands. Understanding endocrine function is important for military medical training and understanding stress responses.",
  difficulty: "Easy"
},
{
  id: 811,
  subject: "General Science",
  question: "What is the difference between prokaryotic and eukaryotic cell structure?",
  answer: "Prokaryotic cells lack a nucleus and membrane-bound organelles (bacteria/archaea). Eukaryotic cells have a true nucleus containing DNA and numerous organelles. Prokaryotes are smaller and simpler; eukaryotes are larger and more complex. Understanding cell types is fundamental to military microbiology.",
  difficulty: "Medium"
},
{
  id: 812,
  subject: "General Science",
  question: "What is the definition of elasticity in physics?",
  answer: "Elasticity is the ability of a material to return to its original shape and size after deforming forces are removed. The elastic limit is the maximum stress before permanent deformation occurs. Understanding elasticity is crucial for military material science and equipment design.",
  difficulty: "Medium"
},
{
  id: 813,
  subject: "General Science",
  question: "What is the role of RNA polymerase?",
  answer: "RNA polymerase is the enzyme that catalyzes transcription, synthesizing RNA from a DNA template. It unwinds DNA, reads the template strand, and assembles complementary RNA nucleotides. Understanding this enzyme is essential for military molecular biology and genetic engineering.",
  difficulty: "Hard"
},
{
  id: 814,
  subject: "General Science",
  question: "What is the primary function of mitochondrial cristae?",
  answer: "Mitochondrial cristae are infoldings of the inner mitochondrial membrane that increase surface area for the electron transport chain. They contain the enzymes and electron carriers for ATP synthesis. Understanding cristae structure is important for military bioenergetics and cell biology.",
  difficulty: "Hard"
},
{
  id: 815,
  subject: "General Science",
  question: "What is a phenotype and what factors determine it?",
  answer: "Phenotype is the observable characteristics of an organism resulting from both genotype (genes) and environmental factors. The same genotype can produce different phenotypes in different environments. Understanding phenotype is important for military forensics, genetics, and biological research.",
  difficulty: "Medium"
},
{
  id: 816,
  subject: "General Science",
  question: "What is nuclear binding energy and its significance?",
  answer: "Nuclear binding energy is the energy that holds protons and neutrons together in a nucleus. It relates to nuclear stability and mass defect. Understanding binding energy is crucial for military nuclear physics, radiation effects, and nuclear weapons assessments.",
  difficulty: "Hard"
},
{
  id: 817,
  subject: "General Science",
  question: "What are alleles and how do they relate to inheritance?",
  answer: "Alleles are different versions of a gene at the same locus on homologous chromosomes. Organisms inherit one allele from each parent. Alleles may be dominant or recessive, determining phenotypic expression. Understanding alleles is fundamental for military genetics and forensic analysis.",
  difficulty: "Medium"
},
{
  id: 818,
  subject: "General Science",
  question: "What is the role of the corpus callosum in the brain?",
  answer: "The corpus callosum is the largest white matter structure in the brain, containing approximately 200 million axons connecting the left and right cerebral hemispheres. It enables interhemispheric communication. Understanding this is important for military neuroscience and brain function.",
  difficulty: "Hard"
},
{
  id: 819,
  subject: "General Science",
  question: "What is the difference between diffusion and active transport?",
  answer: "Diffusion is passive transport moving substances from high to low concentration without energy. Active transport moves substances against concentration gradients requiring ATP energy. Understanding both processes is crucial for military cellular biology and medical pharmacology.",
  difficulty: "Medium"
},
{
  id: 820,
  subject: "General Science",
  question: "What is the function of the Golgi apparatus?",
  answer: "The Golgi apparatus modifies, packages, and ships proteins and lipids produced by the ER. It processes proteins into their final forms and directs them to their destinations via vesicles. Understanding the Golgi is important for military cell biology and understanding protein synthesis.",
  difficulty: "Medium"
}
,
{
  id: 821,
  subject: "General Science",
  question: "What is the basic unit of life?",
  answer: "The cell is the basic unit of life. All living organisms are composed of one or more cells, which contain genetic material and carry out life processes.",
  difficulty: "Easy"
},
{
  id: 822,
  subject: "General Science",
  question: "Name the three main types of rocks.",
  answer: "The three main types of rocks are igneous (formed from molten magma), sedimentary (formed from compressed sediments), and metamorphic (formed from existing rocks changed by heat and pressure).",
  difficulty: "Easy"
},
{
  id: 823,
  subject: "General Science",
  question: "What is photosynthesis?",
  answer: "Photosynthesis is the process by which plants convert sunlight, water, and carbon dioxide into glucose (sugar) and oxygen. This is essential for producing energy and oxygen for life on Earth.",
  difficulty: "Easy"
},
{
  id: 824,
  subject: "General Science",
  question: "What is the pH scale used for?",
  answer: "The pH scale measures how acidic or basic a substance is, ranging from 0 (very acidic) to 14 (very basic), with 7 being neutral. This is important in chemistry, biology, and environmental science.",
  difficulty: "Easy"
},
{
  id: 825,
  subject: "General Science",
  question: "What are the four main types of tissue in animals?",
  answer: "The four main types of animal tissue are: epithelial (covers body surfaces), connective (supports other tissues), muscle (enables movement), and nervous (transmits signals). Military personnel need strong muscle tissue for physical tasks.",
  difficulty: "Easy"
},
{
  id: 826,
  subject: "General Science",
  question: "Define velocity.",
  answer: "Velocity is the rate of change of position in a specific direction. It includes both speed and direction, measured in units like meters per second (m/s). This is critical for military ballistics calculations.",
  difficulty: "Easy"
},
{
  id: 827,
  subject: "General Science",
  question: "What is the difference between velocity and speed?",
  answer: "Speed is the rate at which an object moves (scalar quantity), while velocity includes the direction of movement (vector quantity). A car going 60 mph has speed; going 60 mph north has velocity.",
  difficulty: "Easy"
},
{
  id: 828,
  subject: "General Science",
  question: "What is the periodic table?",
  answer: "The periodic table is an organized chart of all known chemical elements arranged by atomic number and properties. It shows patterns in element behavior and is fundamental to chemistry.",
  difficulty: "Easy"
},
{
  id: 829,
  subject: "General Science",
  question: "What is density?",
  answer: "Density is the mass of a substance per unit volume, calculated as mass divided by volume. It determines whether an object will float or sink in water. Important for understanding material properties.",
  difficulty: "Easy"
},
{
  id: 830,
  subject: "General Science",
  question: "What are the four states of matter?",
  answer: "The four states of matter are solid (fixed shape and volume), liquid (fixed volume but takes container shape), gas (no fixed shape or volume), and plasma (ionized gas). Understanding these is essential for chemistry.",
  difficulty: "Easy"
},
{
  id: 831,
  subject: "General Science",
  question: "What is the role of the mitochondria in cells?",
  answer: "Mitochondria are the powerhouses of cells, producing ATP (adenosine triphosphate) through cellular respiration. This provides energy for all cellular functions. Military personnel need efficient mitochondrial function for physical endurance.",
  difficulty: "Medium"
},
{
  id: 832,
  subject: "General Science",
  question: "Explain Newton's First Law of Motion.",
  answer: "Newton's First Law states that an object at rest stays at rest, and an object in motion stays in motion unless acted upon by an external force. This principle applies to military vehicles and projectiles.",
  difficulty: "Medium"
},
{
  id: 833,
  subject: "General Science",
  question: "What is the difference between prokaryotes and eukaryotes?",
  answer: "Prokaryotes (bacteria and archaea) lack a membrane-bound nucleus and organelles. Eukaryotes (animals, plants, fungi) have a nucleus and organelles. Understanding this distinction is fundamental to microbiology.",
  difficulty: "Medium"
},
{
  id: 834,
  subject: "General Science",
  question: "What is the greenhouse effect?",
  answer: "The greenhouse effect is the process where gases like CO2 trap heat in Earth's atmosphere, causing global warming. Certain gases allow sunlight to enter but prevent heat from escaping, affecting climate patterns.",
  difficulty: "Medium"
},
{
  id: 835,
  subject: "General Science",
  question: "What is the carbon cycle?",
  answer: "The carbon cycle describes how carbon moves between the atmosphere, living organisms, and Earth. Carbon is released through respiration and combustion, taken up by plants through photosynthesis. Critical for understanding climate and ecology.",
  difficulty: "Medium"
},
{
  id: 836,
  subject: "General Science",
  question: "Define acceleration.",
  answer: "Acceleration is the rate of change of velocity over time. An object accelerates when it speeds up, slows down, or changes direction. Military aircraft and vehicles require rapid acceleration capabilities.",
  difficulty: "Medium"
},
{
  id: 837,
  subject: "General Science",
  question: "What is a chemical bond?",
  answer: "A chemical bond is a force holding atoms together in molecules. Main types include ionic bonds (between charged atoms) and covalent bonds (where atoms share electrons). Understanding bonds is essential to chemistry.",
  difficulty: "Medium"
},
{
  id: 838,
  subject: "General Science",
  question: "What is the function of ribosomes?",
  answer: "Ribosomes are cellular structures that synthesize proteins by reading mRNA and translating genetic instructions. They are essential for all protein production in cells, which is vital for maintaining military personnel health.",
  difficulty: "Medium"
},
{
  id: 839,
  subject: "General Science",
  question: "Explain the water cycle.",
  answer: "The water cycle includes evaporation (water becomes vapor), condensation (vapor becomes liquid), precipitation (falls as rain/snow), and collection (gathers in bodies of water). This cycle is essential for weather patterns and water supply.",
  difficulty: "Medium"
},
{
  id: 840,
  subject: "General Science",
  question: "What is the difference between sexual and asexual reproduction?",
  answer: "Sexual reproduction involves two parents combining genetic material, creating genetic diversity. Asexual reproduction involves one parent, creating genetically identical offspring. Sexual reproduction is more common in complex organisms.",
  difficulty: "Medium"
},
{
  id: 841,
  subject: "General Science",
  question: "What is DNA and what is its function?",
  answer: "DNA (deoxyribonucleic acid) is the molecule carrying genetic instructions for life. It consists of two strands forming a double helix structure containing genes that code for proteins. DNA is essential for all living organisms.",
  difficulty: "Hard"
},
{
  id: 842,
  subject: "General Science",
  question: "Explain Newton's Second Law of Motion (F=ma).",
  answer: "Newton's Second Law states that force equals mass times acceleration (F=ma). The acceleration of an object depends on the force applied and the object's mass. This principle is critical for understanding ballistics and vehicle dynamics in military applications.",
  difficulty: "Hard"
},
{
  id: 843,
  subject: "General Science",
  question: "What is osmosis?",
  answer: "Osmosis is the movement of water across a semipermeable membrane from areas of higher water concentration to lower water concentration. This process is essential for maintaining cellular function and fluid balance in organisms.",
  difficulty: "Hard"
},
{
  id: 844,
  subject: "General Science",
  question: "Explain the concept of homeostasis.",
  answer: "Homeostasis is the process by which living organisms maintain stable internal conditions despite external changes. Examples include temperature regulation and pH balance. Military personnel must maintain homeostasis during physical exertion.",
  difficulty: "Hard"
},
{
  id: 845,
  subject: "General Science",
  question: "What is natural selection?",
  answer: "Natural selection is the mechanism of evolution where organisms with advantageous traits survive and reproduce more successfully. Over generations, beneficial traits become more common in populations. This principle shapes biological diversity.",
  difficulty: "Hard"
},
{
  id: 846,
  subject: "General Science",
  question: "What are enzymes and how do they work?",
  answer: "Enzymes are proteins that catalyze chemical reactions by lowering activation energy. They speed up reactions without being consumed. Enzymes are essential for digestion, energy production, and all metabolic processes in living organisms.",
  difficulty: "Hard"
},
{
  id: 847,
  subject: "General Science",
  question: "Explain Newton's Third Law of Motion.",
  answer: "Newton's Third Law states that for every action, there is an equal and opposite reaction. When you push against a wall, the wall pushes back equally. This principle explains recoil in firearms and propulsion in military systems.",
  difficulty: "Hard"
},
{
  id: 848,
  subject: "General Science",
  question: "What is the role of ATP in cells?",
  answer: "ATP (adenosine triphosphate) is the primary energy currency of cells. Energy stored in ATP bonds is released to power cellular processes. ATP production is essential for muscle contraction and all cellular activities in military personnel.",
  difficulty: "Hard"
},
{
  id: 849,
  subject: "General Science",
  question: "What is the difference between meiosis and mitosis?",
  answer: "Mitosis produces two identical daughter cells for growth and repair. Meiosis produces four genetically different sex cells with half the chromosomes. Understanding these processes is fundamental to genetics and reproduction.",
  difficulty: "Hard"
},
{
  id: 850,
  subject: "General Science",
  question: "Explain the concept of work in physics.",
  answer: "Work is force applied over a distance in the direction of that force, calculated as W=Fd. No work occurs if force and displacement are perpendicular. This concept is essential for understanding mechanical systems and military equipment.",
  difficulty: "Hard"
},
{
  id: 851,
  subject: "General Science",
  question: "What is the basic building block of proteins?",
  answer: "Amino acids are the basic building blocks of proteins. There are 20 common amino acids that link together in various combinations to form different proteins. Proteins are essential for all cellular functions and muscle development.",
  difficulty: "Easy"
},
{
  id: 852,
  subject: "General Science",
  question: "What is the atmosphere composed of?",
  answer: "The atmosphere is primarily composed of nitrogen (78%), oxygen (21%), and trace amounts of argon, carbon dioxide, and other gases. The atmosphere protects Earth from radiation and provides air for breathing.",
  difficulty: "Easy"
},
{
  id: 853,
  subject: "General Science",
  question: "What is the definition of an ecosystem?",
  answer: "An ecosystem is a community of living organisms interacting with their physical environment. It includes both biotic factors (living things) and abiotic factors (non-living things like temperature and soil).",
  difficulty: "Easy"
},
{
  id: 854,
  subject: "General Science",
  question: "What is the function of the ribosome?",
  answer: "The ribosome is the cellular structure responsible for protein synthesis. It reads messenger RNA and assembles amino acids into proteins according to genetic instructions from DNA.",
  difficulty: "Easy"
},
{
  id: 855,
  subject: "General Science",
  question: "What is metabolism?",
  answer: "Metabolism is the sum of all chemical reactions occurring in living cells to maintain life. It includes anabolism (building molecules) and catabolism (breaking down molecules for energy). Efficient metabolism is important for military personnel endurance.",
  difficulty: "Easy"
},
{
  id: 856,
  subject: "General Science",
  question: "What is the Mohs hardness scale?",
  answer: "The Mohs hardness scale ranks minerals from 1 (softest, talc) to 10 (hardest, diamond) based on their resistance to scratching. It's used in geology to identify minerals and materials.",
  difficulty: "Easy"
},
{
  id: 857,
  subject: "General Science",
  question: "What is the difference between kinetic and potential energy?",
  answer: "Kinetic energy is the energy of motion, while potential energy is stored energy based on position or configuration. A falling object has kinetic energy; a raised object has gravitational potential energy.",
  difficulty: "Easy"
},
{
  id: 858,
  subject: "General Science",
  question: "What are the major organs in the human body?",
  answer: "Major organs include the heart (pumps blood), lungs (enable breathing), brain (controls functions), liver (filters blood), kidneys (process waste), and stomach (aids digestion). Military personnel must maintain these organs for optimal performance.",
  difficulty: "Easy"
},
{
  id: 859,
  subject: "General Science",
  question: "What is the role of chlorophyll in plants?",
  answer: "Chlorophyll is the green pigment in plant cells that absorbs sunlight energy during photosynthesis. It captures light energy and converts it to chemical energy stored in glucose, enabling plant growth.",
  difficulty: "Easy"
},
{
  id: 860,
  subject: "General Science",
  question: "What is a mutation?",
  answer: "A mutation is a change in DNA sequence that can result from errors during replication or exposure to radiation/chemicals. Mutations can be beneficial, neutral, or harmful to organisms.",
  difficulty: "Medium"
},
{
  id: 861,
  subject: "General Science",
  question: "What is the function of the nervous system?",
  answer: "The nervous system transmits signals between the brain, spinal cord, and body through neurons. It controls sensory perception, motor response, and bodily functions. Critical for military personnel reaction time and decision-making.",
  difficulty: "Medium"
},
{
  id: 862,
  subject: "General Science",
  question: "Explain the process of diffusion.",
  answer: "Diffusion is the movement of particles from areas of high concentration to low concentration without energy expenditure. This process enables nutrient transport into cells and waste removal from cells.",
  difficulty: "Medium"
},
{
  id: 863,
  subject: "General Science",
  question: "What is the role of the liver in the human body?",
  answer: "The liver is the largest internal organ, responsible for filtering blood, producing bile for digestion, storing glucose, and detoxifying harmful substances. It's essential for maintaining health in military personnel.",
  difficulty: "Medium"
},
{
  id: 864,
  subject: "General Science",
  question: "What is the difference between weather and climate?",
  answer: "Weather refers to short-term atmospheric conditions (hours to days), while climate is the long-term average weather pattern of a region (years to decades). Climate affects military operations planning.",
  difficulty: "Medium"
},
{
  id: 865,
  subject: "General Science",
  question: "What is the rock cycle?",
  answer: "The rock cycle describes how rocks form and transform: igneous rocks form from magma, weather to sedimentary rocks, which are buried and heat-treated to form metamorphic rocks. Heat and pressure can melt rocks back to magma.",
  difficulty: "Medium"
},
{
  id: 866,
  subject: "General Science",
  question: "What is the function of the immune system?",
  answer: "The immune system protects the body from pathogens and disease. It includes white blood cells, antibodies, and lymphoid organs. A strong immune system is essential for military personnel health and readiness.",
  difficulty: "Medium"
},
{
  id: 867,
  subject: "General Science",
  question: "What is the difference between an atom and a molecule?",
  answer: "An atom is the smallest unit of an element consisting of protons, neutrons, and electrons. A molecule is formed when two or more atoms bond together. Water (H2O) is a molecule of hydrogen and oxygen atoms.",
  difficulty: "Medium"
},
{
  id: 868,
  subject: "General Science",
  question: "What is the function of red blood cells?",
  answer: "Red blood cells transport oxygen from the lungs to body tissues and return carbon dioxide to the lungs for exhalation. They contain hemoglobin protein that binds oxygen. Proper oxygen transport is critical for military physical performance.",
  difficulty: "Medium"
},
{
  id: 869,
  subject: "General Science",
  question: "What is a food chain?",
  answer: "A food chain shows the flow of energy and nutrients through an ecosystem: plants (producers) → herbivores (primary consumers) → carnivores (secondary consumers). Understanding food chains helps predict ecosystem stability.",
  difficulty: "Medium"
},
{
  id: 870,
  subject: "General Science",
  question: "What is the definition of pressure in physics?",
  answer: "Pressure is force exerted per unit area, calculated as P=F/A. It's measured in pascals (Pa) or pounds per square inch (PSI). Understanding pressure is important for hydraulic systems in military equipment.",
  difficulty: "Medium"
}
,
{
  id: 871,
  subject: "Arithmetic Reasoning",
  question: "A soldier runs 3 miles in 24 minutes. How many miles can he run in 1 hour at the same pace?",
  answer: "Step 1: Convert 1 hour to minutes: 1 hour = 60 minutes\nStep 2: Find the rate: 3 miles / 24 minutes = 0.125 miles per minute\nStep 3: Calculate distance in 60 minutes: 0.125 × 60 = 7.5 miles\nAnswer: 7.5 miles",
  difficulty: "Easy"
},
{
  id: 872,
  subject: "Arithmetic Reasoning",
  question: "A military convoy travels at 45 mph for 2.5 hours. What is the total distance covered?",
  answer: "Step 1: Use the formula: Distance = Rate × Time\nStep 2: Distance = 45 mph × 2.5 hours\nStep 3: Distance = 112.5 miles\nAnswer: 112.5 miles",
  difficulty: "Easy"
},
{
  id: 873,
  subject: "Arithmetic Reasoning",
  question: "If 20% of a soldier's paycheck is $400, what is the total paycheck?",
  answer: "Step 1: Let x = total paycheck\nStep 2: 20% of x = 400\nStep 3: 0.20x = 400\nStep 4: x = 400 / 0.20 = 2000\nAnswer: $2000",
  difficulty: "Easy"
},
{
  id: 874,
  subject: "Arithmetic Reasoning",
  question: "A training facility has a ratio of instructors to recruits of 1:8. If there are 120 recruits, how many instructors are there?",
  answer: "Step 1: Ratio is 1 instructor : 8 recruits\nStep 2: Number of instructors = 120 recruits ÷ 8 = 15\nAnswer: 15 instructors",
  difficulty: "Easy"
},
{
  id: 875,
  subject: "Arithmetic Reasoning",
  question: "A sergeant purchases 24 meal rations for the squad. If each ration costs $3.50, what is the total cost?",
  answer: "Step 1: Total cost = Number of rations × Cost per ration\nStep 2: Total cost = 24 × $3.50\nStep 3: Total cost = $84\nAnswer: $84",
  difficulty: "Easy"
},
{
  id: 876,
  subject: "Arithmetic Reasoning",
  question: "Convert 2.5 kilometers to meters.",
  answer: "Step 1: 1 kilometer = 1000 meters\nStep 2: 2.5 kilometers × 1000 = 2500 meters\nAnswer: 2500 meters",
  difficulty: "Easy"
},
{
  id: 877,
  subject: "Arithmetic Reasoning",
  question: "A military base has 800 personnel. If 15% are deployed, how many personnel remain?",
  answer: "Step 1: Personnel deployed = 15% of 800 = 0.15 × 800 = 120\nStep 2: Personnel remaining = 800 - 120 = 680\nAnswer: 680 personnel",
  difficulty: "Easy"
},
{
  id: 878,
  subject: "Arithmetic Reasoning",
  question: "If a tank travels 240 miles on 60 gallons of fuel, what is its fuel efficiency in miles per gallon?",
  answer: "Step 1: Fuel efficiency = Distance ÷ Fuel used\nStep 2: Fuel efficiency = 240 miles ÷ 60 gallons\nStep 3: Fuel efficiency = 4 miles per gallon\nAnswer: 4 mpg",
  difficulty: "Easy"
},
{
  id: 879,
  subject: "Arithmetic Reasoning",
  question: "A platoon of 36 soldiers is divided equally into 4 squads. How many soldiers are in each squad?",
  answer: "Step 1: Soldiers per squad = Total soldiers ÷ Number of squads\nStep 2: Soldiers per squad = 36 ÷ 4\nStep 3: Soldiers per squad = 9\nAnswer: 9 soldiers",
  difficulty: "Easy"
},
{
  id: 880,
  subject: "Arithmetic Reasoning",
  question: "A soldier's equipment weighs 45 pounds. How many ounces is this?",
  answer: "Step 1: 1 pound = 16 ounces\nStep 2: 45 pounds × 16 = 720 ounces\nAnswer: 720 ounces",
  difficulty: "Easy"
},
{
  id: 881,
  subject: "Arithmetic Reasoning",
  question: "A recruiting office signs up 150 new soldiers in one month. If this represents a 25% increase from the previous month, how many soldiers were recruited the previous month?",
  answer: "Step 1: Let x = soldiers recruited previous month\nStep 2: x + 0.25x = 150\nStep 3: 1.25x = 150\nStep 4: x = 150 / 1.25 = 120\nAnswer: 120 soldiers",
  difficulty: "Medium"
},
{
  id: 882,
  subject: "Arithmetic Reasoning",
  question: "A military transport plane flies at 300 mph. If it needs to reach a destination 1200 miles away, how many hours will the flight take?",
  answer: "Step 1: Time = Distance ÷ Speed\nStep 2: Time = 1200 miles ÷ 300 mph\nStep 3: Time = 4 hours\nAnswer: 4 hours",
  difficulty: "Medium"
},
{
  id: 883,
  subject: "Arithmetic Reasoning",
  question: "In a battalion of 800 soldiers, the ratio of officers to enlisted personnel is 1:7. How many officers are in the battalion?",
  answer: "Step 1: Total ratio parts = 1 + 7 = 8\nStep 2: Officers = (1/8) × 800 = 100\nAnswer: 100 officers",
  difficulty: "Medium"
},
{
  id: 884,
  subject: "Arithmetic Reasoning",
  question: "A soldier's basic salary is $1800 per month. After a 12% pay raise, what will the new salary be?",
  answer: "Step 1: Pay raise = 12% of $1800 = 0.12 × $1800 = $216\nStep 2: New salary = $1800 + $216 = $2016\nAnswer: $2016",
  difficulty: "Medium"
},
{
  id: 885,
  subject: "Arithmetic Reasoning",
  question: "A supply depot receives 5000 ammunition boxes. After distribution to three bases in the ratio 2:3:5, how many boxes does the base receiving the largest share get?",
  answer: "Step 1: Total ratio parts = 2 + 3 + 5 = 10\nStep 2: Largest share = (5/10) × 5000 = 2500\nAnswer: 2500 boxes",
  difficulty: "Medium"
},
{
  id: 886,
  subject: "Arithmetic Reasoning",
  question: "A jeep uses 15 gallons of fuel to travel 225 miles. How many gallons will it use to travel 600 miles at the same rate?",
  answer: "Step 1: Fuel efficiency = 225 miles ÷ 15 gallons = 15 miles per gallon\nStep 2: Gallons needed = 600 miles ÷ 15 miles per gallon = 40 gallons\nAnswer: 40 gallons",
  difficulty: "Medium"
},
{
  id: 887,
  subject: "Arithmetic Reasoning",
  question: "A military training program costs $500 per soldier. If 120 soldiers complete the program and the total cost is split equally among 3 bases, how much does each base pay?",
  answer: "Step 1: Total program cost = 120 × $500 = $60,000\nStep 2: Cost per base = $60,000 ÷ 3 = $20,000\nAnswer: $20,000",
  difficulty: "Medium"
},
{
  id: 888,
  subject: "Arithmetic Reasoning",
  question: "Convert 18 feet to yards.",
  answer: "Step 1: 1 yard = 3 feet\nStep 2: 18 feet ÷ 3 = 6 yards\nAnswer: 6 yards",
  difficulty: "Easy"
},
{
  id: 889,
  subject: "Arithmetic Reasoning",
  question: "A soldier completes 40% of a mission in 8 hours. At the same rate, how many total hours will the mission take?",
  answer: "Step 1: If 40% takes 8 hours, then 100% takes x hours\nStep 2: 0.40x = (100/40) × 8 = 20 hours\nAnswer: 20 hours",
  difficulty: "Medium"
},
{
  id: 890,
  subject: "Arithmetic Reasoning",
  question: "A barracks has 480 beds. If 60% are occupied, how many beds are empty?",
  answer: "Step 1: Occupied beds = 60% of 480 = 0.60 × 480 = 288\nStep 2: Empty beds = 480 - 288 = 192\nAnswer: 192 beds",
  difficulty: "Easy"
},
{
  id: 891,
  subject: "Arithmetic Reasoning",
  question: "A helicopter flies 200 miles in 40 minutes. What is its speed in miles per hour?",
  answer: "Step 1: Convert 40 minutes to hours: 40 ÷ 60 = 2/3 hour\nStep 2: Speed = Distance ÷ Time = 200 ÷ (2/3) = 200 × (3/2) = 300 mph\nAnswer: 300 mph",
  difficulty: "Medium"
},
{
  id: 892,
  subject: "Arithmetic Reasoning",
  question: "In a military unit, 35 out of 175 soldiers have specialized training. What percentage have specialized training?",
  answer: "Step 1: Percentage = (35 ÷ 175) × 100%\nStep 2: Percentage = 0.20 × 100% = 20%\nAnswer: 20%",
  difficulty: "Medium"
},
{
  id: 893,
  subject: "Arithmetic Reasoning",
  question: "A supply truck carries 2400 pounds of equipment. How many tons is this?",
  answer: "Step 1: 1 ton = 2000 pounds\nStep 2: 2400 ÷ 2000 = 1.2 tons\nAnswer: 1.2 tons",
  difficulty: "Easy"
},
{
  id: 894,
  subject: "Arithmetic Reasoning",
  question: "A soldier's training score improved from 72 to 90. What was the percent increase?",
  answer: "Step 1: Increase = 90 - 72 = 18\nStep 2: Percent increase = (18 ÷ 72) × 100% = 0.25 × 100% = 25%\nAnswer: 25%",
  difficulty: "Medium"
},
{
  id: 895,
  subject: "Arithmetic Reasoning",
  question: "A military canteen sells 240 meals per day. How many meals are sold in 30 days?",
  answer: "Step 1: Total meals = Daily meals × Number of days\nStep 2: Total meals = 240 × 30 = 7200\nAnswer: 7200 meals",
  difficulty: "Easy"
},
{
  id: 896,
  subject: "Arithmetic Reasoning",
  question: "A base requires a 3:2 ratio of personnel to vehicles. If there are 450 personnel, how many vehicles are needed?",
  answer: "Step 1: 3 personnel : 2 vehicles\nStep 2: 450 personnel ÷ 3 = 150 (ratio units)\nStep 3: 150 × 2 = 300 vehicles\nAnswer: 300 vehicles",
  difficulty: "Medium"
},
{
  id: 897,
  subject: "Arithmetic Reasoning",
  question: "Convert 3.5 hours to minutes.",
  answer: "Step 1: 1 hour = 60 minutes\nStep 2: 3.5 × 60 = 210 minutes\nAnswer: 210 minutes",
  difficulty: "Easy"
},
{
  id: 898,
  subject: "Arithmetic Reasoning",
  question: "A soldier earns $30,000 annually. What is the monthly salary?",
  answer: "Step 1: Monthly salary = Annual salary ÷ 12 months\nStep 2: Monthly salary = $30,000 ÷ 12 = $2500\nAnswer: $2500",
  difficulty: "Easy"
},
{
  id: 899,
  subject: "Arithmetic Reasoning",
  question: "A military exercise involves 600 soldiers. If they are divided into teams with 15 soldiers each, how many teams are formed?",
  answer: "Step 1: Number of teams = Total soldiers ÷ Soldiers per team\nStep 2: Number of teams = 600 ÷ 15 = 40\nAnswer: 40 teams",
  difficulty: "Easy"
},
{
  id: 900,
  subject: "Arithmetic Reasoning",
  question: "A jeep's fuel tank holds 18 gallons and provides 360 miles of travel. A truck's tank holds 30 gallons. If the truck has the same fuel efficiency as the jeep, how many miles can the truck travel on a full tank?",
  answer: "Step 1: Jeep's efficiency = 360 miles ÷ 18 gallons = 20 miles per gallon\nStep 2: Truck's range = 30 gallons × 20 miles per gallon = 600 miles\nAnswer: 600 miles",
  difficulty: "Medium"
},
{
  id: 901,
  subject: "Arithmetic Reasoning",
  question: "A barracks has 180 soldiers. If 1/4 are on leave, how many are present?",
  answer: "Step 1: Soldiers on leave = 1/4 × 180 = 45\nStep 2: Soldiers present = 180 - 45 = 135\nAnswer: 135 soldiers",
  difficulty: "Easy"
},
{
  id: 902,
  subject: "Arithmetic Reasoning",
  question: "An ammunition depot has 50,000 rounds. After 3 days of use, 35% has been distributed. How many rounds remain?",
  answer: "Step 1: Rounds distributed = 35% of 50,000 = 0.35 × 50,000 = 17,500\nStep 2: Rounds remaining = 50,000 - 17,500 = 32,500\nAnswer: 32,500 rounds",
  difficulty: "Medium"
},
{
  id: 903,
  subject: "Arithmetic Reasoning",
  question: "A soldier marches 15 miles in 5 hours. What is the average speed in miles per hour?",
  answer: "Step 1: Average speed = Distance ÷ Time\nStep 2: Average speed = 15 miles ÷ 5 hours = 3 mph\nAnswer: 3 mph",
  difficulty: "Easy"
},
{
  id: 904,
  subject: "Arithmetic Reasoning",
  question: "Convert 2500 meters to kilometers.",
  answer: "Step 1: 1 kilometer = 1000 meters\nStep 2: 2500 ÷ 1000 = 2.5 kilometers\nAnswer: 2.5 kilometers",
  difficulty: "Easy"
},
{
  id: 905,
  subject: "Arithmetic Reasoning",
  question: "A military base budget is $5 million. If 40% goes to personnel, 30% to operations, and the remainder to equipment, how much is allocated for equipment?",
  answer: "Step 1: Personnel = 40% of $5M = $2M\nStep 2: Operations = 30% of $5M = $1.5M\nStep 3: Equipment = 100% - 40% - 30% = 30% of $5M = $1.5M\nAnswer: $1.5 million",
  difficulty: "Medium"
},
{
  id: 906,
  subject: "Arithmetic Reasoning",
  question: "A training course has 80 participants. If 90% pass the exam, how many pass?",
  answer: "Step 1: Number passing = 90% of 80 = 0.90 × 80 = 72\nAnswer: 72 participants",
  difficulty: "Easy"
},
{
  id: 907,
  subject: "Arithmetic Reasoning",
  question: "A supply ship carries 360 tons of cargo. If it delivers 1/3 to the first port and 1/4 to the second port, how much cargo remains?",
  answer: "Step 1: First port = 1/3 × 360 = 120 tons\nStep 2: Second port = 1/4 × 360 = 90 tons\nStep 3: Delivered total = 120 + 90 = 210 tons\nStep 4: Remaining = 360 - 210 = 150 tons\nAnswer: 150 tons",
  difficulty: "Medium"
},
{
  id: 908,
  subject: "Arithmetic Reasoning",
  question: "A soldier weighs 180 pounds. How many kilograms is this? (1 pound = 0.454 kg)",
  answer: "Step 1: Weight in kg = 180 pounds × 0.454 kg/pound\nStep 2: Weight in kg = 81.72 kg\nAnswer: 81.72 kg",
  difficulty: "Medium"
},
{
  id: 909,
  subject: "Arithmetic Reasoning",
  question: "A platoon sergeant orders 144 meals for 36 soldiers. How many meals per soldier?",
  answer: "Step 1: Meals per soldier = Total meals ÷ Number of soldiers\nStep 2: Meals per soldier = 144 ÷ 36 = 4\nAnswer: 4 meals per soldier",
  difficulty: "Easy"
},
{
  id: 910,
  subject: "Arithmetic Reasoning",
  question: "A military vehicle cost $45,000 two years ago. If it has depreciated by 20%, what is its current value?",
  answer: "Step 1: Depreciation = 20% of $45,000 = 0.20 × $45,000 = $9,000\nStep 2: Current value = $45,000 - $9,000 = $36,000\nAnswer: $36,000",
  difficulty: "Medium"
},
{
  id: 911,
  subject: "Arithmetic Reasoning",
  question: "Convert 2 miles to kilometers. (1 mile = 1.609 km)",
  answer: "Step 1: Distance in km = 2 miles × 1.609 km/mile\nStep 2: Distance in km = 3.218 km\nAnswer: 3.218 km",
  difficulty: "Medium"
},
{
  id: 912,
  subject: "Arithmetic Reasoning",
  question: "A soldier's combat gear includes items weighing: rifle 8.5 lbs, vest 7.2 lbs, helmet 3.5 lbs, boots 4 lbs, and pack 12 lbs. What is the total weight?",
  answer: "Step 1: Total weight = 8.5 + 7.2 + 3.5 + 4 + 12\nStep 2: Total weight = 35.2 pounds\nAnswer: 35.2 pounds",
  difficulty: "Easy"
},
{
  id: 913,
  subject: "Arithmetic Reasoning",
  question: "A base has 1200 soldiers. The ratio of combat to support personnel is 2:1. How many combat personnel are there?",
  answer: "Step 1: Total ratio parts = 2 + 1 = 3\nStep 2: Combat personnel = (2/3) × 1200 = 800\nAnswer: 800 combat personnel",
  difficulty: "Medium"
},
{
  id: 914,
  subject: "Arithmetic Reasoning",
  question: "A helicopter needs to travel 480 miles. If it can fly at 120 mph, how long will the flight take?",
  answer: "Step 1: Time = Distance ÷ Speed\nStep 2: Time = 480 miles ÷ 120 mph = 4 hours\nAnswer: 4 hours",
  difficulty: "Easy"
},
{
  id: 915,
  subject: "Arithmetic Reasoning",
  question: "A recruiter's quota is 200 new soldiers per year. After 8 months, 140 have signed up. If the rate continues, how many will be recruited by year-end?",
  answer: "Step 1: Rate = 140 soldiers ÷ 8 months = 17.5 soldiers per month\nStep 2: Remaining months = 12 - 8 = 4 months\nStep 3: Additional soldiers = 17.5 × 4 = 70\nStep 4: Total = 140 + 70 = 210\nAnswer: 210 soldiers",
  difficulty: "Hard"
},
{
  id: 916,
  subject: "Arithmetic Reasoning",
  question: "A compound interest problem: A soldier invests $2000 in a military savings account at 5% annual interest. What is the balance after 2 years?",
  answer: "Step 1: Amount = Principal × (1 + rate)^time\nStep 2: Amount = $2000 × (1.05)^2\nStep 3: Amount = $2000 × 1.1025 = $2205\nAnswer: $2205",
  difficulty: "Hard"
},
{
  id: 917,
  subject: "Arithmetic Reasoning",
  question: "A military convoy includes 45 vehicles. If 20% are motorcycles, 35% are trucks, and the rest are jeeps, how many jeeps are in the convoy?",
  answer: "Step 1: Motorcycles = 20% of 45 = 9\nStep 2: Trucks = 35% of 45 = 15.75 ≈ 16\nStep 3: Jeeps = 45 - 9 - 16 = 20\nAnswer: 20 jeeps",
  difficulty: "Medium"
},
{
  id: 918,
  subject: "Arithmetic Reasoning",
  question: "A base receives a shipment of 500 meal rations. The cook uses 75 per day. After 4 days, how many remain?",
  answer: "Step 1: Rations used = 75 × 4 = 300\nStep 2: Rations remaining = 500 - 300 = 200\nAnswer: 200 rations",
  difficulty: "Easy"
},
{
  id: 919,
  subject: "Arithmetic Reasoning",
  question: "A military base is expanding. The current capacity is 2000 soldiers. The expansion will increase it by 30%. What will the new capacity be?",
  answer: "Step 1: Increase = 30% of 2000 = 0.30 × 2000 = 600\nStep 2: New capacity = 2000 + 600 = 2600\nAnswer: 2600 soldiers",
  difficulty: "Easy"
},
{
  id: 920,
  subject: "Arithmetic Reasoning",
  question: "A soldier's test scores are 85, 92, 78, and 88. What is the average score?",
  answer: "Step 1: Sum of scores = 85 + 92 + 78 + 88 = 343\nStep 2: Average = 343 ÷ 4 = 85.75\nAnswer: 85.75",
  difficulty: "Easy"
},
{
  id: 921,
  subject: "Arithmetic Reasoning",
  question: "A training facility operates 16 hours per day. How many hours does it operate in a week?",
  answer: "Step 1: Hours per week = 16 hours/day × 7 days = 112 hours\nAnswer: 112 hours",
  difficulty: "Easy"
},
{
  id: 922,
  subject: "Arithmetic Reasoning",
  question: "An officer's annual salary is $48,000. A junior enlisted soldier's salary is $24,000. What is the ratio of officer to soldier salary?",
  answer: "Step 1: Ratio = $48,000 : $24,000\nStep 2: Simplify by dividing both by $24,000: 2 : 1\nAnswer: 2:1",
  difficulty: "Medium"
},
{
  id: 923,
  subject: "Arithmetic Reasoning",
  question: "A base orders 600 uniforms. If 2/5 are for new recruits and the rest for veterans, how many are for veterans?",
  answer: "Step 1: Uniforms for recruits = 2/5 × 600 = 240\nStep 2: Uniforms for veterans = 600 - 240 = 360\nAnswer: 360 uniforms",
  difficulty: "Easy"
},
{
  id: 924,
  subject: "Arithmetic Reasoning",
  question: "A soldier's training program lasts 12 weeks. If she has completed 9 weeks, what percentage is complete?",
  answer: "Step 1: Percentage complete = (9 ÷ 12) × 100%\nStep 2: Percentage complete = 0.75 × 100% = 75%\nAnswer: 75%",
  difficulty: "Medium"
},
{
  id: 925,
  subject: "Arithmetic Reasoning",
  question: "A tactical exercise covers an area of 120 square kilometers. If the area is divided into 5 equal zones, what is the size of each zone?",
  answer: "Step 1: Size per zone = 120 square km ÷ 5\nStep 2: Size per zone = 24 square km\nAnswer: 24 square kilometers",
  difficulty: "Easy"
},
{
  id: 926,
  subject: "Arithmetic Reasoning",
  question: "A military truck travels 280 miles and uses 35 gallons of fuel. How many miles per gallon does it get?",
  answer: "Step 1: MPG = 280 miles ÷ 35 gallons\nStep 2: MPG = 8\nAnswer: 8 mpg",
  difficulty: "Easy"
},
{
  id: 927,
  subject: "Arithmetic Reasoning",
  question: "A supply depot has 720 boxes of ammunition. It distributes them equally to 8 armories. How many boxes does each armory receive?",
  answer: "Step 1: Boxes per armory = 720 ÷ 8 = 90\nAnswer: 90 boxes",
  difficulty: "Easy"
},
{
  id: 928,
  subject: "Arithmetic Reasoning",
  question: "A base cafeteria sells coffee at $2.50 per cup. On Monday, they sold 280 cups. What were the sales?",
  answer: "Step 1: Sales = Number of cups × Price per cup\nStep 2: Sales = 280 × $2.50 = $700\nAnswer: $700",
  difficulty: "Easy"
},
{
  id: 929,
  subject: "Arithmetic Reasoning",
  question: "A soldier's weight increased from 175 pounds to 185 pounds. What is the percent increase?",
  answer: "Step 1: Increase = 185 - 175 = 10 pounds\nStep 2: Percent increase = (10 ÷ 175) × 100% = 5.71%\nAnswer: 5.71%",
  difficulty: "Medium"
},
{
  id: 930,
  subject: "Arithmetic Reasoning",
  question: "Convert 5 hours and 30 minutes to minutes.",
  answer: "Step 1: 5 hours = 5 × 60 = 300 minutes\nStep 2: Total = 300 + 30 = 330 minutes\nAnswer: 330 minutes",
  difficulty: "Easy"
},
{
  id: 931,
  subject: "Arithmetic Reasoning",
  question: "A military equipment purchase order totals $15,000. If a 10% discount is applied, what is the final cost?",
  answer: "Step 1: Discount = 10% of $15,000 = 0.10 × $15,000 = $1,500\nStep 2: Final cost = $15,000 - $1,500 = $13,500\nAnswer: $13,500",
  difficulty: "Medium"
},
{
  id: 932,
  subject: "Arithmetic Reasoning",
  question: "A soldier completes a 10-mile run in 80 minutes. What is the average pace in minutes per mile?",
  answer: "Step 1: Pace = Total time ÷ Total distance\nStep 2: Pace = 80 minutes ÷ 10 miles = 8 minutes per mile\nAnswer: 8 minutes per mile",
  difficulty: "Medium"
},
{
  id: 933,
  subject: "Arithmetic Reasoning",
  question: "A base has 360 parking spaces. If 75% are occupied, how many spaces are empty?",
  answer: "Step 1: Occupied spaces = 75% of 360 = 0.75 × 360 = 270\nStep 2: Empty spaces = 360 - 270 = 90\nAnswer: 90 spaces",
  difficulty: "Easy"
},
{
  id: 934,
  subject: "Arithmetic Reasoning",
  question: "A military academy has 400 students. If the freshman class makes up 25% of the total, how many freshmen are there?",
  answer: "Step 1: Number of freshmen = 25% of 400 = 0.25 × 400 = 100\nAnswer: 100 freshmen",
  difficulty: "Easy"
},
{
  id: 935,
  subject: "Arithmetic Reasoning",
  question: "A soldier's backpack weighs 65 pounds. After removing items, it now weighs 52 pounds. What percentage of the weight was removed?",
  answer: "Step 1: Weight removed = 65 - 52 = 13 pounds\nStep 2: Percentage removed = (13 ÷ 65) × 100% = 20%\nAnswer: 20%",
  difficulty: "Medium"
},
{
  id: 936,
  subject: "Arithmetic Reasoning",
  question: "A convoy of 12 trucks must travel 360 miles. If each truck can go 60 miles on a full tank, how many full tanks will each truck need?",
  answer: "Step 1: Tanks needed per truck = 360 miles ÷ 60 miles per tank\nStep 2: Tanks needed per truck = 6\nAnswer: 6 tanks",
  difficulty: "Easy"
},
{
  id: 937,
  subject: "Arithmetic Reasoning",
  question: "A military hospital has 200 beds. If 85% are occupied, how many patients are in the hospital?",
  answer: "Step 1: Occupied beds = 85% of 200 = 0.85 × 200 = 170\nAnswer: 170 patients",
  difficulty: "Easy"
},
{
  id: 938,
  subject: "Arithmetic Reasoning",
  question: "A soldier received a bonus of $500. This represents 5% of her annual salary. What is her annual salary?",
  answer: "Step 1: Let x = annual salary\nStep 2: 5% of x = $500\nStep 3: 0.05x = $500\nStep 4: x = $500 ÷ 0.05 = $10,000\nAnswer: $10,000",
  difficulty: "Medium"
},
{
  id: 939,
  subject: "Arithmetic Reasoning",
  question: "Convert 1.5 gallons to pints. (1 gallon = 8 pints)",
  answer: "Step 1: Pints = 1.5 gallons × 8 pints/gallon\nStep 2: Pints = 12\nAnswer: 12 pints",
  difficulty: "Easy"
},
{
  id: 940,
  subject: "Arithmetic Reasoning",
  question: "A base recreation center has 450 members. If 40% are officers and 60% are enlisted, how many more enlisted members than officers are there?",
  answer: "Step 1: Officers = 40% of 450 = 180\nStep 2: Enlisted = 60% of 450 = 270\nStep 3: Difference = 270 - 180 = 90\nAnswer: 90 more enlisted members",
  difficulty: "Medium"
},
{
  id: 941,
  subject: "Arithmetic Reasoning",
  question: "A training mission covers 2400 kilometers. If the unit travels at 120 km/h, how many hours will the mission take?",
  answer: "Step 1: Time = Distance ÷ Speed\nStep 2: Time = 2400 km ÷ 120 km/h = 20 hours\nAnswer: 20 hours",
  difficulty: "Medium"
},
{
  id: 942,
  subject: "Arithmetic Reasoning",
  question: "A military band has 80 members. If 35% play brass instruments, how many play brass?",
  answer: "Step 1: Brass players = 35% of 80 = 0.35 × 80 = 28\nAnswer: 28 members",
  difficulty: "Easy"
},
{
  id: 943,
  subject: "Arithmetic Reasoning",
  question: "A soldier's physical fitness test includes a 2-mile run. If she completes it in 16 minutes, what is her average speed in miles per hour?",
  answer: "Step 1: Convert time to hours: 16 minutes ÷ 60 = 0.267 hours\nStep 2: Speed = 2 miles ÷ 0.267 hours = 7.5 mph\nAnswer: 7.5 mph",
  difficulty: "Hard"
},
{
  id: 944,
  subject: "Arithmetic Reasoning",
  question: "A military shipment includes 1500 items. After 3 shipments of 250 items each are delivered, how many remain?",
  answer: "Step 1: Items delivered = 3 × 250 = 750\nStep 2: Items remaining = 1500 - 750 = 750\nAnswer: 750 items",
  difficulty: "Easy"
},
{
  id: 945,
  subject: "Arithmetic Reasoning",
  question: "A base's monthly utility bill is $12,000. If this is split equally among 5 departments, how much does each department pay?",
  answer: "Step 1: Cost per department = $12,000 ÷ 5 = $2,400\nAnswer: $2,400",
  difficulty: "Easy"
},
{
  id: 946,
  subject: "Arithmetic Reasoning",
  question: "A soldier's rent is $900 per month and represents 30% of her salary. What is her monthly salary?",
  answer: "Step 1: Let x = monthly salary\nStep 2: 30% of x = $900\nStep 3: 0.30x = $900\nStep 4: x = $900 ÷ 0.30 = $3,000\nAnswer: $3,000",
  difficulty: "Medium"
},
{
  id: 947,
  subject: "Arithmetic Reasoning",
  question: "Convert 96 ounces to pounds.",
  answer: "Step 1: 1 pound = 16 ounces\nStep 2: 96 ounces ÷ 16 = 6 pounds\nAnswer: 6 pounds",
  difficulty: "Easy"
},
{
  id: 948,
  subject: "Arithmetic Reasoning",
  question: "A training exercise takes place over 3 days. On day 1, 120 soldiers participate. On day 2, 150 participate. On day 3, 140 participate. What is the average daily participation?",
  answer: "Step 1: Total participation = 120 + 150 + 140 = 410\nStep 2: Average per day = 410 ÷ 3 = 136.67\nAnswer: 136.67 soldiers per day",
  difficulty: "Easy"
},
{
  id: 949,
  subject: "Arithmetic Reasoning",
  question: "A military vehicle's tank capacity is 25 gallons. It consumes 6.25 gallons per hour. How many hours of operation does a full tank provide?",
  answer: "Step 1: Hours of operation = Tank capacity ÷ Consumption rate\nStep 2: Hours of operation = 25 ÷ 6.25 = 4 hours\nAnswer: 4 hours",
  difficulty: "Medium"
},
{
  id: 950,
  subject: "Arithmetic Reasoning",
  question: "A recruitment drive targets 500 volunteers. After 2 weeks, 125 have signed up. If the rate continues, how many total will sign up in 8 weeks?",
  answer: "Step 1: Rate = 125 ÷ 2 = 62.5 per week\nStep 2: Total in 8 weeks = 62.5 × 8 = 500\nAnswer: 500 volunteers",
  difficulty: "Hard"
},
{
  id: 951,
  subject: "Arithmetic Reasoning",
  question: "A barracks contains 240 rooms. If 10% are administrative offices, 20% are storage, and the rest are living quarters, how many living quarters are there?",
  answer: "Step 1: Administrative = 10% of 240 = 24\nStep 2: Storage = 20% of 240 = 48\nStep 3: Living quarters = 240 - 24 - 48 = 168\nAnswer: 168 living quarters",
  difficulty: "Medium"
},
{
  id: 952,
  subject: "Arithmetic Reasoning",
  question: "A soldier's test score increased by 15 points, from 75 to 90. What is the percent increase?",
  answer: "Step 1: Increase = 90 - 75 = 15\nStep 2: Percent increase = (15 ÷ 75) × 100% = 20%\nAnswer: 20%",
  difficulty: "Medium"
},
{
  id: 953,
  subject: "Arithmetic Reasoning",
  question: "A supply truck carries 2 tons of cargo. How many pounds is this?",
  answer: "Step 1: 1 ton = 2000 pounds\nStep 2: 2 tons × 2000 = 4000 pounds\nAnswer: 4000 pounds",
  difficulty: "Easy"
},
{
  id: 954,
  subject: "Arithmetic Reasoning",
  question: "A military academy has 960 students. They are divided into 8 companies. How many students are in each company?",
  answer: "Step 1: Students per company = 960 ÷ 8 = 120\nAnswer: 120 students",
  difficulty: "Easy"
},
{
  id: 955,
  subject: "Arithmetic Reasoning",
  question: "A soldier's rations cost $3.75 each. The unit orders 240 rations. What is the total cost?",
  answer: "Step 1: Total cost = 240 × $3.75\nStep 2: Total cost = $900\nAnswer: $900",
  difficulty: "Easy"
},
{
  id: 956,
  subject: "Arithmetic Reasoning",
  question: "A base has a monthly maintenance budget of $80,000. If 35% goes to vehicle maintenance and 25% to facility maintenance, how much is left for other maintenance?",
  answer: "Step 1: Vehicle maintenance = 35% of $80,000 = $28,000\nStep 2: Facility maintenance = 25% of $80,000 = $20,000\nStep 3: Other = 100% - 35% - 25% = 40% of $80,000 = $32,000\nAnswer: $32,000",
  difficulty: "Medium"
},
{
  id: 957,
  subject: "Arithmetic Reasoning",
  question: "A soldier runs a 5K (5 kilometers) in 25 minutes. What is the average speed in kilometers per hour?",
  answer: "Step 1: Convert 25 minutes to hours: 25 ÷ 60 = 0.417 hours\nStep 2: Speed = 5 km ÷ 0.417 hours = 12 km/h\nAnswer: 12 km/h",
  difficulty: "Hard"
},
{
  id: 958,
  subject: "Arithmetic Reasoning",
  question: "A training program has 150 participants. If 60% complete the program successfully, how many pass?",
  answer: "Step 1: Participants passing = 60% of 150 = 0.60 × 150 = 90\nAnswer: 90 participants",
  difficulty: "Easy"
},
{
  id: 959,
  subject: "Arithmetic Reasoning",
  question: "A military supply order totals $5,600. If the supplier offers a 15% discount for bulk orders, what is the discounted price?",
  answer: "Step 1: Discount = 15% of $5,600 = 0.15 × $5,600 = $840\nStep 2: Discounted price = $5,600 - $840 = $4,760\nAnswer: $4,760",
  difficulty: "Medium"
},
{
  id: 960,
  subject: "Arithmetic Reasoning",
  question: "A base recreation area has 600 square meters. How many square kilometers is this?",
  answer: "Step 1: 1 square kilometer = 1,000,000 square meters\nStep 2: 600 ÷ 1,000,000 = 0.0006 square kilometers\nAnswer: 0.0006 square kilometers",
  difficulty: "Hard"
},
{
  id: 961,
  subject: "Arithmetic Reasoning",
  question: "A soldier scores 88 on a first exam and 94 on a second exam. What is the average?",
  answer: "Step 1: Average = (88 + 94) ÷ 2\nStep 2: Average = 182 ÷ 2 = 91\nAnswer: 91",
  difficulty: "Easy"
},
{
  id: 962,
  subject: "Arithmetic Reasoning",
  question: "A military convoy has 15 vehicles. Each vehicle carries 480 pounds of supplies. What is the total weight carried?",
  answer: "Step 1: Total weight = 15 vehicles × 480 pounds/vehicle\nStep 2: Total weight = 7,200 pounds\nAnswer: 7,200 pounds",
  difficulty: "Easy"
},
{
  id: 963,
  subject: "Arithmetic Reasoning",
  question: "A base operates 18 hours per day. How many hours does it operate in 365 days?",
  answer: "Step 1: Total hours = 18 hours/day × 365 days\nStep 2: Total hours = 6,570 hours\nAnswer: 6,570 hours",
  difficulty: "Easy"
},
{
  id: 964,
  subject: "Arithmetic Reasoning",
  question: "A soldier's equipment includes items costing $120, $85, $65, and $50. What is the total cost?",
  answer: "Step 1: Total = $120 + $85 + $65 + $50\nStep 2: Total = $320\nAnswer: $320",
  difficulty: "Easy"
},
{
  id: 965,
  subject: "Arithmetic Reasoning",
  question: "A military base has 2800 personnel. If 15% are female, how many female personnel are there?",
  answer: "Step 1: Female personnel = 15% of 2800 = 0.15 × 2800 = 420\nAnswer: 420 female personnel",
  difficulty: "Easy"
},
{
  id: 966,
  subject: "Arithmetic Reasoning",
  question: "A helicopter transport mission requires 4 trips to move 800 soldiers. How many soldiers per trip?",
  answer: "Step 1: Soldiers per trip = 800 ÷ 4 = 200\nAnswer: 200 soldiers",
  difficulty: "Easy"
},
{
  id: 967,
  subject: "Arithmetic Reasoning",
  question: "A soldier's pay increased from $1,800 to $2,000 per month. What is the percent increase?",
  answer: "Step 1: Increase = $2,000 - $1,800 = $200\nStep 2: Percent increase = ($200 ÷ $1,800) × 100% = 11.11%\nAnswer: 11.11%",
  difficulty: "Medium"
},
{
  id: 968,
  subject: "Arithmetic Reasoning",
  question: "A training facility has 360 training hours available. If 120 hours are used for basic training, 140 hours for advanced training, how many hours remain for specialized training?",
  answer: "Step 1: Hours used = 120 + 140 = 260\nStep 2: Hours remaining = 360 - 260 = 100\nAnswer: 100 hours",
  difficulty: "Easy"
},
{
  id: 969,
  subject: "Arithmetic Reasoning",
  question: "A soldier's monthly expenses are: housing $1000, food $400, utilities $150, and transportation $200. What is the total monthly expense?",
  answer: "Step 1: Total = $1000 + $400 + $150 + $200\nStep 2: Total = $1750\nAnswer: $1750",
  difficulty: "Easy"
},
{
  id: 970,
  subject: "Arithmetic Reasoning",
  question: "A military supply depot must fulfill an order of 5000 meals. If they prepare 800 meals per day, in how many days will the order be completed?",
  answer: "Step 1: Days needed = Total meals ÷ Meals per day\nStep 2: Days needed = 5000 ÷ 800 = 6.25 days\nAnswer: 6.25 days (or 6 days and 6 hours)",
  difficulty: "Medium"
}
,
{
  id: 971,
  subject: "Arithmetic Reasoning",
  question: "A military truck travels 240 miles in 4 hours. What is the truck's average speed in miles per hour?",
  answer: "Step 1: Use the formula: Speed = Distance ÷ Time\nStep 2: Speed = 240 miles ÷ 4 hours\nStep 3: Speed = 60 miles per hour\n\nAnswer: 60 mph",
  difficulty: "Easy"
},
{
  id: 972,
  subject: "Arithmetic Reasoning",
  question: "A soldier's base salary is $2,400 per month. If he receives a 15% raise, what is his new monthly salary?",
  answer: "Step 1: Calculate 15% of $2,400\nStep 2: 0.15 × $2,400 = $360\nStep 3: New salary = $2,400 + $360 = $2,760\n\nAnswer: $2,760 per month",
  difficulty: "Easy"
},
{
  id: 973,
  subject: "Arithmetic Reasoning",
  question: "A military barracks can accommodate 240 soldiers. If the current occupancy is 180 soldiers, what percentage of the barracks is currently occupied?",
  answer: "Step 1: Use the formula: Percentage = (Part ÷ Whole) × 100\nStep 2: Percentage = (180 ÷ 240) × 100\nStep 3: Percentage = 0.75 × 100 = 75%\n\nAnswer: 75% occupied",
  difficulty: "Easy"
},
{
  id: 974,
  subject: "Arithmetic Reasoning",
  question: "A training exercise requires 5 gallons of fuel per 50 miles. How many gallons are needed for a 300-mile mission?",
  answer: "Step 1: Set up a proportion: 5 gallons / 50 miles = x gallons / 300 miles\nStep 2: Cross multiply: 5 × 300 = 50 × x\nStep 3: 1,500 = 50x\nStep 4: x = 1,500 ÷ 50 = 30 gallons\n\nAnswer: 30 gallons",
  difficulty: "Easy"
},
{
  id: 975,
  subject: "Arithmetic Reasoning",
  question: "A supply depot has 480 boxes of ammunition. If distributed equally among 12 platoons, how many boxes does each platoon receive?",
  answer: "Step 1: Divide total boxes by number of platoons\nStep 2: 480 boxes ÷ 12 platoons\nStep 3: = 40 boxes per platoon\n\nAnswer: 40 boxes per platoon",
  difficulty: "Easy"
},
{
  id: 976,
  subject: "Arithmetic Reasoning",
  question: "A soldier runs 2 miles in 16 minutes. At this rate, how many miles can he run in 40 minutes?",
  answer: "Step 1: Calculate running speed: 2 miles ÷ 16 minutes = 0.125 miles per minute\nStep 2: Distance in 40 minutes: 0.125 × 40 = 5 miles\n\nAlternatively: Set up proportion: 2/16 = x/40\nStep 3: 16x = 80\nStep 4: x = 5 miles\n\nAnswer: 5 miles",
  difficulty: "Easy"
},
{
  id: 977,
  subject: "Arithmetic Reasoning",
  question: "A helicopter costs $850,000. If the military budget covers 60% of this cost, how much does the budget cover?",
  answer: "Step 1: Calculate 60% of $850,000\nStep 2: 0.60 × $850,000 = $510,000\n\nAnswer: $510,000",
  difficulty: "Easy"
},
{
  id: 978,
  subject: "Arithmetic Reasoning",
  question: "A military vehicle's fuel tank holds 45 gallons. If it currently has 18 gallons, what percentage of the tank is empty?",
  answer: "Step 1: Calculate how many gallons are empty: 45 - 18 = 27 gallons\nStep 2: Calculate percentage empty: (27 ÷ 45) × 100\nStep 3: = 0.6 × 100 = 60%\n\nAnswer: 60% empty",
  difficulty: "Easy"
},
{
  id: 979,
  subject: "Arithmetic Reasoning",
  question: "A soldier needs to convert 2 miles to feet. If 1 mile = 5,280 feet, how many feet is 2 miles?",
  answer: "Step 1: Use conversion factor: 1 mile = 5,280 feet\nStep 2: 2 miles × 5,280 feet/mile = 10,560 feet\n\nAnswer: 10,560 feet",
  difficulty: "Easy"
},
{
  id: 980,
  subject: "Arithmetic Reasoning",
  question: "A training course costs $1,200 for 8 soldiers. What is the cost per soldier?",
  answer: "Step 1: Divide total cost by number of soldiers\nStep 2: $1,200 ÷ 8 soldiers = $150 per soldier\n\nAnswer: $150 per soldier",
  difficulty: "Easy"
},
{
  id: 981,
  subject: "Arithmetic Reasoning",
  question: "A military transport plane flies at 500 mph. How long will it take to fly 2,000 miles?",
  answer: "Step 1: Use the formula: Time = Distance ÷ Speed\nStep 2: Time = 2,000 miles ÷ 500 mph\nStep 3: Time = 4 hours\n\nAnswer: 4 hours",
  difficulty: "Easy"
},
{
  id: 982,
  subject: "Arithmetic Reasoning",
  question: "A unit has 320 soldiers. If 25% are assigned to guard duty, how many soldiers are on guard duty?",
  answer: "Step 1: Calculate 25% of 320\nStep 2: 0.25 × 320 = 80 soldiers\n\nAnswer: 80 soldiers",
  difficulty: "Easy"
},
{
  id: 983,
  subject: "Arithmetic Reasoning",
  question: "A military kitchen prepares 360 meals for 9 companies. How many meals per company?",
  answer: "Step 1: Divide total meals by number of companies\nStep 2: 360 meals ÷ 9 companies = 40 meals per company\n\nAnswer: 40 meals per company",
  difficulty: "Easy"
},
{
  id: 984,
  subject: "Arithmetic Reasoning",
  question: "A soldier saves $50 per month. If his goal is to save $600, how many months will it take?",
  answer: "Step 1: Divide total savings goal by monthly savings\nStep 2: $600 ÷ $50 per month = 12 months\n\nAnswer: 12 months",
  difficulty: "Easy"
},
{
  id: 985,
  subject: "Arithmetic Reasoning",
  question: "A military test score is 72 out of 90. What percentage is this?",
  answer: "Step 1: Calculate percentage: (72 ÷ 90) × 100\nStep 2: = 0.8 × 100 = 80%\n\nAnswer: 80%",
  difficulty: "Easy"
},
{
  id: 986,
  subject: "Arithmetic Reasoning",
  question: "A ammunition storage facility receives 1,200 rounds and stores them in boxes of 40 rounds each. How many boxes are needed?",
  answer: "Step 1: Divide total rounds by rounds per box\nStep 2: 1,200 rounds ÷ 40 rounds/box = 30 boxes\n\nAnswer: 30 boxes",
  difficulty: "Easy"
},
{
  id: 987,
  subject: "Arithmetic Reasoning",
  question: "A soldier's fitness test score improved from 65 to 78. What is the absolute improvement?",
  answer: "Step 1: Subtract the original score from the new score\nStep 2: 78 - 65 = 13 points\n\nAnswer: 13 points improvement",
  difficulty: "Easy"
},
{
  id: 988,
  subject: "Arithmetic Reasoning",
  question: "A military base has 5 identical water storage tanks, each holding 800 gallons. What is the total storage capacity?",
  answer: "Step 1: Multiply the number of tanks by capacity per tank\nStep 2: 5 tanks × 800 gallons/tank = 4,000 gallons\n\nAnswer: 4,000 gallons total capacity",
  difficulty: "Easy"
},
{
  id: 989,
  subject: "Arithmetic Reasoning",
  question: "A soldier's equipment weighs 85 pounds. After adding supplies, the total weight is 120 pounds. How much do the supplies weigh?",
  answer: "Step 1: Subtract the original equipment weight from the total weight\nStep 2: 120 pounds - 85 pounds = 35 pounds\n\nAnswer: 35 pounds",
  difficulty: "Easy"
},
{
  id: 990,
  subject: "Arithmetic Reasoning",
  question: "A unit completes 15 training exercises per week. How many exercises are completed in 8 weeks?",
  answer: "Step 1: Multiply exercises per week by number of weeks\nStep 2: 15 exercises/week × 8 weeks = 120 exercises\n\nAnswer: 120 exercises",
  difficulty: "Easy"
},
{
  id: 991,
  subject: "Arithmetic Reasoning",
  question: "A military convoy travels at 55 mph for 3 hours, then at 65 mph for 2 hours. What is the total distance traveled?",
  answer: "Step 1: Calculate distance for first segment: 55 mph × 3 hours = 165 miles\nStep 2: Calculate distance for second segment: 65 mph × 2 hours = 130 miles\nStep 3: Total distance = 165 + 130 = 295 miles\n\nAnswer: 295 miles",
  difficulty: "Medium"
},
{
  id: 992,
  subject: "Arithmetic Reasoning",
  question: "A soldier's monthly expenses are: rent $800, food $300, utilities $150, transportation $100. What are his total monthly expenses?",
  answer: "Step 1: Add all expenses together\nStep 2: $800 + $300 + $150 + $100 = $1,350\n\nAnswer: $1,350 per month",
  difficulty: "Medium"
},
{
  id: 993,
  subject: "Arithmetic Reasoning",
  question: "A military storage room has 3 shelves. Each shelf holds 24 boxes. If 8 boxes have been removed, how many boxes remain?",
  answer: "Step 1: Calculate total capacity: 3 shelves × 24 boxes/shelf = 72 boxes\nStep 2: Subtract removed boxes: 72 - 8 = 64 boxes\n\nAnswer: 64 boxes remain",
  difficulty: "Medium"
},
{
  id: 994,
  subject: "Arithmetic Reasoning",
  question: "A soldier's bonus is 20% of his annual salary of $36,000. If he receives this bonus quarterly (4 times per year), how much does he receive each quarter?",
  answer: "Step 1: Calculate annual bonus: 20% of $36,000 = 0.20 × $36,000 = $7,200\nStep 2: Divide by 4 quarters: $7,200 ÷ 4 = $1,800 per quarter\n\nAnswer: $1,800 per quarter",
  difficulty: "Medium"
},
{
  id: 995,
  subject: "Arithmetic Reasoning",
  question: "A military parade involves 240 soldiers arranged in rows of 15. How many complete rows are there, and how many soldiers are left over?",
  answer: "Step 1: Divide total soldiers by soldiers per row: 240 ÷ 15 = 16 with no remainder\nStep 2: There are 16 complete rows and 0 soldiers left over\n\nAnswer: 16 complete rows, 0 soldiers remaining",
  difficulty: "Medium"
},
{
  id: 996,
  subject: "Arithmetic Reasoning",
  question: "A military base's water consumption is 1,500 gallons per day for 28 days. How much water is consumed in total?",
  answer: "Step 1: Multiply daily consumption by number of days\nStep 2: 1,500 gallons/day × 28 days = 42,000 gallons\n\nAnswer: 42,000 gallons",
  difficulty: "Medium"
},
{
  id: 997,
  subject: "Arithmetic Reasoning",
  question: "A soldier's deployment lasted 8 months and 15 days. If we count this as 255 days total, how many weeks is this approximately?",
  answer: "Step 1: Divide days by days per week (7)\nStep 2: 255 days ÷ 7 days/week = 36.43 weeks\nStep 3: Approximately 36 weeks\n\nAnswer: Approximately 36 weeks",
  difficulty: "Medium"
},
{
  id: 998,
  subject: "Arithmetic Reasoning",
  question: "A military supply order costs $2,400. If there is a 12% discount for bulk orders, what is the final cost?",
  answer: "Step 1: Calculate discount: 12% of $2,400 = 0.12 × $2,400 = $288\nStep 2: Final cost = $2,400 - $288 = $2,112\n\nAnswer: $2,112",
  difficulty: "Medium"
},
{
  id: 999,
  subject: "Arithmetic Reasoning",
  question: "A training facility has 360 participants divided into 6 equal groups. Each group then divides into 3 smaller teams. How many people are in each team?",
  answer: "Step 1: Divide participants by number of groups: 360 ÷ 6 = 60 per group\nStep 2: Divide each group into 3 teams: 60 ÷ 3 = 20 per team\n\nAnswer: 20 people per team",
  difficulty: "Medium"
},
{
  id: 1000,
  subject: "Arithmetic Reasoning",
  question: "A soldier works 8 hours per day at $18 per hour. If he works 22 days per month, what is his monthly income?",
  answer: "Step 1: Calculate daily income: 8 hours × $18/hour = $144\nStep 2: Calculate monthly income: $144 × 22 days = $3,168\n\nAnswer: $3,168 per month",
  difficulty: "Medium"
},
{
  id: 1001,
  subject: "Arithmetic Reasoning",
  question: "A military vehicle has a fuel efficiency of 8 miles per gallon. If it has 32 gallons of fuel and uses 4 gallons per hour while operating, how far can it travel before running out of fuel?",
  answer: "Step 1: Calculate distance: 32 gallons × 8 miles/gallon = 256 miles\n\nNote: The fuel consumption rate is additional information not needed for this calculation.\n\nAnswer: 256 miles",
  difficulty: "Medium"
},
{
  id: 1002,
  subject: "Arithmetic Reasoning",
  question: "A military barracks needs cleaning supplies. One company uses 12 bottles of disinfectant per month. If there are 8 companies and each bottle costs $6, what is the total monthly cost?",
  answer: "Step 1: Calculate total bottles needed: 12 bottles × 8 companies = 96 bottles\nStep 2: Calculate total cost: 96 bottles × $6/bottle = $576\n\nAnswer: $576 per month",
  difficulty: "Medium"
},
{
  id: 1003,
  subject: "Arithmetic Reasoning",
  question: "A soldier completed 180 miles of a 300-mile march. What percentage of the march remains?",
  answer: "Step 1: Calculate remaining distance: 300 - 180 = 120 miles\nStep 2: Calculate percentage: (120 ÷ 300) × 100 = 40%\n\nAnswer: 40% of the march remains",
  difficulty: "Medium"
},
{
  id: 1004,
  subject: "Arithmetic Reasoning",
  question: "A military kitchen purchases 48 pounds of beef, 36 pounds of chicken, and 24 pounds of pork. What is the total weight of meat?",
  answer: "Step 1: Add all quantities: 48 + 36 + 24 = 108 pounds\n\nAnswer: 108 pounds of meat",
  difficulty: "Medium"
},
{
  id: 1005,
  subject: "Arithmetic Reasoning",
  question: "A soldier's helmet costs $150. A uniform costs $200. Body armor costs $350. If a unit needs to equip 20 soldiers with complete gear, what is the total cost?",
  answer: "Step 1: Calculate cost per soldier: $150 + $200 + $350 = $700\nStep 2: Calculate total for 20 soldiers: $700 × 20 = $14,000\n\nAnswer: $14,000",
  difficulty: "Medium"
},
{
  id: 1006,
  subject: "Arithmetic Reasoning",
  question: "A military base has 1,200 soldiers. If 30% are deployed, how many soldiers remain at the base?",
  answer: "Step 1: Calculate deployed soldiers: 30% of 1,200 = 0.30 × 1,200 = 360\nStep 2: Calculate remaining soldiers: 1,200 - 360 = 840\n\nAnswer: 840 soldiers remain at the base",
  difficulty: "Medium"
},
{
  id: 1007,
  subject: "Arithmetic Reasoning",
  question: "A soldier's test scores are: 85, 92, 78, and 88. What is his average score?",
  answer: "Step 1: Add all scores: 85 + 92 + 78 + 88 = 343\nStep 2: Divide by number of tests: 343 ÷ 4 = 85.75\n\nAnswer: 85.75 (or 86 rounded)",
  difficulty: "Medium"
},
{
  id: 1008,
  subject: "Arithmetic Reasoning",
  question: "A military aircraft can carry 8 tons of cargo. If each supply crate weighs 400 pounds, how many crates can it carry? (Note: 1 ton = 2,000 pounds)",
  answer: "Step 1: Convert cargo capacity to pounds: 8 tons × 2,000 pounds/ton = 16,000 pounds\nStep 2: Divide by crate weight: 16,000 ÷ 400 = 40 crates\n\nAnswer: 40 crates",
  difficulty: "Medium"
},
{
  id: 1009,
  subject: "Arithmetic Reasoning",
  question: "A soldier earns $2,000 per month. After taxes and deductions of 18%, what is his take-home pay?",
  answer: "Step 1: Calculate deductions: 18% of $2,000 = 0.18 × $2,000 = $360\nStep 2: Calculate take-home: $2,000 - $360 = $1,640\n\nAnswer: $1,640",
  difficulty: "Medium"
},
{
  id: 1010,
  subject: "Arithmetic Reasoning",
  question: "A military base uses 4,500 gallons of water daily for 365 days per year. What is the annual water consumption?",
  answer: "Step 1: Multiply daily usage by days per year\nStep 2: 4,500 gallons/day × 365 days = 1,642,500 gallons per year\n\nAnswer: 1,642,500 gallons per year",
  difficulty: "Medium"
},
{
  id: 1011,
  subject: "Arithmetic Reasoning",
  question: "A military convoy consisting of 3 trucks travels together. Truck A carries 2,400 pounds, Truck B carries 3,100 pounds, and Truck C carries 2,900 pounds. The average load is distributed equally. What is each truck's equal share?",
  answer: "Step 1: Calculate total load: 2,400 + 3,100 + 2,900 = 8,400 pounds\nStep 2: Divide by number of trucks: 8,400 ÷ 3 = 2,800 pounds each\n\nAnswer: 2,800 pounds per truck",
  difficulty: "Hard"
},
{
  id: 1012,
  subject: "Arithmetic Reasoning",
  question: "A soldier travels from Base A to Base B, a distance of 180 miles. He travels at 60 mph for 2 hours, then at 50 mph for the remaining time. How long does the entire trip take?",
  answer: "Step 1: Calculate distance in first 2 hours: 60 mph × 2 hours = 120 miles\nStep 2: Calculate remaining distance: 180 - 120 = 60 miles\nStep 3: Calculate time for remaining distance: 60 miles ÷ 50 mph = 1.2 hours\nStep 4: Total time: 2 + 1.2 = 3.2 hours (or 3 hours 12 minutes)\n\nAnswer: 3.2 hours",
  difficulty: "Hard"
},
{
  id: 1013,
  subject: "Arithmetic Reasoning",
  question: "A military budget allocates $500,000. Of this, 35% goes to personnel, 40% to equipment, and the remainder to operations. How much is allocated to operations?",
  answer: "Step 1: Calculate personnel allocation: 35% of $500,000 = 0.35 × $500,000 = $175,000\nStep 2: Calculate equipment allocation: 40% of $500,000 = 0.40 × $500,000 = $200,000\nStep 3: Calculate remainder for operations: 100% - 35% - 40% = 25%\nStep 4: Operations allocation: 25% of $500,000 = 0.25 × $500,000 = $125,000\n\nAnswer: $125,000",
  difficulty: "Hard"
},
{
  id: 1014,
  subject: "Arithmetic Reasoning",
  question: "A training program costs $3,200 for 16 soldiers. If an additional 24 soldiers join the program at the same rate per person, what is the new total cost?",
  answer: "Step 1: Calculate cost per soldier: $3,200 ÷ 16 = $200 per soldier\nStep 2: Calculate cost for additional 24 soldiers: 24 × $200 = $4,800\nStep 3: Calculate new total: $3,200 + $4,800 = $8,000\n\nAnswer: $8,000",
  difficulty: "Hard"
},
{
  id: 1015,
  subject: "Arithmetic Reasoning",
  question: "A soldier's compound interest savings account has $5,000 at 4% annual interest. After 2 years with simple interest, how much will he have? (Simple Interest = Principal × Rate × Time)",
  answer: "Step 1: Use simple interest formula: SI = P × R × T\nStep 2: SI = $5,000 × 0.04 × 2 = $400\nStep 3: Total amount = Principal + Interest = $5,000 + $400 = $5,400\n\nAnswer: $5,400",
  difficulty: "Hard"
},
{
  id: 1016,
  subject: "Arithmetic Reasoning",
  question: "A military base has a ratio of officers to enlisted personnel of 1:8. If there are 72 officers, how many enlisted personnel are there, and what is the total number of personnel?",
  answer: "Step 1: Set up ratio: 1 officer : 8 enlisted\nStep 2: If 72 officers, then: 72 × 8 = 576 enlisted personnel\nStep 3: Total personnel: 72 + 576 = 648\n\nAnswer: 576 enlisted personnel; 648 total personnel",
  difficulty: "Hard"
},
{
  id: 1017,
  subject: "Arithmetic Reasoning",
  question: "A military supply shipment contains 3 types of items. Type A: 240 units at $5 each, Type B: 180 units at $8 each, Type C: 150 units at $10 each. What is the total value of the shipment?",
  answer: "Step 1: Calculate Type A value: 240 × $5 = $1,200\nStep 2: Calculate Type B value: 180 × $8 = $1,440\nStep 3: Calculate Type C value: 150 × $10 = $1,500\nStep 4: Total value: $1,200 + $1,440 + $1,500 = $4,140\n\nAnswer: $4,140",
  difficulty: "Hard"
},
{
  id: 1018,
  subject: "Arithmetic Reasoning",
  question: "A soldier can run 8 miles in 64 minutes. At this same pace, how long will it take him to run 15 miles?",
  answer: "Step 1: Calculate pace: 64 minutes ÷ 8 miles = 8 minutes per mile\nStep 2: Calculate time for 15 miles: 15 miles × 8 minutes/mile = 120 minutes\nStep 3: Convert to hours and minutes: 120 minutes = 2 hours\n\nAnswer: 120 minutes (or 2 hours)",
  difficulty: "Hard"
},
{
  id: 1019,
  subject: "Arithmetic Reasoning",
  question: "A military vehicle's odometer reads 45,280 miles. After a mission, it reads 45,620 miles. If the vehicle uses 1 gallon of fuel per 8 miles, how many gallons were used on the mission?",
  answer: "Step 1: Calculate distance traveled: 45,620 - 45,280 = 340 miles\nStep 2: Calculate fuel used: 340 miles ÷ 8 miles/gallon = 42.5 gallons\n\nAnswer: 42.5 gallons",
  difficulty: "Hard"
},
{
  id: 1020,
  subject: "Arithmetic Reasoning",
  question: "A soldier completes a fitness test with a score of 240 points. If this score improves by 8% next month, what will his new score be? If it then improves another 5% the following month, what will be his final score?",
  answer: "Step 1: Calculate first improvement: 8% of 240 = 0.08 × 240 = 19.2\nStep 2: Score after first month: 240 + 19.2 = 259.2\nStep 3: Calculate second improvement: 5% of 259.2 = 0.05 × 259.2 = 12.96\nStep 4: Final score: 259.2 + 12.96 = 272.16\n\nAnswer: 272.16 (or 272 rounded)",
  difficulty: "Hard"
}
,
  {
    id: 1021,
    subject: "Electronics Information",
    question: "What is the SI unit of electrical current?",
    answer: "The SI unit of electrical current is the Ampere (A). One ampere represents one coulomb of charge flowing per second through a conductor. Current is fundamental in electrical systems and is used to measure the flow of electrons in circuits.",
    difficulty: "Easy"
  },
  {
    id: 1022,
    subject: "Electronics Information",
    question: "Define voltage in an electrical circuit.",
    answer: "Voltage is the electrical potential difference between two points in a circuit, measured in volts (V). It represents the energy per unit charge, or the 'push' that drives current through a conductor. Higher voltage means greater energy transfer capability.",
    difficulty: "Easy"
  },
  {
    id: 1023,
    subject: "Electronics Information",
    question: "What is electrical resistance?",
    answer: "Electrical resistance is the opposition to current flow in a conductor, measured in ohms (Ω). It depends on the material's properties, length, and cross-sectional area. Resistance converts electrical energy into heat and is essential for controlling current in circuits.",
    difficulty: "Easy"
  },
  {
    id: 1024,
    subject: "Electronics Information",
    question: "State Ohm's Law.",
    answer: "Ohm's Law states that V = IR, where V is voltage (volts), I is current (amperes), and R is resistance (ohms). This fundamental law shows that voltage is directly proportional to current when resistance is constant, and is used in all circuit analysis.",
    difficulty: "Easy"
  },
  {
    id: 1025,
    subject: "Electronics Information",
    question: "What are the two main types of electrical circuits?",
    answer: "The two main types are series circuits and parallel circuits. In a series circuit, components are connected end-to-end so current has one path. In a parallel circuit, components share the same two connection points, providing multiple current paths.",
    difficulty: "Easy"
  },
  {
    id: 1026,
    subject: "Electronics Information",
    question: "How does current flow in a series circuit?",
    answer: "In a series circuit, current flows through each component sequentially in a single path. The current is the same everywhere in the circuit because there is only one path for electrons to travel. If one component fails, the entire circuit breaks.",
    difficulty: "Easy"
  },
  {
    id: 1027,
    subject: "Electronics Information",
    question: "How does voltage distribute in a parallel circuit?",
    answer: "In a parallel circuit, the voltage across each branch is equal to the source voltage. Each resistor receives the full source voltage, regardless of the number of parallel paths. This is a key characteristic of parallel circuits.",
    difficulty: "Easy"
  },
  {
    id: 1028,
    subject: "Electronics Information",
    question: "What is a resistor?",
    answer: "A resistor is a passive electronic component that opposes the flow of electrical current, measured in ohms (Ω). Resistors are used to control current, protect circuits, divide voltages, and convert electrical energy to heat. They come in various types and power ratings.",
    difficulty: "Easy"
  },
  {
    id: 1029,
    subject: "Electronics Information",
    question: "What is a capacitor?",
    answer: "A capacitor is a passive component that stores electrical energy in an electric field between two conductive plates separated by a dielectric material. Capacitors are measured in farads (F), block DC current, and pass AC current. They are used for filtering, coupling, and energy storage.",
    difficulty: "Easy"
  },
  {
    id: 1030,
    subject: "Electronics Information",
    question: "What is a diode?",
    answer: "A diode is a semiconductor device with two terminals (anode and cathode) that allows current to flow in one direction only. The forward direction is when current flows from anode to cathode (when forward biased). Diodes are used in rectification, voltage regulation, and protection circuits.",
    difficulty: "Easy"
  },
  {
    id: 1031,
    subject: "Electronics Information",
    question: "Explain the difference between AC and DC current.",
    answer: "DC (Direct Current) flows in one direction at constant voltage, commonly used in batteries and electronics. AC (Alternating Current) reverses direction periodically, measured in hertz (Hz), and is used for power distribution. AC can transmit power over long distances more efficiently.",
    difficulty: "Easy"
  },
  {
    id: 1032,
    subject: "Electronics Information",
    question: "What is the frequency of standard US household AC power?",
    answer: "Standard US household AC power has a frequency of 60 hertz (Hz), meaning the current alternates direction 60 times per second. This is the standard for North America. Europe and many other countries use 50 Hz. Frequency is crucial for synchronizing AC equipment.",
    difficulty: "Easy"
  },
  {
    id: 1033,
    subject: "Electronics Information",
    question: "What is the purpose of a ground wire?",
    answer: "A ground wire provides a safe path for excess current or electrical faults to dissipate into the earth. It protects people from electrical shock and equipment from damage. In a three-wire system, the ground (earth) wire is the third wire and is essential for safety in AC circuits.",
    difficulty: "Easy"
  },
  {
    id: 1034,
    subject: "Electronics Information",
    question: "What is a circuit breaker?",
    answer: "A circuit breaker is a safety device that automatically interrupts electrical current when it exceeds a safe level. It protects circuits from overload and short circuit conditions, preventing fires and equipment damage. Circuit breakers can be reset, unlike fuses which must be replaced.",
    difficulty: "Easy"
  },
  {
    id: 1035,
    subject: "Electronics Information",
    question: "What is a fuse?",
    answer: "A fuse is a protective device with a wire that melts when current exceeds its rated value, breaking the circuit. Once blown, a fuse must be replaced with a new one. Fuses are rated by their amperage and must match the circuit they protect.",
    difficulty: "Easy"
  },
  {
    id: 1036,
    subject: "Electronics Information",
    question: "What is electrical power?",
    answer: "Electrical power is the rate of energy transfer, measured in watts (W). The formula is P = VI, where P is power, V is voltage, and I is current. Power represents how much work an electrical device can do per unit time.",
    difficulty: "Easy"
  },
  {
    id: 1037,
    subject: "Electronics Information",
    question: "Define electrical energy.",
    answer: "Electrical energy is the capacity to perform work using electrical power, measured in watt-hours (Wh) or joules (J). It is calculated as Energy = Power × Time (E = Pt). Batteries store electrical energy that is consumed by devices.",
    difficulty: "Easy"
  },
  {
    id: 1038,
    subject: "Electronics Information",
    question: "What is the formula for power dissipation in a resistor?",
    answer: "The formula for power dissipation is P = I²R or P = V²/R. This represents the heat generated when current flows through resistance. Understanding power dissipation is crucial for selecting appropriate component ratings and preventing overheating.",
    difficulty: "Easy"
  },
  {
    id: 1039,
    subject: "Electronics Information",
    question: "What is a transistor?",
    answer: "A transistor is a semiconductor device with three terminals (base, collector, emitter for BJTs; gate, drain, source for FETs) used to amplify or switch electrical signals. Transistors are the building blocks of modern electronics, used in amplifiers, switches, and logic circuits.",
    difficulty: "Easy"
  },
  {
    id: 1040,
    subject: "Electronics Information",
    question: "What is a switch?",
    answer: "A switch is a device that controls the flow of electrical current by opening (breaking) or closing (completing) a circuit. Switches can be manual (operated by hand) or automatic (controlled by sensors). They are essential for controlling electrical devices.",
    difficulty: "Easy"
  },
  {
    id: 1041,
    subject: "Electronics Information",
    question: "Calculate the current using Ohm's Law if voltage is 12V and resistance is 4 ohms.",
    answer: "Using Ohm's Law (I = V/R): I = 12V / 4Ω = 3A. The current is 3 amperes. This calculation is fundamental for circuit analysis and is used frequently in electrical troubleshooting and design.",
    difficulty: "Easy"
  },
  {
    id: 1042,
    subject: "Electronics Information",
    question: "If a circuit has 24V and draws 2A of current, what is the resistance?",
    answer: "Using Ohm's Law (R = V/I): R = 24V / 2A = 12Ω. The resistance is 12 ohms. This type of calculation helps determine circuit characteristics and is essential for designing protective devices.",
    difficulty: "Easy"
  },
  {
    id: 1043,
    subject: "Electronics Information",
    question: "What is the relationship between voltage and current in a conductor at constant resistance?",
    answer: "In a conductor with constant resistance, voltage and current are directly proportional (V ∝ I). This means if voltage doubles, current doubles; if voltage halves, current halves. This linear relationship is described by Ohm's Law.",
    difficulty: "Easy"
  },
  {
    id: 1044,
    subject: "Electronics Information",
    question: "How does temperature affect resistance in most conductors?",
    answer: "In most conductors, resistance increases with temperature. As temperature increases, atoms vibrate more, causing more collisions with electrons and increasing opposition to current flow. This is why electrical devices generate heat and why cooling systems are important.",
    difficulty: "Easy"
  },
  {
    id: 1045,
    subject: "Electronics Information",
    question: "What is a short circuit?",
    answer: "A short circuit occurs when two points in a circuit with different potentials are connected with minimal resistance, causing excessive current flow. This can damage equipment, cause fires, and create safety hazards. Short circuits trigger circuit breakers or fuses to protect circuits.",
    difficulty: "Easy"
  },
  {
    id: 1046,
    subject: "Electronics Information",
    question: "What is an open circuit?",
    answer: "An open circuit is a break in the electrical path that prevents current flow. This can occur due to a broken wire, failed component, or open switch. In an open circuit, voltage is present across the break but no current flows.",
    difficulty: "Easy"
  },
  {
    id: 1047,
    subject: "Electronics Information",
    question: "What is the color code for resistor bands?",
    answer: "Resistor color bands indicate the resistance value: Black=0, Brown=1, Red=2, Orange=3, Yellow=4, Green=5, Blue=6, Violet=7, Grey=8, White=9. The first two bands represent significant digits, the third band is the multiplier, and the fourth band indicates tolerance. This standardized system allows quick identification.",
    difficulty: "Easy"
  },
  {
    id: 1048,
    subject: "Electronics Information",
    question: "What does a red resistor band followed by violet and red mean?",
    answer: "Red=2, Violet=7, Red=100 multiplier. The resistance value is 27 × 100 = 2700 ohms or 2.7 kilohms (kΩ). The fourth band (usually gold or silver) indicates the tolerance. This is a common color code reading problem in electronics.",
    difficulty: "Easy"
  },
  {
    id: 1049,
    subject: "Electronics Information",
    question: "What is a load in an electrical circuit?",
    answer: "A load is any device in a circuit that consumes electrical energy and converts it to another form (light, heat, motion, sound, etc.). Examples include light bulbs, heaters, motors, and speakers. The load determines current draw based on its resistance.",
    difficulty: "Easy"
  },
  {
    id: 1050,
    subject: "Electronics Information",
    question: "What is internal resistance in a battery?",
    answer: "Internal resistance is the inherent opposition to current flow within a battery, caused by the chemical and physical characteristics of the battery. It causes the terminal voltage to drop when current flows. Real batteries have internal resistance; ideal batteries have zero internal resistance.",
    difficulty: "Easy"
  },
  {
    id: 1051,
    subject: "Electronics Information",
    question: "Calculate total current in a series circuit with voltage 12V and total resistance 6 ohms.",
    answer: "Using Ohm's Law (I = V/R): I = 12V / 6Ω = 2A. In a series circuit, current is the same everywhere, so 2 amperes flows through each component. Series circuits are simple but have limitations for safety and control.",
    difficulty: "Medium"
  },
  {
    id: 1052,
    subject: "Electronics Information",
    question: "How do you calculate total resistance in a series circuit?",
    answer: "Total resistance in a series circuit is the sum of all individual resistances: R_total = R1 + R2 + R3 + ... Rn. The total resistance increases with each additional resistor. This is why devices in series all share the same current path.",
    difficulty: "Medium"
  },
  {
    id: 1053,
    subject: "Electronics Information",
    question: "How do you calculate total resistance in a parallel circuit?",
    answer: "For parallel resistors, the reciprocal of total resistance equals the sum of reciprocals: 1/R_total = 1/R1 + 1/R2 + 1/R3 + ... For equal resistors: R_total = R / N (where N is the number of resistors). Total resistance is always less than the smallest resistor.",
    difficulty: "Medium"
  },
  {
    id: 1054,
    subject: "Electronics Information",
    question: "Calculate total current in a parallel circuit if a 12V source is connected to two 6-ohm resistors in parallel.",
    answer: "In parallel, voltage across each resistor is 12V. Current through each resistor: I = V/R = 12V / 6Ω = 2A per resistor. Total current: I_total = 2A + 2A = 4A. Parallel circuits draw more total current than series circuits.",
    difficulty: "Medium"
  },
  {
    id: 1055,
    subject: "Electronics Information",
    question: "What is Kirchhoff's Current Law?",
    answer: "Kirchhoff's Current Law (KCL) states that the sum of all currents entering a node equals the sum of all currents leaving that node. This is based on conservation of charge. KCL is used in complex circuit analysis and is fundamental to circuit theory.",
    difficulty: "Medium"
  },
  {
    id: 1056,
    subject: "Electronics Information",
    question: "What is Kirchhoff's Voltage Law?",
    answer: "Kirchhoff's Voltage Law (KVL) states that the sum of all voltages around a closed loop equals zero. Voltage drops equal voltage rises in any complete circuit path. KVL is used to analyze circuits with multiple voltage sources and is essential for circuit troubleshooting.",
    difficulty: "Medium"
  },
  {
    id: 1057,
    subject: "Electronics Information",
    question: "How does a voltage divider circuit work?",
    answer: "A voltage divider uses two resistors in series to produce an output voltage that is a fraction of the input voltage. The formula is: V_out = V_in × (R2 / (R1 + R2)). Voltage dividers are used to reduce voltages for sensor inputs and signal processing.",
    difficulty: "Medium"
  },
  {
    id: 1058,
    subject: "Electronics Information",
    question: "Calculate the output voltage in a voltage divider where V_in = 24V, R1 = 4Ω, and R2 = 8Ω.",
    answer: "Using V_out = V_in × (R2 / (R1 + R2)): V_out = 24V × (8Ω / 12Ω) = 24V × (2/3) = 16V. The output voltage is 16 volts. Voltage dividers scale voltages for different circuit requirements.",
    difficulty: "Medium"
  },
  {
    id: 1059,
    subject: "Electronics Information",
    question: "What is forward bias for a diode?",
    answer: "Forward bias occurs when the anode of a diode is positive relative to the cathode, reducing the barrier potential and allowing current to flow. For silicon diodes, forward bias requires approximately 0.7V; for germanium diodes, approximately 0.3V. Forward bias enables diode conduction.",
    difficulty: "Medium"
  },
  {
    id: 1060,
    subject: "Electronics Information",
    question: "What is reverse bias for a diode?",
    answer: "Reverse bias occurs when the cathode is positive relative to the anode, increasing the barrier potential and preventing current flow (except for a small leakage current). Reverse bias blocks conduction until breakdown voltage is exceeded. Reverse bias is used in rectification and protection circuits.",
    difficulty: "Medium"
  },
  {
    id: 1061,
    subject: "Electronics Information",
    question: "What is a rectifier diode and what is its purpose?",
    answer: "A rectifier diode converts AC current to DC current by allowing current to flow in only one direction. In a half-wave rectifier, only half of the AC cycle is passed. In a full-wave rectifier using four diodes (bridge rectifier), both half-cycles are utilized, producing smoother DC output.",
    difficulty: "Medium"
  },
  {
    id: 1062,
    subject: "Electronics Information",
    question: "What is the difference between NPN and PNP transistors?",
    answer: "NPN transistors conduct when the base is positive, and PNP transistors conduct when the base is negative. NPN transistors are more commonly used because electrons (charge carriers) are more mobile than holes. The choice depends on the circuit configuration and power supply polarity.",
    difficulty: "Medium"
  },
  {
    id: 1063,
    subject: "Electronics Information",
    question: "What is a capacitor's capacitance and how is it measured?",
    answer: "Capacitance is the ability of a capacitor to store charge, measured in farads (F). The formula is C = Q/V, where Q is charge (coulombs) and V is voltage. One farad is the capacitance that stores one coulomb at one volt. Practical units are microfarads (μF) and nanofarads (nF).",
    difficulty: "Medium"
  },
  {
    id: 1064,
    subject: "Electronics Information",
    question: "What factors affect capacitor capacitance?",
    answer: "Capacitance depends on: the area of the plates (larger area = higher capacitance), the distance between plates (closer plates = higher capacitance), and the dielectric material (different materials have different permittivity). The formula is C = ε₀εᵣA/d, where ε₀ is permittivity of free space, εᵣ is relative permittivity, A is area, and d is distance.",
    difficulty: "Medium"
  },
  {
    id: 1065,
    subject: "Electronics Information",
    question: "What is the reactance of a capacitor?",
    answer: "Capacitive reactance (Xc) is the opposition to AC current flow by a capacitor, measured in ohms. The formula is Xc = 1/(2πfC), where f is frequency and C is capacitance. At higher frequencies, capacitive reactance decreases, allowing more current to pass.",
    difficulty: "Medium"
  },
  {
    id: 1066,
    subject: "Electronics Information",
    question: "What is the reactance of an inductor?",
    answer: "Inductive reactance (XL) is the opposition to AC current flow by an inductor, measured in ohms. The formula is XL = 2πfL, where f is frequency and L is inductance. At higher frequencies, inductive reactance increases, blocking more current.",
    difficulty: "Medium"
  },
  {
    id: 1067,
    subject: "Electronics Information",
    question: "What is impedance in an AC circuit?",
    answer: "Impedance (Z) is the total opposition to AC current flow, combining resistance (R), capacitive reactance (Xc), and inductive reactance (XL). The formula is Z = √(R² + (XL - Xc)²). Impedance includes both resistive and reactive components and is measured in ohms.",
    difficulty: "Medium"
  },
  {
    id: 1068,
    subject: "Electronics Information",
    question: "What is the phase relationship between voltage and current in a purely resistive AC circuit?",
    answer: "In a purely resistive circuit, voltage and current are in phase, meaning they reach their maximum and minimum values at the same time. The phase angle between them is 0 degrees. Power is calculated as P = VI × cos(θ) where θ = 0.",
    difficulty: "Medium"
  },
  {
    id: 1069,
    subject: "Electronics Information",
    question: "What is the phase relationship between voltage and current in a purely inductive AC circuit?",
    answer: "In a purely inductive circuit, current lags voltage by 90 degrees. This means current reaches its peak 90 degrees (1/4 cycle) after voltage. This phase difference is due to the inductor's opposition to changing current.",
    difficulty: "Medium"
  },
  {
    id: 1070,
    subject: "Electronics Information",
    question: "What is the phase relationship between voltage and current in a purely capacitive AC circuit?",
    answer: "In a purely capacitive circuit, current leads voltage by 90 degrees. Current reaches its peak 90 degrees before voltage. This is opposite to the inductive case and is due to the capacitor's charging and discharging characteristics.",
    difficulty: "Medium"
  },
  {
    id: 1071,
    subject: "Electronics Information",
    question: "What is resonance in an LC circuit?",
    answer: "Resonance occurs in an LC circuit when inductive reactance equals capacitive reactance (XL = Xc), causing impedance to be minimum (equal to resistance only). At resonance frequency (f = 1/(2π√LC)), current reaches maximum and the circuit is purely resistive. Resonance is used in filters and tuning circuits.",
    difficulty: "Medium"
  },
  {
    id: 1072,
    subject: "Electronics Information",
    question: "What is the quality factor (Q) of a resonant circuit?",
    answer: "Quality factor (Q) measures the sharpness of resonance in a circuit, defined as Q = XL/R = (1/Xc)/R at resonance. Higher Q indicates sharper resonance peak. Q = f₀/BW, where f₀ is resonant frequency and BW is bandwidth. Q is important in filter design.",
    difficulty: "Medium"
  },
  {
    id: 1073,
    subject: "Electronics Information",
    question: "What is power factor in an AC circuit?",
    answer: "Power factor (PF) is the ratio of real power to apparent power, ranging from 0 to 1. It equals cos(θ), where θ is the phase angle between voltage and current. A power factor of 1.0 means all power is real (resistive); less than 1.0 means some power is reactive (inductive or capacitive).",
    difficulty: "Medium"
  },
  {
    id: 1074,
    subject: "Electronics Information",
    question: "How do you measure voltage with a multimeter?",
    answer: "To measure voltage: 1) Set the multimeter to voltage mode (AC or DC). 2) Select the appropriate range higher than expected voltage. 3) Connect the black probe to common/ground and red probe to the test point. 4) Read the display. For AC circuits, use AC setting; for DC circuits, use DC setting with correct polarity.",
    difficulty: "Medium"
  },
  {
    id: 1075,
    subject: "Electronics Information",
    question: "How do you measure current with a multimeter?",
    answer: "To measure current: 1) Set the multimeter to current mode (AC or DC) and select the appropriate range. 2) Break the circuit and insert the multimeter in series (black probe upstream, red probe downstream). 3) Read the display. Current must flow through the meter, so it must be in the circuit path, not across it.",
    difficulty: "Medium"
  },
  {
    id: 1076,
    subject: "Electronics Information",
    question: "How do you measure resistance with a multimeter?",
    answer: "To measure resistance: 1) Set the multimeter to resistance (ohms) mode and select the appropriate range. 2) Disconnect power from the circuit. 3) Connect the probes across the component to be measured. 4) Read the display. The component must be isolated from the circuit to ensure accurate measurement.",
    difficulty: "Medium"
  },
  {
    id: 1077,
    subject: "Electronics Information",
    question: "What is the purpose of a heat sink in electronic components?",
    answer: "A heat sink is a device that dissipates heat generated by electronic components (like power transistors or voltage regulators) to prevent overheating. Heat sinks increase surface area for heat transfer to the surrounding air or fluid. They are essential for maintaining component reliability and preventing thermal shutdown.",
    difficulty: "Medium"
  },
  {
    id: 1078,
    subject: "Electronics Information",
    question: "What is the purpose of a relay?",
    answer: "A relay is an electromagnetic switch controlled by a low-power signal to control a high-power circuit. When current flows through the relay coil, it creates a magnetic field that moves a switch contact, allowing a separate circuit to be controlled. Relays protect sensitive components by isolating control circuits from high-current loads.",
    difficulty: "Medium"
  },
  {
    id: 1079,
    subject: "Electronics Information",
    question: "What is the purpose of a transformer?",
    answer: "A transformer changes voltage levels in AC circuits using electromagnetic induction. It consists of a primary coil and secondary coil wound on an iron core. The voltage ratio equals the turns ratio: V_secondary/V_primary = N_secondary/N_primary. Transformers are used for voltage step-up/step-down, isolation, and impedance matching.",
    difficulty: "Medium"
  },
  {
    id: 1080,
    subject: "Electronics Information",
    question: "What is the difference between a step-up and step-down transformer?",
    answer: "A step-up transformer has more turns in the secondary coil than primary, increasing voltage but decreasing current. A step-down transformer has fewer turns in the secondary, decreasing voltage but increasing current. Power is conserved (ideally): P_primary = P_secondary (assuming no losses).",
    difficulty: "Medium"
  },
  {
    id: 1081,
    subject: "Electronics Information",
    question: "How does a voltmeter connect in a circuit and why?",
    answer: "A voltmeter connects in parallel across the component to measure the voltage drop across it. Voltmeters have very high resistance (ideally infinite) so they draw minimal current from the circuit. High resistance prevents the voltmeter from affecting circuit operation and from being damaged.",
    difficulty: "Medium"
  },
  {
    id: 1082,
    subject: "Electronics Information",
    question: "How does an ammeter connect in a circuit and why?",
    answer: "An ammeter connects in series with the circuit to measure current flowing through it. Ammeters have very low resistance (ideally zero) to minimize voltage drop across the meter. Low resistance prevents the ammeter from significantly affecting circuit operation and ensures accurate current measurement.",
    difficulty: "Medium"
  },
  {
    id: 1083,
    subject: "Electronics Information",
    question: "What is the difference between active and passive components?",
    answer: "Passive components (resistors, capacitors, inductors, diodes) cannot amplify signals and only consume or store energy. Active components (transistors, operational amplifiers, integrated circuits) require a power source and can amplify signals or process information. Active components control energy flow; passive components do not.",
    difficulty: "Medium"
  },
  {
    id: 1084,
    subject: "Electronics Information",
    question: "What is an operational amplifier (op-amp)?",
    answer: "An operational amplifier is an integrated circuit with very high gain that amplifies the voltage difference between its two inputs (inverting and non-inverting). Op-amps are used in amplifiers, comparators, filters, and mathematical operations (summing, integrating). They require feedback for stable operation.",
    difficulty: "Medium"
  },
  {
    id: 1085,
    subject: "Electronics Information",
    question: "What is negative feedback in an op-amp circuit?",
    answer: "Negative feedback occurs when a portion of the output signal is fed back to the inverting input, opposing input changes. This stabilizes the op-amp gain, reduces distortion, and improves linearity. Negative feedback is essential for practical op-amp circuits and allows precise control of circuit gain.",
    difficulty: "Medium"
  },
  {
    id: 1086,
    subject: "Electronics Information",
    question: "What is a logic gate and how many basic types are there?",
    answer: "Logic gates are digital circuits that perform Boolean logic operations on binary inputs. The seven basic types are: AND (output high if all inputs high), OR (output high if any input high), NOT (inverts input), NAND (AND inverted), NOR (OR inverted), XOR (output high if inputs differ), XNOR (XOR inverted).",
    difficulty: "Medium"
  },
  {
    id: 1087,
    subject: "Electronics Information",
    question: "What is a half-wave rectifier and what is its main disadvantage?",
    answer: "A half-wave rectifier uses one diode to convert AC to DC, conducting only during the positive half-cycle. The output consists of unidirectional pulses with gaps, requiring heavy filtering. Disadvantages include low average output voltage, high ripple, and poor transformer utilization (only 50% of AC cycle used).",
    difficulty: "Medium"
  },
  {
    id: 1088,
    subject: "Electronics Information",
    question: "What is a full-wave bridge rectifier and how does it improve on the half-wave?",
    answer: "A full-wave bridge rectifier uses four diodes to utilize both positive and negative half-cycles of AC input. It produces DC output twice per cycle (two pulses per cycle instead of one), resulting in higher average voltage, lower ripple, and better transformer utilization than half-wave rectifiers.",
    difficulty: "Medium"
  },
  {
    id: 1089,
    subject: "Electronics Information",
    question: "What is the purpose of a filter capacitor in a power supply?",
    answer: "A filter capacitor (also called a smoothing capacitor) reduces the ripple (variation) in rectified DC output. It charges when the rectifier output is high and discharges when output drops, smoothing the voltage. Larger capacitance provides better filtering (lower ripple), but affects surge current during charging.",
    difficulty: "Medium"
  },
  {
    id: 1090,
    subject: "Electronics Information",
    question: "What is electromagnetic interference (EMI) and how can it be minimized?",
    answer: "EMI is unwanted electrical noise from external sources that interferes with circuit operation. It can be minimized by: shielding with conductive materials, grounding, using filters, keeping signal lines short, separating power and signal grounds, and using twisted pair cables. EMI is critical in sensitive military electronics.",
    difficulty: "Medium"
  },
  {
    id: 1091,
    subject: "Electronics Information",
    question: "Calculate the resonant frequency of an LC circuit where L = 10 mH and C = 1 μF.",
    answer: "Using f = 1/(2π√LC): f = 1/(2π√(10×10⁻³ × 1×10⁻⁶)) = 1/(2π√(10×10⁻⁹)) = 1/(2π × 10⁻⁴·⁵) ≈ 1591 Hz. The resonant frequency is approximately 1.59 kHz. This calculation is used in tuning circuits and filter design.",
    difficulty: "Hard"
  },
  {
    id: 1092,
    subject: "Electronics Information",
    question: "In a series RLC circuit with R = 10Ω, L = 5 mH, C = 100 μF, and f = 50 Hz, calculate impedance.",
    answer: "XL = 2πfL = 2π(50)(0.005) ≈ 1.57 Ω. Xc = 1/(2πfC) = 1/(2π(50)(100×10⁻⁶)) ≈ 31.83 Ω. Z = √(R² + (XL - Xc)²) = √(10² + (1.57 - 31.83)²) = √(100 + 915.4) ≈ 31.8 Ω. Complex circuit analysis requires careful calculation of reactive components.",
    difficulty: "Hard"
  },
  {
    id: 1093,
    subject: "Electronics Information",
    question: "What happens to circuit performance when resistance in a series RLC circuit equals zero?",
    answer: "When R = 0, the circuit becomes a pure LC resonator with no damping. At resonance, impedance becomes zero (theoretically infinite current), and the circuit rings indefinitely after excitation. In practice, small resistances always exist (from wire and component losses), providing damping. This condition must be avoided in practical circuits.",
    difficulty: "Hard"
  },
  {
    id: 1094,
    subject: "Electronics Information",
    question: "How does temperature coefficient affect resistor accuracy in critical military applications?",
    answer: "Temperature coefficient specifies how resistance changes with temperature (typically in ppm/°C). High-precision military applications require low temperature coefficients (near zero). As temperature changes, resistance drifts, affecting circuit calibration and performance. Precision resistors with low temperature coefficients maintain circuit stability across wide temperature ranges.",
    difficulty: "Hard"
  },
  {
    id: 1095,
    subject: "Electronics Information",
    question: "Calculate the power factor of a circuit with apparent power of 1000 VA and true power of 800 W.",
    answer: "Power Factor = True Power / Apparent Power = 800 W / 1000 VA = 0.8. This indicates that 80% of power is real and 20% is reactive. A low power factor (0.8) suggests significant inductive or capacitive loading, reducing system efficiency compared to unity power factor (1.0).",
    difficulty: "Hard"
  },
  {
    id: 1096,
    subject: "Electronics Information",
    question: "What is the purpose of power factor correction in electrical systems?",
    answer: "Power factor correction improves efficiency by reducing reactive power and bringing power factor closer to 1.0. Capacitors are used to cancel inductive reactance in industrial systems. Better power factor reduces transmission losses, lowers utility costs, and allows higher real power delivery on the same infrastructure.",
    difficulty: "Hard"
  },
  {
    id: 1097,
    subject: "Electronics Information",
    question: "How does a surge protector protect connected devices from voltage spikes?",
    answer: "Surge protectors use components like Metal Oxide Varistors (MOVs) or Gas Discharge Tubes (GDTs) that exhibit low resistance when voltage exceeds a threshold. When a surge occurs, these components divert excess current to ground, clamping voltage to safe levels. This protects sensitive electronics from transient overvoltages.",
    difficulty: "Hard"
  },
  {
    id: 1098,
    subject: "Electronics Information",
    question: "What is the difference between series and parallel voltage regulators?",
    answer: "Series regulators place a control element in series with the load, dropping excess voltage and adjusting based on output requirements. They are efficient but dissipate power in the control element. Parallel regulators (shunt regulators) divert excess current around the load. Series regulators are more common for linear power supplies.",
    difficulty: "Hard"
  },
  {
    id: 1099,
    subject: "Electronics Information",
    question: "How does a Three-phase AC system compare to single-phase in terms of power delivery?",
    answer: "Three-phase AC provides three AC voltages 120 degrees out of phase, delivering constant (not pulsating) power. Three-phase has three times more average power than single-phase at same voltage and current ratings. Three-phase is used in industrial applications for motors and high-power distribution because of efficiency and consistent torque.",
    difficulty: "Hard"
  },
  {
    id: 1100,
    subject: "Electronics Information",
    question: "What is the relationship between frequency, wavelength, and speed of electromagnetic waves?",
    answer: "The relationship is: c = f × λ, where c is the speed of light (3×10⁸ m/s), f is frequency (Hz), and λ is wavelength (meters). Higher frequency corresponds to shorter wavelength. At 60 Hz (power line), wavelength is very long; at microwave frequencies (GHz), wavelength is short. This is fundamental to understanding signal propagation.",
    difficulty: "Hard"
  },
  {
    id: 1101,
    subject: "Electronics Information",
    question: "Explain signal attenuation and its effects in transmission lines.",
    answer: "Signal attenuation is the reduction in signal amplitude as it travels through a transmission line due to resistance, dielectric losses, and radiation. Attenuation increases with frequency, line length, and poor impedance matching. Higher attenuation requires signal amplification or use of lower frequencies. This is critical in military communications systems.",
    difficulty: "Hard"
  },
  {
    id: 1102,
    subject: "Electronics Information",
    question: "What is characteristic impedance of a transmission line and why is it important?",
    answer: "Characteristic impedance (Z₀) is the natural impedance of a transmission line determined by its physical properties (inductance per unit length divided by capacitance per unit length). For maximum power transfer, load impedance should match characteristic impedance. Mismatches cause reflections that distort signals, which is critical in high-frequency applications.",
    difficulty: "Hard"
  },
  {
    id: 1103,
    subject: "Electronics Information",
    question: "How does a voltage regulator maintain constant output despite input variations?",
    answer: "A voltage regulator uses feedback control: it compares output voltage to a reference, detects deviations, and adjusts the series or shunt element to correct the error. The feedback loop continuously adjusts the regulator to maintain constant output voltage. Output resistance is low, and line regulation is good, maintaining voltage stability.",
    difficulty: "Hard"
  },
  {
    id: 1104,
    subject: "Electronics Information",
    question: "What is the principle behind a flyback diode in an inductive circuit?",
    answer: "When an inductive circuit is switched off, the inductor opposes current change, creating a large voltage spike (flyback voltage). A flyback diode (placed in parallel with the inductor, reverse-biased during normal operation) provides a conducting path for this energy, preventing damage to switching components. The diode dissipates stored magnetic energy safely.",
    difficulty: "Hard"
  },
  {
    id: 1105,
    subject: "Electronics Information",
    question: "Explain the difference between peak, RMS, and average values of AC voltage.",
    answer: "Peak voltage is the maximum instantaneous value. RMS (Root Mean Square) voltage is 1/√2 (≈0.707) times peak voltage and represents equivalent DC power. Average voltage is the mean over one half-cycle. For AC: V_RMS = V_peak × 0.707. Standard AC ratings (like 120V household) refer to RMS values.",
    difficulty: "Hard"
  },
  {
    id: 1106,
    subject: "Electronics Information",
    question: "Calculate the RMS voltage if the peak voltage of an AC signal is 170V.",
    answer: "Using V_RMS = V_peak × 0.707: V_RMS = 170V × 0.707 ≈ 120V. This corresponds to standard US household voltage. The RMS value represents the equivalent DC voltage that would deliver the same power to a resistive load. This calculation is essential for power calculations in AC circuits.",
    difficulty: "Hard"
  },
  {
    id: 1107,
    subject: "Electronics Information",
    question: "What are the effects of skin effect at high frequencies in conductors?",
    answer: "Skin effect is the tendency of AC current to flow near the surface of a conductor at high frequencies, ignoring the interior. This effectively increases resistance. Skin depth δ = √(2ρ/(ωμ)), where ρ is resistivity, ω is angular frequency, and μ is permeability. This effect is important in microwave and RF applications.",
    difficulty: "Hard"
  },
  {
    id: 1108,
    subject: "Electronics Information",
    question: "How do you select appropriate wire gauge for a circuit in terms of current capacity?",
    answer: "Wire gauge (AWG) must handle the expected current with acceptable voltage drop. Larger diameter wires (lower AWG numbers) carry more current with less resistance. At 12V with 20A, appropriate wire might be 12 AWG; at 120V with 15A, 14 AWG may suffice. Maximum safe current depends on insulation and cooling. Always use tables for specific applications.",
    difficulty: "Hard"
  },
  {
    id: 1109,
    subject: "Electronics Information",
    question: "What is the difference between bipolar junction transistors (BJTs) and field-effect transistors (FETs)?",
    answer: "BJTs are controlled by base current (current-driven), while FETs are controlled by gate voltage (voltage-driven). BJTs generally have higher current gain but lower input impedance; FETs have lower current drain on the control input (higher input impedance). FETs generate less heat and are better for high-impedance circuits. Choice depends on application requirements.",
    difficulty: "Hard"
  },
  {
    id: 1110,
    subject: "Electronics Information",
    question: "Explain the difference between active and passive filters.",
    answer: "Active filters use op-amps with external components to shape frequency response, allowing gain and complex filtering characteristics. Passive filters use only resistors, capacitors, and inductors, limiting attenuation to 6dB per octave per stage. Active filters offer greater flexibility, steeper roll-off, and can provide gain, but require power supply. Passive filters are simpler but less flexible.",
    difficulty: "Hard"
  },
  {
    id: 1111,
    subject: "Electronics Information",
    question: "What is a low-pass filter and what are its military applications?",
    answer: "A low-pass filter passes low frequencies while attenuating high frequencies above the cutoff frequency (f_c = 1/(2πRC) for RC low-pass). Military applications include: noise reduction in sensors, EMI filtering, audio processing in communications, and protecting equipment from high-frequency interference. Critical in battlefield electronics operating in noisy RF environments.",
    difficulty: "Hard"
  },
  {
    id: 1112,
    subject: "Electronics Information",
    question: "What is a high-pass filter and what are its military applications?",
    answer: "A high-pass filter passes high frequencies while attenuating low frequencies. Military applications include: AC coupling (removing DC bias), eliminating low-frequency noise and hum, extracting high-frequency signal components, and AC signal processing in communication systems. Used in radar systems to distinguish from ground clutter at low frequencies.",
    difficulty: "Hard"
  },
  {
    id: 1113,
    subject: "Electronics Information",
    question: "What is a band-pass filter and when would it be used in military systems?",
    answer: "A band-pass filter passes signals within a specific frequency range while attenuating frequencies outside this band. Military applications include: frequency-selective communications (tuning to specific channels), radar systems (selecting target frequencies), identifying specific transmitters, and reducing interference from unwanted frequencies. Critical in crowded RF electromagnetic environments.",
    difficulty: "Hard"
  },
  {
    id: 1114,
    subject: "Electronics Information",
    question: "How does a Zener diode maintain voltage regulation and what is breakdown voltage?",
    answer: "A Zener diode is reverse-biased and operates in the reverse breakdown region where voltage remains nearly constant despite current changes. The breakdown voltage (Zener voltage V_Z) is the voltage at which the diode conducts heavily in reverse. Zener diodes regulate voltage by conducting heavily when voltage exceeds V_Z, clamping it at that level.",
    difficulty: "Hard"
  },
  {
    id: 1115,
    subject: "Electronics Information",
    question: "What is an LED and how does it differ from a regular diode?",
    answer: "An LED (Light Emitting Diode) is a semiconductor that emits light when forward-biased. Unlike regular diodes, LEDs have a wider bandgap energy that corresponds to photon emission (light). LEDs are used as indicators and displays. They require current-limiting resistors to prevent overcurrent, operate at specific forward voltages (typically 1.5-3.3V), and are highly efficient.",
    difficulty: "Hard"
  },
  {
    id: 1116,
    subject: "Electronics Information",
    question: "Calculate the current-limiting resistor for an LED that requires 20mA at 2V forward voltage connected to a 12V supply.",
    answer: "Voltage across resistor: V_R = 12V - 2V = 10V. Using Ohm's Law: R = V_R / I = 10V / 0.020A = 500Ω. Choose a standard 510Ω resistor. This protects the LED from overcurrent damage. Proper current limiting is essential for LED longevity and safe operation.",
    difficulty: "Hard"
  },
  {
    id: 1117,
    subject: "Electronics Information",
    question: "How does pulse-width modulation (PWM) control the power to a device?",
    answer: "PWM controls average power by rapidly switching a device on and off at varying duty cycles. Duty cycle percentage = (ON time / Total period) × 100%. Higher duty cycle means more average power. For example, 50% PWM at 100W delivers 50W average. PWM is used in motor speed control, LED brightness, and switching power supplies.",
    difficulty: "Hard"
  },
  {
    id: 1118,
    subject: "Electronics Information",
    question: "What is the difference between series and parallel battery configurations?",
    answer: "Series connection increases voltage (V_total = V1 + V2 + V3...) but capacity remains the same. Parallel connection increases capacity/current capability (C_total = C1 + C2 + C3...) but voltage stays the same. Series-parallel combinations provide both higher voltage and capacity. Choice depends on required voltage and current specifications.",
    difficulty: "Hard"
  },
  {
    id: 1119,
    subject: "Electronics Information",
    question: "Explain how inductive and capacitive loads affect power factor differently.",
    answer: "Inductive loads (motors, transformers) cause current to lag voltage, reducing power factor below 1.0. Capacitive loads cause current to lead voltage. Both reduce efficiency. Inductive loads are more common, and power factor correction uses capacitors to cancel the lag. In military systems, maintaining high power factor ensures efficient power delivery.",
    difficulty: "Hard"
  },
  {
    id: 1120,
    subject: "Electronics Information",
    question: "What is the difference between peak inverse voltage (PIV) and breakdown voltage in diodes?",
    answer: "PIV (Peak Inverse Voltage) is the maximum reverse voltage a diode can withstand without conducting heavily. Breakdown voltage is the specific reverse voltage at which the diode enters reverse conduction (for Zener diodes). Regular diodes should never be exposed to voltages near or exceeding their PIV rating to prevent permanent damage. Selecting diodes with adequate PIV rating is critical for circuit reliability.",
    difficulty: "Hard"
  }
,
  {
    id: 1121,
    subject: "Electronics Information",
    question: "What is an electric current?",
    answer: "Electric current is the flow of electrons through a conductor measured in amperes (A). One ampere equals one coulomb of charge passing through a point per second. Current is essential for powering devices and is denoted by the symbol I in electrical equations.",
    difficulty: "Easy"
  },
  {
    id: 1122,
    subject: "Electronics Information",
    question: "Define voltage in electrical circuits.",
    answer: "Voltage is the electrical potential difference between two points in a circuit, measured in volts (V). It represents the energy per unit charge that drives current through a circuit. Voltage is denoted by V and is the 'push' that causes electrons to move.",
    difficulty: "Easy"
  },
  {
    id: 1123,
    subject: "Electronics Information",
    question: "What is electrical resistance?",
    answer: "Electrical resistance is the opposition to current flow in a conductor, measured in ohms (Ω). Materials have different resistivities; good conductors like copper have low resistance while insulators have very high resistance. Resistance is denoted by R and generates heat when current flows through it.",
    difficulty: "Easy"
  },
  {
    id: 1124,
    subject: "Electronics Information",
    question: "State Ohm's Law.",
    answer: "Ohm's Law states that the current through a conductor is directly proportional to the voltage applied and inversely proportional to its resistance. Mathematically: I = V/R, where I is current (A), V is voltage (V), and R is resistance (Ω). This fundamental law is used in all circuit analysis.",
    difficulty: "Easy"
  },
  {
    id: 1125,
    subject: "Electronics Information",
    question: "What is a series circuit?",
    answer: "A series circuit is one where components are connected end-to-end in a single path. The same current flows through all components. Total resistance is the sum of individual resistances (R_total = R1 + R2 + R3...). If one component fails, the entire circuit stops working.",
    difficulty: "Easy"
  },
  {
    id: 1126,
    subject: "Electronics Information",
    question: "What is a parallel circuit?",
    answer: "A parallel circuit has multiple paths for current flow with components connected across the same voltage source. All components have the same voltage across them. Total resistance is found using 1/R_total = 1/R1 + 1/R2 + 1/R3... If one component fails, others continue operating.",
    difficulty: "Easy"
  },
  {
    id: 1127,
    subject: "Electronics Information",
    question: "What is electrical power?",
    answer: "Electrical power is the rate at which electrical energy is consumed or produced, measured in watts (W). It can be calculated as P = V × I or P = I²R or P = V²/R. One watt equals one joule per second. Power represents how much work electricity can do per unit time.",
    difficulty: "Easy"
  },
  {
    id: 1128,
    subject: "Electronics Information",
    question: "What is a conductor?",
    answer: "A conductor is a material that allows electric current to flow easily due to its abundance of free electrons. Common conductors include copper, aluminum, and silver. These materials have low electrical resistance and are used in wires and electrical components for transmitting electrical energy.",
    difficulty: "Easy"
  },
  {
    id: 1129,
    subject: "Electronics Information",
    question: "What is an insulator?",
    answer: "An insulator is a material that prevents electric current from flowing easily due to tightly bound electrons. Common insulators include rubber, plastic, glass, and ceramic materials. They have very high electrical resistance and are used to prevent electrical shocks and protect conductors.",
    difficulty: "Easy"
  },
  {
    id: 1130,
    subject: "Electronics Information",
    question: "What is a resistor?",
    answer: "A resistor is an electronic component that limits the flow of electric current and converts electrical energy to heat. Resistors are specified by their resistance value in ohms and are color-coded for easy identification. They are used to control current, protect components, and create voltage dividers.",
    difficulty: "Easy"
  },
  {
    id: 1131,
    subject: "Electronics Information",
    question: "What is a capacitor?",
    answer: "A capacitor is an electronic component that stores electrical charge and opposes changes in voltage. It consists of two conducting plates separated by a dielectric material. Capacitors block DC current but allow AC current to pass. They are used in filters, timing circuits, and energy storage.",
    difficulty: "Easy"
  },
  {
    id: 1132,
    subject: "Electronics Information",
    question: "What is an inductor?",
    answer: "An inductor is an electronic component that stores electrical energy in a magnetic field and opposes changes in current. It consists of a coil of wire and creates a magnetic field when current flows through it. Inductors pass DC current easily but oppose AC current, and are used in filters and tuning circuits.",
    difficulty: "Easy"
  },
  {
    id: 1133,
    subject: "Electronics Information",
    question: "What is a diode?",
    answer: "A diode is a two-terminal electronic component that allows current to flow in only one direction. It has an anode (positive) and cathode (negative). Diodes are used in power supplies for rectification, as voltage regulators, and as protection devices. A forward-biased diode conducts; reverse-biased diodes block current.",
    difficulty: "Easy"
  },
  {
    id: 1134,
    subject: "Electronics Information",
    question: "What is a transistor?",
    answer: "A transistor is a three-terminal electronic component used to amplify or switch electronic signals. Transistors can be bipolar (BJT) or field-effect (FET) types. They are fundamental building blocks of modern electronics and are used in amplifiers, switches, and digital logic circuits.",
    difficulty: "Easy"
  },
  {
    id: 1135,
    subject: "Electronics Information",
    question: "What is the difference between AC and DC current?",
    answer: "Direct current (DC) flows in one direction continuously, while alternating current (AC) periodically reverses direction. DC is provided by batteries and used in electronic devices; AC comes from power plants and is used for household power transmission. AC can be converted to DC using a rectifier.",
    difficulty: "Easy"
  },
  {
    id: 1136,
    subject: "Electronics Information",
    question: "What is frequency in AC circuits?",
    answer: "Frequency is the number of complete cycles of an AC signal per second, measured in hertz (Hz). Standard household frequency in the US is 60 Hz, meaning the current alternates 60 times per second. Higher frequencies are used in radio communications and electronic devices.",
    difficulty: "Easy"
  },
  {
    id: 1137,
    subject: "Electronics Information",
    question: "What is a transformer?",
    answer: "A transformer is an electrical device that transfers energy between two circuits using electromagnetic induction. It consists of primary and secondary coils around an iron core. Transformers can step up (increase) or step down (decrease) voltage and are essential for power distribution and electrical isolation.",
    difficulty: "Easy"
  },
  {
    id: 1138,
    subject: "Electronics Information",
    question: "What is a switch?",
    answer: "A switch is an electrical component that opens or closes a circuit to control the flow of current. When closed, it allows current to flow; when open, it blocks current. Switches are used to turn devices on/off and are fundamental components in electrical systems.",
    difficulty: "Easy"
  },
  {
    id: 1139,
    subject: "Electronics Information",
    question: "What is a fuse?",
    answer: "A fuse is a protective device that opens a circuit when current exceeds a safe level, preventing fire and damage. It contains a wire that melts if excessive current flows through it. Fuses are rated by current (in amperes) and must be replaced when blown, unlike circuit breakers which can be reset.",
    difficulty: "Easy"
  },
  {
    id: 1140,
    subject: "Electronics Information",
    question: "What is a circuit breaker?",
    answer: "A circuit breaker is a reusable protective device that automatically opens a circuit when current exceeds a safe level. Unlike fuses, circuit breakers can be reset after tripping. They contain a bimetallic strip or electromagnetic coil that responds to excessive current and are used in modern homes.",
    difficulty: "Easy"
  },
  {
    id: 1141,
    subject: "Electronics Information",
    question: "What is ground or earth in electrical systems?",
    answer: "Ground (or earth) is a reference point for electrical potential, typically set to zero volts. It provides a safe return path for current and is used to prevent electrical shocks and equipment damage. Electrical safety depends on proper grounding, which connects conductive paths to the earth.",
    difficulty: "Easy"
  },
  {
    id: 1142,
    subject: "Electronics Information",
    question: "What is electrical energy?",
    answer: "Electrical energy is the energy carried by moving electrons, measured in watt-hours or joules. Energy is the product of power and time: E = P × t. A kilowatt-hour (kWh) is a common unit for measuring electrical energy consumed by household appliances.",
    difficulty: "Easy"
  },
  {
    id: 1143,
    subject: "Electronics Information",
    question: "What is impedance in AC circuits?",
    answer: "Impedance is the total opposition to AC current flow in a circuit, measured in ohms. Unlike DC resistance, impedance includes both resistance and reactance (from capacitors and inductors). Impedance is a complex number: Z = R + jX, where X is reactance.",
    difficulty: "Medium"
  },
  {
    id: 1144,
    subject: "Electronics Information",
    question: "What is reactance in AC circuits?",
    answer: "Reactance is the opposition to AC current caused by capacitors and inductors, measured in ohms. Capacitive reactance (Xc) decreases with frequency, while inductive reactance (XL) increases with frequency. Reactance is proportional to frequency: XL = 2πfL and Xc = 1/(2πfC).",
    difficulty: "Medium"
  },
  {
    id: 1145,
    subject: "Electronics Information",
    question: "Calculate the current through a 100-ohm resistor with 10 volts applied.",
    answer: "Using Ohm's Law: I = V/R = 10V / 100Ω = 0.1 amperes (100 milliamps). This current produces power dissipation: P = V²/R = 100/100 = 1 watt. The resistor generates heat at this rate.",
    difficulty: "Easy"
  },
  {
    id: 1146,
    subject: "Electronics Information",
    question: "Calculate the voltage across a 50-ohm resistor with 2 amperes of current.",
    answer: "Using Ohm's Law: V = I × R = 2A × 50Ω = 100 volts. The power dissipated: P = I²R = 4 × 50 = 200 watts. This high power means the resistor must be rated for this power to avoid damage.",
    difficulty: "Easy"
  },
  {
    id: 1147,
    subject: "Electronics Information",
    question: "Calculate the resistance of a component that draws 3 amperes at 120 volts.",
    answer: "Using Ohm's Law: R = V/I = 120V / 3A = 40 ohms. The power consumed: P = V × I = 120 × 3 = 360 watts. This high power consumption is typical for heating elements in appliances.",
    difficulty: "Easy"
  },
  {
    id: 1148,
    subject: "Electronics Information",
    question: "What is the total resistance of three 100-ohm resistors in series?",
    answer: "In series, resistances add: R_total = R1 + R2 + R3 = 100 + 100 + 100 = 300 ohms. The same current flows through all three. With 60 volts applied, current would be I = 60/300 = 0.2 amperes.",
    difficulty: "Easy"
  },
  {
    id: 1149,
    subject: "Electronics Information",
    question: "What is the total resistance of three 100-ohm resistors in parallel?",
    answer: "In parallel: 1/R_total = 1/100 + 1/100 + 1/100 = 3/100. Therefore R_total = 100/3 ≈ 33.3 ohms. With 60 volts applied, total current would be I = 60/33.3 ≈ 1.8 amperes.",
    difficulty: "Easy"
  },
  {
    id: 1150,
    subject: "Electronics Information",
    question: "Two resistors of 60 ohms and 40 ohms are in series. What is the total resistance?",
    answer: "In series: R_total = 60 + 40 = 100 ohms. The same current flows through both resistors. Voltage divides proportionally: V1 = V_total × (R1/R_total) and V2 = V_total × (R2/R_total).",
    difficulty: "Easy"
  },
  {
    id: 1151,
    subject: "Electronics Information",
    question: "Two resistors of 60 ohms and 40 ohms are in parallel. What is the total resistance?",
    answer: "In parallel: 1/R_total = 1/60 + 1/40 = 2/120 + 3/120 = 5/120. Therefore R_total = 120/5 = 24 ohms. All components experience the same voltage but current divides inversely to resistance.",
    difficulty: "Medium"
  },
  {
    id: 1152,
    subject: "Electronics Information",
    question: "What is the power rating of a device using 5 amperes at 240 volts?",
    answer: "Power: P = V × I = 240V × 5A = 1200 watts or 1.2 kilowatts. This device would use 1.2 kWh of energy if operated for one hour. The current of 5 amperes requires appropriate wiring gauge to handle safely.",
    difficulty: "Easy"
  },
  {
    id: 1153,
    subject: "Electronics Information",
    question: "What is the current drawn by a 1500-watt appliance at 120 volts?",
    answer: "Using P = V × I: I = P/V = 1500W / 120V = 12.5 amperes. This high current requires a 15-ampere or 20-ampere circuit. Resistance: R = V/I = 120/12.5 = 9.6 ohms.",
    difficulty: "Easy"
  },
  {
    id: 1154,
    subject: "Electronics Information",
    question: "What is Kirchhoff's Voltage Law (KVL)?",
    answer: "Kirchhoff's Voltage Law states that the sum of voltages around any closed loop in a circuit equals zero. Going around a loop: V_source - V_R1 - V_R2 - ... = 0. This law is essential for circuit analysis and solving complex circuits with multiple voltage sources.",
    difficulty: "Medium"
  },
  {
    id: 1155,
    subject: "Electronics Information",
    question: "What is Kirchhoff's Current Law (KCL)?",
    answer: "Kirchhoff's Current Law states that the sum of currents entering a node equals the sum of currents leaving that node. This principle is based on charge conservation. At any junction in a circuit: I_in1 + I_in2 + ... = I_out1 + I_out2 + ...",
    difficulty: "Medium"
  },
  {
    id: 1156,
    subject: "Electronics Information",
    question: "What is the difference between active and passive components?",
    answer: "Active components require external power and can amplify or generate signals (transistors, ICs, amplifiers). Passive components do not require power and only consume or store energy (resistors, capacitors, inductors). Understanding this distinction is crucial for circuit design.",
    difficulty: "Medium"
  },
  {
    id: 1157,
    subject: "Electronics Information",
    question: "What is a semiconductor?",
    answer: "A semiconductor is a material with electrical properties between conductors and insulators, typically silicon or germanium. Semiconductors form the basis of diodes and transistors by using doping to create regions with different electrical properties. They enable modern electronics through controlled conduction.",
    difficulty: "Medium"
  },
  {
    id: 1158,
    subject: "Electronics Information",
    question: "What is an N-type semiconductor?",
    answer: "An N-type (negative) semiconductor is created by doping pure silicon with donor impurities like phosphorus. These impurities contribute extra electrons, making electrons the majority charge carriers. N-type material is used in the negative side of a diode and has negative charge carriers.",
    difficulty: "Medium"
  },
  {
    id: 1159,
    subject: "Electronics Information",
    question: "What is a P-type semiconductor?",
    answer: "A P-type (positive) semiconductor is created by doping pure silicon with acceptor impurities like boron. These impurities create holes (missing electrons), making holes the majority charge carriers. P-type material is used in the positive side of a diode and represents positive charge carriers.",
    difficulty: "Medium"
  },
  {
    id: 1160,
    subject: "Electronics Information",
    question: "What is a PN junction?",
    answer: "A PN junction is the boundary between P-type and N-type semiconductor material. When forward-biased (positive to P-side), it conducts; when reverse-biased (negative to P-side), it blocks current. The junction creates a depletion region and is the basis for diodes and transistor operation.",
    difficulty: "Medium"
  },
  {
    id: 1161,
    subject: "Electronics Information",
    question: "What is forward bias in a diode?",
    answer: "Forward bias occurs when the positive terminal of a voltage source connects to the P-type material and negative to N-type. This reduces the depletion region width and allows current to flow easily through the diode. The diode conducts with a small voltage drop (typically 0.7V for silicon).",
    difficulty: "Medium"
  },
  {
    id: 1162,
    subject: "Electronics Information",
    question: "What is reverse bias in a diode?",
    answer: "Reverse bias occurs when negative voltage is applied to the P-type material and positive to N-type. This widens the depletion region and blocks current flow. Diodes block current in reverse bias except for a small leakage current. Excessive reverse voltage causes breakdown.",
    difficulty: "Medium"
  },
  {
    id: 1163,
    subject: "Electronics Information",
    question: "What is a Zener diode?",
    answer: "A Zener diode is a heavily doped diode that conducts significantly when reverse-biased at a specific voltage (Zener voltage). It is designed to break down at a controlled voltage without damage. Zener diodes are used as voltage regulators and protection devices in circuits.",
    difficulty: "Medium"
  },
  {
    id: 1164,
    subject: "Electronics Information",
    question: "What is a light-emitting diode (LED)?",
    answer: "An LED is a diode that emits light when forward-biased. When current flows through the PN junction, electrons recombine with holes, releasing energy as photons (light). LEDs are used as indicators, displays, and lighting because they are efficient and long-lasting.",
    difficulty: "Medium"
  },
  {
    id: 1165,
    subject: "Electronics Information",
    question: "What is an integrated circuit (IC)?",
    answer: "An integrated circuit is a complex electronic circuit with many components (transistors, resistors, capacitors) manufactured on a single semiconductor chip. ICs miniaturize circuits, improve reliability, and reduce cost. Examples include microprocessors, memory chips, and operational amplifiers.",
    difficulty: "Medium"
  },
  {
    id: 1166,
    subject: "Electronics Information",
    question: "What is an operational amplifier (op-amp)?",
    answer: "An operational amplifier is an integrated circuit that amplifies the difference between two input signals. It has two inputs (inverting and non-inverting), one output, and requires dual power supplies. Op-amps are used in amplifiers, filters, comparators, and many analog circuits.",
    difficulty: "Medium"
  },
  {
    id: 1167,
    subject: "Electronics Information",
    question: "What is a logic gate?",
    answer: "A logic gate is a digital circuit that performs Boolean operations on binary inputs (0 or 1). Common gates include AND, OR, NOT, NAND, NOR, and XOR. Logic gates are fundamental building blocks of digital electronics and computer processors.",
    difficulty: "Medium"
  },
  {
    id: 1168,
    subject: "Electronics Information",
    question: "What is an AND gate?",
    answer: "An AND gate outputs 1 only when all inputs are 1. With two inputs: output is 1 only if both input A AND input B are 1. AND gates are used in digital circuits to test if multiple conditions are simultaneously true.",
    difficulty: "Medium"
  },
  {
    id: 1169,
    subject: "Electronics Information",
    question: "What is an OR gate?",
    answer: "An OR gate outputs 1 when at least one input is 1. With two inputs: output is 1 if either input A OR input B (or both) is 1. OR gates are used to combine multiple conditions in digital circuits.",
    difficulty: "Medium"
  },
  {
    id: 1170,
    subject: "Electronics Information",
    question: "What is a NOT gate (inverter)?",
    answer: "A NOT gate inverts its input: if input is 0, output is 1; if input is 1, output is 0. It has one input and one output. NOT gates are used to reverse logic signals and are combined with other gates to create NAND and NOR gates.",
    difficulty: "Medium"
  },
  {
    id: 1171,
    subject: "Electronics Information",
    question: "What is a flip-flop circuit?",
    answer: "A flip-flop is a digital circuit that stores one bit of information (0 or 1). It has two stable states and switches between them based on input signals. Flip-flops are used in counters, shift registers, and memory elements of digital circuits.",
    difficulty: "Hard"
  },
  {
    id: 1172,
    subject: "Electronics Information",
    question: "What is the function of a rectifier?",
    answer: "A rectifier converts AC current to DC current by using diodes to block the negative half-cycles of AC. A half-wave rectifier uses one diode and passes every other half-cycle. A full-wave rectifier uses four diodes and passes both half-cycles, producing higher average DC voltage.",
    difficulty: "Hard"
  },
  {
    id: 1173,
    subject: "Electronics Information",
    question: "What is the relationship between primary and secondary voltage in a transformer?",
    answer: "The voltage ratio in a transformer equals the turns ratio: V_secondary/V_primary = N_secondary/N_primary. If the secondary has more turns (step-up transformer), voltage increases and current decreases. If fewer turns (step-down), voltage decreases and current increases. Power remains nearly constant.",
    difficulty: "Hard"
  },
  {
    id: 1174,
    subject: "Electronics Information",
    question: "What is a current transformer?",
    answer: "A current transformer steps down high current to a measurable level for instruments. It has many primary turns and few secondary turns. Current transformers are used with ammeters to safely measure large currents in power systems without the ammeter being destroyed.",
    difficulty: "Hard"
  },
  {
    id: 1175,
    subject: "Electronics Information",
    question: "What is power factor in AC circuits?",
    answer: "Power factor is the ratio of real power to apparent power: PF = cos(φ), where φ is the phase angle between voltage and current. A power factor of 1 (or 100%) means all power is real; less than 1 means some is reactive. Poor power factor indicates inefficiency.",
    difficulty: "Hard"
  },
  {
    id: 1176,
    subject: "Electronics Information",
    question: "What is reactive power in AC circuits?",
    answer: "Reactive power is the portion of apparent power that oscillates between source and load without performing work, measured in VARs (volt-ampere reactive). It results from capacitors and inductors and is calculated as Q = V × I × sin(φ). High reactive power reduces power factor.",
    difficulty: "Hard"
  },
  {
    id: 1177,
    subject: "Electronics Information",
    question: "What is the relationship between frequency and inductive reactance?",
    answer: "Inductive reactance is directly proportional to frequency: XL = 2πfL, where f is frequency in Hz and L is inductance in henries. At zero frequency (DC), XL = 0 (inductor acts as short circuit). At higher frequencies, inductors provide greater opposition to current.",
    difficulty: "Hard"
  },
  {
    id: 1178,
    subject: "Electronics Information",
    question: "What is the relationship between frequency and capacitive reactance?",
    answer: "Capacitive reactance is inversely proportional to frequency: Xc = 1/(2πfC), where f is frequency in Hz and C is capacitance in farads. At low frequencies, Xc is large (capacitor blocks current). At high frequencies, Xc is small (capacitor passes current).",
    difficulty: "Hard"
  },
  {
    id: 1179,
    subject: "Electronics Information",
    question: "What is resonance in an LC circuit?",
    answer: "Resonance occurs when inductive reactance equals capacitive reactance (XL = Xc), and the circuit impedance is minimized. At resonance frequency: f = 1/(2π√LC). Impedance is purely resistive and minimum; current is maximum. Resonance is used in radio tuning and filters.",
    difficulty: "Hard"
  },
  {
    id: 1180,
    subject: "Electronics Information",
    question: "What is bandwidth in a tuned circuit?",
    answer: "Bandwidth is the range of frequencies over which a circuit responds effectively, typically measured between points where power is half the maximum (3dB points). Narrow bandwidth indicates sharp frequency selectivity (high Q factor); wide bandwidth indicates broader response. Bandwidth = f_resonance / Q factor.",
    difficulty: "Hard"
  },
  {
    id: 1181,
    subject: "Electronics Information",
    question: "What is a filter circuit?",
    answer: "A filter selectively passes or blocks signals at specific frequencies. Low-pass filters attenuate high frequencies; high-pass filters attenuate low frequencies; band-pass filters pass a specific frequency range; band-stop filters block a specific range. Filters are crucial in audio, radio, and power electronics.",
    difficulty: "Medium"
  },
  {
    id: 1182,
    subject: "Electronics Information",
    question: "What is the purpose of a voltage regulator?",
    answer: "A voltage regulator maintains constant output voltage despite variations in input voltage or load current. Linear regulators use a series transistor; switching regulators use pulse-width modulation for higher efficiency. Regulators are essential in power supplies to provide stable power for electronic circuits.",
    difficulty: "Medium"
  },
  {
    id: 1183,
    subject: "Electronics Information",
    question: "What is a power supply?",
    answer: "A power supply converts input power (AC from wall outlet) to DC at desired voltage and current levels for electronic equipment. It includes a transformer, rectifier, filter, and voltage regulator. Regulated power supplies maintain constant output voltage; unregulated supplies have varying output with load changes.",
    difficulty: "Medium"
  },
  {
    id: 1184,
    subject: "Electronics Information",
    question: "What is electromagnetic induction?",
    answer: "Electromagnetic induction is the production of voltage when a magnetic field changes in a conductor. Faraday's Law states: V = -N × (dΦ/dt), where Φ is magnetic flux. This principle enables transformers, generators, and inductive circuits to function.",
    difficulty: "Hard"
  },
  {
    id: 1185,
    subject: "Electronics Information",
    question: "What is mutual inductance?",
    answer: "Mutual inductance occurs when current change in one coil induces voltage in another coil. Coupling coefficient (k) ranges from 0 (no coupling) to 1 (perfect coupling). Transformers rely on mutual inductance to transfer energy between primary and secondary coils.",
    difficulty: "Hard"
  },
  {
    id: 1186,
    subject: "Electronics Information",
    question: "What is self-inductance?",
    answer: "Self-inductance is the property of a coil to oppose changes in its own current through magnetic field effects. Inductance is measured in henries (H). When current through an inductor changes, it induces a back-voltage opposing the change (Lenz's Law).",
    difficulty: "Hard"
  },
  {
    id: 1187,
    subject: "Electronics Information",
    question: "What is the purpose of a decoupling capacitor?",
    answer: "A decoupling capacitor removes high-frequency noise from power supply rails in circuits. It provides a local source of charge to supply transient current demands, preventing voltage ripple and spikes. Decoupling capacitors are placed close to IC power pins.",
    difficulty: "Hard"
  },
  {
    id: 1188,
    subject: "Electronics Information",
    question: "What is crosstalk in circuits?",
    answer: "Crosstalk occurs when signal in one conductor or trace couples to adjacent conductors, causing unwanted interference. It results from capacitive and inductive coupling between nearby conductors. Minimizing crosstalk requires proper PCB layout with controlled trace separation and shielding.",
    difficulty: "Hard"
  },
  {
    id: 1189,
    subject: "Electronics Information",
    question: "What is impedance matching?",
    answer: "Impedance matching ensures maximum power transfer between source and load by making their impedances equal. In transmission lines, impedance matching prevents signal reflections and standing waves. Impedance must be matched for efficient RF and signal transmission.",
    difficulty: "Hard"
  },
  {
    id: 1190,
    subject: "Electronics Information",
    question: "What is a bimetallic strip?",
    answer: "A bimetallic strip consists of two different metals bonded together. When heated, they expand differently, causing the strip to bend. Used in thermostats and circuit breakers to respond to temperature changes, converting thermal energy into mechanical motion.",
    difficulty: "Easy"
  },
  {
    id: 1191,
    subject: "Electronics Information",
    question: "What is an ammeter?",
    answer: "An ammeter measures electric current flowing through a circuit, with readings in amperes. It must be connected in series with the circuit to measure current. Ammeters have very low internal resistance to minimize voltage drop and circuit disruption.",
    difficulty: "Easy"
  },
  {
    id: 1192,
    subject: "Electronics Information",
    question: "What is a voltmeter?",
    answer: "A voltmeter measures the electrical potential difference between two points, with readings in volts. It is connected in parallel across components to measure voltage. Voltmeters have very high internal resistance to minimize current draw from the circuit.",
    difficulty: "Easy"
  },
  {
    id: 1193,
    subject: "Electronics Information",
    question: "What is an ohmmeter?",
    answer: "An ohmmeter measures electrical resistance of components or circuits, with readings in ohms. It provides its own internal voltage source to drive current through the resistance being measured. Ohmmeters should only be used on unpowered circuits to avoid damage.",
    difficulty: "Easy"
  },
  {
    id: 1194,
    subject: "Electronics Information",
    question: "What is a multimeter?",
    answer: "A multimeter is a versatile instrument combining ammeter, voltmeter, and ohmmeter functions. It can measure DC/AC voltage, current, and resistance. Digital multimeters are common and display readings on LCD screens, replacing multiple individual meters.",
    difficulty: "Easy"
  },
  {
    id: 1195,
    subject: "Electronics Information",
    question: "What is the purpose of a megohmmeter?",
    answer: "A megohmmeter measures very high resistances (megohms) used in insulation testing. It applies higher voltage than a standard ohmmeter to test insulation breakdown. Used to verify wire and equipment insulation integrity, critical for electrical safety.",
    difficulty: "Medium"
  },
  {
    id: 1196,
    subject: "Electronics Information",
    question: "What is an oscilloscope?",
    answer: "An oscilloscope displays electrical signals as waveforms on a screen, allowing analysis of signal shape, frequency, and amplitude. It has vertical (voltage) and horizontal (time) axes. Oscilloscopes are essential for troubleshooting and analyzing AC circuits and signals.",
    difficulty: "Medium"
  },
  {
    id: 1197,
    subject: "Electronics Information",
    question: "What is a signal generator?",
    answer: "A signal generator produces electrical signals of specific frequency, amplitude, and waveform for testing purposes. It can generate sine waves, square waves, triangular waves, and pulses. Signal generators are used to test circuits and troubleshoot electronic equipment.",
    difficulty: "Medium"
  },
  {
    id: 1198,
    subject: "Electronics Information",
    question: "What is an antenna?",
    answer: "An antenna converts electrical signals to electromagnetic waves for transmission, or electromagnetic waves to electrical signals for reception. Antenna design determines frequency selectivity and radiation pattern. Antennas are essential components of radio communication systems.",
    difficulty: "Medium"
  },
  {
    id: 1199,
    subject: "Electronics Information",
    question: "What is modulation in radio communication?",
    answer: "Modulation is the process of encoding information onto a carrier wave by varying its properties. AM (Amplitude Modulation) varies amplitude; FM (Frequency Modulation) varies frequency. Modulation allows multiple signals to share the same communication channel.",
    difficulty: "Hard"
  },
  {
    id: 1200,
    subject: "Electronics Information",
    question: "What is demodulation in radio communication?",
    answer: "Demodulation extracts the information signal from a modulated carrier wave. AM demodulation uses rectification and filtering; FM demodulation uses frequency-to-voltage converters. Demodulation recovers the original information at the receiving end of communication.",
    difficulty: "Hard"
  },
  {
    id: 1201,
    subject: "Electronics Information",
    question: "What is a bipolar junction transistor (BJT)?",
    answer: "A BJT is a three-terminal transistor with collector, base, and emitter. It can be NPN or PNP type. The small base current controls large collector-emitter current, enabling amplification and switching. BJTs are used in amplifiers, switches, and digital logic circuits.",
    difficulty: "Medium"
  },
  {
    id: 1202,
    subject: "Electronics Information",
    question: "What is a field-effect transistor (FET)?",
    answer: "A FET is a voltage-controlled transistor with gate, source, and drain terminals. The voltage on the gate controls current between source and drain. FETs have high input impedance and low power consumption, making them ideal for integrated circuits and high-impedance circuits.",
    difficulty: "Medium"
  },
  {
    id: 1203,
    subject: "Electronics Information",
    question: "What is a MOSFET?",
    answer: "A MOSFET (Metal-Oxide-Semiconductor FET) is a type of FET with an insulated gate. It has extremely high input impedance and is widely used in digital circuits and high-frequency applications. MOSFETs can be enhancement-mode or depletion-mode types.",
    difficulty: "Hard"
  },
  {
    id: 1204,
    subject: "Electronics Information",
    question: "What is thermal runaway in semiconductors?",
    answer: "Thermal runaway occurs when heat generated in a semiconductor increases temperature, which increases current, generating more heat in a positive feedback loop. This can destroy the device if not controlled through heat sinking or current limiting. Proper thermal management prevents runaway.",
    difficulty: "Hard"
  },
  {
    id: 1205,
    subject: "Electronics Information",
    question: "What is a heat sink?",
    answer: "A heat sink is a component that dissipates heat from semiconductor devices through increased surface area. Typically made of aluminum or copper, it is attached to hot components to maintain safe operating temperatures. Proper heat sinking prevents thermal damage and extends component life.",
    difficulty: "Medium"
  },
  {
    id: 1206,
    subject: "Electronics Information",
    question: "What is surge current in circuits?",
    answer: "Surge current is the sudden large current spike when power is first applied to a circuit. Inrush current in transformers and capacitor charging cause surges. Surge suppressors (fuses, current-limiting resistors) protect against damage from excessive surge currents.",
    difficulty: "Medium"
  },
  {
    id: 1207,
    subject: "Electronics Information",
    question: "What is a commutator in electric motors?",
    answer: "A commutator is a split ring on motor shafts that reverses current direction in armature coils twice per revolution. This maintains continuous rotational force on the spinning coil in the magnetic field. Commutators convert DC current reversals into unidirectional mechanical rotation.",
    difficulty: "Medium"
  },
  {
    id: 1208,
    subject: "Electronics Information",
    question: "What is a brush in electric motors?",
    answer: "Brushes are carbon contact pieces that maintain electrical connection to the rotating commutator in DC motors. As the commutator rotates, brushes slide against it, ensuring continuous current flow despite rotation. Worn brushes cause poor motor performance and must be replaced.",
    difficulty: "Medium"
  },
  {
    id: 1209,
    subject: "Electronics Information",
    question: "What is back EMF in motors?",
    answer: "Back EMF (electromotive force) is the voltage generated by a rotating motor that opposes applied voltage. It equals: V_back = V_applied - I × R. Back EMF increases with motor speed. At startup with zero speed, back EMF is zero, allowing high inrush current.",
    difficulty: "Hard"
  },
  {
    id: 1210,
    subject: "Electronics Information",
    question: "What is motor torque?",
    answer: "Motor torque is the rotational force produced by a motor, proportional to current and magnetic field strength. Torque = K × I × B, where K is motor constant, I is current, and B is magnetic field. Higher torque enables motors to drive heavier loads.",
    difficulty: "Medium"
  },
  {
    id: 1211,
    subject: "Electronics Information",
    question: "What is motor efficiency?",
    answer: "Motor efficiency is the ratio of mechanical power output to electrical power input: Efficiency = (Mechanical Power / Electrical Power) × 100%. Typical motor efficiency ranges from 70% to 95%. Losses include resistive heating, friction, and windage.",
    difficulty: "Medium"
  },
  {
    id: 1212,
    subject: "Electronics Information",
    question: "What is a relay?",
    answer: "A relay is an electromagnetic switch controlled by current in one circuit to switch connections in another circuit. The electromagnet attracts an armature when energized, closing contacts. Relays isolate control circuits from high-power circuits and enable remote switching.",
    difficulty: "Medium"
  },
  {
    id: 1213,
    subject: "Electronics Information",
    question: "What is a solenoid?",
    answer: "A solenoid is a coil of wire that produces a magnetic field when current flows through it. The magnetic field pulls a movable iron plunger. Solenoids convert electrical energy to linear mechanical motion and are used in relays, locks, and actuators.",
    difficulty: "Medium"
  },
  {
    id: 1214,
    subject: "Electronics Information",
    question: "What is a contactor?",
    answer: "A contactor is a heavy-duty relay designed to switch large currents and voltages in industrial applications. It has electromagnetically operated contacts that close with coil energization. Contactors can control motor circuits and high-power loads safely.",
    difficulty: "Medium"
  },
  {
    id: 1215,
    subject: "Electronics Information",
    question: "What is an electrical short circuit?",
    answer: "A short circuit occurs when a low-resistance path forms between different voltage points, bypassing normal circuit components. This causes excessive current flow that can damage equipment and create fire hazards. Fuses and circuit breakers protect against short circuits.",
    difficulty: "Easy"
  },
  {
    id: 1216,
    subject: "Electronics Information",
    question: "What is an open circuit?",
    answer: "An open circuit occurs when the normal current path is broken, interrupting current flow. This may result from broken wires, blown fuses, or open switches. No current flows in an open circuit regardless of applied voltage.",
    difficulty: "Easy"
  },
  {
    id: 1217,
    subject: "Electronics Information",
    question: "What is electrical shock?",
    answer: "Electrical shock occurs when current flows through the human body, potentially causing injury or death. Current as low as 0.1 ampere can be fatal; 0.001-0.005 ampere causes pain. Proper grounding, insulation, and safety devices protect against electrical shock.",
    difficulty: "Easy"
  },
  {
    id: 1218,
    subject: "Electronics Information",
    question: "What is GFCI (Ground Fault Circuit Interrupter)?",
    answer: "A GFCI is a safety device that detects ground faults (current leakage to ground) and disconnects power within milliseconds. It can detect faults as small as 5 milliamps. GFCIs are required in bathrooms and kitchens to prevent electrical shock from damaged equipment.",
    difficulty: "Medium"
  },
  {
    id: 1219,
    subject: "Electronics Information",
    question: "What is an arc flash?",
    answer: "An arc flash is a sudden release of electrical energy that occurs when an electric arc is established between conductors. It produces extremely high temperatures (up to 35,000°F) and can cause severe burns. Proper arc flash safety precautions are essential in electrical work.",
    difficulty: "Hard"
  },
  {
    id: 1220,
    subject: "Electronics Information",
    question: "What is electrical safety equipment?",
    answer: "Electrical safety equipment includes insulated tools, insulated gloves, safety glasses, arc-rated clothing, and grounding straps. This equipment protects workers from electrical hazards including shock, arc flash, and burns. Proper use of safety equipment is mandatory in electrical work environments.",
    difficulty: "Easy"
  }
,
  {
    id: 1221,
    subject: "Mechanical Comprehension",
    question: "What is a lever?",
    answer: "A lever is a simple machine consisting of a rigid bar that rotates around a fixed point called a fulcrum. It reduces the effort needed to lift or move an object. Example: A seesaw is a lever where the fulcrum is in the middle, allowing two people to balance or lift weight with less effort.",
    difficulty: "Easy"
  },
  {
    id: 1222,
    subject: "Mechanical Comprehension",
    question: "What is mechanical advantage?",
    answer: "Mechanical advantage is the ratio of the output force to the input force. It shows how much easier a machine makes work. For a lever, MA = length of effort arm / length of resistance arm. A lever with MA of 3 means you need only 1/3 the force to lift the same load.",
    difficulty: "Easy"
  },
  {
    id: 1223,
    subject: "Mechanical Comprehension",
    question: "How do pulleys reduce effort?",
    answer: "Pulleys change the direction of force and, when combined, can reduce the effort needed. A single fixed pulley changes direction. A movable pulley halves the force needed to lift an object. With four pulleys in a system, you'd need only 1/4 the force, but must pull the rope 4 times as far.",
    difficulty: "Easy"
  },
  {
    id: 1224,
    subject: "Mechanical Comprehension",
    question: "What is friction?",
    answer: "Friction is the resistance force between two surfaces in contact. It opposes motion and depends on the materials involved and the normal force pressing them together. Example: Sandpaper has high friction, making it useful for smoothing wood, while ice has low friction, making surfaces slippery.",
    difficulty: "Easy"
  },
  {
    id: 1225,
    subject: "Mechanical Comprehension",
    question: "What is an inclined plane?",
    answer: "An inclined plane is a flat surface tilted at an angle. It reduces the force needed to raise an object by spreading the work over a longer distance. The gentler the slope, the less force needed but the longer the distance. Formula: MA = length of slope / vertical height.",
    difficulty: "Easy"
  },
  {
    id: 1226,
    subject: "Mechanical Comprehension",
    question: "What is a wedge?",
    answer: "A wedge is a simple machine shaped like a triangle that converts downward force into sideways force. It's used to split, cut, or separate objects. Example: An axe uses a wedge shape to split wood. A door wedge uses the wedge principle to hold a door open.",
    difficulty: "Easy"
  },
  {
    id: 1227,
    subject: "Mechanical Comprehension",
    question: "What is a screw?",
    answer: "A screw is an inclined plane wrapped around a cylinder. It converts rotational motion into linear motion. The threads are like the ramp of an inclined plane. Example: Screwing a screw into wood uses less force than pushing it straight in, but requires more rotation.",
    difficulty: "Easy"
  },
  {
    id: 1228,
    subject: "Mechanical Comprehension",
    question: "How do gears work?",
    answer: "Gears are wheels with teeth that mesh together to transmit motion and force. When a small gear drives a larger gear, the larger gear rotates slower but with more force (increased torque). When a large gear drives a small gear, speed increases but force decreases.",
    difficulty: "Easy"
  },
  {
    id: 1229,
    subject: "Mechanical Comprehension",
    question: "What is pressure?",
    answer: "Pressure is force divided by area (P = F/A). It measures how concentrated a force is. Higher pressure results from greater force or smaller area. Example: A knife cuts better than a fork because the blade concentrates force into a smaller area, creating higher pressure.",
    difficulty: "Easy"
  },
  {
    id: 1230,
    subject: "Mechanical Comprehension",
    question: "What is Pascal's Law?",
    answer: "Pascal's Law states that pressure applied to a confined fluid is transmitted equally in all directions. This principle is used in hydraulic systems like car brakes. When you push the brake pedal (small area), it creates pressure transmitted equally through the brake fluid to larger pistons in each wheel.",
    difficulty: "Easy"
  },
  {
    id: 1231,
    subject: "Mechanical Comprehension",
    question: "How do hydraulic systems provide mechanical advantage?",
    answer: "Hydraulic systems use Pascal's Law with pistons of different sizes. A small piston with force applied creates pressure that acts on a larger piston. Since pressure is equal, the larger piston produces greater output force. MA = large piston area / small piston area.",
    difficulty: "Medium"
  },
  {
    id: 1232,
    subject: "Mechanical Comprehension",
    question: "What is velocity?",
    answer: "Velocity is the rate of change of position in a specific direction. Unlike speed, velocity includes direction. Formula: v = distance / time. Example: Moving 100 meters east in 10 seconds has a velocity of 10 m/s east. Velocity is a vector quantity.",
    difficulty: "Easy"
  },
  {
    id: 1233,
    subject: "Mechanical Comprehension",
    question: "What is acceleration?",
    answer: "Acceleration is the rate of change of velocity over time. Formula: a = (final velocity - initial velocity) / time. Example: A car going from 0 to 60 mph in 10 seconds has an acceleration of 6 mph per second. Objects can accelerate even at constant speed if direction changes.",
    difficulty: "Easy"
  },
  {
    id: 1234,
    subject: "Mechanical Comprehension",
    question: "What is Newton's First Law of Motion?",
    answer: "Objects at rest stay at rest, and objects in motion stay in motion unless acted upon by an external force. This is called inertia. Example: In a car that suddenly stops, passengers continue moving forward due to inertia until they hit something or friction slows them.",
    difficulty: "Easy"
  },
  {
    id: 1235,
    subject: "Mechanical Comprehension",
    question: "What is Newton's Second Law of Motion?",
    answer: "Force equals mass times acceleration (F = ma). The greater the mass or acceleration, the greater the force needed. Example: Pushing a bicycle is easier than pushing a car because the car has greater mass. Acceleration also matters: faster acceleration requires more force.",
    difficulty: "Easy"
  },
  {
    id: 1236,
    subject: "Mechanical Comprehension",
    question: "What is Newton's Third Law of Motion?",
    answer: "For every action, there is an equal and opposite reaction. Forces always come in pairs. Example: When you push on a wall, the wall pushes back on you with equal force. When a rocket expels exhaust, the exhaust pushes the rocket forward.",
    difficulty: "Easy"
  },
  {
    id: 1237,
    subject: "Mechanical Comprehension",
    question: "What is work in physics?",
    answer: "Work is force applied over distance in the direction of the force. Formula: W = F × d. Unit is joules or foot-pounds. Example: Pushing a box 10 feet with 50 pounds of force = 500 foot-pounds of work. No work occurs if force and motion are perpendicular.",
    difficulty: "Easy"
  },
  {
    id: 1238,
    subject: "Mechanical Comprehension",
    question: "What is power?",
    answer: "Power is the rate at which work is done. Formula: P = W/t or P = F × v. Units are watts or horsepower. Example: Lifting a 100-pound box 10 feet in 5 seconds requires more power than lifting it in 10 seconds, even though the work is the same.",
    difficulty: "Medium"
  },
  {
    id: 1239,
    subject: "Mechanical Comprehension",
    question: "What is energy?",
    answer: "Energy is the ability to do work. Common forms include kinetic energy (motion), potential energy (stored), thermal energy (heat), and chemical energy (in fuel). Energy can transform between forms but is conserved. Example: Water at the top of a waterfall has potential energy that converts to kinetic energy as it falls.",
    difficulty: "Easy"
  },
  {
    id: 1240,
    subject: "Mechanical Comprehension",
    question: "What is kinetic energy?",
    answer: "Kinetic energy is energy due to motion. Formula: KE = 1/2 × m × v². It depends on mass and the square of velocity. Example: A 2-ton truck moving at 30 mph has more kinetic energy than a 1-ton car at 30 mph. Doubling velocity quadruples kinetic energy.",
    difficulty: "Medium"
  },
  {
    id: 1241,
    subject: "Mechanical Comprehension",
    question: "What is potential energy?",
    answer: "Potential energy is stored energy due to position or condition. Gravitational PE = m × g × h. Example: A book on a shelf has gravitational potential energy. If dropped, it converts to kinetic energy. A compressed spring has elastic potential energy that releases when the spring is released.",
    difficulty: "Easy"
  },
  {
    id: 1242,
    subject: "Mechanical Comprehension",
    question: "Explain the principle of mechanical advantage applied to wedges.",
    answer: "A wedge concentrates force into a small area creating high pressure. MA = thickness at top / length of slope. A thin wedge has higher mechanical advantage but requires more force directed downward. A thick wedge needs less downward force but has lower mechanical advantage. Used in axes, chisels, and splitting mauls.",
    difficulty: "Medium"
  },
  {
    id: 1243,
    subject: "Mechanical Comprehension",
    question: "How do gear ratios affect speed and torque?",
    answer: "Gear ratio = number of teeth on driven gear / number of teeth on driving gear. High ratio (large driven gear) = low speed, high torque. Low ratio (small driven gear) = high speed, low torque. Example: In a car, low gears provide high torque for acceleration; high gears provide speed on highways.",
    difficulty: "Medium"
  },
  {
    id: 1244,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between force, area, and pressure in hydraulic systems?",
    answer: "In hydraulic systems: P1 = P2 (pressure is equal). If F1/A1 = F2/A2, then F2 = F1 × (A2/A1). A small force on a small piston creates pressure that produces a large force on a large piston. Example: 100 pounds on a 1-square-inch piston creates pressure that produces 1000 pounds on a 10-square-inch piston.",
    difficulty: "Medium"
  },
  {
    id: 1245,
    subject: "Mechanical Comprehension",
    question: "Explain the three classes of levers.",
    answer: "Class 1: Fulcrum in middle (seesaw, crowbar). Force and resistance on opposite sides. Class 2: Resistance in middle (wheelbarrow, nutcracker). Provides mechanical advantage. Class 3: Effort in middle (fishing rod, tweezers). Provides speed and range of motion but requires more force. Each class has different MA and applications.",
    difficulty: "Medium"
  },
  {
    id: 1246,
    subject: "Mechanical Comprehension",
    question: "How do pulleys affect mechanical advantage in a system?",
    answer: "Single fixed pulley: MA = 1 (changes direction only). Single movable pulley: MA = 2. Two movable pulleys: MA = 4. General rule: MA equals the number of supporting rope segments. Increased MA means less force needed but more rope must be pulled. Example: A block and tackle with 4 supporting segments has MA = 4.",
    difficulty: "Medium"
  },
  {
    id: 1247,
    subject: "Mechanical Comprehension",
    question: "What factors affect the force of friction?",
    answer: "Friction force depends on: 1) Type of surfaces (material determines coefficient), 2) Normal force (weight pressing surfaces together). Friction = coefficient × normal force. Friction does NOT depend on area or speed. Example: Rough rubber on concrete has high friction; smooth ice on smooth steel has low friction.",
    difficulty: "Medium"
  },
  {
    id: 1248,
    subject: "Mechanical Comprehension",
    question: "Explain static versus kinetic friction.",
    answer: "Static friction prevents motion between stationary surfaces (must overcome this to start motion). Kinetic friction occurs between moving surfaces. Static friction is usually greater than kinetic friction. Example: It takes more force to start a box sliding than to keep it sliding. Once moving, kinetic friction takes over.",
    difficulty: "Medium"
  },
  {
    id: 1249,
    subject: "Mechanical Comprehension",
    question: "How does an inclined plane reduce the force needed to lift an object?",
    answer: "On an inclined plane, the weight is resolved into components. The component along the plane is less than the full weight. As the angle decreases, less force is needed but the distance increases. MA = length of slope / vertical height. A very gentle slope has high MA but very long distance.",
    difficulty: "Medium"
  },
  {
    id: 1250,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between distance and force in simple machines?",
    answer: "Simple machines trade distance for force: increased mechanical advantage requires moving through greater distance. Work input = Work output (ignoring friction). If MA = 3, you apply 1/3 the force but move 3 times as far. This principle applies to levers, pulleys, and inclined planes.",
    difficulty: "Medium"
  },
  {
    id: 1251,
    subject: "Mechanical Comprehension",
    question: "How is a screw an inclined plane?",
    answer: "A screw's thread is an inclined plane wrapped around a cylinder. The pitch (distance per turn) represents the height of the plane. The circumference represents the length of the plane. MA = circumference / pitch. One complete turn moves the screw forward by one pitch, providing high mechanical advantage with small rotational force.",
    difficulty: "Medium"
  },
  {
    id: 1252,
    subject: "Mechanical Comprehension",
    question: "What is torque?",
    answer: "Torque is rotational force measured as force times the distance from the pivot. Formula: τ = F × r. Units are foot-pounds or Newton-meters. Example: A wrench 12 inches long with 50 pounds of force applied produces 600 foot-pounds of torque. Longer wrenches or more force increase torque.",
    difficulty: "Medium"
  },
  {
    id: 1253,
    subject: "Mechanical Comprehension",
    question: "How does gravity affect objects on an inclined plane?",
    answer: "Gravity pulls straight down with the object's weight. On an incline, this weight is split into two components: one perpendicular to the plane (normal force) and one parallel to the plane (sliding force). The sliding force depends on the angle: F = W × sin(angle). Steeper angles mean greater sliding force.",
    difficulty: "Medium"
  },
  {
    id: 1254,
    subject: "Mechanical Comprehension",
    question: "What is efficiency in mechanical systems?",
    answer: "Efficiency is useful work output divided by total work input, expressed as a percentage. Efficiency = (work out / work in) × 100%. No machine is 100% efficient due to friction, heat loss, and other factors. A lever with 90% efficiency wastes 10% of input work. Better lubrication and materials increase efficiency.",
    difficulty: "Medium"
  },
  {
    id: 1255,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the velocity of a rotating object?",
    answer: "Tangential velocity = angular velocity × radius. Formula: v = ω × r. Angular velocity is measured in radians per second or revolutions per minute (rpm). Example: A wheel with radius 2 feet rotating at 10 rpm has a tangential velocity of approximately 2.1 feet per second at the rim.",
    difficulty: "Medium"
  },
  {
    id: 1256,
    subject: "Mechanical Comprehension",
    question: "What is the difference between speed and velocity?",
    answer: "Speed is the magnitude of motion (distance/time), a scalar quantity. Velocity includes direction (distance/time + direction), a vector quantity. Example: A car traveling 60 mph north has speed of 60 mph and velocity of 60 mph north. If it turns, velocity changes even if speed stays constant.",
    difficulty: "Easy"
  },
  {
    id: 1257,
    subject: "Mechanical Comprehension",
    question: "How does mass affect acceleration?",
    answer: "According to F = ma, acceleration is inversely proportional to mass. The same force on a heavier object produces less acceleration. Example: Pushing a 100-pound box with 50 pounds of force produces less acceleration than pushing a 50-pound box with the same 50 pounds of force.",
    difficulty: "Medium"
  },
  {
    id: 1258,
    subject: "Mechanical Comprehension",
    question: "What is centripetal force?",
    answer: "Centripetal force is the inward force needed to keep an object moving in a circle. Formula: F = m × v² / r. Greater speed or tighter curves require more force. Example: A car turning at 60 mph needs more centripetal force on a tight curve than on a gentle curve. Friction between tires and road provides this force.",
    difficulty: "Medium"
  },
  {
    id: 1259,
    subject: "Mechanical Comprehension",
    question: "How do you calculate density?",
    answer: "Density = mass / volume. Measured in pounds per cubic foot, kilograms per cubic meter, etc. Objects with higher density are heavier for the same volume. Example: Lead is denser than aluminum, so a lead cube weighs more than an equal-sized aluminum cube. Density helps determine if objects float.",
    difficulty: "Easy"
  },
  {
    id: 1260,
    subject: "Mechanical Comprehension",
    question: "What is buoyancy?",
    answer: "Buoyancy is an upward force on objects immersed in fluids. According to Archimedes' Principle, buoyant force equals the weight of fluid displaced. Objects float when buoyant force equals weight; they sink when denser than fluid. Example: A boat displaces water weighing more than the boat itself, providing sufficient buoyant force.",
    difficulty: "Easy"
  },
  {
    id: 1261,
    subject: "Mechanical Comprehension",
    question: "How do you find the center of gravity?",
    answer: "The center of gravity is the point where all weight appears concentrated. For a uniform object, it's at the geometric center. For irregular objects, it can be found by balancing on a fulcrum. An object's stability depends on its center of gravity: lower CG means more stability. A tall, narrow object tips easier than a wide, low one.",
    difficulty: "Medium"
  },
  {
    id: 1262,
    subject: "Mechanical Comprehension",
    question: "What is resonance?",
    answer: "Resonance occurs when an applied force frequency matches an object's natural frequency. This causes large vibrations. Example: Pushing a swing at the right time increases amplitude; pushing at the wrong time decreases it. Bridge vibrations from marching soldiers can cause resonance damage. Machines are designed to avoid operating at resonant frequencies.",
    difficulty: "Hard"
  },
  {
    id: 1263,
    subject: "Mechanical Comprehension",
    question: "How do brakes work in a mechanical system?",
    answer: "Brakes convert kinetic energy into heat through friction. Friction brake pads press against a rotating disc or drum, creating friction that slows rotation. Hydraulic brakes use fluid pressure to increase the force pressing the pads. More friction or larger brake surface area increases stopping power. ABS systems prevent wheel lock-up during hard braking.",
    difficulty: "Medium"
  },
  {
    id: 1264,
    subject: "Mechanical Comprehension",
    question: "What is a bearing?",
    answer: "A bearing is a mechanical component that reduces friction between moving parts. Ball bearings use spheres rolling between races. Roller bearings use cylinders. Thrust bearings support axial loads. Bearings allow smooth rotation with minimal friction loss. Example: Wheel bearings allow a wheel to spin freely on an axle.",
    difficulty: "Easy"
  },
  {
    id: 1265,
    subject: "Mechanical Comprehension",
    question: "How do lubrication and friction relate?",
    answer: "Lubrication reduces friction by inserting a thin layer between surfaces. Oil and grease are common lubricants. They reduce the coefficient of friction significantly. Proper lubrication extends machine life, reduces wear, and improves efficiency. Example: A dry hinge squeaks and resists rotation; an oiled hinge rotates smoothly with less sound.",
    difficulty: "Easy"
  },
  {
    id: 1266,
    subject: "Mechanical Comprehension",
    question: "What is moment of inertia?",
    answer: "Moment of inertia is rotational resistance, the rotational equivalent of mass. Formula: I = m × r². It depends on mass and distance from axis squared. Greater distance means much more inertia. Example: A spinning figure skater slows down when extending arms (more inertia) and speeds up when pulling arms in (less inertia).",
    difficulty: "Hard"
  },
  {
    id: 1267,
    subject: "Mechanical Comprehension",
    question: "How do you calculate mechanical advantage for a ramp?",
    answer: "For an inclined plane: MA = length of slope / vertical height. This can also be expressed as 1 / sin(angle). A longer, gentler ramp has higher mechanical advantage. Example: A ramp 20 feet long rising 4 feet has MA = 5, meaning 1/5 the force is needed to push an object up versus lifting it straight up.",
    difficulty: "Medium"
  },
  {
    id: 1268,
    subject: "Mechanical Comprehension",
    question: "What is stress and strain?",
    answer: "Stress is force per unit area applied to material. Strain is the resulting deformation (change in length divided by original length). Materials can recover after strain (elastic) or permanently deform (plastic). Example: Pulling a rubber band causes stress and strain; it returns to original shape (elastic). Pulling too hard causes permanent damage (plastic deformation).",
    difficulty: "Hard"
  },
  {
    id: 1269,
    subject: "Mechanical Comprehension",
    question: "How do shock absorbers reduce the effects of impact?",
    answer: "Shock absorbers use springs and dampers to slow down rapid position changes. Springs store energy; dampers dissipate it as heat. Together they extend impact time, reducing peak force. Formula: F = m × a; longer deceleration time means lower force for same distance. Example: A car's suspension absorbs bumps; without it, forces would transfer directly to passengers.",
    difficulty: "Hard"
  },
  {
    id: 1270,
    subject: "Mechanical Comprehension",
    question: "What is the conservation of momentum?",
    answer: "Momentum is mass times velocity. In a closed system, total momentum before collision equals total momentum after. Formula: m1 × v1 + m2 × v2 = constant. Example: Two balls colliding and sticking together: if a 5-pound ball at 10 ft/s hits a stationary 5-pound ball, they both move at 5 ft/s together.",
    difficulty: "Hard"
  },
  {
    id: 1271,
    subject: "Mechanical Comprehension",
    question: "How does a belt and pulley system transmit power?",
    answer: "Belt and pulley systems transfer rotational power between shafts. Speed ratio = diameter of driven pulley / diameter of driving pulley. Large pulley to small pulley = speed increase, torque decrease. Small pulley to large pulley = speed decrease, torque increase. Timing belts prevent slipping in precision applications.",
    difficulty: "Medium"
  },
  {
    id: 1272,
    subject: "Mechanical Comprehension",
    question: "What is a fulcrum?",
    answer: "A fulcrum is the fixed pivot point of a lever. The position of the fulcrum determines the lever class and mechanical advantage. Moving the fulcrum closer to the load increases mechanical advantage but requires more distance. Example: In a crowbar used to pry open a crate, the fulcrum is the edge of the wooden box.",
    difficulty: "Easy"
  },
  {
    id: 1273,
    subject: "Mechanical Comprehension",
    question: "How do you calculate force on an inclined plane?",
    answer: "The component of weight along the plane = weight × sin(angle). The normal force perpendicular to plane = weight × cos(angle). To push up the plane, you must overcome the parallel component plus friction. Example: On a 30-degree slope, sin(30°) = 0.5, so a 100-pound object experiences 50 pounds of downslope force.",
    difficulty: "Medium"
  },
  {
    id: 1274,
    subject: "Mechanical Comprehension",
    question: "What is a cam?",
    answer: "A cam is a rotating or sliding piece that produces motion in another part. Cam shapes convert rotational motion into linear or oscillating motion. Cams are used in engines to open and close valves. A circular cam produces continuous motion; an egg-shaped cam produces variable motion. Followers ride on the cam surface.",
    difficulty: "Medium"
  },
  {
    id: 1275,
    subject: "Mechanical Comprehension",
    question: "How do springs work?",
    answer: "Springs store mechanical energy when compressed or stretched. Force = spring constant × displacement (Hooke's Law: F = kx). Stiffer springs have higher spring constants. Springs return to original shape when released. Example: Car suspension uses springs to absorb bumps; stiffer springs provide firmer ride but less comfort.",
    difficulty: "Medium"
  },
  {
    id: 1276,
    subject: "Mechanical Comprehension",
    question: "What is Hooke's Law?",
    answer: "Hooke's Law states that force is proportional to displacement: F = kx. The spring constant k determines stiffness. If you double the stretch, force doubles. Example: Hanging 10 pounds on a spring stretches it 1 inch; 20 pounds stretches it 2 inches. This is linear until the spring is overstretched.",
    difficulty: "Medium"
  },
  {
    id: 1277,
    subject: "Mechanical Comprehension",
    question: "What is a chain and sprocket system?",
    answer: "Chain and sprocket systems transfer power between shafts using meshed teeth. Speed ratio = number of teeth on driven sprocket / number on driving sprocket. Less slipping than belts; better for high-power transmission. Example: Bicycle chains transfer pedal power to the rear wheel; motorcycle chains handle engine power.",
    difficulty: "Medium"
  },
  {
    id: 1278,
    subject: "Mechanical Comprehension",
    question: "How do you determine the direction of force on a lever?",
    answer: "On a lever, the effort force and resistance force act perpendicular to the lever arm. Direction is determined by the lever orientation. Class 1 levers have effort and resistance on opposite sides. Class 2 and 3 levers have them on the same side. The fulcrum always experiences a reaction force in the opposite direction.",
    difficulty: "Medium"
  },
  {
    id: 1279,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between work and energy?",
    answer: "Work and energy are closely related; work is the transfer of energy. When work is done on an object, its energy increases. When an object does work, its energy decreases. Example: Pushing a box does work and increases its kinetic energy; the box slowing down due to friction does negative work.",
    difficulty: "Medium"
  },
  {
    id: 1280,
    subject: "Mechanical Comprehension",
    question: "How does friction affect a system's efficiency?",
    answer: "Friction converts useful mechanical energy into heat, reducing efficiency. Efficiency = work output / work input. More friction means more energy lost as heat. Example: An engine is 30% efficient; 70% of fuel energy becomes heat. Reducing friction through lubrication and design improves efficiency significantly.",
    difficulty: "Medium"
  },
  {
    id: 1281,
    subject: "Mechanical Comprehension",
    question: "What is a differential?",
    answer: "A differential allows wheels to rotate at different speeds while receiving power from the same source. It's essential for turning corners smoothly. Without a differential, tires would slip or drag on turns. Example: When a car turns, the outer wheel travels faster than the inner wheel; the differential allows this speed difference.",
    difficulty: "Hard"
  },
  {
    id: 1282,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the velocity ratio of gears?",
    answer: "Velocity ratio = speed of input gear / speed of output gear = number of teeth on output gear / number of teeth on input gear. If driving gear has 10 teeth and driven gear has 40 teeth, velocity ratio is 4. The driven gear rotates 1/4 as fast as the driving gear.",
    difficulty: "Medium"
  },
  {
    id: 1283,
    subject: "Mechanical Comprehension",
    question: "What is pitch in relation to threads?",
    answer: "Pitch is the distance along a screw that advances with one complete rotation. Finer pitch (smaller distance) provides higher mechanical advantage but more rotations needed. Coarser pitch (larger distance) needs fewer rotations but lower mechanical advantage. Example: A screw with 1/4-inch pitch advances 1/4 inch per rotation.",
    difficulty: "Medium"
  },
  {
    id: 1284,
    subject: "Mechanical Comprehension",
    question: "How does a toggle clamp work?",
    answer: "A toggle clamp uses linked levers to provide mechanical advantage with a quick-acting mechanism. Pushing the handle activates the linkage, creating a powerful clamping force over a short distance. The mechanical advantage comes from the lever principle. Toggle clamps are used in woodworking, machining, and welding for quick, secure clamping.",
    difficulty: "Medium"
  },
  {
    id: 1285,
    subject: "Mechanical Comprehension",
    question: "What is a ratchet and pawl mechanism?",
    answer: "A ratchet is a gear with angled teeth; a pawl is a lever that engages the teeth. The pawl allows forward rotation but prevents backward rotation. Ratchets enable one-direction power transmission and prevent backslipping. Example: Car jacks use ratchets to allow lifting without fear of sudden lowering.",
    difficulty: "Medium"
  },
  {
    id: 1286,
    subject: "Mechanical Comprehension",
    question: "How does a clutch work?",
    answer: "A clutch is a mechanical device that engages and disengages power transmission. In a car, the clutch disc temporarily breaks connection between engine and transmission for gear changing. Friction between discs transmits or stops rotational power. A disengaged clutch (pedal down) stops power flow; engaged clutch transmits full power.",
    difficulty: "Hard"
  },
  {
    id: 1287,
    subject: "Mechanical Comprehension",
    question: "What is a mechanical advantage ratio?",
    answer: "The mechanical advantage ratio is the ratio of output force to input force. It equals the distance ratio: MA = distance moved by effort / distance moved by load. Example: If you push a lever 6 inches and lift a load only 2 inches, MA = 3. You lift 3 times heavier loads but move 3 times farther.",
    difficulty: "Easy"
  },
  {
    id: 1288,
    subject: "Mechanical Comprehension",
    question: "How do you identify simple machines in compound machines?",
    answer: "Compound machines combine multiple simple machines. Example: A bicycle uses gears (inclined planes wrapped around cylinders), wheels (levers), and bearings (to reduce friction). A pencil sharpener uses gears and wedges. Identifying the component machines helps understand how the device works and calculate overall mechanical advantage.",
    difficulty: "Medium"
  },
  {
    id: 1289,
    subject: "Mechanical Comprehension",
    question: "What is the principle of virtual work?",
    answer: "Virtual work states that for a system in equilibrium, the total virtual work is zero. If forces are in equilibrium, the work done by one force is canceled by the work done by another. This principle helps calculate unknown forces in lever systems. Example: On a balanced seesaw, the moment (force × distance) on each side is equal.",
    difficulty: "Hard"
  },
  {
    id: 1290,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the force needed to overcome friction?",
    answer: "Friction force = coefficient of friction × normal force. The coefficient depends on material surfaces. Steel on steel might be 0.6; ice on ice might be 0.02. Example: Dragging a 100-pound box on concrete (coefficient 0.7) requires at least 70 pounds of force to overcome friction and start motion.",
    difficulty: "Medium"
  },
  {
    id: 1291,
    subject: "Mechanical Comprehension",
    question: "What is a flywheel?",
    answer: "A flywheel is a heavy rotating disc that stores rotational energy and maintains steady speed. Its high moment of inertia resists speed changes. Flywheels smooth out irregular power input and release stored energy during demanding periods. Example: Engine flywheels store energy from power strokes and release it during non-power strokes.",
    difficulty: "Hard"
  },
  {
    id: 1292,
    subject: "Mechanical Comprehension",
    question: "How do you determine the effort force needed for a Class 2 lever?",
    answer: "In a Class 2 lever, the load is between the fulcrum and effort. Formula: Effort × effort arm length = Load × load arm length. Since the load arm is shorter, less effort is needed but the effort moves farther. Example: A wheelbarrow 5 feet from handle to wheel (effort arm) with load 2 feet from wheel (load arm): if load is 100 pounds, effort needed is only 40 pounds.",
    difficulty: "Medium"
  },
  {
    id: 1293,
    subject: "Mechanical Comprehension",
    question: "What is angular velocity?",
    answer: "Angular velocity is the rate of rotation around an axis. Measured in revolutions per minute (rpm), radians per second, or degrees per second. Formula: ω = θ/t (angle/time). Example: A wheel rotating 1000 rpm rotates 16.67 complete revolutions per second (1000/60).",
    difficulty: "Medium"
  },
  {
    id: 1294,
    subject: "Mechanical Comprehension",
    question: "How do you convert linear motion to rotational motion?",
    answer: "Mechanisms like screws, levers, and cams convert linear to rotational motion. A screw converts pushing/pulling force to rotation. A lever can convert linear push to rotational motion about a fulcrum. Cams perform the reverse. Example: A valve stem (linear motion of driver) opens a butterfly valve (rotational motion) in engine carburetor.",
    difficulty: "Hard"
  },
  {
    id: 1295,
    subject: "Mechanical Comprehension",
    question: "What is the principle of moments?",
    answer: "The principle of moments states that for a balanced lever, the clockwise moment equals the counterclockwise moment. Moment = force × perpendicular distance from pivot. Example: On a balanced seesaw, if a 100-pound person sits 5 feet from center, a 50-pound person must sit 10 feet from center to balance.",
    difficulty: "Medium"
  },
  {
    id: 1296,
    subject: "Mechanical Comprehension",
    question: "How do pneumatic systems provide force?",
    answer: "Pneumatic systems use compressed air pressure to create force. Force = pressure × area. Higher pressure or larger area produces more force. Advantages: clean, adjustable, fast. Disadvantages: less power than hydraulics, compressibility causes slower response. Example: Pneumatic tools like impact drivers and nail guns use compressed air.",
    difficulty: "Medium"
  },
  {
    id: 1297,
    subject: "Mechanical Comprehension",
    question: "What is the difference between static and dynamic equilibrium?",
    answer: "Static equilibrium: object is at rest, all forces and moments are balanced. Dynamic equilibrium: object moves at constant velocity, all forces and moments are still balanced (acceleration = 0). Both satisfy F = 0 and torque = 0. Example: A hanging picture is in static equilibrium; a train coasting at constant speed is in dynamic equilibrium.",
    difficulty: "Hard"
  },
  {
    id: 1298,
    subject: "Mechanical Comprehension",
    question: "How do you calculate work done against gravity?",
    answer: "Work against gravity = mass × gravity × height. Formula: W = mgh. Example: Lifting a 50-pound object 10 feet vertically requires 500 foot-pounds of work. A ramp allows the same work but with less force over greater distance. Work amount is the same; how it's distributed changes.",
    difficulty: "Medium"
  },
  {
    id: 1299,
    subject: "Mechanical Comprehension",
    question: "What is a load cell?",
    answer: "A load cell is a sensor that measures force or weight using strain gauges. The applied force causes small deformations that electrical sensors detect. Load cells are used in scales, testing equipment, and industrial automation. They convert mechanical force into electrical signals for measurement and control.",
    difficulty: "Hard"
  },
  {
    id: 1300,
    subject: "Mechanical Comprehension",
    question: "How does a belt-driven system compare to a gear-driven system?",
    answer: "Belt systems: quieter, more flexible, allow larger speed ratios, slip under overload, less maintenance. Gear systems: more efficient, no slipping, better for high-power, noisier, require more precise alignment. Choice depends on application. Example: Belts for adjustable-speed machinery; gears for automotive engines.",
    difficulty: "Medium"
  },
  {
    id: 1301,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between pressure and force in hydraulic cylinders?",
    answer: "In hydraulic cylinders: Pressure = Force / Area, so Force = Pressure × Area. A larger cylinder area produces greater force for the same pressure. Example: A 2-inch diameter cylinder at 1000 psi produces about 3000 pounds of force. Doubling the diameter quadruples the force for the same pressure.",
    difficulty: "Medium"
  },
  {
    id: 1302,
    subject: "Mechanical Comprehension",
    question: "How do you determine whether an object will slide on an incline?",
    answer: "Compare the downslope force component with maximum static friction. Object slides if: weight × sin(angle) > coefficient of friction × weight × cos(angle). Simplifies to: tan(angle) > coefficient of friction. Example: On a 30-degree slope, tan(30°) = 0.577; if friction coefficient is less than 0.577, the object slides.",
    difficulty: "Hard"
  },
  {
    id: 1303,
    subject: "Mechanical Comprehension",
    question: "What is the advantage of a movable pulley?",
    answer: "A movable pulley reduces the force needed by half (mechanical advantage = 2) but requires pulling rope twice as far. The load is supported by two rope segments, so each carries half the weight. Useful for lifting heavy objects with less force. Example: A movable pulley supporting a 100-pound load requires only 50 pounds of pull but twice the rope length.",
    difficulty: "Easy"
  },
  {
    id: 1304,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the force exerted by a spring?",
    answer: "Force = spring constant × displacement (F = kx). The spring constant is specific to each spring (measured in pounds per inch or similar). Example: A spring with constant 100 pounds per inch compressed 2 inches exerts 200 pounds of force. A stiffer spring (higher constant) exerts more force at the same displacement.",
    difficulty: "Easy"
  },
  {
    id: 1305,
    subject: "Mechanical Comprehension",
    question: "What is the purpose of a torque wrench?",
    answer: "A torque wrench ensures bolts are tightened to precise specifications (often measured in foot-pounds). Too little torque: connection too loose, components separate. Too much torque: threads strip, bolts break. Different fasteners require specific torques. Engine bolts, wheel lugs, and structural connections all have standard torque specifications.",
    difficulty: "Medium"
  },
  {
    id: 1306,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the mechanical advantage of a block and tackle?",
    answer: "Count the number of supporting rope segments. A block and tackle with 4 supporting rope segments has MA = 4. The effort is 1/4 the load, but requires pulling 4 times the distance. More supporting segments increase mechanical advantage but also increase complexity and friction.",
    difficulty: "Medium"
  },
  {
    id: 1307,
    subject: "Mechanical Comprehension",
    question: "What is mechanical resonance and why is it dangerous?",
    answer: "Resonance occurs when applied force frequency matches an object's natural frequency, causing large amplitude vibrations. Bridges vibrate at their natural frequency; marching soldiers in step can cause resonance and failure. Machines are designed to operate away from resonant frequencies. Dampers (shock absorbers) reduce resonance effects.",
    difficulty: "Hard"
  },
  {
    id: 1308,
    subject: "Mechanical Comprehension",
    question: "How does a lever advantage the effort and load?",
    answer: "A lever can either amplify force (load side shorter), provide speed/distance (effort side shorter), or change direction (fulcrum between). MA = effort arm / load arm. Higher MA amplifies force but reduces distance. Lower MA amplifies distance/speed but requires more force. Class design determines the trade-off.",
    difficulty: "Medium"
  },
  {
    id: 1309,
    subject: "Mechanical Comprehension",
    question: "What is a syncromesh transmission?",
    answer: "A syncromesh transmission uses friction cones to synchronize speeds before engaging gears. This allows smooth, quiet gear changes without grinding. The driver feels minimal gear change impact. Modern car transmissions use syncromesh for all forward gears. Old transmissions required 'double-clutching' to avoid grinding.",
    difficulty: "Hard"
  },
  {
    id: 1310,
    subject: "Mechanical Comprehension",
    question: "How does gravity affect objects in different reference frames?",
    answer: "Gravity always acts downward with force = mass × gravitational acceleration (9.8 m/s² or 32 ft/s² on Earth). In accelerating reference frames, apparent gravity changes. Example: In an elevator accelerating upward, you feel heavier; accelerating downward, you feel lighter. This affects normal force and friction calculations.",
    difficulty: "Hard"
  },
  {
    id: 1311,
    subject: "Mechanical Comprehension",
    question: "What is the purpose of a counterweight?",
    answer: "A counterweight balances another weight, reducing the force needed to lift or move it. Elevator systems use counterweights to balance the car; only the difference in weight must be powered. This principle reduces energy requirements. Example: An elevator with counterweight uses less power than without because motor only needs to overcome the weight difference.",
    difficulty: "Medium"
  },
  {
    id: 1312,
    subject: "Mechanical Comprehension",
    question: "How do you determine the efficiency of an inclined plane?",
    answer: "Efficiency = (ideal mechanical advantage / actual mechanical advantage) × 100%. Ideal MA = length / height. Actual MA includes friction losses. Example: An ideal ramp 20 feet long, 4 feet high (MA = 5) might have actual MA of 4 due to friction, giving 80% efficiency.",
    difficulty: "Hard"
  },
  {
    id: 1313,
    subject: "Mechanical Comprehension",
    question: "What is the principle behind a hydraulic press?",
    answer: "A hydraulic press uses Pascal's Law: pressure applied to confined fluid transmits equally everywhere. Small piston applies force to small area, creating high pressure. This pressure acts on large piston, producing large output force. Formula: F_output = F_input × (A_large / A_small). Enables tremendous force multiplication.",
    difficulty: "Medium"
  },
  {
    id: 1314,
    subject: "Mechanical Comprehension",
    question: "How does a bevel gear work?",
    answer: "Bevel gears have angled teeth and are used to transmit power between shafts at angles (usually 90 degrees). The teeth mesh in a cone pattern. Bevel gears allow complex mechanical arrangements. Example: A car's rear axle uses bevel gears to transfer power from the longitudinal drive shaft to the transverse axles.",
    difficulty: "Hard"
  },
  {
    id: 1315,
    subject: "Mechanical Comprehension",
    question: "What is the purpose of a universal joint?",
    answer: "A universal joint connects two shafts that are misaligned. It transmits rotation while allowing angular deflection. Used in drive shafts, machinery, and power tools. Without universal joints, aligned shafts would be required, limiting mechanical flexibility. Example: A car's drive shaft uses universal joints where it connects to the transmission and differential.",
    difficulty: "Medium"
  },
  {
    id: 1316,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the distance advantage on an inclined plane?",
    answer: "Distance advantage = length of slope / vertical height. A slope 30 feet long rising 6 feet has distance advantage of 5. You travel 5 times as far but need only 1/5 the force. This is the trade-off for mechanical advantage: more distance, less force.",
    difficulty: "Easy"
  },
  {
    id: 1317,
    subject: "Mechanical Comprehension",
    question: "What is a worm gear?",
    answer: "A worm gear is a screw-like gear that meshes with a spur gear. It provides very high mechanical advantage and can self-lock (worm can drive gear, but gear cannot drive worm back). Used in hoists, conveyor systems, and machinery requiring high reduction ratios. Example: A 1-tooth worm meshing with a 40-tooth gear provides 40:1 reduction.",
    difficulty: "Hard"
  },
  {
    id: 1318,
    subject: "Mechanical Comprehension",
    question: "How does a Newton's cradle demonstrate conservation of momentum?",
    answer: "A Newton's cradle is a series of pendulum balls. Lifting one ball and letting it swing down hits the balls at rest. The impact transfers momentum through the middle balls to the last ball, which swings out. This demonstrates that momentum is conserved and transferred through collisions. The middle balls barely move while end balls swap.",
    difficulty: "Hard"
  },
  {
    id: 1319,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between force, mass, and weight?",
    answer: "Weight = mass × gravitational acceleration. Formula: W = mg. On Earth, gravity = 32 ft/s² or 9.8 m/s². Weight changes with location; mass doesn't. Example: A 100-pound mass on Earth weighs 100 pounds; on the Moon (1/6 gravity), it weighs only 16.7 pounds. Mass remains 100 pounds either way.",
    difficulty: "Easy"
  },
  {
    id: 1320,
    subject: "Mechanical Comprehension",
    question: "How do you apply Newton's laws to determine motion outcomes?",
    answer: "First Law: Identify if forces are balanced (no acceleration) or unbalanced (acceleration occurs). Second Law: F = ma tells how much acceleration results. Third Law: For each applied force, expect an equal opposite reaction. Example: Pushing on ground (action), ground pushes back (reaction), resulting in forward motion if net forces are unbalanced.",
    difficulty: "Medium"
  }
,
  {
    id: 1321,
    subject: "Mechanical Comprehension",
    question: "What is a gear ratio and why is it important in mechanical systems?",
    answer: "A gear ratio is the relationship between the number of teeth on two meshing gears. It determines how much the speed and torque of the input shaft are multiplied or reduced. For example, a 2:1 gear ratio means the output shaft rotates at half the speed but with twice the torque. Gear ratios are crucial for tailoring the mechanical advantage of machines to their intended purpose, such as increasing torque in a car's lower gears for acceleration.",
    difficulty: "Easy"
  },
  {
    id: 1322,
    subject: "Mechanical Comprehension",
    question: "If a drive gear has 20 teeth and a driven gear has 40 teeth, what is the gear ratio?",
    answer: "The gear ratio is 1:2 (or 0.5:1). This means the driven gear rotates at half the speed of the drive gear, but produces twice the torque. The formula is: Gear Ratio = Driven Gear Teeth / Drive Gear Teeth = 40/20 = 2. When the ratio is less than 1, the output moves slower but with greater force, which is useful for heavy lifting applications.",
    difficulty: "Easy"
  },
  {
    id: 1323,
    subject: "Mechanical Comprehension",
    question: "What happens to the output torque when gears increase the rotational speed?",
    answer: "When gears increase rotational speed, the output torque decreases proportionally. This is due to the conservation of energy and the inverse relationship between speed and torque in mechanical systems. For example, if a gear system increases speed by a factor of 3, the torque is reduced by a factor of 3. This principle applies to all gear systems: speed and torque are inversely proportional.",
    difficulty: "Easy"
  },
  {
    id: 1324,
    subject: "Mechanical Comprehension",
    question: "What is the purpose of an idler gear in a gear train?",
    answer: "An idler gear serves multiple purposes: it changes the direction of rotation of the final output gear without affecting the gear ratio, it can reverse rotation between two parallel shafts, and it allows gears of different sizes to mesh over a greater distance. The idler gear itself doesn't change the overall gear ratio because its teeth cancel out mathematically in the calculation.",
    difficulty: "Medium"
  },
  {
    id: 1325,
    subject: "Mechanical Comprehension",
    question: "In a belt and pulley system, what determines the mechanical advantage?",
    answer: "The mechanical advantage of a belt and pulley system is determined by the ratio of the pulley diameters. Advantage = Driven Pulley Diameter / Drive Pulley Diameter. For example, if the driven pulley has a diameter of 4 inches and the drive pulley has a diameter of 2 inches, the mechanical advantage is 2:1. Smaller drive pulleys and larger driven pulleys increase speed and reduce torque.",
    difficulty: "Easy"
  },
  {
    id: 1326,
    subject: "Mechanical Comprehension",
    question: "What is the gear ratio if a motor turns at 1000 RPM and needs to drive a shaft at 250 RPM?",
    answer: "The gear ratio needed is 4:1 (four to one). This is calculated by dividing the input speed by the desired output speed: 1000 RPM / 250 RPM = 4. This means the drive gear must have one-quarter the teeth of the driven gear, or a combination of gears must achieve this 4:1 reduction ratio to slow down the motor's output to 250 RPM.",
    difficulty: "Medium"
  },
  {
    id: 1327,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the gear ratio for a system with three gears in sequence?",
    answer: "For a three-gear system, the total gear ratio equals the product of individual ratios: Gear Ratio = (Gear 2 Teeth / Gear 1 Teeth) × (Gear 3 Teeth / Gear 2 Teeth). The middle gear cancels out mathematically. Alternatively, count all driving gear teeth and divide by all driven gear teeth. For example, if gears have 20, 40, and 30 teeth respectively, the ratio is (40/20) × (30/40) = 1.5:1.",
    difficulty: "Hard"
  },
  {
    id: 1328,
    subject: "Mechanical Comprehension",
    question: "What is a simple pulley and what mechanical advantage does it provide?",
    answer: "A simple pulley is a fixed wheel with a groove that holds a rope or cable, used to change the direction of force. A simple pulley provides a mechanical advantage of 1:1, meaning it doesn't multiply force or reduce the effort required. However, it makes lifting easier by redirecting force downward (easier to pull down than to lift up). Its main benefit is convenience, not force multiplication. Simple pulleys are commonly seen on flagpoles and window blinds.",
    difficulty: "Easy"
  },
  {
    id: 1329,
    subject: "Mechanical Comprehension",
    question: "How does a movable pulley differ from a fixed pulley in terms of mechanical advantage?",
    answer: "A movable pulley is attached to the load and provides a mechanical advantage of 2:1, meaning you need only half the force to lift the load, but you must pull twice the length of rope. A fixed pulley merely changes the direction of force and provides 1:1 mechanical advantage. Movable pulleys are more efficient for lifting heavy loads, though they require more rope movement than fixed pulleys.",
    difficulty: "Easy"
  },
  {
    id: 1330,
    subject: "Mechanical Comprehension",
    question: "What mechanical advantage does a block and tackle system with 4 strands of rope provide?",
    answer: "A block and tackle system with 4 supporting rope strands provides a mechanical advantage of 4:1. This means you need only one-quarter of the force to lift a load, but you must pull four times the length of rope. For example, to lift a 400-pound load, you would only need to apply 100 pounds of force. Block and tackle systems are commonly used in sailing, construction, and rescue operations.",
    difficulty: "Medium"
  },
  {
    id: 1331,
    subject: "Mechanical Comprehension",
    question: "What is a spring and what does the spring constant represent?",
    answer: "A spring is an elastic object that stores mechanical energy when compressed or extended. The spring constant (k) represents the stiffness of the spring and is measured in force per unit length (typically pounds per inch or Newtons per meter). A higher spring constant means the spring is stiffer and requires more force to compress or extend it the same distance. Springs follow Hooke's Law: Force = k × displacement.",
    difficulty: "Easy"
  },
  {
    id: 1332,
    subject: "Mechanical Comprehension",
    question: "If a spring has a spring constant of 100 N/m and is compressed 0.5 meters, what is the restoring force?",
    answer: "Using Hooke's Law (F = k × x), the restoring force is 100 N/m × 0.5 m = 50 Newtons. This is the force the spring exerts to return to its original position. The spring wants to push back with 50 Newtons when compressed 0.5 meters. If compressed further or if the spring constant is higher, the restoring force increases proportionally.",
    difficulty: "Medium"
  },
  {
    id: 1333,
    subject: "Mechanical Comprehension",
    question: "What are the two main types of springs and how do they differ?",
    answer: "The two main types are compression springs and tension springs. Compression springs resist and push back against compressive forces (like under a car seat), storing energy when squeezed. Tension springs resist and pull against tensile forces (like in a screen door closer), storing energy when stretched. Both follow Hooke's Law, but compression springs return to shape when the compressive force is removed, while tension springs return when the pulling force is removed.",
    difficulty: "Medium"
  },
  {
    id: 1334,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between spring stiffness and stored elastic potential energy?",
    answer: "Elastic potential energy stored in a spring is proportional to both the spring constant and the square of the displacement: PE = ½k × x². This means a stiffer spring (higher k value) stores more energy at the same displacement, and doubling the compression/extension quadruples the stored energy. For example, if a spring compressed 1 inch stores 10 joules, the same spring compressed 2 inches stores 40 joules.",
    difficulty: "Hard"
  },
  {
    id: 1335,
    subject: "Mechanical Comprehension",
    question: "What is momentum and how is it calculated?",
    answer: "Momentum is the measure of an object's motion, calculated as mass multiplied by velocity: p = m × v. A heavier object or a faster object has greater momentum. For example, a 10 kg object moving at 5 m/s has a momentum of 50 kg·m/s. Momentum is important in understanding collisions, explosions, and interactions between objects. Objects with high momentum require greater force to stop or change direction.",
    difficulty: "Easy"
  },
  {
    id: 1336,
    subject: "Mechanical Comprehension",
    question: "A 2000 kg car is traveling at 30 m/s. What is its momentum?",
    answer: "Using the momentum formula p = m × v, the car's momentum is 2000 kg × 30 m/s = 60,000 kg·m/s. This large momentum explains why stopping a car requires significant braking force and time. Conversely, a small change in velocity (from 30 m/s to 29 m/s) still changes the momentum by 2000 kg·m/s, demonstrating how momentum is sensitive to velocity changes.",
    difficulty: "Easy"
  },
  {
    id: 1337,
    subject: "Mechanical Comprehension",
    question: "What is the law of conservation of momentum and when does it apply?",
    answer: "The law of conservation of momentum states that in a closed system with no external forces, the total momentum before an interaction equals the total momentum after. This applies to collisions, explosions, and interactions between objects. For example, in a car collision, the total momentum of both cars before impact equals the total momentum after impact. This law is fundamental in analyzing crash dynamics and safety systems.",
    difficulty: "Medium"
  },
  {
    id: 1338,
    subject: "Mechanical Comprehension",
    question: "If a 5 kg ball moving at 4 m/s collides and sticks to a 5 kg stationary ball, what is their combined velocity after collision?",
    answer: "Using conservation of momentum: m₁v₁ + m₂v₂ = (m₁ + m₂)v_final. Substituting: (5 kg × 4 m/s) + (5 kg × 0 m/s) = (10 kg) × v_final. Therefore, v_final = 20 kg·m/s / 10 kg = 2 m/s. The combined balls move together at 2 m/s. Notice that momentum is conserved (20 kg·m/s before and after), but kinetic energy is not fully conserved due to the inelastic collision.",
    difficulty: "Hard"
  },
  {
    id: 1339,
    subject: "Mechanical Comprehension",
    question: "What is the difference between kinetic energy and potential energy?",
    answer: "Kinetic energy is the energy of motion, calculated as KE = ½mv². Potential energy is stored energy due to position or configuration, such as gravitational potential energy (PE = mgh). A moving car has kinetic energy; a car at the top of a hill has gravitational potential energy. Energy is constantly converted between these forms: as an object falls, potential energy converts to kinetic energy.",
    difficulty: "Easy"
  },
  {
    id: 1340,
    subject: "Mechanical Comprehension",
    question: "A 10 kg object is lifted to a height of 5 meters. How much gravitational potential energy does it gain?",
    answer: "Using the formula PE = mgh, the potential energy gained is 10 kg × 9.8 m/s² × 5 m = 490 Joules (approximately 500 J using g = 10 m/s²). This stored energy could be converted back to kinetic energy if the object falls. The potential energy depends on both the mass and the height; doubling either the mass or height doubles the potential energy.",
    difficulty: "Easy"
  },
  {
    id: 1341,
    subject: "Mechanical Comprehension",
    question: "What is kinetic energy and how does it relate to an object's velocity?",
    answer: "Kinetic energy is the energy an object possesses due to its motion, calculated as KE = ½mv². Kinetic energy is proportional to mass but proportional to the square of velocity. This means doubling an object's velocity quadruples its kinetic energy. For example, a car moving at 30 mph has four times the kinetic energy of the same car moving at 15 mph, explaining why stopping distance increases dramatically at higher speeds.",
    difficulty: "Medium"
  },
  {
    id: 1342,
    subject: "Mechanical Comprehension",
    question: "A 3 kg object is moving at 8 m/s. How much kinetic energy does it have?",
    answer: "Using the formula KE = ½mv², the kinetic energy is ½ × 3 kg × (8 m/s)² = ½ × 3 × 64 = 96 Joules. If the object's velocity increased to 16 m/s (doubled), the kinetic energy would become 384 Joules (quadrupled), demonstrating the squared relationship between velocity and kinetic energy.",
    difficulty: "Medium"
  },
  {
    id: 1343,
    subject: "Mechanical Comprehension",
    question: "What is the law of conservation of energy and how does it apply to a pendulum?",
    answer: "The law of conservation of energy states that energy cannot be created or destroyed, only converted from one form to another. In a pendulum, at the highest point, the bob has maximum potential energy and zero kinetic energy. At the lowest point, it has maximum kinetic energy and zero potential energy. Energy continuously converts between these forms, maintaining constant total mechanical energy (ignoring air resistance).",
    difficulty: "Hard"
  },
  {
    id: 1344,
    subject: "Mechanical Comprehension",
    question: "A ball is dropped from a 20-meter height. Ignoring air resistance, how fast is it moving when it hits the ground?",
    answer: "Using energy conservation or kinematics: v = √(2gh) = √(2 × 10 m/s² × 20 m) = √(400) = 20 m/s. The initial potential energy (mgh) completely converts to kinetic energy (½mv²). All objects, regardless of mass, fall at the same acceleration and reach the same speed when dropped from the same height (ignoring air resistance).",
    difficulty: "Medium"
  },
  {
    id: 1345,
    subject: "Mechanical Comprehension",
    question: "What is centrifugal force and where is it commonly observed?",
    answer: "Centrifugal force is the apparent outward force experienced by an object moving in a circular path. It's a fictitious force (not a real force, but a perceived effect of inertia). When a car turns sharply, passengers feel pushed outward—this is centrifugal force. It's calculated as F = mv²/r. Centrifugal force increases with higher speed and smaller radius of turn. It's commonly observed in spinning carnival rides, planets orbiting stars, and rotating machinery.",
    difficulty: "Easy"
  },
  {
    id: 1346,
    subject: "Mechanical Comprehension",
    question: "Why does a passenger in a car feel pushed outward when turning a corner at high speed?",
    answer: "The passenger experiences centrifugal force, which is not a real force but rather the effect of inertia. The car changes direction, but the passenger's body tends to continue in a straight line due to inertia, creating a sensation of being pushed outward. The faster the car travels or the tighter the turn (smaller radius), the stronger this effect. Safety features like side-impact airbags and roll bars are designed with this force in mind.",
    difficulty: "Medium"
  },
  {
    id: 1347,
    subject: "Mechanical Comprehension",
    question: "What factors determine the magnitude of centrifugal force on an object?",
    answer: "Centrifugal force depends on three factors: mass (heavier objects experience greater force), velocity squared (doubling speed quadruples the force), and radius of curvature (tighter turns create stronger force). The formula is F = mv²/r. For example, doubling the mass doubles the force, but doubling the velocity quadruples the force. Decreasing the radius by half doubles the force. This is why high-speed turns on tight curves are most dangerous.",
    difficulty: "Hard"
  },
  {
    id: 1348,
    subject: "Mechanical Comprehension",
    question: "What is buoyancy and why do objects float in water?",
    answer: "Buoyancy is the upward force exerted on an object submerged in or floating on a fluid. It occurs because fluid pressure increases with depth; the pressure on the bottom of an object exceeds the pressure on the top, creating a net upward force. Objects float when their weight equals the buoyant force, which depends on the volume of fluid displaced. This is Archimedes' Principle: the buoyant force equals the weight of the displaced fluid.",
    difficulty: "Easy"
  },
  {
    id: 1349,
    subject: "Mechanical Comprehension",
    question: "Why does a steel ship float even though steel is denser than water?",
    answer: "A steel ship floats because it displaces a volume of water equal to its weight, not because the steel is less dense than water. The ship's hollow hull contains mostly air, making its average density less than water. The buoyant force (weight of displaced water) equals the ship's total weight, so it floats. If the hull were filled with water or developed a hole, water would enter, decreasing the displaced water volume, and the ship would sink.",
    difficulty: "Medium"
  },
  {
    id: 1350,
    subject: "Mechanical Comprehension",
    question: "What is Archimedes' Principle and how is it mathematically expressed?",
    answer: "Archimedes' Principle states that the buoyant force on an object equals the weight of the fluid displaced by that object: F_buoyant = ρ_fluid × V_displaced × g. Where ρ is fluid density, V is volume displaced, and g is gravitational acceleration. For example, a 1-cubic-meter object submerged in water displaces 1 cubic meter of water, creating a buoyant force of approximately 9800 Newtons (the weight of 1000 kg of water).",
    difficulty: "Hard"
  },
  {
    id: 1351,
    subject: "Mechanical Comprehension",
    question: "What is a structural force and what are the main types?",
    answer: "Structural forces are forces acting on buildings and structures. The main types are tension (pulling forces), compression (pushing forces), shear (sliding forces), torsion (twisting forces), and bending. Tension pulls a structure apart; compression squeezes it. Shear forces try to make parts slide past each other. Torsion twists the structure. Bending combines compression and tension. Structures must be designed to resist all these forces based on their purpose and environment.",
    difficulty: "Easy"
  },
  {
    id: 1352,
    subject: "Mechanical Comprehension",
    question: "What is the difference between tension and compression forces?",
    answer: "Tension is a pulling force that tries to stretch or elongate a material, pulling its atoms apart. Compression is a pushing force that tries to squeeze or shorten a material, pushing its atoms together. Tension affects materials like cables, ropes, and suspension bridges. Compression affects materials like columns and pillars supporting weight. Some materials resist tension better (like steel cables), while others resist compression better (like concrete pillars).",
    difficulty: "Easy"
  },
  {
    id: 1353,
    subject: "Mechanical Comprehension",
    question: "What is shear force and how does it affect structural materials?",
    answer: "Shear force is a force that tries to make two adjacent parts of a material slide past each other, like cutting with scissors. When shear force is applied, the material experiences internal stresses that try to deform it by making layers slide sideways. Shear forces are common in bolted connections, rivets, and welded joints. If shear forces exceed a material's shear strength, the material fails by sliding or tearing along a plane parallel to the force.",
    difficulty: "Medium"
  },
  {
    id: 1354,
    subject: "Mechanical Comprehension",
    question: "What is torsion and where is it commonly found in mechanical systems?",
    answer: "Torsion is a twisting force that tries to rotate a material about its axis. It creates shear stresses within the material, with maximum stress at the outer edges and minimum at the center. Torsion is found in drive shafts, steering columns, drill bits, and screwdrivers. Resistance to torsion depends on material properties and the shaft's diameter; a larger diameter resists torsion much better. Power transmission through rotating shafts relies on torsion to transfer torque.",
    difficulty: "Medium"
  },
  {
    id: 1355,
    subject: "Mechanical Comprehension",
    question: "What is torque and how is it different from force?",
    answer: "Torque is a rotational force that causes an object to spin or rotate, calculated as torque = force × perpendicular distance from the axis (τ = F × r). Torque depends on both the force applied and where it's applied relative to the pivot point. A small force applied far from the pivot creates more torque than a large force applied near the pivot. This is why door knobs are placed far from hinges and why longer wrenches make loosening bolts easier.",
    difficulty: "Easy"
  },
  {
    id: 1356,
    subject: "Mechanical Comprehension",
    question: "If you apply a 50-Newton force perpendicular to a door 0.8 meters from the hinge, what torque is produced?",
    answer: "Using the torque formula τ = F × r, the torque produced is 50 N × 0.8 m = 40 Newton-meters (N·m). If you applied the same force only 0.4 meters from the hinge, the torque would be 50 N × 0.4 m = 20 N·m (half as much). If you applied the force at an angle rather than perpendicular, only the perpendicular component of force counts toward torque.",
    difficulty: "Medium"
  },
  {
    id: 1357,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between torque and lever arms in simple machines?",
    answer: "Torque increases with longer lever arms. The torque equation τ = F × r shows that for the same applied force, a longer distance from the pivot (longer lever arm) produces more torque. This is the principle behind all lever machines: extending the lever arm increases mechanical advantage. A 2-meter-long crowbar requires less force to pry open a door than a 1-meter crowbar, and a 1-meter wrench makes turning a bolt easier than a short wrench.",
    difficulty: "Medium"
  },
  {
    id: 1358,
    subject: "Mechanical Comprehension",
    question: "What is the mechanical advantage of a first-class lever and how is it calculated?",
    answer: "A first-class lever has the fulcrum (pivot point) between the effort and the load. Mechanical advantage = length of effort arm / length of load arm. If the effort arm is 3 meters and the load arm is 1 meter, the mechanical advantage is 3:1. This means applying 100 pounds of effort lifts 300 pounds of load. First-class levers are used in seesaws, crowbars, and scissors, providing a choice between distance or force advantage.",
    difficulty: "Easy"
  },
  {
    id: 1359,
    subject: "Mechanical Comprehension",
    question: "Describe the characteristics and advantage of a second-class lever.",
    answer: "A second-class lever has the load between the fulcrum and the effort point. Examples include wheelbarrows, nutcrackers, and bottle openers. The mechanical advantage always exceeds 1:1 because the load arm is always shorter than the effort arm. For instance, in a wheelbarrow, if the load is 2 feet from the fulcrum and your hands push 5 feet away, the advantage is 5/2 = 2.5:1. Second-class levers always multiply force but require moving the effort point a greater distance.",
    difficulty: "Medium"
  },
  {
    id: 1360,
    subject: "Mechanical Comprehension",
    question: "What is a third-class lever and why would you use one if it provides less mechanical advantage?",
    answer: "A third-class lever has the effort between the fulcrum and the load. Examples include fishing rods, tongs, and tweezers. The mechanical advantage is always less than 1:1, requiring more effort than the load. Despite this disadvantage, third-class levers are valued for precision and range of motion. They allow you to move objects great distances with small hand movements, making them ideal for tasks requiring dexterity and control rather than force multiplication.",
    difficulty: "Hard"
  },
  {
    id: 1361,
    subject: "Mechanical Comprehension",
    question: "What is efficiency in mechanical systems and how is it calculated?",
    answer: "Efficiency is the ratio of useful output to total input, expressed as a percentage: Efficiency = (Useful Output / Total Input) × 100%. In mechanical systems, some input energy is always lost to friction, heat, and deformation. For example, if a machine uses 100 joules of input energy but only 80 joules becomes useful work, its efficiency is 80%. No machine is 100% efficient, but designing systems with smooth surfaces, proper lubrication, and precision reduces losses.",
    difficulty: "Easy"
  },
  {
    id: 1362,
    subject: "Mechanical Comprehension",
    question: "A pulley system has an input force of 100 pounds and lifts a 180-pound load. What is the system's efficiency?",
    answer: "The efficiency is calculated as (Output / Input) × 100% = (180 / 100) × 100% = 180%. Wait, this is incorrect—efficiency cannot exceed 100%. This indicates an error in the problem statement. Actually, for a pulley system lifting a 180-pound load, the ideal input force would be 180 pounds divided by the mechanical advantage. If the input is 100 pounds, the mechanical advantage must be 1.8:1, making the efficiency (180/100)/1.8 × 100% ≈ 100%, accounting for the assumed ideal case.",
    difficulty: "Hard"
  },
  {
    id: 1363,
    subject: "Mechanical Comprehension",
    question: "What are the main causes of energy loss in mechanical systems?",
    answer: "The main causes of energy loss are friction (between moving parts), air resistance and drag, deformation and vibration, heat generation, and sound production. Friction is the primary loss source in most systems, occurring between sliding surfaces, rolling elements, and moving parts. Lubricants reduce friction but can't eliminate it entirely. Design improvements like precision bearings, smooth surfaces, aerodynamic shapes, and reducing vibration all help minimize energy losses and improve overall efficiency.",
    difficulty: "Medium"
  },
  {
    id: 1364,
    subject: "Mechanical Comprehension",
    question: "How does lubrication affect the efficiency of mechanical systems?",
    answer: "Lubrication reduces friction by creating a thin film between moving surfaces, allowing them to slide past each other with less resistance. This decreases energy loss due to friction, improving efficiency and reducing heat generation. Proper lubrication also extends equipment lifespan by preventing wear. However, excess lubrication can create drag and actually reduce efficiency. The type of lubricant matters—viscosity must match the application, and temperature affects lubricant performance.",
    difficulty: "Medium"
  },
  {
    id: 1365,
    subject: "Mechanical Comprehension",
    question: "What is the mechanical advantage of an inclined plane?",
    answer: "The mechanical advantage of an inclined plane is the length of the slope divided by the height: MA = Length of slope / Height = 1 / sin(angle). A longer, gentler slope provides greater mechanical advantage. For example, a ramp that is 10 meters long and 2 meters high has a mechanical advantage of 5:1, meaning you need only one-fifth the force to move an object up the ramp compared to lifting it vertically, but you must move the object five times farther.",
    difficulty: "Medium"
  },
  {
    id: 1366,
    subject: "Mechanical Comprehension",
    question: "A 200-pound object needs to be moved up a 4-foot vertical wall. What length incline (at 30 degrees) would provide a 2:1 mechanical advantage?",
    answer: "For a 2:1 mechanical advantage, the incline length must be 2 × 4 = 8 feet. Using the angle verification: if the vertical height is 4 feet and the angle is 30 degrees, the theoretical incline length would be 4 / sin(30°) = 4 / 0.5 = 8 feet. With this 8-foot incline, you would only need 100 pounds of force to move the object up (200 / 2 = 100), but you'd need to move it 8 feet along the slope.",
    difficulty: "Hard"
  },
  {
    id: 1367,
    subject: "Mechanical Comprehension",
    question: "What is the mechanical advantage of a screw and how does pitch affect it?",
    answer: "A screw is an inclined plane wrapped around a cylinder. Its mechanical advantage is determined by the pitch (distance the screw advances per complete rotation) and the circumference of the screw head: MA = 2πr / pitch. A finer pitch (smaller advance per turn) provides greater mechanical advantage but requires more rotations. Coarse threads advance faster but require more force per rotation. Ball screws used in precision machinery have very fine pitches for high mechanical advantage.",
    difficulty: "Hard"
  },
  {
    id: 1368,
    subject: "Mechanical Comprehension",
    question: "What is a wedge and what mechanical advantage does it provide?",
    answer: "A wedge is a modified inclined plane used to split, cut, or separate materials. Its mechanical advantage is the length of the slope divided by the thickness (width): MA = Length / Thickness. A thin, long wedge provides high mechanical advantage. For example, an axe blade that's 12 inches long and 0.5 inches thick has a mechanical advantage of 24:1. This explains why thin, sharp axes split wood more easily than thick, dull ones—greater mechanical advantage overcomes wood's resistance.",
    difficulty: "Medium"
  },
  {
    id: 1369,
    subject: "Mechanical Comprehension",
    question: "Why do cutting tools like knives and scissors work more effectively with thin, sharp edges?",
    answer: "Sharp, thin edges concentrate force into a very small contact area, creating extremely high pressure (pressure = force / area). A thin knife blade with the same applied force creates much higher pressure than a thick blade, making it easier to cut through materials. This high pressure exceeds the material's strength, causing it to deform and separate. Dull tools require more force because the large contact area spreads the force, reducing pressure below the material's resistance threshold.",
    difficulty: "Medium"
  },
  {
    id: 1370,
    subject: "Mechanical Comprehension",
    question: "What is stress in materials and how does it relate to force and area?",
    answer: "Stress is the internal force per unit area acting on a material: Stress = Force / Area (measured in Pascals or pounds per square inch). Tensile stress pulls a material apart, compressive stress squeezes it, and shear stress slides parts past each other. Materials have stress limits; exceeding these limits causes permanent deformation or failure. Understanding stress is crucial in engineering to ensure structures and components don't fail under expected loads.",
    difficulty: "Easy"
  },
  {
    id: 1371,
    subject: "Mechanical Comprehension",
    question: "A 1000-pound load is applied to a steel rod with a cross-sectional area of 2 square inches. What stress is applied to the rod?",
    answer: "Using the stress formula Stress = Force / Area, the stress is 1000 pounds / 2 square inches = 500 pounds per square inch (psi). If the same load were applied to a rod with only 1 square inch of area, the stress would double to 1000 psi. If applied to 4 square inches, the stress would be only 250 psi. This shows how doubling the material's cross-sectional area halves the stress for the same load.",
    difficulty: "Easy"
  },
  {
    id: 1372,
    subject: "Mechanical Comprehension",
    question: "What is strain and how does it differ from stress?",
    answer: "Strain is the deformation or change in shape of a material in response to stress, measured as a dimensionless ratio or percentage. Stress is the cause (applied force), while strain is the effect (resulting deformation). For example, if a rubber band stretches from 10 cm to 12 cm, the strain is (12-10)/10 = 0.2 or 20%. Materials respond differently to stress—some strain a lot before breaking (flexible), while others strain little (brittle).",
    difficulty: "Medium"
  },
  {
    id: 1373,
    subject: "Mechanical Comprehension",
    question: "What is Young's modulus and how is it used in material selection?",
    answer: "Young's modulus (E) is a material property that measures stiffness, defined as stress divided by strain (E = Stress / Strain). Higher Young's modulus indicates a stiffer material that resists deformation. Steel has Young's modulus around 30 million psi; aluminum around 10 million psi; rubber around 0.001 million psi. Engineers use Young's modulus to predict how much a material deforms under load and select appropriate materials for structures requiring specific rigidity.",
    difficulty: "Hard"
  },
  {
    id: 1374,
    subject: "Mechanical Comprehension",
    question: "What does it mean when a material has a high tensile strength?",
    answer: "High tensile strength means the material can withstand large pulling forces before breaking. It's measured as the maximum tensile stress before failure. Materials like steel have high tensile strength (around 40,000-100,000 psi), making them suitable for cables, suspension bridges, and load-bearing structural members. Materials like concrete have relatively low tensile strength, which is why reinforcing steel is embedded in concrete—the steel provides tensile strength that concrete lacks.",
    difficulty: "Easy"
  },
  {
    id: 1375,
    subject: "Mechanical Comprehension",
    question: "What is the difference between brittle and ductile materials?",
    answer: "Brittle materials break suddenly with little warning, exhibiting little or no plastic deformation before fracture (examples: glass, concrete, cast iron). Ductile materials deform significantly before breaking, showing plastic strain (examples: steel, aluminum, copper). Ductile materials strain considerably, giving warning before failure and absorbing significant energy. Brittle materials fail suddenly, making them unsuitable for applications where sudden failure is catastrophic. Material selection depends on whether predictability and gradual failure are important.",
    difficulty: "Easy"
  },
  {
    id: 1376,
    subject: "Mechanical Comprehension",
    question: "What is a bearing and what role does it play in mechanical systems?",
    answer: "A bearing is a component that supports loads and allows smooth rotation or sliding motion between parts. Common types include ball bearings, roller bearings, and plain bearings. Bearings reduce friction between moving parts, allowing machinery to operate efficiently with minimal energy loss. They distribute loads over larger areas, preventing wear and extending equipment life. Bearings are found in wheels, motors, pumps, and virtually all rotating machinery, making them essential for mechanical system performance.",
    difficulty: "Easy"
  },
  {
    id: 1377,
    subject: "Mechanical Comprehension",
    question: "How do ball bearings reduce friction compared to sliding contacts?",
    answer: "Ball bearings replace sliding friction (high resistance) with rolling friction (much lower resistance). In a ball bearing, steel balls roll between two raceway surfaces rather than parts sliding past each other. Rolling friction is typically 100 to 1000 times lower than sliding friction for the same materials. This dramatic reduction in friction decreases energy loss, reduces heat generation, increases equipment efficiency, and extends component lifespan. Ball bearings are superior to plain bearings in most high-speed applications.",
    difficulty: "Medium"
  },
  {
    id: 1378,
    subject: "Mechanical Comprehension",
    question: "What is the difference between radial and thrust bearings?",
    answer: "Radial bearings support loads perpendicular to the shaft (radial direction) and are commonly used in wheels, motors, and pumps. Thrust bearings support loads parallel to the shaft (along the axis) and prevent axial motion. A ball bearing can handle both radial and thrust loads but is optimized for one direction. Angular contact bearings handle some of both. Many applications use a combination of radial and thrust bearings to fully support equipment and constrain motion in all directions.",
    difficulty: "Hard"
  },
  {
    id: 1379,
    subject: "Mechanical Comprehension",
    question: "What is friction and why is it both helpful and harmful in mechanical systems?",
    answer: "Friction is the resistance to motion between two surfaces in contact. Helpful friction includes: providing traction for tires, preventing objects from sliding, enabling braking, and allowing gripping. Harmful friction includes: wasting energy as heat in machinery, causing wear on parts, and reducing efficiency. Most engineering challenges involve reducing harmful friction through lubrication and design while maintaining or enhancing helpful friction through material selection and surface design.",
    difficulty: "Easy"
  },
  {
    id: 1380,
    subject: "Mechanical Comprehension",
    question: "What factors affect the magnitude of friction between two surfaces?",
    answer: "Friction magnitude depends on: the coefficient of friction (depends on materials), the normal force (the force pressing the surfaces together), and surface roughness (smoother surfaces have lower friction). The friction formula is F_friction = μ × F_normal, where μ is the coefficient of friction. Friction is independent of the area of contact and sliding speed (kinetic friction), but increases slightly at higher normal forces. Different material combinations have different coefficients of friction.",
    difficulty: "Medium"
  },
  {
    id: 1381,
    subject: "Mechanical Comprehension",
    question: "What is the difference between static and kinetic friction?",
    answer: "Static friction prevents motion from starting; kinetic friction opposes motion already occurring. Static friction is typically higher than kinetic friction for the same surfaces—this is why it's harder to start moving an object than to keep it moving. Once an object starts sliding, kinetic friction takes over at a lower value. The maximum static friction must be overcome to initiate motion. This difference explains why it's hard to get a heavy box moving but easier to keep pushing once it's sliding.",
    difficulty: "Medium"
  },
  {
    id: 1382,
    subject: "Mechanical Comprehension",
    question: "What is centripetal force and how does it differ from centrifugal force?",
    answer: "Centripetal force is the real, inward force required to keep an object moving in a circle. Centrifugal force is a fictitious, apparent outward force felt by an object in circular motion due to inertia. Centripetal force causes the circular motion; without it, the object would travel straight. Centrifugal force is not a real force but the perception created by inertia resisting the directional change. In a car turning a corner, the road provides centripetal force (inward), while passengers feel the centrifugal effect (outward).",
    difficulty: "Hard"
  },
  {
    id: 1383,
    subject: "Mechanical Comprehension",
    question: "What is the formula for centripetal acceleration and how does it relate to circular motion?",
    answer: "Centripetal acceleration is a = v²/r, where v is velocity and r is the radius of the circular path. This acceleration is always directed toward the center of the circle. Greater velocity or tighter radius (smaller r) increases centripetal acceleration. For example, a car traveling 30 mph on a curve with a 100-foot radius needs much less centripetal acceleration than the same car on a 50-foot radius curve. This is why highway curves are gentle (large radius) and parking lots have tight curves that feel sharper.",
    difficulty: "Hard"
  },
  {
    id: 1384,
    subject: "Mechanical Comprehension",
    question: "What is a simple machine and what are the six classical simple machines?",
    answer: "A simple machine is a mechanical device that changes the magnitude or direction of force to make work easier. The six classical simple machines are: lever (changes force direction and magnitude), inclined plane (reduces force by increasing distance), pulley (changes force direction and can multiply force), screw (converts rotational force to linear force), wedge (splits or separates materials), and wheel and axle (multiplies rotational force). Complex machines combine these simple machines.",
    difficulty: "Easy"
  },
  {
    id: 1385,
    subject: "Mechanical Comprehension",
    question: "What is the principle of virtual work and how is it used in analyzing simple machines?",
    answer: "The principle of virtual work states that in a simple machine at equilibrium, the work done by the effort force equals the work done on the load. Work = Force × Distance, so if a machine provides a 3:1 force advantage, it requires 3 times the distance of travel. This principle applies to all simple machines: the effort force times the distance moved by the effort equals the load force times the distance moved by the load (assuming 100% efficiency).",
    difficulty: "Hard"
  },
  {
    id: 1386,
    subject: "Mechanical Comprehension",
    question: "How does a wheel and axle provide mechanical advantage?",
    answer: "A wheel and axle consists of two cylinders of different sizes connected to rotate together. The mechanical advantage is the ratio of the wheel radius to the axle radius: MA = R_wheel / R_axle. A larger wheel or smaller axle increases mechanical advantage. For example, if the wheel radius is 20 inches and the axle radius is 2 inches, the mechanical advantage is 10:1. Applying force to the wheel's rim (farther from center) produces torque that lifts loads on the axle with much less effort.",
    difficulty: "Medium"
  },
  {
    id: 1387,
    subject: "Mechanical Comprehension",
    question: "What is a compound machine and provide an example?",
    answer: "A compound machine combines two or more simple machines to provide greater mechanical advantage than either alone. The total mechanical advantage is the product of individual advantages. For example, a bicycle uses a wheel and axle (gears and chain) combined with a lever system (pedal) and simple machines in the chain drive. A car jack uses a screw (high mechanical advantage) combined with leverage, allowing a single person to lift thousands of pounds. Compound machines are more practical than simple machines alone.",
    difficulty: "Medium"
  },
  {
    id: 1388,
    subject: "Mechanical Comprehension",
    question: "What is power and how is it different from work?",
    answer: "Work is the energy transferred by a force over a distance: Work = Force × Distance. Power is the rate of doing work: Power = Work / Time. Work measures total energy; power measures how quickly energy is used. For example, climbing stairs in 10 seconds requires more power than climbing the same stairs in 60 seconds, even though the work is identical. Power is measured in Watts (Joules per second) or horsepower. Higher power indicates faster energy transfer.",
    difficulty: "Easy"
  },
  {
    id: 1389,
    subject: "Mechanical Comprehension",
    question: "If 1000 Joules of work is done in 20 seconds, how much power is being generated?",
    answer: "Using the power formula Power = Work / Time, the power is 1000 Joules / 20 seconds = 50 Watts. If the same work were done in 10 seconds, the power would be 100 Watts (twice as much). If done in 40 seconds, the power would be 25 Watts (half as much). This illustrates the inverse relationship between time and power—the shorter the time to complete work, the greater the power required.",
    difficulty: "Easy"
  },
  {
    id: 1390,
    subject: "Mechanical Comprehension",
    question: "What is horsepower and how does it relate to Watts?",
    answer: "Horsepower (hp) is a unit of power traditionally used in the US and for engines. One horsepower equals 746 Watts. Conversely, 1 Watt = 0.00134 horsepower. For example, a 1-hp electric motor produces 746 Watts of power. A 10,000 Watt machine produces approximately 13.4 horsepower. Both units measure the rate of energy transfer; horsepower is an older unit still used for vehicles and equipment, while Watts is the standard international unit.",
    difficulty: "Medium"
  },
  {
    id: 1391,
    subject: "Mechanical Comprehension",
    question: "What does it mean if a machine operates at 75% efficiency?",
    answer: "If a machine operates at 75% efficiency, it means 75% of the input energy becomes useful output work, while 25% is lost to friction, heat, and other inefficiencies. For example, if a machine receives 100 kilowatt-hours of electrical input, it delivers 75 kilowatt-hours of useful mechanical work, with 25 kilowatt-hours wasted as heat and friction. Most real machines operate at 50-95% efficiency depending on design and type. Perfect 100% efficiency is impossible due to thermodynamic laws.",
    difficulty: "Medium"
  },
  {
    id: 1392,
    subject: "Mechanical Comprehension",
    question: "What factors determine the efficiency of a motor or engine?",
    answer: "Motor efficiency depends on: friction losses in bearings and gears, electrical resistance (in motors), fuel quality and combustion efficiency (in engines), cooling system losses, vibration and sound losses, and design quality. Reducing friction through better lubrication and precision bearing selection significantly improves efficiency. Modern high-efficiency motors achieve 90-95% efficiency through optimized design, quality components, and proper cooling. Operating temperature and load conditions also affect efficiency—motors typically have peak efficiency at partial load.",
    difficulty: "Hard"
  },
  {
    id: 1393,
    subject: "Mechanical Comprehension",
    question: "What is the relationship between force, distance, and work in mechanical systems?",
    answer: "Work is calculated as the product of force and distance in the direction of the force: Work = Force × Distance × cos(angle). If force is applied perpendicular to motion, no work is done. If force and distance are in the same direction, maximum work is performed. For example, pushing a box 10 meters with 50 pounds of force does 500 foot-pounds of work. If you push at an angle, only the component of force in the direction of motion counts toward work.",
    difficulty: "Easy"
  },
  {
    id: 1394,
    subject: "Mechanical Comprehension",
    question: "What is the work-energy theorem and how does it apply to mechanical systems?",
    answer: "The work-energy theorem states that the net work done on an object equals its change in kinetic energy: W_net = ΔKE = ½m(v_f² - v_i²). This theorem shows how work translates directly into motion. For example, if 1000 Joules of net work is applied to a 10 kg object initially at rest, it will accelerate to a final velocity where ½(10)(v_f²) = 1000 J, giving v_f = 14.1 m/s. This relates force application to resulting motion.",
    difficulty: "Hard"
  },
  {
    id: 1395,
    subject: "Mechanical Comprehension",
    question: "How do you calculate the mechanical advantage of a combination pulley system?",
    answer: "In a combination pulley system, count the number of rope segments supporting the load. Each supporting rope segment provides mechanical advantage of 1. For example, in a block and tackle with 4 supporting ropes, the mechanical advantage is 4:1. This means 4 foot-pounds of input work lifts 1 foot-pound of load 4 feet high. The mechanical advantage equals the number of supporting ropes. Systems with more rope segments provide greater mechanical advantage but require more rope movement.",
    difficulty: "Medium"
  },
  {
    id: 1396,
    subject: "Mechanical Comprehension",
    question: "What is resonance in mechanical systems and why is it dangerous?",
    answer: "Resonance occurs when a system is driven at its natural frequency, causing vibrations to increase to dangerous levels. Every structure has a natural frequency at which it prefers to vibrate. If external forces (like wind, earthquakes, or machinery vibration) match this frequency, vibrations amplify dramatically. Famous examples include the Tacoma Narrows Bridge collapse and the Millennium Bridge wobble. Avoiding resonance requires damping (energy absorption) or ensuring operating frequencies avoid the system's natural frequency.",
    difficulty: "Hard"
  },
  {
    id: 1397,
    subject: "Mechanical Comprehension",
    question: "What is damping and how does it reduce vibration in mechanical systems?",
    answer: "Damping is the dissipation of energy from vibrating systems, typically through friction or other resistance. Dampers convert vibration energy into heat, reducing vibration amplitude. Common damping methods include: hydraulic dampers (used in vehicle suspensions), friction dampers, viscous dampers (using oil), and tuned mass dampers (using a secondary mass). Effective damping prevents resonance, reduces noise, increases comfort (in vehicles), and protects structural integrity. Without damping, vibrations continue indefinitely; with damping, they gradually fade.",
    difficulty: "Hard"
  },
  {
    id: 1398,
    subject: "Mechanical Comprehension",
    question: "What is the difference between static and dynamic loads in structural design?",
    answer: "Static loads are constant or slowly changing (like a building's own weight or a constant force). Dynamic loads change rapidly or cyclically (like wind gusts, earthquakes, or machinery vibration). Dynamic loads are typically more damaging because they cause vibration, stress concentration, and fatigue damage. Structures must be designed for both types of loads. Dynamic load factors are often much higher than static load factors to account for impact and vibration effects.",
    difficulty: "Medium"
  },
  {
    id: 1399,
    subject: "Mechanical Comprehension",
    question: "What is fatigue failure and why does it occur at lower stresses than static failure?",
    answer: "Fatigue failure occurs when repeated or fluctuating loads cause failure at stresses below the material's static strength limit. Each load cycle causes microscopic damage that accumulates over time. After millions or billions of cycles, cracks initiate and propagate until catastrophic failure. Fatigue is particularly dangerous because it's unpredictable—a part may function fine for years, then suddenly fail. This is why aircraft, bridges, and rotating machinery must be regularly inspected and have fatigue safety factors.",
    difficulty: "Hard"
  },
  {
    id: 1400,
    subject: "Mechanical Comprehension",
    question: "What is the S-N curve (Wohler curve) and what information does it provide?",
    answer: "The S-N curve plots stress level (S) against the number of cycles to failure (N) for a material under repeated loading. It shows the relationship between stress amplitude and fatigue life. Most materials show a fatigue limit—a stress level below which failure doesn't occur no matter how many cycles. Steel typically has a fatigue limit around half its tensile strength. Aluminum typically doesn't have a clear fatigue limit, requiring life calculations for any stress level. Engineers use S-N curves to design for fatigue resistance.",
    difficulty: "Hard"
  },
  {
    id: 1401,
    subject: "Mechanical Comprehension",
    question: "What is the difference between compression springs and extension springs in their behavior?",
    answer: "Compression springs are compressed from their natural length and push back with restoring force. Extension springs are stretched from their natural length and pull back. Both follow Hooke's Law, but they're designed differently. Compression springs have closed ends; extension springs have hooks or eyes for attachment. Extension springs have initial tension (pre-load), meaning they begin resisting force immediately when installed. Both store elastic potential energy proportional to their spring constant and deformation squared.",
    difficulty: "Medium"
  },
  {
    id: 1402,
    subject: "Mechanical Comprehension",
    question: "What is the natural frequency of a spring-mass system and how is it calculated?",
    answer: "The natural frequency (f) of a spring-mass system is f = (1/2π) × √(k/m), where k is the spring constant and m is the mass. A stiffer spring (higher k) increases natural frequency, making the system oscillate faster. A heavier mass (higher m) decreases natural frequency, making it oscillate slower. For example, a 10 kg mass on a spring with k=1000 N/m has a natural frequency of about 1.6 Hz (1.6 oscillations per second). This is important in vibration analysis.",
    difficulty: "Hard"
  },
  {
    id: 1403,
    subject: "Mechanical Comprehension",
    question: "What is the difference between elastic and plastic deformation?",
    answer: "Elastic deformation is temporary—the material returns to its original shape when the stress is removed (like stretching a rubber band slightly). Plastic deformation is permanent—the material doesn't fully return to its original shape after stress is removed (like permanently bending a paper clip). The elastic limit is the maximum stress before permanent deformation begins. Beyond this point, material continues to deform plastically until it reaches its ultimate strength and breaks.",
    difficulty: "Easy"
  },
  {
    id: 1404,
    subject: "Mechanical Comprehension",
    question: "What is a stress-strain diagram and what information does it show?",
    answer: "A stress-strain diagram plots stress (vertical axis) against strain (horizontal axis) for a material under tension. It shows: elastic region (linear, material returns to original shape), yield point (where permanent deformation begins), plastic region (nonlinear, permanent deformation), ultimate strength (maximum stress), and fracture point (where material breaks). The slope of the elastic region is Young's modulus. This diagram characterizes material behavior and guides design decisions for safety margins and material selection.",
    difficulty: "Hard"
  },
  {
    id: 1405,
    subject: "Mechanical Comprehension",
    question: "What is the difference between yield strength and ultimate strength?",
    answer: "Yield strength is the stress at which permanent (plastic) deformation begins—below this, material behavior is elastic and reversible. Ultimate strength is the maximum stress the material can withstand before fracture. Materials typically deform plastically between yield and ultimate strength, giving warning before failure. Design safety factors use yield strength; materials are designed to remain in the elastic region under normal loads. Brittle materials have yield and ultimate strength very close together; ductile materials have significant difference.",
    difficulty: "Medium"
  },
  {
    id: 1406,
    subject: "Mechanical Comprehension",
    question: "What is the factor of safety and why is it important in structural design?",
    answer: "Factor of safety is the ratio of material strength to applied stress: FS = Strength / Applied Stress. A factor of safety of 3 means the material is 3 times stronger than necessary for the current load. Higher factors of safety provide protection against unknown loads, material defects, fatigue, and uncertainty. Typical factors of safety range from 1.5 (low risk) to 5 or more (high risk or critical components). Buildings might use FS of 3-4; aircraft use FS of 1.5-3 (lower because of careful control).",
    difficulty: "Medium"
  },
  {
    id: 1407,
    subject: "Mechanical Comprehension",
    question: "What is an eccentric load and how does it affect structural stress?",
    answer: "An eccentric load is applied away from the centroid (center) of a structural member, causing both compression/tension and bending moment. This creates non-uniform stress distribution, with higher stresses near the outer fibers and lower stresses elsewhere. For example, a load applied off-center to a column creates more stress on the far side of the column. Eccentric loading is more dangerous than concentric loading because it combines axial stress and bending stress, potentially exceeding material limits sooner.",
    difficulty: "Hard"
  },
  {
    id: 1408,
    subject: "Mechanical Comprehension",
    question: "What is a moment of inertia and how does it affect beam bending?",
    answer: "Moment of inertia (I) is a geometric property describing how a shape's area is distributed around an axis. It affects how much a beam resists bending. Larger moment of inertia means greater bending resistance. For a rectangular beam, I increases with the width and with the cube of the height (I ∝ width × height³). This is why I-beams (with large height) resist bending better than rectangular beams of equal area—the material is distributed farther from the neutral axis, increasing moment of inertia.",
    difficulty: "Hard"
  },
  {
    id: 1409,
    subject: "Mechanical Comprehension",
    question: "What is the neutral axis in a bent beam and why is it important?",
    answer: "The neutral axis is the imaginary line through the center of a bent beam where stress is zero. Above the neutral axis, material experiences compression; below it, material experiences tension. The neutral axis typically passes through the geometric center of the cross-section but can shift for unsymmetrical shapes. Understanding the neutral axis location is crucial for calculating stresses and designing beams—outer fibers experience maximum stress, while the neutral axis experiences no stress.",
    difficulty: "Hard"
  },
  {
    id: 1410,
    subject: "Mechanical Comprehension",
    question: "What is pressure and how is it different from force?",
    answer: "Force is the total push or pull on an object; pressure is force per unit area: Pressure = Force / Area. Pressure is measured in Pascals (Pa), pounds per square inch (psi), or bars. Pressure depends on both force and area—the same force concentrated on a small area creates high pressure, while spread over a large area creates low pressure. High-pressure systems are used for cutting and clamping; low-pressure systems for gentle handling. This explains why knife blades are thin (small area) and cutting boards are soft (distribute pressure).",
    difficulty: "Easy"
  },
  {
    id: 1411,
    subject: "Mechanical Comprehension",
    question: "What is hydrostatic pressure and how does it affect submerged objects?",
    answer: "Hydrostatic pressure is pressure exerted by a static fluid (liquid at rest) due to its weight. It increases with depth: P = ρgh (where ρ is density, g is gravity, h is depth). For example, in water, pressure increases about 1 psi per 2.3 feet of depth. Hydrostatic pressure acts equally in all directions, so objects experience pressure from above, below, and sides. This pressure creates the buoyant force mentioned earlier—pressure is higher on the bottom of an object than the top.",
    difficulty: "Medium"
  },
  {
    id: 1412,
    subject: "Mechanical Comprehension",
    question: "What is a hydraulic system and what advantages does it provide?",
    answer: "A hydraulic system transmits power using pressurized fluid in pipes and cylinders. Advantages include: high force multiplication (small pump creates high pressure in cylinders), even force distribution, ability to transmit power through flexible hoses, smooth and controllable motion, and safety (fluid absorbs energy better than solid connections). Hydraulic systems are used in excavators, brakes, power steering, and industrial machinery. The mechanical advantage depends on the area ratio of cylinders: force amplification = Area of output cylinder / Area of input cylinder.",
    difficulty: "Medium"
  },
  {
    id: 1413,
    subject: "Mechanical Comprehension",
    question: "What is Pascal's Principle and how does it apply to hydraulic systems?",
    answer: "Pascal's Principle states that pressure applied to an enclosed fluid is transmitted equally throughout the fluid in all directions. This principle enables hydraulic force multiplication: applying a small force to a small piston pressurizes the fluid, which then pushes on a larger piston with proportionally greater force. For example, pushing with 100 pounds on a 1-square-inch piston creates 100 psi pressure, which pushes on a 10-square-inch piston with 1000 pounds of force. Hydraulic systems depend entirely on Pascal's Principle.",
    difficulty: "Hard"
  },
  {
    id: 1414,
    subject: "Mechanical Comprehension",
    question: "How does a hydraulic cylinder multiply force?",
    answer: "A hydraulic cylinder multiplies force through the area ratio of pistons: Force Output = Force Input × (Area Output / Area Input). For example, if input piston has 1 square inch and output piston has 10 square inches, applying 100 pounds to the input piston produces 1000 pounds of output force. However, the output piston moves proportionally less distance—if the input moves 10 inches, the output moves 1 inch. This trades distance for force, demonstrating the conservation of energy.",
    difficulty: "Medium"
  },
  {
    id: 1415,
    subject: "Mechanical Comprehension",
    question: "What is the difference between static and dynamic pressure in fluid mechanics?",
    answer: "Static pressure is the pressure of a stationary fluid, exerted in all directions. Dynamic pressure is related to fluid motion and velocity: Dynamic Pressure = ½ρv². Total pressure is the sum of static and dynamic pressures. For example, water flowing through a pipe has both static pressure (exerted on pipe walls) and dynamic pressure (related to flow velocity). Bernoulli's equation describes this relationship: Total Pressure = Static Pressure + Dynamic Pressure is constant along a streamline.",
    difficulty: "Hard"
  },
  {
    id: 1416,
    subject: "Mechanical Comprehension",
    question: "What is a venturi tube and what principle does it demonstrate?",
    answer: "A venturi tube is a pipe section that narrows and then expands, demonstrating Bernoulli's principle. As fluid flows through the narrow section, velocity increases and static pressure decreases. This pressure drop can be used to measure flow rate or create suction. In carburetors, venturi tubes create low pressure that draws in fuel. Aircraft wings are shaped like venturi tubes—air flows faster over the curved top, reducing pressure and creating lift. The principle: faster-moving fluids have lower pressure.",
    difficulty: "Hard"
  },
  {
    id: 1417,
    subject: "Mechanical Comprehension",
    question: "What is cavitation in fluid systems and why is it problematic?",
    answer: "Cavitation occurs when fluid pressure drops below its vapor pressure, causing the fluid to vaporize and form bubbles. When these bubbles collapse (typically when pressure increases again), they release enormous energy that can damage nearby surfaces and equipment. Cavitation is common in pumps, propellers, and hydraulic systems operating at high speeds. It causes noise, vibration, erosion damage, and loss of efficiency. Preventing cavitation requires maintaining adequate inlet pressure and avoiding sharp pressure transitions.",
    difficulty: "Hard"
  },
  {
    id: 1418,
    subject: "Mechanical Comprehension",
    question: "What is a turbine and how does it convert fluid flow into rotational motion?",
    answer: "A turbine is a rotating machine that converts fluid flow (water, steam, or air) into rotational mechanical energy. Turbine blades are shaped to redirect fluid flow, transferring the fluid's momentum to the rotating rotor. Applications include: hydroelectric turbines (water flow), steam turbines (power plants), wind turbines (air flow), and jet engines. Turbine efficiency depends on blade design, operating speed, and fluid properties. Turbines are highly efficient at converting fluid energy to mechanical power, typically 85-95%.",
    difficulty: "Medium"
  },
  {
    id: 1419,
    subject: "Mechanical Comprehension",
    question: "What is the difference between a turbine and a compressor in terms of energy flow?",
    answer: "A turbine extracts energy from a flowing fluid, slowing the fluid and producing mechanical power. A compressor does the opposite—it uses mechanical power to compress and speed up a fluid. Turbines are driven by fluid flow; compressors drive fluid flow. In a combined cycle power plant, a gas turbine generates electricity, and waste heat from the turbine drives a steam turbine. Compressors are used in air conditioning, refrigeration, and pneumatic tools. Both are important in fluid power systems.",
    difficulty: "Hard"
  },
  {
    id: 1420,
    subject: "Mechanical Comprehension",
    question: "What is the overall mechanical efficiency of a typical mechanical system and what factors limit it to less than 100%?",
    answer: "Typical mechanical systems operate at 50-95% efficiency depending on design and application. Simple machines like inclined planes and pulleys can achieve 80-90% efficiency with proper design and maintenance. Complex systems like vehicles achieve 20-35% overall efficiency (engines are 30-40%, drivetrain is 85-95%, resulting in 25-38% total). Factors limiting efficiency include friction losses (primary factor), heat generation, deformation losses, air/wind resistance, vibration, and sound production. Perfect 100% efficiency is impossible due to the second law of thermodynamics.",
    difficulty: "Hard"
  }
,
  {
    id: 1421,
    subject: "Auto & Shop Information",
    question: "What is the primary function of a car battery?",
    answer: "The primary function of a car battery is to provide electrical energy to start the engine through the starter motor and to power electrical systems when the engine is off. It stores chemical energy and converts it to electrical energy. The battery also stabilizes voltage in the electrical system.",
    difficulty: "Easy"
  },
  {
    id: 1422,
    subject: "Auto & Shop Information",
    question: "What does the alternator do in a vehicle?",
    answer: "The alternator is a generator that produces electrical current to recharge the battery and power the electrical systems while the engine is running. It converts mechanical energy from the engine into electrical energy. When the engine runs, the alternator maintains the battery charge and supplies power to lights, radio, and other electrical components.",
    difficulty: "Easy"
  },
  {
    id: 1423,
    subject: "Auto & Shop Information",
    question: "What is the purpose of spark plugs?",
    answer: "Spark plugs create an electrical spark inside the engine cylinders to ignite the air-fuel mixture. This combustion powers the engine. Spark plugs typically fire thousands of times per minute and must be replaced periodically as they wear out and become less effective.",
    difficulty: "Easy"
  },
  {
    id: 1424,
    subject: "Auto & Shop Information",
    question: "What is the function of the radiator?",
    answer: "The radiator cools the engine by circulating coolant through the engine block to absorb heat, then releasing that heat to the air through its fins. Hot coolant flows through the radiator where air passes over the cooling fins, transferring heat away from the coolant before it returns to the engine.",
    difficulty: "Easy"
  },
  {
    id: 1425,
    subject: "Auto & Shop Information",
    question: "What does the oil filter do?",
    answer: "The oil filter removes dirt, debris, and contaminants from engine oil. As oil circulates through the engine, particles accumulate in the filter media, keeping the oil clean. A clogged oil filter is bypassed to prevent engine damage, so regular filter changes are essential for engine longevity.",
    difficulty: "Easy"
  },
  {
    id: 1426,
    subject: "Auto & Shop Information",
    question: "What is the purpose of brake pads?",
    answer: "Brake pads create friction against the brake rotor to slow or stop the vehicle. When you press the brake pedal, hydraulic pressure pushes the brake pads onto the rotor, converting the vehicle's kinetic energy into heat. Brake pads wear down with use and must be replaced periodically.",
    difficulty: "Easy"
  },
  {
    id: 1427,
    subject: "Auto & Shop Information",
    question: "What is a crankshaft?",
    answer: "The crankshaft is a shaft in the engine that converts the up-and-down motion of the pistons into rotational motion to turn the wheels. It connects to the connecting rods of all cylinders and transfers the power from combustion into usable rotational force that drives the transmission.",
    difficulty: "Easy"
  },
  {
    id: 1428,
    subject: "Auto & Shop Information",
    question: "What is the function of the thermostat?",
    answer: "The thermostat regulates engine coolant temperature by controlling the flow of coolant through the radiator. It stays closed when the engine is cold, allowing the engine to warm up quickly, then opens as the engine reaches operating temperature to prevent overheating.",
    difficulty: "Easy"
  },
  {
    id: 1429,
    subject: "Auto & Shop Information",
    question: "What does the air filter do?",
    answer: "The air filter removes dust, pollen, and other particles from the air before it enters the engine. A clean air filter is essential for proper engine performance and fuel efficiency. Clogged air filters reduce airflow and can cause rough idle and reduced power.",
    difficulty: "Easy"
  },
  {
    id: 1430,
    subject: "Auto & Shop Information",
    question: "What is the purpose of the fuel injector?",
    answer: "The fuel injector sprays a fine mist of gasoline into the engine's combustion chamber at precise times. Modern vehicles use electronic fuel injectors controlled by the engine computer to optimize the air-fuel mixture for efficiency and performance. This precision replaces older carburetor systems.",
    difficulty: "Easy"
  },
  {
    id: 1431,
    subject: "Auto & Shop Information",
    question: "What is a wrench used for?",
    answer: "A wrench is a hand tool used to tighten or loosen nuts and bolts. Different types of wrenches include combination wrenches, adjustable wrenches, socket wrenches, and specialty wrenches like pipe wrenches. The correct size and type of wrench prevents slipping and stripped fasteners.",
    difficulty: "Easy"
  },
  {
    id: 1432,
    subject: "Auto & Shop Information",
    question: "What is a screwdriver used for?",
    answer: "A screwdriver is a hand tool with a blade or head shaped to fit into screw slots or drive patterns. Common types include Phillips, flat-head, Robertson, and Torx. Using the correct screwdriver type prevents damaging screws and components.",
    difficulty: "Easy"
  },
  {
    id: 1433,
    subject: "Auto & Shop Information",
    question: "What is the purpose of pliers?",
    answer: "Pliers are hand tools used for gripping, bending, cutting, and holding objects. Types include slip-joint pliers, needle-nose pliers, locking pliers, and cutting pliers. They are essential for holding parts in place while working on vehicles.",
    difficulty: "Easy"
  },
  {
    id: 1434,
    subject: "Auto & Shop Information",
    question: "What is a socket wrench used for?",
    answer: "A socket wrench consists of a ratchet handle with interchangeable sockets that fit over hex-shaped nuts and bolts. Socket wrenches provide greater leverage and speed than regular wrenches and come in various sizes to fit different fasteners.",
    difficulty: "Easy"
  },
  {
    id: 1435,
    subject: "Auto & Shop Information",
    question: "What does a torque wrench measure?",
    answer: "A torque wrench measures and applies a specific amount of rotational force (torque) to fasteners. It's essential for applications where precise tightness is critical, such as engine head bolts, wheel lug nuts, and suspension components. Over-tightening or under-tightening can cause damage.",
    difficulty: "Easy"
  },
  {
    id: 1436,
    subject: "Auto & Shop Information",
    question: "What is a micrometer used for?",
    answer: "A micrometer is a precision measuring tool that measures small distances or thicknesses with high accuracy, typically to 0.01 millimeters. It's used for measuring brake rotor thickness, piston wear, and other critical engine components.",
    difficulty: "Easy"
  },
  {
    id: 1437,
    subject: "Auto & Shop Information",
    question: "What is a multimeter used for in automotive work?",
    answer: "A multimeter is an electrical testing tool that measures voltage, current, and resistance. Automotive technicians use multimeters to test battery voltage, check for electrical faults, diagnose charging system problems, and troubleshoot electrical components.",
    difficulty: "Easy"
  },
  {
    id: 1438,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a jack and jack stands?",
    answer: "A jack lifts a vehicle off the ground for maintenance and repairs. Jack stands support the vehicle safely while work is performed. Proper use includes placing stands on solid ground and never working under a vehicle supported only by a jack.",
    difficulty: "Easy"
  },
  {
    id: 1439,
    subject: "Auto & Shop Information",
    question: "What is an impact wrench?",
    answer: "An impact wrench is a power tool that delivers quick bursts of high torque to loosen or tighten fasteners. It's commonly used for removing stuck bolts and lug nuts. Impact wrenches significantly reduce manual effort compared to hand tools.",
    difficulty: "Easy"
  },
  {
    id: 1440,
    subject: "Auto & Shop Information",
    question: "What is the purpose of safety glasses in a shop environment?",
    answer: "Safety glasses protect eyes from flying debris, sparks, and chemical splashes during automotive work. They are essential personal protective equipment (PPE) that prevents serious eye injuries. Different lenses are used for different tasks, such as UV protection for welding.",
    difficulty: "Easy"
  },
  {
    id: 1441,
    subject: "Auto & Shop Information",
    question: "What is a transmission in a vehicle?",
    answer: "The transmission transfers power from the engine to the wheels while allowing the engine to operate within its optimal speed range. Manual transmissions use a clutch to engage and disengage gears, while automatic transmissions shift gears automatically using a fluid coupling and planetary gears.",
    difficulty: "Medium"
  },
  {
    id: 1442,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a clutch in a manual transmission?",
    answer: "The clutch disconnects the engine from the transmission, allowing the driver to shift gears without grinding. When the clutch pedal is pressed, a spring-loaded pressure plate releases the friction disc, breaking the connection. When released, the friction disc engages the flywheel to transfer engine power.",
    difficulty: "Medium"
  },
  {
    id: 1443,
    subject: "Auto & Shop Information",
    question: "What is the function of the flywheel?",
    answer: "The flywheel is a heavy disc attached to the engine crankshaft that provides rotational inertia, smoothing out engine vibrations and helping the engine run smoothly at low speeds. It also serves as a mounting surface for the clutch pressure plate and starter motor.",
    difficulty: "Medium"
  },
  {
    id: 1444,
    subject: "Auto & Shop Information",
    question: "What does the cooling system's water pump do?",
    answer: "The water pump circulates coolant through the engine block, radiator, and heater core. Driven by the serpentine belt, it maintains constant coolant flow to absorb heat from the engine and transport it to the radiator for dissipation. A failed water pump causes engine overheating.",
    difficulty: "Medium"
  },
  {
    id: 1445,
    subject: "Auto & Shop Information",
    question: "What is the purpose of the serpentine belt?",
    answer: "The serpentine belt is a long rubber belt that transmits power from the crankshaft pulley to auxiliary components like the alternator, water pump, air conditioning compressor, and power steering pump. Regular inspection for cracks and wear is essential to prevent component failure.",
    difficulty: "Medium"
  },
  {
    id: 1446,
    subject: "Auto & Shop Information",
    question: "What is the function of shock absorbers?",
    answer: "Shock absorbers dampen oscillations of the suspension springs, reducing vehicle bounce and keeping tires in contact with the road. They improve ride comfort and vehicle handling by dissipating energy from suspension movement. Worn shocks increase stopping distance and reduce stability.",
    difficulty: "Medium"
  },
  {
    id: 1447,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a strut in a suspension system?",
    answer: "A strut combines a shock absorber and coil spring into one assembly, serving as both a suspension damper and structural component. Struts are more compact than separate shocks and springs and are commonly used in modern vehicles for improved handling and reduced weight.",
    difficulty: "Medium"
  },
  {
    id: 1448,
    subject: "Auto & Shop Information",
    question: "What does the catalytic converter do?",
    answer: "The catalytic converter uses chemical reactions to convert harmful exhaust emissions like carbon monoxide and unburned hydrocarbons into less harmful substances. It contains precious metals that catalyze these reactions without being consumed. Catalytic converters are crucial for reducing air pollution.",
    difficulty: "Medium"
  },
  {
    id: 1449,
    subject: "Auto & Shop Information",
    question: "What is the function of the oxygen sensor?",
    answer: "The oxygen sensor measures the amount of unburned oxygen in the exhaust stream to optimize the air-fuel ratio for combustion efficiency. The engine computer uses this data to adjust fuel injection and ignition timing. Faulty sensors cause poor fuel economy and increased emissions.",
    difficulty: "Medium"
  },
  {
    id: 1450,
    subject: "Auto & Shop Information",
    question: "What is the purpose of the starter motor?",
    answer: "The starter motor is an electric motor that cranks the engine during starting. Powered by the battery, it rotates the crankshaft through a series of gears to begin the combustion process. Once the engine fires, an overrunning clutch disengages the starter.",
    difficulty: "Medium"
  },
  {
    id: 1451,
    subject: "Auto & Shop Information",
    question: "What is a brake master cylinder?",
    answer: "The brake master cylinder converts brake pedal pressure into hydraulic pressure that activates the brake system. When you press the pedal, it pushes a piston in the master cylinder, forcing brake fluid through lines to wheel cylinders or calipers. A failed master cylinder causes brake failure.",
    difficulty: "Medium"
  },
  {
    id: 1452,
    subject: "Auto & Shop Information",
    question: "What is the function of brake fluid?",
    answer: "Brake fluid transmits force from the master cylinder to the brake calipers or wheel cylinders through hydraulic pressure. It must be incompressible to effectively transfer force and must withstand high temperatures without boiling. Moisture contamination is a concern because water lowers the boiling point.",
    difficulty: "Medium"
  },
  {
    id: 1453,
    subject: "Auto & Shop Information",
    question: "What is ABS (Anti-lock Braking System)?",
    answer: "ABS prevents wheel lockup during hard braking by rapidly pulsing the brakes on and off. When sensors detect that a wheel is about to lock, the system modulates brake pressure to maintain traction. This allows the driver to maintain steering control during emergency stops.",
    difficulty: "Medium"
  },
  {
    id: 1454,
    subject: "Auto & Shop Information",
    question: "What is the purpose of brake rotors?",
    answer: "Brake rotors are spinning discs that work with brake pads to stop the vehicle. When brake pads press against the rotor, friction converts the vehicle's kinetic energy into heat. Rotors must dissipate this heat quickly to prevent brake fade. Warped or scored rotors reduce braking effectiveness.",
    difficulty: "Medium"
  },
  {
    id: 1455,
    subject: "Auto & Shop Information",
    question: "What is a ball joint in a suspension system?",
    answer: "A ball joint is a flexible connection between the steering knuckle and control arm that allows up-and-down suspension movement while permitting the wheel to turn for steering. Worn ball joints cause clunking sounds, poor alignment, and unsafe handling.",
    difficulty: "Medium"
  },
  {
    id: 1456,
    subject: "Auto & Shop Information",
    question: "What is wheel alignment?",
    answer: "Wheel alignment adjusts the angles of the wheels to manufacturer specifications for proper tracking and tire wear. Key alignment angles include camber (tilt), caster (angle), and toe-in (direction). Misalignment causes uneven tire wear, pulling to one side, and poor handling.",
    difficulty: "Medium"
  },
  {
    id: 1457,
    subject: "Auto & Shop Information",
    question: "What is the function of tire tread?",
    answer: "Tire tread provides traction by gripping the road surface and channeling water away to prevent hydroplaning. Tread depth affects braking distance, acceleration grip, and weather performance. Minimum legal tread depth is 2/32 inch. Bald tires significantly increase accident risk.",
    difficulty: "Medium"
  },
  {
    id: 1458,
    subject: "Auto & Shop Information",
    question: "What is tire pressure and why is it important?",
    answer: "Tire pressure is the amount of air inside a tire, measured in PSI (pounds per square inch). Proper tire pressure is critical for fuel efficiency, handling, tire life, and safety. Under-inflated tires generate excessive heat and wear prematurely. Over-inflated tires provide a harsh ride and reduced traction.",
    difficulty: "Medium"
  },
  {
    id: 1459,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a timing belt?",
    answer: "The timing belt synchronizes the rotation of the crankshaft and camshaft, ensuring that valves open and close at precisely the right moment relative to piston position. A broken timing belt can cause catastrophic engine damage. Timing belts should be replaced at manufacturer-recommended intervals.",
    difficulty: "Medium"
  },
  {
    id: 1460,
    subject: "Auto & Shop Information",
    question: "What is the function of valve springs?",
    answer: "Valve springs close the intake and exhaust valves after they open to allow the engine to complete its four-stroke cycle. They store energy when pushed down and release it to snap the valve closed, preventing spring surge at high RPMs. Weak springs cause valve float and poor engine performance.",
    difficulty: "Medium"
  },
  {
    id: 1461,
    subject: "Auto & Shop Information",
    question: "What is compression ratio in an engine?",
    answer: "Compression ratio is the ratio of the cylinder's volume when the piston is at the bottom compared to when it's at the top. Higher compression ratios generally produce more power but require higher octane fuel to prevent detonation (knocking). Typical ratios range from 8:1 to 12:1.",
    difficulty: "Hard"
  },
  {
    id: 1462,
    subject: "Auto & Shop Information",
    question: "What is the difference between diesel and gasoline engines?",
    answer: "Diesel engines use compression ignition while gasoline engines use spark ignition. Diesel fuel has a higher energy density, providing better fuel economy. Diesel engines generate more torque at lower RPMs and have higher compression ratios (14:1 to 25:1). They're more durable but heavier and noisier than gasoline engines.",
    difficulty: "Hard"
  },
  {
    id: 1463,
    subject: "Auto & Shop Information",
    question: "How does a four-stroke engine cycle work?",
    answer: "The four-stroke cycle consists of: 1) Intake stroke - intake valve opens, piston moves down, drawing air-fuel mixture; 2) Compression stroke - both valves close, piston moves up, compressing mixture; 3) Power stroke - spark plug ignites mixture, explosion pushes piston down; 4) Exhaust stroke - exhaust valve opens, piston moves up, pushing out burned gases.",
    difficulty: "Hard"
  },
  {
    id: 1464,
    subject: "Auto & Shop Information",
    question: "What causes engine detonation (knocking)?",
    answer: "Engine knocking occurs when the air-fuel mixture ignites prematurely or has multiple ignition points instead of a smooth, controlled burn. This can be caused by low octane fuel, carbon buildup, lean fuel mixture, advanced ignition timing, or overheating. Detonation damages pistons and connecting rods over time.",
    difficulty: "Hard"
  },
  {
    id: 1465,
    subject: "Auto & Shop Information",
    question: "What is the purpose of the EGR valve (Exhaust Gas Recirculation)?",
    answer: "The EGR valve recirculates small amounts of exhaust gases back into the intake manifold to lower combustion temperatures and reduce nitrogen oxide (NOx) emissions. This improves emissions but can cause rough idle, hesitation, and carbon buildup if stuck open or closed.",
    difficulty: "Hard"
  },
  {
    id: 1466,
    subject: "Auto & Shop Information",
    question: "How does turbocharging work?",
    answer: "A turbocharger uses exhaust gases to spin a turbine that compresses intake air, forcing more air into cylinders for more combustion energy. This increases engine power output without increasing engine size. Turbochargers generate significant heat and require heat management. They add complexity and cost but improve performance.",
    difficulty: "Hard"
  },
  {
    id: 1467,
    subject: "Auto & Shop Information",
    question: "What is supercharging and how does it differ from turbocharging?",
    answer: "A supercharger is a mechanical air compressor driven by an engine belt (like the serpentine belt) that pressurizes intake air. Unlike turbochargers, superchargers provide immediate boost with no lag but consume engine power. Superchargers are more reliable and cooler running than turbochargers but less efficient.",
    difficulty: "Hard"
  },
  {
    id: 1468,
    subject: "Auto & Shop Information",
    question: "What is variable valve timing (VVT)?",
    answer: "VVT adjusts the timing of valve opening and closing during the engine cycle to optimize performance and efficiency at different engine speeds and loads. It uses oil pressure to adjust camshaft position relative to the crankshaft. VVT improves fuel economy, power, and emissions.",
    difficulty: "Hard"
  },
  {
    id: 1469,
    subject: "Auto & Shop Information",
    question: "How does a continuously variable transmission (CVT) work?",
    answer: "A CVT uses two variable-diameter pulleys connected by a belt or chain to provide infinite gear ratios without discrete steps. As engine speed changes, pulley diameters automatically adjust to maintain optimal engine RPM. CVTs provide excellent fuel economy and smooth acceleration but can feel unstable.",
    difficulty: "Hard"
  },
  {
    id: 1470,
    subject: "Auto & Shop Information",
    question: "What causes brake fade?",
    answer: "Brake fade occurs when intense or prolonged braking generates excessive heat, causing brake fluid to boil or brake pads to glaze, reducing friction. Different types include hydraulic fade (fluid boiling), mechanical fade (pad glazing), and fade from wet brakes. Prevention includes using quality brake fluid and allowing brakes to cool.",
    difficulty: "Hard"
  },
  {
    id: 1471,
    subject: "Auto & Shop Information",
    question: "What is a dead blow hammer used for?",
    answer: "A dead blow hammer (also called a soft-faced hammer) has a weighted head partially filled with sand or lead shot that absorbs recoil energy, reducing bounce and impact to surrounding parts. It's used for striking components without damaging them, such as removing bearings or driving shafts without denting.",
    difficulty: "Medium"
  },
  {
    id: 1472,
    subject: "Auto & Shop Information",
    question: "What is a slide hammer puller used for?",
    answer: "A slide hammer puller is used to extract stuck parts like bearings, gears, and pullers from shafts. A hook or claw engages the part, and sliding weight creates a pulling force. This tool prevents part damage compared to brute force or striking.",
    difficulty: "Medium"
  },
  {
    id: 1473,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a bearing puller?",
    answer: "A bearing puller safely removes bearings from shafts without damage. Two or three legs hook under the bearing's inner race while a central screw applies gradual pulling force. Using the correct puller size prevents bearing distortion and shaft damage.",
    difficulty: "Medium"
  },
  {
    id: 1474,
    subject: "Auto & Shop Information",
    question: "What is a dial indicator used for?",
    answer: "A dial indicator measures runout (wobbling), deflection, and alignment of rotating shafts and components. The needle indicates measurement changes to 0.001 inch precision. Technicians use dial indicators to check for bent shafts, worn bearings, and component alignment.",
    difficulty: "Medium"
  },
  {
    id: 1475,
    subject: "Auto & Shop Information",
    question: "What is a feeler gauge used for?",
    answer: "A feeler gauge measures small gaps and clearances between components, consisting of thin metal blades of precise thickness. Automotive uses include measuring valve clearances, spark plug gaps, and bearing clearances. Selecting the correct gauge size ensures accurate measurements.",
    difficulty: "Medium"
  },
  {
    id: 1476,
    subject: "Auto & Shop Information",
    question: "What is an oscilloscope used for in automotive diagnostics?",
    answer: "An oscilloscope displays electrical signals as waveforms, allowing technicians to observe voltage patterns over time. In automotive work, it's used to diagnose ignition system problems, fuel injector performance, charging system issues, and sensor faults that regular meters cannot detect.",
    difficulty: "Hard"
  },
  {
    id: 1477,
    subject: "Auto & Shop Information",
    question: "What is a compression tester?",
    answer: "A compression tester measures cylinder pressure during the engine's compression stroke, indicating piston ring condition, valve sealing, and overall engine health. Low or uneven compression indicates blown head gaskets, cracked pistons, worn rings, or valve problems.",
    difficulty: "Hard"
  },
  {
    id: 1478,
    subject: "Auto & Shop Information",
    question: "What is a leak detector used for?",
    answer: "A leak detector identifies coolant, refrigerant, and fuel leaks that are difficult to see. Methods include dye tracing (adds visible dye to fluids), halogen detectors (detect refrigerant), and smoke testers (pump smoke through systems). Proper leak detection saves time and prevents repeat failures.",
    difficulty: "Medium"
  },
  {
    id: 1479,
    subject: "Auto & Shop Information",
    question: "What is the purpose of penetrating oil?",
    answer: "Penetrating oil like WD-40 or Liquid Wrench loosens corroded, stuck, or rusty bolts by breaking down rust bonds and providing lubrication. Application time (often 15-30 minutes) is necessary for effectiveness. Penetrating oil also displaces moisture, aiding in rust prevention.",
    difficulty: "Easy"
  },
  {
    id: 1480,
    subject: "Auto & Shop Information",
    question: "What is the purpose of engine oil?",
    answer: "Engine oil lubricates moving parts, reduces friction, removes contaminants, dissipates heat, and protects against wear. Oil viscosity varies with temperature - thinner oils (low numbers) for cold weather, thicker oils (high numbers) for hot weather. Multi-viscosity oils (like 10W-30) perform across temperature ranges.",
    difficulty: "Medium"
  },
  {
    id: 1481,
    subject: "Auto & Shop Information",
    question: "What is the difference between synthetic and conventional oil?",
    answer: "Synthetic oil is man-made from chemical compounds, offering superior protection, longer intervals between changes (up to 10,000 miles or more), better performance in extreme temperatures, and higher cost. Conventional oil is refined crude oil, requiring more frequent changes but costing less. Semi-synthetic blends offer a middle ground.",
    difficulty: "Medium"
  },
  {
    id: 1482,
    subject: "Auto & Shop Information",
    question: "What does oil viscosity mean?",
    answer: "Oil viscosity refers to an oil's thickness or resistance to flow. Viscosity ratings use numbers - 0W-30 means thin at startup (0W) and thick at operating temperature (30). Proper viscosity ensures adequate lubrication across temperature ranges. Too thick in cold weather prevents startup; too thin at heat causes inadequate protection.",
    difficulty: "Medium"
  },
  {
    id: 1483,
    subject: "Auto & Shop Information",
    question: "What is the purpose of transmission fluid?",
    answer: "Transmission fluid lubricates transmission components, provides hydraulic pressure for clutch and band operation, cools the transmission, and carries away contaminants. Automatic transmission fluid also includes detergents and viscosity index improvers. Dirty or low transmission fluid causes rough shifting and transmission damage.",
    difficulty: "Medium"
  },
  {
    id: 1484,
    subject: "Auto & Shop Information",
    question: "What is differential fluid used for?",
    answer: "Differential fluid lubricates the differential gearset, spider gears, and bearings in the rear axle. It must withstand high pressures and temperatures generated by gear meshing. Different types (conventional, synthetic, limited-slip) serve different purposes. Low or degraded fluid causes noise and bearing damage.",
    difficulty: "Medium"
  },
  {
    id: 1485,
    subject: "Auto & Shop Information",
    question: "What is the purpose of coolant flush service?",
    answer: "A coolant flush removes old, degraded coolant and replaces it with fresh coolant that maintains proper engine temperature, prevents corrosion, and protects against freeze-up. Old coolant loses effectiveness and can become acidic, damaging engine components. Flushes are recommended every 30,000-60,000 miles.",
    difficulty: "Easy"
  },
  {
    id: 1486,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a battery load test?",
    answer: "A battery load test applies a heavy electrical load to the battery while measuring voltage drop to determine battery health and cranking ability. A good battery maintains adequate voltage under load. Load tests identify weak batteries before they fail to start the engine.",
    difficulty: "Medium"
  },
  {
    id: 1487,
    subject: "Auto & Shop Information",
    question: "What causes a dead battery?",
    answer: "Common causes include: leaving lights on, parasitic drain from faulty modules, corroded terminals preventing charging, failed alternator, prolonged cold weather, age (typically 3-5 years), and defective battery cells. Proper diagnosis determines if the battery or charging system is at fault.",
    difficulty: "Medium"
  },
  {
    id: 1488,
    subject: "Auto & Shop Information",
    question: "What is battery sulfation?",
    answer: "Battery sulfation occurs when lead sulfate crystals form on battery plates during discharge or storage, reducing battery capacity and cranking power. Once sulfation becomes severe, it's permanent and requires battery replacement. Regular charging and preventing complete discharge prevents sulfation.",
    difficulty: "Hard"
  },
  {
    id: 1489,
    subject: "Auto & Shop Information",
    question: "What is the purpose of battery terminals and cable cleaning?",
    answer: "Battery terminal corrosion (white, green, or blue deposits) increases electrical resistance, reducing charging and starting power. Cleaning terminals with a battery terminal cleaner and wire brush restores good electrical contact. Terminals should be tight and free from corrosion for optimal battery performance.",
    difficulty: "Easy"
  },
  {
    id: 1490,
    subject: "Auto & Shop Information",
    question: "What is the purpose of brake bleeding?",
    answer: "Brake bleeding removes air bubbles from brake lines that compress instead of transmitting hydraulic pressure, causing a soft or spongy brake pedal. Bleeding is performed after brake system service or when air enters the system. Proper technique maintains brake performance and safety.",
    difficulty: "Medium"
  },
  {
    id: 1491,
    subject: "Auto & Shop Information",
    question: "What causes tire dry rot?",
    answer: "Tire dry rot results from prolonged sun exposure and weather exposure breaking down tire rubber, causing cracks and splits. Contributing factors include age (tires degrade after 5-7 years), low pressure, and lack of use. Dry rotted tires are unsafe and must be replaced immediately.",
    difficulty: "Medium"
  },
  {
    id: 1492,
    subject: "Auto & Shop Information",
    question: "What is tire balancing?",
    answer: "Tire balancing corrects uneven weight distribution around a tire by adding weights to the wheel rim. Unbalanced tires cause vibration, increased wear, and steering wheel shaking, particularly at highway speeds. Balancing is performed whenever tires are mounted on wheels.",
    difficulty: "Easy"
  },
  {
    id: 1493,
    subject: "Auto & Shop Information",
    question: "What is the purpose of an emission test?",
    answer: "Emission tests measure vehicle pollutants like carbon monoxide, nitrogen oxides, and hydrocarbons to ensure compliance with environmental regulations. States require periodic testing. Vehicles failing tests often have issues like bad oxygen sensors, faulty catalytic converters, or improper fuel mixture.",
    difficulty: "Medium"
  },
  {
    id: 1494,
    subject: "Auto & Shop Information",
    question: "What is a diagnostic trouble code (DTC)?",
    answer: "A DTC is a code stored by the engine computer (PCM) when it detects a sensor or system malfunction. Codes begin with a letter (P for powertrain, C for chassis, B for body, U for network) followed by numbers indicating the specific fault. A diagnostic scanner reads these codes to guide repairs.",
    difficulty: "Medium"
  },
  {
    id: 1495,
    subject: "Auto & Shop Information",
    question: "What is the check engine light?",
    answer: "The check engine light illuminates when the engine computer detects an emissions system or engine malfunction. It's not necessarily an emergency but indicates the need for diagnostic scanning to identify the fault. Continuing to drive with the light on can worsen damage or emissions violations.",
    difficulty: "Easy"
  },
  {
    id: 1496,
    subject: "Auto & Shop Information",
    question: "What is antilock brake system (ABS) service interval?",
    answer: "ABS typically requires no routine maintenance but should be inspected if the ABS light comes on. Regular brake service (pads, rotors, fluid) maintains the conventional brake portion of the system. ABS modulator replacement may be necessary after 100,000+ miles if faults occur.",
    difficulty: "Hard"
  },
  {
    id: 1497,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a fuel pressure regulator?",
    answer: "A fuel pressure regulator maintains constant fuel pressure to the fuel injectors by releasing excess fuel back to the tank. Proper fuel pressure is critical for correct fuel injector spray pattern and air-fuel mixture. A faulty regulator causes lean or rich running conditions.",
    difficulty: "Hard"
  },
  {
    id: 1498,
    subject: "Auto & Shop Information",
    question: "What is carburetor function?",
    answer: "Though largely replaced by fuel injection, carburetors meter air and gasoline to create the proper fuel mixture for combustion. Carburetors are simpler and more affordable but less precise than fuel injection. Rebuilding requires cleaning and gasket replacement.",
    difficulty: "Medium"
  },
  {
    id: 1499,
    subject: "Auto & Shop Information",
    question: "What is the purpose of an air compressor in a shop?",
    answer: "An air compressor pressurizes air for pneumatic tools like impact wrenches, air ratchets, air grinders, spray guns, and blow guns. Compressed air is safer than electrical tools in wet environments and provides consistent power. Compressors require regular moisture draining and filter maintenance.",
    difficulty: "Easy"
  },
  {
    id: 1500,
    subject: "Auto & Shop Information",
    question: "What is a pneumatic impact wrench used for?",
    answer: "A pneumatic impact wrench uses compressed air bursts to apply high torque for loosening stuck fasteners and tightening lug nuts quickly. It's faster and requires less effort than hand tools. Selection includes various sizes for different applications.",
    difficulty: "Easy"
  },
  {
    id: 1501,
    subject: "Auto & Shop Information",
    question: "What is a drill press used for?",
    answer: "A drill press is a stationary power tool for drilling precise, perpendicular holes in metal, wood, and other materials. It provides better accuracy and control than a handheld drill. Variable speed allows adjustment for different materials and hole sizes.",
    difficulty: "Easy"
  },
  {
    id: 1502,
    subject: "Auto & Shop Information",
    question: "What is a bench grinder used for?",
    answer: "A bench grinder sharpens tools, grinds metal, and shapes parts using high-speed rotating wheels. It's essential for maintaining tool edges and removing material quickly. Safety includes using wheel guards and eye protection to protect against flying debris.",
    difficulty: "Easy"
  },
  {
    id: 1503,
    subject: "Auto & Shop Information",
    question: "What is a hacksaw used for?",
    answer: "A hacksaw cuts metal pipes, bolts, and bars using a fine-toothed blade under tension. The handle allows cutting at different angles. Proper technique involves using full strokes with even pressure for efficient, clean cuts.",
    difficulty: "Easy"
  },
  {
    id: 1504,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a spring compressor?",
    answer: "A spring compressor safely compresses coil springs for removal and installation without risking sudden release that could cause injury. Spring compressors are essential for suspension work, particularly when replacing struts or shocks. Improper spring compression is extremely dangerous.",
    difficulty: "Medium"
  },
  {
    id: 1505,
    subject: "Auto & Shop Information",
    question: "What is a hydraulic press used for?",
    answer: "A hydraulic press applies tremendous force for pressing bearings onto shafts, removing stuck components, and straightening bent parts. Hydraulic pressure gradually increases for safer, controlled operations compared to striking with a hammer.",
    difficulty: "Medium"
  },
  {
    id: 1506,
    subject: "Auto & Shop Information",
    question: "What is a welding torch used for?",
    answer: "A welding torch joins metal parts by melting and fusing them together with extreme heat. Different torch types (TIG, MIG, oxy-acetylene) serve different purposes. Proper technique and safety equipment are essential to prevent burns, eye damage, and fires.",
    difficulty: "Medium"
  },
  {
    id: 1507,
    subject: "Auto & Shop Information",
    question: "What is the purpose of cutting fluid?",
    answer: "Cutting fluid lubricates and cools cutting tools during drilling, tapping, and grinding operations. It reduces friction, extends tool life, improves cut quality, and prevents metal chips from welding to the tool. Different fluids are used for different materials.",
    difficulty: "Easy"
  },
  {
    id: 1508,
    subject: "Auto & Shop Information",
    question: "What is the purpose of work gloves in a shop?",
    answer: "Work gloves protect hands from cuts, abrasions, oil, chemicals, heat, and punctures. Different glove types serve different purposes - mechanics gloves for general work, leather gloves for heat protection, nitrile gloves for chemical protection. Proper glove selection prevents injuries.",
    difficulty: "Easy"
  },
  {
    id: 1509,
    subject: "Auto & Shop Information",
    question: "What is the purpose of ear protection in a shop?",
    answer: "Ear protection prevents hearing damage from loud noise exposure in shops. Prolonged exposure to noise above 85 dB causes permanent hearing loss. Types include earplugs, earmuffs, and foam inserts. OSHA regulations require hearing protection when noise exceeds safe levels.",
    difficulty: "Easy"
  },
  {
    id: 1510,
    subject: "Auto & Shop Information",
    question: "What is the proper storage for flammable liquids?",
    answer: "Flammable liquids like gasoline, paint thinner, and solvents must be stored in approved metal cabinets away from ignition sources and heat. Storage areas should be well-ventilated, clearly labeled, and away from work areas. OSHA regulations specify storage cabinet requirements.",
    difficulty: "Medium"
  },
  {
    id: 1511,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a fire extinguisher in a shop?",
    answer: "Fire extinguishers control small fires before they spread. Different types (A, B, C, D, K) extinguish different fire classes. Type ABC extinguishers work on most fires. All shop personnel should know extinguisher location and proper operation (PASS: Pull, Aim, Squeeze, Sweep).",
    difficulty: "Medium"
  },
  {
    id: 1512,
    subject: "Auto & Shop Information",
    question: "What is the first aid for chemical exposure?",
    answer: "If chemical exposure occurs: flush eyes with water for 15 minutes, rinse skin with water immediately, remove contaminated clothing, and seek medical attention. Always have safety data sheets (SDS) available to identify hazards and proper treatment. Prevention includes proper protective equipment and ventilation.",
    difficulty: "Easy"
  },
  {
    id: 1513,
    subject: "Auto & Shop Information",
    question: "What is lockout/tagout (LOTO) procedure?",
    answer: "Lockout/tagout prevents accidental equipment startup during maintenance by locking the power switch and tagging it. Each technician locks the equipment with their own lock and keeps the key. LOTO prevents serious injuries from unexpected machine operation.",
    difficulty: "Medium"
  },
  {
    id: 1514,
    subject: "Auto & Shop Information",
    question: "What is the proper procedure for changing a tire?",
    answer: "Tire change procedure: 1) Park safely, engage parking brake; 2) Loosen lug nuts slightly; 3) Raise vehicle with jack and place jack stand; 4) Remove lug nuts and wheel; 5) Install spare tire and hand-tighten lug nuts; 6) Lower vehicle and torque lug nuts to specification; 7) Have tire repaired or replaced soon.",
    difficulty: "Easy"
  },
  {
    id: 1515,
    subject: "Auto & Shop Information",
    question: "What is the purpose of engine degreaser?",
    answer: "Engine degreaser removes accumulated oil, dirt, and grease from engine surfaces for easier inspection and component access. Degreaser allows better visibility of leaks and damage. Modern degreasers are less toxic but still require proper ventilation and skin protection.",
    difficulty: "Easy"
  },
  {
    id: 1516,
    subject: "Auto & Shop Information",
    question: "What is the purpose of wire brushes?",
    answer: "Wire brushes remove rust, corrosion, paint, and debris from metal surfaces. Different stiffness levels (soft, medium, hard) suit different tasks. Soft brushes prevent damage to finished surfaces while hard brushes handle heavy corrosion. Electric wire wheels speed large projects.",
    difficulty: "Easy"
  },
  {
    id: 1517,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a impact driver?",
    answer: "An impact driver is a power tool that applies rotational bursts of high torque for driving fasteners and loosening stuck bolts. The rotating chuck suddenly stops, creating an impact that breaks corrosion. More precise than impact wrenches, impact drivers excel at driving fasteners without slipping.",
    difficulty: "Medium"
  },
  {
    id: 1518,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a rotary tool?",
    answer: "A rotary tool (like a Dremel) is a handheld power tool with various attachments for grinding, cutting, polishing, and drilling small components. It provides precision work in confined spaces. Different bits and stones serve specialized automotive restoration and repair tasks.",
    difficulty: "Easy"
  },
  {
    id: 1519,
    subject: "Auto & Shop Information",
    question: "What is the purpose of masking tape in automotive work?",
    answer: "Masking tape protects areas that shouldn't receive paint or other coatings during restoration work. It creates clean paint lines and prevents overspray. Proper tape application ensures professional results without damaging finished surfaces.",
    difficulty: "Easy"
  },
  {
    id: 1520,
    subject: "Auto & Shop Information",
    question: "What is the purpose of battery recycling?",
    answer: "Battery recycling recovers valuable materials like lead, plastic, and sulfuric acid from used batteries, reducing landfill waste and environmental contamination. Recycling also reduces the need for new mining. Retailers often accept old batteries for recycling when you buy a replacement.",
    difficulty: "Easy"
  }
,
  {
    id: 1521,
    subject: "Auto & Shop Information",
    question: "What is the primary function of a spark plug in an internal combustion engine?",
    answer: "A spark plug ignites the fuel-air mixture in the engine cylinder by creating an electrical spark. This controlled explosion pushes the piston down, creating the power stroke that drives the vehicle. Spark plugs typically fire thousands of times per minute depending on engine speed.",
    difficulty: "Easy"
  },
  {
    id: 1522,
    subject: "Auto & Shop Information",
    question: "Explain the purpose of an alternator in a vehicle electrical system.",
    answer: "An alternator is a generator that converts mechanical energy from the engine into electrical energy. It charges the battery while the engine is running and supplies power to the electrical system (lights, starter, accessories). A typical alternator generates 50-100+ amps depending on vehicle demands.",
    difficulty: "Easy"
  },
  {
    id: 1523,
    subject: "Auto & Shop Information",
    question: "What does the cooling system do in an engine?",
    answer: "The cooling system removes excess heat generated during combustion to prevent engine damage. It circulates coolant through passages in the engine block and head, then through a radiator where heat is released to the atmosphere. Proper cooling prevents overheating and engine seizure.",
    difficulty: "Easy"
  },
  {
    id: 1524,
    subject: "Auto & Shop Information",
    question: "What is the function of the transmission in a vehicle?",
    answer: "The transmission transfers power from the engine to the wheels while allowing the engine to operate in its optimal RPM range. It provides different gear ratios for various speeds and conditions - low gears for acceleration and high gears for fuel efficiency at highway speeds.",
    difficulty: "Easy"
  },
  {
    id: 1525,
    subject: "Auto & Shop Information",
    question: "Describe the role of the suspension system in a vehicle.",
    answer: "The suspension system supports the vehicle's weight, absorbs road shocks through springs and dampers, and maintains tire contact with the road. It improves ride comfort, handling, and safety by isolating the body from road irregularities while keeping wheels aligned for traction.",
    difficulty: "Easy"
  },
  {
    id: 1526,
    subject: "Auto & Shop Information",
    question: "What is the primary purpose of the brake system?",
    answer: "The brake system safely stops the vehicle by converting the vehicle's kinetic energy into heat through friction. When the driver presses the brake pedal, hydraulic pressure pushes brake pads against rotors (disc brakes) or shoes against drums (drum brakes), creating the stopping force.",
    difficulty: "Easy"
  },
  {
    id: 1527,
    subject: "Auto & Shop Information",
    question: "What does the fuel injection system do?",
    answer: "The fuel injection system precisely sprays atomized fuel directly into the engine cylinders or intake manifold at the optimal time. This provides better fuel economy, faster starts, and cleaner emissions compared to carburetors. Modern systems use computer control for precise timing and volume.",
    difficulty: "Easy"
  },
  {
    id: 1528,
    subject: "Auto & Shop Information",
    question: "Explain what a catalytic converter does.",
    answer: "A catalytic converter reduces harmful emissions by converting pollutants like carbon monoxide, nitrogen oxides, and unburned hydrocarbons into less harmful substances through a chemical reaction. The converter contains a catalyst material (usually precious metals) that speeds up this conversion process.",
    difficulty: "Easy"
  },
  {
    id: 1529,
    subject: "Auto & Shop Information",
    question: "What is the purpose of the engine oil?",
    answer: "Engine oil lubricates moving parts to reduce friction and wear, cools components by carrying heat away from the engine, seals piston rings, and suspends contaminants. Regular oil changes maintain engine health and performance. Oil viscosity affects flow at different temperatures.",
    difficulty: "Easy"
  },
  {
    id: 1530,
    subject: "Auto & Shop Information",
    question: "What does a thermostat do in the cooling system?",
    answer: "A thermostat is a temperature-sensitive valve that regulates coolant flow through the radiator. It remains closed while the engine warms up to operating temperature, then opens to allow coolant circulation. This maintains optimal engine temperature and reduces warm-up time.",
    difficulty: "Easy"
  },
  {
    id: 1531,
    subject: "Auto & Shop Information",
    question: "What is the function of shock absorbers and struts?",
    answer: "Shock absorbers and struts dampen the oscillations of the suspension springs, controlling bounce and sway. They absorb energy from road impacts and keep tires in contact with the road surface. Worn shocks reduce handling, increase stopping distance, and create unsafe driving conditions.",
    difficulty: "Easy"
  },
  {
    id: 1532,
    subject: "Auto & Shop Information",
    question: "Describe the role of the drive shaft in a rear-wheel-drive vehicle.",
    answer: "The drive shaft (also called propeller shaft) transfers rotational power from the transmission to the rear differential. It transmits torque from the engine through the transmission to turn the rear wheels. The shaft is balanced and supported by bearing to minimize vibration.",
    difficulty: "Easy"
  },
  {
    id: 1533,
    subject: "Auto & Shop Information",
    question: "What is a serpentine belt and what does it do?",
    answer: "A serpentine belt is a long, ribbed rubber belt that drives multiple engine accessories like the alternator, water pump, air conditioning compressor, and power steering pump. A single belt winds around multiple pulleys. If it breaks, several systems fail simultaneously.",
    difficulty: "Easy"
  },
  {
    id: 1534,
    subject: "Auto & Shop Information",
    question: "What does the air filter do in an engine?",
    answer: "The air filter removes dust, dirt, and contaminants from incoming air before it enters the engine. A clean filter improves engine performance and fuel efficiency. A clogged filter restricts airflow, reducing power and increasing emissions and fuel consumption.",
    difficulty: "Easy"
  },
  {
    id: 1535,
    subject: "Auto & Shop Information",
    question: "Explain the purpose of a tire rotation.",
    answer: "Tire rotation moves tires to different wheel positions to ensure even wear. Front tires wear faster due to steering stress, so rotation extends tire life. Regular rotation improves handling, safety, and fuel efficiency by maintaining even tread depth across all tires.",
    difficulty: "Easy"
  },
  {
    id: 1536,
    subject: "Auto & Shop Information",
    question: "What is wheel alignment and why is it important?",
    answer: "Wheel alignment adjusts the angle of wheels relative to the vehicle frame. Proper alignment ensures straight-line tracking, improves handling, reduces tire wear, improves fuel economy, and enhances safety. Misalignment causes uneven tire wear and pulling to one side.",
    difficulty: "Medium"
  },
  {
    id: 1537,
    subject: "Auto & Shop Information",
    question: "Describe the four-stroke engine cycle.",
    answer: "The four-stroke cycle consists of: 1) Intake - intake valve opens, piston moves down, drawing fuel-air mixture; 2) Compression - both valves close, piston moves up, compressing mixture; 3) Power - spark ignites mixture, explosion forces piston down; 4) Exhaust - exhaust valve opens, piston moves up, expelling gases. This cycle repeats thousands of times per minute.",
    difficulty: "Medium"
  },
  {
    id: 1538,
    subject: "Auto & Shop Information",
    question: "What is engine compression and how is it measured?",
    answer: "Engine compression is the pressure created when the piston compresses the fuel-air mixture. It's measured in PSI (pounds per square inch) using a compression tester. Low compression indicates worn piston rings, valve leaks, or head gasket problems. Typical compression is 120-200 PSI depending on engine design.",
    difficulty: "Medium"
  },
  {
    id: 1539,
    subject: "Auto & Shop Information",
    question: "Explain the difference between horsepower and torque.",
    answer: "Horsepower is the rate at which an engine can do work, measuring overall power output. Torque is rotational force, measured in foot-pounds, representing the engine's ability to turn the wheels. Low-gear acceleration depends on torque, while top speed depends on horsepower. Both are important for vehicle performance.",
    difficulty: "Medium"
  },
  {
    id: 1540,
    subject: "Auto & Shop Information",
    question: "What does OBD (On-Board Diagnostic) scan do?",
    answer: "OBD-II scan tools read diagnostic trouble codes and real-time engine data to identify problems. They connect to the vehicle's diagnostic port and retrieve information about engine performance, emissions, transmission, and other systems. This helps mechanics quickly diagnose issues without extensive testing.",
    difficulty: "Medium"
  },
  {
    id: 1541,
    subject: "Auto & Shop Information",
    question: "Describe brake pad wear indicators.",
    answer: "Brake pad wear indicators are warning systems that alert drivers when pads need replacement. Mechanical indicators have a metal tab that scrapes the rotor when pads are thin, creating a squealing noise. Electronic indicators trigger a dashboard light. Regular brake inspections prevent rotor damage and expensive repairs.",
    difficulty: "Medium"
  },
  {
    id: 1542,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a PCV system?",
    answer: "The Positive Crankcase Ventilation (PCV) system routes harmful crankcase gases back into the engine for combustion instead of venting them to the atmosphere. This reduces emissions, prevents pressure buildup in the engine, and prevents oil leaks. A faulty PCV system causes rough idle and increased emissions.",
    difficulty: "Medium"
  },
  {
    id: 1543,
    subject: "Auto & Shop Information",
    question: "Explain how an automatic transmission works.",
    answer: "An automatic transmission uses a torque converter (hydraulic coupling), planetary gear sets, and bands/clutches to automatically shift gears based on engine load and vehicle speed. The transmission fluid provides hydraulic pressure to engage different gear combinations. Electronic sensors control shift timing for optimal performance and fuel economy.",
    difficulty: "Medium"
  },
  {
    id: 1544,
    subject: "Auto & Shop Information",
    question: "What does the exhaust manifold do?",
    answer: "The exhaust manifold collects hot exhaust gases from individual cylinder ports into one pipe. It directs gases from combustion toward the catalytic converter, muffler, and tailpipe. The manifold must withstand extreme temperatures (1200-1800 degrees F) while maintaining structural integrity.",
    difficulty: "Medium"
  },
  {
    id: 1545,
    subject: "Auto & Shop Information",
    question: "Describe the purpose of an emission control system.",
    answer: "Emission control systems reduce harmful pollutants released from the tailpipe. Components include catalytic converters, PCV systems, EGR systems, and oxygen sensors. These systems work together to reduce carbon monoxide, nitrogen oxides, and unburned hydrocarbons. Proper maintenance ensures compliance with environmental standards.",
    difficulty: "Medium"
  },
  {
    id: 1546,
    subject: "Auto & Shop Information",
    question: "What is anti-lock braking system (ABS)?",
    answer: "ABS prevents wheel lockup during hard braking by automatically pulsing brake pressure on and off. Sensors detect when a wheel stops rotating (lockup), and the system reduces pressure to that wheel, allowing it to continue rolling. This maintains steering control and traction during emergency braking.",
    difficulty: "Medium"
  },
  {
    id: 1547,
    subject: "Auto & Shop Information",
    question: "Explain the function of the differential in a vehicle.",
    answer: "The differential allows drive wheels to rotate at different speeds while receiving equal power from the engine. This is essential for turning corners where the outside wheel travels farther than the inside wheel. Without a differential, tires would slip during turns, causing premature wear and poor handling.",
    difficulty: "Medium"
  },
  {
    id: 1548,
    subject: "Auto & Shop Information",
    question: "What does the intake manifold do?",
    answer: "The intake manifold distributes the fuel-air mixture from the fuel injectors or carburetor evenly to each engine cylinder. It must provide balanced distribution for smooth, efficient combustion across all cylinders. The manifold also acts as a mounting point for various accessories like the throttle body.",
    difficulty: "Medium"
  },
  {
    id: 1549,
    subject: "Auto & Shop Information",
    question: "Describe the purpose of a transmission fluid cooler.",
    answer: "A transmission fluid cooler removes excess heat from transmission fluid by passing it through a small radiator-like device. Excessive heat damages transmission seals, reduces fluid viscosity, and causes internal wear. Coolers are especially important in vehicles that tow or operate in hot conditions.",
    difficulty: "Medium"
  },
  {
    id: 1550,
    subject: "Auto & Shop Information",
    question: "What is a camshaft and what does it do?",
    answer: "A camshaft is a shaft with lobes (cams) that operate the intake and exhaust valves. As the shaft rotates, the lobes push on valve lifters or rocker arms, opening and closing valves at precise times during the engine cycle. Proper cam timing is critical for engine performance and efficiency.",
    difficulty: "Medium"
  },
  {
    id: 1551,
    subject: "Auto & Shop Information",
    question: "What is the difference between synthetic and conventional motor oil?",
    answer: "Synthetic oil is chemically engineered with uniform molecular structure, offering better performance at extreme temperatures, longer change intervals (7,500-10,000+ miles), and superior protection. Conventional oil comes from crude oil with variable composition, requiring more frequent changes (3,000-5,000 miles). Synthetic is more expensive but provides better engine protection.",
    difficulty: "Medium"
  },
  {
    id: 1552,
    subject: "Auto & Shop Information",
    question: "Explain the function of traction control.",
    answer: "Traction control prevents wheel spin during acceleration by detecting when a wheel loses grip on the road. The system automatically reduces engine power and applies brakes to that wheel, restoring traction. This improves acceleration on slippery surfaces and prevents loss of vehicle control.",
    difficulty: "Medium"
  },
  {
    id: 1553,
    subject: "Auto & Shop Information",
    question: "What does engine knock indicate?",
    answer: "Engine knock (pinging) occurs when fuel detonates prematurely before the spark plug fires. This creates abnormal shock waves damaging the engine. Causes include low-octane fuel, carbon buildup, improper timing, or overheating. Modern knock sensors detect this and retard timing to prevent damage.",
    difficulty: "Medium"
  },
  {
    id: 1554,
    subject: "Auto & Shop Information",
    question: "Describe the purpose of a muffler.",
    answer: "A muffler reduces exhaust noise by using chambers and baffles to muffle sound waves created by the combustion process. It also affects exhaust backpressure which influences engine performance. Quality mufflers balance noise reduction with minimal performance impact and must withstand extreme temperatures and corrosion.",
    difficulty: "Medium"
  },
  {
    id: 1555,
    subject: "Auto & Shop Information",
    question: "What is power steering and how does it work?",
    answer: "Power steering uses hydraulic or electric pressure to assist steering input, reducing the physical effort required to turn the wheel. Hydraulic systems use an engine-driven pump; electric systems use an electric motor. Power steering improves maneuverability, reduces driver fatigue, and enables tighter steering ratios.",
    difficulty: "Medium"
  },
  {
    id: 1556,
    subject: "Auto & Shop Information",
    question: "What is the function of an oxygen sensor in the exhaust?",
    answer: "An oxygen sensor measures the oxygen content in exhaust gases to determine if the fuel mixture is rich or lean. This information goes to the engine computer which adjusts fuel injection for optimal combustion efficiency and emissions control. A faulty oxygen sensor causes poor fuel economy and increased emissions.",
    difficulty: "Medium"
  },
  {
    id: 1557,
    subject: "Auto & Shop Information",
    question: "Explain what happens when a water pump fails.",
    answer: "When a water pump fails, coolant circulation stops, causing the engine to overheat rapidly. This can lead to warped cylinder heads, blown head gaskets, engine seizure, and complete engine failure. Failed pumps must be replaced immediately to prevent catastrophic engine damage.",
    difficulty: "Medium"
  },
  {
    id: 1558,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a CV joint (constant velocity joint)?",
    answer: "CV joints allow the front wheels to receive power at varying angles during suspension movement and steering. They use ball bearings and a spider design to transmit torque smoothly regardless of the angle. Boots around CV joints seal in grease and keep out dirt to prevent joint failure.",
    difficulty: "Medium"
  },
  {
    id: 1559,
    subject: "Auto & Shop Information",
    question: "Describe the symptoms of a failing starter motor.",
    answer: "A failing starter may produce clicking sounds without cranking, slow cranking speeds, grinding noises, or complete failure to crank. These indicate worn brushes, damaged armature, weak solenoid, or battery problems. A failing starter prevents engine start and requires replacement.",
    difficulty: "Medium"
  },
  {
    id: 1560,
    subject: "Auto & Shop Information",
    question: "What is a timing belt and why is it critical?",
    answer: "A timing belt synchronizes crankshaft and camshaft rotation to ensure valves open and close at the exact right moments during the engine cycle. If the belt breaks, valves and pistons collide causing catastrophic engine damage. Timing belts typically need replacement every 60,000-100,000 miles.",
    difficulty: "Medium"
  },
  {
    id: 1561,
    subject: "Auto & Shop Information",
    question: "What are the basic shop safety rules when working on vehicles?",
    answer: "Key safety rules include: use wheel chocks and jack stands when raising vehicles, wear safety glasses and gloves, disconnect batteries before electrical work, allow engines to cool before touching, use proper tools for the job, keep loose clothing away from moving parts, never smoke around fuel, and maintain a clean work area. Safety prevents serious injury.",
    difficulty: "Easy"
  },
  {
    id: 1562,
    subject: "Auto & Shop Information",
    question: "What is the proper way to use a floor jack safely?",
    answer: "Always place the jack on a hard, level surface. Use the designated jacking points on the vehicle frame, never under body panels. Raise the vehicle slowly and smoothly. After lifting, immediately support the vehicle with properly rated jack stands before working underneath. Never rely solely on a jack for support.",
    difficulty: "Easy"
  },
  {
    id: 1563,
    subject: "Auto & Shop Information",
    question: "Describe proper fire safety in an auto shop.",
    answer: "Keep fire extinguishers readily accessible and know their types: Class A for ordinary materials, Class B for flammable liquids, Class C for electrical fires. No smoking near fuel, batteries, or flammable materials. Store fuel and solvents in proper containers away from ignition sources. Know emergency procedures and evacuation routes.",
    difficulty: "Easy"
  },
  {
    id: 1564,
    subject: "Auto & Shop Information",
    question: "What are the hazards of working with batteries?",
    answer: "Batteries pose several hazards: they store electrical energy that can cause shock or arc flash, contain corrosive sulfuric acid that burns skin and eyes, emit explosive hydrogen gas during charging, and have heavy weight causing strain injuries. Always wear protection, disconnect before major work, and provide ventilation during charging.",
    difficulty: "Easy"
  },
  {
    id: 1565,
    subject: "Auto & Shop Information",
    question: "What safety precautions apply when working with hydraulic systems?",
    answer: "High-pressure hydraulic fluid can penetrate skin causing serious injury. Never point a leak toward yourself or others. Use proper containment when disconnecting lines. Depressurize systems before service. Wear eye protection against spray. Keep high-pressure hoses and connections in good condition. Contaminated fluid reduces system performance.",
    difficulty: "Easy"
  },
  {
    id: 1566,
    subject: "Auto & Shop Information",
    question: "Describe proper ventilation requirements for auto shops.",
    answer: "Adequate ventilation removes harmful fumes from engine exhaust, solvents, paints, and welding. Use exhaust hose connections on running vehicles, install fume extraction systems, keep doors and windows open when possible, and use respirators when working with hazardous materials. Poor ventilation causes headaches, respiratory issues, and long-term health problems.",
    difficulty: "Easy"
  },
  {
    id: 1567,
    subject: "Auto & Shop Information",
    question: "What is the proper procedure for handling hazardous materials?",
    answer: "Follow MSDS (Material Safety Data Sheet) instructions for each chemical. Wear appropriate PPE including gloves, eye protection, and respiratory protection when needed. Store materials in properly labeled containers in designated areas away from incompatible materials. Dispose of waste properly according to environmental regulations. Never mix chemicals unless instructed.",
    difficulty: "Easy"
  },
  {
    id: 1568,
    subject: "Auto & Shop Information",
    question: "What protective equipment should be worn when working on brakes?",
    answer: "Wear safety glasses to protect from brake cleaner spray and dust, nitrile gloves to prevent contact with harmful materials and contaminants, and a respirator when using brake cleaner or creating brake dust. Proper PPE prevents eye damage, skin irritation, and respiratory issues from asbestos and brake dust.",
    difficulty: "Easy"
  },
  {
    id: 1569,
    subject: "Auto & Shop Information",
    question: "Describe the dangers of working under a vehicle without proper support.",
    answer: "A vehicle can slip off a jack causing crushing injuries or death. Always use jack stands rated for the vehicle's weight, placed on solid ground at stable contact points. Never work under a vehicle supported only by a jack. Even brief periods under unsupported vehicles create serious injury risk.",
    difficulty: "Easy"
  },
  {
    id: 1570,
    subject: "Auto & Shop Information",
    question: "What should you do if gasoline gets on your skin?",
    answer: "Immediately wash the affected area with soap and water for at least 15 seconds. Remove contaminated clothing and allow skin to air dry. Do not use solvents or strong detergents that can cause additional damage. If skin irritation persists or gasoline is ingested, seek medical attention immediately. Prevention through proper handling is essential.",
    difficulty: "Easy"
  },
  {
    id: 1571,
    subject: "Auto & Shop Information",
    question: "What is the purpose of a welding torch and what types exist?",
    answer: "A welding torch combines fuel gas and oxygen to create high-temperature flame for joining metals. Oxy-acetylene torches use acetylene gas for general welding and cutting up to 3000 degrees F. Different nozzle sizes control flame temperature and speed. Proper torch handling prevents burns and fire hazards.",
    difficulty: "Medium"
  },
  {
    id: 1572,
    subject: "Auto & Shop Information",
    question: "Describe the difference between MIG and TIG welding.",
    answer: "MIG (Metal Inert Gas) welding uses a wire electrode fed continuously from a gun, faster for production work, good for thin materials. TIG (Tungsten Inert Gas) welding uses a non-consumable tungsten electrode with separate filler rod, requires more skill, produces high-quality welds, excellent for precise work. TIG offers better control; MIG is faster.",
    difficulty: "Medium"
  },
  {
    id: 1573,
    subject: "Auto & Shop Information",
    question: "What is proper technique for stick welding?",
    answer: "Hold the electrode at 15-30 degree angle to the work piece, maintain a short arc length (1/8 inch), move steadily along the joint, and watch the molten pool. Proper speed prevents burning through or creating weak welds. Allow slag to cool slightly before chipping away. Proper technique creates strong, aesthetically pleasing welds.",
    difficulty: "Medium"
  },
  {
    id: 1574,
    subject: "Auto & Shop Information",
    question: "Describe the hazards of welding and proper safety equipment.",
    answer: "Welding produces intense UV radiation, extreme heat, sparks, and toxic fumes. Required PPE includes welding helmet with proper shade, heat-resistant gloves, long sleeves, and closed-toe boots. Good ventilation removes fumes from metals like zinc and cadmium. Never weld in confined spaces without ventilation to prevent toxic exposure.",
    difficulty: "Medium"
  },
  {
    id: 1575,
    subject: "Auto & Shop Information",
    question: "What is the purpose of welding flux?",
    answer: "Flux is a chemical compound applied to the joint or electrode that removes oxides from the metal surface, allowing proper fusion. It also creates a shielding gas to protect the molten metal from atmospheric contamination. Different flux types match specific welding processes and materials. Proper flux selection ensures strong, clean welds.",
    difficulty: "Medium"
  },
  {
    id: 1576,
    subject: "Auto & Shop Information",
    question: "Describe common welding defects and their causes.",
    answer: "Porosity (gas pockets) results from contamination or improper shielding. Cracks indicate excessive heating or cooling rates. Incomplete fusion occurs from inadequate heat or improper angle. Undercut weakens the joint by removing base metal. Spatter (metal beads) happens with excessive current. Proper technique, clean materials, and correct settings prevent defects.",
    difficulty: "Medium"
  },
  {
    id: 1577,
    subject: "Auto & Shop Information",
    question: "What is metal tempering and why is it important?",
    answer: "Tempering is heating hardened metal to a specific temperature below its critical point, then cooling it. This process reduces brittleness while maintaining hardness, improving toughness and workability. Untempered hardened steel shatters easily; proper tempering creates the ideal balance of strength and flexibility for tools and parts.",
    difficulty: "Medium"
  },
  {
    id: 1578,
    subject: "Auto & Shop Information",
    question: "Describe the annealing process for metals.",
    answer: "Annealing heats metal to a high temperature, then cools it slowly to room temperature. This removes internal stresses, improves workability, and reduces hardness. Annealing is performed after heavy work to restore ductility so the metal can be worked further without cracking. Different metals require specific annealing temperatures.",
    difficulty: "Medium"
  },
  {
    id: 1579,
    subject: "Auto & Shop Information",
    question: "What is case hardening and how is it used?",
    answer: "Case hardening adds carbon or nitrogen to the surface of low-carbon steel, creating a hard outer case while keeping the core tough. This process involves heating in a carbon-rich environment, then quenching. It's used for gears, bearing surfaces, and wear parts that need hardness without brittleness.",
    difficulty: "Medium"
  },
  {
    id: 1580,
    subject: "Auto & Shop Information",
    question: "Describe the purpose of a metal file and common file types.",
    answer: "Files remove material, smooth surfaces, and shape metal. Flat files remove large amounts; round files fit circular surfaces; triangular files fit corners; needle files work fine detail. Cut refers to coarseness: coarse for heavy removal, medium for general work, fine for finishing. Proper file selection and technique prevent slipping and damage.",
    difficulty: "Medium"
  },
  {
    id: 1581,
    subject: "Auto & Shop Information",
    question: "What is woodworking hand planing and when is it used?",
    answer: "Hand planing removes thin layers of wood to smooth surfaces and create precise dimensions. A sharp blade at the correct angle produces clean shavings without tearout. Planing follows grain direction for best results. Woodworkers use planes for finishing work, fitting joints, and customizing dimensions where power tools are too aggressive.",
    difficulty: "Medium"
  },
  {
    id: 1582,
    subject: "Auto & Shop Information",
    question: "Describe basic woodworking joint types and their applications.",
    answer: "Butt joints simply place wood edges together, weakest but easiest. Lap joints overlap wood pieces, stronger than butt. Mortise and tenon joints use projecting tenon fitting into mortise cavity, very strong. Dovetail joints have interlocking pins, excellent for drawers and boxes. Each joint type has specific applications based on strength needs.",
    difficulty: "Medium"
  },
  {
    id: 1583,
    subject: "Auto & Shop Information",
    question: "What is the purpose of wood finishing and types of finishes?",
    answer: "Wood finishing protects the wood from moisture, wear, and UV damage while enhancing appearance. Oil finishes penetrate grain, water-resistant stains add color, lacquer creates hard glossy coats, polyurethane offers durable protection, and wax provides low luster and feel. The right finish depends on intended use and desired appearance.",
    difficulty: "Medium"
  },
  {
    id: 1584,
    subject: "Auto & Shop Information",
    question: "Describe proper saw blade selection for different materials.",
    answer: "For wood: fine teeth for crosscutting, coarse teeth for ripping. For metal: high-speed steel or carbide teeth, slower speed. For plastic: fine teeth, low speed to prevent melting. Blade material, tooth count, and set affect cutting quality and speed. Wrong blade selection causes binding, poor cuts, or blade damage.",
    difficulty: "Medium"
  },
  {
    id: 1585,
    subject: "Auto & Shop Information",
    question: "What is sharpening and how is it performed?",
    answer: "Sharpening restores cutting edges to tools using whetstones, honing guides, or grinding wheels. Whetstones use fine-grained stones; grinding wheels cut fast but require skill. Proper angle and pressure create uniform edge. Sharp tools cut cleanly and safely; dull tools require excessive force and slip dangerously.",
    difficulty: "Medium"
  },
  {
    id: 1586,
    subject: "Auto & Shop Information",
    question: "Explain the difference between bolts, screws, and studs.",
    answer: "Bolts have a hexagonal head and nut, withstand high tension, used for structural connections. Screws have a pointed tip and thread the material directly, used for assembly. Studs are headless bolts threaded at both ends, used where space is tight. Each fastener type serves specific applications based on strength and installation requirements.",
    difficulty: "Medium"
  },
  {
    id: 1587,
    subject: "Auto & Shop Information",
    question: "What do bolt grades and markings indicate?",
    answer: "Bolt grade markings on the head indicate material strength: SAE Grade 2 (no marking, lowest strength), Grade 5 (3 lines), Grade 8 (6 lines), with higher grades having higher tensile strength. Metric bolts use different marking systems. Using correct grade is critical to prevent fastener failure under load.",
    difficulty: "Medium"
  },
  {
    id: 1588,
    subject: "Auto & Shop Information",
    question: "Describe different thread pitch and when each is used.",
    answer: "Coarse pitch (standard) uses larger threads for general purposes, easier to assemble, less prone to cross-threading. Fine pitch uses smaller threads for closer tolerances, higher strength, better vibration resistance. Very fine pitch for thin materials or delicate work. Pitch affects assembly speed and joint strength - coarse for ease, fine for precision and vibration resistance.",
    difficulty: "Medium"
  },
  {
    id: 1589,
    subject: "Auto & Shop Information",
    question: "What is thread locking compound and how is it used?",
    answer: "Thread-locking compounds seal fastener threads preventing loosening from vibration. Removable types (blue) allow disassembly with normal tools. Permanent types (red) require heat for removal. Apply sparingly to clean threads before assembly. Proper use prevents fastener failure and maintains critical connections under vibration and stress.",
    difficulty: "Medium"
  },
  {
    id: 1590,
    subject: "Auto & Shop Information",
    question: "Explain the purpose of washers with fasteners.",
    answer: "Washers distribute pressure over a larger area preventing fastener heads from sinking into soft materials. Flat washers protect surfaces, lock washers (split or star) prevent loosening from vibration. Using proper washers prevents fastener failure, extends component life, and ensures proper load distribution.",
    difficulty: "Medium"
  },
  {
    id: 1591,
    subject: "Auto & Shop Information",
    question: "Describe the difference between ferrous and non-ferrous metals.",
    answer: "Ferrous metals contain iron (steel, cast iron, wrought iron) and are magnetic. They rust easily without protection but offer high strength. Non-ferrous metals (aluminum, copper, brass, bronze) contain no iron, resist corrosion, are lighter, conduct electricity better. Each type has specific applications based on strength, weight, corrosion resistance, and cost.",
    difficulty: "Easy"
  },
  {
    id: 1592,
    subject: "Auto & Shop Information",
    question: "What is steel and how is it different from pure iron?",
    answer: "Steel is an alloy of iron and carbon (typically 0.2-2% carbon). Adding carbon significantly increases strength and hardness compared to pure iron which is too soft for most applications. Different carbon content creates different steel grades: low-carbon (mild), medium-carbon, and high-carbon steels. Carbon percentage determines hardness and workability.",
    difficulty: "Easy"
  },
  {
    id: 1593,
    subject: "Auto & Shop Information",
    question: "Describe aluminum and its common uses.",
    answer: "Aluminum is a lightweight, non-ferrous metal about one-third the density of steel. It resists corrosion naturally and machines easily. Common automotive uses include wheels, engine blocks, transmission cases, and body panels. Aluminum alloys gain strength through specific element additions. Poor strength-to-weight ratio for highly stressed components limits pure aluminum use.",
    difficulty: "Easy"
  },
  {
    id: 1594,
    subject: "Auto & Shop Information",
    question: "What is cast iron and what are its characteristics?",
    answer: "Cast iron contains 2-4% carbon with a graphite microstructure making it brittle but excellent at retaining heat. Common applications include engine blocks, brake drums, and manifolds. Cast iron is inexpensive and excellent at absorbing vibration, though heavier than modern alternatives. Its rigidity makes it ideal for high-temperature and vibration environments.",
    difficulty: "Easy"
  },
  {
    id: 1595,
    subject: "Auto & Shop Information",
    question: "Explain the properties of copper and brass.",
    answer: "Copper is an excellent conductor of electricity and heat, resists corrosion, and is easily worked. Brass is a copper-zinc alloy with superior strength and corrosion resistance. Both are used in cooling systems, electrical components, and connectors. They're non-magnetic and attractive, but expensive compared to steel.",
    difficulty: "Easy"
  },
  {
    id: 1596,
    subject: "Auto & Shop Information",
    question: "What is stainless steel and why is it used?",
    answer: "Stainless steel contains chromium (10-30%) that creates an oxide layer resisting corrosion. It maintains appearance over time and handles moisture well without rusting. More expensive than regular steel, stainless is used where corrosion resistance and appearance matter: fasteners, trim, exhaust components, and marine applications.",
    difficulty: "Easy"
  },
  {
    id: 1597,
    subject: "Auto & Shop Information",
    question: "Describe the difference between hardness and strength in metals.",
    answer: "Hardness is resistance to deformation under pressure or scratching. Strength is the ability to withstand stress without breaking. A metal can be hard but brittle (breaks suddenly) or strong but ductile (bends before breaking). Both properties are important depending on application requirements.",
    difficulty: "Easy"
  },
  {
    id: 1598,
    subject: "Auto & Shop Information",
    question: "What is ductility and why is it important?",
    answer: "Ductility is the ability of a material to deform plastically without breaking. High ductility allows bending and shaping without cracking. Metals like copper and aluminum have high ductility. Ductile materials give warning before failure through visible deformation, whereas brittle materials fail suddenly.",
    difficulty: "Easy"
  },
  {
    id: 1599,
    subject: "Auto & Shop Information",
    question: "Describe material brittleness and its effects.",
    answer: "Brittleness is the tendency to fracture suddenly under stress without plastic deformation. Brittle materials like cast iron and glass give no warning before failure. Brittleness increases at low temperatures and with impact loads. Hard materials are often brittle; tempering reduces brittleness while maintaining hardness.",
    difficulty: "Easy"
  },
  {
    id: 1600,
    subject: "Auto & Shop Information",
    question: "What is corrosion and how can it be prevented?",
    answer: "Corrosion is chemical degradation of metal through oxidation, particularly in iron-based metals. It weakens components and creates rough surfaces. Prevention methods include painting, galvanizing, stainless steel, oil coating, and proper drainage. Regular maintenance and inspection prevent corrosion damage and extend component life.",
    difficulty: "Easy"
  },
  {
    id: 1601,
    subject: "Auto & Shop Information",
    question: "Describe turbocharging and supercharging for engine performance.",
    answer: "Both force more air into cylinders, increasing power output. Superchargers use engine power via belt drive; turbos use exhaust gas spin to drive a turbine. Turbos have lag before boost pressure builds; superchargers respond immediately. Both increase horsepower significantly; turbos are more efficient while superchargers are more responsive.",
    difficulty: "Hard"
  },
  {
    id: 1602,
    subject: "Auto & Shop Information",
    question: "What is variable valve timing (VVT) and its benefits?",
    answer: "VVT adjusts the timing of valve opening and closing based on engine speed and load using computer control and hydraulic actuators. This optimizes engine performance across different RPMs, improving power, efficiency, and emissions. Advanced VVT systems provide continuous adjustment rather than fixed timing.",
    difficulty: "Hard"
  },
  {
    id: 1603,
    subject: "Auto & Shop Information",
    question: "Explain direct fuel injection advantages over port injection.",
    answer: "Direct injection sprays fuel directly into cylinders rather than intake manifold. This provides better fuel atomization, faster combustion, improved efficiency, and reduced emissions. Disadvantages include higher pressure requirements, complex injector design, and potential carbon buildup. Modern engines increasingly use direct injection.",
    difficulty: "Hard"
  },
  {
    id: 1604,
    subject: "Auto & Shop Information",
    question: "Describe hybrid-electric propulsion systems.",
    answer: "Hybrid systems combine internal combustion engines with electric motors and batteries. The engine recharges the battery through regenerative braking and operates at optimal efficiency. Electric motor assists during acceleration and powers low-speed driving. Hybrid systems improve fuel economy and reduce emissions by optimizing energy use.",
    difficulty: "Hard"
  },
  {
    id: 1605,
    subject: "Auto & Shop Information",
    question: "What is regenerative braking and how does it work?",
    answer: "Regenerative braking captures kinetic energy during deceleration using electric motors as generators to recharge the battery. As vehicle slows, the motor creates resistance while generating electricity. This process recovers energy normally lost as heat, improving overall efficiency. Hybrid and electric vehicles use this technology extensively.",
    difficulty: "Hard"
  },
  {
    id: 1606,
    subject: "Auto & Shop Information",
    question: "Explain electronic stability control (ESC) systems.",
    answer: "ESC detects loss of traction using gyroscopic sensors and vehicle dynamics. When skidding is detected, the system automatically applies individual wheel brakes and reduces engine power to restore vehicle control. ESC improves safety during emergency maneuvers and slippery conditions by maintaining directional control.",
    difficulty: "Hard"
  },
  {
    id: 1607,
    subject: "Auto & Shop Information",
    question: "Describe the function of an EGR system (exhaust gas recirculation).",
    answer: "EGR routes a portion of exhaust gases back into the intake manifold to reduce peak combustion temperatures and nitrogen oxide formation. Lower combustion temperature reduces emissions while slightly reducing power. EGR systems must be properly calibrated to maintain performance while meeting emission standards.",
    difficulty: "Hard"
  },
  {
    id: 1608,
    subject: "Auto & Shop Information",
    question: "What is a turbocharger wastegate and how does it function?",
    answer: "A wastegate is a valve that bypasses exhaust gas around the turbo turbine when boost pressure exceeds the target. This prevents overboosting and excessive pressure buildup that could damage the engine. Wastegates use spring tension or computer solenoids for boost control, maintaining safe operating pressures.",
    difficulty: "Hard"
  },
  {
    id: 1609,
    subject: "Auto & Shop Information",
    question: "Describe active suspension systems and their advantages.",
    answer: "Active suspension uses computer-controlled hydraulic or electromagnetic actuators to adjust suspension stiffness and height in real-time. Sensors monitor road conditions and vehicle dynamics, adjusting suspension response for optimal comfort and handling. This provides superior ride quality and handling compared to passive suspensions.",
    difficulty: "Hard"
  },
  {
    id: 1610,
    subject: "Auto & Shop Information",
    question: "What is a limited-slip differential and why is it used?",
    answer: "A limited-slip differential allows some wheel speed difference during normal driving but limits the difference when one wheel loses traction. This improves cornering balance and traction better than open differentials. Locking differentials completely lock wheels for maximum traction in extreme conditions.",
    difficulty: "Hard"
  },
  {
    id: 1611,
    subject: "Auto & Shop Information",
    question: "Explain the purpose and operation of a torque converter.",
    answer: "A torque converter is a fluid coupling that transfers power from the engine to the transmission. It acts as a fluid flywheel, allowing engine speed to be independent of wheel speed. At low speeds, it multiplies torque; at high speeds, it locks up for direct drive. This enables smooth, automatic shifting.",
    difficulty: "Hard"
  },
  {
    id: 1612,
    subject: "Auto & Shop Information",
    question: "What is the purpose of transmission resonance dampers?",
    answer: "Resonance dampers absorb vibrations and torsional oscillations from the engine transmitted through the transmission. These vibrations can damage components at certain RPM ranges. Dampers use spring-mass or hydraulic principles to isolate and absorb these vibrations, protecting transmission longevity.",
    difficulty: "Hard"
  },
  {
    id: 1613,
    subject: "Auto & Shop Information",
    question: "Describe dual-clutch transmission operation.",
    answer: "Dual-clutch transmissions have two clutches and two separate shafts controlling odd and even gears. While one gear transmits power, the next gear pre-selects on the second clutch. Clutch switching provides near-instantaneous shifts without power interruption. This offers quick shifts and good efficiency similar to manual transmissions.",
    difficulty: "Hard"
  },
  {
    id: 1614,
    subject: "Auto & Shop Information",
    question: "What is adaptive transmission logic in modern vehicles?",
    answer: "Adaptive transmission logic uses artificial intelligence and sensors to learn driving patterns and adjust shift points accordingly. The system adapts to individual driver behavior, road conditions, and vehicle load. This optimizes performance, efficiency, and driving feel personalized to each driver.",
    difficulty: "Hard"
  },
  {
    id: 1615,
    subject: "Auto & Shop Information",
    question: "Explain brake fade and what causes it.",
    answer: "Brake fade is reduced braking force caused by excessive heat reducing friction between pad and rotor. Continuous heavy braking generates temperatures exceeding 600-900 degrees F, causing fluid vaporization and pad glazing. Fade is prevented through proper maintenance, high-temperature brake fluid, and vented rotors for heat dissipation.",
    difficulty: "Hard"
  },
  {
    id: 1616,
    subject: "Auto & Shop Information",
    question: "Describe the purpose of brake bias adjustment.",
    answer: "Brake bias balances front and rear brake force distribution. Front brakes typically handle 60-70% of stopping force due to weight transfer during braking. Adjustable bias allows optimization for different track conditions and driving styles. Improper bias causes rear lock-up or extended front stop distance.",
    difficulty: "Hard"
  },
  {
    id: 1617,
    subject: "Auto & Shop Information",
    question: "What is brake assist and how does it improve safety?",
    answer: "Brake assist detects emergency braking through brake pedal pressure rate and automatically applies maximum braking force. This helps drivers who don't press firmly enough during panic stops. Brake assist can reduce stopping distance 20-30 feet compared to manual maximum effort.",
    difficulty: "Hard"
  },
  {
    id: 1618,
    subject: "Auto & Shop Information",
    question: "Explain continuously variable transmission (CVT) operation.",
    answer: "CVTs use two variable-diameter pulleys connected by a belt, eliminating discrete gears. As engine load and speed change, pulley diameters adjust continuously providing infinite gear ratios. CVTs offer smooth acceleration without gear shifts, excellent efficiency, and responsive power delivery.",
    difficulty: "Hard"
  },
  {
    id: 1619,
    subject: "Auto & Shop Information",
    question: "What is a synchronizer in a manual transmission and how does it work?",
    answer: "Synchronizers match engine speed to selected gear speed before engagement, preventing grinding. A friction cone on the gear hub contacts a corresponding cone on the input shaft, creating friction that brings speeds to match. Once synchronized, the gear teeth mesh smoothly. Worn synchronizers cause grinding noises.",
    difficulty: "Hard"
  },
  {
    id: 1620,
    subject: "Auto & Shop Information",
    question: "Describe variable engine displacement technology and its efficiency benefits.",
    answer: "Variable displacement engines deactivate some cylinders during low-load conditions, reducing fuel consumption. The system manages fuel, spark, and valve timing to cylinders as needed, typically cutting power in half. This provides significant fuel economy improvements during city driving while maintaining full power for acceleration.",
    difficulty: "Hard"
  }
,
{
  id: 1621,
  subject: "Paragraph Comprehension",
  question: "Effective military leadership requires more than technical expertise. Officers must understand their personnel's motivations, strengths, and limitations. A commander who invests time in knowing their troops builds trust and achieves higher mission success rates. What is the main idea of this passage?",
  answer: "The main idea is that effective military leadership depends on understanding personnel and building trust, not just technical knowledge. This results in better mission outcomes.",
  difficulty: "Easy"
},
{
  id: 1622,
  subject: "Paragraph Comprehension",
  question: "The supply chain is critical to military operations. Every piece of equipment must reach the right unit at the right time. A single breakdown in logistics can compromise an entire mission. According to the passage, what makes the supply chain important?",
  answer: "The supply chain is important because timely delivery of equipment to the right units is essential for mission success, and any delay can compromise operations.",
  difficulty: "Easy"
},
{
  id: 1623,
  subject: "Paragraph Comprehension",
  question: "Physical fitness standards in the military exist to ensure all personnel can meet operational demands. Soldiers who maintain peak condition are better prepared for combat scenarios and recovery from injuries. Why are physical fitness standards established?",
  answer: "Physical fitness standards ensure personnel can meet operational demands, prepare for combat, and recover more quickly from injuries.",
  difficulty: "Easy"
},
{
  id: 1624,
  subject: "Paragraph Comprehension",
  question: "Communication failures in combat situations can be catastrophic. Units must have clear protocols for relaying information. Radio operators train extensively to ensure messages are transmitted accurately and quickly. What is the main purpose of the passage?",
  answer: "To explain why communication is critical in combat and how training helps prevent failures through accurate and quick message transmission.",
  difficulty: "Easy"
},
{
  id: 1625,
  subject: "Paragraph Comprehension",
  question: "The rules of engagement define what actions military personnel can take in a conflict. These rules protect civilians and help maintain international law compliance. All soldiers must understand their ROE before deploying. What is a function of the rules of engagement?",
  answer: "Rules of engagement define acceptable military actions, protect civilians, and ensure compliance with international law.",
  difficulty: "Easy"
},
{
  id: 1626,
  subject: "Paragraph Comprehension",
  question: "Military discipline creates order and efficiency. When soldiers follow procedures consistently, operations run smoothly. Discipline also builds unit cohesion and mutual respect among team members. What benefit of discipline is mentioned in the passage?",
  answer: "Discipline creates order, efficiency, unit cohesion, and mutual respect among team members.",
  difficulty: "Easy"
},
{
  id: 1627,
  subject: "Paragraph Comprehension",
  question: "Intelligence gathering provides critical information about enemy capabilities and movements. Accurate intelligence allows commanders to make informed strategic decisions. Without reliable intelligence, military operations are conducted at a significant disadvantage. What does intelligence gathering provide according to the passage?",
  answer: "Intelligence gathering provides critical information about enemy capabilities and movements, enabling informed strategic decisions.",
  difficulty: "Easy"
},
{
  id: 1628,
  subject: "Paragraph Comprehension",
  question: "Medical training is mandatory for all combat troops. In situations where formal medical support is unavailable, soldiers must provide basic first aid to themselves and their unit. This training saves lives in critical moments. What makes medical training important for combat troops?",
  answer: "Medical training is important because troops must be able to provide first aid when formal medical support is unavailable, which can save lives.",
  difficulty: "Easy"
},
{
  id: 1629,
  subject: "Paragraph Comprehension",
  question: "Aviation maintenance requires meticulous attention to detail. Even minor oversights can lead to catastrophic failures during flight. Maintenance crews document every inspection and repair to ensure aircraft safety. Why is attention to detail important in aviation maintenance?",
  answer: "Because even minor oversights can cause catastrophic failures during flight, so documentation and careful inspection are essential for safety.",
  difficulty: "Easy"
},
{
  id: 1630,
  subject: "Paragraph Comprehension",
  question: "Cyber defense protects military networks from unauthorized access and attacks. Soldiers must protect sensitive information and follow protocols for secure communication. A successful cyber attack could compromise entire operations. What is the primary purpose of cyber defense?",
  answer: "To protect military networks from unauthorized access and attacks, safeguarding sensitive information and preventing operational compromise.",
  difficulty: "Easy"
},
{
  id: 1631,
  subject: "Paragraph Comprehension",
  question: "Deployment rotation policies aim to provide service members adequate time at home to rest and reconnect with family. Extended deployments without rotation periods can negatively impact mental health and readiness. What is the purpose of deployment rotation policies?",
  answer: "To provide service members rest time with family and maintain mental health and readiness by preventing extended continuous deployments.",
  difficulty: "Easy"
},
{
  id: 1632,
  subject: "Paragraph Comprehension",
  question: "Strategic planning requires analyzing terrain, weather patterns, and available resources. Military planners use this information to develop operational approaches that maximize effectiveness while minimizing risks. What factors do military planners analyze?",
  answer: "Terrain, weather patterns, and available resources to develop effective operational approaches that maximize effectiveness and minimize risks.",
  difficulty: "Easy"
},
{
  id: 1633,
  subject: "Paragraph Comprehension",
  question: "Veteran support programs provide essential services including mental health counseling, job training, and educational benefits. These programs recognize the sacrifices made during service. Why do veteran support programs exist?",
  answer: "To provide essential services including mental health counseling, job training, and education, recognizing the sacrifices service members made.",
  difficulty: "Easy"
},
{
  id: 1634,
  subject: "Paragraph Comprehension",
  question: "Leadership requires the ability to make difficult decisions under pressure. In combat situations, a hesitant leader can endanger the entire unit. Effective commanders train to remain calm and decisive when facing critical challenges. What characteristic must effective military leaders demonstrate?",
  answer: "Effective leaders must remain calm and decisive under pressure, as hesitation in combat can endanger the entire unit.",
  difficulty: "Easy"
},
{
  id: 1635,
  subject: "Paragraph Comprehension",
  question: "Training simulations prepare soldiers for combat scenarios without risking lives. Advanced virtual reality systems can recreate realistic battlefield conditions. These simulations allow personnel to practice decision-making and tactical responses. What advantage do training simulations provide?",
  answer: "Training simulations allow personnel to practice in realistic scenarios without risking lives, improving decision-making and tactical responses.",
  difficulty: "Easy"
},
{
  id: 1636,
  subject: "Paragraph Comprehension",
  question: "Environmental monitoring in military operations includes tracking water sources, weather patterns, and geographical features. This information helps units plan movements and locate resources in deployment areas. What is the purpose of environmental monitoring?",
  answer: "To track water sources, weather, and geographical features, helping units plan movements and locate resources in deployment areas.",
  difficulty: "Easy"
},
{
  id: 1637,
  subject: "Paragraph Comprehension",
  question: "Maintenance schedules for equipment prevent breakdowns during critical operations. Regular inspections identify potential problems before they become serious issues. Well-maintained equipment increases mission success rates. Why are maintenance schedules important?",
  answer: "Maintenance schedules prevent breakdowns, identify potential problems early, and increase equipment reliability for mission success.",
  difficulty: "Easy"
},
{
  id: 1638,
  subject: "Paragraph Comprehension",
  question: "Navigation skills remain essential even with modern GPS technology. Soldiers must be able to navigate using maps and compasses if electronic systems fail. Backup navigation methods ensure units can maintain their course under any conditions. Why are traditional navigation skills still important?",
  answer: "Because electronic systems can fail, and soldiers must be able to navigate using maps and compasses to maintain course regardless of conditions.",
  difficulty: "Easy"
},
{
  id: 1639,
  subject: "Paragraph Comprehension",
  question: "Unit cohesion improves when team members understand each other's roles and responsibilities. Regular training together strengthens bonds and improves operational coordination. What factor strengthens unit cohesion?",
  answer: "Understanding each other's roles, responsibilities, and regular training together strengthens bonds and improves operational coordination.",
  difficulty: "Easy"
},
{
  id: 1640,
  subject: "Paragraph Comprehension",
  question: "Ammunition storage requires strict protocols to prevent accidental detonation. Ammunition must be stored in designated areas away from personnel. Violations of ammunition storage procedures endanger everyone nearby. What is the purpose of ammunition storage protocols?",
  answer: "To prevent accidental detonation by requiring ammunition to be stored in designated areas away from personnel, protecting everyone from danger.",
  difficulty: "Easy"
},
{
  id: 1641,
  subject: "Paragraph Comprehension",
  question: "During the Cold War, tensions between superpowers shaped military strategies and doctrine. Nations invested heavily in nuclear weapons and deterrence capabilities. The prolonged conflict lasted nearly fifty years before ending in the early 1990s. What was a characteristic of Cold War military strategy?",
  answer: "Superpowers invested heavily in nuclear weapons and deterrence capabilities to manage tensions during the prolonged conflict.",
  difficulty: "Medium"
},
{
  id: 1642,
  subject: "Paragraph Comprehension",
  question: "Adaptive leadership involves adjusting strategies when circumstances change. Military leaders who recognize changing conditions and modify their approach achieve better outcomes. Rigid adherence to initial plans can lead to mission failure. What does adaptive leadership require?",
  answer: "Recognition of changing conditions and modification of strategies accordingly; rigid adherence to initial plans can lead to failure.",
  difficulty: "Medium"
},
{
  id: 1643,
  subject: "Paragraph Comprehension",
  question: "Psychological resilience training prepares soldiers for the mental stressors of combat. Personnel who develop strong coping mechanisms adapt better to deployment and experience fewer mental health issues post-service. Why is psychological resilience training important?",
  answer: "It prepares soldiers for mental stressors of combat, helps develop coping mechanisms, and reduces post-service mental health issues.",
  difficulty: "Medium"
},
{
  id: 1644,
  subject: "Paragraph Comprehension",
  question: "Logistics coordination between allied nations requires clear communication and standardized procedures. Differences in equipment specifications can complicate supply and maintenance operations. Effective alliances depend on compatible systems and shared protocols. What challenge is presented in allied logistics?",
  answer: "Differences in equipment specifications can complicate supply operations, so compatible systems and shared protocols are necessary for effective alliances.",
  difficulty: "Medium"
},
{
  id: 1645,
  subject: "Paragraph Comprehension",
  question: "Non-commissioned officers serve as the backbone of military units. NCOs bridge the gap between enlisted personnel and officers, translating high-level directives into actionable tasks. Their experience and expertise are invaluable to mission success. What role do non-commissioned officers play?",
  answer: "NCOs bridge gaps between enlisted personnel and officers, translating directives into tasks using their experience and expertise for mission success.",
  difficulty: "Medium"
},
{
  id: 1646,
  subject: "Paragraph Comprehension",
  question: "Reconnaissance missions gather information about enemy positions and terrain features. These missions are typically conducted by small, highly trained units. Successful reconnaissance provides commanders with advantages in planning operations. What is the primary purpose of reconnaissance?",
  answer: "To gather information about enemy positions and terrain features, providing commanders with strategic advantages in planning operations.",
  difficulty: "Medium"
},
{
  id: 1647,
  subject: "Paragraph Comprehension",
  question: "Air defense systems protect military installations and mobile units from aerial threats. Early warning systems allow time for personnel to take shelter or maneuver. Modern air defense relies on both radar detection and visual observation. What do air defense systems accomplish?",
  answer: "They protect installations and units from aerial threats, using early warning to allow time for shelter or maneuvers.",
  difficulty: "Medium"
},
{
  id: 1648,
  subject: "Paragraph Comprehension",
  question: "The principle of unity of command ensures that each soldier receives orders from a single, clearly identified leader. When authority is ambiguous, confusion results and mission objectives may not be achieved. Effective organizations maintain clear chains of command. Why is unity of command important?",
  answer: "It ensures clear authority structure and prevents confusion; when authority is ambiguous, mission objectives may not be achieved.",
  difficulty: "Medium"
},
{
  id: 1649,
  subject: "Paragraph Comprehension",
  question: "Fuel logistics are critical for vehicle operations and power generation. Units must maintain adequate fuel supplies while protecting fuel storage from contamination and theft. Fuel shortages can quickly compromise mobility and support operations. What challenge does fuel logistics present?",
  answer: "Units must maintain adequate supplies while protecting from contamination and theft; shortages compromise mobility and support operations.",
  difficulty: "Medium"
},
{
  id: 1650,
  subject: "Paragraph Comprehension",
  question: "Cultural awareness training helps military personnel understand local customs and communication styles in deployment areas. Misunderstandings based on cultural differences can damage relationships with local populations. Cultural competency improves mission effectiveness and safety. What benefit does cultural awareness provide?",
  answer: "It helps prevent misunderstandings, improves relationships with local populations, and enhances mission effectiveness and safety.",
  difficulty: "Medium"
},
{
  id: 1651,
  subject: "Paragraph Comprehension",
  question: "Camouflage and concealment techniques reduce detection by enemy forces. Effective concealment considers terrain, vegetation, and lighting conditions. Units trained in concealment tactics gain tactical advantages during operations. What advantage does effective concealment provide?",
  answer: "Effective concealment reduces enemy detection, and trained units gain tactical advantages during operations.",
  difficulty: "Medium"
},
{
  id: 1652,
  subject: "Paragraph Comprehension",
  question: "Armor plating on vehicles protects occupants from small arms fire and shrapnel. The thickness and composition of armor must balance protection with weight and mobility. Vehicle design reflects compromises between protection and operational capability. What must be balanced in vehicle armor design?",
  answer: "Protection capability must be balanced with vehicle weight and mobility to maintain operational effectiveness.",
  difficulty: "Medium"
},
{
  id: 1653,
  subject: "Paragraph Comprehension",
  question: "Weapons accuracy depends on proper maintenance, ammunition quality, and shooter training. Inconsistent maintenance or substandard ammunition reduces effective range and precision. Military units conduct regular qualification training to ensure shooter proficiency. What factors affect weapons accuracy?",
  answer: "Proper maintenance, ammunition quality, and shooter training; inconsistent maintenance or substandard ammunition reduces range and precision.",
  difficulty: "Medium"
},
{
  id: 1654,
  subject: "Paragraph Comprehension",
  question: "After-action reviews examine what went well and what needs improvement following operations. These reviews capture lessons learned before they are forgotten. Implementation of lessons learned prevents similar mistakes in future operations. What is the purpose of after-action reviews?",
  answer: "To capture lessons learned by examining what went well and what needs improvement, preventing similar mistakes in future operations.",
  difficulty: "Medium"
},
{
  id: 1655,
  subject: "Paragraph Comprehension",
  question: "Military contracts with suppliers must specify exact requirements for materials and delivery timelines. Vague specifications can result in delivery of unsuitable equipment. Clear contract language ensures suppliers understand military needs and meet expectations. Why are specific military contracts important?",
  answer: "Specific requirements prevent unsuitable equipment delivery; clear language ensures suppliers understand needs and meet expectations.",
  difficulty: "Medium"
},
{
  id: 1656,
  subject: "Paragraph Comprehension",
  question: "Risk assessment in military operations evaluates potential threats and develops mitigation strategies. Commanders must weigh mission objectives against personnel safety. Accepting unnecessary risks shows poor judgment; accepting no risks may result in mission failure. What does risk assessment balance?",
  answer: "Risk assessment balances mission objectives against personnel safety, requiring commanders to accept necessary but minimize unnecessary risks.",
  difficulty: "Medium"
},
{
  id: 1657,
  subject: "Paragraph Comprehension",
  question: "Joint operations involve coordination between different military branches. Army, Navy, Air Force, and Marine personnel must work together seamlessly. Interservice cooperation requires compatible equipment and shared communication protocols. What is required for successful joint operations?",
  answer: "Coordination between branches, compatible equipment, and shared communication protocols for interservice cooperation.",
  difficulty: "Medium"
},
{
  id: 1658,
  subject: "Paragraph Comprehension",
  question: "Convoy security protects supply vehicles from ambush and attack. Security forces must maintain situational awareness of surroundings and respond quickly to threats. Successful convoy operations require careful planning and trained personnel. What is the primary concern in convoy security?",
  answer: "Protection from ambush and attack through situational awareness, quick response to threats, and careful planning.",
  difficulty: "Medium"
},
{
  id: 1659,
  subject: "Paragraph Comprehension",
  question: "Equipment redundancy ensures operations can continue if primary systems fail. Military units maintain backup generators, communication systems, and medical equipment. Redundancy adds cost but prevents catastrophic operational failures. Why do military units maintain equipment redundancy?",
  answer: "To ensure operations continue if primary systems fail, preventing catastrophic failures despite added cost.",
  difficulty: "Medium"
},
{
  id: 1660,
  subject: "Paragraph Comprehension",
  question: "Terrain analysis influences military tactics and positioning. Units positioned in defensible terrain gain advantages against attackers. Understanding elevation, vegetation, and natural barriers helps commanders develop effective defensive strategies. How does terrain analysis help military operations?",
  answer: "It identifies defensible positions, elevation advantages, and natural barriers, helping commanders develop effective defensive strategies.",
  difficulty: "Medium"
},
{
  id: 1661,
  subject: "Paragraph Comprehension",
  question: "The history of military strategy demonstrates that armies relying solely on technology without trained personnel suffer defeats. Throughout conflicts from ancient times to modern day, the human factor remains paramount. Technological advancement must be coupled with personnel development and doctrine refinement. What does military history suggest about technology and personnel?",
  answer: "That technology alone is insufficient; trained personnel and proper doctrine are equally important for military success.",
  difficulty: "Hard"
},
{
  id: 1662,
  subject: "Paragraph Comprehension",
  question: "Decentralized command structures distribute authority to lower-level leaders, enabling faster decision-making in rapidly changing situations. However, such structures require personnel with strong judgment and understanding of mission objectives. Organizations must balance flexibility with maintaining coherent operations. What is a potential drawback of decentralized command?",
  answer: "Decentralized structures require personnel with strong judgment and understanding of mission objectives to maintain coherent operations.",
  difficulty: "Hard"
},
{
  id: 1663,
  subject: "Paragraph Comprehension",
  question: "Military procurement decisions often pit immediate readiness requirements against long-term strategic investments. Purchasing advanced systems today may reduce funds for training and personnel development. The relationship between equipment procurement and other operational needs requires nuanced analysis. What tension exists in military procurement?",
  answer: "Tension between immediate readiness needs and long-term strategic investments, as advanced equipment purchases reduce funds for training and personnel.",
  difficulty: "Hard"
},
{
  id: 1664,
  subject: "Paragraph Comprehension",
  question: "Intelligence analysis requires distinguishing between confirmed facts and unverified reports. Analysts must consider source reliability, potential bias, and contradictory information. Drawing conclusions from incomplete information can lead to strategic miscalculation. What challenge do intelligence analysts face?",
  answer: "Distinguishing between confirmed facts and unverified reports while considering source reliability, bias, and contradictions to avoid strategic miscalculation.",
  difficulty: "Hard"
},
{
  id: 1665,
  subject: "Paragraph Comprehension",
  question: "Coalition warfare brings together nations with different military doctrines, equipment standards, and operational objectives. While coalitions provide numerical and resource advantages, they also create coordination challenges. The success of coalition operations depends on shared commitment to strategic goals. What is a challenge unique to coalition warfare?",
  answer: "Coordination challenges resulting from different doctrines, equipment, and objectives, requiring shared commitment to strategic goals.",
  difficulty: "Hard"
},
{
  id: 1666,
  subject: "Paragraph Comprehension",
  question: "Casualty prediction models attempt to forecast personnel losses based on tactical scenarios and threat assessments. However, unpredictable factors such as weather, equipment failures, and individual actions can significantly alter predictions. Commanders must plan conservatively despite predictive models. Why are casualty predictions uncertain?",
  answer: "Unpredictable factors such as weather, equipment failures, and individual actions significantly alter predictions, requiring conservative planning.",
  difficulty: "Hard"
},
{
  id: 1667,
  subject: "Paragraph Comprehension",
  question: "Morale directly influences operational effectiveness, yet morale is difficult to measure and manage. Poor conditions, inadequate leadership, or perceived unfairness erode morale rapidly. Maintaining morale requires attention to both tangible factors like living conditions and intangible factors like unit pride. What makes morale management challenging?",
  answer: "Morale is difficult to measure and manage; it depends on both tangible factors like conditions and intangible factors like unit pride.",
  difficulty: "Hard"
},
{
  id: 1668,
  subject: "Paragraph Comprehension",
  question: "Historical military defeats often resulted from commanders' overconfidence or underestimation of adversary capabilities. The Maginot Line was built on assumptions about future warfare that proved incorrect. Strategic planning must account for adversary innovation and potential tactical surprises. What lesson does military history teach about strategic planning?",
  answer: "Strategic planning must account for adversary innovation and potential surprises; overconfidence and underestimation of adversaries lead to defeat.",
  difficulty: "Hard"
},
{
  id: 1669,
  subject: "Paragraph Comprehension",
  question: "Medical resource allocation during mass casualty events requires difficult prioritization decisions. Providers must treat patients with highest survival probability first, potentially leaving more critically wounded without immediate care. These ethical dilemmas reflect the complexity of military medicine. What dilemma faces medical personnel during mass casualties?",
  answer: "Prioritization decisions based on survival probability may require leaving critically wounded without immediate care, creating ethical complexities.",
  difficulty: "Hard"
},
{
  id: 1670,
  subject: "Paragraph Comprehension",
  question: "Supply line vulnerabilities can become strategic targets for adversaries. Disrupting logistics is often more effective than direct combat operations. Historical examples show that supply line destruction determined campaign outcomes. Why are supply lines strategic targets?",
  answer: "Disrupting logistics is often more effective than direct combat; historical examples show supply line destruction determined campaign outcomes.",
  difficulty: "Hard"
},
{
  id: 1671,
  subject: "Paragraph Comprehension",
  question: "Military readiness depends on maintaining skills through continuous training, but training itself requires resources and time away from other tasks. The optimal level of training that maximizes readiness while minimizing opportunity costs remains debated. Organizations must continuously reassess training requirements. What is the training readiness dilemma?",
  answer: "Continuous training maintains skills but requires resources and time away from other tasks; finding optimal training levels minimizes opportunity costs.",
  difficulty: "Hard"
},
{
  id: 1672,
  subject: "Paragraph Comprehension",
  question: "Classified information requires compartmentalization to limit damage if security is breached. However, excessive compartmentalization can impede necessary information sharing between units. Balancing security with operational effectiveness requires careful protocol development. What is the purpose of information compartmentalization?",
  answer: "To limit damage from security breaches by restricting classified information access, though excessive compartmentalization can impede necessary sharing.",
  difficulty: "Hard"
},
{
  id: 1673,
  subject: "Paragraph Comprehension",
  question: "Military strategy must account for civilian populations in conflict zones. Rules of engagement restrict targeting to minimize civilian casualties, but such restrictions can provide adversary tactical advantages. The ethical and strategic implications of civilian protection remain contentious. What tension exists in civilian protection?",
  answer: "Minimizing civilian casualties through restrictions provides adversaries tactical advantages, creating tension between ethics and strategic military advantage.",
  difficulty: "Hard"
},
{
  id: 1674,
  subject: "Paragraph Comprehension",
  question: "Organizational learning in military institutions often occurs slowly because established doctrine is resistant to change. Yet failure to adapt to new threats and technologies can result in strategic disadvantage. The challenge is distinguishing between necessary adaptation and premature abandonment of proven methods. What organizational challenge faces militaries?",
  answer: "Established doctrine resists change, but failing to adapt to threats and new technologies creates disadvantage; distinguishing necessary adaptation from hasty change is difficult.",
  difficulty: "Hard"
},
{
  id: 1675,
  subject: "Paragraph Comprehension",
  question: "Interoperability standards attempt to ensure different equipment and systems can work together seamlessly. However, requiring compatibility can constrain innovation and increase costs compared to non-standardized systems. The balance between standardization and flexibility reflects complex organizational tradeoffs. What constraint does standardization create?",
  answer: "Standardization can constrain innovation and increase costs compared to non-standardized systems, reflecting tradeoffs between compatibility and flexibility.",
  difficulty: "Hard"
},
{
  id: 1676,
  subject: "Paragraph Comprehension",
  question: "The transition from peacekeeping to combat operations requires rapid mental and tactical adjustment. Personnel trained for humanitarian operations must quickly shift to combat mindset. This shift presents psychological challenges and potential operational risks if not managed carefully. What challenge does operational transition present?",
  answer: "Personnel must shift from humanitarian to combat mindset rapidly, presenting psychological challenges and operational risks if not properly managed.",
  difficulty: "Hard"
},
{
  id: 1677,
  subject: "Paragraph Comprehension",
  question: "Military retirement systems create incentives for 20-year service commitment but may exclude talented personnel who lack continuous service history. Retaining experienced personnel with non-traditional service patterns requires flexible systems that traditional bureaucracies resist. The modernization of retention systems remains incomplete. What is a limitation of traditional military retirement systems?",
  answer: "They create incentives for continuous 20-year service but exclude talented personnel with non-traditional service, requiring system modernization.",
  difficulty: "Hard"
},
{
  id: 1678,
  subject: "Paragraph Comprehension",
  question: "Cyber warfare introduces asymmetric advantages where non-state actors can inflict damage comparable to traditional military attacks. Defensive cyber strategies face challenges because identifying attackers is difficult and response options are unclear. The legal and strategic frameworks for cyber conflict remain underdeveloped. What makes cyber warfare asymmetric?",
  answer: "Non-state actors can inflict comparable damage to traditional attacks; identifying attackers is difficult and response options unclear, with underdeveloped legal frameworks.",
  difficulty: "Hard"
},
{
  id: 1679,
  subject: "Paragraph Comprehension",
  question: "Military procurement corruption involves officials accepting bribes for awarding contracts to unqualified suppliers. Such corruption compromises equipment quality and operational effectiveness. Despite anti-corruption measures, some systems remain vulnerable because oversight mechanisms are incomplete. What consequence does procurement corruption create?",
  answer: "Compromised equipment quality and operational effectiveness result when unqualified suppliers receive contracts; complete oversight remains difficult.",
  difficulty: "Hard"
},
{
  id: 1680,
  subject: "Paragraph Comprehension",
  question: "Geographic dispersion of military installations provides defense redundancy but increases administrative complexity and communication challenges. Centralization improves efficiency but creates vulnerability to concentrated attacks. Strategic facility placement reflects this ongoing security-efficiency tradeoff. What tradeoff does facility placement create?",
  answer: "Dispersion provides defense redundancy but increases complexity; centralization improves efficiency but creates vulnerability, reflecting ongoing tradeoffs.",
  difficulty: "Hard"
},
{
  id: 1681,
  subject: "Paragraph Comprehension",
  question: "The Battle of Marathon in 490 BCE demonstrated that disciplined infantry formations could defeat larger cavalry-dominated forces through superior tactics and terrain positioning. This victory established Athens as a military power and influenced military thinking for centuries. What does the Battle of Marathon demonstrate?",
  answer: "That disciplined infantry with superior tactics and terrain positioning can defeat larger forces, establishing principles of military advantage beyond size.",
  difficulty: "Easy"
},
{
  id: 1682,
  subject: "Paragraph Comprehension",
  question: "The development of gunpowder weapons fundamentally changed military fortification design. Medieval castles with high vertical walls became obsolete against cannon fire. New fortifications used lower profiles and angled bastions for better cannon protection. How did gunpowder affect military fortifications?",
  answer: "It made high vertical walls obsolete, leading to fortifications with lower profiles and angled bastions for better cannon protection.",
  difficulty: "Easy"
},
{
  id: 1683,
  subject: "Paragraph Comprehension",
  question: "The formation of NATO in 1949 created a military alliance based on collective defense principles. Member nations agreed that attack on one would be considered attack on all. This alliance framework continues shaping global military strategy today. What principle underlies NATO?",
  answer: "Collective defense, where attack on one member is considered attack on all, providing mutual protection.",
  difficulty: "Easy"
},
{
  id: 1684,
  subject: "Paragraph Comprehension",
  question: "Military hospitals near battlefields allow rapid medical treatment of wounded personnel. The proximity to operations reduces transport time and improves survival rates. Mobile medical facilities adapt to changing front lines during operations. Why are mobile medical facilities important?",
  answer: "They reduce transport time to treatment and improve survival rates by providing rapid medical care near operations.",
  difficulty: "Easy"
},
{
  id: 1685,
  subject: "Paragraph Comprehension",
  question: "The strategic importance of sea lanes affects military operations and economic trade. Nations maintain naval forces to protect shipping routes and project power globally. Control of critical sea passages provides significant strategic advantages. What is the strategic importance of sea lanes?",
  answer: "They are critical for trade and military operations; nations maintain naval forces to protect them and project power globally.",
  difficulty: "Easy"
},
{
  id: 1686,
  subject: "Paragraph Comprehension",
  question: "Officer candidate schools select and train individuals for leadership positions. Candidates undergo rigorous screening and instruction in military strategy, tactics, and personnel management. Successfully graduating establishes foundation for advanced military leadership. What is the purpose of officer candidate schools?",
  answer: "To select and train individuals through rigorous instruction in strategy, tactics, and personnel management for military leadership positions.",
  difficulty: "Easy"
},
{
  id: 1687,
  subject: "Paragraph Comprehension",
  question: "Early warning systems detect incoming aircraft, missiles, or naval vessels before reaching targets. Radar technology provides extended detection range compared to visual observation. Early detection enables defenders to activate defenses or evacuate personnel. What advantage does early warning provide?",
  answer: "Extended detection range enables defenders to activate defenses or evacuate personnel before threats reach targets.",
  difficulty: "Easy"
},
{
  id: 1688,
  subject: "Paragraph Comprehension",
  question: "Special operations forces undergo extensive training beyond standard military instruction. These elite units operate with minimal support in challenging environments. The training emphasizes mental toughness, advanced tactical skills, and adaptability. What characterizes special operations forces?",
  answer: "Extensive training beyond standard instruction, emphasizing mental toughness, advanced tactical skills, and adaptability for independent operations.",
  difficulty: "Easy"
},
{
  id: 1689,
  subject: "Paragraph Comprehension",
  question: "Military academy graduates receive officer commissions and initial leadership responsibilities. Academy training emphasizes both academic and military instruction, shaping leaders who understand technical and tactical knowledge. Graduates typically serve as officers throughout their careers. What do military academy graduates receive?",
  answer: "Officer commissions and initial leadership responsibilities, trained in both academic and military instruction.",
  difficulty: "Easy"
},
{
  id: 1690,
  subject: "Paragraph Comprehension",
  question: "Command posts serve as operational centers for coordinating military activities. Personnel at command posts manage communications, intelligence, and decision-making. The physical security of command posts is critical to continuous operations. What function do command posts serve?",
  answer: "They serve as operational centers coordinating communications, intelligence, and decision-making for military activities.",
  difficulty: "Easy"
},
{
  id: 1691,
  subject: "Paragraph Comprehension",
  question: "The Treaty of Westphalia in 1648 established the modern state system and principles of national sovereignty. It ended religious conflicts in Europe by recognizing the right of states to determine their own religious character. This treaty fundamentally shaped international relations and military organization. What did the Treaty of Westphalia establish?",
  answer: "The modern state system and national sovereignty principles, recognizing states' rights to determine religious character and ending religious conflicts.",
  difficulty: "Medium"
},
{
  id: 1692,
  subject: "Paragraph Comprehension",
  question: "Rapid response forces maintain readiness to deploy within hours of notification. These units store pre-positioned equipment and regularly conduct training to maintain deployment capability. Rapid response capability demonstrates military commitment and deters potential adversaries. What advantage does rapid response capability provide?",
  answer: "It demonstrates commitment and deters adversaries through ability to deploy quickly while maintaining high readiness.",
  difficulty: "Medium"
},
{
  id: 1693,
  subject: "Paragraph Comprehension",
  question: "Intelligence fusion centers combine information from multiple sources to develop comprehensive operational pictures. Analysts integrate signals intelligence, human intelligence, and imagery intelligence. Effective fusion improves decision quality by providing complete information. What is the purpose of intelligence fusion centers?",
  answer: "To combine multiple intelligence sources into comprehensive operational pictures, improving decision quality through complete information.",
  difficulty: "Medium"
},
{
  id: 1694,
  subject: "Paragraph Comprehension",
  question: "Military strategy during the Napoleonic Wars centered on rapid maneuvering and concentrated force application. Napoleon's success depended on efficient logistics, rapid communication, and operational mobility. His tactics influenced military doctrine for over a century. What was distinctive about Napoleonic strategy?",
  answer: "Rapid maneuvering, concentrated force application, efficient logistics, and operational mobility that influenced military doctrine for generations.",
  difficulty: "Medium"
},
{
  id: 1695,
  subject: "Paragraph Comprehension",
  question: "Weapons systems integration requires compatibility between detection equipment, communication systems, and engagement mechanisms. Integrated systems respond faster and more effectively than independent components. System integration complexity increases with advanced technology adoption. What does weapons system integration accomplish?",
  answer: "It enables faster and more effective response through compatibility between detection, communication, and engagement mechanisms.",
  difficulty: "Medium"
},
{
  id: 1696,
  subject: "Paragraph Comprehension",
  question: "Military discipline differs from civilian discipline by emphasizing immediate obedience and unit cohesion alongside individual accountability. The stakes in military operations—where delays can cause casualties—justify stricter standards than civilian contexts. Understanding this distinction helps personnel adapt to military culture. What distinguishes military discipline?",
  answer: "Emphasis on immediate obedience and unit cohesion with individual accountability, reflecting the high stakes where delays cause casualties.",
  difficulty: "Medium"
},
{
  id: 1697,
  subject: "Paragraph Comprehension",
  question: "Strategic bombing campaigns in World War II aimed to destroy enemy industrial capacity and demoralize civilian populations. However, civilian casualties and property destruction raised ethical questions about bombing tactics. Post-war analysis questioned bombing effectiveness relative to human costs. What was the purpose of strategic bombing campaigns?",
  answer: "To destroy industrial capacity and demoralize populations, though effectiveness was questioned relative to civilian casualties and ethical concerns.",
  difficulty: "Medium"
},
{
  id: 1698,
  subject: "Paragraph Comprehension",
  question: "Personnel rotation policies balance maintaining unit cohesion with preventing burnout from continuous assignment. Rotating personnel introduces fresh perspectives but disrupts established working relationships. Finding optimal rotation schedules requires careful analysis of operational needs and personnel welfare. What does personnel rotation policy balance?",
  answer: "Maintaining unit cohesion against preventing burnout, introducing fresh perspectives while disrupting established relationships.",
  difficulty: "Medium"
},
{
  id: 1699,
  subject: "Paragraph Comprehension",
  question: "Electronic warfare capabilities enable disruption of enemy communications and radar systems. Jamming and spoofing techniques can degrade enemy capability without direct destruction. Effective electronic warfare requires understanding enemy systems and rapid response capability. What does electronic warfare accomplish?",
  answer: "It disrupts enemy communications and radar through jamming and spoofing, degrading capability without direct destruction.",
  difficulty: "Medium"
},
{
  id: 1700,
  subject: "Paragraph Comprehension",
  question: "Military transition planning helps personnel shift from military to civilian careers after service. Transition services include job training, resume development, and employer networking. Successful transition affects veteran satisfaction and post-service economic security. What purpose does military transition planning serve?",
  answer: "It helps personnel shift to civilian careers through job training, networking, affecting veteran satisfaction and economic security.",
  difficulty: "Medium"
},
{
  id: 1701,
  subject: "Paragraph Comprehension",
  question: "The Doctrine of Military Necessity permits actions otherwise prohibited when essential for achieving military objectives. However, such doctrine requires careful application to prevent abuse and maintain humanitarian principles. The interpretation of military necessity remains contentious in international law. What does the Doctrine of Military Necessity address?",
  answer: "It permits actions otherwise prohibited when essential for military objectives, though application requires care to maintain humanitarian principles.",
  difficulty: "Hard"
},
{
  id: 1702,
  subject: "Paragraph Comprehension",
  question: "Predictive maintenance uses equipment performance data to identify failures before they occur. This approach reduces unexpected breakdowns and extends equipment service life. However, predictive systems require extensive data collection and analysis capability. What advantage does predictive maintenance provide?",
  answer: "It reduces unexpected breakdowns and extends service life by identifying failures before occurrence using performance data analysis.",
  difficulty: "Hard"
},
{
  id: 1703,
  subject: "Paragraph Comprehension",
  question: "Military force structure reflects strategic assumptions about likely threats and available resources. Force structure decisions made decades ago determine current operational capability. Restructuring forces requires abandoning some capabilities while developing others, creating difficult tradeoffs. What do force structure decisions reflect?",
  answer: "Strategic assumptions about threats and resources; restructuring creates tradeoffs between abandoning some capabilities and developing others.",
  difficulty: "Hard"
},
{
  id: 1704,
  subject: "Paragraph Comprehension",
  question: "The psychological contract between military personnel and their organization involves expectations about treatment, support, and career development. Violations of this contract through inadequate support or career barriers erode commitment. Maintaining the psychological contract requires consistent organizational performance. What is the psychological contract?",
  answer: "Expectations about treatment, support, and career development; violations erode commitment and require consistent organizational performance.",
  difficulty: "Hard"
},
{
  id: 1705,
  subject: "Paragraph Comprehension",
  question: "Military organizations struggle with information overload where increasing data volumes exceed personnel ability to process and analyze. Advanced analytics systems attempt to filter relevant information, but algorithms may miss important signals. The challenge is distinguishing between noise and genuine intelligence. What challenge does information overload create?",
  answer: "Personnel cannot process increasing data volumes; algorithms may miss important signals, creating difficulty in distinguishing noise from intelligence.",
  difficulty: "Hard"
},
{
  id: 1706,
  subject: "Paragraph Comprehension",
  question: "The Clausewitzian concept of 'fog of war' describes uncertainty and incomplete information characterizing actual combat. While modern technology reduces some uncertainty, fog of war persists because adversaries conceal information and unexpected events occur. Acknowledging fog of war affects strategic planning. What does fog of war describe?",
  answer: "Uncertainty and incomplete information in combat from adversary concealment and unexpected events, persisting despite modern technology.",
  difficulty: "Hard"
},
{
  id: 1707,
  subject: "Paragraph Comprehension",
  question: "Military leadership often requires promoting promising officers into positions where they lack direct experience. Organizations gamble that leadership skill transfers between domains and that learning-on-the-job will close capability gaps. This approach accelerates development but risks leadership failures. What challenge do personnel decisions create?",
  answer: "Promoting officers into unfamiliar positions gambles that skills transfer and learning-on-job closes gaps, risking leadership failures.",
  difficulty: "Hard"
},
{
  id: 1708,
  subject: "Paragraph Comprehension",
  question: "Asymmetric conflicts involve opponents with vastly different military capabilities and operational strategies. Weaker forces often employ guerrilla tactics and terrorism to offset conventional disadvantage. Successfully countering asymmetric threats requires understanding adversary motivation and constraints. What characterizes asymmetric conflicts?",
  answer: "Opponents with vastly different capabilities; weaker forces employ guerrilla tactics and terrorism, requiring understanding of adversary motivation.",
  difficulty: "Hard"
},
{
  id: 1709,
  subject: "Paragraph Comprehension",
  question: "Military climate change adaptation planning addresses how environmental changes affect operations and capabilities. Melting ice creates new maritime access but also geopolitical competition. Rising temperatures and extreme weather affect equipment performance and personnel health. Why is climate change adaptation important?",
  answer: "Environmental changes affect operations and capabilities; new access creates competition, and extreme weather affects equipment and personnel.",
  difficulty: "Hard"
},
{
  id: 1710,
  subject: "Paragraph Comprehension",
  question: "The transformation from conscript armies to all-volunteer forces changes military culture and operational capability. Volunteer forces allow specialization and longer tenure but sacrifice numerical mobilization capacity. This transition reflects different strategic assumptions about future conflicts. What does the transition to volunteer forces reflect?",
  answer: "Different strategic assumptions about conflicts; volunteer forces enable specialization but sacrifice numerical mobilization capacity.",
  difficulty: "Hard"
}
,
{
  id: 1711,
  subject: "Paragraph Comprehension",
  question: "Effective military leadership requires the ability to make quick decisions under pressure while maintaining focus on the mission objectives. A good commander considers the welfare of their troops while ensuring operational success. What is the main idea of this passage?",
  answer: "The main idea is that effective military leadership involves balancing quick decision-making under pressure with concern for troops and mission success. This combines multiple essential leadership qualities.",
  difficulty: "Easy"
},
{
  id: 1712,
  subject: "Paragraph Comprehension",
  question: "The Army's physical training program is designed to develop strength, endurance, and agility. Soldiers participate in regular exercises including running, strength training, and tactical drills. What is the primary purpose of the Army's physical training program?",
  answer: "The primary purpose is to develop multiple physical capabilities including strength, endurance, and agility necessary for military readiness.",
  difficulty: "Easy"
},
{
  id: 1713,
  subject: "Paragraph Comprehension",
  question: "Communication in military units is critical for mission success. Clear, concise orders prevent misunderstandings that could compromise safety or effectiveness. Officers must practice active listening to understand their subordinates' concerns. Which of the following best describes the importance of communication?",
  answer: "Communication is important because it prevents misunderstandings that could affect mission safety and effectiveness, and allows commanders to understand their troops' concerns.",
  difficulty: "Easy"
},
{
  id: 1714,
  subject: "Paragraph Comprehension",
  question: "Teamwork is the foundation of military operations. No single soldier can accomplish a mission alone. Success depends on each member performing their role while trusting their teammates. What does the passage suggest about military success?",
  answer: "Military success depends on teamwork where each soldier performs their assigned role while maintaining trust in teammates, not individual effort alone.",
  difficulty: "Easy"
},
{
  id: 1715,
  subject: "Paragraph Comprehension",
  question: "The rifle is the primary weapon of the infantry soldier. It must be maintained meticulously to ensure reliability in combat. A soldier should clean and inspect their weapon daily. What is the main idea?",
  answer: "The main idea is that rifles require careful daily maintenance and inspection to ensure they function reliably during combat operations.",
  difficulty: "Easy"
},
{
  id: 1716,
  subject: "Paragraph Comprehension",
  question: "Strategic planning involves analyzing available resources, identifying objectives, and determining the most effective approach. Military leaders must consider terrain, weather, enemy capabilities, and unit strengths. What is essential to strategic planning?",
  answer: "Strategic planning requires analyzing multiple factors including resources, objectives, terrain, weather, enemy capabilities, and unit strengths before determining the approach.",
  difficulty: "Easy"
},
{
  id: 1717,
  subject: "Paragraph Comprehension",
  question: "Ethics in military service means acting with integrity and adhering to established rules of engagement. Soldiers must protect civilians and avoid unnecessary harm. These principles distinguish military forces from other armed groups. What role do ethics play in military service?",
  answer: "Ethics in military service ensure integrity, adherence to rules of engagement, civilian protection, and distinguish military forces through principled conduct.",
  difficulty: "Easy"
},
{
  id: 1718,
  subject: "Paragraph Comprehension",
  question: "Navigation skills are essential for soldiers operating in unfamiliar terrain. Using map and compass techniques, soldiers can determine their location and plan routes. GPS devices provide modern alternatives but can fail. Why are traditional navigation skills valuable?",
  answer: "Traditional navigation skills are valuable because they provide reliable alternatives when modern GPS devices fail or are unavailable.",
  difficulty: "Easy"
},
{
  id: 1719,
  subject: "Paragraph Comprehension",
  question: "Discipline is the backbone of military effectiveness. It ensures soldiers follow procedures, maintain readiness, and execute orders precisely. Without discipline, coordinated operations become impossible. What does the passage indicate about discipline?",
  answer: "Discipline is essential because it ensures soldiers follow procedures, maintain readiness, and execute orders precisely, making coordinated operations possible.",
  difficulty: "Easy"
},
{
  id: 1720,
  subject: "Paragraph Comprehension",
  question: "Physical fitness directly impacts a soldier's ability to perform combat operations. Cardiovascular endurance allows sustained effort during extended missions. Strength training prepares soldiers for carrying equipment and moving obstacles. What is the connection between fitness and military performance?",
  answer: "Physical fitness enables soldiers to sustain effort during extended missions and perform combat tasks like carrying equipment, thus directly impacting military performance.",
  difficulty: "Easy"
},
{
  id: 1721,
  subject: "Paragraph Comprehension",
  question: "Effective unit cohesion develops through regular training together, clear communication, and mutual respect among soldiers. When a unit demonstrates strong cohesion, members work together seamlessly and support each other during difficult situations. The sergeant emphasized daily team-building exercises to strengthen unit cohesion before deployment. What factor is suggested as important for building cohesion?",
  answer: "The passage suggests that regular team-building exercises, clear communication, and mutual respect among soldiers are important for building strong unit cohesion.",
  difficulty: "Medium"
},
{
  id: 1722,
  subject: "Paragraph Comprehension",
  question: "Infantry tactics have evolved significantly with modern technology and battlefield realities. Traditional frontal assaults are now considered ineffective against well-defended positions. Contemporary doctrine emphasizes maneuver, firepower coordination, and combined arms operations. What does the passage imply about changes in military tactics?",
  answer: "The passage implies that military tactics have shifted away from traditional frontal assaults toward maneuver, firepower coordination, and combined arms approaches due to modern realities.",
  difficulty: "Medium"
},
{
  id: 1723,
  subject: "Paragraph Comprehension",
  question: "Supply chain management in military operations ensures troops receive necessary equipment, ammunition, and provisions. Logistical failures can compromise mission success more severely than tactical setbacks. A commander once said that amateurs study strategy while professionals study logistics. Why is logistics considered critical?",
  answer: "Logistics is critical because supply failures can compromise mission success more severely than tactical setbacks, making proper equipment and provision distribution essential.",
  difficulty: "Medium"
},
{
  id: 1724,
  subject: "Paragraph Comprehension",
  question: "Leadership under stress demonstrates a commander's true character. When situations become chaotic or dangerous, some leaders remain calm and focused while others become overwhelmed. The ability to maintain composure influences how troops respond to critical situations. What does the passage suggest about leadership during stress?",
  answer: "The passage suggests that maintaining composure during stress demonstrates leadership character and influences how troops respond, separating effective leaders from ineffective ones.",
  difficulty: "Medium"
},
{
  id: 1725,
  subject: "Paragraph Comprehension",
  question: "The concept of 'situational awareness' refers to understanding your environment and potential threats. Soldiers who maintain high situational awareness notice unusual activities or approaching dangers before others. This skill can be the difference between survival and casualty. What is situational awareness primarily used for?",
  answer: "Situational awareness is primarily used to understand the environment, notice potential threats early, and detect unusual activities that could affect safety or mission success.",
  difficulty: "Medium"
},
{
  id: 1726,
  subject: "Paragraph Comprehension",
  question: "Cross-training soldiers in multiple roles provides operational flexibility and increases unit effectiveness. If one team member becomes casualties or unavailable, others can assume their responsibilities. Units with cross-trained personnel demonstrate better resilience during difficult circumstances. Why is cross-training emphasized in military units?",
  answer: "Cross-training is emphasized because it provides flexibility, allows soldiers to assume different roles if needed, and increases unit resilience when personnel become unavailable.",
  difficulty: "Medium"
},
{
  id: 1727,
  subject: "Paragraph Comprehension",
  question: "Combat stress reactions are normal responses to abnormal situations. Soldiers may experience anxiety, difficulty concentrating, or emotional numbness after intense operations. Mental health support and peer assistance help soldiers recover and maintain effectiveness. What is implied about combat stress reactions?",
  answer: "Combat stress reactions are implied to be normal responses requiring mental health support and peer assistance to help soldiers maintain effectiveness and recover.",
  difficulty: "Medium"
},
{
  id: 1728,
  subject: "Paragraph Comprehension",
  question: "The M-16 rifle has served military forces effectively for decades but is being replaced by the M4 carbine for close-quarters operations. The M4 is lighter, more maneuverable in confined spaces, and easier to carry in vehicles. However, the M16 maintains greater effective range. What advantage does the M4 have over the M16?",
  answer: "The M4 is lighter, more maneuverable in confined spaces, and easier to carry in vehicles, making it superior for close-quarters operations despite the M16's greater effective range.",
  difficulty: "Medium"
},
{
  id: 1729,
  subject: "Paragraph Comprehension",
  question: "Rehearsals before complex operations significantly reduce errors and clarify each team member's responsibilities. Soldiers who practice procedures multiple times execute them more efficiently and confidently under stress. However, extensive rehearsals consume time and resources that might be limited. What is a benefit of conducting rehearsals?",
  answer: "Rehearsals benefit operations by reducing errors, clarifying responsibilities, and allowing soldiers to execute procedures more efficiently and confidently under stress.",
  difficulty: "Medium"
},
{
  id: 1730,
  subject: "Paragraph Comprehension",
  question: "Military doctrine establishes standardized procedures for operations, ensuring consistency across units and enabling seamless coordination. When all units understand and follow the same doctrinal principles, they can work together effectively without extensive communication. New soldiers learn doctrine during basic training. What purpose does military doctrine serve?",
  answer: "Military doctrine serves to establish standardized procedures that ensure consistency across units and enable seamless coordination without extensive communication.",
  difficulty: "Medium"
},
{
  id: 1731,
  subject: "Paragraph Comprehension",
  question: "Camouflage techniques help soldiers blend with their surroundings, reducing visibility to enemy observation. Different environments require different camouflage patterns and approaches. Desert camouflage differs markedly from forest camouflage, requiring soldiers to adapt to specific terrain. The squad leader distributed new camouflage uniforms before deployment to the mountainous region. What does effective camouflage accomplish?",
  answer: "Effective camouflage reduces visibility to enemy observation by helping soldiers blend with their surroundings, requiring adaptation to specific environmental conditions.",
  difficulty: "Medium"
},
{
  id: 1732,
  subject: "Paragraph Comprehension",
  question: "Communication systems in modern military units integrate radio, satellite, and data networks. These systems must be secure, reliable, and accessible across challenging terrain. Equipment failures can isolate units and compromise mission coordination. Despite advances, soldiers still use hand signals for silent communication. Why is communication system reliability important?",
  answer: "Communication system reliability is important because failures can isolate units and compromise mission coordination, even though soldiers also use hand signals as backup.",
  difficulty: "Medium"
},
{
  id: 1733,
  subject: "Paragraph Comprehension",
  question: "Promotion in military ranks requires demonstrating leadership qualities, technical proficiency, and consistent performance. Senior personnel must evaluate candidates comprehensively before advancement. Premature promotion of unqualified individuals can harm unit effectiveness and troop morale. The first sergeant recommended specific soldiers for advancement. What factors influence military promotion?",
  answer: "Military promotion requires demonstrating leadership qualities, technical proficiency, and consistent performance, evaluated comprehensively to avoid harming unit effectiveness.",
  difficulty: "Medium"
},
{
  id: 1734,
  subject: "Paragraph Comprehension",
  question: "Ambush tactics exploit surprise and superior positioning to overcome larger or better-equipped forces. The timing of the initial volley is critical to success. Soldiers must maintain discipline and coordinated fire rather than acting independently. Historical military forces have used ambushes effectively throughout history. What is essential for ambush tactics to succeed?",
  answer: "Ambush tactics succeed through surprise, superior positioning, critical timing of initial fire, and maintaining discipline with coordinated fire rather than independent actions.",
  difficulty: "Medium"
},
{
  id: 1735,
  subject: "Paragraph Comprehension",
  question: "Morale significantly influences unit performance and soldier motivation. Units with high morale demonstrate better resilience, faster recovery after setbacks, and greater commitment to objectives. Leaders can influence morale through recognition, fair treatment, and transparent communication. The commander's consistent positive attitude reflected in unit performance. What relationship exists between morale and performance?",
  answer: "High morale influences unit performance by creating better resilience, faster recovery after setbacks, and greater commitment to objectives, influenced by leadership through recognition and fair treatment.",
  difficulty: "Medium"
},
{
  id: 1736,
  subject: "Paragraph Comprehension",
  question: "Night operations require specialized training and equipment because visibility is severely reduced. Thermal imaging, night vision devices, and illumination systems partially compensate for darkness. However, these technologies can malfunction or be unavailable. Soldiers must also develop skills for operating effectively without artificial aids. What challenges do night operations present?",
  answer: "Night operations present challenges of severely reduced visibility requiring specialized training, equipment like thermal imaging and night vision, but also skills for operation without artificial aids.",
  difficulty: "Medium"
},
{
  id: 1737,
  subject: "Paragraph Comprehension",
  question: "Veteran soldiers often mentor newer personnel, sharing practical experience and combat lessons. This informal knowledge transfer complements formal training and accelerates development. Experienced mentors can identify mistakes before they become serious problems. The battalion established a formal mentorship program recognizing this valuable practice. Why is mentorship valued in military units?",
  answer: "Mentorship is valued because it shares practical experience and combat lessons, accelerates development of new personnel, and prevents mistakes before they become serious problems.",
  difficulty: "Medium"
},
{
  id: 1738,
  subject: "Paragraph Comprehension",
  question: "Medical response in combat situations must be rapid and decisive. Combat medics receive extensive training to treat traumatic injuries with limited resources. Quick decisions about triage priorities can save lives. However, emotional stress can challenge medics' ability to remain objective. What demands do combat medics face?",
  answer: "Combat medics face demands including rapid response to traumatic injuries, making triage decisions with limited resources, while managing emotional stress to remain objective.",
  difficulty: "Medium"
},
{
  id: 1739,
  subject: "Paragraph Comprehension",
  question: "Defensive positions must leverage terrain, establish overlapping fields of fire, and include contingency plans. Strong defensive positions multiply effective force by compensating for numerical disadvantages. However, defensive positions can become traps if escape routes are blocked. Military engineers analyze terrain to recommend optimal positioning. What advantages do well-positioned defensive positions provide?",
  answer: "Well-positioned defensive positions leverage terrain and overlapping fire fields to multiply effective force and compensate for numerical disadvantages, though escape routes must remain available.",
  difficulty: "Medium"
},
{
  id: 1740,
  subject: "Paragraph Comprehension",
  question: "Weapon qualification ensures soldiers can effectively use their assigned weapons. Soldiers must achieve specified accuracy standards at various distances and conditions. Regular qualification maintains proficiency and identifies soldiers needing additional training. The platoon sergeant scheduled quarterly qualification exercises. What is the purpose of weapon qualification?",
  answer: "Weapon qualification ensures soldiers can effectively use their weapons by achieving accuracy standards, maintains proficiency, and identifies soldiers needing additional training.",
  difficulty: "Medium"
},
{
  id: 1741,
  subject: "Paragraph Comprehension",
  question: "The soldier carefully maintained his equipment, cleaning each component systematically despite being exhausted after a 20-mile march. His sergeant observed that this discipline distinguished effective soldiers from merely competent ones. When another soldier appeared ready to skip maintenance procedures, the sergeant intervened with quiet authority. Some soldiers understood immediately, though others required repeated emphasis on standards. What behavior does the passage illustrate?",
  answer: "The passage illustrates that maintaining discipline through equipment care despite exhaustion demonstrates character that distinguishes effective soldiers, and that leadership sometimes requires repeated emphasis on standards.",
  difficulty: "Hard"
},
{
  id: 1742,
  subject: "Paragraph Comprehension",
  question: "Military strategy must consider not only immediate tactical situations but also long-term strategic implications. A tactical victory might have strategic consequences that undermine overall objectives. For example, a successful assault that alienates the local population could create future resistance. Conversely, restraint in specific situations might strengthen strategic position. What complexity is implied in military decision-making?",
  answer: "Military decision-making must balance immediate tactical gains against potential long-term strategic consequences, recognizing that tactical victories might undermine overall objectives while restraint could strengthen strategy.",
  difficulty: "Hard"
},
{
  id: 1743,
  subject: "Paragraph Comprehension",
  question: "Leadership effectiveness cannot be measured solely by unit performance metrics because several factors influence outcomes beyond a leader's control. Weather, enemy decisions, and resource availability affect operations independently of leadership quality. However, leaders demonstrably influence how units respond to challenges, adapt to unexpected situations, and maintain cohesion. Evaluating leaders requires distinguishing between factors within and outside their control. What complication does this present for leadership assessment?",
  answer: "Leadership assessment is complicated because unit performance reflects multiple factors beyond a leader's control, requiring evaluation to distinguish between controllable leadership influence and external factors.",
  difficulty: "Hard"
},
{
  id: 1744,
  subject: "Paragraph Comprehension",
  question: "The term 'sunk cost fallacy' applies to military decisions when commanders continue investing resources in failing operations because previous investment cannot be recovered. Military history contains examples of forces stubbornly pursuing objectives despite clear evidence of failure. Recognizing when to withdraw from failing operations requires overcoming psychological attachment to previous decisions. This tension between commitment and pragmatism challenges effective command. What psychological challenge affects military decisions?",
  answer: "The sunk cost fallacy challenges military decisions by creating psychological attachment to previous investments, making it difficult for commanders to withdraw from failing operations despite evidence of failure.",
  difficulty: "Hard"
},
{
  id: 1745,
  subject: "Paragraph Comprehension",
  question: "Military ethics become complicated in gray areas where rules of engagement contain ambiguity. Soldiers must sometimes make rapid decisions with incomplete information in morally complex situations. Training cannot eliminate all ambiguity; instead, it develops ethical judgment through case study and reflection. Some experienced soldiers report that initial training inadequately prepared them for actual ethical dilemmas. What is suggested about military ethics training?",
  answer: "Military ethics training develops judgment through case study and reflection but cannot eliminate ambiguity, sometimes leaving soldiers feeling inadequately prepared for actual ethical dilemmas encountered.",
  difficulty: "Hard"
},
{
  id: 1746,
  subject: "Paragraph Comprehension",
  question: "Intelligence analysis involves processing vast quantities of information to identify patterns and make predictions. However, analysts face confirmation bias, where they unconsciously favor information supporting existing beliefs. This bias can cause intelligence failures despite abundant available information. Intelligence agencies implement formal processes and devil's advocate positions to counteract bias. What vulnerability does intelligence analysis face?",
  answer: "Intelligence analysis faces confirmation bias where analysts unconsciously favor information supporting existing beliefs, potentially causing failures despite abundant information, counteracted by formal processes and devil's advocacy.",
  difficulty: "Hard"
},
{
  id: 1747,
  subject: "Paragraph Comprehension",
  question: "Military adaptation to new technologies creates organizational challenges because established procedures, training programs, and mental models require fundamental revision. Soldiers trained extensively with previous weapons must unlearn habits before fully adopting new systems. Organizations struggle between maintaining proven procedures and embracing new approaches. This tension intensifies during wartime when change must occur quickly. What organizational challenge accompanies technological change?",
  answer: "Technological adaptation requires revising established procedures and mental models, forcing soldiers to unlearn habits, creating organizational tension between maintaining proven methods and embracing change.",
  difficulty: "Hard"
},
{
  id: 1748,
  subject: "Paragraph Comprehension",
  question: "Counterinsurgency differs fundamentally from conventional warfare because insurgents deliberately operate among civilian populations, blurring combat and non-combat spaces. Distinguishing combatants from non-combatants becomes incredibly difficult. Large-scale firepower that succeeds in conventional warfare often creates civilian casualties, strengthening insurgent recruitment. Counterinsurgency requires restraint and precision that feels inefficient compared to conventional approaches. What strategic paradox characterizes counterinsurgency?",
  answer: "Counterinsurgency presents a paradox where large-scale firepower effective in conventional warfare often creates civilian casualties strengthening insurgent recruitment, requiring restraint that appears inefficient.",
  difficulty: "Hard"
},
{
  id: 1749,
  subject: "Paragraph Comprehension",
  question: "The concept of 'mission command' empowers subordinates to accomplish assigned objectives using their judgment rather than following detailed instructions. This approach requires extensive training, clear commander intent, and mutual trust. It enables rapid response to unexpected situations without referencing higher command. However, it also creates potential for misalignment if lower levels misunderstand intent. What is the essential requirement for mission command effectiveness?",
  answer: "Mission command effectiveness requires extensive training, clear commander intent, and mutual trust to empower subordinates while preventing misalignment from misunderstood intent.",
  difficulty: "Hard"
},
{
  id: 1750,
  subject: "Paragraph Comprehension",
  question: "Soldiers experience multiple competing loyalties: to fellow soldiers, to their unit, to their service, to their country, and potentially to personal conscience. When these loyalties conflict, soldiers must navigate complex moral terrain. A soldier might face situations where following orders violates conscience or where loyalty to peers conflicts with regulations. Military training emphasizes hierarchical authority while ethics emphasizes individual conscience. How does military service complicate loyalty?",
  answer: "Military service complicates loyalty by creating competing obligations to fellow soldiers, unit, service, country, and personal conscience, requiring navigation of complex moral terrain with no simple resolution.",
  difficulty: "Hard"
},
{
  id: 1751,
  subject: "Paragraph Comprehension",
  question: "The basic principle of firepower superiority means controlling who shoots first and most effectively. Forces achieving firepower superiority typically succeed regardless of other factors. However, achieving firepower superiority sometimes requires risking concentrated positioning that creates vulnerability. Military history shows examples where apparent superiority proved illusory due to unexpected enemy capabilities or terrain effects. What does this suggest about firepower calculations?",
  answer: "Firepower superiority calculations must consider unexpected capabilities and terrain effects because apparent superiority can prove illusory despite concentrated positioning that achieves tactical advantage.",
  difficulty: "Hard"
},
{
  id: 1752,
  subject: "Paragraph Comprehension",
  question: "Civilians in conflict zones experience profound displacement, economic disruption, and trauma that persist long after military operations conclude. Military forces sometimes underestimate the duration and severity of civilian harm. Reconstruction takes decades while security takes years. Understanding this dynamic influences military decision-making about minimizing civilian effects during operations. What is implied about military operations' consequences?",
  answer: "Military operations create civilian consequences that persist far longer than combat operations, with reconstruction taking decades, requiring military consideration of civilian effects during planning.",
  difficulty: "Hard"
},
{
  id: 1753,
  subject: "Paragraph Comprehension",
  question: "Military uniforms serve practical purposes including identification and psychological impact but create vulnerabilities by making soldiers visible to enemies. Camouflage uniforms address this conflict between identification and concealment. However, uniforms also signal combatant status, an important legal distinction in warfare. This creates ethical tension between military effectiveness and law of war compliance. What tension characterizes military uniform design?",
  answer: "Military uniform design creates tension between visibility for identification purposes and camouflage for concealment, further complicated by legal requirements signaling combatant status.",
  difficulty: "Hard"
},
{
  id: 1754,
  subject: "Paragraph Comprehension",
  question: "Veterans transitioning to civilian employment sometimes struggle because military experience emphasizes hierarchical authority and defined roles while civilian employment increasingly emphasizes initiative and ambiguity. Skills directly applicable in military contexts become liabilities in civilian settings where independent judgment is valued differently. The structure appreciated in military service becomes constraining in civilian life. What complication do veterans face?",
  answer: "Veterans face complications because military emphasis on hierarchical authority and defined roles contrasts with civilian employment valuing initiative and ambiguity, making military skills and structures misaligned.",
  difficulty: "Hard"
},
{
  id: 1755,
  subject: "Paragraph Comprehension",
  question: "Classified information creates dilemmas for military officers who believe certain policies are ineffective or harmful but cannot publicly discuss classified reasoning without violating security requirements. Officers can resign but cannot whistleblow within established systems. This structure prevents public accountability for classified decisions while protecting security. Democratic governance assumes informed public discourse, but classified operations remove information from public consideration. What governance paradox emerges?",
  answer: "A governance paradox emerges where democratic informed public discourse assumes available information, but classified operations remove information from public consideration while preventing officers' public discussion.",
  difficulty: "Hard"
},
{
  id: 1756,
  subject: "Paragraph Comprehension",
  question: "Military efficiency sometimes conflicts with transparency because explaining detailed reasoning consumes time and creates vulnerabilities if enemies understand decision-making processes. Rank has centralized authority partly for efficiency, reducing consultation that would improve decisions but slow response. Some decisions require rapid implementation before extensive discussion occurs. The tension between deliberation and decisiveness pervades military operations. What fundamental tension affects military organizations?",
  answer: "Military organizations face tension between efficiency requiring rapid decisions and deliberation that improves decisions, with centralized authority maximizing speed while reducing consultation and transparency.",
  difficulty: "Hard"
},
{
  id: 1757,
  subject: "Paragraph Comprehension",
  question: "Training scenarios designed to prepare soldiers for combat can inadvertently create overconfidence because training environments lack certain dangers and casualties are simulated. Soldiers sometimes transfer confidence from training to actual combat despite significant differences. Experienced soldiers recognize these differences and resist overconfidence, but newer soldiers sometimes assume training equivalence to combat. What limitation exists in combat training?",
  answer: "Combat training can create overconfidence because training environments lack actual dangers and casualties, with newer soldiers sometimes assuming training equivalence despite significant differences that experienced soldiers recognize.",
  difficulty: "Hard"
},
{
  id: 1758,
  subject: "Paragraph Comprehension",
  question: "Civilian control of military forces is a democratic principle, but civilian leaders sometimes lack military expertise to evaluate military recommendations. This creates potential for both civilian overreach into military operational details and military dominance over civilian decision-makers. Healthy civil-military relations require civilian leaders who are both deferential to expertise and willing to override recommendations. Finding this balance proves persistently difficult. What complication characterizes civil-military relations?",
  answer: "Civil-military relations face the challenge of civilian leaders balancing deference to military expertise with willingness to override recommendations, requiring both respect for expertise and democratic oversight.",
  difficulty: "Hard"
},
{
  id: 1759,
  subject: "Paragraph Comprehension",
  question: "Soldiers developing close bonds through shared hardship and danger sometimes struggle to maintain friendships with civilians who lack equivalent experience. The intensity of military friendships contrasts with civilian relationships in ways that feel isolating post-service. Understanding military service requires experiencing military context that civilians cannot fully access. This experience creates both bonds among veterans and distance from civilian friends. What does this suggest about military relationships?",
  answer: "Military relationships develop intense bonds through shared hardship that can seem isolating from civilians who lack equivalent experience, creating both veteran connection and civilian distance.",
  difficulty: "Hard"
},
{
  id: 1760,
  subject: "Paragraph Comprehension",
  question: "The passage described new recruits arriving at their first assignment with impressive academic credentials but limited practical knowledge. Within weeks, experienced soldiers recognized potential in some recruits while others struggled despite credentials. The sergeant observed that institutional success and military effectiveness require different capabilities. Some educated recruits adapted quickly while others had to unlearn civilian expectations. What is implied about military effectiveness?",
  answer: "Military effectiveness requires different capabilities than academic success, with some educated recruits adapting quickly while others struggle because civilian expectations must be unlearned.",
  difficulty: "Hard"
},
{
  id: 1761,
  subject: "Paragraph Comprehension",
  question: "Fort Benning hosts the Infantry School where soldiers learn advanced combat techniques. The demanding physical training prepares soldiers for the rigors of infantry operations. Instructors emphasize practical skills over theoretical knowledge. Upon graduation, soldiers deploy to units worldwide. What is the primary purpose of Fort Benning's Infantry School?",
  answer: "Fort Benning's Infantry School prepares soldiers for advanced combat operations through demanding physical training and practical skills, after which they deploy to units worldwide.",
  difficulty: "Easy"
},
{
  id: 1762,
  subject: "Paragraph Comprehension",
  question: "Marksmanship requires steady aim, proper breathing, and trigger control. Shooters must maintain consistency to achieve accurate shots. Regular practice at firing ranges develops muscle memory that carries into combat situations. Which element is necessary for developing marksmanship?",
  answer: "Developing marksmanship requires steady aim, proper breathing, trigger control, and regular practice that builds muscle memory for consistent accurate shots.",
  difficulty: "Easy"
},
{
  id: 1763,
  subject: "Paragraph Comprehension",
  question: "Military medical training includes recognizing vital signs, applying tourniquets, and stabilizing injuries. Field medics often operate with limited equipment in dangerous environments. Quick thinking and decisive action save lives during emergencies. What do military medical professionals require?",
  answer: "Military medical professionals require training in recognizing vital signs and applying treatments, quick thinking, and decisive action despite limited equipment and dangerous environments.",
  difficulty: "Easy"
},
{
  id: 1764,
  subject: "Paragraph Comprehension",
  question: "Rank structure in the military creates clear chains of command and accountability. Each rank carries specific responsibilities and authority. Soldiers understand their position within the hierarchy. Why is rank structure important in military organizations?",
  answer: "Rank structure is important because it creates clear chains of command, establishes accountability, and helps soldiers understand their position and responsibilities within the hierarchy.",
  difficulty: "Easy"
},
{
  id: 1765,
  subject: "Paragraph Comprehension",
  question: "The uniform code of military justice establishes legal procedures for military justice. Courts martial address violations of military law. Procedures protect both the accused and the military organization. What does the uniform code accomplish?",
  answer: "The uniform code establishes legal procedures for military justice, protects both the accused and the organization, and addresses violations through courts martial.",
  difficulty: "Easy"
},
{
  id: 1766,
  subject: "Paragraph Comprehension",
  question: "Military alliances strengthen collective security by pooling resources and coordinating defense. NATO members share training and intelligence. Cooperation multiplies individual nation capabilities. What is the advantage of military alliances?",
  answer: "Military alliances strengthen collective security by pooling resources, coordinating defense, sharing training and intelligence, and multiplying individual nation capabilities.",
  difficulty: "Easy"
},
{
  id: 1767,
  subject: "Paragraph Comprehension",
  question: "Reconnaissance missions gather intelligence about enemy positions and intentions. Scouts move carefully to avoid detection while observing activities. Information collected during reconnaissance guides operational planning. What is the primary function of reconnaissance?",
  answer: "The primary function of reconnaissance is gathering intelligence about enemy positions and intentions by moving carefully while observing, which guides operational planning.",
  difficulty: "Easy"
},
{
  id: 1768,
  subject: "Paragraph Comprehension",
  question: "Logistics officers oversee supply chains ensuring soldiers receive equipment, food, and ammunition. Complex supply networks connect production facilities to field units. Efficient logistics enables operational success. Why are logistics officers essential?",
  answer: "Logistics officers are essential because they oversee supply chains connecting production to field units, ensuring soldiers receive necessary resources that enable operational success.",
  difficulty: "Easy"
},
{
  id: 1769,
  subject: "Paragraph Comprehension",
  question: "Weapons maintenance prevents equipment failure during critical moments. Soldiers learn proper cleaning and storage procedures during initial training. Neglecting maintenance creates unreliability that endangers units. What consequence results from neglecting maintenance?",
  answer: "Neglecting maintenance creates equipment unreliability that endangers units and can cause failure during critical moments when soldiers depend on functional weapons.",
  difficulty: "Easy"
},
{
  id: 1770,
  subject: "Paragraph Comprehension",
  question: "Parachute operations require soldiers to exit aircraft, deploy parachutes, and land safely in designated areas. Training emphasizes proper equipment checks and landing techniques. Airborne operations provide rapid deployment capability. What capability do airborne operations provide?",
  answer: "Airborne operations provide rapid deployment capability by allowing soldiers to be delivered from aircraft with parachutes to designated landing areas.",
  difficulty: "Easy"
},
{
  id: 1771,
  subject: "Paragraph Comprehension",
  question: "Military fitness standards establish minimum physical requirements that all soldiers must meet. Push-ups, running, and other exercises test different capabilities. Meeting standards demonstrates readiness for field operations. The newly promoted sergeant established mandatory morning PT sessions to improve unit fitness and emphasize that high standards benefit everyone through increased operational capability. What is accomplished through meeting fitness standards?",
  answer: "Meeting fitness standards demonstrates readiness for field operations and ensures soldiers can perform demanding tasks, accomplished through regular PT emphasizing capability development.",
  difficulty: "Medium"
},
{
  id: 1772,
  subject: "Paragraph Comprehension",
  question: "Military objectives must be specific, measurable, achievable, relevant, and time-bound. Vague objectives create confusion and wasted effort. Clear objectives focus resources and measure progress. Commanders analyze operational requirements to develop appropriate objectives. How do clear objectives benefit operations?",
  answer: "Clear, specific objectives focus resources, prevent confusion and wasted effort, enable progress measurement, and create understanding throughout the organization about purpose and goals.",
  difficulty: "Medium"
},
{
  id: 1773,
  subject: "Paragraph Comprehension",
  question: "Radar systems detect objects at distances where visual observation fails. Military radar provides early warning of approaching aircraft and ships. However, radar can be jammed or provide false information. Modern forces balance radar reliance with alternative detection methods. What limitation does radar present?",
  answer: "Radar limitations include vulnerability to jamming and false information, requiring modern forces to balance radar reliance with alternative detection methods for comprehensive awareness.",
  difficulty: "Medium"
},
{
  id: 1774,
  subject: "Paragraph Comprehension",
  question: "Soldier accountability systems track personnel location and status during operations. Knowing exactly where soldiers are positioned enables coordination and response to emergencies. Technology aids accountability but cannot replace leaders knowing their soldiers personally. How does accountability benefit operations?",
  answer: "Accountability enables coordination, emergency response, and leader knowledge of soldier location and status, enhanced by technology but requiring personal leader awareness as well.",
  difficulty: "Medium"
},
{
  id: 1775,
  subject: "Paragraph Comprehension",
  question: "Rules of engagement specify when soldiers can use force and against whom. Clear ROE prevent unauthorized force use while ensuring self-defense capability. Ambiguous ROE create uncertainty that impacts decision-making during combat. Legal advisors develop ROE that balance operational requirements and international law. What role do rules of engagement play?",
  answer: "Rules of engagement specify force use authorization, prevent inappropriate force use while ensuring self-defense, and provide clarity required for combat decision-making.",
  difficulty: "Medium"
},
{
  id: 1776,
  subject: "Paragraph Comprehension",
  question: "Joint operations involve coordination among different military services like Army, Navy, and Air Force. Each service brings distinct capabilities requiring integration for complex operations. Command structures must clarify authority while leveraging service strengths. Joint training and operations experience develop integration capabilities. What is necessary for successful joint operations?",
  answer: "Successful joint operations require coordinating different service capabilities, clarifying authority structures, and developing integration through training and operational experience.",
  difficulty: "Medium"
},
{
  id: 1777,
  subject: "Paragraph Comprehension",
  question: "Reserve soldiers balance military service with civilian employment and family responsibilities. They deploy less frequently than active duty personnel but must maintain readiness. Reserve components provide depth to military force structure. What is the role of reserve soldiers?",
  answer: "Reserve soldiers balance military service with civilian responsibilities, deploy less frequently than active duty but maintain readiness, providing force structure depth.",
  difficulty: "Medium"
},
{
  id: 1778,
  subject: "Paragraph Comprehension",
  question: "Military history reveals patterns showing how factors like terrain, supply lines, and leadership influence outcomes. Studying historical examples helps commanders understand principles applying to current situations. However, each conflict contains unique elements requiring adaptation of historical lessons. Military academies emphasize historical study for this reason. Why is military history studied?",
  answer: "Military history is studied to reveal principles about terrain, supply lines, and leadership that inform current decisions, though each situation requires adaptation of historical lessons.",
  difficulty: "Medium"
},
{
  id: 1779,
  subject: "Paragraph Comprehension",
  question: "Non-commissioned officers serve as the primary connection between command decisions and soldier implementation. Sergeants translate orders into actionable instructions and ensure compliance. NCO experience and judgment directly impacts unit effectiveness. Military forces recognize that competent NCOs are essential to success. What role do NCOs fill in military organizations?",
  answer: "NCOs fill the essential role of translating orders into actionable instructions, ensuring compliance, applying experience and judgment directly to unit effectiveness.",
  difficulty: "Medium"
},
{
  id: 1780,
  subject: "Paragraph Comprehension",
  question: "Training rotations expose soldiers to diverse situations, personnel, and environments. Variety in training develops adaptability and prevents staleness. Soldiers training together at rotation centers develop networks that continue into operational assignments. Participation in rotations accelerates professional development. What benefit do training rotations provide?",
  answer: "Training rotations provide exposure to diverse situations and personnel, develop adaptability, build networks, and accelerate professional development through varied experiences.",
  difficulty: "Medium"
},
{
  id: 1781,
  subject: "Paragraph Comprehension",
  question: "Explosive ordnance disposal specialists train extensively to safely neutralize explosives. The work carries extreme risk despite rigorous preparation. EOD personnel must maintain focus while working under stress. Some EOD soldiers describe the experience as mentally demanding beyond physical danger. What characterizes explosive ordnance disposal work?",
  answer: "EOD work involves extreme risk despite rigorous training, demanding mental focus under stress alongside physical danger, with specialists reporting significant mental demands.",
  difficulty: "Hard"
},
{
  id: 1782,
  subject: "Paragraph Comprehension",
  question: "Military organizations occasionally face situations where implementing seemingly logical orders creates serious unintended consequences. A commander might order a legitimate action that inadvertently harms mission or personnel. Complex systems mean actions trigger unexpected reactions. Soldiers sometimes face tension between following orders and recognizing harmful outcomes. What dilemma emerges in complex operations?",
  answer: "Complex operations create dilemmas where legitimate orders sometimes produce unintended harmful consequences, creating tension between following orders and recognizing harmful outcomes.",
  difficulty: "Hard"
},
{
  id: 1783,
  subject: "Paragraph Comprehension",
  question: "Captured soldiers face legal protections under international law but practical vulnerability dependent on captor adherence. History contains examples of honored protections and horrific violations. International law cannot prevent violations but establishes norms and accountability standards. Soldiers sometimes must accept that law provides incomplete protection. What limitation characterizes captured soldier protections?",
  answer: "Captured soldier protections under international law depend on captor adherence, establish norms and accountability standards, but cannot prevent violations and provide incomplete practical protection.",
  difficulty: "Hard"
},
{
  id: 1784,
  subject: "Paragraph Comprehension",
  question: "Military secrecy sometimes prevents useful information from reaching soldiers who need it for effective performance. A soldier might unknowingly duplicate work because they cannot access information about other units. Security requirements justify information compartmentalization but create inefficiency. Finding optimal secrecy levels balances security and operational efficiency. What tension emerges from military secrecy?",
  answer: "Military secrecy balances security needs against operational inefficiency from information compartmentalization, creating tension because useful information sometimes cannot reach soldiers who need it.",
  difficulty: "Hard"
},
{
  id: 1785,
  subject: "Paragraph Comprehension",
  question: "Different military cultures develop different approaches to problem-solving, decision-making, and authority. Army, Navy, Marines, and Air Force cultures reflect service traditions and operational requirements. Cross-service assignments create friction as personnel with different cultural expectations interact. Understanding cultural differences enables better cooperation but also reveals how arbitrary some practices are. What does cross-service interaction reveal?",
  answer: "Cross-service interaction reveals that different military cultures developed different practices reflecting service traditions, creates friction between cultures, but enables understanding that some practices are arbitrary.",
  difficulty: "Hard"
},
{
  id: 1786,
  subject: "Paragraph Comprehension",
  question: "Military fitness requirements seem objectively necessary but different roles require different capabilities. Infantry fitness differs from cyber operations fitness. Applying identical standards to dissimilar roles either under-prepares some personnel or over-requires for others. Customized standards are fairer but create fairness perceptions of inequity. Military organizations struggle with this tension between standardization and specialization. What fairness complication exists?",
  answer: "Military fitness standards face fairness complications because identical standards either under-prepare or over-require different roles, while customized standards create perceptions of inequity.",
  difficulty: "Hard"
},
{
  id: 1787,
  subject: "Paragraph Comprehension",
  question: "Technology dramatically increases military power but also increases dependency on functioning systems. Soldiers become less self-sufficient as technology takes over capabilities. Systems failures create vulnerability that soldiers without technological support become poorly equipped to handle. This creates a paradox where increased capability creates increased fragility. What paradox emerges from military technology?",
  answer: "Military technology creates a paradox where increased capability creates increased system dependency and fragility, making soldiers poorly equipped to operate without functioning systems.",
  difficulty: "Hard"
},
{
  id: 1788,
  subject: "Paragraph Comprehension",
  question: "Soldiers transitioning to veteran status sometimes experience identity disruption because military identity becomes central to their sense of self. Military provides clear role, purpose, and community that civilian life does not automatically provide. Adjusting to civilian identity while maintaining veteran identity creates psychological challenges. Not all soldiers experience equal difficulty, but the transition remains significant. What complication do transitioning soldiers face?",
  answer: "Transitioning soldiers face identity disruption because military identity becomes central to self-concept and community, and civilian life does not automatically provide equivalent role and purpose.",
  difficulty: "Hard"
},
{
  id: 1789,
  subject: "Paragraph Comprehension",
  question: "Military discipline requires enforcing rules even when enforcement seems excessive or counterproductive to individuals involved. Consistent enforcement prevents disciplinary system erosion. However, overly rigid enforcement sometimes creates resentment and disengagement. Effective discipline balances consistency with proportionality and rationale explanation. This balance proves difficult to achieve consistently. What challenge faces military discipline?",
  answer: "Military discipline faces challenges balancing consistent enforcement necessary to prevent erosion with proportionality and explanation that prevent resentment and disengagement.",
  difficulty: "Hard"
},
{
  id: 1790,
  subject: "Paragraph Comprehension",
  question: "Military force can achieve tactical objectives but often fails at strategic objectives involving complex social changes. Force can destroy enemy military but cannot directly create governance, reduce corruption, or change cultural practices. Military limitations in addressing non-military problems creates tension between military capability and political requirements. What is implied about military force?",
  answer: "Military force can achieve tactical objectives but often fails at strategic objectives involving complex social changes, revealing limitations in addressing non-military political and social problems.",
  difficulty: "Hard"
},
{
  id: 1791,
  subject: "Paragraph Comprehension",
  question: "Advanced military equipment requires extensive training that soldiers must maintain through practice. Technology sophistication increases capabilities but also increases training burden. Soldiers spending significant time training on equipment have less time for other necessary activities. The technological arms race forces continuing investment in training. What trade-off emerges from equipment sophistication?",
  answer: "Equipment sophistication creates trade-off between increased capabilities and training burden, requiring soldiers to spend significant time maintaining proficiency at cost of other activities.",
  difficulty: "Hard"
},
{
  id: 1792,
  subject: "Paragraph Comprehension",
  question: "Military organizations value reliability and consistency, yet innovation requires accepting failure as part of experimentation. Organizations that never fail may be missing opportunities for improvement. However, organizations accepting excessive failure risk operational competence. Finding productive balance between innovation and reliability proves persistently difficult. What tension characterizes military innovation?",
  answer: "Military innovation faces tension between valuing reliability and consistency while accepting failure as part of experimentation, requiring balance between avoiding excessive failure and enabling improvement.",
  difficulty: "Hard"
},
{
  id: 1793,
  subject: "Paragraph Comprehension",
  question: "Soldiers sometimes receive conflicting guidance from different leaders with legitimate authority in different domains. A safety officer and an operations officer might give contradictory direction. Resolving conflicts requires understanding authority domains and escalating appropriately. However, unclear authority domains create persistent confusion. What complication emerges from multiple authority sources?",
  answer: "Multiple authority sources create complications when leaders give conflicting legitimate guidance, requiring understanding authority domains and escalation procedures to resolve confusion.",
  difficulty: "Hard"
},
{
  id: 1794,
  subject: "Paragraph Comprehension",
  question: "Military culture emphasizes loyalty and cohesion which bind units together but can also discourage whistleblowing about problems or misconduct. Loyalty becomes problematic when it prevents necessary accountability. Healthy organizations need mechanisms enabling reporting problems without violating loyalty values. Creating these mechanisms while maintaining cohesion proves challenging. What cultural tension exists in military loyalty?",
  answer: "Military loyalty creates cultural tension where cohesion binds units but discourages necessary whistleblowing about misconduct, requiring mechanisms for accountability without violating loyalty values.",
  difficulty: "Hard"
},
{
  id: 1795,
  subject: "Paragraph Comprehension",
  question: "Military operations depend on trust between leaders and followers that sometimes develops despite poor communication or conflicting information. Soldiers trust leaders based on reputation and demonstrated competence even when they disagree with specific decisions. Trust once lost becomes extremely difficult to rebuild. Leaders sometimes must maintain authority through trust rather than force. What role does trust play in military effectiveness?",
  answer: "Trust between leaders and followers enables military effectiveness and can develop despite disagreements, depends on demonstrated competence and reputation, and rebuilds with extreme difficulty once lost.",
  difficulty: "Hard"
},
{
  id: 1796,
  subject: "Paragraph Comprehension",
  question: "Military organizations occasionally face requirements to accomplish impossible tasks with insufficient resources and time. Leaders must communicate honestly about limitations while remaining committed to best possible outcomes. Soldiers recognize impossible situations but continue performing because unit cohesion and leadership example inspire continued effort. This creates moral complexity for leaders who knowingly direct doomed efforts. What moral complexity emerges?",
  answer: "Moral complexity emerges when leaders must direct soldiers in impossible situations with insufficient resources, requiring honesty about limitations while inspiring continued effort despite known difficulties.",
  difficulty: "Hard"
},
{
  id: 1797,
  subject: "Paragraph Comprehension",
  question: "Military forces serve different purposes including defense, deterrence, power projection, and humanitarian assistance. These roles require different capabilities and create different requirements. Preparing for one role sometimes compromises preparation for others. Military leaders face persistent tension deciding resource allocation among competing roles. What challenge faces military resource allocation?",
  answer: "Military resource allocation faces the challenge that different roles requiring different capabilities compete for resources, with preparation for one role sometimes compromising preparation for others.",
  difficulty: "Hard"
},
{
  id: 1798,
  subject: "Paragraph Comprehension",
  question: "Military experience sometimes becomes difficult to translate to civilian employment because employers misunderstand military accomplishments or overestimate capability transfer. A soldier who managed supply logistics might struggle to articulate that skill for civilian positions. Military culture, language, and values sometimes alienate civilian employers. Successfully transitioning requires actively translating military experience. What complication do transitioning soldiers face?",
  answer: "Transitioning soldiers face complications because employers misunderstand military accomplishments, overestimate capability transfer, and military culture sometimes alienates civilian employers.",
  difficulty: "Hard"
},
{
  id: 1799,
  subject: "Paragraph Comprehension",
  question: "Military family members face unique stresses from separation, uncertainty about combat safety, frequent moves, and social isolation. Spousal employment becomes complicated by frequent transfers. Children experience interrupted education and friendship disruption. Military support systems exist but cannot fully mitigate family stress from military service requirements. Family resilience depends partly on individual factors and partly on support availability. What stresses affect military families?",
  answer: "Military families face stresses from separation, safety uncertainty, frequent moves, employment complications, educational disruption, and social isolation despite available support systems.",
  difficulty: "Hard"
},
{
  id: 1800,
  subject: "Paragraph Comprehension",
  question: "Military training increasingly incorporates virtual simulation and computer-based scenarios alongside live training. Simulations provide cost-effective, repeatable practice enabling higher volume training. However, simulations cannot perfectly replicate actual combat stress, real-world equipment variability, or genuine physical demands. Effective training requires combining simulation and live experience. What is the role of simulation in military training?",
  answer: "Simulation provides cost-effective repeatable practice and higher volume training but cannot perfectly replicate combat stress and physical demands, requiring combination with live training.",
  difficulty: "Hard"
}
,
{
  id: 1801,
  subject: "Word Knowledge",
  question: "What does 'vigilant' most nearly mean?",
  answer: "Watchful and alert. Example: The vigilant guard noticed the intruder immediately.",
  difficulty: "Easy"
},
{
  id: 1802,
  subject: "Word Knowledge",
  question: "What does 'meticulous' most nearly mean?",
  answer: "Very careful and precise. Example: The mechanic was meticulous in checking every part of the engine.",
  difficulty: "Easy"
},
{
  id: 1803,
  subject: "Word Knowledge",
  question: "The soldier was commended for his valor in battle. What does 'valor' mean?",
  answer: "Courage and bravery, especially in combat. Example: His valor earned him a medal of honor.",
  difficulty: "Easy"
},
{
  id: 1804,
  subject: "Word Knowledge",
  question: "What does 'adversary' most nearly mean?",
  answer: "An opponent or enemy. Example: The two teams were long-time adversaries on the field.",
  difficulty: "Easy"
},
{
  id: 1805,
  subject: "Word Knowledge",
  question: "What does 'terminate' most nearly mean?",
  answer: "To end or stop something. Example: The company decided to terminate the contract early.",
  difficulty: "Easy"
},
{
  id: 1806,
  subject: "Word Knowledge",
  question: "What does 'deploy' most nearly mean?",
  answer: "To move troops or equipment into position for action. Example: The military will deploy additional forces to the region.",
  difficulty: "Easy"
},
{
  id: 1807,
  subject: "Word Knowledge",
  question: "The witness gave a vague description of the suspect. What does 'vague' mean?",
  answer: "Unclear or not specific. Example: His vague instructions left us confused about what to do.",
  difficulty: "Easy"
},
{
  id: 1808,
  subject: "Word Knowledge",
  question: "What does 'authentic' most nearly mean?",
  answer: "Genuine or real. Example: The museum displayed authentic artifacts from ancient Rome.",
  difficulty: "Easy"
},
{
  id: 1809,
  subject: "Word Knowledge",
  question: "What does 'demolish' most nearly mean?",
  answer: "To destroy or tear down completely. Example: Workers will demolish the old building next week.",
  difficulty: "Easy"
},
{
  id: 1810,
  subject: "Word Knowledge",
  question: "What does 'fortify' most nearly mean?",
  answer: "To strengthen or reinforce. Example: The troops worked to fortify their defensive positions.",
  difficulty: "Easy"
},
{
  id: 1811,
  subject: "Word Knowledge",
  question: "The sergeant gave explicit orders to the squad. What does 'explicit' mean?",
  answer: "Clear and detailed, leaving no doubt. Example: She gave explicit directions to the destination.",
  difficulty: "Easy"
},
{
  id: 1812,
  subject: "Word Knowledge",
  question: "What does 'endure' most nearly mean?",
  answer: "To withstand or suffer through. Example: The soldiers had to endure harsh weather conditions.",
  difficulty: "Easy"
},
{
  id: 1813,
  subject: "Word Knowledge",
  question: "What does 'prominent' most nearly mean?",
  answer: "Important, famous, or easily noticeable. Example: The building had a prominent location in the city center.",
  difficulty: "Easy"
},
{
  id: 1814,
  subject: "Word Knowledge",
  question: "What does 'hostile' most nearly mean?",
  answer: "Unfriendly or antagonistic. Example: The troops entered hostile territory with extreme caution.",
  difficulty: "Easy"
},
{
  id: 1815,
  subject: "Word Knowledge",
  question: "The commander made a swift decision. What does 'swift' mean?",
  answer: "Quick or rapid. Example: His swift response prevented a disaster.",
  difficulty: "Easy"
},
{
  id: 1816,
  subject: "Word Knowledge",
  question: "What does 'adequate' most nearly mean?",
  answer: "Sufficient or enough. Example: The supplies were adequate for the mission.",
  difficulty: "Easy"
},
{
  id: 1817,
  subject: "Word Knowledge",
  question: "What does 'consecutive' most nearly mean?",
  answer: "Following one after another without interruption. Example: She worked for three consecutive days without a break.",
  difficulty: "Easy"
},
{
  id: 1818,
  subject: "Word Knowledge",
  question: "What does 'evacuate' most nearly mean?",
  answer: "To leave or remove from a dangerous place. Example: Officials ordered residents to evacuate before the storm.",
  difficulty: "Easy"
},
{
  id: 1819,
  subject: "Word Knowledge",
  question: "The pilot maintained altitude during turbulent weather. What does 'turbulent' mean?",
  answer: "Characterized by disorder or instability. Example: The turbulent waters made navigation difficult.",
  difficulty: "Easy"
},
{
  id: 1820,
  subject: "Word Knowledge",
  question: "What does 'abundant' most nearly mean?",
  answer: "Plentiful or existing in large quantities. Example: The forest had abundant wildlife.",
  difficulty: "Easy"
},
{
  id: 1821,
  subject: "Word Knowledge",
  question: "What does 'reconnaissance' most nearly mean?",
  answer: "Military observation of a region to gather information. Example: The team conducted reconnaissance before the main assault.",
  difficulty: "Medium"
},
{
  id: 1822,
  subject: "Word Knowledge",
  question: "What does 'scrutinize' most nearly mean?",
  answer: "To examine very carefully and critically. Example: The inspector will scrutinize every detail of the equipment.",
  difficulty: "Medium"
},
{
  id: 1823,
  subject: "Word Knowledge",
  question: "The officer showed clemency toward the young recruit. What does 'clemency' mean?",
  answer: "Mercy or leniency. Example: The judge granted clemency and reduced the sentence.",
  difficulty: "Medium"
},
{
  id: 1824,
  subject: "Word Knowledge",
  question: "What does 'autonomous' most nearly mean?",
  answer: "Self-governing or independent. Example: The autonomous vehicle can drive without human control.",
  difficulty: "Medium"
},
{
  id: 1825,
  subject: "Word Knowledge",
  question: "What does 'retaliate' most nearly mean?",
  answer: "To take revenge or strike back. Example: The military promised to retaliate against any aggression.",
  difficulty: "Medium"
},
{
  id: 1826,
  subject: "Word Knowledge",
  question: "What does 'morale' most nearly mean?",
  answer: "The confidence and enthusiasm of a person or group. Example: High morale among troops improves performance.",
  difficulty: "Medium"
},
{
  id: 1827,
  subject: "Word Knowledge",
  question: "The general's strategy was deemed prudent by his advisors. What does 'prudent' mean?",
  answer: "Wise and careful in practical matters. Example: It was prudent to save money for emergencies.",
  difficulty: "Medium"
},
{
  id: 1828,
  subject: "Word Knowledge",
  question: "What does 'procurement' most nearly mean?",
  answer: "The act of obtaining or acquiring something. Example: The procurement of new equipment took several months.",
  difficulty: "Medium"
},
{
  id: 1829,
  subject: "Word Knowledge",
  question: "What does 'mobilize' most nearly mean?",
  answer: "To prepare and organize for action or use. Example: The country began to mobilize its military forces.",
  difficulty: "Medium"
},
{
  id: 1830,
  subject: "Word Knowledge",
  question: "What does 'subsequent' most nearly mean?",
  answer: "Coming after something in time or order. Example: The first attack was followed by subsequent strikes.",
  difficulty: "Medium"
},
{
  id: 1831,
  subject: "Word Knowledge",
  question: "The battalion prepared for imminent deployment. What does 'imminent' mean?",
  answer: "About to happen very soon. Example: The dark clouds indicated imminent rain.",
  difficulty: "Medium"
},
{
  id: 1832,
  subject: "Word Knowledge",
  question: "What does 'protocol' most nearly mean?",
  answer: "An official procedure or system of rules. Example: Military protocol requires saluting superior officers.",
  difficulty: "Medium"
},
{
  id: 1833,
  subject: "Word Knowledge",
  question: "What does 'expedite' most nearly mean?",
  answer: "To speed up or make happen more quickly. Example: We need to expedite the shipping process.",
  difficulty: "Medium"
},
{
  id: 1834,
  subject: "Word Knowledge",
  question: "What does 'versatile' most nearly mean?",
  answer: "Able to adapt or be used in many different ways. Example: A Swiss Army knife is a versatile tool.",
  difficulty: "Medium"
},
{
  id: 1835,
  subject: "Word Knowledge",
  question: "The captain showed deference to the admiral. What does 'deference' mean?",
  answer: "Respectful submission or yielding to another's judgment. Example: She spoke with deference to her elders.",
  difficulty: "Medium"
},
{
  id: 1836,
  subject: "Word Knowledge",
  question: "What does 'jurisdiction' most nearly mean?",
  answer: "The official power to make legal decisions. Example: The case fell under federal jurisdiction.",
  difficulty: "Medium"
},
{
  id: 1837,
  subject: "Word Knowledge",
  question: "What does 'tactical' most nearly mean?",
  answer: "Relating to actions carefully planned to achieve a specific goal. Example: The tactical maneuver caught the enemy off guard.",
  difficulty: "Medium"
},
{
  id: 1838,
  subject: "Word Knowledge",
  question: "What does 'intermittent' most nearly mean?",
  answer: "Stopping and starting at irregular intervals. Example: Intermittent rain showers occurred throughout the day.",
  difficulty: "Medium"
},
{
  id: 1839,
  subject: "Word Knowledge",
  question: "The officer maintained composure during the crisis. What does 'composure' mean?",
  answer: "Calmness and self-control. Example: She kept her composure even under pressure.",
  difficulty: "Medium"
},
{
  id: 1840,
  subject: "Word Knowledge",
  question: "What does 'armament' most nearly mean?",
  answer: "Military weapons and equipment. Example: The ship carried heavy armament for defense.",
  difficulty: "Medium"
},
{
  id: 1841,
  subject: "Word Knowledge",
  question: "What does 'rigorous' most nearly mean?",
  answer: "Extremely thorough and demanding. Example: Basic training involves rigorous physical conditioning.",
  difficulty: "Medium"
},
{
  id: 1842,
  subject: "Word Knowledge",
  question: "What does 'coalition' most nearly mean?",
  answer: "An alliance of groups for a common purpose. Example: Several nations formed a coalition against terrorism.",
  difficulty: "Medium"
},
{
  id: 1843,
  subject: "Word Knowledge",
  question: "The troops received comprehensive training. What does 'comprehensive' mean?",
  answer: "Complete and including all elements. Example: The comprehensive exam covered all course material.",
  difficulty: "Medium"
},
{
  id: 1844,
  subject: "Word Knowledge",
  question: "What does 'contingency' most nearly mean?",
  answer: "A future event or circumstance that is possible but cannot be predicted. Example: We developed a contingency plan in case of emergency.",
  difficulty: "Medium"
},
{
  id: 1845,
  subject: "Word Knowledge",
  question: "What does 'tenacity' most nearly mean?",
  answer: "Determination and persistence. Example: Her tenacity helped her overcome many obstacles.",
  difficulty: "Medium"
},
{
  id: 1846,
  subject: "Word Knowledge",
  question: "What does 'arbitrary' most nearly mean?",
  answer: "Based on random choice rather than reason or system. Example: The rule seemed arbitrary and unfair.",
  difficulty: "Medium"
},
{
  id: 1847,
  subject: "Word Knowledge",
  question: "The commander issued a mandate to all personnel. What does 'mandate' mean?",
  answer: "An official order or command. Example: The government issued a mandate requiring masks.",
  difficulty: "Medium"
},
{
  id: 1848,
  subject: "Word Knowledge",
  question: "What does 'subordinate' most nearly mean?",
  answer: "Lower in rank or position. Example: Officers give orders to subordinate personnel.",
  difficulty: "Medium"
},
{
  id: 1849,
  subject: "Word Knowledge",
  question: "What does 'fortitude' most nearly mean?",
  answer: "Courage in facing pain or adversity. Example: The soldiers showed great fortitude during the long campaign.",
  difficulty: "Medium"
},
{
  id: 1850,
  subject: "Word Knowledge",
  question: "What does 'logistics' most nearly mean?",
  answer: "The detailed organization and implementation of a complex operation. Example: Military logistics involve moving troops and supplies efficiently.",
  difficulty: "Medium"
},
{
  id: 1851,
  subject: "Word Knowledge",
  question: "The unit demonstrated exemplary conduct. What does 'exemplary' mean?",
  answer: "Serving as a desirable model; outstanding. Example: Her exemplary performance earned her a promotion.",
  difficulty: "Medium"
},
{
  id: 1852,
  subject: "Word Knowledge",
  question: "What does 'covert' most nearly mean?",
  answer: "Secret or not openly shown. Example: The agents conducted a covert operation behind enemy lines.",
  difficulty: "Medium"
},
{
  id: 1853,
  subject: "Word Knowledge",
  question: "What does 'volatile' most nearly mean?",
  answer: "Likely to change suddenly or unpredictably. Example: The volatile situation required careful handling.",
  difficulty: "Medium"
},
{
  id: 1854,
  subject: "Word Knowledge",
  question: "What does 'sustain' most nearly mean?",
  answer: "To support, maintain, or keep something going. Example: The troops needed supplies to sustain the operation.",
  difficulty: "Medium"
},
{
  id: 1855,
  subject: "Word Knowledge",
  question: "The lieutenant showed initiative during the emergency. What does 'initiative' mean?",
  answer: "The ability to act independently and make decisions. Example: Taking initiative is important for leadership.",
  difficulty: "Medium"
},
{
  id: 1856,
  subject: "Word Knowledge",
  question: "What does 'surveillance' most nearly mean?",
  answer: "Close observation, especially of a suspected person. Example: The police maintained surveillance on the building.",
  difficulty: "Medium"
},
{
  id: 1857,
  subject: "Word Knowledge",
  question: "What does 'implement' most nearly mean?",
  answer: "To put a plan or decision into effect. Example: The commander will implement new safety procedures.",
  difficulty: "Medium"
},
{
  id: 1858,
  subject: "Word Knowledge",
  question: "What does 'disciplinary' most nearly mean?",
  answer: "Relating to punishment or enforcement of rules. Example: The soldier faced disciplinary action for misconduct.",
  difficulty: "Medium"
},
{
  id: 1859,
  subject: "Word Knowledge",
  question: "The general gave a concise briefing. What does 'concise' mean?",
  answer: "Brief and to the point. Example: A concise report is easier to read than a lengthy one.",
  difficulty: "Medium"
},
{
  id: 1860,
  subject: "Word Knowledge",
  question: "What does 'formidable' most nearly mean?",
  answer: "Inspiring fear or respect through size, power, or ability. Example: The enemy had a formidable army.",
  difficulty: "Medium"
},
{
  id: 1861,
  subject: "Word Knowledge",
  question: "What does 'acquiesce' most nearly mean?",
  answer: "To accept or agree to something reluctantly. Example: The officer had to acquiesce to the general's decision.",
  difficulty: "Hard"
},
{
  id: 1862,
  subject: "Word Knowledge",
  question: "What does 'superfluous' most nearly mean?",
  answer: "Unnecessary or more than needed. Example: The report contained superfluous details that distracted from the main point.",
  difficulty: "Hard"
},
{
  id: 1863,
  subject: "Word Knowledge",
  question: "The diplomat tried to ameliorate tensions between the nations. What does 'ameliorate' mean?",
  answer: "To make something better or less severe. Example: The new policy helped ameliorate working conditions.",
  difficulty: "Hard"
},
{
  id: 1864,
  subject: "Word Knowledge",
  question: "What does 'ubiquitous' most nearly mean?",
  answer: "Present everywhere at the same time. Example: Cell phones have become ubiquitous in modern society.",
  difficulty: "Hard"
},
{
  id: 1865,
  subject: "Word Knowledge",
  question: "What does 'capitulate' most nearly mean?",
  answer: "To surrender or give in to demands. Example: The besieged city finally capitulated after months.",
  difficulty: "Hard"
},
{
  id: 1866,
  subject: "Word Knowledge",
  question: "What does 'impervious' most nearly mean?",
  answer: "Unable to be affected or penetrated. Example: The bunker was impervious to small arms fire.",
  difficulty: "Hard"
},
{
  id: 1867,
  subject: "Word Knowledge",
  question: "The senator's speech was full of bellicose rhetoric. What does 'bellicose' mean?",
  answer: "Demonstrating aggression and willingness to fight. Example: His bellicose statements alarmed neighboring countries.",
  difficulty: "Hard"
},
{
  id: 1868,
  subject: "Word Knowledge",
  question: "What does 'arduous' most nearly mean?",
  answer: "Involving great effort and difficulty. Example: The soldiers completed the arduous mountain trek.",
  difficulty: "Hard"
},
{
  id: 1869,
  subject: "Word Knowledge",
  question: "What does 'taciturn' most nearly mean?",
  answer: "Reserved or uncommunicative in speech. Example: The taciturn soldier rarely spoke during briefings.",
  difficulty: "Hard"
},
{
  id: 1870,
  subject: "Word Knowledge",
  question: "What does 'pragmatic' most nearly mean?",
  answer: "Dealing with things practically rather than theoretically. Example: The general took a pragmatic approach to solving problems.",
  difficulty: "Hard"
},
{
  id: 1871,
  subject: "Word Knowledge",
  question: "The commander showed remarkable perspicacity in battle. What does 'perspicacity' mean?",
  answer: "The quality of having keen insight or judgment. Example: Her perspicacity allowed her to predict the opponent's moves.",
  difficulty: "Hard"
},
{
  id: 1872,
  subject: "Word Knowledge",
  question: "What does 'obsolete' most nearly mean?",
  answer: "No longer in use or outdated. Example: The obsolete equipment was replaced with modern technology.",
  difficulty: "Hard"
},
{
  id: 1873,
  subject: "Word Knowledge",
  question: "What does 'incendiary' most nearly mean?",
  answer: "Designed to cause fires or capable of arousing strong emotion. Example: The troops used incendiary devices to destroy the target.",
  difficulty: "Hard"
},
{
  id: 1874,
  subject: "Word Knowledge",
  question: "What does 'subjugate' most nearly mean?",
  answer: "To bring under control or domination. Example: The empire sought to subjugate neighboring territories.",
  difficulty: "Hard"
},
{
  id: 1875,
  subject: "Word Knowledge",
  question: "The ambassador spoke with diplomatic circumlocution. What does 'circumlocution' mean?",
  answer: "The use of many words where fewer would do; evasive speech. Example: His circumlocution made it hard to understand his point.",
  difficulty: "Hard"
},
{
  id: 1876,
  subject: "Word Knowledge",
  question: "What does 'insubordinate' most nearly mean?",
  answer: "Defiant of authority or disobedient. Example: The insubordinate soldier refused to follow orders.",
  difficulty: "Hard"
},
{
  id: 1877,
  subject: "Word Knowledge",
  question: "What does 'autonomous' most nearly mean?",
  answer: "Having the freedom to act independently. Example: The autonomous region governed itself without outside interference.",
  difficulty: "Hard"
},
{
  id: 1878,
  subject: "Word Knowledge",
  question: "What does 'commensurate' most nearly mean?",
  answer: "Corresponding in size or degree; proportionate. Example: The pay should be commensurate with experience.",
  difficulty: "Hard"
},
{
  id: 1879,
  subject: "Word Knowledge",
  question: "The operation required meticulous clandestine planning. What does 'clandestine' mean?",
  answer: "Kept secret or done secretively. Example: The clandestine meeting was held at midnight.",
  difficulty: "Hard"
},
{
  id: 1880,
  subject: "Word Knowledge",
  question: "What does 'duplicity' most nearly mean?",
  answer: "Deceitfulness or double-dealing. Example: The spy's duplicity was eventually discovered.",
  difficulty: "Hard"
},
{
  id: 1881,
  subject: "Word Knowledge",
  question: "What does 'integrity' most nearly mean?",
  answer: "The quality of being honest and having strong moral principles. Example: Officers must maintain integrity in all actions.",
  difficulty: "Easy"
},
{
  id: 1882,
  subject: "Word Knowledge",
  question: "What does 'priority' most nearly mean?",
  answer: "Something that is more important than other things. Example: Safety is the top priority on this mission.",
  difficulty: "Easy"
},
{
  id: 1883,
  subject: "Word Knowledge",
  question: "The team showed excellent coordination during the exercise. What does 'coordination' mean?",
  answer: "The organization of different elements to work together effectively. Example: Good coordination between units is essential for success.",
  difficulty: "Easy"
},
{
  id: 1884,
  subject: "Word Knowledge",
  question: "What does 'verify' most nearly mean?",
  answer: "To check or confirm that something is true or accurate. Example: Please verify your identity before entering.",
  difficulty: "Easy"
},
{
  id: 1885,
  subject: "Word Knowledge",
  question: "What does 'precise' most nearly mean?",
  answer: "Exact and accurate. Example: The GPS provided precise coordinates for the target.",
  difficulty: "Easy"
},
{
  id: 1886,
  subject: "Word Knowledge",
  question: "What does 'mandatory' most nearly mean?",
  answer: "Required or compulsory. Example: Attendance at the briefing is mandatory for all personnel.",
  difficulty: "Easy"
},
{
  id: 1887,
  subject: "Word Knowledge",
  question: "The sergeant maintained discipline in the ranks. What does 'discipline' mean?",
  answer: "Training to follow rules and develop self-control. Example: Military discipline is essential for unit effectiveness.",
  difficulty: "Easy"
},
{
  id: 1888,
  subject: "Word Knowledge",
  question: "What does 'modify' most nearly mean?",
  answer: "To make partial changes to something. Example: We need to modify the plan based on new intelligence.",
  difficulty: "Easy"
},
{
  id: 1889,
  subject: "Word Knowledge",
  question: "What does 'eliminate' most nearly mean?",
  answer: "To completely remove or get rid of. Example: The goal is to eliminate all safety hazards.",
  difficulty: "Easy"
},
{
  id: 1890,
  subject: "Word Knowledge",
  question: "What does 'accelerate' most nearly mean?",
  answer: "To increase in speed or rate. Example: The vehicle began to accelerate down the runway.",
  difficulty: "Easy"
},
{
  id: 1891,
  subject: "Word Knowledge",
  question: "The commander emphasized the critical nature of the mission. What does 'critical' mean?",
  answer: "Extremely important or essential. Example: Timing is critical for this operation's success.",
  difficulty: "Easy"
},
{
  id: 1892,
  subject: "Word Knowledge",
  question: "What does 'restrict' most nearly mean?",
  answer: "To limit or control. Example: The base will restrict access during the exercise.",
  difficulty: "Easy"
},
{
  id: 1893,
  subject: "Word Knowledge",
  question: "What does 'comply' most nearly mean?",
  answer: "To act in accordance with rules or requests. Example: All personnel must comply with safety regulations.",
  difficulty: "Easy"
},
{
  id: 1894,
  subject: "Word Knowledge",
  question: "What does 'retain' most nearly mean?",
  answer: "To keep or continue to have something. Example: The military seeks to retain experienced personnel.",
  difficulty: "Easy"
},
{
  id: 1895,
  subject: "Word Knowledge",
  question: "The unit received authorization to proceed. What does 'authorization' mean?",
  answer: "Official permission or approval. Example: You need authorization before accessing classified materials.",
  difficulty: "Easy"
},
{
  id: 1896,
  subject: "Word Knowledge",
  question: "What does 'transport' most nearly mean?",
  answer: "To carry or move from one place to another. Example: Helicopters will transport supplies to the outpost.",
  difficulty: "Easy"
},
{
  id: 1897,
  subject: "Word Knowledge",
  question: "What does 'inspect' most nearly mean?",
  answer: "To examine carefully. Example: The officer will inspect the equipment before departure.",
  difficulty: "Easy"
},
{
  id: 1898,
  subject: "Word Knowledge",
  question: "What does 'standard' most nearly mean?",
  answer: "A level of quality or achievement used as a reference. Example: All equipment must meet military standards.",
  difficulty: "Easy"
},
{
  id: 1899,
  subject: "Word Knowledge",
  question: "The patrol maintained constant vigilance. What does 'constant' mean?",
  answer: "Occurring continuously or remaining unchanged. Example: The radar provides constant surveillance.",
  difficulty: "Easy"
},
{
  id: 1900,
  subject: "Word Knowledge",
  question: "What does 'personnel' most nearly mean?",
  answer: "People employed in an organization or engaged in a service. Example: All personnel must report to the assembly area.",
  difficulty: "Easy"
},
{
  id: 1901,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x + 7 = 22",
  answer: "x = 5\n\nSteps:\n1. Subtract 7 from both sides: 3x = 15\n2. Divide both sides by 3: x = 5",
  difficulty: "Easy"
},
{
  id: 1902,
  subject: "Mathematics Knowledge",
  question: "What is the area of a rectangle with length 8 inches and width 5 inches?",
  answer: "40 square inches\n\nFormula: Area = length × width\nArea = 8 × 5 = 40 square inches",
  difficulty: "Easy"
},
{
  id: 1903,
  subject: "Mathematics Knowledge",
  question: "Simplify: 4x + 2x - 3x",
  answer: "3x\n\nCombine like terms:\n4x + 2x - 3x = (4 + 2 - 3)x = 3x",
  difficulty: "Easy"
},
{
  id: 1904,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a square with side length 9 cm?",
  answer: "36 cm\n\nFormula: Perimeter = 4 × side\nPerimeter = 4 × 9 = 36 cm",
  difficulty: "Easy"
},
{
  id: 1905,
  subject: "Mathematics Knowledge",
  question: "Evaluate: 2³ + 5",
  answer: "13\n\nSteps:\n1. Calculate 2³ = 2 × 2 × 2 = 8\n2. Add 5: 8 + 5 = 13",
  difficulty: "Easy"
},
{
  id: 1906,
  subject: "Mathematics Knowledge",
  question: "Solve for y: y - 12 = 8",
  answer: "y = 20\n\nAdd 12 to both sides:\ny = 8 + 12 = 20",
  difficulty: "Easy"
},
{
  id: 1907,
  subject: "Mathematics Knowledge",
  question: "What is the area of a triangle with base 10 cm and height 6 cm?",
  answer: "30 square cm\n\nFormula: Area = (1/2) × base × height\nArea = (1/2) × 10 × 6 = 30 square cm",
  difficulty: "Easy"
},
{
  id: 1908,
  subject: "Mathematics Knowledge",
  question: "Simplify: 5(x + 3)",
  answer: "5x + 15\n\nDistribute 5 to both terms:\n5 × x + 5 × 3 = 5x + 15",
  difficulty: "Easy"
},
{
  id: 1909,
  subject: "Mathematics Knowledge",
  question: "What is the circumference of a circle with radius 7 cm? (Use π ≈ 3.14)",
  answer: "43.96 cm\n\nFormula: Circumference = 2πr\nC = 2 × 3.14 × 7 = 43.96 cm",
  difficulty: "Easy"
},
{
  id: 1910,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x/4 = 3",
  answer: "x = 12\n\nMultiply both sides by 4:\nx = 3 × 4 = 12",
  difficulty: "Easy"
},
{
  id: 1911,
  subject: "Mathematics Knowledge",
  question: "What is the value of √64?",
  answer: "8\n\n√64 = 8 because 8 × 8 = 64",
  difficulty: "Easy"
},
{
  id: 1912,
  subject: "Mathematics Knowledge",
  question: "Simplify: 3x² + 5x² - 2x²",
  answer: "6x²\n\nCombine like terms:\n3x² + 5x² - 2x² = (3 + 5 - 2)x² = 6x²",
  difficulty: "Easy"
},
{
  id: 1913,
  subject: "Mathematics Knowledge",
  question: "What is the area of a circle with radius 5 cm? (Use π ≈ 3.14)",
  answer: "78.5 square cm\n\nFormula: Area = πr²\nArea = 3.14 × 5² = 3.14 × 25 = 78.5 square cm",
  difficulty: "Easy"
},
{
  id: 1914,
  subject: "Mathematics Knowledge",
  question: "Evaluate: 10 - 2 × 3",
  answer: "4\n\nUsing order of operations (PEMDAS):\n1. Multiply first: 2 × 3 = 6\n2. Subtract: 10 - 6 = 4",
  difficulty: "Easy"
},
{
  id: 1915,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x = 18",
  answer: "x = 9\n\nDivide both sides by 2:\nx = 18 ÷ 2 = 9",
  difficulty: "Easy"
},
{
  id: 1916,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a cube with side length 4 inches?",
  answer: "64 cubic inches\n\nFormula: Volume = side³\nVolume = 4³ = 4 × 4 × 4 = 64 cubic inches",
  difficulty: "Easy"
},
{
  id: 1917,
  subject: "Mathematics Knowledge",
  question: "Simplify: 7a - 4a + 2a",
  answer: "5a\n\nCombine like terms:\n7a - 4a + 2a = (7 - 4 + 2)a = 5a",
  difficulty: "Easy"
},
{
  id: 1918,
  subject: "Mathematics Knowledge",
  question: "What is 4² × 2²?",
  answer: "64\n\nSteps:\n1. Calculate 4² = 16\n2. Calculate 2² = 4\n3. Multiply: 16 × 4 = 64",
  difficulty: "Easy"
},
{
  id: 1919,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x + 15 = 23",
  answer: "x = 8\n\nSubtract 15 from both sides:\nx = 23 - 15 = 8",
  difficulty: "Easy"
},
{
  id: 1920,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a rectangle with length 12 cm and width 7 cm?",
  answer: "38 cm\n\nFormula: Perimeter = 2(length + width)\nPerimeter = 2(12 + 7) = 2(19) = 38 cm",
  difficulty: "Easy"
},
{
  id: 1921,
  subject: "Mathematics Knowledge",
  question: "Evaluate: 3(4 + 2) - 5",
  answer: "13\n\nUsing order of operations:\n1. Parentheses: 4 + 2 = 6\n2. Multiply: 3 × 6 = 18\n3. Subtract: 18 - 5 = 13",
  difficulty: "Easy"
},
{
  id: 1922,
  subject: "Mathematics Knowledge",
  question: "What is the value of √100?",
  answer: "10\n\n√100 = 10 because 10 × 10 = 100",
  difficulty: "Easy"
},
{
  id: 1923,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 5x - 3 = 17",
  answer: "x = 4\n\nSteps:\n1. Add 3 to both sides: 5x = 20\n2. Divide both sides by 5: x = 4",
  difficulty: "Easy"
},
{
  id: 1924,
  subject: "Mathematics Knowledge",
  question: "Simplify: 2(3x + 4)",
  answer: "6x + 8\n\nDistribute 2 to both terms:\n2 × 3x + 2 × 4 = 6x + 8",
  difficulty: "Easy"
},
{
  id: 1925,
  subject: "Mathematics Knowledge",
  question: "What is 5³?",
  answer: "125\n\n5³ = 5 × 5 × 5 = 125",
  difficulty: "Easy"
},
{
  id: 1926,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a rectangular prism with length 5 cm, width 3 cm, and height 4 cm?",
  answer: "60 cubic cm\n\nFormula: Volume = length × width × height\nVolume = 5 × 3 × 4 = 60 cubic cm",
  difficulty: "Easy"
},
{
  id: 1927,
  subject: "Mathematics Knowledge",
  question: "Solve for y: 3y = 27",
  answer: "y = 9\n\nDivide both sides by 3:\ny = 27 ÷ 3 = 9",
  difficulty: "Easy"
},
{
  id: 1928,
  subject: "Mathematics Knowledge",
  question: "Simplify: 8x - 5x + x",
  answer: "4x\n\nCombine like terms:\n8x - 5x + x = (8 - 5 + 1)x = 4x",
  difficulty: "Easy"
},
{
  id: 1929,
  subject: "Mathematics Knowledge",
  question: "What is the area of a square with side length 11 inches?",
  answer: "121 square inches\n\nFormula: Area = side²\nArea = 11² = 121 square inches",
  difficulty: "Easy"
},
{
  id: 1930,
  subject: "Mathematics Knowledge",
  question: "Evaluate: 20 ÷ 4 + 3 × 2",
  answer: "11\n\nUsing order of operations:\n1. Divide: 20 ÷ 4 = 5\n2. Multiply: 3 × 2 = 6\n3. Add: 5 + 6 = 11",
  difficulty: "Easy"
},
{
  id: 1931,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x - 7 = 14",
  answer: "x = 21\n\nAdd 7 to both sides:\nx = 14 + 7 = 21",
  difficulty: "Easy"
},
{
  id: 1932,
  subject: "Mathematics Knowledge",
  question: "What is the value of 3² + 4²?",
  answer: "25\n\nSteps:\n1. Calculate 3² = 9\n2. Calculate 4² = 16\n3. Add: 9 + 16 = 25",
  difficulty: "Easy"
},
{
  id: 1933,
  subject: "Mathematics Knowledge",
  question: "Simplify: 4(2x - 3)",
  answer: "8x - 12\n\nDistribute 4 to both terms:\n4 × 2x - 4 × 3 = 8x - 12",
  difficulty: "Easy"
},
{
  id: 1934,
  subject: "Mathematics Knowledge",
  question: "What is √36?",
  answer: "6\n\n√36 = 6 because 6 × 6 = 36",
  difficulty: "Easy"
},
{
  id: 1935,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x/5 = 7",
  answer: "x = 35\n\nMultiply both sides by 5:\nx = 7 × 5 = 35",
  difficulty: "Easy"
},
{
  id: 1936,
  subject: "Mathematics Knowledge",
  question: "What is the perimeter of a triangle with sides 5 cm, 7 cm, and 9 cm?",
  answer: "21 cm\n\nPerimeter = sum of all sides\nPerimeter = 5 + 7 + 9 = 21 cm",
  difficulty: "Easy"
},
{
  id: 1937,
  subject: "Mathematics Knowledge",
  question: "Evaluate: 15 - (3 + 4)",
  answer: "8\n\nSteps:\n1. Parentheses first: 3 + 4 = 7\n2. Subtract: 15 - 7 = 8",
  difficulty: "Easy"
},
{
  id: 1938,
  subject: "Mathematics Knowledge",
  question: "Simplify: 10y - 7y + 3y",
  answer: "6y\n\nCombine like terms:\n10y - 7y + 3y = (10 - 7 + 3)y = 6y",
  difficulty: "Easy"
},
{
  id: 1939,
  subject: "Mathematics Knowledge",
  question: "What is 2⁴?",
  answer: "16\n\n2⁴ = 2 × 2 × 2 × 2 = 16",
  difficulty: "Easy"
},
{
  id: 1940,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 4x + 5 = 21",
  answer: "x = 4\n\nSteps:\n1. Subtract 5 from both sides: 4x = 16\n2. Divide both sides by 4: x = 4",
  difficulty: "Easy"
},
{
  id: 1941,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2x + 5 = 3x - 7",
  answer: "x = 12\n\nSteps:\n1. Subtract 2x from both sides: 5 = x - 7\n2. Add 7 to both sides: x = 12",
  difficulty: "Medium"
},
{
  id: 1942,
  subject: "Mathematics Knowledge",
  question: "Factor: x² + 7x + 12",
  answer: "(x + 3)(x + 4)\n\nFind two numbers that multiply to 12 and add to 7:\n3 and 4 work because 3 × 4 = 12 and 3 + 4 = 7\nTherefore: x² + 7x + 12 = (x + 3)(x + 4)",
  difficulty: "Medium"
},
{
  id: 1943,
  subject: "Mathematics Knowledge",
  question: "If a right triangle has legs of 6 cm and 8 cm, what is the length of the hypotenuse?",
  answer: "10 cm\n\nUsing the Pythagorean theorem: a² + b² = c²\n6² + 8² = c²\n36 + 64 = c²\n100 = c²\nc = √100 = 10 cm",
  difficulty: "Medium"
},
{
  id: 1944,
  subject: "Mathematics Knowledge",
  question: "Simplify: (3x²)(4x³)",
  answer: "12x⁵\n\nMultiply coefficients and add exponents:\n3 × 4 = 12\nx² × x³ = x^(2+3) = x⁵\nResult: 12x⁵",
  difficulty: "Medium"
},
{
  id: 1945,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3(x - 4) = 2x + 5",
  answer: "x = 17\n\nSteps:\n1. Distribute: 3x - 12 = 2x + 5\n2. Subtract 2x from both sides: x - 12 = 5\n3. Add 12 to both sides: x = 17",
  difficulty: "Medium"
},
{
  id: 1946,
  subject: "Mathematics Knowledge",
  question: "What is the area of a trapezoid with bases 8 cm and 12 cm and height 5 cm?",
  answer: "50 square cm\n\nFormula: Area = (1/2)(b₁ + b₂)(h)\nArea = (1/2)(8 + 12)(5)\nArea = (1/2)(20)(5) = 50 square cm",
  difficulty: "Medium"
},
{
  id: 1947,
  subject: "Mathematics Knowledge",
  question: "Simplify: 15x⁴ ÷ 3x²",
  answer: "5x²\n\nDivide coefficients and subtract exponents:\n15 ÷ 3 = 5\nx⁴ ÷ x² = x^(4-2) = x²\nResult: 5x²",
  difficulty: "Medium"
},
{
  id: 1948,
  subject: "Mathematics Knowledge",
  question: "Solve for y: 5y - 8 = 2y + 10",
  answer: "y = 6\n\nSteps:\n1. Subtract 2y from both sides: 3y - 8 = 10\n2. Add 8 to both sides: 3y = 18\n3. Divide by 3: y = 6",
  difficulty: "Medium"
},
{
  id: 1949,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a cylinder with radius 3 cm and height 10 cm? (Use π ≈ 3.14)",
  answer: "282.6 cubic cm\n\nFormula: Volume = πr²h\nVolume = 3.14 × 3² × 10\nVolume = 3.14 × 9 × 10 = 282.6 cubic cm",
  difficulty: "Medium"
},
{
  id: 1950,
  subject: "Mathematics Knowledge",
  question: "Factor: x² - 9",
  answer: "(x + 3)(x - 3)\n\nThis is a difference of squares: a² - b² = (a + b)(a - b)\nx² - 9 = x² - 3² = (x + 3)(x - 3)",
  difficulty: "Medium"
},
{
  id: 1951,
  subject: "Mathematics Knowledge",
  question: "Simplify: (2x + 3) + (5x - 7)",
  answer: "7x - 4\n\nCombine like terms:\n2x + 5x = 7x\n3 - 7 = -4\nResult: 7x - 4",
  difficulty: "Medium"
},
{
  id: 1952,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x² = 49",
  answer: "x = ±7\n\nTake the square root of both sides:\nx = ±√49 = ±7\nSo x = 7 or x = -7",
  difficulty: "Medium"
},
{
  id: 1953,
  subject: "Mathematics Knowledge",
  question: "What is the distance between points (2, 3) and (6, 6) on a coordinate plane?",
  answer: "5 units\n\nUsing the distance formula: d = √[(x₂-x₁)² + (y₂-y₁)²]\nd = √[(6-2)² + (6-3)²]\nd = √[4² + 3²]\nd = √[16 + 9] = √25 = 5 units",
  difficulty: "Medium"
},
{
  id: 1954,
  subject: "Mathematics Knowledge",
  question: "Simplify: 3(2x - 5) + 4(x + 2)",
  answer: "10x - 7\n\nSteps:\n1. Distribute: 6x - 15 + 4x + 8\n2. Combine like terms: 10x - 7",
  difficulty: "Medium"
},
{
  id: 1955,
  subject: "Mathematics Knowledge",
  question: "What is the slope of a line passing through points (1, 2) and (5, 10)?",
  answer: "2\n\nFormula: slope (m) = (y₂ - y₁)/(x₂ - x₁)\nm = (10 - 2)/(5 - 1)\nm = 8/4 = 2",
  difficulty: "Medium"
},
{
  id: 1956,
  subject: "Mathematics Knowledge",
  question: "Factor: x² - 5x + 6",
  answer: "(x - 2)(x - 3)\n\nFind two numbers that multiply to 6 and add to -5:\n-2 and -3 work because (-2) × (-3) = 6 and (-2) + (-3) = -5\nTherefore: x² - 5x + 6 = (x - 2)(x - 3)",
  difficulty: "Medium"
},
{
  id: 1957,
  subject: "Mathematics Knowledge",
  question: "Solve for x: (x + 3)/4 = 5",
  answer: "x = 17\n\nSteps:\n1. Multiply both sides by 4: x + 3 = 20\n2. Subtract 3 from both sides: x = 17",
  difficulty: "Medium"
},
{
  id: 1958,
  subject: "Mathematics Knowledge",
  question: "What is the area of a parallelogram with base 9 cm and height 7 cm?",
  answer: "63 square cm\n\nFormula: Area = base × height\nArea = 9 × 7 = 63 square cm",
  difficulty: "Medium"
},
{
  id: 1959,
  subject: "Mathematics Knowledge",
  question: "Simplify: (x³)²",
  answer: "x⁶\n\nWhen raising a power to a power, multiply the exponents:\n(x³)² = x^(3×2) = x⁶",
  difficulty: "Medium"
},
{
  id: 1960,
  subject: "Mathematics Knowledge",
  question: "If two angles are supplementary and one angle measures 65°, what is the measure of the other angle?",
  answer: "115°\n\nSupplementary angles sum to 180°:\n180° - 65° = 115°",
  difficulty: "Medium"
},
{
  id: 1961,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 4x - 7 = 2x + 15",
  answer: "x = 11\n\nSteps:\n1. Subtract 2x from both sides: 2x - 7 = 15\n2. Add 7 to both sides: 2x = 22\n3. Divide by 2: x = 11",
  difficulty: "Medium"
},
{
  id: 1962,
  subject: "Mathematics Knowledge",
  question: "What is the surface area of a cube with side length 5 cm?",
  answer: "150 square cm\n\nFormula: Surface Area = 6 × side²\nSurface Area = 6 × 5² = 6 × 25 = 150 square cm",
  difficulty: "Medium"
},
{
  id: 1963,
  subject: "Mathematics Knowledge",
  question: "Simplify: (4x²y)(3xy³)",
  answer: "12x³y⁴\n\nMultiply coefficients and add exponents for like bases:\n4 × 3 = 12\nx² × x = x³\ny × y³ = y⁴\nResult: 12x³y⁴",
  difficulty: "Medium"
},
{
  id: 1964,
  subject: "Mathematics Knowledge",
  question: "Factor: 2x² + 8x",
  answer: "2x(x + 4)\n\nFactor out the greatest common factor (GCF):\nGCF = 2x\n2x² + 8x = 2x(x + 4)",
  difficulty: "Medium"
},
{
  id: 1965,
  subject: "Mathematics Knowledge",
  question: "If a right triangle has one leg of 5 cm and a hypotenuse of 13 cm, what is the length of the other leg?",
  answer: "12 cm\n\nUsing the Pythagorean theorem: a² + b² = c²\n5² + b² = 13²\n25 + b² = 169\nb² = 144\nb = √144 = 12 cm",
  difficulty: "Medium"
},
{
  id: 1966,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2(3x + 1) = 5(x - 2)",
  answer: "x = -12\n\nSteps:\n1. Distribute: 6x + 2 = 5x - 10\n2. Subtract 5x from both sides: x + 2 = -10\n3. Subtract 2 from both sides: x = -12",
  difficulty: "Medium"
},
{
  id: 1967,
  subject: "Mathematics Knowledge",
  question: "What is the value of x⁰ (where x ≠ 0)?",
  answer: "1\n\nAny non-zero number raised to the power of 0 equals 1.\nx⁰ = 1 (for x ≠ 0)",
  difficulty: "Medium"
},
{
  id: 1968,
  subject: "Mathematics Knowledge",
  question: "Simplify: 8x - 3(2x - 5)",
  answer: "2x + 15\n\nSteps:\n1. Distribute -3: 8x - 6x + 15\n2. Combine like terms: 2x + 15",
  difficulty: "Medium"
},
{
  id: 1969,
  subject: "Mathematics Knowledge",
  question: "If two angles are complementary and one angle measures 38°, what is the measure of the other angle?",
  answer: "52°\n\nComplementary angles sum to 90°:\n90° - 38° = 52°",
  difficulty: "Medium"
},
{
  id: 1970,
  subject: "Mathematics Knowledge",
  question: "What is the midpoint of the line segment connecting points (2, 4) and (8, 10)?",
  answer: "(5, 7)\n\nMidpoint formula: M = ((x₁+x₂)/2, (y₁+y₂)/2)\nM = ((2+8)/2, (4+10)/2)\nM = (10/2, 14/2) = (5, 7)",
  difficulty: "Medium"
},
{
  id: 1971,
  subject: "Mathematics Knowledge",
  question: "Factor: x² + 10x + 25",
  answer: "(x + 5)²\n\nThis is a perfect square trinomial:\nx² + 10x + 25 = (x + 5)(x + 5) = (x + 5)²",
  difficulty: "Medium"
},
{
  id: 1972,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x/3 + 2 = 7",
  answer: "x = 15\n\nSteps:\n1. Subtract 2 from both sides: x/3 = 5\n2. Multiply both sides by 3: x = 15",
  difficulty: "Medium"
},
{
  id: 1973,
  subject: "Mathematics Knowledge",
  question: "Simplify: √(16x⁴)",
  answer: "4x²\n\n√(16x⁴) = √16 × √(x⁴) = 4 × x² = 4x²",
  difficulty: "Medium"
},
{
  id: 1974,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a cone with radius 4 cm and height 9 cm? (Use π ≈ 3.14)",
  answer: "150.72 cubic cm\n\nFormula: Volume = (1/3)πr²h\nVolume = (1/3) × 3.14 × 4² × 9\nVolume = (1/3) × 3.14 × 16 × 9\nVolume = (1/3) × 452.16 = 150.72 cubic cm",
  difficulty: "Medium"
},
{
  id: 1975,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 5(2x - 3) = 3(x + 5)",
  answer: "x = 30/7 or approximately 4.29\n\nSteps:\n1. Distribute: 10x - 15 = 3x + 15\n2. Subtract 3x from both sides: 7x - 15 = 15\n3. Add 15 to both sides: 7x = 30\n4. Divide by 7: x = 30/7",
  difficulty: "Medium"
},
{
  id: 1976,
  subject: "Mathematics Knowledge",
  question: "What is the sum of the interior angles of a pentagon?",
  answer: "540°\n\nFormula: Sum = (n - 2) × 180° where n = number of sides\nSum = (5 - 2) × 180° = 3 × 180° = 540°",
  difficulty: "Medium"
},
{
  id: 1977,
  subject: "Mathematics Knowledge",
  question: "Simplify: (2x³y²)³",
  answer: "8x⁹y⁶\n\nRaise each factor to the third power:\n2³ = 8\n(x³)³ = x⁹\n(y²)³ = y⁶\nResult: 8x⁹y⁶",
  difficulty: "Medium"
},
{
  id: 1978,
  subject: "Mathematics Knowledge",
  question: "Factor: 3x² - 12",
  answer: "3(x + 2)(x - 2)\n\nSteps:\n1. Factor out GCF: 3(x² - 4)\n2. Factor difference of squares: 3(x + 2)(x - 2)",
  difficulty: "Medium"
},
{
  id: 1979,
  subject: "Mathematics Knowledge",
  question: "If a line has equation y = 3x - 5, what is the y-intercept?",
  answer: "-5\n\nIn the slope-intercept form y = mx + b, the y-intercept is b.\nTherefore, the y-intercept is -5.",
  difficulty: "Medium"
},
{
  id: 1980,
  subject: "Mathematics Knowledge",
  question: "Solve for x: |x - 3| = 7",
  answer: "x = 10 or x = -4\n\nThe absolute value equation splits into two cases:\nCase 1: x - 3 = 7, so x = 10\nCase 2: x - 3 = -7, so x = -4",
  difficulty: "Medium"
},
{
  id: 1981,
  subject: "Mathematics Knowledge",
  question: "Solve the system of equations: 2x + y = 10 and x - y = 2",
  answer: "x = 4, y = 2\n\nUsing elimination:\n1. Add the equations: (2x + y) + (x - y) = 10 + 2\n   3x = 12, so x = 4\n2. Substitute x = 4 into x - y = 2:\n   4 - y = 2, so y = 2",
  difficulty: "Hard"
},
{
  id: 1982,
  subject: "Mathematics Knowledge",
  question: "Factor completely: 2x³ + 8x² - 10x",
  answer: "2x(x + 5)(x - 1)\n\nSteps:\n1. Factor out GCF: 2x(x² + 4x - 5)\n2. Factor the trinomial: 2x(x + 5)(x - 1)",
  difficulty: "Hard"
},
{
  id: 1983,
  subject: "Mathematics Knowledge",
  question: "If the diagonal of a square is 10√2 cm, what is the area of the square?",
  answer: "100 square cm\n\nFor a square with side s, diagonal d = s√2\n10√2 = s√2\ns = 10 cm\nArea = s² = 10² = 100 square cm",
  difficulty: "Hard"
},
{
  id: 1984,
  subject: "Mathematics Knowledge",
  question: "Simplify: (3x² - 5x + 2) - (x² + 3x - 7)",
  answer: "2x² - 8x + 9\n\nDistribute the negative sign and combine like terms:\n3x² - 5x + 2 - x² - 3x + 7\n= (3x² - x²) + (-5x - 3x) + (2 + 7)\n= 2x² - 8x + 9",
  difficulty: "Hard"
},
{
  id: 1985,
  subject: "Mathematics Knowledge",
  question: "Solve for x: x² - 6x + 8 = 0",
  answer: "x = 2 or x = 4\n\nFactor: (x - 2)(x - 4) = 0\nSet each factor equal to 0:\nx - 2 = 0, so x = 2\nx - 4 = 0, so x = 4",
  difficulty: "Hard"
},
{
  id: 1986,
  subject: "Mathematics Knowledge",
  question: "What is the surface area of a cylinder with radius 5 cm and height 8 cm? (Use π ≈ 3.14)",
  answer: "408.2 square cm\n\nFormula: SA = 2πr² + 2πrh\nSA = 2(3.14)(5²) + 2(3.14)(5)(8)\nSA = 2(3.14)(25) + 2(3.14)(40)\nSA = 157 + 251.2 = 408.2 square cm",
  difficulty: "Hard"
},
{
  id: 1987,
  subject: "Mathematics Knowledge",
  question: "If f(x) = 2x² - 3x + 1, what is f(3)?",
  answer: "10\n\nSubstitute x = 3:\nf(3) = 2(3²) - 3(3) + 1\nf(3) = 2(9) - 9 + 1\nf(3) = 18 - 9 + 1 = 10",
  difficulty: "Hard"
},
{
  id: 1988,
  subject: "Mathematics Knowledge",
  question: "Simplify: (x² - 4)/(x + 2)",
  answer: "x - 2 (for x ≠ -2)\n\nFactor the numerator:\n(x² - 4)/(x + 2) = (x + 2)(x - 2)/(x + 2)\nCancel common factors: x - 2",
  difficulty: "Hard"
},
{
  id: 1989,
  subject: "Mathematics Knowledge",
  question: "What is the volume of a sphere with radius 6 cm? (Use π ≈ 3.14)",
  answer: "904.32 cubic cm\n\nFormula: Volume = (4/3)πr³\nVolume = (4/3)(3.14)(6³)\nVolume = (4/3)(3.14)(216)\nVolume = (4/3)(678.24) = 904.32 cubic cm",
  difficulty: "Hard"
},
{
  id: 1990,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 3x² = 48",
  answer: "x = ±4\n\nSteps:\n1. Divide both sides by 3: x² = 16\n2. Take square root: x = ±√16 = ±4\nSo x = 4 or x = -4",
  difficulty: "Hard"
},
{
  id: 1991,
  subject: "Mathematics Knowledge",
  question: "Factor: x² - 8x + 16",
  answer: "(x - 4)²\n\nThis is a perfect square trinomial:\nx² - 8x + 16 = (x - 4)(x - 4) = (x - 4)²",
  difficulty: "Hard"
},
{
  id: 1992,
  subject: "Mathematics Knowledge",
  question: "If a triangle has angles measuring 45°, 60°, and x°, what is the value of x?",
  answer: "75°\n\nThe sum of angles in a triangle is 180°:\n45° + 60° + x° = 180°\n105° + x° = 180°\nx° = 75°",
  difficulty: "Hard"
},
{
  id: 1993,
  subject: "Mathematics Knowledge",
  question: "Simplify: (2x + 3)(x - 5)",
  answer: "2x² - 7x - 15\n\nUsing FOIL method:\nFirst: 2x × x = 2x²\nOuter: 2x × (-5) = -10x\nInner: 3 × x = 3x\nLast: 3 × (-5) = -15\nCombine: 2x² - 10x + 3x - 15 = 2x² - 7x - 15",
  difficulty: "Hard"
},
{
  id: 1994,
  subject: "Mathematics Knowledge",
  question: "What is the area of a regular hexagon with side length 6 cm? (Use √3 ≈ 1.73)",
  answer: "93.42 square cm\n\nFormula: Area = (3√3/2) × side²\nArea = (3 × 1.73/2) × 6²\nArea = (5.19/2) × 36\nArea = 2.595 × 36 = 93.42 square cm",
  difficulty: "Hard"
},
{
  id: 1995,
  subject: "Mathematics Knowledge",
  question: "Solve for x: 2/(x-1) = 4/(x+3)",
  answer: "x = 5\n\nCross-multiply:\n2(x + 3) = 4(x - 1)\n2x + 6 = 4x - 4\n6 + 4 = 4x - 2x\n10 = 2x\nx = 5",
  difficulty: "Hard"
},
{
  id: 1996,
  subject: "Mathematics Knowledge",
  question: "If y varies directly with x and y = 12 when x = 4, what is y when x = 7?",
  answer: "y = 21\n\nDirect variation: y = kx\nFind k: 12 = k(4), so k = 3\nWhen x = 7: y = 3(7) = 21",
  difficulty: "Hard"
},
{
  id: 1997,
  subject: "Mathematics Knowledge",
  question: "Simplify: √(50x²y⁴)",
  answer: "5xy²√2\n\nBreak down the radical:\n√(50x²y⁴) = √(25 × 2 × x² × y⁴)\n= √25 × √2 × √(x²) × √(y⁴)\n= 5xy²√2",
  difficulty: "Hard"
},
{
  id: 1998,
  subject: "Mathematics Knowledge",
  question: "What is the equation of a line with slope 2 that passes through point (3, 5)?",
  answer: "y = 2x - 1\n\nUsing point-slope form: y - y₁ = m(x - x₁)\ny - 5 = 2(x - 3)\ny - 5 = 2x - 6\ny = 2x - 1",
  difficulty: "Hard"
},
{
  id: 1999,
  subject: "Mathematics Knowledge",
  question: "Factor: 4x² - 25",
  answer: "(2x + 5)(2x - 5)\n\nThis is a difference of squares: a² - b² = (a + b)(a - b)\n4x² - 25 = (2x)² - 5² = (2x + 5)(2x - 5)",
  difficulty: "Hard"
},
{
  id: 2000,
  subject: "Mathematics Knowledge",
  question: "If the perimeter of a rectangle is 48 cm and the length is 3 times the width, what is the area?",
  answer: "108 square cm\n\nLet width = w, then length = 3w\nPerimeter: 2(w + 3w) = 48\n8w = 48, so w = 6 cm\nLength = 3(6) = 18 cm\nArea = 6 × 18 = 108 square cm",
  difficulty: "Hard"
},
{
  id: 2001,
  subject: "General Science",
  question: "What is the basic unit of life?",
  answer: "The cell. All living organisms are made up of one or more cells, which are the smallest units that can carry out all life processes.",
  difficulty: "Easy"
},
{
  id: 2002,
  subject: "General Science",
  question: "What is the powerhouse of the cell?",
  answer: "The mitochondria. Mitochondria produce ATP (adenosine triphosphate) through cellular respiration, providing energy for the cell's activities.",
  difficulty: "Easy"
},
{
  id: 2003,
  subject: "General Science",
  question: "How many bones are in the adult human body?",
  answer: "206 bones. Babies are born with about 270 bones, but many fuse together as the body matures, resulting in 206 bones in adults.",
  difficulty: "Easy"
},
{
  id: 2004,
  subject: "General Science",
  question: "What type of blood cells fight infection?",
  answer: "White blood cells (leukocytes). They are part of the immune system and help defend the body against bacteria, viruses, and other pathogens.",
  difficulty: "Easy"
},
{
  id: 2005,
  subject: "General Science",
  question: "What gas do plants absorb from the atmosphere during photosynthesis?",
  answer: "Carbon dioxide (CO2). Plants use carbon dioxide, water, and sunlight to produce glucose and oxygen during photosynthesis.",
  difficulty: "Easy"
},
{
  id: 2006,
  subject: "General Science",
  question: "What is the largest organ in the human body?",
  answer: "The skin. It covers the entire body, protects internal organs, regulates temperature, and provides sensory information.",
  difficulty: "Easy"
},
{
  id: 2007,
  subject: "General Science",
  question: "What are the three states of matter?",
  answer: "Solid, liquid, and gas. Matter can exist in these three common states, which differ in how tightly particles are packed and how freely they move.",
  difficulty: "Easy"
},
{
  id: 2008,
  subject: "General Science",
  question: "What is the chemical symbol for water?",
  answer: "H2O. Water molecules consist of two hydrogen atoms bonded to one oxygen atom.",
  difficulty: "Easy"
},
{
  id: 2009,
  subject: "General Science",
  question: "What force pulls objects toward Earth?",
  answer: "Gravity. Gravity is the force of attraction between objects with mass, pulling everything toward the Earth's center.",
  difficulty: "Easy"
},
{
  id: 2010,
  subject: "General Science",
  question: "What is the closest star to Earth?",
  answer: "The Sun. It is approximately 93 million miles away and provides light and heat essential for life on Earth.",
  difficulty: "Easy"
},
{
  id: 2011,
  subject: "General Science",
  question: "What is DNA?",
  answer: "Deoxyribonucleic acid. DNA is the molecule that carries genetic information and instructions for growth, development, and reproduction in all living organisms.",
  difficulty: "Easy"
},
{
  id: 2012,
  subject: "General Science",
  question: "What is the hardest natural substance on Earth?",
  answer: "Diamond. Diamonds are composed of carbon atoms arranged in an extremely strong crystal structure, making them the hardest known natural material.",
  difficulty: "Easy"
},
{
  id: 2013,
  subject: "General Science",
  question: "What is the boiling point of water at sea level?",
  answer: "100 degrees Celsius (212 degrees Fahrenheit). At this temperature and standard atmospheric pressure, water changes from liquid to gas.",
  difficulty: "Easy"
},
{
  id: 2014,
  subject: "General Science",
  question: "What is the center of an atom called?",
  answer: "The nucleus. The nucleus contains protons and neutrons, while electrons orbit around it in electron shells.",
  difficulty: "Easy"
},
{
  id: 2015,
  subject: "General Science",
  question: "What type of animal is a frog?",
  answer: "An amphibian. Amphibians are cold-blooded vertebrates that typically live both in water and on land during different life stages.",
  difficulty: "Easy"
},
{
  id: 2016,
  subject: "General Science",
  question: "What is the main gas in Earth's atmosphere?",
  answer: "Nitrogen. Approximately 78% of Earth's atmosphere is nitrogen, with oxygen making up about 21%.",
  difficulty: "Easy"
},
{
  id: 2017,
  subject: "General Science",
  question: "What organ pumps blood throughout the body?",
  answer: "The heart. The heart is a muscular organ that pumps blood through the circulatory system, delivering oxygen and nutrients to tissues.",
  difficulty: "Easy"
},
{
  id: 2018,
  subject: "General Science",
  question: "What is the freezing point of water?",
  answer: "0 degrees Celsius (32 degrees Fahrenheit). At this temperature, water changes from liquid to solid (ice) at standard atmospheric pressure.",
  difficulty: "Easy"
},
{
  id: 2019,
  subject: "General Science",
  question: "What is the process by which plants make food?",
  answer: "Photosynthesis. Plants use sunlight, carbon dioxide, and water to produce glucose (food) and oxygen.",
  difficulty: "Easy"
},
{
  id: 2020,
  subject: "General Science",
  question: "What is the speed of light?",
  answer: "Approximately 186,000 miles per second (or 300,000 kilometers per second). This is the fastest speed possible in the universe.",
  difficulty: "Easy"
},
{
  id: 2021,
  subject: "General Science",
  question: "What are organisms that break down dead matter called?",
  answer: "Decomposers. Examples include bacteria and fungi, which break down dead plants and animals, returning nutrients to the ecosystem.",
  difficulty: "Easy"
},
{
  id: 2022,
  subject: "General Science",
  question: "What is the chemical symbol for oxygen?",
  answer: "O. Oxygen is element number 8 on the periodic table and is essential for respiration in most living organisms.",
  difficulty: "Easy"
},
{
  id: 2023,
  subject: "General Science",
  question: "How many chambers does the human heart have?",
  answer: "Four chambers: two atria (upper chambers) and two ventricles (lower chambers). This structure allows for efficient separation of oxygenated and deoxygenated blood.",
  difficulty: "Easy"
},
{
  id: 2024,
  subject: "General Science",
  question: "What is the study of weather called?",
  answer: "Meteorology. Meteorologists study atmospheric conditions to understand and predict weather patterns.",
  difficulty: "Easy"
},
{
  id: 2025,
  subject: "General Science",
  question: "What is the largest planet in our solar system?",
  answer: "Jupiter. It is a gas giant with a mass more than twice that of all other planets combined.",
  difficulty: "Easy"
},
{
  id: 2026,
  subject: "General Science",
  question: "What particle in an atom has a negative charge?",
  answer: "Electrons. Electrons orbit the nucleus and have a negative charge, while protons have a positive charge and neutrons have no charge.",
  difficulty: "Easy"
},
{
  id: 2027,
  subject: "General Science",
  question: "What is the process of water changing from liquid to gas called?",
  answer: "Evaporation. This occurs when water molecules gain enough energy to break free from the liquid surface and become water vapor.",
  difficulty: "Easy"
},
{
  id: 2028,
  subject: "General Science",
  question: "What type of rock is formed from cooled lava or magma?",
  answer: "Igneous rock. Examples include granite (formed underground) and basalt (formed from lava at the surface).",
  difficulty: "Easy"
},
{
  id: 2029,
  subject: "General Science",
  question: "What is the basic unit of heredity?",
  answer: "The gene. Genes are segments of DNA that contain instructions for specific traits and are passed from parents to offspring.",
  difficulty: "Easy"
},
{
  id: 2030,
  subject: "General Science",
  question: "What is Newton's First Law of Motion?",
  answer: "An object at rest stays at rest, and an object in motion stays in motion at constant velocity unless acted upon by an unbalanced force. This is also called the law of inertia.",
  difficulty: "Easy"
},
{
  id: 2031,
  subject: "General Science",
  question: "What is the main function of red blood cells?",
  answer: "To carry oxygen from the lungs to body tissues and return carbon dioxide to the lungs. Red blood cells contain hemoglobin, which binds to oxygen.",
  difficulty: "Easy"
},
{
  id: 2032,
  subject: "General Science",
  question: "What is the pH of pure water?",
  answer: "7. A pH of 7 is neutral, meaning the substance is neither acidic (pH below 7) nor basic/alkaline (pH above 7).",
  difficulty: "Easy"
},
{
  id: 2033,
  subject: "General Science",
  question: "What is the smallest bone in the human body?",
  answer: "The stapes (or stirrup bone) in the middle ear. It is about 2-3 millimeters long and helps transmit sound vibrations.",
  difficulty: "Easy"
},
{
  id: 2034,
  subject: "General Science",
  question: "What is an animal that eats only plants called?",
  answer: "An herbivore. Examples include deer, rabbits, and cows. Animals that eat only meat are carnivores, and those that eat both are omnivores.",
  difficulty: "Easy"
},
{
  id: 2035,
  subject: "General Science",
  question: "What is the chemical formula for table salt?",
  answer: "NaCl (sodium chloride). It is composed of one sodium atom bonded to one chlorine atom.",
  difficulty: "Easy"
},
{
  id: 2036,
  subject: "General Science",
  question: "What is the Earth's innermost layer called?",
  answer: "The inner core. It is primarily composed of solid iron and nickel and has extremely high temperatures and pressures.",
  difficulty: "Easy"
},
{
  id: 2037,
  subject: "General Science",
  question: "What is the function of the lungs?",
  answer: "To exchange gases: taking in oxygen from the air and releasing carbon dioxide from the blood. This process is called respiration.",
  difficulty: "Easy"
},
{
  id: 2038,
  subject: "General Science",
  question: "What is the atomic number of an element?",
  answer: "The number of protons in an atom's nucleus. The atomic number determines the element's identity and its position on the periodic table.",
  difficulty: "Easy"
},
{
  id: 2039,
  subject: "General Science",
  question: "What is the largest type of blood vessel?",
  answer: "The aorta. It is the main artery that carries oxygenated blood from the left ventricle of the heart to the rest of the body.",
  difficulty: "Easy"
},
{
  id: 2040,
  subject: "General Science",
  question: "What are the building blocks of proteins?",
  answer: "Amino acids. There are 20 different amino acids that combine in various sequences to form the thousands of different proteins in living organisms.",
  difficulty: "Easy"
},
{
  id: 2041,
  subject: "General Science",
  question: "What is the control center of the cell?",
  answer: "The nucleus. It contains the cell's genetic material (DNA) and controls cell activities by regulating gene expression.",
  difficulty: "Medium"
},
{
  id: 2042,
  subject: "General Science",
  question: "What is the difference between mitosis and meiosis?",
  answer: "Mitosis produces two identical daughter cells with the same number of chromosomes as the parent cell (for growth and repair). Meiosis produces four sex cells (gametes) with half the chromosomes (for reproduction).",
  difficulty: "Medium"
},
{
  id: 2043,
  subject: "General Science",
  question: "What is the role of chlorophyll in photosynthesis?",
  answer: "Chlorophyll is a green pigment that absorbs light energy (mainly red and blue wavelengths) from the sun, which is then used to convert carbon dioxide and water into glucose.",
  difficulty: "Medium"
},
{
  id: 2044,
  subject: "General Science",
  question: "What is the difference between arteries and veins?",
  answer: "Arteries carry oxygenated blood away from the heart to the body (except pulmonary arteries). Veins carry deoxygenated blood back to the heart (except pulmonary veins). Arteries have thicker, more elastic walls.",
  difficulty: "Medium"
},
{
  id: 2045,
  subject: "General Science",
  question: "What is the function of the ribosomes in a cell?",
  answer: "Ribosomes are the sites of protein synthesis. They read mRNA (messenger RNA) and assemble amino acids into proteins according to the genetic instructions.",
  difficulty: "Medium"
},
{
  id: 2046,
  subject: "General Science",
  question: "What is the difference between ionic and covalent bonds?",
  answer: "Ionic bonds form when electrons are transferred from one atom to another, creating charged ions that attract each other. Covalent bonds form when atoms share electrons. Ionic bonds typically occur between metals and nonmetals, while covalent bonds occur between nonmetals.",
  difficulty: "Medium"
},
{
  id: 2047,
  subject: "General Science",
  question: "What is the function of the cerebellum?",
  answer: "The cerebellum coordinates voluntary muscle movements, maintains balance and posture, and helps with motor learning. It is located at the back of the brain below the cerebrum.",
  difficulty: "Medium"
},
{
  id: 2048,
  subject: "General Science",
  question: "What is the difference between weather and climate?",
  answer: "Weather refers to short-term atmospheric conditions (temperature, precipitation, wind) in a specific area over hours or days. Climate refers to the long-term average weather patterns in a region over many years or decades.",
  difficulty: "Medium"
},
{
  id: 2049,
  subject: "General Science",
  question: "What is the law of conservation of energy?",
  answer: "Energy cannot be created or destroyed, only transformed from one form to another. The total amount of energy in a closed system remains constant.",
  difficulty: "Medium"
},
{
  id: 2050,
  subject: "General Science",
  question: "What is the difference between exothermic and endothermic reactions?",
  answer: "Exothermic reactions release energy (usually as heat) to the surroundings, making them feel warm. Endothermic reactions absorb energy from the surroundings, making them feel cold. Examples: combustion is exothermic, photosynthesis is endothermic.",
  difficulty: "Medium"
},
{
  id: 2051,
  subject: "General Science",
  question: "What is the role of the pancreas in digestion?",
  answer: "The pancreas produces digestive enzymes that break down carbohydrates, proteins, and fats in the small intestine. It also produces hormones like insulin and glucagon to regulate blood sugar levels.",
  difficulty: "Medium"
},
{
  id: 2052,
  subject: "General Science",
  question: "What are isotopes?",
  answer: "Isotopes are atoms of the same element that have the same number of protons but different numbers of neutrons. This gives them different atomic masses but the same chemical properties.",
  difficulty: "Medium"
},
{
  id: 2053,
  subject: "General Science",
  question: "What is the difference between dominant and recessive genes?",
  answer: "Dominant genes are expressed even if only one copy is present (represented by capital letters). Recessive genes are only expressed when two copies are present (represented by lowercase letters). For example, brown eyes (B) are dominant over blue eyes (b).",
  difficulty: "Medium"
},
{
  id: 2054,
  subject: "General Science",
  question: "What is Newton's Second Law of Motion?",
  answer: "Force equals mass times acceleration (F = ma). This means the acceleration of an object depends on the force applied and the object's mass. Greater force produces greater acceleration, while greater mass produces less acceleration for the same force.",
  difficulty: "Medium"
},
{
  id: 2055,
  subject: "General Science",
  question: "What is the function of the nephron in the kidney?",
  answer: "The nephron is the functional unit of the kidney that filters blood, removes waste products, and regulates water and electrolyte balance. It produces urine through filtration, reabsorption, and secretion.",
  difficulty: "Medium"
},
{
  id: 2056,
  subject: "General Science",
  question: "What is the difference between potential and kinetic energy?",
  answer: "Potential energy is stored energy due to an object's position or condition (like a raised object or compressed spring). Kinetic energy is the energy of motion. As an object falls, potential energy converts to kinetic energy.",
  difficulty: "Medium"
},
{
  id: 2057,
  subject: "General Science",
  question: "What causes the phases of the Moon?",
  answer: "The Moon's phases are caused by the changing relative positions of the Moon, Earth, and Sun. As the Moon orbits Earth, different portions of its illuminated half face Earth, creating the appearance of changing shapes from new moon to full moon.",
  difficulty: "Medium"
},
{
  id: 2058,
  subject: "General Science",
  question: "What is the difference between aerobic and anaerobic respiration?",
  answer: "Aerobic respiration uses oxygen to break down glucose, producing 36-38 ATP molecules, water, and carbon dioxide. Anaerobic respiration occurs without oxygen, producing only 2 ATP molecules and lactic acid (in animals) or ethanol (in yeast).",
  difficulty: "Medium"
},
{
  id: 2059,
  subject: "General Science",
  question: "What is the role of white blood cells in the immune system?",
  answer: "White blood cells defend against pathogens through various mechanisms: phagocytes engulf and destroy invaders, lymphocytes produce antibodies and coordinate immune responses, and some white blood cells remember previous infections for faster future responses.",
  difficulty: "Medium"
},
{
  id: 2060,
  subject: "General Science",
  question: "What is the rock cycle?",
  answer: "The rock cycle describes how rocks transform between three types: igneous (from cooled magma/lava), sedimentary (from compressed sediments), and metamorphic (from heat/pressure changing existing rocks). Each type can be transformed into the others through geological processes.",
  difficulty: "Medium"
},
{
  id: 2061,
  subject: "General Science",
  question: "What is the difference between transverse and longitudinal waves?",
  answer: "In transverse waves, particles vibrate perpendicular to the wave's direction of travel (like water waves or light). In longitudinal waves, particles vibrate parallel to the wave's direction (like sound waves). Both transfer energy without permanently moving matter.",
  difficulty: "Medium"
},
{
  id: 2062,
  subject: "General Science",
  question: "What is the role of enzymes in chemical reactions?",
  answer: "Enzymes are biological catalysts that speed up chemical reactions by lowering the activation energy required. They are not consumed in the reaction and can be reused. Each enzyme is specific to a particular substrate (lock-and-key model).",
  difficulty: "Medium"
},
{
  id: 2063,
  subject: "General Science",
  question: "What causes seasons on Earth?",
  answer: "Seasons are caused by Earth's tilted axis (23.5 degrees) as it orbits the Sun. When the Northern Hemisphere tilts toward the Sun, it receives more direct sunlight and experiences summer, while the Southern Hemisphere experiences winter, and vice versa.",
  difficulty: "Medium"
},
{
  id: 2064,
  subject: "General Science",
  question: "What is the difference between mass and weight?",
  answer: "Mass is the amount of matter in an object and remains constant everywhere (measured in kilograms or grams). Weight is the force of gravity on an object and varies with gravitational strength (measured in newtons or pounds). Weight = mass × gravity.",
  difficulty: "Medium"
},
{
  id: 2065,
  subject: "General Science",
  question: "What is the function of the Golgi apparatus?",
  answer: "The Golgi apparatus modifies, packages, and sorts proteins and lipids received from the endoplasmic reticulum. It prepares these molecules for transport to their final destinations inside or outside the cell.",
  difficulty: "Medium"
},
{
  id: 2066,
  subject: "General Science",
  question: "What is the water cycle?",
  answer: "The water cycle describes how water moves through Earth's systems: evaporation (liquid to gas), condensation (gas to liquid forming clouds), precipitation (rain/snow), collection in bodies of water, and transpiration from plants. This cycle continuously recycles Earth's water.",
  difficulty: "Medium"
},
{
  id: 2067,
  subject: "General Science",
  question: "What is the difference between acids and bases?",
  answer: "Acids have a pH below 7, taste sour, and release hydrogen ions (H+) in solution. Bases have a pH above 7, taste bitter, feel slippery, and release hydroxide ions (OH-) in solution. When mixed, they neutralize each other, forming water and a salt.",
  difficulty: "Medium"
},
{
  id: 2068,
  subject: "General Science",
  question: "What is the function of hemoglobin?",
  answer: "Hemoglobin is an iron-containing protein in red blood cells that binds to oxygen in the lungs and transports it to body tissues. It also helps carry carbon dioxide back to the lungs for exhalation. Its iron gives blood its red color.",
  difficulty: "Medium"
},
{
  id: 2069,
  subject: "General Science",
  question: "What causes thunder and lightning?",
  answer: "Lightning is an electrical discharge caused by the buildup of positive and negative charges in storm clouds. When the charge difference becomes large enough, electricity flows between clouds or from clouds to ground. Thunder is the sound created by rapidly expanding air heated by the lightning.",
  difficulty: "Medium"
},
{
  id: 2070,
  subject: "General Science",
  question: "What is the difference between renewable and nonrenewable resources?",
  answer: "Renewable resources can be naturally replenished on a human timescale (solar, wind, water, biomass). Nonrenewable resources are finite and cannot be replaced once used (fossil fuels, minerals, nuclear fuels). Renewable resources are more sustainable.",
  difficulty: "Medium"
},
{
  id: 2071,
  subject: "General Science",
  question: "What is the role of the myelin sheath in neurons?",
  answer: "The myelin sheath is a fatty insulating layer around nerve fibers (axons) that increases the speed of electrical signal transmission. It acts like insulation on electrical wires, allowing signals to jump between gaps (nodes of Ranvier) in a process called saltatory conduction.",
  difficulty: "Medium"
},
{
  id: 2072,
  subject: "General Science",
  question: "What is Ohm's Law?",
  answer: "Ohm's Law states that voltage (V) equals current (I) times resistance (R), written as V = IR. This describes the relationship between electrical voltage, current, and resistance in a circuit. Higher resistance reduces current flow for a given voltage.",
  difficulty: "Medium"
},
{
  id: 2073,
  subject: "General Science",
  question: "What is the function of the stomata in plant leaves?",
  answer: "Stomata are small pores on leaf surfaces that regulate gas exchange. They allow carbon dioxide to enter for photosynthesis and oxygen to exit. They also release water vapor through transpiration and can close to prevent water loss during dry conditions.",
  difficulty: "Medium"
},
{
  id: 2074,
  subject: "General Science",
  question: "What is the difference between genotype and phenotype?",
  answer: "Genotype is an organism's genetic makeup (the actual genes it carries), while phenotype is the observable physical characteristics resulting from both genes and environmental factors. For example, genotype might be Bb for eye color, while phenotype is brown eyes.",
  difficulty: "Medium"
},
{
  id: 2075,
  subject: "General Science",
  question: "What causes tides on Earth?",
  answer: "Tides are caused primarily by the Moon's gravitational pull on Earth's oceans, with a smaller contribution from the Sun. The Moon pulls water toward it, creating a high tide, while another high tide occurs on the opposite side due to inertia. Two high and two low tides occur daily.",
  difficulty: "Medium"
},
{
  id: 2076,
  subject: "General Science",
  question: "What is the function of the endoplasmic reticulum?",
  answer: "The endoplasmic reticulum (ER) is a network of membranes for protein and lipid synthesis. Rough ER has ribosomes and produces proteins for export. Smooth ER lacks ribosomes and synthesizes lipids, metabolizes carbohydrates, and detoxifies substances.",
  difficulty: "Medium"
},
{
  id: 2077,
  subject: "General Science",
  question: "What is the electromagnetic spectrum?",
  answer: "The electromagnetic spectrum includes all types of electromagnetic radiation arranged by wavelength and frequency: radio waves, microwaves, infrared, visible light, ultraviolet, X-rays, and gamma rays. Visible light is only a small portion of the spectrum.",
  difficulty: "Medium"
},
{
  id: 2078,
  subject: "General Science",
  question: "What is the difference between weathering and erosion?",
  answer: "Weathering is the breaking down of rocks into smaller pieces by physical (freeze-thaw, temperature changes) or chemical (oxidation, acid rain) processes at or near the surface. Erosion is the transportation of weathered material by wind, water, ice, or gravity to new locations.",
  difficulty: "Medium"
},
{
  id: 2079,
  subject: "General Science",
  question: "What is natural selection?",
  answer: "Natural selection is the process by which organisms with traits better suited to their environment are more likely to survive, reproduce, and pass those traits to offspring. Over time, this leads to evolutionary changes in populations as advantageous traits become more common.",
  difficulty: "Medium"
},
{
  id: 2080,
  subject: "General Science",
  question: "What is the function of platelets in blood?",
  answer: "Platelets (thrombocytes) are cell fragments that help blood clot. When a blood vessel is damaged, platelets stick together at the injury site and release chemicals that activate clotting factors, forming a plug that stops bleeding and allows healing.",
  difficulty: "Medium"
},
{
  id: 2081,
  subject: "General Science",
  question: "Explain the difference between homozygous and heterozygous genotypes.",
  answer: "Homozygous means having two identical alleles for a trait (AA or aa), resulting in a predictable phenotype. Heterozygous means having two different alleles (Aa), where the dominant allele typically determines the phenotype. Homozygous organisms breed true, while heterozygous can produce varied offspring.",
  difficulty: "Hard"
},
{
  id: 2082,
  subject: "General Science",
  question: "What is the electron transport chain and where does it occur?",
  answer: "The electron transport chain is the final stage of cellular respiration occurring in the inner mitochondrial membrane. It uses electrons from NADH and FADH2 to pump protons across the membrane, creating a gradient that drives ATP synthase to produce about 34 ATP molecules through oxidative phosphorylation.",
  difficulty: "Hard"
},
{
  id: 2083,
  subject: "General Science",
  question: "Explain the concept of half-life in radioactive decay.",
  answer: "Half-life is the time required for half of a radioactive substance to decay into another element or isotope. It is constant for each radioactive isotope and independent of amount, temperature, or pressure. For example, Carbon-14 has a half-life of 5,730 years, making it useful for dating organic materials.",
  difficulty: "Hard"
},
{
  id: 2084,
  subject: "General Science",
  question: "What is the Hardy-Weinberg equilibrium and what does it predict?",
  answer: "The Hardy-Weinberg equilibrium predicts that allele and genotype frequencies remain constant in a population from generation to generation if five conditions are met: no mutations, random mating, no gene flow, infinite population size, and no natural selection. It provides a baseline to measure evolutionary changes.",
  difficulty: "Hard"
},
{
  id: 2085,
  subject: "General Science",
  question: "Explain the difference between convergent and divergent evolution.",
  answer: "Convergent evolution occurs when unrelated species develop similar traits due to similar environmental pressures (e.g., wings in birds and bats). Divergent evolution occurs when related species develop different traits due to different environments (e.g., Darwin's finches with different beak shapes for different food sources).",
  difficulty: "Hard"
},
{
  id: 2086,
  subject: "General Science",
  question: "What is the Doppler effect and how does it apply to light and sound?",
  answer: "The Doppler effect is the change in wave frequency due to relative motion between source and observer. For sound, it causes pitch changes (ambulance siren). For light, it causes redshift (moving away) or blueshift (moving toward). Astronomers use redshift to determine that distant galaxies are moving away, supporting the expanding universe theory.",
  difficulty: "Hard"
},
{
  id: 2087,
  subject: "General Science",
  question: "Describe the electron configuration of oxygen and explain its valence.",
  answer: "Oxygen has 8 electrons with configuration 1s² 2s² 2p⁴. It has 6 valence electrons in its outer shell and needs 2 more to complete its octet, making it highly reactive and typically forming 2 covalent bonds (as in H2O) or gaining 2 electrons to form O²⁻ ions.",
  difficulty: "Hard"
},
{
  id: 2088,
  subject: "General Science",
  question: "What is the difference between voltage, current, and resistance in electrical circuits?",
  answer: "Voltage (V) is electrical potential difference or pressure, measured in volts, that pushes electrons. Current (I) is the flow rate of electrons, measured in amperes. Resistance (R) opposes current flow, measured in ohms. They relate through Ohm's Law (V=IR). Think of water analogy: voltage is pressure, current is flow rate, resistance is pipe friction.",
  difficulty: "Hard"
},
{
  id: 2089,
  subject: "General Science",
  question: "Explain the concept of oxidation-reduction (redox) reactions.",
  answer: "Redox reactions involve electron transfer between substances. Oxidation is loss of electrons (OIL: Oxidation Is Loss), while reduction is gain of electrons (RIG: Reduction Is Gain). These always occur together: one substance is oxidized while another is reduced. Example: in rusting, iron loses electrons (oxidized) while oxygen gains them (reduced).",
  difficulty: "Hard"
},
{
  id: 2090,
  subject: "General Science",
  question: "What is the relationship between pressure and volume in gases (Boyle's Law)?",
  answer: "Boyle's Law states that for a fixed amount of gas at constant temperature, pressure and volume are inversely proportional: P₁V₁ = P₂V₂. When volume decreases, pressure increases proportionally, and vice versa. This explains why compressing a gas in a syringe requires more force and why deep-sea divers must decompress slowly.",
  difficulty: "Hard"
},
{
  id: 2091,
  subject: "General Science",
  question: "Explain the structure and function of ATP in cellular energy transfer.",
  answer: "ATP (adenosine triphosphate) is the cell's energy currency. It consists of adenine, ribose sugar, and three phosphate groups. Energy is stored in high-energy bonds between phosphates. When the terminal phosphate is removed (ATP → ADP + P + energy), about 7.3 kcal/mol is released to power cellular processes. ATP is constantly regenerated through cellular respiration.",
  difficulty: "Hard"
},
{
  id: 2092,
  subject: "General Science",
  question: "What is the difference between the sympathetic and parasympathetic nervous systems?",
  answer: "The sympathetic nervous system activates 'fight or flight' responses: increases heart rate, dilates pupils, releases adrenaline, decreases digestion. The parasympathetic system activates 'rest and digest': decreases heart rate, constricts pupils, increases digestion. They are complementary divisions of the autonomic nervous system that maintain homeostasis.",
  difficulty: "Hard"
},
{
  id: 2093,
  subject: "General Science",
  question: "Explain the concept of specific heat capacity and its significance for water.",
  answer: "Specific heat capacity is the energy required to raise one gram of a substance by 1°C. Water has an unusually high specific heat (4.18 J/g°C) due to hydrogen bonding, meaning it resists temperature change. This moderates Earth's climate, regulates body temperature, and allows aquatic life to survive temperature fluctuations.",
  difficulty: "Hard"
},
{
  id: 2094,
  subject: "General Science",
  question: "What is the Krebs cycle and what is its role in cellular respiration?",
  answer: "The Krebs cycle (citric acid cycle) is the second stage of cellular respiration occurring in the mitochondrial matrix. It completes the breakdown of glucose-derived pyruvate, producing 2 ATP, 6 NADH, and 2 FADH2 per glucose molecule. These electron carriers then fuel the electron transport chain for maximum ATP production.",
  difficulty: "Hard"
},
{
  id: 2095,
  subject: "General Science",
  question: "Explain the concept of limiting factors in population growth.",
  answer: "Limiting factors are environmental conditions that restrict population growth when they fall below minimum requirements or exceed maximum tolerances. Density-dependent factors (competition, predation, disease) increase with population density. Density-independent factors (weather, natural disasters) affect populations regardless of density. These factors determine carrying capacity.",
  difficulty: "Hard"
},
{
  id: 2096,
  subject: "General Science",
  question: "What is the difference between series and parallel circuits?",
  answer: "In series circuits, components are connected end-to-end in one path; current is constant but voltage divides among components. If one component fails, the circuit breaks. In parallel circuits, components have separate paths; voltage is constant but current divides. If one component fails, others continue working. Home wiring uses parallel circuits.",
  difficulty: "Hard"
},
{
  id: 2097,
  subject: "General Science",
  question: "Explain the process of protein synthesis from DNA to protein.",
  answer: "Protein synthesis has two stages: 1) Transcription: DNA unzips, RNA polymerase reads the template strand and creates complementary mRNA, which exits the nucleus. 2) Translation: mRNA attaches to a ribosome, tRNA molecules bring amino acids matching the mRNA codons (3-base sequences), and amino acids link to form a polypeptide chain that folds into a functional protein.",
  difficulty: "Hard"
},
{
  id: 2098,
  subject: "General Science",
  question: "What is the principle of superposition in geology and its application?",
  answer: "The principle of superposition states that in undisturbed sedimentary rock layers, the oldest layers are at the bottom and youngest at the top. This allows geologists to determine relative ages of rocks and fossils. However, geological events like folding, faulting, and intrusions can disrupt this pattern and must be carefully analyzed.",
  difficulty: "Hard"
},
{
  id: 2099,
  subject: "General Science",
  question: "Explain Le Chatelier's principle in chemical equilibrium.",
  answer: "Le Chatelier's principle states that when stress is applied to a system at equilibrium, the system shifts to counteract the stress and restore equilibrium. Stresses include concentration changes (shifts away from added substance), temperature changes (shifts toward endothermic for heat added), and pressure changes (shifts toward fewer gas molecules for pressure increase).",
  difficulty: "Hard"
},
{
  id: 2100,
  subject: "General Science",
  question: "What is the role of RNA polymerase in gene expression and how is it regulated?",
  answer: "RNA polymerase is the enzyme that synthesizes mRNA from DNA during transcription. It binds to promoter regions on DNA, unwinds the double helix, and builds complementary RNA. Regulation occurs through transcription factors that enhance or inhibit RNA polymerase binding, allowing cells to control which genes are expressed and when, enabling cellular differentiation and response to environment.",
  difficulty: "Hard"
},
{
  id: 2101,
  subject: "Arithmetic Reasoning",
  question: "A military convoy travels 240 miles in 4 hours. What is the average speed of the convoy?",
  answer: "Speed = Distance / Time\nSpeed = 240 miles / 4 hours = 60 miles per hour",
  difficulty: "Easy"
},
{
  id: 2102,
  subject: "Arithmetic Reasoning",
  question: "If a soldier can do 45 push-ups in 60 seconds, how many push-ups can he do in 20 seconds at the same rate?",
  answer: "Rate = 45 push-ups / 60 seconds = 0.75 push-ups per second\nIn 20 seconds: 0.75 × 20 = 15 push-ups",
  difficulty: "Easy"
},
{
  id: 2103,
  subject: "Arithmetic Reasoning",
  question: "A store offers a 25% discount on a jacket that originally costs $80. What is the sale price?",
  answer: "Discount amount = 25% of $80 = 0.25 × $80 = $20\nSale price = $80 - $20 = $60",
  difficulty: "Easy"
},
{
  id: 2104,
  subject: "Arithmetic Reasoning",
  question: "If 3 pounds of apples cost $6, how much would 7 pounds cost at the same rate?",
  answer: "Unit price = $6 / 3 pounds = $2 per pound\nCost for 7 pounds = $2 × 7 = $14",
  difficulty: "Easy"
},
{
  id: 2105,
  subject: "Arithmetic Reasoning",
  question: "A recipe calls for 2 cups of flour to make 12 cookies. How many cups of flour are needed to make 30 cookies?",
  answer: "Set up proportion: 2/12 = x/30\nCross multiply: 12x = 60\nx = 60/12 = 5 cups of flour",
  difficulty: "Easy"
},
{
  id: 2106,
  subject: "Arithmetic Reasoning",
  question: "Convert 5 feet 6 inches to inches.",
  answer: "1 foot = 12 inches\n5 feet = 5 × 12 = 60 inches\nTotal = 60 + 6 = 66 inches",
  difficulty: "Easy"
},
{
  id: 2107,
  subject: "Arithmetic Reasoning",
  question: "A soldier runs 2 miles in 16 minutes. At this pace, how long would it take to run 5 miles?",
  answer: "Rate = 16 minutes / 2 miles = 8 minutes per mile\nTime for 5 miles = 8 × 5 = 40 minutes",
  difficulty: "Easy"
},
{
  id: 2108,
  subject: "Arithmetic Reasoning",
  question: "If gas costs $3.60 per gallon and you need to fill a 15-gallon tank, how much will it cost?",
  answer: "Total cost = $3.60 × 15 gallons = $54.00",
  difficulty: "Easy"
},
{
  id: 2109,
  subject: "Arithmetic Reasoning",
  question: "A rectangular room is 12 feet long and 10 feet wide. What is the perimeter of the room?",
  answer: "Perimeter = 2(length + width)\nPerimeter = 2(12 + 10) = 2(22) = 44 feet",
  difficulty: "Easy"
},
{
  id: 2110,
  subject: "Arithmetic Reasoning",
  question: "If 4 workers can complete a task in 6 hours, how many hours would it take 8 workers to complete the same task?",
  answer: "Total work = 4 workers × 6 hours = 24 worker-hours\nTime for 8 workers = 24 worker-hours / 8 workers = 3 hours",
  difficulty: "Easy"
},
{
  id: 2111,
  subject: "Arithmetic Reasoning",
  question: "A car rental costs $35 per day plus $0.25 per mile. What is the total cost for a 3-day rental with 120 miles driven?",
  answer: "Daily cost = $35 × 3 = $105\nMileage cost = $0.25 × 120 = $30\nTotal cost = $105 + $30 = $135",
  difficulty: "Easy"
},
{
  id: 2112,
  subject: "Arithmetic Reasoning",
  question: "If a shirt is on sale for $24 after a 20% discount, what was the original price?",
  answer: "Sale price = 80% of original (100% - 20% = 80%)\n$24 = 0.80 × original price\nOriginal price = $24 / 0.80 = $30",
  difficulty: "Medium"
},
{
  id: 2113,
  subject: "Arithmetic Reasoning",
  question: "Convert 3.5 hours to minutes.",
  answer: "1 hour = 60 minutes\n3.5 hours = 3.5 × 60 = 210 minutes",
  difficulty: "Easy"
},
{
  id: 2114,
  subject: "Arithmetic Reasoning",
  question: "A military base uses 450 gallons of water per day. How many gallons will be used in a week?",
  answer: "1 week = 7 days\nTotal water = 450 gallons/day × 7 days = 3,150 gallons",
  difficulty: "Easy"
},
{
  id: 2115,
  subject: "Arithmetic Reasoning",
  question: "If a box contains 24 items and each item weighs 3 pounds, what is the total weight of the box's contents?",
  answer: "Total weight = 24 items × 3 pounds = 72 pounds",
  difficulty: "Easy"
},
{
  id: 2116,
  subject: "Arithmetic Reasoning",
  question: "A warehouse has 1,200 boxes. If 35% of them are shipped out, how many boxes remain?",
  answer: "Boxes shipped = 35% of 1,200 = 0.35 × 1,200 = 420\nBoxes remaining = 1,200 - 420 = 780 boxes",
  difficulty: "Easy"
},
{
  id: 2117,
  subject: "Arithmetic Reasoning",
  question: "If the ratio of officers to enlisted personnel is 1:8 and there are 72 enlisted personnel, how many officers are there?",
  answer: "Set up proportion: 1/8 = x/72\nCross multiply: 8x = 72\nx = 72/8 = 9 officers",
  difficulty: "Easy"
},
{
  id: 2118,
  subject: "Arithmetic Reasoning",
  question: "A rectangular garden is 15 feet long and 8 feet wide. What is its area?",
  answer: "Area = length × width\nArea = 15 feet × 8 feet = 120 square feet",
  difficulty: "Easy"
},
{
  id: 2119,
  subject: "Arithmetic Reasoning",
  question: "If you earn $15 per hour and work 35 hours in a week, what is your weekly pay before taxes?",
  answer: "Weekly pay = $15/hour × 35 hours = $525",
  difficulty: "Easy"
},
{
  id: 2120,
  subject: "Arithmetic Reasoning",
  question: "A map scale shows that 1 inch equals 50 miles. If two cities are 3.5 inches apart on the map, what is the actual distance between them?",
  answer: "Actual distance = 3.5 inches × 50 miles/inch = 175 miles",
  difficulty: "Easy"
},
{
  id: 2121,
  subject: "Arithmetic Reasoning",
  question: "If a 12-ounce can of soda costs $0.96, what is the cost per ounce?",
  answer: "Cost per ounce = $0.96 / 12 ounces = $0.08 per ounce",
  difficulty: "Easy"
},
{
  id: 2122,
  subject: "Arithmetic Reasoning",
  question: "A train travels 180 miles in 3 hours. At this rate, how far will it travel in 7 hours?",
  answer: "Speed = 180 miles / 3 hours = 60 mph\nDistance in 7 hours = 60 mph × 7 hours = 420 miles",
  difficulty: "Easy"
},
{
  id: 2123,
  subject: "Arithmetic Reasoning",
  question: "If a store increases the price of an item by 15% and the new price is $46, what was the original price?",
  answer: "New price = 115% of original (100% + 15% = 115%)\n$46 = 1.15 × original price\nOriginal price = $46 / 1.15 = $40",
  difficulty: "Medium"
},
{
  id: 2124,
  subject: "Arithmetic Reasoning",
  question: "Convert 2.5 kilograms to grams.",
  answer: "1 kilogram = 1,000 grams\n2.5 kilograms = 2.5 × 1,000 = 2,500 grams",
  difficulty: "Easy"
},
{
  id: 2125,
  subject: "Arithmetic Reasoning",
  question: "A painter can paint a room in 5 hours. How much of the room can be painted in 2 hours?",
  answer: "Rate = 1 room / 5 hours = 1/5 room per hour\nIn 2 hours: (1/5) × 2 = 2/5 of the room",
  difficulty: "Easy"
},
{
  id: 2126,
  subject: "Arithmetic Reasoning",
  question: "If 5 notebooks cost $12.50, what is the cost of 8 notebooks?",
  answer: "Cost per notebook = $12.50 / 5 = $2.50\nCost of 8 notebooks = $2.50 × 8 = $20.00",
  difficulty: "Easy"
},
{
  id: 2127,
  subject: "Arithmetic Reasoning",
  question: "A soldier's paycheck shows a 7.5% deduction for taxes. If the gross pay is $2,400, what is the tax amount?",
  answer: "Tax amount = 7.5% of $2,400 = 0.075 × $2,400 = $180",
  difficulty: "Easy"
},
{
  id: 2128,
  subject: "Arithmetic Reasoning",
  question: "A water tank holds 500 gallons when full. If it is currently 60% full, how many gallons are in the tank?",
  answer: "Gallons in tank = 60% of 500 = 0.60 × 500 = 300 gallons",
  difficulty: "Easy"
},
{
  id: 2129,
  subject: "Arithmetic Reasoning",
  question: "If a bicycle wheel has a diameter of 26 inches, what is the radius?",
  answer: "Radius = diameter / 2\nRadius = 26 inches / 2 = 13 inches",
  difficulty: "Easy"
},
{
  id: 2130,
  subject: "Arithmetic Reasoning",
  question: "A mechanic charges $75 per hour for labor. If a repair takes 3.5 hours, what is the labor cost?",
  answer: "Labor cost = $75/hour × 3.5 hours = $262.50",
  difficulty: "Easy"
},
{
  id: 2131,
  subject: "Arithmetic Reasoning",
  question: "If a recipe for 6 people calls for 4 cups of rice, how many cups are needed for 15 people?",
  answer: "Set up proportion: 4/6 = x/15\nCross multiply: 6x = 60\nx = 60/6 = 10 cups",
  difficulty: "Easy"
},
{
  id: 2132,
  subject: "Arithmetic Reasoning",
  question: "A delivery truck travels at an average speed of 55 mph. How far will it travel in 4.5 hours?",
  answer: "Distance = speed × time\nDistance = 55 mph × 4.5 hours = 247.5 miles",
  difficulty: "Easy"
},
{
  id: 2133,
  subject: "Arithmetic Reasoning",
  question: "If 3 shirts cost $45 and 2 pairs of pants cost $60, what is the total cost of 1 shirt and 1 pair of pants?",
  answer: "Cost per shirt = $45 / 3 = $15\nCost per pair of pants = $60 / 2 = $30\nTotal = $15 + $30 = $45",
  difficulty: "Easy"
},
{
  id: 2134,
  subject: "Arithmetic Reasoning",
  question: "Convert 120 minutes to hours.",
  answer: "1 hour = 60 minutes\n120 minutes = 120 / 60 = 2 hours",
  difficulty: "Easy"
},
{
  id: 2135,
  subject: "Arithmetic Reasoning",
  question: "A parking meter charges $1.50 per hour. How much will it cost to park for 3 hours and 30 minutes?",
  answer: "3 hours 30 minutes = 3.5 hours\nCost = $1.50 × 3.5 = $5.25",
  difficulty: "Easy"
},
{
  id: 2136,
  subject: "Arithmetic Reasoning",
  question: "If a case of 24 water bottles costs $6.00, what is the cost per bottle?",
  answer: "Cost per bottle = $6.00 / 24 = $0.25 per bottle",
  difficulty: "Easy"
},
{
  id: 2137,
  subject: "Arithmetic Reasoning",
  question: "A warehouse worker loads 15 boxes per hour. How many boxes can be loaded in 6.5 hours?",
  answer: "Total boxes = 15 boxes/hour × 6.5 hours = 97.5 boxes\nSince you can't load half a box, 97 boxes",
  difficulty: "Easy"
},
{
  id: 2138,
  subject: "Arithmetic Reasoning",
  question: "If the sales tax rate is 8% and an item costs $125, what is the total cost including tax?",
  answer: "Sales tax = 8% of $125 = 0.08 × $125 = $10\nTotal cost = $125 + $10 = $135",
  difficulty: "Easy"
},
{
  id: 2139,
  subject: "Arithmetic Reasoning",
  question: "A swimming pool is 25 meters long. What is this length in centimeters?",
  answer: "1 meter = 100 centimeters\n25 meters = 25 × 100 = 2,500 centimeters",
  difficulty: "Easy"
},
{
  id: 2140,
  subject: "Arithmetic Reasoning",
  question: "If a student scores 42 out of 50 on a test, what is the percentage score?",
  answer: "Percentage = (42/50) × 100%\nPercentage = 0.84 × 100% = 84%",
  difficulty: "Easy"
},
{
  id: 2141,
  subject: "Arithmetic Reasoning",
  question: "A military aircraft flies 1,500 miles in 2.5 hours. What is its average speed?",
  answer: "Average speed = 1,500 miles / 2.5 hours = 600 mph",
  difficulty: "Medium"
},
{
  id: 2142,
  subject: "Arithmetic Reasoning",
  question: "If 6 identical books weigh 9 pounds total, what is the weight of 10 such books?",
  answer: "Weight per book = 9 pounds / 6 = 1.5 pounds\nWeight of 10 books = 1.5 × 10 = 15 pounds",
  difficulty: "Medium"
},
{
  id: 2143,
  subject: "Arithmetic Reasoning",
  question: "A printer can print 12 pages per minute. How long will it take to print 450 pages?",
  answer: "Time = 450 pages / 12 pages per minute = 37.5 minutes",
  difficulty: "Medium"
},
{
  id: 2144,
  subject: "Arithmetic Reasoning",
  question: "If a worker's salary increases from $40,000 to $45,000, what is the percentage increase?",
  answer: "Increase = $45,000 - $40,000 = $5,000\nPercentage increase = ($5,000 / $40,000) × 100% = 12.5%",
  difficulty: "Medium"
},
{
  id: 2145,
  subject: "Arithmetic Reasoning",
  question: "A rectangular parking lot is 80 feet long and 50 feet wide. What is the area of the parking lot?",
  answer: "Area = length × width\nArea = 80 feet × 50 feet = 4,000 square feet",
  difficulty: "Medium"
},
{
  id: 2146,
  subject: "Arithmetic Reasoning",
  question: "If a machine produces 240 parts in 8 hours, how many parts will it produce in 15 hours at the same rate?",
  answer: "Rate = 240 parts / 8 hours = 30 parts per hour\nIn 15 hours: 30 × 15 = 450 parts",
  difficulty: "Medium"
},
{
  id: 2147,
  subject: "Arithmetic Reasoning",
  question: "A store sells apples for $1.20 per pound and oranges for $1.80 per pound. What is the total cost of 3 pounds of apples and 2 pounds of oranges?",
  answer: "Apples: $1.20 × 3 = $3.60\nOranges: $1.80 × 2 = $3.60\nTotal cost = $3.60 + $3.60 = $7.20",
  difficulty: "Medium"
},
{
  id: 2148,
  subject: "Arithmetic Reasoning",
  question: "If a car uses 12 gallons of gas to travel 360 miles, what is the fuel efficiency in miles per gallon?",
  answer: "Fuel efficiency = 360 miles / 12 gallons = 30 miles per gallon",
  difficulty: "Medium"
},
{
  id: 2149,
  subject: "Arithmetic Reasoning",
  question: "A construction crew can complete 1/4 of a project in 3 days. At this rate, how many days will it take to complete the entire project?",
  answer: "If 1/4 takes 3 days, then full project takes: 3 days × 4 = 12 days",
  difficulty: "Medium"
},
{
  id: 2150,
  subject: "Arithmetic Reasoning",
  question: "Convert 5 kilometers to meters.",
  answer: "1 kilometer = 1,000 meters\n5 kilometers = 5 × 1,000 = 5,000 meters",
  difficulty: "Medium"
},
{
  id: 2151,
  subject: "Arithmetic Reasoning",
  question: "If the ratio of men to women in a class is 3:5 and there are 24 men, how many women are there?",
  answer: "Set up proportion: 3/5 = 24/x\nCross multiply: 3x = 120\nx = 120/3 = 40 women",
  difficulty: "Medium"
},
{
  id: 2152,
  subject: "Arithmetic Reasoning",
  question: "A cylindrical water tank has a radius of 4 feet and a height of 10 feet. What is the volume? (Use 3.14 for pi)",
  answer: "Volume = pi × r² × h\nVolume = 3.14 × 4² × 10 = 3.14 × 16 × 10 = 502.4 cubic feet",
  difficulty: "Medium"
},
{
  id: 2153,
  subject: "Arithmetic Reasoning",
  question: "If a discount of 30% reduces the price of an item by $75, what was the original price?",
  answer: "30% of original price = $75\n0.30 × original = $75\nOriginal price = $75 / 0.30 = $250",
  difficulty: "Medium"
},
{
  id: 2154,
  subject: "Arithmetic Reasoning",
  question: "A plane leaves at 8:45 AM and arrives at 2:30 PM. If the flight covered 1,350 miles, what was the average speed?",
  answer: "Flight time = 8:45 AM to 2:30 PM = 5 hours 45 minutes = 5.75 hours\nAverage speed = 1,350 miles / 5.75 hours = 234.78 mph (approximately 235 mph)",
  difficulty: "Medium"
},
{
  id: 2155,
  subject: "Arithmetic Reasoning",
  question: "If 8 workers can complete a job in 12 days, how many days would it take 6 workers to complete the same job?",
  answer: "Total work = 8 workers × 12 days = 96 worker-days\nTime for 6 workers = 96 worker-days / 6 workers = 16 days",
  difficulty: "Medium"
},
{
  id: 2156,
  subject: "Arithmetic Reasoning",
  question: "A store buys items for $40 each and sells them for $65 each. What is the percentage markup based on cost?",
  answer: "Markup = $65 - $40 = $25\nPercentage markup = ($25 / $40) × 100% = 62.5%",
  difficulty: "Medium"
},
{
  id: 2157,
  subject: "Arithmetic Reasoning",
  question: "If you mix 2 liters of a solution that is 40% acid with 3 liters of a solution that is 60% acid, what is the percentage of acid in the mixture?",
  answer: "Acid from first solution: 2 × 0.40 = 0.8 liters\nAcid from second solution: 3 × 0.60 = 1.8 liters\nTotal acid = 0.8 + 1.8 = 2.6 liters\nTotal mixture = 2 + 3 = 5 liters\nPercentage = (2.6/5) × 100% = 52%",
  difficulty: "Medium"
},
{
  id: 2158,
  subject: "Arithmetic Reasoning",
  question: "A rectangular box has dimensions 8 inches by 6 inches by 5 inches. What is the volume?",
  answer: "Volume = length × width × height\nVolume = 8 × 6 × 5 = 240 cubic inches",
  difficulty: "Medium"
},
{
  id: 2159,
  subject: "Arithmetic Reasoning",
  question: "If a truck travels 320 miles on 16 gallons of gas, how many gallons are needed to travel 500 miles?",
  answer: "Fuel efficiency = 320 miles / 16 gallons = 20 mpg\nGallons needed = 500 miles / 20 mpg = 25 gallons",
  difficulty: "Medium"
},
{
  id: 2160,
  subject: "Arithmetic Reasoning",
  question: "A shirt originally priced at $60 is on sale for 25% off. An additional 10% discount is applied to the sale price. What is the final price?",
  answer: "First discount: $60 × 0.25 = $15, Price = $60 - $15 = $45\nSecond discount: $45 × 0.10 = $4.50, Final price = $45 - $4.50 = $40.50",
  difficulty: "Medium"
},
{
  id: 2161,
  subject: "Arithmetic Reasoning",
  question: "Convert 72 inches to feet.",
  answer: "1 foot = 12 inches\n72 inches = 72 / 12 = 6 feet",
  difficulty: "Medium"
},
{
  id: 2162,
  subject: "Arithmetic Reasoning",
  question: "If a bakery produces 480 loaves of bread in 6 hours, what is the production rate per hour?",
  answer: "Production rate = 480 loaves / 6 hours = 80 loaves per hour",
  difficulty: "Medium"
},
{
  id: 2163,
  subject: "Arithmetic Reasoning",
  question: "A rectangular field is 120 yards long and 80 yards wide. What is the perimeter in yards?",
  answer: "Perimeter = 2(length + width)\nPerimeter = 2(120 + 80) = 2(200) = 400 yards",
  difficulty: "Medium"
},
{
  id: 2164,
  subject: "Arithmetic Reasoning",
  question: "If 15% of a shipment is defective and there are 45 defective items, how many items are in the shipment?",
  answer: "15% of total = 45\n0.15 × total = 45\nTotal = 45 / 0.15 = 300 items",
  difficulty: "Medium"
},
{
  id: 2165,
  subject: "Arithmetic Reasoning",
  question: "A cyclist rides 18 miles in 1 hour and 12 minutes. What is the average speed in miles per hour?",
  answer: "1 hour 12 minutes = 1.2 hours (12 minutes = 0.2 hours)\nSpeed = 18 miles / 1.2 hours = 15 mph",
  difficulty: "Medium"
},
{
  id: 2166,
  subject: "Arithmetic Reasoning",
  question: "If a rectangular garden has a length that is twice its width and the perimeter is 84 feet, what is the width?",
  answer: "Let width = w, then length = 2w\nPerimeter = 2(w + 2w) = 84\n2(3w) = 84\n6w = 84\nw = 14 feet",
  difficulty: "Medium"
},
{
  id: 2167,
  subject: "Arithmetic Reasoning",
  question: "A water pump fills a tank at a rate of 150 gallons per hour. How long will it take to fill a 1,000-gallon tank that already contains 250 gallons?",
  answer: "Gallons needed = 1,000 - 250 = 750 gallons\nTime = 750 gallons / 150 gallons per hour = 5 hours",
  difficulty: "Medium"
},
{
  id: 2168,
  subject: "Arithmetic Reasoning",
  question: "If you buy 3 items for $5.99 each and 2 items for $8.50 each, what is the total cost before tax?",
  answer: "Cost of 3 items: 3 × $5.99 = $17.97\nCost of 2 items: 2 × $8.50 = $17.00\nTotal = $17.97 + $17.00 = $34.97",
  difficulty: "Medium"
},
{
  id: 2169,
  subject: "Arithmetic Reasoning",
  question: "A solution contains 20% salt. How many liters of water must be added to 5 liters of this solution to make it 10% salt?",
  answer: "Salt in original = 5 × 0.20 = 1 liter\nNew solution: 1 liter salt / (5 + x) = 0.10\n1 = 0.10(5 + x)\n1 = 0.5 + 0.10x\n0.5 = 0.10x\nx = 5 liters of water",
  difficulty: "Medium"
},
{
  id: 2170,
  subject: "Arithmetic Reasoning",
  question: "Convert 4.5 gallons to quarts.",
  answer: "1 gallon = 4 quarts\n4.5 gallons = 4.5 × 4 = 18 quarts",
  difficulty: "Medium"
},
{
  id: 2171,
  subject: "Arithmetic Reasoning",
  question: "If a square has a perimeter of 48 inches, what is its area?",
  answer: "Perimeter = 4 × side, so 48 = 4 × side\nSide = 48/4 = 12 inches\nArea = side² = 12² = 144 square inches",
  difficulty: "Medium"
},
{
  id: 2172,
  subject: "Arithmetic Reasoning",
  question: "A train leaves Station A at 9:00 AM traveling at 60 mph. Another train leaves Station A at 11:00 AM traveling at 80 mph in the same direction. At what time will the second train catch up?",
  answer: "First train's head start = 2 hours × 60 mph = 120 miles\nRelative speed = 80 - 60 = 20 mph\nTime to catch up = 120 miles / 20 mph = 6 hours\nSecond train catches up at 11:00 AM + 6 hours = 5:00 PM",
  difficulty: "Medium"
},
{
  id: 2173,
  subject: "Arithmetic Reasoning",
  question: "If a bookshelf has 5 shelves and each shelf holds 32 books, how many books can the bookshelf hold?",
  answer: "Total books = 5 shelves × 32 books per shelf = 160 books",
  difficulty: "Medium"
},
{
  id: 2174,
  subject: "Arithmetic Reasoning",
  question: "A car depreciates by 20% in the first year. If it was worth $25,000 new, what is its value after one year?",
  answer: "Depreciation = 20% of $25,000 = 0.20 × $25,000 = $5,000\nValue after one year = $25,000 - $5,000 = $20,000",
  difficulty: "Medium"
},
{
  id: 2175,
  subject: "Arithmetic Reasoning",
  question: "If 12 pencils cost $3.60, what is the cost of 5 pencils?",
  answer: "Cost per pencil = $3.60 / 12 = $0.30\nCost of 5 pencils = $0.30 × 5 = $1.50",
  difficulty: "Medium"
},
{
  id: 2176,
  subject: "Arithmetic Reasoning",
  question: "A rectangular swimming pool is 50 meters long and 25 meters wide. If you walk around the perimeter, how far do you walk?",
  answer: "Perimeter = 2(length + width)\nPerimeter = 2(50 + 25) = 2(75) = 150 meters",
  difficulty: "Medium"
},
{
  id: 2177,
  subject: "Arithmetic Reasoning",
  question: "If a worker earns time-and-a-half for overtime and the regular rate is $18 per hour, what is the overtime rate?",
  answer: "Overtime rate = 1.5 × regular rate\nOvertime rate = 1.5 × $18 = $27 per hour",
  difficulty: "Medium"
},
{
  id: 2178,
  subject: "Arithmetic Reasoning",
  question: "Convert 8 pounds to ounces.",
  answer: "1 pound = 16 ounces\n8 pounds = 8 × 16 = 128 ounces",
  difficulty: "Medium"
},
{
  id: 2179,
  subject: "Arithmetic Reasoning",
  question: "A military convoy consists of 15 vehicles. If each vehicle carries 8 personnel, how many personnel are in the convoy?",
  answer: "Total personnel = 15 vehicles × 8 personnel = 120 personnel",
  difficulty: "Medium"
},
{
  id: 2180,
  subject: "Arithmetic Reasoning",
  question: "If a store marks up merchandise by 40% above cost and an item costs the store $80, what is the selling price?",
  answer: "Markup = 40% of $80 = 0.40 × $80 = $32\nSelling price = $80 + $32 = $112",
  difficulty: "Medium"
},
{
  id: 2181,
  subject: "Arithmetic Reasoning",
  question: "A military transport plane carries supplies weighing 45,000 pounds. If the plane makes 8 trips in a day, what is the total weight of supplies transported?",
  answer: "Total weight = 45,000 pounds × 8 trips = 360,000 pounds",
  difficulty: "Hard"
},
{
  id: 2182,
  subject: "Arithmetic Reasoning",
  question: "Two workers can complete a task together in 6 hours. If one worker takes 10 hours alone to complete the task, how long would the other worker take alone?",
  answer: "Combined rate = 1/6 per hour\nFirst worker's rate = 1/10 per hour\nSecond worker's rate = 1/6 - 1/10 = 5/30 - 3/30 = 2/30 = 1/15\nSecond worker alone takes 15 hours",
  difficulty: "Hard"
},
{
  id: 2183,
  subject: "Arithmetic Reasoning",
  question: "A rectangular room is 18 feet long, 12 feet wide, and 9 feet high. If you want to paint all four walls, what is the total wall area? (Exclude ceiling and floor)",
  answer: "Two long walls: 2 × (18 × 9) = 2 × 162 = 324 sq ft\nTwo short walls: 2 × (12 × 9) = 2 × 108 = 216 sq ft\nTotal area = 324 + 216 = 540 square feet",
  difficulty: "Hard"
},
{
  id: 2184,
  subject: "Arithmetic Reasoning",
  question: "A store offers a 20% discount on an item, then adds 8% sales tax. If the final price is $86.40, what was the original price before discount?",
  answer: "Let original = x\nAfter discount: 0.80x\nAfter tax: 0.80x × 1.08 = 0.864x\n0.864x = $86.40\nx = $86.40 / 0.864 = $100",
  difficulty: "Hard"
},
{
  id: 2185,
  subject: "Arithmetic Reasoning",
  question: "A car traveling at 65 mph leaves at 8:00 AM. Another car traveling at 55 mph leaves from the same place at 9:00 AM. At what distance from the starting point will they be 200 miles apart?",
  answer: "At 9:00 AM, first car is 65 miles ahead\nRelative speed = 65 - 55 = 10 mph apart\nAdditional separation needed = 200 - 65 = 135 miles\nTime = 135/10 = 13.5 hours after 9:00 AM\nDistance from start = 65 + (65 × 13.5) = 65 + 877.5 = 942.5 miles",
  difficulty: "Hard"
},
{
  id: 2186,
  subject: "Arithmetic Reasoning",
  question: "If a rectangular tank is 8 feet long, 6 feet wide, and 4 feet deep, how many gallons does it hold? (1 cubic foot = 7.48 gallons)",
  answer: "Volume = 8 × 6 × 4 = 192 cubic feet\nGallons = 192 × 7.48 = 1,436.16 gallons",
  difficulty: "Hard"
},
{
  id: 2187,
  subject: "Arithmetic Reasoning",
  question: "A chemist needs to create 15 liters of a 30% acid solution by mixing a 20% solution with a 50% solution. How many liters of each should be used?",
  answer: "Let x = liters of 20% solution, then (15-x) = liters of 50% solution\n0.20x + 0.50(15-x) = 0.30(15)\n0.20x + 7.5 - 0.50x = 4.5\n-0.30x = -3\nx = 10 liters of 20%, and 5 liters of 50%",
  difficulty: "Hard"
},
{
  id: 2188,
  subject: "Arithmetic Reasoning",
  question: "A military unit marches at 3 mph for 2 hours, then increases speed to 4 mph for 3 hours. What is the average speed for the entire march?",
  answer: "Distance at 3 mph = 3 × 2 = 6 miles\nDistance at 4 mph = 4 × 3 = 12 miles\nTotal distance = 6 + 12 = 18 miles\nTotal time = 2 + 3 = 5 hours\nAverage speed = 18/5 = 3.6 mph",
  difficulty: "Hard"
},
{
  id: 2189,
  subject: "Arithmetic Reasoning",
  question: "A store sells an item for $90 and makes a 25% profit on the cost. What was the cost to the store?",
  answer: "Selling price = Cost + 25% of Cost\n$90 = Cost × 1.25\nCost = $90 / 1.25 = $72",
  difficulty: "Hard"
},
{
  id: 2190,
  subject: "Arithmetic Reasoning",
  question: "Three pipes can fill a tank in 4, 6, and 12 hours respectively. If all three pipes are opened together, how long will it take to fill the tank?",
  answer: "Rates: 1/4, 1/6, and 1/12 per hour\nCombined rate = 3/12 + 2/12 + 1/12 = 6/12 = 1/2 per hour\nTime = 1 / (1/2) = 2 hours",
  difficulty: "Hard"
},
{
  id: 2191,
  subject: "Arithmetic Reasoning",
  question: "A rectangular garden has a length of 40 feet and width of 30 feet. A path 2 feet wide surrounds it. What is the area of the path?",
  answer: "Garden area = 40 × 30 = 1,200 sq ft\nGarden with path = 44 × 34 = 1,496 sq ft (adds 2 ft on each side)\nPath area = 1,496 - 1,200 = 296 square feet",
  difficulty: "Hard"
},
{
  id: 2192,
  subject: "Arithmetic Reasoning",
  question: "If a person invests $5,000 at 6% annual interest compounded annually, what is the value after 2 years?",
  answer: "After year 1: $5,000 × 1.06 = $5,300\nAfter year 2: $5,300 × 1.06 = $5,618",
  difficulty: "Hard"
},
{
  id: 2193,
  subject: "Arithmetic Reasoning",
  question: "A boat travels 36 miles downstream in 2 hours and returns upstream in 3 hours. What is the speed of the current?",
  answer: "Downstream speed = 36/2 = 18 mph (boat + current)\nUpstream speed = 36/3 = 12 mph (boat - current)\nAdding: 2×boat speed = 30, boat = 15 mph\nCurrent = 18 - 15 = 3 mph",
  difficulty: "Hard"
},
{
  id: 2194,
  subject: "Arithmetic Reasoning",
  question: "A military squad has 12 members. If 3 are chosen for a special mission, how many different ways can this be done? Use the combination formula.",
  answer: "Combinations = C(12,3) = 12!/(3!×9!)\n= (12×11×10)/(3×2×1)\n= 1,320/6 = 220 ways",
  difficulty: "Hard"
},
{
  id: 2195,
  subject: "Arithmetic Reasoning",
  question: "A circular track has a diameter of 100 meters. If a runner completes 5 laps, approximately how many meters has the runner traveled? (Use 3.14 for pi)",
  answer: "Circumference = pi × diameter = 3.14 × 100 = 314 meters\nDistance for 5 laps = 314 × 5 = 1,570 meters",
  difficulty: "Hard"
},
{
  id: 2196,
  subject: "Arithmetic Reasoning",
  question: "A warehouse contains boxes that weigh either 25 pounds or 40 pounds. If there are 80 boxes with a total weight of 2,600 pounds, how many boxes weigh 25 pounds?",
  answer: "Let x = number of 25-lb boxes, then (80-x) = 40-lb boxes\n25x + 40(80-x) = 2,600\n25x + 3,200 - 40x = 2,600\n-15x = -600\nx = 40 boxes of 25 pounds",
  difficulty: "Hard"
},
{
  id: 2197,
  subject: "Arithmetic Reasoning",
  question: "Two cyclists start from opposite ends of a 150-mile road. One travels at 15 mph and the other at 20 mph. How long until they meet?",
  answer: "Combined approach speed = 15 + 20 = 35 mph\nTime to meet = 150 miles / 35 mph = 4.29 hours (approximately 4 hours 17 minutes)",
  difficulty: "Hard"
},
{
  id: 2198,
  subject: "Arithmetic Reasoning",
  question: "A factory produces widgets at a cost of $12 each. Fixed costs are $3,000 per month. If widgets sell for $25 each, how many must be sold to break even?",
  answer: "Profit per widget = $25 - $12 = $13\nBreak even: 13x = 3,000\nx = 3,000/13 = 230.77\nMust sell 231 widgets to break even",
  difficulty: "Hard"
},
{
  id: 2199,
  subject: "Arithmetic Reasoning",
  question: "A rectangular box has a length twice its width and a height three times its width. If the volume is 384 cubic inches, what is the width?",
  answer: "Let width = w, length = 2w, height = 3w\nVolume = w × 2w × 3w = 6w³ = 384\nw³ = 64\nw = 4 inches",
  difficulty: "Hard"
},
{
  id: 2200,
  subject: "Arithmetic Reasoning",
  question: "A 600-mile trip is completed in three stages. The first stage is driven at 50 mph, the second at 60 mph, and the third at 75 mph. If each stage covers the same distance, what is the average speed for the entire trip?",
  answer: "Each stage = 200 miles\nTime for stage 1 = 200/50 = 4 hours\nTime for stage 2 = 200/60 = 3.33 hours\nTime for stage 3 = 200/75 = 2.67 hours\nTotal time = 10 hours\nAverage speed = 600/10 = 60 mph",
  difficulty: "Hard"
},
{
  id: 2201,
  subject: "Electronics Information",
  question: "What is electric current?",
  answer: "Electric current is the flow of electric charge through a conductor, measured in amperes (amps). It represents the movement of electrons through a circuit.",
  difficulty: "Easy"
},
{
  id: 2202,
  subject: "Electronics Information",
  question: "What is voltage?",
  answer: "Voltage is the electrical pressure or potential difference that pushes electric current through a circuit. It is measured in volts (V) and represents the energy per unit charge.",
  difficulty: "Easy"
},
{
  id: 2203,
  subject: "Electronics Information",
  question: "What is resistance?",
  answer: "Resistance is the opposition to the flow of electric current in a circuit. It is measured in ohms (Ω) and determines how much current will flow for a given voltage.",
  difficulty: "Easy"
},
{
  id: 2204,
  subject: "Electronics Information",
  question: "What is a conductor?",
  answer: "A conductor is a material that allows electric current to flow easily through it. Good conductors include copper, aluminum, silver, and gold.",
  difficulty: "Easy"
},
{
  id: 2205,
  subject: "Electronics Information",
  question: "What is an insulator?",
  answer: "An insulator is a material that resists the flow of electric current. Common insulators include rubber, plastic, glass, wood, and ceramic.",
  difficulty: "Easy"
},
{
  id: 2206,
  subject: "Electronics Information",
  question: "State Ohm's Law.",
  answer: "Ohm's Law states that current (I) equals voltage (V) divided by resistance (R): I = V/R. This fundamental relationship describes how voltage, current, and resistance relate in an electrical circuit.",
  difficulty: "Easy"
},
{
  id: 2207,
  subject: "Electronics Information",
  question: "What unit measures electric current?",
  answer: "Electric current is measured in amperes (amps or A). One ampere represents one coulomb of charge flowing past a point per second.",
  difficulty: "Easy"
},
{
  id: 2208,
  subject: "Electronics Information",
  question: "What unit measures voltage?",
  answer: "Voltage is measured in volts (V). One volt is the potential difference that will cause one ampere of current to flow against one ohm of resistance.",
  difficulty: "Easy"
},
{
  id: 2209,
  subject: "Electronics Information",
  question: "What unit measures resistance?",
  answer: "Resistance is measured in ohms (Ω, the Greek letter omega). One ohm is the resistance that allows one ampere to flow when one volt is applied.",
  difficulty: "Easy"
},
{
  id: 2210,
  subject: "Electronics Information",
  question: "What unit measures electrical power?",
  answer: "Electrical power is measured in watts (W). One watt equals one joule of energy per second, or one volt times one ampere (P = IV).",
  difficulty: "Easy"
},
{
  id: 2211,
  subject: "Electronics Information",
  question: "What does DC stand for in electricity?",
  answer: "DC stands for Direct Current. It is electric current that flows in one constant direction, like the current from a battery.",
  difficulty: "Easy"
},
{
  id: 2212,
  subject: "Electronics Information",
  question: "What does AC stand for in electricity?",
  answer: "AC stands for Alternating Current. It is electric current that periodically reverses direction, like the current from wall outlets in homes (typically 60 Hz in the US).",
  difficulty: "Easy"
},
{
  id: 2213,
  subject: "Electronics Information",
  question: "Which is the best conductor of electricity: copper, rubber, or wood?",
  answer: "Copper is the best conductor of electricity among these materials. Rubber and wood are insulators that resist electrical flow.",
  difficulty: "Easy"
},
{
  id: 2214,
  subject: "Electronics Information",
  question: "What is the purpose of a fuse in an electrical circuit?",
  answer: "A fuse protects a circuit from excessive current by melting and breaking the circuit when current exceeds a safe level. This prevents damage to equipment and reduces fire risk.",
  difficulty: "Easy"
},
{
  id: 2215,
  subject: "Electronics Information",
  question: "What is a resistor?",
  answer: "A resistor is an electronic component that limits or regulates the flow of electric current in a circuit. It provides a specific amount of resistance measured in ohms.",
  difficulty: "Easy"
},
{
  id: 2216,
  subject: "Electronics Information",
  question: "What is a capacitor?",
  answer: "A capacitor is an electronic component that stores electrical energy in an electric field. It consists of two conductors separated by an insulator and is measured in farads.",
  difficulty: "Easy"
},
{
  id: 2217,
  subject: "Electronics Information",
  question: "What does a battery do in a circuit?",
  answer: "A battery provides the voltage (electrical pressure) that pushes current through a circuit. It converts chemical energy into electrical energy and is a source of DC power.",
  difficulty: "Easy"
},
{
  id: 2218,
  subject: "Electronics Information",
  question: "What is the function of a switch?",
  answer: "A switch opens or closes an electrical circuit, controlling whether current can flow. When closed, current flows; when open, current is blocked.",
  difficulty: "Easy"
},
{
  id: 2219,
  subject: "Electronics Information",
  question: "What is ground in an electrical circuit?",
  answer: "Ground is a reference point in a circuit that serves as a return path for current and is typically at zero voltage. It provides safety by directing excess current away from users.",
  difficulty: "Easy"
},
{
  id: 2220,
  subject: "Electronics Information",
  question: "What does LED stand for?",
  answer: "LED stands for Light Emitting Diode. It is a semiconductor device that emits light when current flows through it in the forward direction.",
  difficulty: "Easy"
},
{
  id: 2221,
  subject: "Electronics Information",
  question: "In a series circuit, how does total resistance relate to individual resistances?",
  answer: "In a series circuit, the total resistance equals the sum of all individual resistances: R_total = R1 + R2 + R3 + ... This means resistances add up directly.",
  difficulty: "Easy"
},
{
  id: 2222,
  subject: "Electronics Information",
  question: "In a series circuit, is the current the same through all components?",
  answer: "Yes, in a series circuit, the same current flows through all components because there is only one path for current to follow.",
  difficulty: "Easy"
},
{
  id: 2223,
  subject: "Electronics Information",
  question: "In a parallel circuit, is the voltage the same across all branches?",
  answer: "Yes, in a parallel circuit, the voltage is the same across all parallel branches because each branch is connected directly to the voltage source.",
  difficulty: "Easy"
},
{
  id: 2224,
  subject: "Electronics Information",
  question: "What is a diode?",
  answer: "A diode is a semiconductor device that allows current to flow in only one direction (forward bias) and blocks current in the reverse direction (reverse bias).",
  difficulty: "Easy"
},
{
  id: 2225,
  subject: "Electronics Information",
  question: "What is a transformer?",
  answer: "A transformer is a device that transfers electrical energy between two circuits through electromagnetic induction. It can increase (step-up) or decrease (step-down) AC voltage.",
  difficulty: "Easy"
},
{
  id: 2226,
  subject: "Electronics Information",
  question: "What type of current does a standard household battery provide?",
  answer: "A standard household battery provides Direct Current (DC), which flows in one constant direction from the positive to negative terminal.",
  difficulty: "Easy"
},
{
  id: 2227,
  subject: "Electronics Information",
  question: "What type of current comes from a wall outlet in your home?",
  answer: "Wall outlets in homes provide Alternating Current (AC), which reverses direction periodically at 60 Hz in the United States (120V AC).",
  difficulty: "Easy"
},
{
  id: 2228,
  subject: "Electronics Information",
  question: "If voltage increases and resistance stays the same, what happens to current?",
  answer: "According to Ohm's Law (I = V/R), if voltage increases and resistance stays constant, current will increase proportionally.",
  difficulty: "Easy"
},
{
  id: 2229,
  subject: "Electronics Information",
  question: "If resistance increases and voltage stays the same, what happens to current?",
  answer: "According to Ohm's Law (I = V/R), if resistance increases and voltage stays constant, current will decrease proportionally.",
  difficulty: "Easy"
},
{
  id: 2230,
  subject: "Electronics Information",
  question: "What does an inductor do?",
  answer: "An inductor is a coil of wire that stores energy in a magnetic field when current flows through it. It opposes changes in current and is measured in henries.",
  difficulty: "Easy"
},
{
  id: 2231,
  subject: "Electronics Information",
  question: "What is the standard voltage for a car battery?",
  answer: "A standard car battery is 12 volts DC. It consists of six 2-volt cells connected in series.",
  difficulty: "Easy"
},
{
  id: 2232,
  subject: "Electronics Information",
  question: "What is a transistor used for?",
  answer: "A transistor is a semiconductor device used to amplify or switch electronic signals. It has three terminals and can control a large current with a small current.",
  difficulty: "Easy"
},
{
  id: 2233,
  subject: "Electronics Information",
  question: "What is the electrical symbol for a resistor?",
  answer: "The electrical symbol for a resistor is a zigzag line (American standard) or a rectangle (international standard).",
  difficulty: "Easy"
},
{
  id: 2234,
  subject: "Electronics Information",
  question: "What is an amp-hour?",
  answer: "An amp-hour (Ah) is a unit of electric charge that represents the amount of charge transferred by one ampere of current flowing for one hour. It measures battery capacity.",
  difficulty: "Easy"
},
{
  id: 2235,
  subject: "Electronics Information",
  question: "What happens when you connect two identical batteries in series?",
  answer: "When two identical batteries are connected in series (positive to negative), their voltages add while the current capacity remains the same. Two 1.5V batteries in series give 3V.",
  difficulty: "Easy"
},
{
  id: 2236,
  subject: "Electronics Information",
  question: "Is silver a good conductor or insulator?",
  answer: "Silver is an excellent conductor of electricity, actually the best conductor of all metals. However, copper is more commonly used because it's less expensive.",
  difficulty: "Easy"
},
{
  id: 2237,
  subject: "Electronics Information",
  question: "What is a short circuit?",
  answer: "A short circuit is an unintended low-resistance path that allows excessive current to flow. It bypasses the normal load and can cause overheating, damage, or fire.",
  difficulty: "Easy"
},
{
  id: 2238,
  subject: "Electronics Information",
  question: "What is an open circuit?",
  answer: "An open circuit is a break in the circuit path that prevents current from flowing. This can be intentional (like an open switch) or unintentional (like a broken wire).",
  difficulty: "Easy"
},
{
  id: 2239,
  subject: "Electronics Information",
  question: "What color is typically used for the ground wire in household wiring?",
  answer: "In household wiring, the ground wire is typically green or bare copper. The hot wire is black, and the neutral wire is white.",
  difficulty: "Easy"
},
{
  id: 2240,
  subject: "Electronics Information",
  question: "What is the purpose of an amplifier?",
  answer: "An amplifier increases the amplitude (strength) of an electrical signal. It takes a weak input signal and produces a stronger output signal with the same waveform.",
  difficulty: "Easy"
},
{
  id: 2241,
  subject: "Electronics Information",
  question: "A circuit has 12 volts and 3 ohms of resistance. What is the current?",
  answer: "Using Ohm's Law: I = V/R = 12V / 3Ω = 4 amps. The current flowing through the circuit is 4 amperes.",
  difficulty: "Medium"
},
{
  id: 2242,
  subject: "Electronics Information",
  question: "A circuit has 6 amps of current and 2 ohms of resistance. What is the voltage?",
  answer: "Rearranging Ohm's Law to V = I × R: V = 6A × 2Ω = 12 volts. The voltage across the circuit is 12 volts.",
  difficulty: "Medium"
},
{
  id: 2243,
  subject: "Electronics Information",
  question: "A circuit has 120 volts and 10 amps of current. What is the resistance?",
  answer: "Rearranging Ohm's Law to R = V/I: R = 120V / 10A = 12 ohms. The resistance in the circuit is 12 ohms.",
  difficulty: "Medium"
},
{
  id: 2244,
  subject: "Electronics Information",
  question: "Calculate the power in a circuit with 120 volts and 5 amps.",
  answer: "Using the power formula P = I × V: P = 5A × 120V = 600 watts. The circuit consumes 600 watts of power.",
  difficulty: "Medium"
},
{
  id: 2245,
  subject: "Electronics Information",
  question: "What is the total resistance of three resistors in series: 10Ω, 20Ω, and 30Ω?",
  answer: "In a series circuit, resistances add: R_total = 10Ω + 20Ω + 30Ω = 60 ohms. The total resistance is 60 ohms.",
  difficulty: "Medium"
},
{
  id: 2246,
  subject: "Electronics Information",
  question: "In a series circuit with a 9V battery and three 3Ω resistors, what is the current?",
  answer: "First find total resistance: R_total = 3 + 3 + 3 = 9Ω. Then use Ohm's Law: I = V/R = 9V / 9Ω = 1 amp.",
  difficulty: "Medium"
},
{
  id: 2247,
  subject: "Electronics Information",
  question: "What is the difference between forward bias and reverse bias in a diode?",
  answer: "Forward bias occurs when the positive voltage is applied to the anode (allowing current flow). Reverse bias occurs when positive voltage is applied to the cathode (blocking current flow).",
  difficulty: "Medium"
},
{
  id: 2248,
  subject: "Electronics Information",
  question: "What are the three terminals of a transistor?",
  answer: "The three terminals of a transistor are the base, collector, and emitter. The base controls current flow between the collector and emitter.",
  difficulty: "Medium"
},
{
  id: 2249,
  subject: "Electronics Information",
  question: "What is the difference between NPN and PNP transistors?",
  answer: "In an NPN transistor, current flows from collector to emitter when the base is positive. In a PNP transistor, current flows from emitter to collector when the base is negative. The arrow direction differs in their symbols.",
  difficulty: "Medium"
},
{
  id: 2250,
  subject: "Electronics Information",
  question: "What does a step-up transformer do?",
  answer: "A step-up transformer increases AC voltage from the primary coil to the secondary coil. It has more turns in the secondary coil than the primary coil.",
  difficulty: "Medium"
},
{
  id: 2251,
  subject: "Electronics Information",
  question: "What does a step-down transformer do?",
  answer: "A step-down transformer decreases AC voltage from the primary coil to the secondary coil. It has fewer turns in the secondary coil than the primary coil.",
  difficulty: "Medium"
},
{
  id: 2252,
  subject: "Electronics Information",
  question: "If a 120V light bulb draws 0.5 amps, what is its power consumption?",
  answer: "Using P = I × V: P = 0.5A × 120V = 60 watts. The light bulb consumes 60 watts of power.",
  difficulty: "Medium"
},
{
  id: 2253,
  subject: "Electronics Information",
  question: "What happens to the total current in a parallel circuit compared to each branch?",
  answer: "In a parallel circuit, the total current is the sum of the currents in each branch: I_total = I1 + I2 + I3 + ... The current divides among the parallel paths.",
  difficulty: "Medium"
},
{
  id: 2254,
  subject: "Electronics Information",
  question: "How does total resistance in a parallel circuit compare to individual resistances?",
  answer: "In a parallel circuit, the total resistance is always less than the smallest individual resistance. It is calculated using: 1/R_total = 1/R1 + 1/R2 + 1/R3 + ...",
  difficulty: "Medium"
},
{
  id: 2255,
  subject: "Electronics Information",
  question: "What is the total resistance of two 6-ohm resistors connected in parallel?",
  answer: "For equal resistors in parallel: R_total = R/n = 6Ω/2 = 3 ohms. Or using 1/R_total = 1/6 + 1/6 = 2/6, so R_total = 3 ohms.",
  difficulty: "Medium"
},
{
  id: 2256,
  subject: "Electronics Information",
  question: "What is capacitance and what unit measures it?",
  answer: "Capacitance is the ability of a component to store electric charge, measured in farads (F). One farad stores one coulomb of charge per volt applied.",
  difficulty: "Medium"
},
{
  id: 2257,
  subject: "Electronics Information",
  question: "What happens to a capacitor when DC voltage is first applied?",
  answer: "When DC voltage is first applied, current flows into the capacitor as it charges. Once fully charged, current stops flowing because a capacitor blocks DC in steady state.",
  difficulty: "Medium"
},
{
  id: 2258,
  subject: "Electronics Information",
  question: "How does a capacitor respond to AC current?",
  answer: "A capacitor allows AC current to pass through because the voltage is constantly changing, causing the capacitor to repeatedly charge and discharge. Higher frequency AC passes more easily.",
  difficulty: "Medium"
},
{
  id: 2259,
  subject: "Electronics Information",
  question: "What is inductance and what unit measures it?",
  answer: "Inductance is the property of a conductor (usually a coil) to oppose changes in current by storing energy in a magnetic field. It is measured in henries (H).",
  difficulty: "Medium"
},
{
  id: 2260,
  subject: "Electronics Information",
  question: "What is the electrical symbol for a capacitor?",
  answer: "The electrical symbol for a capacitor is two parallel lines of equal length, sometimes with one line curved for polarized capacitors. It represents the two conductive plates.",
  difficulty: "Medium"
},
{
  id: 2261,
  subject: "Electronics Information",
  question: "What is the electrical symbol for a diode?",
  answer: "The electrical symbol for a diode is a triangle pointing toward a line. The triangle (anode) shows the direction current can flow; the line (cathode) blocks reverse current.",
  difficulty: "Medium"
},
{
  id: 2262,
  subject: "Electronics Information",
  question: "What is the electrical symbol for a battery?",
  answer: "The electrical symbol for a battery is one or more pairs of parallel lines of unequal length. The longer line represents the positive terminal, and the shorter line represents the negative terminal.",
  difficulty: "Medium"
},
{
  id: 2263,
  subject: "Electronics Information",
  question: "What is the electrical symbol for a switch?",
  answer: "The electrical symbol for a switch is a line that can be open (broken circuit) or closed (complete circuit). It's often shown as a line with a pivot point that can connect or disconnect.",
  difficulty: "Medium"
},
{
  id: 2264,
  subject: "Electronics Information",
  question: "What is the electrical symbol for ground?",
  answer: "The electrical symbol for ground is typically three horizontal lines of decreasing length stacked vertically, or sometimes a single horizontal line with vertical lines beneath it.",
  difficulty: "Medium"
},
{
  id: 2265,
  subject: "Electronics Information",
  question: "Why is copper commonly used for electrical wiring?",
  answer: "Copper is commonly used because it is an excellent conductor of electricity (second only to silver), is relatively inexpensive, is durable, can be easily formed into wires, and resists corrosion.",
  difficulty: "Medium"
},
{
  id: 2266,
  subject: "Electronics Information",
  question: "What happens when you connect two identical batteries in parallel?",
  answer: "When two identical batteries are connected in parallel (positive to positive, negative to negative), the voltage stays the same but the current capacity (amp-hours) doubles.",
  difficulty: "Medium"
},
{
  id: 2267,
  subject: "Electronics Information",
  question: "A 1200-watt appliance runs on 120 volts. How much current does it draw?",
  answer: "Rearranging P = I × V to I = P/V: I = 1200W / 120V = 10 amps. The appliance draws 10 amperes of current.",
  difficulty: "Medium"
},
{
  id: 2268,
  subject: "Electronics Information",
  question: "What is impedance?",
  answer: "Impedance is the total opposition to current flow in an AC circuit, combining resistance, capacitive reactance, and inductive reactance. It is measured in ohms and represented by Z.",
  difficulty: "Medium"
},
{
  id: 2269,
  subject: "Electronics Information",
  question: "What is a rectifier?",
  answer: "A rectifier is a device that converts AC (alternating current) to DC (direct current). The simplest rectifier is a diode, but full-wave rectifiers use multiple diodes for more efficient conversion.",
  difficulty: "Medium"
},
{
  id: 2270,
  subject: "Electronics Information",
  question: "What is the purpose of an antenna?",
  answer: "An antenna transmits and receives electromagnetic waves (radio waves). It converts electrical signals into radio waves for transmission and captures radio waves to convert back to electrical signals for reception.",
  difficulty: "Medium"
},
{
  id: 2271,
  subject: "Electronics Information",
  question: "What is frequency in AC circuits?",
  answer: "Frequency is the number of complete cycles per second that AC voltage or current completes. It is measured in hertz (Hz). US household AC is 60 Hz.",
  difficulty: "Medium"
},
{
  id: 2272,
  subject: "Electronics Information",
  question: "What is a potentiometer?",
  answer: "A potentiometer is a variable resistor with three terminals. It allows manual adjustment of resistance by moving a sliding contact along a resistive element. Common uses include volume controls.",
  difficulty: "Medium"
},
{
  id: 2273,
  subject: "Electronics Information",
  question: "What is a circuit breaker?",
  answer: "A circuit breaker is a resettable protective device that automatically interrupts current flow when it exceeds a safe level. Unlike a fuse, it can be reset after tripping rather than replaced.",
  difficulty: "Medium"
},
{
  id: 2274,
  subject: "Electronics Information",
  question: "If three 9V batteries are connected in series, what is the total voltage?",
  answer: "In a series connection, voltages add: V_total = 9V + 9V + 9V = 27 volts. Three 9V batteries in series provide 27 volts.",
  difficulty: "Medium"
},
{
  id: 2275,
  subject: "Electronics Information",
  question: "What is RMS voltage?",
  answer: "RMS (Root Mean Square) voltage is the effective value of AC voltage equivalent to DC voltage that would deliver the same power. For household 120V AC, the RMS value is 120V, but peak voltage is about 170V.",
  difficulty: "Medium"
},
{
  id: 2276,
  subject: "Electronics Information",
  question: "What is the primary difference between AC and DC in terms of electron flow?",
  answer: "In DC, electrons flow continuously in one direction from negative to positive. In AC, electrons periodically reverse direction, alternating back and forth at a specific frequency.",
  difficulty: "Medium"
},
{
  id: 2277,
  subject: "Electronics Information",
  question: "Can a transformer work with DC current?",
  answer: "No, a transformer only works with AC current. Transformers rely on changing magnetic fields to induce voltage in the secondary coil, which requires alternating current.",
  difficulty: "Medium"
},
{
  id: 2278,
  subject: "Electronics Information",
  question: "What does GFCI stand for and what does it do?",
  answer: "GFCI stands for Ground Fault Circuit Interrupter. It quickly cuts off power when it detects current leaking to ground, protecting against electric shock. Common in bathrooms and kitchens.",
  difficulty: "Medium"
},
{
  id: 2279,
  subject: "Electronics Information",
  question: "What is a semiconductor?",
  answer: "A semiconductor is a material whose electrical conductivity falls between that of conductors and insulators. Silicon and germanium are common semiconductors used to make diodes and transistors.",
  difficulty: "Medium"
},
{
  id: 2280,
  subject: "Electronics Information",
  question: "What is Kirchhoff's Current Law?",
  answer: "Kirchhoff's Current Law states that the sum of all currents entering a node (junction) equals the sum of all currents leaving that node. In other words, charge is conserved at any junction.",
  difficulty: "Hard"
},
{
  id: 2281,
  subject: "Electronics Information",
  question: "What is Kirchhoff's Voltage Law?",
  answer: "Kirchhoff's Voltage Law states that the sum of all voltages around any closed loop in a circuit equals zero. The voltage rises equal the voltage drops in any complete circuit path.",
  difficulty: "Hard"
},
{
  id: 2282,
  subject: "Electronics Information",
  question: "Calculate the total resistance of a 4-ohm and 6-ohm resistor in parallel.",
  answer: "Using 1/R_total = 1/R1 + 1/R2: 1/R_total = 1/4 + 1/6 = 3/12 + 2/12 = 5/12, so R_total = 12/5 = 2.4 ohms.",
  difficulty: "Hard"
},
{
  id: 2283,
  subject: "Electronics Information",
  question: "A series circuit has a 24V battery and three resistors: 2Ω, 4Ω, and 6Ω. What is the voltage drop across the 4Ω resistor?",
  answer: "First, total R = 2 + 4 + 6 = 12Ω. Current: I = 24V/12Ω = 2A. Voltage across 4Ω: V = I × R = 2A × 4Ω = 8 volts.",
  difficulty: "Hard"
},
{
  id: 2284,
  subject: "Electronics Information",
  question: "What is reactance in AC circuits?",
  answer: "Reactance is the opposition to AC current caused by capacitors (capacitive reactance, Xc) or inductors (inductive reactance, XL). Unlike resistance, reactance depends on frequency and doesn't dissipate power as heat.",
  difficulty: "Hard"
},
{
  id: 2285,
  subject: "Electronics Information",
  question: "In a parallel circuit with 12V and two branches (3Ω and 6Ω), what is the total current?",
  answer: "Find current in each branch: I1 = 12V/3Ω = 4A, I2 = 12V/6Ω = 2A. Total current: I_total = 4A + 2A = 6 amps. (Or: R_total = 2Ω, I = 12V/2Ω = 6A)",
  difficulty: "Hard"
},
{
  id: 2286,
  subject: "Electronics Information",
  question: "What is power factor in AC circuits?",
  answer: "Power factor is the ratio of real power (watts) to apparent power (volt-amps) in an AC circuit. It ranges from 0 to 1 and indicates how efficiently electrical power is converted to useful work. It's affected by reactance.",
  difficulty: "Hard"
},
{
  id: 2287,
  subject: "Electronics Information",
  question: "What is the time constant in an RC circuit?",
  answer: "The time constant (τ) in an RC circuit equals R × C (resistance times capacitance). It represents the time for the capacitor to charge to 63.2% of the supply voltage or discharge to 36.8% of its initial voltage.",
  difficulty: "Hard"
},
{
  id: 2288,
  subject: "Electronics Information",
  question: "How does a transistor function as an amplifier?",
  answer: "A small current at the base controls a much larger current between collector and emitter. Small variations in base current produce proportionally larger variations in collector current, amplifying the input signal.",
  difficulty: "Hard"
},
{
  id: 2289,
  subject: "Electronics Information",
  question: "What is the relationship between voltage ratio and turns ratio in a transformer?",
  answer: "The voltage ratio equals the turns ratio: Vs/Vp = Ns/Np, where Vs and Vp are secondary and primary voltages, and Ns and Np are the number of turns. If Ns/Np = 2, voltage doubles.",
  difficulty: "Hard"
},
{
  id: 2290,
  subject: "Electronics Information",
  question: "A circuit has 15V across a series combination of a 3Ω resistor and an unknown resistor, with 2A current. What is the unknown resistance?",
  answer: "Total R = V/I = 15V/2A = 7.5Ω. Since R_total = R1 + R2, the unknown resistor = 7.5Ω - 3Ω = 4.5 ohms.",
  difficulty: "Hard"
},
{
  id: 2291,
  subject: "Electronics Information",
  question: "What is a Wheatstone bridge used for?",
  answer: "A Wheatstone bridge is a circuit used to accurately measure unknown resistance. It consists of four resistors in a diamond configuration. When the bridge is balanced, the unknown resistance can be calculated from the other three resistances.",
  difficulty: "Hard"
},
{
  id: 2292,
  subject: "Electronics Information",
  question: "Explain the skin effect in conductors.",
  answer: "The skin effect is the tendency of high-frequency AC current to flow primarily near the surface of a conductor rather than uniformly throughout. This effectively increases resistance at higher frequencies because less cross-sectional area is used.",
  difficulty: "Hard"
},
{
  id: 2293,
  subject: "Electronics Information",
  question: "What is the purpose of a decoupling capacitor?",
  answer: "A decoupling (or bypass) capacitor is placed near power supply pins of integrated circuits to filter out noise and stabilize voltage. It provides a local charge reservoir to handle rapid current demands, preventing voltage fluctuations.",
  difficulty: "Hard"
},
{
  id: 2294,
  subject: "Electronics Information",
  question: "Calculate power dissipated in a 10Ω resistor with 5A current.",
  answer: "Using P = I²R: P = (5A)² × 10Ω = 25 × 10 = 250 watts. The resistor dissipates 250 watts of power as heat.",
  difficulty: "Hard"
},
{
  id: 2295,
  subject: "Electronics Information",
  question: "What is the difference between analog and digital signals?",
  answer: "Analog signals are continuous and can have any value within a range (like a sine wave). Digital signals are discrete with only specific values, typically representing binary states (0 and 1, or off and on).",
  difficulty: "Hard"
},
{
  id: 2296,
  subject: "Electronics Information",
  question: "How does a Zener diode differ from a regular diode?",
  answer: "A Zener diode is designed to operate in reverse breakdown mode at a specific voltage (Zener voltage). While regular diodes block reverse current, Zener diodes conduct at their rated reverse voltage, making them useful for voltage regulation.",
  difficulty: "Hard"
},
{
  id: 2297,
  subject: "Electronics Information",
  question: "What is electromagnetic induction?",
  answer: "Electromagnetic induction is the production of voltage across a conductor when it is exposed to a changing magnetic field. This principle is fundamental to transformers, generators, and inductors. Discovered by Michael Faraday.",
  difficulty: "Hard"
},
{
  id: 2298,
  subject: "Electronics Information",
  question: "In a series RLC circuit, what is resonance?",
  answer: "Resonance occurs when inductive reactance equals capacitive reactance, causing them to cancel out. At resonant frequency, impedance is minimum (equals resistance), and current is maximum. This frequency is f = 1/(2π√LC).",
  difficulty: "Hard"
},
{
  id: 2299,
  subject: "Electronics Information",
  question: "What is the maximum power transfer theorem?",
  answer: "The maximum power transfer theorem states that maximum power is delivered from a source to a load when the load resistance equals the source's internal resistance. This is important in impedance matching for efficient power delivery.",
  difficulty: "Hard"
},
{
  id: 2300,
  subject: "Electronics Information",
  question: "Three resistors (10Ω, 20Ω, 30Ω) are in parallel across a 60V source. Calculate total current.",
  answer: "Find currents: I1 = 60/10 = 6A, I2 = 60/20 = 3A, I3 = 60/30 = 2A. Total: I_total = 6 + 3 + 2 = 11 amps. (Or: 1/R_total = 1/10 + 1/20 + 1/30 = 11/60, R = 60/11 = 5.45Ω, I = 60/5.45 = 11A)",
  difficulty: "Hard"
},
{
  id: 2301,
  subject: "Mechanical Comprehension",
  question: "In a first-class lever, where is the fulcrum located relative to the effort and load?",
  answer: "The fulcrum is located BETWEEN the effort and the load. Examples include a seesaw, crowbar, and scissors. This arrangement can provide mechanical advantage depending on the distances from the fulcrum.",
  difficulty: "Easy"
},
{
  id: 2302,
  subject: "Mechanical Comprehension",
  question: "A fixed pulley is attached to a ceiling. If you pull down with 50 pounds of force, how much weight can you lift?",
  answer: "50 pounds. A fixed pulley provides NO mechanical advantage (MA = 1). It only changes the direction of the force. You must pull with a force equal to the weight being lifted.",
  difficulty: "Easy"
},
{
  id: 2303,
  subject: "Mechanical Comprehension",
  question: "If Gear A (10 teeth) drives Gear B (30 teeth), and Gear A rotates at 60 RPM, what is the speed of Gear B?",
  answer: "20 RPM. Gear ratio = 30/10 = 3:1. Speed of Gear B = 60 RPM / 3 = 20 RPM. When a smaller gear drives a larger gear, the larger gear rotates slower but with more torque.",
  difficulty: "Medium"
},
{
  id: 2304,
  subject: "Mechanical Comprehension",
  question: "What is the mechanical advantage of an inclined plane that is 12 feet long and rises 3 feet high?",
  answer: "MA = Length / Height = 12 / 3 = 4. The mechanical advantage is 4:1, meaning you need only 1/4 the force to move an object up the ramp compared to lifting it straight up.",
  difficulty: "Easy"
},
{
  id: 2305,
  subject: "Mechanical Comprehension",
  question: "In a wheel and axle system, the wheel has a radius of 20 inches and the axle has a radius of 4 inches. What is the mechanical advantage?",
  answer: "MA = Wheel Radius / Axle Radius = 20 / 4 = 5. This means you can lift 5 times the force applied to the wheel, but the wheel must move 5 times farther than the axle.",
  difficulty: "Medium"
},
{
  id: 2306,
  subject: "Mechanical Comprehension",
  question: "Which type of friction is greater: static friction or kinetic friction?",
  answer: "Static friction is greater. It takes more force to START moving an object than to KEEP it moving. This is why it's harder to push a heavy box from rest than to keep it sliding.",
  difficulty: "Easy"
},
{
  id: 2307,
  subject: "Mechanical Comprehension",
  question: "If you apply 100 pounds of force to move a box 10 feet, how much work have you done?",
  answer: "Work = Force × Distance = 100 lbs × 10 ft = 1,000 foot-pounds. Work is only done when force causes displacement in the direction of the force.",
  difficulty: "Easy"
},
{
  id: 2308,
  subject: "Mechanical Comprehension",
  question: "A movable pulley system has 2 supporting ropes. If you need to lift a 200-pound weight, how much force must you apply?",
  answer: "100 pounds. MA = number of supporting ropes = 2. Force needed = Weight / MA = 200 / 2 = 100 lbs. However, you must pull twice the distance the load moves.",
  difficulty: "Medium"
},
{
  id: 2309,
  subject: "Mechanical Comprehension",
  question: "In a second-class lever, where is the load located?",
  answer: "The load is located BETWEEN the fulcrum and the effort. Examples include a wheelbarrow, nutcracker, and bottle opener. This arrangement ALWAYS provides mechanical advantage greater than 1.",
  difficulty: "Easy"
},
{
  id: 2310,
  subject: "Mechanical Comprehension",
  question: "If two gears mesh together, and one gear rotates clockwise, which direction does the other gear rotate?",
  answer: "Counterclockwise (opposite direction). When two gears mesh directly, they always rotate in OPPOSITE directions. To make them rotate in the same direction, you need an idler gear between them.",
  difficulty: "Easy"
},
{
  id: 2311,
  subject: "Mechanical Comprehension",
  question: "What is Pascal's Principle in hydraulic systems?",
  answer: "Pressure applied to a confined fluid is transmitted equally and undiminished in all directions throughout the fluid. This principle allows hydraulic systems to multiply force using different piston sizes.",
  difficulty: "Medium"
},
{
  id: 2312,
  subject: "Mechanical Comprehension",
  question: "A hydraulic lift has a small piston with area 2 sq in and a large piston with area 20 sq in. If you apply 50 lbs to the small piston, what force is produced at the large piston?",
  answer: "500 lbs. Force multiplication = Area ratio = 20/2 = 10. Output force = 50 lbs × 10 = 500 lbs. The trade-off is that the small piston must move 10 times farther than the large piston.",
  difficulty: "Hard"
},
{
  id: 2313,
  subject: "Mechanical Comprehension",
  question: "What is a wedge and give two common examples?",
  answer: "A wedge is an inclined plane that moves to separate or lift objects. It converts a force applied to its blunt end into forces perpendicular to its inclined surfaces. Examples: axe, knife, chisel, doorstop.",
  difficulty: "Easy"
},
{
  id: 2314,
  subject: "Mechanical Comprehension",
  question: "State Newton's First Law of Motion.",
  answer: "An object at rest stays at rest, and an object in motion stays in motion at constant velocity, unless acted upon by an external force. This is the law of INERTIA - objects resist changes in their state of motion.",
  difficulty: "Easy"
},
{
  id: 2315,
  subject: "Mechanical Comprehension",
  question: "In a third-class lever, where is the effort applied?",
  answer: "The effort is applied BETWEEN the fulcrum and the load. Examples include tweezers, fishing rods, and human forearms. This arrangement provides NO mechanical advantage (MA < 1) but increases speed and range of motion.",
  difficulty: "Easy"
},
{
  id: 2316,
  subject: "Mechanical Comprehension",
  question: "A block and tackle system has 4 supporting ropes. What is the mechanical advantage?",
  answer: "MA = 4. The mechanical advantage equals the number of rope segments supporting the movable pulley. You need 1/4 the force to lift the load, but must pull 4 times the distance.",
  difficulty: "Easy"
},
{
  id: 2317,
  subject: "Mechanical Comprehension",
  question: "If a 10-tooth gear meshes with a 40-tooth gear, what is the gear ratio and which gear has more torque?",
  answer: "Gear ratio = 40:10 = 4:1. The 40-tooth gear (larger gear) has 4 times MORE torque but rotates at 1/4 the speed. In gear systems, speed and torque are inversely related.",
  difficulty: "Medium"
},
{
  id: 2318,
  subject: "Mechanical Comprehension",
  question: "What is the definition of mechanical advantage?",
  answer: "Mechanical Advantage (MA) = Output Force / Input Force. It measures how much a machine multiplies force. MA > 1 means force multiplication; MA < 1 means speed/distance multiplication; MA = 1 means only direction change.",
  difficulty: "Easy"
},
{
  id: 2319,
  subject: "Mechanical Comprehension",
  question: "A lever has the fulcrum 2 feet from the load and 8 feet from the effort. What is the mechanical advantage?",
  answer: "MA = Effort Distance / Load Distance = 8 / 2 = 4. You can lift 4 times the weight applied, but the effort must move 4 times farther than the load moves.",
  difficulty: "Medium"
},
{
  id: 2320,
  subject: "Mechanical Comprehension",
  question: "What is Archimedes' Principle?",
  answer: "An object submerged in a fluid experiences an upward buoyant force equal to the weight of the fluid displaced. This explains why objects float or sink and is the basis of ship buoyancy.",
  difficulty: "Medium"
},
{
  id: 2321,
  subject: "Mechanical Comprehension",
  question: "A screw is really what type of simple machine wrapped around a cylinder?",
  answer: "An inclined plane. The threads of a screw are an inclined plane wrapped helically around a cylinder. This converts rotational motion into linear motion and provides high mechanical advantage.",
  difficulty: "Easy"
},
{
  id: 2322,
  subject: "Mechanical Comprehension",
  question: "State Newton's Second Law of Motion with its formula.",
  answer: "Force = Mass × Acceleration (F = ma). The acceleration of an object is directly proportional to the net force acting on it and inversely proportional to its mass. Greater force = greater acceleration; greater mass = less acceleration.",
  difficulty: "Medium"
},
{
  id: 2323,
  subject: "Mechanical Comprehension",
  question: "What is the difference between speed and velocity?",
  answer: "Speed is a scalar (magnitude only) - how fast something moves. Velocity is a vector (magnitude AND direction) - how fast and in what direction. Example: 60 mph is speed; 60 mph north is velocity.",
  difficulty: "Easy"
},
{
  id: 2324,
  subject: "Mechanical Comprehension",
  question: "If three gears are in a line (A meshes with B, B meshes with C), and Gear A rotates clockwise, which direction does Gear C rotate?",
  answer: "Clockwise. Each meshing reverses direction: A (CW) → B (CCW) → C (CW). Gear B acts as an idler gear. With an ODD number of gears, the first and last rotate in the SAME direction.",
  difficulty: "Medium"
},
{
  id: 2325,
  subject: "Mechanical Comprehension",
  question: "What is the center of gravity?",
  answer: "The point where all the weight of an object appears to be concentrated. It's the balance point - if you support an object at its center of gravity, it will remain in equilibrium. Also called center of mass.",
  difficulty: "Easy"
},
{
  id: 2326,
  subject: "Mechanical Comprehension",
  question: "In a fluid at rest, how does pressure change with depth?",
  answer: "Pressure INCREASES with depth. Pressure = Density × Gravity × Depth. The deeper you go in a fluid, the more weight of fluid is above you, creating greater pressure. This is why deep-sea divers experience high pressure.",
  difficulty: "Medium"
},
{
  id: 2327,
  subject: "Mechanical Comprehension",
  question: "What is tension in structural mechanics?",
  answer: "Tension is a pulling force that acts to stretch or elongate a material. It pulls away from the material at both ends. Examples: a rope supporting a weight, a cable in a suspension bridge.",
  difficulty: "Easy"
},
{
  id: 2328,
  subject: "Mechanical Comprehension",
  question: "What is compression in structural mechanics?",
  answer: "Compression is a pushing force that acts to squeeze or shorten a material. It pushes into the material from both ends. Examples: a column supporting a building, a car suspension spring under load.",
  difficulty: "Easy"
},
{
  id: 2329,
  subject: "Mechanical Comprehension",
  question: "A 150-pound person stands 6 feet from the fulcrum of a seesaw. A 100-pound person sits on the other side. How far from the fulcrum must the 100-pound person sit to balance?",
  answer: "9 feet. For balance: Force₁ × Distance₁ = Force₂ × Distance₂. Therefore: 150 × 6 = 100 × Distance₂. Distance₂ = 900 / 100 = 9 feet. The lighter person must sit farther from the fulcrum.",
  difficulty: "Hard"
},
{
  id: 2330,
  subject: "Mechanical Comprehension",
  question: "What is momentum and what is its formula?",
  answer: "Momentum is the quantity of motion an object has. Momentum = Mass × Velocity (p = mv). A heavy object moving slowly can have the same momentum as a light object moving fast. Momentum is conserved in collisions.",
  difficulty: "Medium"
},
{
  id: 2331,
  subject: "Mechanical Comprehension",
  question: "State Newton's Third Law of Motion.",
  answer: "For every action, there is an equal and opposite reaction. Forces always occur in pairs - if object A exerts a force on object B, then object B exerts an equal force in the opposite direction on object A.",
  difficulty: "Easy"
},
{
  id: 2332,
  subject: "Mechanical Comprehension",
  question: "What is the formula for work and when is work NOT done?",
  answer: "Work = Force × Distance × cos(θ), where θ is the angle between force and motion. NO work is done when: (1) there's no motion, (2) force is perpendicular to motion (like carrying something horizontally).",
  difficulty: "Medium"
},
{
  id: 2333,
  subject: "Mechanical Comprehension",
  question: "A compound pulley system has a theoretical mechanical advantage of 6 but an actual mechanical advantage of 5. What explains this difference?",
  answer: "Friction and the weight of the pulleys themselves reduce efficiency. Actual MA is always less than ideal MA due to friction in the pulleys, rope stiffness, and the weight of the moving components.",
  difficulty: "Hard"
},
{
  id: 2334,
  subject: "Mechanical Comprehension",
  question: "What is shear stress?",
  answer: "Shear is a force that causes layers of material to slide parallel to each other in opposite directions, like scissors cutting paper. It acts parallel to the surface, causing deformation without pulling apart or compressing.",
  difficulty: "Medium"
},
{
  id: 2335,
  subject: "Mechanical Comprehension",
  question: "If you increase the length of an inclined plane while keeping the height the same, what happens to the mechanical advantage?",
  answer: "The mechanical advantage INCREASES. MA = Length / Height. A longer, gentler ramp requires less force to move objects up it, but you must push the object a greater distance. Trade-off: less force but more distance.",
  difficulty: "Medium"
},
{
  id: 2336,
  subject: "Mechanical Comprehension",
  question: "What is torsion?",
  answer: "Torsion is a twisting force that causes rotation around an axis, like turning a screwdriver or wringing a towel. It creates shear stress throughout the material and can cause objects to twist or spiral.",
  difficulty: "Easy"
},
{
  id: 2337,
  subject: "Mechanical Comprehension",
  question: "In a wheel and axle, where do you apply force for mechanical advantage, and where for speed advantage?",
  answer: "For FORCE advantage (MA > 1): apply force to the WHEEL (larger radius), output at axle. For SPEED advantage: apply force to the AXLE, output at wheel. Example: doorknob (force advantage), car wheels (speed advantage).",
  difficulty: "Hard"
},
{
  id: 2338,
  subject: "Mechanical Comprehension",
  question: "What is the relationship between pressure, force, and area?",
  answer: "Pressure = Force / Area. For the same force, smaller area = higher pressure; larger area = lower pressure. This is why a sharp knife cuts better (small area = high pressure) and snowshoes prevent sinking (large area = low pressure).",
  difficulty: "Easy"
},
{
  id: 2339,
  subject: "Mechanical Comprehension",
  question: "What is inertia?",
  answer: "Inertia is the tendency of an object to resist changes in its motion. Objects at rest tend to stay at rest; objects in motion tend to stay in motion at constant velocity. Mass is the measure of inertia - more mass means more inertia.",
  difficulty: "Easy"
},
{
  id: 2340,
  subject: "Mechanical Comprehension",
  question: "A gear train has three gears: A (10 teeth) drives B (30 teeth), and B is on the same shaft as C (15 teeth), which drives D (45 teeth). What is the overall gear ratio?",
  answer: "Overall ratio = (30/10) × (45/15) = 3 × 3 = 9:1. Multiply individual ratios in compound gear trains. If A rotates at 180 RPM, D rotates at 180/9 = 20 RPM with 9 times the torque.",
  difficulty: "Hard"
},
{
  id: 2341,
  subject: "Mechanical Comprehension",
  question: "What is Hooke's Law for springs?",
  answer: "Force = Spring Constant × Distance (F = kx). The force needed to stretch or compress a spring is proportional to the distance stretched/compressed. Stiffer springs have higher k values and require more force.",
  difficulty: "Medium"
},
{
  id: 2342,
  subject: "Mechanical Comprehension",
  question: "What is power and how is it calculated?",
  answer: "Power is the RATE of doing work. Power = Work / Time or Power = Force × Velocity. It measures how quickly energy is transferred or work is done. Units: watts (joules/second) or horsepower (foot-pounds/second).",
  difficulty: "Medium"
},
{
  id: 2343,
  subject: "Mechanical Comprehension",
  question: "Will an object with density less than water sink or float?",
  answer: "FLOAT. Objects less dense than water (density < 1.0 g/cm³) float; objects more dense than water sink. This is why ice floats (density 0.92), wood floats (varies), and steel sinks (density 7.8).",
  difficulty: "Easy"
},
{
  id: 2344,
  subject: "Mechanical Comprehension",
  question: "In a first-class lever, if the fulcrum is moved closer to the load, what happens to the mechanical advantage?",
  answer: "The mechanical advantage INCREASES. MA = Effort Distance / Load Distance. Moving the fulcrum closer to the load increases the effort distance and decreases the load distance, making the ratio larger. You gain more force multiplication.",
  difficulty: "Medium"
},
{
  id: 2345,
  subject: "Mechanical Comprehension",
  question: "What is the difference between weight and mass?",
  answer: "MASS is the amount of matter in an object (measured in kg or lbs-mass) and never changes. WEIGHT is the force of gravity on that mass (Weight = Mass × Gravity) and changes with location. Mass is constant; weight varies.",
  difficulty: "Easy"
},
{
  id: 2346,
  subject: "Mechanical Comprehension",
  question: "If two objects of different masses are dropped from the same height (ignoring air resistance), which hits the ground first?",
  answer: "They hit at the SAME TIME. In a vacuum, all objects fall at the same rate regardless of mass (acceleration = 9.8 m/s²). Gravity accelerates all masses equally. This was proven by Galileo's famous experiment.",
  difficulty: "Easy"
},
{
  id: 2347,
  subject: "Mechanical Comprehension",
  question: "What is the mechanical advantage of a single movable pulley?",
  answer: "MA = 2. A single movable pulley has 2 supporting ropes, so the load is shared between them. You pull with half the force but must pull twice the distance. It provides force advantage but not direction change convenience.",
  difficulty: "Easy"
},
{
  id: 2348,
  subject: "Mechanical Comprehension",
  question: "What happens to the volume of a gas when pressure increases at constant temperature?",
  answer: "Volume DECREASES. This is Boyle's Law: Pressure × Volume = Constant (at constant temperature). Pressure and volume are inversely related. Doubling pressure halves volume; halving pressure doubles volume.",
  difficulty: "Medium"
},
{
  id: 2349,
  subject: "Mechanical Comprehension",
  question: "A 50-pound force is applied to a lever 10 feet from the fulcrum. What is the maximum weight that can be lifted 2 feet on the other side of the fulcrum?",
  answer: "250 pounds. Using lever principle: Force₁ × Distance₁ = Force₂ × Distance₂. Therefore: 50 × 10 = Load × 2. Load = 500 / 2 = 250 lbs. The mechanical advantage is 10/2 = 5.",
  difficulty: "Medium"
},
{
  id: 2350,
  subject: "Mechanical Comprehension",
  question: "What is kinetic energy and what is its formula?",
  answer: "Kinetic energy is the energy of motion. KE = (1/2) × Mass × Velocity². It depends on both mass and velocity, but velocity has a squared effect. Doubling mass doubles KE; doubling velocity QUADRUPLES KE.",
  difficulty: "Medium"
},
{
  id: 2351,
  subject: "Mechanical Comprehension",
  question: "What is potential energy?",
  answer: "Potential energy is stored energy due to position or configuration. Gravitational PE = Mass × Gravity × Height. Objects higher up have more PE. Elastic PE is stored in stretched/compressed springs. PE converts to KE when released.",
  difficulty: "Easy"
},
{
  id: 2352,
  subject: "Mechanical Comprehension",
  question: "In a belt drive system connecting two pulleys, if the driver pulley has a 4-inch diameter and the driven pulley has a 12-inch diameter, what is the speed ratio?",
  answer: "3:1 reduction. Speed ratio = Driver Diameter / Driven Diameter = 4 / 12 = 1:3. The driven pulley rotates at 1/3 the speed of the driver but has 3 times the torque. Larger driven pulley = slower speed, more torque.",
  difficulty: "Hard"
},
{
  id: 2353,
  subject: "Mechanical Comprehension",
  question: "What is the advantage of using multiple simple machines together?",
  answer: "The total mechanical advantage is the PRODUCT of individual mechanical advantages. Example: A lever (MA=4) combined with a pulley system (MA=3) gives total MA = 4 × 3 = 12. This multiplies force advantage significantly.",
  difficulty: "Medium"
},
{
  id: 2354,
  subject: "Mechanical Comprehension",
  question: "What is efficiency in mechanical systems?",
  answer: "Efficiency = (Work Output / Work Input) × 100% or (Actual MA / Ideal MA) × 100%. No machine is 100% efficient due to friction and other losses. Efficiency tells you what percentage of input energy is usefully transferred.",
  difficulty: "Medium"
},
{
  id: 2355,
  subject: "Mechanical Comprehension",
  question: "Why do liquids transmit pressure uniformly while gases do not?",
  answer: "Liquids are nearly INCOMPRESSIBLE - their molecules are close together and resist volume change, so pressure transmits instantly and uniformly (Pascal's Principle). Gases are COMPRESSIBLE - they can be squeezed, so pressure transmission is not uniform.",
  difficulty: "Hard"
},
{
  id: 2356,
  subject: "Mechanical Comprehension",
  question: "What is acceleration?",
  answer: "Acceleration is the rate of change of velocity. Acceleration = Change in Velocity / Time. It's a vector (has direction). Speeding up, slowing down, or changing direction are ALL forms of acceleration. Units: m/s² or ft/s².",
  difficulty: "Easy"
},
{
  id: 2357,
  subject: "Mechanical Comprehension",
  question: "A screw has threads that are close together compared to one with widely spaced threads. Which requires less force to turn?",
  answer: "The screw with CLOSE threads (fine thread). It has a longer inclined plane wrapped around it, giving higher mechanical advantage. Less force is needed per turn, but more turns are required. Trade-off: less force but more distance/time.",
  difficulty: "Medium"
},
{
  id: 2358,
  subject: "Mechanical Comprehension",
  question: "What determines whether a first-class lever provides mechanical advantage?",
  answer: "The relative distances from the fulcrum. If the effort distance > load distance, MA > 1 (force advantage). If effort distance < load distance, MA < 1 (speed advantage). If distances are equal, MA = 1 (only direction change).",
  difficulty: "Medium"
},
{
  id: 2359,
  subject: "Mechanical Comprehension",
  question: "What is hydraulic pressure and how does it relate to force and area?",
  answer: "Hydraulic pressure is force per unit area in a fluid. Pressure = Force / Area. In hydraulic systems, the SAME pressure acts on both pistons, but different areas create different forces: F₁/A₁ = F₂/A₂. This allows force multiplication.",
  difficulty: "Hard"
},
{
  id: 2360,
  subject: "Mechanical Comprehension",
  question: "What is the purpose of an idler gear?",
  answer: "An idler gear changes the DIRECTION of rotation without changing the speed ratio. It allows the first and last gears to rotate in the SAME direction instead of opposite directions. It doesn't affect the overall gear ratio calculation.",
  difficulty: "Medium"
},
{
  id: 2361,
  subject: "Mechanical Comprehension",
  question: "If you lift a 100-pound weight 5 feet high in 10 seconds, what is the power output?",
  answer: "50 foot-pounds per second. Work = Force × Distance = 100 × 5 = 500 ft-lbs. Power = Work / Time = 500 / 10 = 50 ft-lbs/sec. (This equals about 0.09 horsepower, since 1 HP = 550 ft-lbs/sec.)",
  difficulty: "Hard"
},
{
  id: 2362,
  subject: "Mechanical Comprehension",
  question: "What is the mechanical advantage of a wedge?",
  answer: "MA = Length of Wedge / Thickness. A long, thin wedge has high MA and splits materials easily with less force. A short, thick wedge has low MA and requires more force but splits faster. The wedge converts horizontal force into vertical splitting force.",
  difficulty: "Medium"
},
{
  id: 2363,
  subject: "Mechanical Comprehension",
  question: "What is the law of conservation of energy?",
  answer: "Energy cannot be created or destroyed, only converted from one form to another. The total energy in a closed system remains constant. Example: Potential energy converts to kinetic energy as an object falls, but total energy stays the same.",
  difficulty: "Easy"
},
{
  id: 2364,
  subject: "Mechanical Comprehension",
  question: "What type of stress does a bolt experience when tightening a nut?",
  answer: "TORSION (twisting) while turning, then TENSION (pulling) when tight. The bolt shaft is twisted during installation, then stretched (under tension) when the nut is tightened, clamping the parts together. Some SHEAR stress may also be present.",
  difficulty: "Medium"
},
{
  id: 2365,
  subject: "Mechanical Comprehension",
  question: "Why is it easier to push a box up a ramp than to lift it straight up?",
  answer: "The ramp (inclined plane) provides mechanical advantage by trading distance for force. You apply less force but push over a longer distance. The work (Force × Distance) is theoretically the same, but less force is needed at any moment.",
  difficulty: "Easy"
},
{
  id: 2366,
  subject: "Mechanical Comprehension",
  question: "What happens to the speed and torque when a small gear drives a large gear?",
  answer: "SPEED DECREASES, TORQUE INCREASES. The large gear rotates slower but with more turning force. Speed ratio = Large teeth / Small teeth. Torque ratio is the inverse. This is speed reduction with torque multiplication.",
  difficulty: "Easy"
},
{
  id: 2367,
  subject: "Mechanical Comprehension",
  question: "A spring with spring constant k = 100 lb/ft is compressed 0.5 feet. What force is required?",
  answer: "50 pounds. Using Hooke's Law: F = kx = 100 × 0.5 = 50 lbs. The force is proportional to compression distance. Compress it 1 foot and you need 100 lbs; compress it 0.25 feet and you need 25 lbs.",
  difficulty: "Hard"
},
{
  id: 2368,
  subject: "Mechanical Comprehension",
  question: "What is the difference between elastic and plastic deformation?",
  answer: "ELASTIC deformation is temporary - the material returns to its original shape when the force is removed (like a rubber band). PLASTIC deformation is permanent - the material stays deformed (like bending a paperclip). Beyond elastic limit = permanent damage.",
  difficulty: "Medium"
},
{
  id: 2369,
  subject: "Mechanical Comprehension",
  question: "What is a compound machine?",
  answer: "A compound machine is made of two or more simple machines working together. Examples: bicycle (wheels, levers, pulleys), car jack (screw and lever), scissors (two levers and wedges). The total MA is the product of individual MAs.",
  difficulty: "Easy"
},
{
  id: 2370,
  subject: "Mechanical Comprehension",
  question: "In a pneumatic system, what provides the force transmission?",
  answer: "Compressed AIR (or other gas). Pneumatic systems use compressed gas to transmit power and motion. Unlike hydraulics (liquids), pneumatics use compressible gases. Common in air tools, air brakes, and factory automation. Less precise than hydraulics due to compressibility.",
  difficulty: "Easy"
},
{
  id: 2371,
  subject: "Mechanical Comprehension",
  question: "What is the relationship between mass and inertia?",
  answer: "Mass IS the measure of inertia. Greater mass = greater inertia = greater resistance to changes in motion. A bowling ball (high mass) resists acceleration more than a tennis ball (low mass). It takes more force to start or stop a massive object.",
  difficulty: "Easy"
},
{
  id: 2372,
  subject: "Mechanical Comprehension",
  question: "A 6-foot crowbar has the fulcrum 1 foot from the load. If you push down with 40 pounds at the long end, what load can you lift?",
  answer: "200 pounds. Effort distance = 5 ft, Load distance = 1 ft. Using lever principle: 40 × 5 = Load × 1. Load = 200 lbs. The MA = 5/1 = 5. First-class lever with high mechanical advantage.",
  difficulty: "Hard"
},
{
  id: 2373,
  subject: "Mechanical Comprehension",
  question: "What is viscosity in fluids?",
  answer: "Viscosity is a fluid's resistance to flow - its 'thickness.' High viscosity fluids (honey, molasses) flow slowly and resist motion. Low viscosity fluids (water, gasoline) flow easily. Viscosity affects pressure loss in pipes and lubrication effectiveness.",
  difficulty: "Medium"
},
{
  id: 2374,
  subject: "Mechanical Comprehension",
  question: "What is the mechanical advantage formula for a lever?",
  answer: "MA = Effort Distance / Load Distance, OR MA = Load Force / Effort Force. Both formulas give the same result for an ideal lever without friction. The distances are measured from the fulcrum to where forces are applied.",
  difficulty: "Easy"
},
{
  id: 2375,
  subject: "Mechanical Comprehension",
  question: "Why do race car drivers lean into curves?",
  answer: "To counteract CENTRIFUGAL FORCE (or more accurately, to provide centripetal acceleration). When turning, inertia wants to keep them moving straight. Leaning shifts their center of gravity to maintain balance and prevent tipping outward. The same principle applies to motorcycles and bicycles.",
  difficulty: "Medium"
},
{
  id: 2376,
  subject: "Mechanical Comprehension",
  question: "What is the difference between hardness and toughness in materials?",
  answer: "HARDNESS is resistance to scratching, indentation, or wear (ability to resist surface deformation). TOUGHNESS is resistance to fracture or breaking (ability to absorb energy before breaking). Diamond is extremely hard but not very tough; steel can be both hard and tough.",
  difficulty: "Hard"
},
{
  id: 2377,
  subject: "Mechanical Comprehension",
  question: "If atmospheric pressure is about 14.7 psi at sea level, what is the total pressure 33 feet underwater?",
  answer: "About 29.4 psi (or 2 atmospheres). Every 33 feet of seawater adds approximately 14.7 psi (1 atmosphere) of pressure. Total pressure = Atmospheric pressure + Water pressure = 14.7 + 14.7 = 29.4 psi. Pressure doubles at 33 feet depth.",
  difficulty: "Hard"
},
{
  id: 2378,
  subject: "Mechanical Comprehension",
  question: "What is the principle of moments in balanced levers?",
  answer: "Clockwise moments = Counterclockwise moments. Moment (torque) = Force × Distance from fulcrum. For balance: F₁ × D₁ = F₂ × D₂. A small force far from fulcrum can balance a large force close to fulcrum.",
  difficulty: "Medium"
},
{
  id: 2379,
  subject: "Mechanical Comprehension",
  question: "What is a cam and what does it do?",
  answer: "A cam is a rotating machine part with an irregular shape that converts rotary motion into linear (reciprocating) motion. As the cam rotates, its profile pushes a follower up and down. Used in engines to open/close valves and in many automated machines.",
  difficulty: "Medium"
},
{
  id: 2380,
  subject: "Mechanical Comprehension",
  question: "What is the difference between stress and strain in materials?",
  answer: "STRESS is the internal FORCE per unit area in a material (Stress = Force/Area). STRAIN is the resulting DEFORMATION (change in length / original length). Stress causes strain. Strong materials can withstand high stress before failing.",
  difficulty: "Medium"
},
{
  id: 2381,
  subject: "Mechanical Comprehension",
  question: "Why are wide tires better than narrow tires in snow?",
  answer: "Wide tires have more SURFACE AREA, which DECREASES pressure (Pressure = Force/Area). Lower pressure prevents sinking into soft surfaces like snow or mud. Conversely, narrow tires concentrate pressure, which is better on ice for breaking through to grip.",
  difficulty: "Easy"
},
{
  id: 2382,
  subject: "Mechanical Comprehension",
  question: "What is centripetal force?",
  answer: "The inward force required to keep an object moving in a circular path. Without centripetal force, inertia would make objects fly off in a straight line. Example: string tension keeps a ball swinging in circles; friction keeps cars turning on curves.",
  difficulty: "Medium"
},
{
  id: 2383,
  subject: "Mechanical Comprehension",
  question: "A driver gear has 20 teeth and rotates at 100 RPM. The driven gear rotates at 50 RPM. How many teeth does the driven gear have?",
  answer: "40 teeth. Using speed ratio: Driver RPM / Driven RPM = Driven Teeth / Driver Teeth. Therefore: 100 / 50 = Driven Teeth / 20. Driven Teeth = 2 × 20 = 40 teeth. The driven gear is twice as large and rotates at half speed.",
  difficulty: "Hard"
},
{
  id: 2384,
  subject: "Mechanical Comprehension",
  question: "What is bearing friction and why are bearings used?",
  answer: "Bearing friction is friction between rotating shafts and their supports. Bearings (ball bearings, roller bearings) REDUCE this friction by replacing sliding friction with rolling friction. This improves efficiency, reduces wear, and allows smoother rotation.",
  difficulty: "Easy"
},
{
  id: 2385,
  subject: "Mechanical Comprehension",
  question: "What happens to water pressure at a given depth if you make the container wider?",
  answer: "Pressure STAYS THE SAME. Pressure in a fluid depends only on DEPTH, not container shape or width. Pressure = Density × Gravity × Depth. Wider containers have more total force on the bottom, but pressure (force per unit area) is unchanged.",
  difficulty: "Medium"
},
{
  id: 2386,
  subject: "Mechanical Comprehension",
  question: "What is torque?",
  answer: "Torque is rotational force - the tendency of a force to cause rotation around an axis. Torque = Force × Distance from axis (perpendicular distance). Like a wrench: more force or a longer wrench increases torque. Units: foot-pounds or Newton-meters.",
  difficulty: "Easy"
},
{
  id: 2387,
  subject: "Mechanical Comprehension",
  question: "In a block and tackle with 6 supporting ropes, if you pull the rope 12 feet, how far does the load rise?",
  answer: "2 feet. Distance moved by load = Rope pulled / Number of supporting ropes = 12 / 6 = 2 feet. The mechanical advantage (MA = 6) means you pull 6 times farther than the load moves, but with 1/6 the force.",
  difficulty: "Medium"
},
{
  id: 2388,
  subject: "Mechanical Comprehension",
  question: "What is the purpose of lubrication in machines?",
  answer: "Lubrication REDUCES FRICTION between moving parts by creating a thin film of oil or grease that prevents direct metal-to-metal contact. This reduces wear, heat generation, and energy loss, while extending machine life and improving efficiency.",
  difficulty: "Easy"
},
{
  id: 2389,
  subject: "Mechanical Comprehension",
  question: "What is the relationship between force, pressure, and area in hydraulic systems?",
  answer: "Force = Pressure × Area (F = P × A). For the SAME pressure: larger area produces MORE force; smaller area produces LESS force. Hydraulic systems exploit this: small piston creates pressure; large piston uses same pressure to produce multiplied force.",
  difficulty: "Medium"
},
{
  id: 2390,
  subject: "Mechanical Comprehension",
  question: "Why does a ship made of steel float while a steel block sinks?",
  answer: "The SHIP has a HOLLOW design that displaces a large volume of water, making its AVERAGE density less than water. The steel block is solid, so its density (7.8 g/cm³) exceeds water (1.0 g/cm³) and it sinks. It's about average density, not just material density.",
  difficulty: "Medium"
},
{
  id: 2391,
  subject: "Mechanical Comprehension",
  question: "What is the difference between a fixed pulley and a movable pulley?",
  answer: "FIXED pulley: attached to support, doesn't move, MA = 1, only changes direction. MOVABLE pulley: moves with the load, MA = 2 (minimum), provides force advantage but not convenient direction change. Combining both gives best results.",
  difficulty: "Easy"
},
{
  id: 2392,
  subject: "Mechanical Comprehension",
  question: "What is the purpose of a flywheel?",
  answer: "A flywheel stores rotational kinetic energy to smooth out variations in rotational speed. Its large mass and inertia resist changes in rotation. Used in engines to maintain steady speed between power strokes and in machinery to store energy for peak demands.",
  difficulty: "Medium"
},
{
  id: 2393,
  subject: "Mechanical Comprehension",
  question: "What is elasticity in materials?",
  answer: "Elasticity is the ability of a material to return to its original shape after deformation when the force is removed. Elastic materials (rubber, spring steel) deform under load but bounce back. Within the elastic limit, deformation is temporary and proportional to force (Hooke's Law).",
  difficulty: "Easy"
},
{
  id: 2394,
  subject: "Mechanical Comprehension",
  question: "If two identical gears mesh together, what is the mechanical advantage?",
  answer: "MA = 1 (no advantage). Equal-sized gears rotate at the SAME speed with SAME torque. The only change is DIRECTION - they rotate opposite to each other. Used when you need to reverse rotation direction without changing speed or torque.",
  difficulty: "Easy"
},
{
  id: 2395,
  subject: "Mechanical Comprehension",
  question: "What is the advantage of using a longer wrench to loosen a tight bolt?",
  answer: "Greater TORQUE. Torque = Force × Distance. A longer wrench increases the distance from the bolt (axis of rotation), so the same force produces more torque. Doubling the wrench length doubles the torque, making it easier to loosen tight fasteners.",
  difficulty: "Easy"
},
{
  id: 2396,
  subject: "Mechanical Comprehension",
  question: "What is specific gravity?",
  answer: "Specific gravity is the ratio of a substance's density to water's density (at 4°C). It's dimensionless. Specific gravity > 1 means denser than water (sinks); < 1 means less dense (floats). Example: lead = 11.3, wood = 0.6, ice = 0.92.",
  difficulty: "Hard"
},
{
  id: 2397,
  subject: "Mechanical Comprehension",
  question: "In a second-class lever like a wheelbarrow, where is the mechanical advantage always?",
  answer: "ALWAYS greater than 1 (always provides force advantage). The load is between fulcrum and effort, so effort distance is ALWAYS longer than load distance. MA = Effort Distance / Load Distance. This arrangement always multiplies force but reduces distance/speed.",
  difficulty: "Medium"
},
{
  id: 2398,
  subject: "Mechanical Comprehension",
  question: "What is the difference between atmospheric pressure and gauge pressure?",
  answer: "ATMOSPHERIC pressure is the absolute pressure of the air (about 14.7 psi at sea level). GAUGE pressure measures pressure ABOVE atmospheric (gauge = 0 at atmospheric pressure). Example: Tire gauge reads 30 psi; absolute pressure = 30 + 14.7 = 44.7 psi.",
  difficulty: "Hard"
},
{
  id: 2399,
  subject: "Mechanical Comprehension",
  question: "What is a rack and pinion system?",
  answer: "A gear (pinion) meshing with a flat, toothed bar (rack). It converts ROTARY motion to LINEAR motion or vice versa. When the pinion rotates, the rack moves in a straight line. Used in steering systems, railroad switches, and linear actuators.",
  difficulty: "Medium"
},
{
  id: 2400,
  subject: "Mechanical Comprehension",
  question: "Why do machine parts fail more often at holes, notches, or corners?",
  answer: "STRESS CONCENTRATION. Holes, notches, sharp corners, and sudden changes in cross-section create concentrated stress points where stress is much higher than in surrounding areas. These are weak points where cracks initiate and failure begins. Rounded corners reduce stress concentration.",
  difficulty: "Hard"
},
{
  id: 2401,
  subject: "Auto & Shop Information",
  question: "What are the four strokes in a 4-stroke engine cycle?",
  answer: "The four strokes are: 1) Intake - piston moves down, intake valve opens, air-fuel mixture enters; 2) Compression - piston moves up, both valves closed, mixture compressed; 3) Power - spark ignites mixture, explosion pushes piston down; 4) Exhaust - piston moves up, exhaust valve opens, burned gases expelled.",
  difficulty: "Medium"
},
{
  id: 2402,
  subject: "Auto & Shop Information",
  question: "What is the primary function of a car's radiator?",
  answer: "The radiator dissipates heat from the engine coolant. Hot coolant flows from the engine through the radiator's tubes, where air flowing through the fins cools it down before it returns to the engine. This prevents the engine from overheating.",
  difficulty: "Easy"
},
{
  id: 2403,
  subject: "Auto & Shop Information",
  question: "What does the alternator do in a vehicle?",
  answer: "The alternator generates electrical power while the engine is running. It converts mechanical energy from the engine into electrical energy to recharge the battery and power the vehicle's electrical systems (lights, radio, etc.). It produces alternating current (AC) that is converted to direct current (DC).",
  difficulty: "Easy"
},
{
  id: 2404,
  subject: "Auto & Shop Information",
  question: "What is the difference between a Phillips screwdriver and a flathead screwdriver?",
  answer: "A flathead (or slotted) screwdriver has a single flat blade that fits into a straight slot. A Phillips screwdriver has a cross-shaped (+) tip that fits into a corresponding cross-shaped recess. Phillips screws provide better grip and are less likely to slip out (cam out) under high torque.",
  difficulty: "Easy"
},
{
  id: 2405,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a thermostat in an engine's cooling system?",
  answer: "The thermostat regulates coolant flow to maintain optimal engine temperature (usually around 195°F). When the engine is cold, it stays closed to help the engine warm up quickly. Once the engine reaches operating temperature, it opens to allow coolant to flow through the radiator for cooling.",
  difficulty: "Medium"
},
{
  id: 2406,
  subject: "Auto & Shop Information",
  question: "What tool would you use to grip and turn pipes or round objects?",
  answer: "A pipe wrench is designed specifically for gripping and turning pipes and other round objects. It has serrated jaws that grip tighter as more pressure is applied, and one jaw is adjustable to accommodate different pipe sizes.",
  difficulty: "Easy"
},
{
  id: 2407,
  subject: "Auto & Shop Information",
  question: "What is the difference between a disc brake and a drum brake?",
  answer: "Disc brakes use brake pads that squeeze a flat metal rotor (disc) to create friction. Drum brakes use brake shoes that press outward against the inside of a rotating drum. Disc brakes generally provide better stopping power, dissipate heat better, and are less prone to brake fade than drum brakes.",
  difficulty: "Medium"
},
{
  id: 2408,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a ball-peen hammer?",
  answer: "A ball-peen hammer has a flat striking face on one side and a rounded ball on the other. It's primarily used for metalworking tasks such as shaping metal, riveting, and striking punches and chisels. The ball end is used for peening (rounding off) rivets and shaping metal.",
  difficulty: "Easy"
},
{
  id: 2409,
  subject: "Auto & Shop Information",
  question: "What does a car's starter motor do?",
  answer: "The starter motor is an electric motor that cranks (turns) the engine to begin the combustion process. When you turn the ignition key, the starter engages with the engine's flywheel and rotates it until the engine starts running on its own power.",
  difficulty: "Easy"
},
{
  id: 2410,
  subject: "Auto & Shop Information",
  question: "What is the function of spark plugs in a gasoline engine?",
  answer: "Spark plugs ignite the compressed air-fuel mixture in the engine's cylinders. They create an electric spark at precisely the right time to ignite the mixture, causing the combustion that powers the engine. Each cylinder typically has one spark plug.",
  difficulty: "Easy"
},
{
  id: 2411,
  subject: "Auto & Shop Information",
  question: "What is a C-clamp used for?",
  answer: "A C-clamp is a fastening tool used to hold objects tightly together while working on them. It has a C-shaped frame with a screw mechanism that tightens to apply pressure. Common uses include holding wood pieces during gluing, securing workpieces for drilling or cutting, and general clamping tasks.",
  difficulty: "Easy"
},
{
  id: 2412,
  subject: "Auto & Shop Information",
  question: "What is the difference between a crosscut saw and a ripsaw?",
  answer: "A crosscut saw is designed to cut wood across (perpendicular to) the grain, with teeth shaped like knives to slice through fibers. A ripsaw cuts along (parallel to) the grain, with chisel-like teeth that tear wood fibers apart. Crosscut saws have more teeth per inch than ripsaws.",
  difficulty: "Medium"
},
{
  id: 2413,
  subject: "Auto & Shop Information",
  question: "What does the master cylinder do in a brake system?",
  answer: "The master cylinder converts the mechanical force from pressing the brake pedal into hydraulic pressure. It pushes brake fluid through the brake lines to the wheel cylinders or calipers, which then apply the brakes. It's the heart of the hydraulic brake system.",
  difficulty: "Medium"
},
{
  id: 2414,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a catalytic converter?",
  answer: "A catalytic converter reduces harmful emissions from the exhaust by converting toxic gases into less harmful substances. It uses chemical catalysts to convert carbon monoxide into carbon dioxide, unburned hydrocarbons into CO2 and water, and nitrogen oxides into nitrogen and oxygen.",
  difficulty: "Medium"
},
{
  id: 2415,
  subject: "Auto & Shop Information",
  question: "What is the difference between a box-end wrench and an open-end wrench?",
  answer: "A box-end wrench has a closed loop that completely surrounds the fastener, providing better grip and less chance of slipping. An open-end wrench has an open U-shape that can slide onto a fastener from the side, useful in tight spaces where you can't fit a closed end over the fastener.",
  difficulty: "Easy"
},
{
  id: 2416,
  subject: "Auto & Shop Information",
  question: "What is engine displacement measured in?",
  answer: "Engine displacement is measured in cubic inches (ci), liters (L), or cubic centimeters (cc). It represents the total volume of all cylinders in an engine - the amount of air-fuel mixture that can be drawn in during one complete engine cycle. Larger displacement generally means more power.",
  difficulty: "Medium"
},
{
  id: 2417,
  subject: "Auto & Shop Information",
  question: "What tool is used to measure very small distances with high precision (to thousandths of an inch)?",
  answer: "A micrometer is used for highly precise measurements, typically accurate to 0.001 inches (one thousandth of an inch) or 0.01mm. It's commonly used in machine shops and automotive work to measure thickness, diameter, or depth of small parts with great accuracy.",
  difficulty: "Medium"
},
{
  id: 2418,
  subject: "Auto & Shop Information",
  question: "What is the purpose of motor oil in an engine?",
  answer: "Motor oil serves multiple purposes: 1) Lubrication - reduces friction between moving parts; 2) Cooling - carries heat away from engine components; 3) Cleaning - suspends dirt and combustion byproducts; 4) Sealing - helps seal gaps between piston rings and cylinder walls; 5) Protection - prevents corrosion and rust.",
  difficulty: "Easy"
},
{
  id: 2419,
  subject: "Auto & Shop Information",
  question: "What is a hacksaw used for?",
  answer: "A hacksaw is designed for cutting metal, plastic, and other hard materials. It has a fine-toothed blade held in a C-shaped frame under tension. The blade can be replaced when dull, and the tooth count (teeth per inch) varies based on the material being cut - more teeth for harder materials.",
  difficulty: "Easy"
},
{
  id: 2420,
  subject: "Auto & Shop Information",
  question: "What does ABS stand for in automotive braking systems, and what does it do?",
  answer: "ABS stands for Anti-lock Braking System. It prevents wheels from locking up (stopping rotation) during hard braking, which maintains steering control and prevents skidding. The system rapidly pumps the brakes (many times per second) when it detects wheel lockup, allowing the driver to maintain control while braking.",
  difficulty: "Medium"
},
{
  id: 2421,
  subject: "Auto & Shop Information",
  question: "What is the difference between a bolt and a screw?",
  answer: "A bolt is designed to be used with a nut and typically passes completely through the materials being joined. It has an unthreaded shank and is tightened by turning the nut. A screw threads directly into the material (like wood or tapped metal) and is tightened by turning its head. Screws are generally pointed at the tip.",
  difficulty: "Easy"
},
{
  id: 2421,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a lock washer?",
  answer: "A lock washer prevents nuts and bolts from loosening due to vibration. Split lock washers dig into the surfaces when compressed, creating friction. Toothed lock washers have serrations that bite into both surfaces. They're essential in automotive and machinery applications where vibration is common.",
  difficulty: "Easy"
},
{
  id: 2422,
  subject: "Auto & Shop Information",
  question: "What is the function of a fuel pump?",
  answer: "The fuel pump moves gasoline from the fuel tank to the engine. In modern vehicles, electric fuel pumps (usually located in the tank) provide pressurized fuel to the fuel injection system. Older vehicles may use mechanical fuel pumps driven by the engine. Proper fuel pressure is critical for engine performance.",
  difficulty: "Easy"
},
{
  id: 2423,
  subject: "Auto & Shop Information",
  question: "What is a vise used for?",
  answer: "A vise is a clamping device mounted to a workbench that holds workpieces securely in place. It has two jaws (one fixed, one movable) operated by a screw mechanism. Vises allow you to work on objects hands-free and apply significant clamping force for cutting, filing, drilling, or assembly work.",
  difficulty: "Easy"
},
{
  id: 2424,
  subject: "Auto & Shop Information",
  question: "What is the difference between gasoline and diesel engines?",
  answer: "Gasoline engines use spark plugs to ignite a compressed air-fuel mixture (spark ignition). Diesel engines compress air to very high pressure and temperature, then inject fuel which ignites spontaneously from the heat (compression ignition). Diesel engines have higher compression ratios, no spark plugs, and typically produce more torque.",
  difficulty: "Medium"
},
{
  id: 2425,
  subject: "Auto & Shop Information",
  question: "What does octane rating measure in gasoline?",
  answer: "Octane rating measures gasoline's resistance to engine knocking (premature detonation). Higher octane fuel (like 91 or 93) resists knocking better than regular (87 octane). High-performance engines with higher compression ratios require higher octane fuel to prevent knocking, which can damage the engine.",
  difficulty: "Medium"
},
{
  id: 2426,
  subject: "Auto & Shop Information",
  question: "What is a socket wrench set used for?",
  answer: "A socket wrench (or socket set) consists of a ratcheting handle and interchangeable sockets that fit over nuts and bolts. The ratcheting mechanism allows you to tighten or loosen fasteners without removing the tool after each turn, making it faster and more efficient than standard wrenches, especially in tight spaces.",
  difficulty: "Easy"
},
{
  id: 2427,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a transmission in a vehicle?",
  answer: "The transmission transfers power from the engine to the wheels while changing gear ratios. Lower gears provide more torque for acceleration and climbing hills; higher gears allow for efficient high-speed cruising. It allows the engine to operate in its optimal RPM range under varying driving conditions.",
  difficulty: "Easy"
},
{
  id: 2428,
  subject: "Auto & Shop Information",
  question: "What is a cold chisel used for?",
  answer: "A cold chisel is a hardened steel cutting tool used to cut or shape cold metal (as opposed to hot forging). It's struck with a hammer to cut rivets, bolts, sheet metal, or to split nuts that won't unscrew. The name distinguishes it from hot chisels used by blacksmiths on heated metal.",
  difficulty: "Medium"
},
{
  id: 2429,
  subject: "Auto & Shop Information",
  question: "What does the water pump do in a cooling system?",
  answer: "The water pump circulates coolant (antifreeze and water mixture) throughout the engine and cooling system. It's typically belt-driven by the engine and pushes coolant through the engine block, cylinder head, radiator, and heater core to maintain proper engine temperature and prevent overheating.",
  difficulty: "Easy"
},
{
  id: 2430,
  subject: "Auto & Shop Information",
  question: "What is the difference between a manual and automatic transmission?",
  answer: "A manual transmission requires the driver to manually select gears using a clutch pedal and gear shifter. An automatic transmission shifts gears automatically based on vehicle speed and engine load using hydraulic systems and computer controls, requiring no clutch pedal. Automatics are easier to drive; manuals often provide better control.",
  difficulty: "Easy"
},
{
  id: 2431,
  subject: "Auto & Shop Information",
  question: "What is a level used for in shop work?",
  answer: "A level is a measuring tool used to determine if a surface is horizontal (level) or vertical (plumb). It contains a sealed glass tube partially filled with liquid and an air bubble. When the bubble is centered between the marks, the surface is level. Essential for construction, carpentry, and installation work.",
  difficulty: "Easy"
},
{
  id: 2432,
  subject: "Auto & Shop Information",
  question: "What is the function of the clutch in a manual transmission vehicle?",
  answer: "The clutch connects and disconnects the engine from the transmission. Pressing the clutch pedal disengages the engine, allowing you to shift gears without grinding. Releasing the pedal engages the engine to the transmission, transferring power to the wheels. It allows smooth starting from a stop and gear changes.",
  difficulty: "Medium"
},
{
  id: 2433,
  subject: "Auto & Shop Information",
  question: "What are tin snips used for?",
  answer: "Tin snips are scissors-like tools designed for cutting sheet metal, aluminum, screening, and other thin materials. They come in different types: straight-cut, left-cut, and right-cut. Aviation snips (color-coded) are more powerful and can cut curves - green for straight, red for left curves, yellow for right curves.",
  difficulty: "Easy"
},
{
  id: 2434,
  subject: "Auto & Shop Information",
  question: "What is the purpose of the differential in a vehicle's drivetrain?",
  answer: "The differential allows the drive wheels to rotate at different speeds, which is necessary when turning (the outer wheel travels farther than the inner wheel). It also transmits power from the driveshaft to the axles at a 90-degree angle and provides a final gear reduction for increased torque.",
  difficulty: "Hard"
},
{
  id: 2435,
  subject: "Auto & Shop Information",
  question: "What is a file used for in shop work?",
  answer: "A file is a hand tool with a rough, hardened surface covered with cutting teeth used to shape, smooth, or remove material from wood, metal, or plastic. Files come in various shapes (flat, round, half-round, triangular) and cuts (coarse, medium, fine) for different applications like deburring, sharpening, or finishing.",
  difficulty: "Easy"
},
{
  id: 2436,
  subject: "Auto & Shop Information",
  question: "What does a car's battery provide?",
  answer: "The battery provides electrical power to start the engine (via the starter motor) and powers electrical accessories when the engine is off. It also stabilizes voltage in the electrical system and provides backup power when electrical demand exceeds the alternator's capacity. Most car batteries are 12-volt lead-acid batteries.",
  difficulty: "Easy"
},
{
  id: 2437,
  subject: "Auto & Shop Information",
  question: "What is the difference between carburetor and fuel injection systems?",
  answer: "A carburetor mechanically mixes air and fuel using venturi effect and jets. Fuel injection electronically sprays precisely metered fuel directly into the intake or cylinders using injectors controlled by computer. Fuel injection is more efficient, provides better performance, reduces emissions, and is used in all modern vehicles.",
  difficulty: "Medium"
},
{
  id: 2438,
  subject: "Auto & Shop Information",
  question: "What is a tape measure used for?",
  answer: "A tape measure is a flexible ruler used to measure longer distances (typically up to 25 feet or more). It has a retractable metal blade marked in inches and feet (and often centimeters). The hook at the end is slightly loose to account for inside and outside measurements. Essential for construction and carpentry.",
  difficulty: "Easy"
},
{
  id: 2439,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a muffler in the exhaust system?",
  answer: "A muffler reduces engine noise by routing exhaust gases through perforated tubes and chambers that cancel out sound waves through destructive interference. It quiets the loud explosions from the engine's combustion process. Some mufflers also slightly restrict exhaust flow, which can affect engine performance and back pressure.",
  difficulty: "Easy"
},
{
  id: 2440,
  subject: "Auto & Shop Information",
  question: "What is a reamer used for?",
  answer: "A reamer is a rotary cutting tool used to enlarge or finish holes to precise dimensions with a smooth surface. It removes only a small amount of material (typically a few thousandths of an inch) and is used after drilling to achieve exact hole size and better surface finish for applications like bearing fits.",
  difficulty: "Hard"
},
{
  id: 2441,
  subject: "Auto & Shop Information",
  question: "What is the function of the distributor in older ignition systems?",
  answer: "The distributor routes high voltage from the ignition coil to each spark plug in the correct firing order. It also houses the breaker points (or electronic trigger) that time the spark, and the rotor that spins to distribute electricity to each cylinder. Modern vehicles use distributorless ignition systems with individual coils.",
  difficulty: "Medium"
},
{
  id: 2442,
  subject: "Auto & Shop Information",
  question: "What is a try square used for?",
  answer: "A try square (or carpenter's square) is used to check if edges and corners are perfectly square (90 degrees) and to mark straight lines perpendicular to an edge. It has a metal blade and a thick wooden or metal handle. Essential for woodworking and ensuring accurate right angles in construction.",
  difficulty: "Medium"
},
{
  id: 2443,
  subject: "Auto & Shop Information",
  question: "What is the purpose of antifreeze/coolant in the cooling system?",
  answer: "Antifreeze (ethylene glycol mixed with water) serves multiple purposes: 1) Lowers the freezing point to prevent damage in cold weather; 2) Raises the boiling point for better high-temperature performance; 3) Contains corrosion inhibitors to protect metal components; 4) Lubricates the water pump. Typically mixed 50/50 with water.",
  difficulty: "Medium"
},
{
  id: 2444,
  subject: "Auto & Shop Information",
  question: "What is a claw hammer primarily used for?",
  answer: "A claw hammer has a flat striking face for driving nails and a curved, forked claw on the back for pulling nails out. It's the most common hammer for general carpentry and construction work. The claw is inserted under the nail head and the hammer is rocked back on its curved head to extract the nail.",
  difficulty: "Easy"
},
{
  id: 2445,
  subject: "Auto & Shop Information",
  question: "What is the driveshaft and what does it do?",
  answer: "The driveshaft (or propeller shaft) is a rotating tube that transmits torque from the transmission to the differential in rear-wheel and four-wheel drive vehicles. It allows power transfer while accommodating the up-and-down movement of the rear axle using universal joints (U-joints) at each end.",
  difficulty: "Medium"
},
{
  id: 2446,
  subject: "Auto & Shop Information",
  question: "What are calipers used for?",
  answer: "Calipers are measuring instruments used to determine the distance between two opposite sides of an object. Outside calipers measure external dimensions (like diameter), inside calipers measure internal dimensions (like hole diameter), and vernier/dial calipers can measure both with precision, typically to 0.001 inches or 0.01mm.",
  difficulty: "Medium"
},
{
  id: 2447,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a car's suspension system?",
  answer: "The suspension system supports the vehicle's weight, absorbs road shocks, and maintains tire contact with the road for control and safety. It consists of springs (coil, leaf, or air), shock absorbers/struts, and linkages. Good suspension provides a comfortable ride while maintaining handling and stability.",
  difficulty: "Easy"
},
{
  id: 2448,
  subject: "Auto & Shop Information",
  question: "What is sandpaper grit, and how does it work?",
  answer: "Sandpaper grit refers to the size of abrasive particles bonded to the paper. Lower numbers (40-60) are coarse for heavy material removal. Medium grits (80-120) are for general sanding. Higher numbers (150-220+) are fine for finishing and smoothing. The number indicates particles per square inch - higher number means finer grit.",
  difficulty: "Medium"
},
{
  id: 2449,
  subject: "Auto & Shop Information",
  question: "What does ignition timing refer to?",
  answer: "Ignition timing refers to when the spark plug fires relative to piston position. The spark must occur at precisely the right moment (usually slightly before top dead center) for optimal combustion. Timing that's too advanced causes knocking; too retarded reduces power and efficiency. Modern engines use computer-controlled timing.",
  difficulty: "Hard"
},
{
  id: 2450,
  subject: "Auto & Shop Information",
  question: "What is a hole saw used for?",
  answer: "A hole saw is a cylindrical cutting tool that attaches to a drill and cuts large diameter holes (typically 3/4 inch to 6 inches) in wood, plastic, or thin metal. It has saw teeth around the edge and a pilot drill bit in the center for accuracy. Much faster than drilling multiple small holes and using a jigsaw.",
  difficulty: "Easy"
},
{
  id: 2451,
  subject: "Auto & Shop Information",
  question: "What is brake fluid and why is it important?",
  answer: "Brake fluid is a hydraulic fluid that transfers force from the brake pedal to the wheel brakes. It must have a high boiling point (to resist heat), low freezing point, and not damage rubber seals. It's hygroscopic (absorbs moisture), so it must be changed periodically. Low or contaminated brake fluid causes brake failure.",
  difficulty: "Medium"
},
{
  id: 2452,
  subject: "Auto & Shop Information",
  question: "What is a sledgehammer used for?",
  answer: "A sledgehammer is a large, heavy hammer with a long handle used for demolition, driving stakes, breaking concrete, or any task requiring powerful blows. It typically weighs 8-16 pounds. The long handle and heavy head provide maximum impact force through the combination of weight and leverage.",
  difficulty: "Easy"
},
{
  id: 2453,
  subject: "Auto & Shop Information",
  question: "What is the difference between front-wheel drive and rear-wheel drive?",
  answer: "Front-wheel drive (FWD) vehicles have the engine power the front wheels, with the engine usually mounted transversely. They offer better traction in snow, more interior space, and lower cost. Rear-wheel drive (RWD) vehicles power the rear wheels, providing better handling balance, towing capacity, and acceleration for performance vehicles.",
  difficulty: "Easy"
},
{
  id: 2454,
  subject: "Auto & Shop Information",
  question: "What is a hand plane used for in woodworking?",
  answer: "A hand plane is used to shave thin layers of wood from a surface to smooth it, reduce thickness, or flatten boards. It has a sharp blade (iron) set at an angle in a flat base (sole). By adjusting blade depth and angle, you can control how much material is removed with each pass.",
  difficulty: "Medium"
},
{
  id: 2455,
  subject: "Auto & Shop Information",
  question: "What is the purpose of engine compression, and why is it important?",
  answer: "Compression is the squeezing of the air-fuel mixture in the cylinder before ignition. Higher compression increases power and efficiency by creating more pressure for the combustion explosion. Typical compression ratios are 8:1 to 12:1 for gasoline engines. Low compression indicates worn rings or valves, causing poor performance.",
  difficulty: "Hard"
},
{
  id: 2456,
  subject: "Auto & Shop Information",
  question: "What is the difference between hardwood and softwood?",
  answer: "Hardwood comes from deciduous trees (oak, maple, cherry) that lose their leaves, while softwood comes from coniferous trees (pine, fir, cedar) that have needles. Despite the names, some softwoods are harder than some hardwoods. Hardwoods are generally denser, more expensive, and used for furniture; softwoods for construction.",
  difficulty: "Medium"
},
{
  id: 2457,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a PCV valve?",
  answer: "The PCV (Positive Crankcase Ventilation) valve controls the flow of blow-by gases from the crankcase back into the intake manifold to be re-burned. This reduces emissions, prevents oil contamination, and maintains proper crankcase pressure. A stuck PCV valve can cause rough idle, oil leaks, or increased oil consumption.",
  difficulty: "Hard"
},
{
  id: 2458,
  subject: "Auto & Shop Information",
  question: "What are the main types of drill bits?",
  answer: "Common drill bit types include: Twist bits (general purpose for wood and metal), Spade bits (flat bits for large holes in wood), Masonry bits (carbide tip for concrete/brick), Hole saws (large diameter holes), Forstner bits (flat-bottomed holes in wood), and Countersink bits (for recessing screw heads).",
  difficulty: "Medium"
},
{
  id: 2459,
  subject: "Auto & Shop Information",
  question: "What is the function of shock absorbers or struts?",
  answer: "Shock absorbers (or struts in MacPherson strut suspensions) dampen the oscillations of the springs after hitting a bump. Without them, the car would bounce continuously. They use hydraulic fluid forced through small passages to convert kinetic energy into heat, controlling spring movement and maintaining tire contact with the road.",
  difficulty: "Medium"
},
{
  id: 2460,
  subject: "Auto & Shop Information",
  question: "What is a torque wrench used for?",
  answer: "A torque wrench is used to tighten fasteners to a specific torque (rotational force) value, usually measured in foot-pounds or Newton-meters. It clicks, beeps, or indicates when the desired torque is reached. Critical for applications like cylinder heads, wheel lug nuts, and any components where over-tightening could cause damage.",
  difficulty: "Medium"
},
{
  id: 2461,
  subject: "Auto & Shop Information",
  question: "What is the purpose of the throttle body in a fuel injection system?",
  answer: "The throttle body controls the amount of air entering the engine. It contains a butterfly valve connected to the accelerator pedal. When you press the gas pedal, the valve opens to allow more air in, and the engine computer adjusts fuel delivery accordingly. It's the air equivalent of opening a faucet.",
  difficulty: "Medium"
},
{
  id: 2462,
  subject: "Auto & Shop Information",
  question: "What is cast iron and what is it commonly used for?",
  answer: "Cast iron is iron with high carbon content (2-4%) that is melted and poured into molds. It's brittle but very hard and wear-resistant. In automotive use, it's common for engine blocks, cylinder heads, brake rotors, and exhaust manifolds because it's inexpensive, dampens vibration well, and handles heat effectively.",
  difficulty: "Medium"
},
{
  id: 2463,
  subject: "Auto & Shop Information",
  question: "What is the difference between 2-wheel drive and 4-wheel drive?",
  answer: "2-wheel drive (2WD) powers either the front or rear wheels. 4-wheel drive (4WD) can power all four wheels simultaneously for better traction in off-road or slippery conditions. 4WD systems may be full-time (always engaged), part-time (driver selects), or automatic (engages when needed). AWD is similar but typically always active.",
  difficulty: "Easy"
},
{
  id: 2464,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a washer when using bolts or screws?",
  answer: "Washers serve multiple purposes: 1) Distribute load over a larger area to prevent damage to the material; 2) Prevent the fastener from pulling through soft material; 3) Provide a smooth bearing surface; 4) Space components; 5) Lock washers prevent loosening from vibration. Flat washers are most common.",
  difficulty: "Easy"
},
{
  id: 2465,
  subject: "Auto & Shop Information",
  question: "What is valve clearance (lash) and why does it matter?",
  answer: "Valve clearance is the small gap between the valve stem and rocker arm (or cam) when the valve is closed. This gap allows for thermal expansion as the engine heats up. Too little clearance causes valves to stay partially open (burning valves); too much causes noisy operation and poor performance. Some engines self-adjust.",
  difficulty: "Hard"
},
{
  id: 2466,
  subject: "Auto & Shop Information",
  question: "What is the difference between steel and aluminum?",
  answer: "Steel is an iron-carbon alloy that is strong, heavy, and relatively inexpensive. Aluminum is a lighter metal (about 1/3 the weight of steel) that resists corrosion naturally but is generally weaker and more expensive. In automotive use, aluminum is used for weight reduction in engine blocks, wheels, and body panels.",
  difficulty: "Easy"
},
{
  id: 2467,
  subject: "Auto & Shop Information",
  question: "What is a punch used for in metalworking?",
  answer: "A punch is a tool struck with a hammer to mark, indent, or pierce metal. Center punches make starter dimples for drill bits to prevent wandering. Pin punches drive pins and rivets out of holes. Prick punches make layout marks. Hollow punches cut holes in sheet metal, leather, or gaskets.",
  difficulty: "Medium"
},
{
  id: 2468,
  subject: "Auto & Shop Information",
  question: "What is the purpose of an oxygen sensor in a vehicle?",
  answer: "The oxygen (O2) sensor measures the amount of oxygen in the exhaust gases and sends this information to the engine computer. The computer uses this data to adjust the air-fuel mixture for optimal efficiency and emissions. Modern vehicles have multiple O2 sensors. A failed O2 sensor causes poor fuel economy and emissions.",
  difficulty: "Hard"
},
{
  id: 2469,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a timing belt or timing chain?",
  answer: "The timing belt or chain synchronizes the rotation of the crankshaft and camshaft(s) so that valves open and close at precisely the right time relative to piston position. The belt is rubber and requires periodic replacement (60k-100k miles). Chains are metal, last longer, but are noisier. If either breaks, engine damage can occur.",
  difficulty: "Hard"
},
{
  id: 2470,
  subject: "Auto & Shop Information",
  question: "What is a stud finder used for?",
  answer: "A stud finder is an electronic device used to locate wooden or metal studs (vertical framing members) behind drywall or other wall surfaces. This is essential for securely mounting heavy objects like shelves or TV brackets, as you need to anchor into studs rather than just drywall for proper support.",
  difficulty: "Easy"
},
{
  id: 2471,
  subject: "Auto & Shop Information",
  question: "What is the difference between horsepower and torque?",
  answer: "Torque is rotational force (measured in lb-ft or Nm) - the twisting power that gets you moving. Horsepower is the rate at which work is done (torque × rpm ÷ 5,252). High torque gives good acceleration and towing; high horsepower gives high top speed. Diesel engines typically have high torque; sports cars emphasize horsepower.",
  difficulty: "Hard"
},
{
  id: 2472,
  subject: "Auto & Shop Information",
  question: "What is a ratchet and how does it work?",
  answer: "A ratchet is a mechanical device that allows rotation in one direction while preventing it in the other. In socket wrenches, the ratcheting mechanism lets you tighten or loosen fasteners with back-and-forth motion without removing the socket. A switch reverses the direction. This speeds up work significantly compared to standard wrenches.",
  difficulty: "Easy"
},
{
  id: 2473,
  subject: "Auto & Shop Information",
  question: "What is the purpose of motor mounts?",
  answer: "Motor mounts secure the engine to the vehicle's frame or unibody structure while isolating vibration. They're typically made of metal brackets with rubber or fluid-filled inserts that absorb engine vibration and prevent it from transferring to the passenger cabin. Worn mounts cause excessive engine movement and vibration.",
  difficulty: "Medium"
},
{
  id: 2474,
  subject: "Auto & Shop Information",
  question: "What is a countersink bit used for?",
  answer: "A countersink bit creates a cone-shaped depression at the top of a hole, allowing a flathead screw to sit flush with or below the surface. This provides a smooth finish and prevents the screw head from protruding. Common in woodworking and metalworking where appearance or clearance is important.",
  difficulty: "Medium"
},
{
  id: 2475,
  subject: "Auto & Shop Information",
  question: "What is the function of the EGR valve?",
  answer: "The EGR (Exhaust Gas Recirculation) valve reduces nitrogen oxide (NOx) emissions by recirculating a small amount of exhaust gas back into the intake. This lowers combustion temperature, reducing NOx formation. A stuck EGR valve causes rough idle, stalling, or poor performance. Modern engines increasingly eliminate EGR through design.",
  difficulty: "Hard"
},
{
  id: 2476,
  subject: "Auto & Shop Information",
  question: "What is plywood and why is it used in construction?",
  answer: "Plywood is manufactured from thin layers (plies) of wood veneer glued together with grain directions alternating. This cross-grain construction makes it stronger and more stable than solid wood - less likely to warp or split. It's widely used in construction for sheathing, subflooring, and cabinets due to strength and cost-effectiveness.",
  difficulty: "Easy"
},
{
  id: 2477,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a flywheel in an engine?",
  answer: "The flywheel is a heavy disc attached to the crankshaft that smooths out power pulses from the engine and stores rotational energy. In manual transmissions, it provides a surface for the clutch to grip. It also has a ring gear for the starter motor. The heavy mass keeps the engine rotating smoothly between power strokes.",
  difficulty: "Hard"
},
{
  id: 2478,
  subject: "Auto & Shop Information",
  question: "What is an Allen wrench (hex key) used for?",
  answer: "An Allen wrench (or hex key) is an L-shaped tool with a hexagonal cross-section used to drive bolts and screws with hexagonal sockets in their heads. The hex socket design allows high torque without the tool slipping out. Common in furniture assembly, bicycles, and machinery. Available in SAE (inches) and metric sizes.",
  difficulty: "Easy"
},
{
  id: 2479,
  subject: "Auto & Shop Information",
  question: "What causes engine knock or ping?",
  answer: "Engine knock (or ping) is caused by premature or uncontrolled combustion - the air-fuel mixture ignites before the spark plug fires or multiple flame fronts collide. Causes include low-octane fuel, carbon buildup, over-advanced timing, or excessive compression. Knocking can damage pistons and should be addressed immediately.",
  difficulty: "Medium"
},
{
  id: 2480,
  subject: "Auto & Shop Information",
  question: "What is a bushing in automotive applications?",
  answer: "A bushing is a cylindrical sleeve (usually rubber, polyurethane, or bronze) that serves as a cushion and wear surface between two moving parts. In suspensions, bushings allow controlled movement while dampening vibration and noise. They're found in control arms, sway bar links, and motor mounts. Worn bushings cause loose handling.",
  difficulty: "Medium"
},
{
  id: 2481,
  subject: "Auto & Shop Information",
  question: "What is the difference between a nail and a screw for fastening?",
  answer: "Nails are smooth shanks driven with a hammer, relying on friction and sometimes the wood's tendency to close around them. They're fast for framing. Screws have threads that bite into material, providing much stronger holding power and the ability to be removed. Screws are better for cabinets and finish work; nails for rough framing.",
  difficulty: "Easy"
},
{
  id: 2482,
  subject: "Auto & Shop Information",
  question: "What is turbocharger and how does it increase engine power?",
  answer: "A turbocharger uses exhaust gases to spin a turbine that compresses incoming air, forcing more air (and therefore more fuel) into the cylinders. This increases power without increasing engine size. The compressor and turbine are connected by a shaft. Turbos can significantly boost power but add complexity and heat.",
  difficulty: "Hard"
},
{
  id: 2483,
  subject: "Auto & Shop Information",
  question: "What is a Phillips screwdriver designed to do that makes it different from flathead?",
  answer: "The Phillips screwdriver has a cross-shaped tip designed to cam out (slip out) under high torque to prevent over-tightening and screw damage. This was originally a feature, not a bug. The design provides better centering and grip than flathead screws. However, modern drivers are often too hard, defeating the cam-out feature.",
  difficulty: "Medium"
},
{
  id: 2484,
  subject: "Auto & Shop Information",
  question: "What is the purpose of tread depth on tires?",
  answer: "Tire tread depth is critical for channeling water away from the contact patch to maintain grip in wet conditions. The grooves prevent hydroplaning by allowing water to escape. Legal minimum is typically 2/32 inch, but performance degrades before that. New tires have 10/32 to 12/32 inch depth. Worn tires lose wet traction.",
  difficulty: "Easy"
},
{
  id: 2485,
  subject: "Auto & Shop Information",
  question: "What is a universal joint (U-joint) and where is it used?",
  answer: "A universal joint (U-joint) is a flexible coupling that allows the driveshaft to transmit power while changing angles as the suspension moves up and down. It consists of a cross with four bearing caps. U-joints are used in driveshafts connecting the transmission to the differential. Worn U-joints cause clunking and vibration.",
  difficulty: "Hard"
},
{
  id: 2486,
  subject: "Auto & Shop Information",
  question: "What is a combination square used for?",
  answer: "A combination square is a versatile measuring and marking tool with a ruler blade and an adjustable head. It can measure and mark 90-degree and 45-degree angles, check for square, find centers, measure depths, and scribe lines parallel to an edge. The head slides along the ruler and locks in position.",
  difficulty: "Medium"
},
{
  id: 2487,
  subject: "Auto & Shop Information",
  question: "What is the difference between power steering and manual steering?",
  answer: "Manual steering requires the driver's muscle power to turn the wheels through mechanical linkage only. Power steering uses hydraulic pressure (from a pump) or electric motors to assist steering effort, making it easier to turn the wheel, especially at low speeds. Modern vehicles almost exclusively use power steering (hydraulic or electric).",
  difficulty: "Easy"
},
{
  id: 2488,
  subject: "Auto & Shop Information",
  question: "What is a tap and die set used for?",
  answer: "A tap cuts internal threads inside a hole to accept a bolt. A die cuts external threads on a rod to create a bolt. Together they allow you to create or repair threads. Taps are turned into holes with a tap handle; dies are turned onto rods with a die stock. Available in various sizes and thread pitches (SAE and metric).",
  difficulty: "Hard"
},
{
  id: 2489,
  subject: "Auto & Shop Information",
  question: "What is the purpose of the air filter in an engine?",
  answer: "The air filter prevents dirt, dust, and debris from entering the engine. Clean air is essential for proper combustion and to prevent wear on cylinder walls, pistons, and rings. A clogged filter restricts airflow, reducing power and fuel economy. Filters should be inspected regularly and replaced according to the maintenance schedule.",
  difficulty: "Easy"
},
{
  id: 2490,
  subject: "Auto & Shop Information",
  question: "What is a spanner wrench used for?",
  answer: "A spanner wrench has pins or tabs that fit into holes or notches on round objects like lock nuts, bearing retainers, or adjustable collars. Common types include hook spanners (curved pin) and pin spanners (straight pins). They're used in automotive work for suspension adjustments and special fasteners that standard wrenches can't grip.",
  difficulty: "Hard"
},
{
  id: 2491,
  subject: "Auto & Shop Information",
  question: "What is wheel alignment and why is it important?",
  answer: "Wheel alignment adjusts the angles of the wheels to manufacturer specifications. The three main angles are: camber (tire tilt), caster (steering axis angle), and toe (wheel direction). Proper alignment ensures even tire wear, straight tracking, and stable handling. Misalignment causes premature tire wear and pulling to one side.",
  difficulty: "Medium"
},
{
  id: 2492,
  subject: "Auto & Shop Information",
  question: "What is MDF (Medium Density Fiberboard) and what is it used for?",
  answer: "MDF is an engineered wood product made from wood fibers bonded with resin under heat and pressure. It's denser and smoother than particle board, with no grain pattern. MDF is easy to cut and paint, making it popular for cabinets, shelving, and molding. However, it's heavy and not moisture-resistant.",
  difficulty: "Medium"
},
{
  id: 2493,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a CV joint in front-wheel drive vehicles?",
  answer: "CV (Constant Velocity) joints allow the drive axles to transmit power to the wheels at various angles while the suspension moves and steering turns the wheels. They maintain constant velocity without vibration. Outer CV joints handle greater angles (steering), inner joints handle suspension movement. Worn CV joints click when turning.",
  difficulty: "Hard"
},
{
  id: 2494,
  subject: "Auto & Shop Information",
  question: "What is a breaker bar used for?",
  answer: "A breaker bar is a non-ratcheting bar with a socket drive (like a ratchet handle but longer and stronger) used to loosen very tight fasteners. The extra length provides increased leverage for breaking loose stubborn bolts. It's more durable than a ratchet for high-torque applications but must be removed and repositioned after each turn.",
  difficulty: "Medium"
},
{
  id: 2495,
  subject: "Auto & Shop Information",
  question: "What is engine displacement and how is it calculated?",
  answer: "Engine displacement is the total volume swept by all pistons in one complete revolution. It's calculated by: bore² × stroke × π/4 × number of cylinders. For example, a 4-cylinder engine with 3.5-inch bore and 3.5-inch stroke has about 135 cubic inches (2.2 liters) displacement. Larger displacement generally means more power.",
  difficulty: "Hard"
},
{
  id: 2496,
  subject: "Auto & Shop Information",
  question: "What is a keyless drill chuck and how does it work?",
  answer: "A keyless drill chuck tightens and loosens by hand without requiring a chuck key. It typically has a two-sleeve design - hold one sleeve and rotate the other to open or close the jaws. They're more convenient than keyed chucks and are standard on modern drills, allowing quick bit changes.",
  difficulty: "Easy"
},
{
  id: 2497,
  subject: "Auto & Shop Information",
  question: "What is the purpose of a serpentine belt?",
  answer: "The serpentine belt is a single, long belt that drives multiple engine accessories including the alternator, power steering pump, water pump, and air conditioning compressor. It wraps around multiple pulleys in a serpentine (snake-like) pattern. Belt tensioners maintain proper tension. One broken belt disables multiple systems.",
  difficulty: "Medium"
},
{
  id: 2498,
  subject: "Auto & Shop Information",
  question: "What is a forstner bit used for?",
  answer: "A Forstner bit drills flat-bottomed holes in wood with clean sides and no breakthrough tear-out. Unlike twist drills, it can drill overlapping holes, angled holes, or partial holes on edges. The flat bottom and precise diameter make it ideal for cabinet hinges, dowel joints, and any application requiring smooth, accurate holes.",
  difficulty: "Medium"
},
{
  id: 2499,
  subject: "Auto & Shop Information",
  question: "What is the difference between understeer and oversteer?",
  answer: "Understeer occurs when the front tires lose grip first during cornering, causing the car to continue forward instead of turning (plow). Common in front-wheel drive vehicles. Oversteer occurs when the rear tires lose grip first, causing the rear to swing out. Common in rear-wheel drive vehicles. Both affect handling and safety.",
  difficulty: "Hard"
},
{
  id: 2500,
  subject: "Auto & Shop Information",
  question: "What is a feeler gauge used for?",
  answer: "A feeler gauge is a set of thin metal blades of precise thicknesses used to measure small gaps or clearances. In automotive work, it's commonly used to measure spark plug gaps, valve clearances, and bearing clearances. You select blades that fit snugly in the gap to determine the exact measurement, typically in thousandths of an inch.",
  difficulty: "Medium"
},
{
  id: 2501,
  subject: "Paragraph Comprehension",
  question: "The primary purpose of a circuit breaker is to protect electrical wiring from damage caused by excessive current flow. When too much electricity passes through a wire, it can overheat and potentially cause a fire. The circuit breaker automatically cuts off power when it detects dangerous current levels. What is the main idea of this passage?",
  answer: "Circuit breakers protect wiring by stopping power when current becomes excessive. The passage focuses on the protective function and automatic safety mechanism of circuit breakers.",
  difficulty: "Easy"
},
{
  id: 2502,
  subject: "Paragraph Comprehension",
  question: "During World War II, the Navajo Code Talkers created an unbreakable military code based on their native language. The Japanese were never able to decipher it, making it one of the most successful secret communications systems in military history. Why was the Navajo code so effective?",
  answer: "The enemy could not decipher the Navajo language. The passage states the Japanese were never able to break the code, making it highly successful.",
  difficulty: "Easy"
},
{
  id: 2503,
  subject: "Paragraph Comprehension",
  question: "Proper tire inflation is essential for vehicle safety and fuel efficiency. Underinflated tires can reduce gas mileage by up to 3% and increase the risk of tire failure. Checking tire pressure monthly takes only a few minutes but can prevent costly problems. According to the passage, what percentage can underinflated tires reduce fuel efficiency?",
  answer: "Up to 3%. The passage specifically states underinflated tires can reduce gas mileage by up to 3%.",
  difficulty: "Easy"
},
{
  id: 2504,
  subject: "Paragraph Comprehension",
  question: "Photosynthesis is the process by which plants convert sunlight into chemical energy. Chlorophyll in plant cells absorbs light energy, which then transforms carbon dioxide and water into glucose and oxygen. This process is fundamental to life on Earth because it produces the oxygen we breathe. What role does chlorophyll play in photosynthesis?",
  answer: "It absorbs light energy. The passage states chlorophyll absorbs light energy, which begins the conversion process.",
  difficulty: "Easy"
},
{
  id: 2505,
  subject: "Paragraph Comprehension",
  question: "The Wright brothers achieved the first powered flight in 1903 at Kitty Hawk, North Carolina. Their aircraft stayed aloft for 12 seconds and covered 120 feet. Although brief, this flight proved that sustained, controlled powered flight was possible and revolutionized transportation. How long did the Wright brothers' first flight last?",
  answer: "12 seconds. The passage directly states the flight lasted 12 seconds.",
  difficulty: "Easy"
},
{
  id: 2506,
  subject: "Paragraph Comprehension",
  question: "When cooking at high altitudes, adjustments must be made because water boils at lower temperatures where air pressure is reduced. Foods take longer to cook, and recipes may require more liquid. Bakers often need to decrease sugar and increase flour to compensate for these atmospheric differences. What causes water to boil at lower temperatures at high altitudes?",
  answer: "Reduced air pressure. The passage indicates lower air pressure at high altitudes causes water to boil at lower temperatures.",
  difficulty: "Easy"
},
{
  id: 2507,
  subject: "Paragraph Comprehension",
  question: "Military ranks serve to establish a clear chain of command and define responsibilities within armed forces. Each rank carries specific duties, authority levels, and expectations. Understanding this hierarchy is essential for maintaining discipline and ensuring effective communication during operations. What is the primary purpose of military ranks?",
  answer: "To establish a clear chain of command and define responsibilities. The passage emphasizes ranks create structure for authority and duties.",
  difficulty: "Easy"
},
{
  id: 2508,
  subject: "Paragraph Comprehension",
  question: "Antibiotics are medications that kill bacteria or prevent their growth. However, they are ineffective against viral infections like the common cold or flu. Misusing antibiotics by taking them for viral illnesses can lead to antibiotic resistance, making these drugs less effective when truly needed. Why are antibiotics ineffective against colds and flu?",
  answer: "Because colds and flu are caused by viruses, not bacteria. The passage explains antibiotics only work against bacterial infections, not viral ones.",
  difficulty: "Easy"
},
{
  id: 2509,
  subject: "Paragraph Comprehension",
  question: "The Richter scale measures the magnitude of earthquakes based on the energy released. Each whole number increase represents a tenfold increase in measured amplitude and roughly 31 times more energy release. An earthquake measuring 6.0 is significantly more destructive than one measuring 5.0. What does each whole number increase on the Richter scale represent?",
  answer: "A tenfold increase in amplitude and about 31 times more energy. The passage provides these specific measurements.",
  difficulty: "Medium"
},
{
  id: 2510,
  subject: "Paragraph Comprehension",
  question: "Regular maintenance extends the life of mechanical equipment and prevents costly breakdowns. Changing oil, inspecting parts for wear, and keeping components clean are simple tasks that yield significant benefits. Neglecting routine maintenance often results in expensive repairs that could have been easily avoided. What is the main idea of this passage?",
  answer: "Regular maintenance prevents costly problems and extends equipment life. The passage emphasizes prevention through routine care.",
  difficulty: "Easy"
},
{
  id: 2511,
  subject: "Paragraph Comprehension",
  question: "The greenhouse effect occurs when certain atmospheric gases trap heat radiating from Earth's surface. Carbon dioxide, methane, and water vapor act like a blanket, preventing heat from escaping into space. While this natural process makes Earth habitable, excessive greenhouse gases can lead to global temperature increases. What causes the greenhouse effect?",
  answer: "Atmospheric gases trapping heat from Earth's surface. The passage explains gases prevent heat from escaping, causing the warming effect.",
  difficulty: "Easy"
},
{
  id: 2512,
  subject: "Paragraph Comprehension",
  question: "Sonar technology uses sound waves to detect underwater objects and measure ocean depths. A device sends out sound pulses and calculates distance based on how long echoes take to return. Originally developed for submarine detection during wartime, sonar now serves many purposes including fishing, navigation, and marine research. How does sonar calculate distance to objects?",
  answer: "By measuring the time it takes for sound echoes to return. The passage explains distance is calculated from echo return time.",
  difficulty: "Easy"
},
{
  id: 2513,
  subject: "Paragraph Comprehension",
  question: "Dehydration occurs when the body loses more fluid than it takes in. Symptoms include thirst, dark urine, fatigue, and dizziness. Severe dehydration can be life-threatening and requires immediate medical attention. Drinking water regularly throughout the day, especially during physical activity, helps maintain proper hydration. What are symptoms of dehydration mentioned in the passage?",
  answer: "Thirst, dark urine, fatigue, and dizziness. These four symptoms are specifically listed in the passage.",
  difficulty: "Easy"
},
{
  id: 2514,
  subject: "Paragraph Comprehension",
  question: "Camouflage helps military personnel and equipment blend into surroundings, reducing visibility to enemies. Different patterns work best in different environments: woodland, desert, and urban settings each require specific designs. Modern digital camouflage uses pixelated patterns that disrupt the human outline more effectively than traditional designs. What is the primary purpose of military camouflage?",
  answer: "To reduce visibility by helping personnel and equipment blend into surroundings. The passage emphasizes concealment from enemies.",
  difficulty: "Easy"
},
{
  id: 2515,
  subject: "Paragraph Comprehension",
  question: "The Declaration of Independence, written primarily by Thomas Jefferson, announced the American colonies' separation from British rule in 1776. It asserted that all people have unalienable rights including life, liberty, and the pursuit of happiness. This document became a foundation for democratic principles worldwide. Who was the primary author of the Declaration of Independence?",
  answer: "Thomas Jefferson. The passage explicitly states Jefferson wrote it primarily.",
  difficulty: "Easy"
},
{
  id: 2516,
  subject: "Paragraph Comprehension",
  question: "Friction is the force that opposes motion between surfaces in contact. While friction can make movement more difficult, it is also essential for many everyday activities. Without friction, we couldn't walk, vehicles couldn't stop, and objects would slide uncontrollably. What can be inferred about friction from this passage?",
  answer: "Friction has both disadvantages and necessary benefits. The passage shows friction opposes motion but is essential for walking and stopping.",
  difficulty: "Medium"
},
{
  id: 2517,
  subject: "Paragraph Comprehension",
  question: "Radar systems emit radio waves and detect their reflections from distant objects. By analyzing the returning signals, radar can determine an object's location, speed, and direction. This technology is crucial for air traffic control, weather forecasting, and military defense systems. What does radar use to detect objects?",
  answer: "Radio waves and their reflections. The passage states radar emits radio waves and detects their reflections.",
  difficulty: "Easy"
},
{
  id: 2518,
  subject: "Paragraph Comprehension",
  question: "Sleep is essential for physical and mental health. During sleep, the body repairs tissues, consolidates memories, and regulates hormones. Most adults require 7-9 hours of sleep per night for optimal functioning. Chronic sleep deprivation can lead to serious health problems including weakened immunity and impaired cognitive performance. According to the passage, how much sleep do most adults need?",
  answer: "7-9 hours per night. The passage specifically states this range for optimal adult functioning.",
  difficulty: "Easy"
},
{
  id: 2519,
  subject: "Paragraph Comprehension",
  question: "Navigation by the stars has guided sailors for thousands of years. The North Star, or Polaris, maintains a nearly fixed position above the North Pole, making it particularly useful for determining direction in the Northern Hemisphere. By observing star positions and movements, experienced navigators can determine latitude and plot courses across vast oceans. Why is Polaris especially useful for navigation?",
  answer: "It maintains a nearly fixed position above the North Pole, making it reliable for determining direction. The passage emphasizes its stable position.",
  difficulty: "Easy"
},
{
  id: 2520,
  subject: "Paragraph Comprehension",
  question: "The human immune system defends the body against disease-causing microorganisms. White blood cells identify and destroy foreign invaders such as bacteria and viruses. Vaccines work by exposing the immune system to weakened or inactive pathogens, allowing it to develop defenses without causing illness. How do vaccines help the immune system?",
  answer: "They expose it to weakened pathogens so it can develop defenses without getting sick. The passage explains vaccines train immunity safely.",
  difficulty: "Medium"
},
{
  id: 2521,
  subject: "Paragraph Comprehension",
  question: "Topographic maps display the three-dimensional shape of terrain on a two-dimensional surface using contour lines. Each line represents a specific elevation, and lines close together indicate steep slopes. Understanding these maps is crucial for military operations, hiking, and land use planning. What do closely spaced contour lines on a topographic map indicate?",
  answer: "Steep slopes. The passage states lines close together show steep terrain.",
  difficulty: "Easy"
},
{
  id: 2522,
  subject: "Paragraph Comprehension",
  question: "The scientific method is a systematic approach to investigating phenomena and acquiring knowledge. It involves making observations, forming hypotheses, conducting experiments, and analyzing results. This process allows scientists to test ideas objectively and build upon existing knowledge through reproducible findings. What is the main purpose of the scientific method?",
  answer: "To systematically investigate phenomena and acquire knowledge objectively. The passage emphasizes systematic, testable investigation.",
  difficulty: "Easy"
},
{
  id: 2523,
  subject: "Paragraph Comprehension",
  question: "Hydraulic systems use pressurized fluid to transmit force and power. A small force applied to a small piston creates pressure that transfers through fluid to a larger piston, multiplying the force. This principle enables heavy machinery like excavators and aircraft landing gear to perform powerful operations with relatively modest input. How do hydraulic systems multiply force?",
  answer: "Pressure from a small piston transfers through fluid to a larger piston, increasing force. The passage explains the fluid pressure transfer mechanism.",
  difficulty: "Medium"
},
{
  id: 2524,
  subject: "Paragraph Comprehension",
  question: "Lightning is a massive electrical discharge between clouds and the ground or between clouds. It occurs when positive and negative charges separate within storm clouds, creating strong electrical fields. When the electrical potential becomes great enough, it overcomes air resistance and releases energy as a brilliant flash and thunder. What causes lightning to occur?",
  answer: "Separation of electrical charges in clouds creating strong fields that discharge. The passage describes the charge buildup and release process.",
  difficulty: "Medium"
},
{
  id: 2525,
  subject: "Paragraph Comprehension",
  question: "First aid is the immediate care given to an injured or ill person before professional medical help arrives. Quick action can prevent a condition from worsening and may save lives. Basic first aid skills include CPR, controlling bleeding, and treating shock. Everyone should learn these fundamental techniques. What is the primary goal of first aid?",
  answer: "To provide immediate care that prevents conditions from worsening before professional help arrives. The passage emphasizes prompt care and prevention.",
  difficulty: "Easy"
},
{
  id: 2526,
  subject: "Paragraph Comprehension",
  question: "The Pythagorean theorem states that in a right triangle, the square of the hypotenuse equals the sum of the squares of the other two sides. This mathematical principle has practical applications in construction, navigation, and engineering. Carpenters use it to ensure corners are perfectly square when building structures. How do carpenters use the Pythagorean theorem?",
  answer: "To ensure corners are perfectly square when building. The passage states carpenters apply it for square corners.",
  difficulty: "Easy"
},
{
  id: 2527,
  subject: "Paragraph Comprehension",
  question: "Composting transforms organic waste into nutrient-rich soil amendment through natural decomposition. Microorganisms break down materials like food scraps and yard waste, creating valuable fertilizer while reducing landfill burden. The process requires proper balance of carbon-rich and nitrogen-rich materials, adequate moisture, and oxygen. What is composting?",
  answer: "The process of transforming organic waste into nutrient-rich soil through natural decomposition. The passage defines composting as decomposition creating fertilizer.",
  difficulty: "Easy"
},
{
  id: 2528,
  subject: "Paragraph Comprehension",
  question: "Military time uses a 24-hour clock format to eliminate confusion between AM and PM. Times are expressed as four digits: 0000 (midnight) through 2359 (11:59 PM). For example, 1:00 PM is written as 1300 hours. This system is standard in armed forces worldwide and in many international operations. Why does the military use 24-hour time?",
  answer: "To eliminate confusion between AM and PM. The passage states this is the reason for the 24-hour format.",
  difficulty: "Easy"
},
{
  id: 2529,
  subject: "Paragraph Comprehension",
  question: "Erosion is the gradual wearing away of rock and soil by wind, water, or ice. While a natural process, human activities like deforestation and poor farming practices can accelerate erosion dramatically. This leads to loss of fertile topsoil, water pollution, and landscape degradation. What can be inferred about human impact on erosion?",
  answer: "Human activities can significantly worsen natural erosion rates. The passage indicates humans can dramatically accelerate the natural process.",
  difficulty: "Medium"
},
{
  id: 2530,
  subject: "Paragraph Comprehension",
  question: "The Bill of Rights comprises the first ten amendments to the U.S. Constitution, guaranteeing fundamental freedoms and rights. These include freedom of speech, religion, and the press, as well as protections against unreasonable searches and the right to a fair trial. Ratified in 1791, these amendments form the cornerstone of American civil liberties. How many amendments make up the Bill of Rights?",
  answer: "Ten. The passage explicitly states the Bill of Rights comprises the first ten amendments.",
  difficulty: "Easy"
},
{
  id: 2531,
  subject: "Paragraph Comprehension",
  question: "Submarines dive and surface by controlling their buoyancy through ballast tanks. To submerge, tanks are flooded with seawater, increasing the vessel's weight. To surface, compressed air forces water out of the tanks, making the submarine lighter than the surrounding water. This system allows precise depth control underwater. How do submarines control their depth?",
  answer: "By flooding or emptying ballast tanks to change buoyancy. The passage explains weight is adjusted by adding or removing water from tanks.",
  difficulty: "Medium"
},
{
  id: 2532,
  subject: "Paragraph Comprehension",
  question: "Hurricanes are powerful tropical storms with wind speeds exceeding 74 miles per hour. They form over warm ocean waters and can cause devastating damage through high winds, heavy rainfall, and storm surges. The eye of a hurricane is a calm center surrounded by the most intense winds. What wind speed defines a hurricane?",
  answer: "Wind speeds exceeding 74 miles per hour. The passage specifically states this threshold for hurricane classification.",
  difficulty: "Easy"
},
{
  id: 2533,
  subject: "Paragraph Comprehension",
  question: "Insulation reduces heat transfer between areas of different temperatures. In buildings, it keeps warmth inside during winter and outside during summer, significantly reducing energy costs. Common insulation materials include fiberglass, foam, and cellulose, each with different thermal resistance properties. What is the primary function of building insulation?",
  answer: "To reduce heat transfer and energy costs by controlling temperature. The passage emphasizes prevention of heat movement between areas.",
  difficulty: "Easy"
},
{
  id: 2534,
  subject: "Paragraph Comprehension",
  question: "Parachutes slow descent by creating air resistance, or drag. When deployed, the large canopy catches air and creates opposing force against gravity. Military parachutes are designed for both personnel and equipment drops, with different designs for various operational needs. The reliable deployment of parachutes is critical for airborne operations. How do parachutes slow a fall?",
  answer: "By creating air resistance through a large canopy that opposes gravity. The passage explains the canopy catches air to create drag.",
  difficulty: "Easy"
},
{
  id: 2535,
  subject: "Paragraph Comprehension",
  question: "The Lewis and Clark expedition explored the newly acquired Louisiana Territory from 1804 to 1806. Commissioned by President Thomas Jefferson, the journey mapped terrain, established trade with Native Americans, and documented flora and fauna. Their success opened the western frontier to further exploration and settlement. Who commissioned the Lewis and Clark expedition?",
  answer: "President Thomas Jefferson. The passage directly states Jefferson commissioned the expedition.",
  difficulty: "Easy"
},
{
  id: 2536,
  subject: "Paragraph Comprehension",
  question: "Torque is a measure of rotational force applied to an object. When using wrenches or other tools, torque determines how tightly bolts are fastened. Too little torque results in loose connections, while excessive torque can damage threads or break components. Proper torque specifications are critical in mechanical assembly and maintenance. What happens if excessive torque is applied?",
  answer: "It can damage threads or break components. The passage warns that too much torque causes damage.",
  difficulty: "Easy"
},
{
  id: 2537,
  subject: "Paragraph Comprehension",
  question: "Democracy is a system of government where power rests with the people through elected representatives. Citizens exercise their authority by voting in free and fair elections. Democratic societies typically protect individual rights, maintain rule of law, and ensure government accountability. This form of governance contrasts with authoritarian systems where power concentrates in single rulers or small groups. What distinguishes democracy from authoritarian systems?",
  answer: "Power rests with the people through elections rather than concentrating in single rulers or small groups. The passage contrasts distributed versus concentrated power.",
  difficulty: "Medium"
},
{
  id: 2538,
  subject: "Paragraph Comprehension",
  question: "Antibodies are proteins produced by the immune system that identify and neutralize foreign objects like bacteria and viruses. Each antibody is specific to a particular antigen, working like a lock and key. After an infection or vaccination, the body retains memory of specific antibodies, providing faster protection against future exposure. What makes antibodies effective?",
  answer: "They are specific to particular antigens, targeting them precisely like a lock and key. The passage emphasizes specificity in antibody function.",
  difficulty: "Medium"
},
{
  id: 2539,
  subject: "Paragraph Comprehension",
  question: "GPS technology uses signals from multiple satellites to determine precise location on Earth. A receiver calculates its position by measuring the time signals take to arrive from at least four satellites. Originally developed for military navigation, GPS now serves countless civilian applications from smartphone maps to precision agriculture. How many satellites are needed for GPS positioning?",
  answer: "At least four satellites. The passage states receivers need signals from at least four satellites to calculate position.",
  difficulty: "Easy"
},
{
  id: 2540,
  subject: "Paragraph Comprehension",
  question: "Effective communication requires both clear expression and active listening. Misunderstandings often arise when people focus on responding rather than truly comprehending what others say. In military contexts, poor communication can have serious consequences, making precision and confirmation protocols essential. What does active listening require according to the passage?",
  answer: "Truly comprehending what others say rather than just focusing on responding. The passage contrasts real understanding with simply preparing responses.",
  difficulty: "Medium"
},
{
  id: 2541,
  subject: "Paragraph Comprehension",
  question: "Newton's first law of motion states that an object at rest stays at rest and an object in motion stays in motion unless acted upon by an external force. This principle, called inertia, explains why passengers lurch forward when cars brake suddenly. Seatbelts provide the external force needed to change the passenger's motion and prevent injury. What is Newton's first law also called?",
  answer: "Inertia. The passage explicitly identifies inertia as the name for Newton's first law.",
  difficulty: "Easy"
},
{
  id: 2542,
  subject: "Paragraph Comprehension",
  question: "Coral reefs are diverse underwater ecosystems formed by colonies of tiny animals called coral polyps. These structures provide habitat for countless marine species and protect coastlines from erosion. However, reefs face serious threats from rising ocean temperatures, pollution, and destructive fishing practices. Many scientists consider reef conservation urgent for ocean health. What can be inferred about the author's view of coral reefs?",
  answer: "They are valuable ecosystems that need protection due to serious threats. The passage emphasizes their importance and vulnerability, suggesting urgency.",
  difficulty: "Medium"
},
{
  id: 2543,
  subject: "Paragraph Comprehension",
  question: "Leather has been used for clothing and equipment for thousands of years because of its durability and flexibility. The tanning process converts animal hides into leather by treating them with chemicals that prevent decay. Modern military boots often combine leather with synthetic materials to optimize protection, breathability, and weight. Why has leather been used for so long?",
  answer: "Because of its durability and flexibility. The passage states these two properties explain leather's long-term use.",
  difficulty: "Easy"
},
{
  id: 2544,
  subject: "Paragraph Comprehension",
  question: "The combustion engine converts chemical energy from fuel into mechanical energy through controlled explosions. Fuel mixed with air ignites in cylinders, driving pistons that turn the crankshaft. This rotational motion ultimately powers the vehicle's wheels. Most cars and trucks rely on this technology, though electric alternatives are becoming more common. What does a combustion engine convert?",
  answer: "Chemical energy from fuel into mechanical energy. The passage describes this as the fundamental conversion process.",
  difficulty: "Easy"
},
{
  id: 2545,
  subject: "Paragraph Comprehension",
  question: "Camels can survive weeks without water due to several remarkable adaptations. They store fat in their humps, which can be converted to water and energy. Their blood cells have a unique oval shape that continues flowing even when dehydrated. Additionally, camels can drink up to 30 gallons of water in just 13 minutes when it becomes available. How do camels' humps help them survive without water?",
  answer: "They store fat that can be converted to water and energy. The passage explains the humps' fat provides both water and energy.",
  difficulty: "Medium"
},
{
  id: 2546,
  subject: "Paragraph Comprehension",
  question: "Maps use symbols and legends to represent real-world features on paper. Different colors and markings indicate terrain types, roads, buildings, and water features. Scale shows the relationship between distances on the map and actual ground distances. Understanding map reading is fundamental for navigation, especially in areas without electronic devices. What does a map's scale show?",
  answer: "The relationship between map distances and actual ground distances. The passage defines scale as this distance relationship.",
  difficulty: "Easy"
},
{
  id: 2547,
  subject: "Paragraph Comprehension",
  question: "The Underground Railroad was not actually underground or a railroad, but a secret network of routes and safe houses that helped enslaved people escape to freedom in the 19th century. Courageous individuals called conductors guided fugitives north to free states and Canada, risking severe punishment. Harriet Tubman was one of the most famous conductors, leading dozens to freedom. What were conductors in the Underground Railroad?",
  answer: "People who guided enslaved individuals to freedom along the escape routes. The passage identifies conductors as those who led fugitives north.",
  difficulty: "Easy"
},
{
  id: 2548,
  subject: "Paragraph Comprehension",
  question: "Proper lifting technique prevents back injuries. When lifting heavy objects, bend at the knees rather than the waist, keep the load close to your body, and use leg muscles to stand. Avoid twisting while carrying weight, and ask for help with items too heavy for one person. These simple practices can prevent serious and painful injuries. According to the passage, which muscles should do most of the work when lifting?",
  answer: "Leg muscles. The passage instructs to use leg muscles to stand when lifting.",
  difficulty: "Easy"
},
{
  id: 2549,
  subject: "Paragraph Comprehension",
  question: "Metamorphosis is a biological process where an animal physically transforms from one form to another. Butterflies undergo complete metamorphosis, changing from egg to larva (caterpillar) to pupa (chrysalis) to adult. This transformation allows different life stages to occupy different ecological niches and exploit varied food sources. What advantage does metamorphosis provide?",
  answer: "Different life stages can occupy different niches and use varied food sources. The passage explains this ecological benefit of transformation.",
  difficulty: "Medium"
},
{
  id: 2550,
  subject: "Paragraph Comprehension",
  question: "Air pressure decreases with altitude because there is less atmospheric mass above to create weight and compression. At sea level, air pressure is about 14.7 pounds per square inch, but at 18,000 feet it drops to roughly half that. This reduced pressure affects breathing, cooking, and aircraft performance. What causes air pressure to decrease at higher altitudes?",
  answer: "Less atmospheric mass above creates less weight and compression. The passage explains pressure comes from the weight of air above.",
  difficulty: "Medium"
},
{
  id: 2551,
  subject: "Paragraph Comprehension",
  question: "Magnets have two poles, north and south, that create magnetic fields. Opposite poles attract while like poles repel each other. This fundamental property enables numerous applications from electric motors to computer hard drives. Earth itself acts as a giant magnet, which is why compass needles point north. What happens when two south poles are brought together?",
  answer: "They repel each other. The passage states like poles repel, so two south poles would push apart.",
  difficulty: "Easy"
},
{
  id: 2552,
  subject: "Paragraph Comprehension",
  question: "The Articles of Confederation served as America's first constitution from 1781 to 1789. However, it created a weak central government that lacked power to tax or regulate commerce effectively. These deficiencies led to the Constitutional Convention, where the current Constitution was drafted to establish a stronger federal system. Why was the Constitution created to replace the Articles of Confederation?",
  answer: "The Articles created too weak a government that couldn't tax or regulate commerce effectively. The passage identifies these deficiencies as the reason for replacement.",
  difficulty: "Medium"
},
{
  id: 2553,
  subject: "Paragraph Comprehension",
  question: "Clouds form when water vapor in the air cools and condenses into tiny water droplets or ice crystals. This typically occurs when warm, moist air rises and expands in the lower pressure of higher altitudes. Different cloud types indicate various weather conditions, helping meteorologists predict atmospheric changes. What must happen for clouds to form?",
  answer: "Water vapor must cool and condense into droplets or ice crystals. The passage describes condensation as the cloud formation process.",
  difficulty: "Easy"
},
{
  id: 2554,
  subject: "Paragraph Comprehension",
  question: "Kevlar is a synthetic fiber five times stronger than steel by weight. Developed in the 1960s, it resists heat and cutting, making it ideal for protective equipment. Body armor, helmets, and cut-resistant gloves commonly use Kevlar to protect military and law enforcement personnel. Its remarkable strength-to-weight ratio revolutionized personal protection. How does Kevlar's strength compare to steel?",
  answer: "It is five times stronger than steel by weight. The passage specifically states this strength ratio.",
  difficulty: "Easy"
},
{
  id: 2555,
  subject: "Paragraph Comprehension",
  question: "Crop rotation is the practice of growing different crops in sequence on the same land. This technique prevents soil depletion, interrupts pest cycles, and can improve soil quality. For example, planting legumes after grain crops adds nitrogen back to the soil naturally. Ancient farmers discovered these benefits through observation and experience. What is one benefit of crop rotation mentioned in the passage?",
  answer: "It prevents soil depletion, interrupts pest cycles, or improves soil quality (any of these three benefits). The passage lists all three advantages.",
  difficulty: "Easy"
},
{
  id: 2556,
  subject: "Paragraph Comprehension",
  question: "Infrared radiation is electromagnetic energy with wavelengths longer than visible light but shorter than radio waves. All objects emit infrared radiation based on their temperature. Night vision devices detect this thermal radiation, allowing users to see in complete darkness. This technology has significant military and search-and-rescue applications. How do night vision devices work?",
  answer: "They detect infrared thermal radiation emitted by objects. The passage explains night vision detects infrared based on temperature.",
  difficulty: "Medium"
},
{
  id: 2557,
  subject: "Paragraph Comprehension",
  question: "The Berlin Airlift of 1948-1949 demonstrated Western resolve during the Cold War. When the Soviet Union blockaded West Berlin, cutting off ground access, Allied forces supplied the city entirely by air for nearly a year. Planes delivered food, fuel, and supplies around the clock, ultimately forcing the Soviets to end the blockade. What did the Berlin Airlift accomplish?",
  answer: "It supplied West Berlin entirely by air during a Soviet blockade, ultimately forcing its end. The passage describes the airlift's success in defeating the blockade.",
  difficulty: "Medium"
},
{
  id: 2558,
  subject: "Paragraph Comprehension",
  question: "Semiconductors are materials with electrical conductivity between conductors and insulators. Silicon is the most common semiconductor, forming the basis of computer chips and electronic devices. By adding impurities in a process called doping, engineers can precisely control semiconductor properties, enabling the transistors that power modern technology. What are semiconductors?",
  answer: "Materials with electrical conductivity between conductors and insulators. The passage defines semiconductors by their intermediate conductivity.",
  difficulty: "Easy"
},
{
  id: 2559,
  subject: "Paragraph Comprehension",
  question: "Echolocation allows certain animals to navigate and hunt using sound. Bats and dolphins emit high-frequency calls and interpret returning echoes to determine object locations, sizes, and distances. This biological sonar works effectively in darkness or murky water where vision fails. The precision of echolocation enables bats to catch tiny insects in complete darkness. What is echolocation?",
  answer: "Navigation and hunting using sound by emitting calls and interpreting echoes. The passage describes it as biological sonar using sound emissions and returns.",
  difficulty: "Easy"
},
{
  id: 2560,
  subject: "Paragraph Comprehension",
  question: "Penicillin, discovered accidentally by Alexander Fleming in 1928, was the first antibiotic drug. Fleming noticed that mold contaminating a bacterial culture had killed surrounding bacteria. This discovery revolutionized medicine, providing effective treatment for previously deadly infections. Mass production during World War II saved countless lives and established antibiotics as essential medical tools. How was penicillin discovered?",
  answer: "Accidentally when Fleming noticed mold had killed bacteria in a contaminated culture. The passage describes the accidental observation of mold's antibacterial effect.",
  difficulty: "Easy"
},
{
  id: 2561,
  subject: "Paragraph Comprehension",
  question: "Osmosis is the movement of water molecules through a semipermeable membrane from areas of lower solute concentration to higher concentration. This process is vital for cells to maintain proper fluid balance. Plants use osmosis to draw water from soil through their roots. Without osmosis, living organisms could not regulate hydration or nutrient distribution. What is osmosis?",
  answer: "The movement of water through a membrane from lower to higher solute concentration. The passage defines osmosis as this directional water movement.",
  difficulty: "Medium"
},
{
  id: 2562,
  subject: "Paragraph Comprehension",
  question: "Welding joins metal pieces by melting their edges and adding filler material. The molten metal fuses together and solidifies, creating a strong bond often as durable as the original material. Different welding techniques suit different metals and applications. Skilled welders are essential in construction, manufacturing, and maintenance industries. How does welding join metals?",
  answer: "By melting edges and adding filler that fuses and solidifies into a strong bond. The passage describes the melting and fusion process.",
  difficulty: "Easy"
},
{
  id: 2563,
  subject: "Paragraph Comprehension",
  question: "The Emancipation Proclamation, issued by President Lincoln on January 1, 1863, declared that all enslaved people in Confederate territory were free. While it didn't immediately free all enslaved individuals, it fundamentally transformed the Civil War's purpose from solely preserving the Union to also ending slavery. The proclamation also allowed African Americans to join Union forces. What effect did the Emancipation Proclamation have on the Civil War's purpose?",
  answer: "It transformed the war from solely preserving the Union to also ending slavery. The passage identifies this fundamental shift in war aims.",
  difficulty: "Medium"
},
{
  id: 2564,
  subject: "Paragraph Comprehension",
  question: "Fiber optic cables transmit data as pulses of light through thin glass strands. Light reflects internally through the fiber, traveling long distances with minimal signal loss. These cables carry far more information than traditional copper wires and are immune to electromagnetic interference. Most modern internet infrastructure relies on fiber optic technology. What advantage do fiber optic cables have over copper wires?",
  answer: "They carry more information and are immune to electromagnetic interference (or either advantage). The passage lists both benefits of fiber optics.",
  difficulty: "Medium"
},
{
  id: 2565,
  subject: "Paragraph Comprehension",
  question: "Tides are the regular rise and fall of ocean water levels caused primarily by the Moon's gravitational pull. As Earth rotates, different areas experience high and low tides roughly twice daily. The Sun also affects tides, and when Sun and Moon align, their combined gravity creates especially high spring tides. Coastal communities must account for tidal changes in navigation and construction. What primarily causes ocean tides?",
  answer: "The Moon's gravitational pull. The passage states the Moon's gravity is the primary cause.",
  difficulty: "Easy"
},
{
  id: 2566,
  subject: "Paragraph Comprehension",
  question: "Alloys are mixtures of two or more metals combined to achieve superior properties. Steel, an alloy of iron and carbon, is stronger than pure iron. Bronze, combining copper and tin, resists corrosion better than either component alone. Creating alloys allows engineers to design materials for specific applications. What is an alloy?",
  answer: "A mixture of two or more metals combined to achieve superior properties. The passage defines alloys as metal mixtures with enhanced characteristics.",
  difficulty: "Easy"
},
{
  id: 2567,
  subject: "Paragraph Comprehension",
  question: "Altitude sickness occurs when people ascend to high elevations too quickly for their bodies to adjust to reduced oxygen levels. Symptoms include headache, nausea, dizziness, and fatigue. Severe cases can be life-threatening. Gradual ascent allows the body to acclimatize by producing more red blood cells to carry oxygen more efficiently. What causes altitude sickness?",
  answer: "Ascending too quickly for the body to adjust to reduced oxygen levels. The passage identifies rapid ascent without adjustment as the cause.",
  difficulty: "Easy"
},
{
  id: 2568,
  subject: "Paragraph Comprehension",
  question: "Distillation separates liquids based on different boiling points. When a mixture is heated, components with lower boiling points evaporate first. The vapor is then cooled and collected separately. This process purifies water, produces alcoholic spirits, and refines petroleum into various fuels. Ancient civilizations used distillation to create perfumes and medicines. How does distillation separate liquids?",
  answer: "By heating mixtures so components with different boiling points evaporate at different times. The passage explains separation occurs through selective evaporation based on boiling points.",
  difficulty: "Medium"
},
{
  id: 2569,
  subject: "Paragraph Comprehension",
  question: "The D-Day invasion on June 6, 1944, was the largest amphibious military assault in history. Allied forces landed on the beaches of Normandy, France, beginning the liberation of Western Europe from Nazi occupation. Despite heavy casualties, the successful invasion marked a turning point in World War II. Detailed planning and deception operations were crucial to its success. What was significant about D-Day?",
  answer: "It was the largest amphibious assault in history and marked a turning point in WWII by beginning the liberation of Western Europe. The passage emphasizes both its scale and strategic importance.",
  difficulty: "Medium"
},
{
  id: 2570,
  subject: "Paragraph Comprehension",
  question: "Wind turbines convert kinetic energy from moving air into electrical energy. Blades rotate when wind strikes them, turning a generator that produces electricity. Modern wind farms can generate substantial power without producing greenhouse gases or consuming water. However, wind energy production varies with weather conditions, requiring backup power sources or energy storage. What limitation of wind energy is mentioned?",
  answer: "Production varies with weather conditions, requiring backup or storage. The passage identifies variable output as a limitation needing supplementation.",
  difficulty: "Medium"
},
{
  id: 2571,
  subject: "Paragraph Comprehension",
  question: "Forensic science applies scientific methods to investigate crimes and analyze evidence. Techniques include DNA analysis, fingerprint examination, and ballistics testing. By carefully examining physical evidence, forensic experts help establish facts and identify perpetrators. This field has become increasingly sophisticated, often providing crucial testimony in legal proceedings. What is forensic science?",
  answer: "The application of scientific methods to investigate crimes and analyze evidence. The passage defines it as science applied to criminal investigation.",
  difficulty: "Easy"
},
{
  id: 2572,
  subject: "Paragraph Comprehension",
  question: "Perspective in art creates the illusion of three-dimensional depth on flat surfaces. Artists achieve this by making distant objects smaller, using converging lines that meet at vanishing points, and adjusting detail and color intensity. Renaissance painters developed mathematical perspective systems that revolutionized realistic representation. Understanding perspective is fundamental to drawing and painting. How do artists create the illusion of depth?",
  answer: "By making distant objects smaller, using converging lines, and adjusting detail and color (or any combination of these techniques). The passage lists these methods for creating depth illusion.",
  difficulty: "Medium"
},
{
  id: 2573,
  subject: "Paragraph Comprehension",
  question: "Antibiotics should be taken exactly as prescribed, even if symptoms improve before the medication is finished. Stopping treatment early allows surviving bacteria to multiply and potentially develop resistance. Resistant bacteria are harder to treat and pose serious health threats. Following complete antibiotic courses protects both individual and public health. Why should antibiotic treatment be completed even after feeling better?",
  answer: "To prevent surviving bacteria from multiplying and developing resistance. The passage explains incomplete treatment allows bacterial survival and resistance development.",
  difficulty: "Medium"
},
{
  id: 2574,
  subject: "Paragraph Comprehension",
  question: "The Korean War began in 1950 when North Korea invaded South Korea, prompting United Nations intervention led by the United States. The conflict ended in 1953 with an armistice that maintained division near the original border. Technically, the war never officially ended, as no peace treaty was signed. The demilitarized zone separating the countries remains one of the world's most heavily fortified borders. What is the current status of the Korean War?",
  answer: "It technically never officially ended, as only an armistice was signed, not a peace treaty. The passage states the war never officially concluded.",
  difficulty: "Hard"
},
{
  id: 2575,
  subject: "Paragraph Comprehension",
  question: "Vaccination programs have eliminated or greatly reduced many deadly diseases. Smallpox was completely eradicated through worldwide vaccination efforts. Polio cases have decreased by over 99% since 1988. These successes demonstrate that coordinated public health initiatives can triumph over devastating illnesses. However, maintaining high vaccination rates is essential to prevent disease resurgence. What does the passage suggest about public health programs?",
  answer: "Coordinated efforts can successfully eliminate diseases, but continued high vaccination rates are necessary. The passage emphasizes both achievements and ongoing need for vaccination.",
  difficulty: "Medium"
},
{
  id: 2576,
  subject: "Paragraph Comprehension",
  question: "Gears transmit motion and force by interlocking teeth. When a small gear drives a large gear, speed decreases but force increases, providing mechanical advantage. Conversely, a large gear driving a small one increases speed while reducing force. This principle enables machines from bicycles to industrial equipment to optimize power delivery for specific tasks. What happens when a small gear drives a larger gear?",
  answer: "Speed decreases but force increases. The passage states this relationship provides mechanical advantage.",
  difficulty: "Easy"
},
{
  id: 2577,
  subject: "Paragraph Comprehension",
  question: "The water cycle continuously circulates Earth's water through evaporation, condensation, and precipitation. Solar energy evaporates water from oceans and land into the atmosphere. As water vapor rises and cools, it condenses into clouds. Eventually, water returns to the surface as rain or snow, replenishing lakes, rivers, and groundwater. What drives the water cycle?",
  answer: "Solar energy. The passage states solar energy powers evaporation, initiating the cycle.",
  difficulty: "Easy"
},
{
  id: 2578,
  subject: "Paragraph Comprehension",
  question: "Concrete is made by mixing cement, water, sand, and gravel. The cement and water react chemically, binding the mixture into a hard, durable material. Adding steel reinforcement creates reinforced concrete, which combines concrete's compressive strength with steel's tensile strength. This combination is fundamental to modern construction of buildings, bridges, and infrastructure. What does reinforced concrete combine?",
  answer: "Concrete's compressive strength with steel's tensile strength. The passage identifies these complementary strength properties.",
  difficulty: "Medium"
},
{
  id: 2579,
  subject: "Paragraph Comprehension",
  question: "The Constitution's system of checks and balances prevents any single government branch from becoming too powerful. The executive, legislative, and judicial branches each have specific powers and can limit actions of the others. For example, the President can veto legislation, Congress can override vetoes, and courts can declare laws unconstitutional. What is the purpose of checks and balances?",
  answer: "To prevent any single government branch from becoming too powerful. The passage states this as the system's purpose.",
  difficulty: "Easy"
},
{
  id: 2580,
  subject: "Paragraph Comprehension",
  question: "Ballistics is the science of projectile motion and behavior. External ballistics examines how bullets travel through air, affected by gravity, wind, and air resistance. Terminal ballistics studies projectile effects upon impact. Understanding ballistics is crucial for military applications, forensic investigations, and improving weapon accuracy. What does external ballistics study?",
  answer: "How bullets travel through air, affected by gravity, wind, and air resistance. The passage defines external ballistics as studying projectile flight.",
  difficulty: "Easy"
},
{
  id: 2581,
  subject: "Paragraph Comprehension",
  question: "Volcanoes form where molten rock, called magma, reaches Earth's surface. Eruptions occur when pressure from dissolved gases forces magma upward. Volcanic activity creates new land, enriches soil with minerals, but also poses significant hazards. The Ring of Fire, circling the Pacific Ocean, contains most of the world's active volcanoes due to tectonic plate boundaries. What causes volcanic eruptions?",
  answer: "Pressure from dissolved gases forcing magma upward. The passage identifies gas pressure as the eruption mechanism.",
  difficulty: "Easy"
},
{
  id: 2582,
  subject: "Paragraph Comprehension",
  question: "Cold War tensions between the United States and Soviet Union dominated global politics from 1947 to 1991. Despite never engaging in direct military conflict, the superpowers competed through proxy wars, arms races, and ideological struggles. The conflict's end came with the Soviet Union's dissolution, fundamentally reshaping international relations. The term 'cold' refers to the absence of direct warfare between the main powers. Why was it called the 'Cold' War?",
  answer: "Because there was no direct military conflict between the main powers despite tensions. The passage explains 'cold' refers to the absence of direct warfare.",
  difficulty: "Easy"
},
{
  id: 2583,
  subject: "Paragraph Comprehension",
  question: "Aerodynamics studies how air moves around objects. Streamlined shapes reduce air resistance, or drag, allowing vehicles and aircraft to move more efficiently. Wings generate lift by creating pressure differences above and below their surfaces. Engineers apply aerodynamic principles to design everything from race cars to skyscrapers. What is drag?",
  answer: "Air resistance. The passage defines drag as air resistance that streamlined shapes reduce.",
  difficulty: "Easy"
},
{
  id: 2584,
  subject: "Paragraph Comprehension",
  question: "The Great Depression began with the 1929 stock market crash and lasted through the 1930s. Unemployment reached 25%, banks failed, and economic output plummeted. President Franklin Roosevelt's New Deal programs provided relief, created jobs, and reformed financial systems. The crisis ended fully only with World War II's industrial mobilization. How did the Great Depression finally end completely?",
  answer: "With World War II's industrial mobilization. The passage states the crisis ended fully with wartime production.",
  difficulty: "Medium"
},
{
  id: 2585,
  subject: "Paragraph Comprehension",
  question: "Camouflage patterns in nature help organisms avoid predators or ambush prey. Countershading, where animals are darker on top and lighter underneath, counters shadows to reduce three-dimensional appearance. Some species can actively change colors to match surroundings. These adaptations evolved over millions of years through natural selection. What is countershading?",
  answer: "Being darker on top and lighter underneath to counter shadows and reduce 3D appearance. The passage defines countershading as this color pattern.",
  difficulty: "Medium"
},
{
  id: 2586,
  subject: "Paragraph Comprehension",
  question: "Supply and demand are fundamental economic principles that determine prices in market economies. When demand exceeds supply, prices typically rise. When supply exceeds demand, prices usually fall. These forces naturally regulate production and consumption without central planning. Understanding these dynamics is essential for business and economic policy decisions. What happens to prices when supply exceeds demand?",
  answer: "Prices usually fall. The passage states this as the typical result of oversupply.",
  difficulty: "Easy"
},
{
  id: 2587,
  subject: "Paragraph Comprehension",
  question: "Sterile technique prevents contamination during medical procedures. Healthcare workers use methods like hand washing, wearing gloves, and sterilizing equipment to eliminate microorganisms. These practices dramatically reduce infection rates and save lives. Ignoring sterile technique can cause serious complications, prolonging illness and increasing healthcare costs. Why is sterile technique important?",
  answer: "It prevents contamination, reduces infection rates, and saves lives. The passage emphasizes infection prevention as the key benefit.",
  difficulty: "Easy"
},
{
  id: 2588,
  subject: "Paragraph Comprehension",
  question: "Thermal expansion causes materials to increase in size when heated. Different materials expand at different rates, which engineers must consider in design. Bridges include expansion joints to accommodate size changes without structural damage. Railroad tracks were traditionally laid with small gaps between sections for the same reason. Why do bridges need expansion joints?",
  answer: "To accommodate size changes from thermal expansion without structural damage. The passage explains joints allow expansion without causing damage.",
  difficulty: "Medium"
},
{
  id: 2589,
  subject: "Paragraph Comprehension",
  question: "The Panama Canal connects the Atlantic and Pacific Oceans, eliminating the need for ships to navigate around South America. Completed in 1914 after enormous effort and loss of life, it revolutionized global shipping. Locks raise and lower vessels through the mountainous terrain. Control of the canal has significant strategic and economic importance. What does the Panama Canal eliminate the need for?",
  answer: "Navigating around South America. The passage states it eliminates this lengthy journey.",
  difficulty: "Easy"
},
{
  id: 2590,
  subject: "Paragraph Comprehension",
  question: "Enzymes are biological catalysts that speed up chemical reactions in living organisms without being consumed. Each enzyme is specific to particular reactions, like keys fitting specific locks. Without enzymes, essential processes like digestion and energy production would occur too slowly to sustain life. Temperature and pH levels affect enzyme function. What role do enzymes play?",
  answer: "They speed up chemical reactions in organisms without being consumed, acting as biological catalysts. The passage defines enzymes as catalysts that accelerate reactions.",
  difficulty: "Medium"
},
{
  id: 2591,
  subject: "Paragraph Comprehension",
  question: "Copyright law protects original creative works, giving creators exclusive rights to reproduce, distribute, and profit from their creations for limited periods. This protection incentivizes artistic and intellectual production while eventually allowing works to enter the public domain. Fair use provisions permit limited use without permission for purposes like education and commentary. What is the purpose of copyright law?",
  answer: "To protect creators' rights and incentivize creative production while eventually allowing public access. The passage identifies both protection and incentive as purposes.",
  difficulty: "Medium"
},
{
  id: 2592,
  subject: "Paragraph Comprehension",
  question: "Lasers produce highly focused beams of coherent light in which all waves are synchronized. This property enables lasers to transmit information, perform precise cuts in surgery and manufacturing, and measure distances with extreme accuracy. Unlike ordinary light, laser beams remain tightly concentrated over long distances. The word 'laser' is actually an acronym. What makes laser light different from ordinary light?",
  answer: "It is highly focused and coherent with synchronized waves that remain concentrated over distance. The passage contrasts laser concentration with ordinary light.",
  difficulty: "Medium"
},
{
  id: 2593,
  subject: "Paragraph Comprehension",
  question: "The Bill of Rights was added to the Constitution to protect individual liberties from government overreach. Anti-Federalists demanded these explicit protections as a condition for ratifying the Constitution. The amendments guarantee fundamental rights including free speech, religious freedom, and protection against unreasonable searches. These protections remain cornerstones of American democracy. Why were the Bill of Rights amendments added to the Constitution?",
  answer: "To protect individual liberties and satisfy Anti-Federalists who demanded explicit protections for ratification. The passage identifies both protection and political necessity.",
  difficulty: "Hard"
},
{
  id: 2594,
  subject: "Paragraph Comprehension",
  question: "Desalination removes salt from seawater to produce fresh water. With growing populations and climate change stressing freshwater supplies, desalination is increasingly important. However, the process requires significant energy and produces concentrated brine that must be disposed of carefully to avoid environmental damage. Current technology costs make desalination more expensive than conventional water sources. What limitation of desalination is mentioned?",
  answer: "It requires significant energy, is expensive, and produces brine requiring careful disposal (any of these limitations). The passage identifies all three challenges.",
  difficulty: "Medium"
},
{
  id: 2595,
  subject: "Paragraph Comprehension",
  question: "Centrifugal force is the apparent force that pushes objects outward when they move in a circular path. Actually, objects are trying to continue in straight lines according to Newton's first law, but are constrained to circular motion. Centrifuges use this principle to separate substances of different densities by spinning them at high speeds. Blood samples are commonly separated this way in laboratories. How do centrifuges separate substances?",
  answer: "By spinning them at high speeds, using centrifugal force to separate materials of different densities. The passage explains high-speed rotation separates by density.",
  difficulty: "Hard"
},
{
  id: 2596,
  subject: "Paragraph Comprehension",
  question: "The Monroe Doctrine, declared in 1823, warned European powers against further colonization or interference in the Americas. President Monroe stated that such actions would be viewed as threats to U.S. security. This policy asserted American influence in the Western Hemisphere and shaped foreign policy for generations. It reflected growing American confidence and desire to protect newly independent Latin American nations. What did the Monroe Doctrine warn against?",
  answer: "European colonization or interference in the Americas. The passage states this was the warning issued to European powers.",
  difficulty: "Medium"
},
{
  id: 2597,
  subject: "Paragraph Comprehension",
  question: "Vaccines typically contain weakened or inactive pathogens, or parts of pathogens, that trigger immune responses without causing illness. The immune system creates antibodies and memory cells specific to that pathogen. If later exposed to the actual disease, the body can respond quickly and effectively, preventing illness or reducing severity. This principle of immunological memory makes vaccination effective. How do vaccines prevent disease?",
  answer: "By triggering immune system to create antibodies and memory cells that enable quick response to later actual infections. The passage explains vaccines create immunological memory for rapid future response.",
  difficulty: "Hard"
},
{
  id: 2598,
  subject: "Paragraph Comprehension",
  question: "Sedimentary rocks form from accumulated sediments compressed over millions of years. Layers reveal Earth's history, with older layers typically beneath younger ones. Fossils preserved in sedimentary rock provide evidence of past life and environmental conditions. Geologists study these formations to understand climate changes, evolutionary processes, and resource locations like oil and coal. What can fossils in sedimentary rock reveal?",
  answer: "Past life and environmental conditions. The passage states fossils provide evidence of ancient life and environments.",
  difficulty: "Easy"
},
{
  id: 2599,
  subject: "Paragraph Comprehension",
  question: "The Marshall Plan provided over $12 billion in economic assistance to help rebuild Western European economies after World War II. Announced in 1947, it aimed to prevent economic collapse that might lead to communist expansion. The program succeeded remarkably, restoring prosperity and creating stable democracies. It demonstrated that enlightened self-interest could serve both humanitarian and strategic goals. What was the strategic purpose of the Marshall Plan?",
  answer: "To prevent economic collapse that might lead to communist expansion by rebuilding European economies. The passage identifies preventing communist spread as the strategic motivation.",
  difficulty: "Hard"
},
{
  id: 2600,
  subject: "Paragraph Comprehension",
  question: "DNA carries genetic information in a double helix structure resembling a twisted ladder. The rungs consist of paired bases—adenine with thymine, cytosine with guanine. This base pairing allows DNA to replicate accurately and transmit hereditary information. Discovering DNA's structure in 1953 revolutionized biology and medicine, enabling advances from genetic testing to gene therapy. What allows DNA to replicate accurately?",
  answer: "The specific base pairing (adenine with thymine, cytosine with guanine). The passage indicates this pairing enables accurate replication.",
  difficulty: "Hard"
}
];

export default flashcards;
